var zipCodeData = {
  "110000": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110001": {
    "city": "Central Delhi",
    "state": "Delhi"
  },
  "110002": {
    "city": "New Delhi",
    "state": "Delhi"
  },
  "110003": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110004": {
    "city": "Central Delhi",
    "state": "Delhi"
  },
  "110005": {
    "city": "Central Delhi",
    "state": "Delhi"
  },
  "110006": {
    "city": "North Delhi",
    "state": "Delhi"
  },
  "110007": {
    "city": "North Delhi",
    "state": "Delhi"
  },
  "110008": {
    "city": "Central Delhi",
    "state": "Delhi"
  },
  "110009": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110010": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110011": {
    "city": "Central Delhi",
    "state": "Delhi"
  },
  "110012": {
    "city": "Central Delhi",
    "state": "Delhi"
  },
  "110013": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110014": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110015": {
    "city": "West Delhi",
    "state": "Delhi"
  },
  "110016": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110017": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110018": {
    "city": "West Delhi",
    "state": "Delhi"
  },
  "110019": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110020": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110021": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110022": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110023": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110024": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110025": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110026": {
    "city": "West Delhi",
    "state": "Delhi"
  },
  "110027": {
    "city": "West Delhi",
    "state": "Delhi"
  },
  "110028": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110029": {
    "city": "New Delhi",
    "state": "Delhi"
  },
  "110030": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110031": {
    "city": "East Delhi",
    "state": "Delhi"
  },
  "110032": {
    "city": "North East Delhi",
    "state": "Delhi"
  },
  "110033": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110034": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110035": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110036": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110037": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110038": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110039": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110040": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110041": {
    "city": "West Delhi",
    "state": "Delhi"
  },
  "110042": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110043": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110044": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110045": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110046": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110047": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110048": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110049": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110050": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110051": {
    "city": "East Delhi",
    "state": "Delhi"
  },
  "110052": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110053": {
    "city": "East Delhi",
    "state": "Delhi"
  },
  "110054": {
    "city": "North Delhi",
    "state": "Delhi"
  },
  "110055": {
    "city": "Central Delhi",
    "state": "Delhi"
  },
  "110056": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110057": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110058": {
    "city": "West Delhi",
    "state": "Delhi"
  },
  "110059": {
    "city": "West Delhi",
    "state": "Delhi"
  },
  "110060": {
    "city": "Central Delhi",
    "state": "Delhi"
  },
  "110061": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110062": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110063": {
    "city": "West Delhi",
    "state": "Delhi"
  },
  "110064": {
    "city": "West Delhi",
    "state": "Delhi"
  },
  "110065": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110066": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110067": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110068": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110069": {
    "city": "Central Delhi",
    "state": "Delhi"
  },
  "110070": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110071": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110072": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110073": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110074": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110075": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110076": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110077": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110078": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110079": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110080": {
    "city": "South Delhi",
    "state": "Delhi"
  },
  "110081": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110082": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110083": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110084": {
    "city": "North Delhi",
    "state": "Delhi"
  },
  "110085": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110086": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110087": {
    "city": "West Delhi",
    "state": "Delhi"
  },
  "110088": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110089": {
    "city": "North West Delhi",
    "state": "Delhi"
  },
  "110090": {
    "city": "North East Delhi",
    "state": "Delhi"
  },
  "110091": {
    "city": "East Delhi",
    "state": "Delhi"
  },
  "110092": {
    "city": "East Delhi",
    "state": "Delhi"
  },
  "110093": {
    "city": "East Delhi",
    "state": "Delhi"
  },
  "110094": {
    "city": "East Delhi",
    "state": "Delhi"
  },
  "110095": {
    "city": "East Delhi",
    "state": "Delhi"
  },
  "110096": {
    "city": "East Delhi",
    "state": "Delhi"
  },
  "110097": {
    "city": "South West Delhi",
    "state": "Delhi"
  },
  "110098": {
    "city": "New Delhi",
    "state": "Delhi"
  },
  "110100": {
    "city": "Central Delhi",
    "state": "Delhi"
  },
  "110101": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110102": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110103": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110104": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110105": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110106": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110107": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110108": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110109": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110110": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110112": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110113": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110114": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110115": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110116": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110117": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110118": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110119": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110120": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110121": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110122": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110124": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110125": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110301": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110302": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110401": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110402": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110403": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110501": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110502": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110503": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110504": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110505": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110506": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110507": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110508": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110509": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110510": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110511": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110512": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110601": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110602": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110603": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110604": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110605": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110606": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110607": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110608": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "110609": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "111000": {
    "city": "Delhi NCR",
    "state": "DELHI"
  },
  "111100": {
    "city": "Delhi NCR",
    "state": "DELHI"
  },
  "111105": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "111110": {
    "city": "Delhi NCR",
    "state": "DELHI"
  },
  "111111": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "111112": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "111113": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "111114": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "111119": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "111120": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "111121": {
    "city": "DELHI",
    "state": "DELHI"
  },
  "120001": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "120002": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "121000": {
    "city": "FARIDABAD",
    "state": "HARYANA"
  },
  "121001": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121002": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121003": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121004": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121005": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121006": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121007": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121008": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121009": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121010": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121011": {
    "city": "FARIDABAD",
    "state": "HARYANA"
  },
  "121012": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121013": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121014": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121015": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121101": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121102": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121103": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121104": {
    "city": "PALWAL",
    "state": "HARYANA"
  },
  "121105": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121106": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121107": {
    "city": "Faridabad",
    "state": "Haryana"
  },
  "121206": {
    "city": "FARIDABAD",
    "state": "HARYANA"
  },
  "121705": {
    "city": "MAUNATH BHANJAN",
    "state": "UTTAR PRADESH"
  },
  "122000": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122001": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122002": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122003": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122004": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122005": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122006": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122007": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122008": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122009": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122010": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122011": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122012": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122013": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122014": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122015": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122016": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122017": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122018": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122019": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122020": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122021": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122022": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122050": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122051": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122052": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122053": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122055": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122100": {
    "city": "BHIWADI",
    "state": "RAJASTHAN"
  },
  "122101": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122102": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122103": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122104": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122105": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122106": {
    "city": "DARUHERA",
    "state": "HARYANA"
  },
  "122107": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122108": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122109": {
    "city": "NUH",
    "state": "HARYANA"
  },
  "122203": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122204": {
    "city": "Delhi NCR",
    "state": "DELHI"
  },
  "122206": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122207": {
    "city": "Delhi NCR",
    "state": "DELHI"
  },
  "122208": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122209": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122210": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122211": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122213": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122214": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122215": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122216": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122217": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122218": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122219": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122220": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122222": {
    "city": "GURGAON RTO CARDS",
    "state": "HARYANA"
  },
  "122223": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122224": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122225": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122226": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122227": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122228": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122229": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122230": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122231": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122232": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122233": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122234": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "122413": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122414": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122502": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122503": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122504": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122505": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122506": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "122508": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "123001": {
    "city": "Mahendragarh",
    "state": "Haryana"
  },
  "123003": {
    "city": "NARNAUL",
    "state": "HARYANA"
  },
  "123020": {
    "city": "NARNAUL",
    "state": "HARYANA"
  },
  "123021": {
    "city": "Rewari",
    "state": "Haryana"
  },
  "123022": {
    "city": "NARNAUL",
    "state": "HARYANA"
  },
  "123023": {
    "city": "Mahendragarh",
    "state": "Haryana"
  },
  "123024": {
    "city": "Mahendragarh",
    "state": "Haryana"
  },
  "123025": {
    "city": "MAHENDARGARH",
    "state": "HARYANA"
  },
  "123026": {
    "city": "MAHENDARGARH",
    "state": "HARYANA"
  },
  "123027": {
    "city": "Mahendragarh",
    "state": "Haryana"
  },
  "123028": {
    "city": "Mahendragarh",
    "state": "Haryana"
  },
  "123029": {
    "city": "Mahendragarh",
    "state": "Haryana"
  },
  "123034": {
    "city": "Mahendragarh",
    "state": "Haryana"
  },
  "123035": {
    "city": "Rewari",
    "state": "Haryana"
  },
  "123101": {
    "city": "Rewari",
    "state": "Haryana"
  },
  "123102": {
    "city": "Rewari",
    "state": "Haryana"
  },
  "123103": {
    "city": "Rewari",
    "state": "Haryana"
  },
  "123106": {
    "city": "Rewari",
    "state": "Haryana"
  },
  "123110": {
    "city": "Rewari",
    "state": "Haryana"
  },
  "123301": {
    "city": "Rewari",
    "state": "Haryana"
  },
  "123302": {
    "city": "Rewari",
    "state": "Haryana"
  },
  "123303": {
    "city": "Rewari",
    "state": "Haryana"
  },
  "123304": {
    "city": "KOSLI",
    "state": "HARYANA"
  },
  "123305": {
    "city": "KOSLI",
    "state": "HARYANA"
  },
  "123401": {
    "city": "Gurgaon",
    "state": "Haryana"
  },
  "123411": {
    "city": "Mahendragarh",
    "state": "Haryana"
  },
  "123412": {
    "city": "Mahendragarh",
    "state": "Haryana"
  },
  "123413": {
    "city": "REWARI",
    "state": "HARYANA"
  },
  "123414": {
    "city": "REWARI",
    "state": "HARYANA"
  },
  "123501": {
    "city": "Mahendragarh",
    "state": "Haryana"
  },
  "123503": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "123504": {
    "city": "GURGAON PATAUDI",
    "state": "HARYANA"
  },
  "123505": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "123506": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "123507": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "123508": {
    "city": "GURUGRAM",
    "state": "HARYANA"
  },
  "124001": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124002": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124003": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124004": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124005": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124006": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124007": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124008": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124009": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124010": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124021": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124022": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124023": {
    "city": "MAHAM",
    "state": "HARYANA"
  },
  "124024": {
    "city": "MAHAM",
    "state": "HARYANA"
  },
  "124101": {
    "city": "JHAJJAR",
    "state": "HARYANA"
  },
  "124102": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124103": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124104": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124105": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124106": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124107": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124108": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124109": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124110": {
    "city": "MAHAM",
    "state": "HARYANA"
  },
  "124111": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124112": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124113": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124114": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124127": {
    "city": "MEHAM",
    "state": "HARYANA"
  },
  "124139": {
    "city": "CHARKHI DADRI",
    "state": "HARYANA"
  },
  "124140": {
    "city": "CHARKHI DADRI",
    "state": "HARYANA"
  },
  "124141": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124142": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124146": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124201": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124202": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124203": {
    "city": "JHAJJAR",
    "state": "HARYANA"
  },
  "124204": {
    "city": "JHAJJAR",
    "state": "HARYANA"
  },
  "124301": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124302": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124303": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124304": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124305": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124401": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124402": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124403": {
    "city": "BAHADURGARH",
    "state": "HARYANA"
  },
  "124404": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124405": {
    "city": "BAHADURGARH",
    "state": "HARYANA"
  },
  "124406": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124407": {
    "city": "BAHADURGARH",
    "state": "HARYANA"
  },
  "124408": {
    "city": "BAHADURGARH",
    "state": "HARYANA"
  },
  "124409": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124410": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124411": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124412": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124413": {
    "city": "ROHTAK",
    "state": "HARYANA"
  },
  "124501": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124502": {
    "city": "BAHADURGARH",
    "state": "HARYANA"
  },
  "124503": {
    "city": "JHAJJAR",
    "state": "HARYANA"
  },
  "124504": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124505": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124506": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124507": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124508": {
    "city": "Jhajjar",
    "state": "Haryana"
  },
  "124509": {
    "city": "BAHADURGARH",
    "state": "HARYANA"
  },
  "124510": {
    "city": "BAHADURGARH",
    "state": "HARYANA"
  },
  "124511": {
    "city": "MAHAM",
    "state": "HARYANA"
  },
  "124512": {
    "city": "MAHAM",
    "state": "HARYANA"
  },
  "124513": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124514": {
    "city": "Rohtak",
    "state": "Haryana"
  },
  "124515": {
    "city": "MAHAM",
    "state": "HARYANA"
  },
  "124516": {
    "city": "MAHAM",
    "state": "HARYANA"
  },
  "125001": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125002": {
    "city": "HISSAR",
    "state": "HARYANA"
  },
  "125003": {
    "city": "HISSAR",
    "state": "HARYANA"
  },
  "125004": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125005": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125006": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125007": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125008": {
    "city": "HISAR",
    "state": "HARYANA"
  },
  "125009": {
    "city": "HISAR",
    "state": "HARYANA"
  },
  "125011": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125012": {
    "city": "HISAR",
    "state": "HARYANA"
  },
  "125031": {
    "city": "HANSI",
    "state": "HARYANA"
  },
  "125032": {
    "city": "HANSI",
    "state": "HARYANA"
  },
  "125033": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125034": {
    "city": "HANSI",
    "state": "HARYANA"
  },
  "125035": {
    "city": "HANSI",
    "state": "HARYANA"
  },
  "125036": {
    "city": "HANSI",
    "state": "HARYANA"
  },
  "125037": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125038": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125039": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125040": {
    "city": "HANSI",
    "state": "HARYANA"
  },
  "125041": {
    "city": "MAHAM",
    "state": "HARYANA"
  },
  "125042": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125043": {
    "city": "HISAR",
    "state": "HARYANA"
  },
  "125044": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125045": {
    "city": "HISAR",
    "state": "HARYANA"
  },
  "125046": {
    "city": "FATEHABAD",
    "state": "HARYANA"
  },
  "125047": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125048": {
    "city": "Fatehabad",
    "state": "Haryana"
  },
  "125049": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125050": {
    "city": "Fatehabad",
    "state": "Haryana"
  },
  "125051": {
    "city": "Fatehabad",
    "state": "Haryana"
  },
  "125052": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125053": {
    "city": "Fatehabad",
    "state": "Haryana"
  },
  "125054": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125055": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125056": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125057": {
    "city": "SIRSA",
    "state": "HARYANA"
  },
  "125058": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125059": {
    "city": "SIRSA",
    "state": "HARYANA"
  },
  "125060": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125061": {
    "city": "SIRSA",
    "state": "HARYANA"
  },
  "125062": {
    "city": "SIRSA",
    "state": "HARYANA"
  },
  "125073": {
    "city": "RANIA",
    "state": "HARYANA"
  },
  "125074": {
    "city": "RANIA",
    "state": "HARYANA"
  },
  "125075": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125076": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125077": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125078": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125079": {
    "city": "KALANWALI",
    "state": "HARYANA"
  },
  "125080": {
    "city": "KALANWALI",
    "state": "HARYANA"
  },
  "125101": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125102": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125103": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125104": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125105": {
    "city": "BHUNA",
    "state": "HARYANA"
  },
  "125106": {
    "city": "Fatehabad",
    "state": "Haryana"
  },
  "125107": {
    "city": "BHUNA",
    "state": "HARYANA"
  },
  "125108": {
    "city": "SIRSA",
    "state": "HARYANA"
  },
  "125109": {
    "city": "SIRSA",
    "state": "HARYANA"
  },
  "125110": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125111": {
    "city": "Fatehabad",
    "state": "Haryana"
  },
  "125112": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125113": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125119": {
    "city": "TOHANA",
    "state": "HARYANA"
  },
  "125120": {
    "city": "Fatehabad",
    "state": "Haryana"
  },
  "125121": {
    "city": "Hisar",
    "state": "Haryana"
  },
  "125122": {
    "city": "BARWALA",
    "state": "HARYANA"
  },
  "125123": {
    "city": "BARWALA",
    "state": "HARYANA"
  },
  "125125": {
    "city": "TOHANA",
    "state": "PUNJAB"
  },
  "125133": {
    "city": "Fatehabad",
    "state": "Haryana"
  },
  "125201": {
    "city": "Sirsa",
    "state": "Haryana"
  },
  "125202": {
    "city": "KALANWALI",
    "state": "HARYANA"
  },
  "125203": {
    "city": "KALANWALI",
    "state": "HARYANA"
  },
  "126001": {
    "city": "TOHANA",
    "state": "HARYANA"
  },
  "126101": {
    "city": "Jind",
    "state": "Haryana"
  },
  "126102": {
    "city": "Jind",
    "state": "Haryana"
  },
  "126103": {
    "city": "JIND",
    "state": "HARYANA"
  },
  "126104": {
    "city": "JIND",
    "state": "HARYANA"
  },
  "126108": {
    "city": "PILU KHERA",
    "state": "HARYANA"
  },
  "126109": {
    "city": "PILU KHERA",
    "state": "HARYANA"
  },
  "126110": {
    "city": "Jind",
    "state": "Haryana"
  },
  "126111": {
    "city": "Jind",
    "state": "Haryana"
  },
  "126112": {
    "city": "Jind",
    "state": "Haryana"
  },
  "126113": {
    "city": "Jind",
    "state": "Haryana"
  },
  "126114": {
    "city": "Jind",
    "state": "Haryana"
  },
  "126115": {
    "city": "Jind",
    "state": "Haryana"
  },
  "126116": {
    "city": "Jind",
    "state": "Haryana"
  },
  "126117": {
    "city": "NARWANA",
    "state": "HARYANA"
  },
  "126118": {
    "city": "NARWANA",
    "state": "HARYANA"
  },
  "126123": {
    "city": "JIND",
    "state": "HARYANA"
  },
  "126124": {
    "city": "JIND",
    "state": "HARYANA"
  },
  "126125": {
    "city": "Jind",
    "state": "Haryana"
  },
  "126126": {
    "city": "JIND",
    "state": "HARYANA"
  },
  "126127": {
    "city": "JIND",
    "state": "HARYANA"
  },
  "126150": {
    "city": "NARWANA",
    "state": "HARYANA"
  },
  "126151": {
    "city": "NARWANA",
    "state": "HARYANA"
  },
  "126152": {
    "city": "Jind",
    "state": "Haryana"
  },
  "126153": {
    "city": "NARWANA",
    "state": "HARYANA"
  },
  "126154": {
    "city": "NARWANA",
    "state": "HARYANA"
  },
  "127020": {
    "city": "BHIWANI",
    "state": "HARYANA"
  },
  "127021": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127022": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127025": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127026": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127027": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127028": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127029": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127030": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127031": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127032": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127035": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127040": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127041": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127042": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127043": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127045": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127046": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127110": {
    "city": "BHIWANI",
    "state": "HARYANA"
  },
  "127111": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127114": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127201": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127306": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127307": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127308": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127309": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127310": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127311": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "127312": {
    "city": "Bhiwani",
    "state": "Haryana"
  },
  "131001": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131002": {
    "city": "SONIPAT",
    "state": "HARYANA"
  },
  "131021": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131022": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131023": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131024": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131025": {
    "city": "SONIPAT",
    "state": "HARYANA"
  },
  "131026": {
    "city": "SONIPAT",
    "state": "HARYANA"
  },
  "131027": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131028": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131029": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131030": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131031": {
    "city": "SONIPAT",
    "state": "HARYANA"
  },
  "131032": {
    "city": "SONIPAT",
    "state": "HARYANA"
  },
  "131035": {
    "city": "SONIPAT",
    "state": "HARYANA"
  },
  "131036": {
    "city": "SONIPAT",
    "state": "HARYANA"
  },
  "131037": {
    "city": "SONIPAT",
    "state": "HARYANA"
  },
  "131038": {
    "city": "SONIPAT",
    "state": "HARYANA"
  },
  "131039": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131101": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131102": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131103": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131104": {
    "city": "SONIPAT",
    "state": "HARYANA"
  },
  "131105": {
    "city": "SONIPAT",
    "state": "HARYANA"
  },
  "131301": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131302": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131303": {
    "city": "GOHANA",
    "state": "HARYANA"
  },
  "131304": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131305": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131306": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131307": {
    "city": "Gohana",
    "state": "HARYANA"
  },
  "131309": {
    "city": "Gohana",
    "state": "HARYANA"
  },
  "131402": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131403": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131407": {
    "city": "SONIPAT",
    "state": "HARYANA"
  },
  "131408": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "131409": {
    "city": "Sonipat",
    "state": "Haryana"
  },
  "132000": {
    "city": "Panipat",
    "state": "HARYANA"
  },
  "132001": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132002": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132018": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132020": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132021": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132022": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132023": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132024": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132025": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132026": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132034": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132035": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132036": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132037": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132038": {
    "city": "ASANDH",
    "state": "HARYANA"
  },
  "132039": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132040": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132041": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132042": {
    "city": "LADWA",
    "state": "HARYANA"
  },
  "132043": {
    "city": "LADWA",
    "state": "HARYANA"
  },
  "132044": {
    "city": "ASANDH",
    "state": "HARYANA"
  },
  "132045": {
    "city": "ASANDH",
    "state": "HARYANA"
  },
  "132046": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132047": {
    "city": "ASANDH",
    "state": "HARYANA"
  },
  "132048": {
    "city": "ASANDH",
    "state": "HARYANA"
  },
  "132052": {
    "city": "LADWA",
    "state": "HARYANA"
  },
  "132053": {
    "city": "LADWA",
    "state": "HARYANA"
  },
  "132054": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132101": {
    "city": "Panipat",
    "state": "Haryana"
  },
  "132102": {
    "city": "Panipat",
    "state": "Haryana"
  },
  "132103": {
    "city": "Panipat",
    "state": "Haryana"
  },
  "132104": {
    "city": "Panipat",
    "state": "Haryana"
  },
  "132105": {
    "city": "Panipat",
    "state": "Haryana"
  },
  "132106": {
    "city": "Panipat",
    "state": "Haryana"
  },
  "132107": {
    "city": "Panipat",
    "state": "Haryana"
  },
  "132108": {
    "city": "Panipat",
    "state": "Haryana"
  },
  "132109": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132110": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132111": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132112": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132113": {
    "city": "Panipat",
    "state": "Haryana"
  },
  "132114": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132115": {
    "city": "Panipat",
    "state": "Haryana"
  },
  "132116": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132117": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "132118": {
    "city": "KURUKSHETRA",
    "state": "HARYANA"
  },
  "132119": {
    "city": "KURUKSHETRA",
    "state": "HARYANA"
  },
  "132120": {
    "city": "KURUKSHETRA",
    "state": "HARYANA"
  },
  "132121": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132122": {
    "city": "Panipat",
    "state": "Haryana"
  },
  "132123": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132124": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132125": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132132": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132138": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132139": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132140": {
    "city": "Panipat",
    "state": "Haryana"
  },
  "132141": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132142": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132143": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132144": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132145": {
    "city": "Panipat",
    "state": "Haryana"
  },
  "132146": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132147": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132149": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132150": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132151": {
    "city": "PANIPAT",
    "state": "HARYANA"
  },
  "132152": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132153": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132154": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132155": {
    "city": "KARNAL",
    "state": "HARYANA"
  },
  "132157": {
    "city": "Karnal",
    "state": "Haryana"
  },
  "133001": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133002": {
    "city": "AMBALA",
    "state": "HARYANA"
  },
  "133003": {
    "city": "AMBALA",
    "state": "HARYANA"
  },
  "133004": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133005": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133006": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133007": {
    "city": "AMBALA",
    "state": "HARYANA"
  },
  "133008": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133010": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133021": {
    "city": "AMBALA CANTT",
    "state": "HARYANA"
  },
  "133101": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133102": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133103": {
    "city": "Yamuna Nagar",
    "state": "Haryana"
  },
  "133104": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133105": {
    "city": "BARARA",
    "state": "HARYANA"
  },
  "133201": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133202": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133203": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133204": {
    "city": "Yamuna Nagar",
    "state": "Haryana"
  },
  "133205": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133206": {
    "city": "Yamuna Nagar",
    "state": "Haryana"
  },
  "133207": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "133208": {
    "city": "BARARA",
    "state": "HARYANA"
  },
  "133301": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "133302": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134001": {
    "city": "AMBALA CANTT",
    "state": "HARYANA"
  },
  "134002": {
    "city": "AMBALA CANTT",
    "state": "HARYANA"
  },
  "134003": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "134004": {
    "city": "AMBALA CANTT",
    "state": "HARYANA"
  },
  "134005": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "134006": {
    "city": "AMBALA",
    "state": "HARYANA"
  },
  "134007": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "134008": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "134009": {
    "city": "PANCHKULA",
    "state": "HARYANA"
  },
  "134011": {
    "city": "AMBALA",
    "state": "HARYANA"
  },
  "134012": {
    "city": "AMBALA",
    "state": "HARYANA"
  },
  "134044": {
    "city": "ASANDH",
    "state": "HARYANA"
  },
  "134101": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134102": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134103": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134104": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134105": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134107": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134108": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134109": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134110": {
    "city": "PANCHKULA",
    "state": "HARYANA"
  },
  "134111": {
    "city": "PANCHKULA",
    "state": "HARYANA"
  },
  "134112": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134113": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134114": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134115": {
    "city": "PANCHKULA",
    "state": "HARYANA"
  },
  "134116": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134117": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134118": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134119": {
    "city": "PANCHKULA",
    "state": "HARYANA"
  },
  "134120": {
    "city": "Panchkula",
    "state": "HARYANA"
  },
  "134121": {
    "city": "Panchkula",
    "state": "HARYANA"
  },
  "134122": {
    "city": "Panchkula",
    "state": "HARYANA"
  },
  "134123": {
    "city": "Panchkula",
    "state": "HARYANA"
  },
  "134124": {
    "city": "Panchkula",
    "state": "HARYANA"
  },
  "134151": {
    "city": "PANCHKULA",
    "state": "HARYANA"
  },
  "134152": {
    "city": "PANCHKULA",
    "state": "HARYANA"
  },
  "134201": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "134202": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "134203": {
    "city": "Ambala",
    "state": "Haryana"
  },
  "134204": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134205": {
    "city": "Panchkula",
    "state": "Haryana"
  },
  "134206": {
    "city": "PANCHKULA",
    "state": "HARYANA"
  },
  "135001": {
    "city": "Yamuna Nagar",
    "state": "Haryana"
  },
  "135002": {
    "city": "Yamuna Nagar",
    "state": "Haryana"
  },
  "135003": {
    "city": "Yamuna Nagar",
    "state": "Haryana"
  },
  "135004": {
    "city": "Yamuna Nagar",
    "state": "Haryana"
  },
  "135012": {
    "city": "BILASPUR - HR",
    "state": "HARYANA"
  },
  "135021": {
    "city": "Yamuna Nagar",
    "state": "Haryana"
  },
  "135101": {
    "city": "Yamuna Nagar",
    "state": "Haryana"
  },
  "135102": {
    "city": "Yamuna Nagar",
    "state": "Haryana"
  },
  "135103": {
    "city": "Yamuna Nagar",
    "state": "Haryana"
  },
  "135104": {
    "city": "BILASPUR - HR",
    "state": "HARYANA"
  },
  "135105": {
    "city": "BILASPUR - HR",
    "state": "HARYANA"
  },
  "135106": {
    "city": "Yamuna Nagar",
    "state": "Haryana"
  },
  "135133": {
    "city": "Yamuna Nagar",
    "state": "Haryana"
  },
  "136020": {
    "city": "Kaithal",
    "state": "Haryana"
  },
  "136021": {
    "city": "Kaithal",
    "state": "Haryana"
  },
  "136026": {
    "city": "Kaithal",
    "state": "Haryana"
  },
  "136027": {
    "city": "Kaithal",
    "state": "Haryana"
  },
  "136030": {
    "city": "Kurukshetra",
    "state": "Haryana"
  },
  "136033": {
    "city": "Kaithal",
    "state": "Haryana"
  },
  "136034": {
    "city": "Kaithal",
    "state": "Haryana"
  },
  "136035": {
    "city": "Kaithal",
    "state": "Haryana"
  },
  "136038": {
    "city": "Kurukshetra",
    "state": "Haryana"
  },
  "136042": {
    "city": "Kaithal",
    "state": "Haryana"
  },
  "136043": {
    "city": "Kaithal",
    "state": "Haryana"
  },
  "136044": {
    "city": "Kaithal",
    "state": "Haryana"
  },
  "136117": {
    "city": "Kaithal",
    "state": "Haryana"
  },
  "136118": {
    "city": "Kurukshetra",
    "state": "Haryana"
  },
  "136119": {
    "city": "Kurukshetra",
    "state": "Haryana"
  },
  "136128": {
    "city": "Kurukshetra",
    "state": "Haryana"
  },
  "136129": {
    "city": "Kurukshetra",
    "state": "Haryana"
  },
  "136130": {
    "city": "Kurukshetra",
    "state": "Haryana"
  },
  "136131": {
    "city": "Kurukshetra",
    "state": "Haryana"
  },
  "136132": {
    "city": "Kurukshetra",
    "state": "Haryana"
  },
  "136135": {
    "city": "Kurukshetra",
    "state": "Haryana"
  },
  "136136": {
    "city": "Kurukshetra",
    "state": "Haryana"
  },
  "136156": {
    "city": "Kurukshetra",
    "state": "Haryana"
  },
  "140001": {
    "city": "Rupnagar",
    "state": "Punjab"
  },
  "140002": {
    "city": "RUPNAGAR",
    "state": "PUNJAB"
  },
  "140063": {
    "city": "RUPNAGAR",
    "state": "PUNJAB"
  },
  "140101": {
    "city": "Ropar",
    "state": "Punjab"
  },
  "140102": {
    "city": "Ropar",
    "state": "Punjab"
  },
  "140103": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "140104": {
    "city": "KHARAR",
    "state": "PUNJAB"
  },
  "140105": {
    "city": "ZIRAKPUR",
    "state": "PUNJAB"
  },
  "140106": {
    "city": "PANCHKULA",
    "state": "PUNJAB"
  },
  "140108": {
    "city": "Rupnagar",
    "state": "Punjab"
  },
  "140109": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "140110": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "140111": {
    "city": "Rupnagar",
    "state": "Punjab"
  },
  "140112": {
    "city": "Rupnagar",
    "state": "Punjab"
  },
  "140113": {
    "city": "Rupnagar",
    "state": "Punjab"
  },
  "140114": {
    "city": "Rupnagar",
    "state": "Punjab"
  },
  "140115": {
    "city": "Ropar",
    "state": "Punjab"
  },
  "140116": {
    "city": "Rupnagar",
    "state": "Punjab"
  },
  "140117": {
    "city": "Rupnagar",
    "state": "Punjab"
  },
  "140118": {
    "city": "Ropar",
    "state": "Punjab"
  },
  "140119": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "140120": {
    "city": "RUPNAGAR",
    "state": "PUNJAB"
  },
  "140123": {
    "city": "Rupnagar",
    "state": "Punjab"
  },
  "140124": {
    "city": "Rupnagar",
    "state": "Punjab"
  },
  "140125": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "140126": {
    "city": "Rupnagar",
    "state": "Punjab"
  },
  "140133": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "140201": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "140202": {
    "city": "PANCHKULA",
    "state": "HARYANA"
  },
  "140203": {
    "city": "DERA BASSI",
    "state": "PUNJAB"
  },
  "140301": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "140306": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "140307": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "140308": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "140401": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "140402": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "140405": {
    "city": "Fatehgarh Sahib",
    "state": "Punjab"
  },
  "140406": {
    "city": "Fatehgarh Sahib",
    "state": "Punjab"
  },
  "140407": {
    "city": "Fatehgarh Sahib",
    "state": "Punjab"
  },
  "140408": {
    "city": "Fatehgarh Sahib",
    "state": "Punjab"
  },
  "140412": {
    "city": "Fatehgarh Sahib",
    "state": "Punjab"
  },
  "140413": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "140417": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "140501": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "140502": {
    "city": "DERA BASSI",
    "state": "PUNJAB"
  },
  "140503": {
    "city": "Chandigarh",
    "state": "CHANDIGARH"
  },
  "140504": {
    "city": "DERA BASSI",
    "state": "PUNJAB"
  },
  "140506": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "140507": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "140508": {
    "city": "DERA BASSI",
    "state": "PUNJAB"
  },
  "140601": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "140602": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "140603": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "140604": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "140630": {
    "city": "PANCHKULA",
    "state": "HARYANA"
  },
  "140701": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "140702": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "140801": {
    "city": "SAMRALA",
    "state": "PUNJAB"
  },
  "140802": {
    "city": "Fatehgarh Sahib",
    "state": "Punjab"
  },
  "140901": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "141000": {
    "city": "LUDHIANA",
    "state": "PUNJAB"
  },
  "141001": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141002": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141003": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141004": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141005": {
    "city": "LUDHIANA",
    "state": "PUNJAB"
  },
  "141006": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141007": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141008": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141009": {
    "city": "LUDHIANA",
    "state": "PUNJAB"
  },
  "141010": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141011": {
    "city": "LUDHIANA",
    "state": "PUNJAB"
  },
  "141012": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141013": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141014": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141015": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141016": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141017": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141020": {
    "city": "LUDHIANA",
    "state": "PUNJAB"
  },
  "141021": {
    "city": "LUDHIANA",
    "state": "PUNJAB"
  },
  "141033": {
    "city": "LUDHIANA",
    "state": "PUNJAB"
  },
  "141101": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141102": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141103": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141104": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141105": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141106": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141107": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141108": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141109": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141110": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141111": {
    "city": "LUDHIANA",
    "state": "PUNJAB"
  },
  "141112": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141113": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141114": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141115": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141116": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141117": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141118": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141119": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141120": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141121": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141122": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141123": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141124": {
    "city": "SAMRALA",
    "state": "PUNJAB"
  },
  "141125": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141126": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141127": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141201": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141202": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141203": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141204": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141205": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141206": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141234": {
    "city": "LUDHIANA",
    "state": "PUNJAB"
  },
  "141301": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "141302": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "141303": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "141304": {
    "city": "PHAGWARA",
    "state": "PUNJAB"
  },
  "141305": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "141306": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "141307": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "141308": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "141309": {
    "city": "JALANDHAR",
    "state": "PUNJAB"
  },
  "141310": {
    "city": "KAPURTHALA",
    "state": "PUNJAB"
  },
  "141311": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "141315": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "141316": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "141317": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "141318": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "141400": {
    "city": "MANDIGOBINDGARH",
    "state": "PUNJAB"
  },
  "141401": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141402": {
    "city": "KHANNA",
    "state": "PUNJAB"
  },
  "141407": {
    "city": "MANDIGOBINDGARH",
    "state": "PUNJAB"
  },
  "141411": {
    "city": "Fatehgarh Sahib",
    "state": "Punjab"
  },
  "141412": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141413": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141414": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141415": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141416": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141417": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141418": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141419": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141420": {
    "city": "PAYAL",
    "state": "PUNJAB"
  },
  "141421": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141422": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "141801": {
    "city": "Fatehgarh Sahib",
    "state": "Punjab"
  },
  "142001": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142002": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142003": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142011": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142013": {
    "city": "MOGA",
    "state": "PUNJAB"
  },
  "142021": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142022": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142023": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142024": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142025": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142026": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142027": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142028": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142029": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142030": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142031": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142032": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142033": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142034": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142035": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142036": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "142037": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142038": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142039": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142040": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142041": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "142042": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142043": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142044": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "142045": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142046": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142047": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "142048": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142049": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142050": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "142051": {
    "city": "DHARAMKOT",
    "state": "PUNJAB"
  },
  "142052": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "142053": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142054": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142055": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142056": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142057": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142058": {
    "city": "Moga",
    "state": "Punjab"
  },
  "142059": {
    "city": "BAGHA PURANA",
    "state": "PUNJAB"
  },
  "142060": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "142061": {
    "city": "BAGHA PURANA",
    "state": "PUNJAB"
  },
  "143000": {
    "city": "AMRITSAR",
    "state": "PUNJAB"
  },
  "143001": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143002": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143003": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143004": {
    "city": "AMRITSAR",
    "state": "PUNJAB"
  },
  "143005": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143006": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143007": {
    "city": "AMRITSAR",
    "state": "PUNJAB"
  },
  "143008": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143009": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143010": {
    "city": "AMRITSAR",
    "state": "PUNJAB"
  },
  "143021": {
    "city": "AMRITSAR",
    "state": "PUNJAB"
  },
  "143022": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143026": {
    "city": "AMRITSAR",
    "state": "PUNJAB"
  },
  "143036": {
    "city": "AMRITSAR",
    "state": "PUNJAB"
  },
  "143044": {
    "city": "AMRITSAR",
    "state": "PUNJAB"
  },
  "143066": {
    "city": "AMRITSAR",
    "state": "PUNJAB"
  },
  "143093": {
    "city": "AMRITSAR",
    "state": "PUNJAB"
  },
  "143101": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143102": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143103": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143104": {
    "city": "AMRITSAR",
    "state": "PUNJAB"
  },
  "143105": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143106": {
    "city": "AMRITSAR",
    "state": "PUNJAB"
  },
  "143107": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143108": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143109": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143110": {
    "city": "AJNALA",
    "state": "PUNJAB"
  },
  "143111": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143112": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143113": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143114": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143115": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143116": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143117": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143118": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143119": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143144": {
    "city": "BEAS",
    "state": "PUNJAB"
  },
  "143149": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143201": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143202": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143203": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143204": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143205": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143301": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143302": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143303": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143304": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143305": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143306": {
    "city": "BIKKIWIND",
    "state": "PUNJAB"
  },
  "143325": {
    "city": "PATHANKOT",
    "state": "PUNJAB"
  },
  "143401": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143402": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143406": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143407": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143408": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143409": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143410": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143411": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143412": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143413": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143414": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143415": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143416": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143417": {
    "city": "BIKKIWIND",
    "state": "PUNJAB"
  },
  "143418": {
    "city": "BIKKIWIND",
    "state": "PUNJAB"
  },
  "143419": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143420": {
    "city": "BIKKIWIND",
    "state": "PUNJAB"
  },
  "143421": {
    "city": "BIKKIWIND",
    "state": "PUNJAB"
  },
  "143422": {
    "city": "Tarn Taran",
    "state": "Punjab"
  },
  "143423": {
    "city": "TARN TARAN",
    "state": "PUNJAB"
  },
  "143501": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143502": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143503": {
    "city": "BATALA",
    "state": "PUNJAB"
  },
  "143504": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143505": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143506": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143507": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143508": {
    "city": "BATALA",
    "state": "PUNJAB"
  },
  "143510": {
    "city": "BATALA",
    "state": "PUNJAB"
  },
  "143511": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143512": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143513": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143514": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143515": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143516": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143517": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143518": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143519": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143520": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143521": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143523": {
    "city": "GURDASPUR",
    "state": "PUNJAB"
  },
  "143524": {
    "city": "GURDASPUR",
    "state": "PUNJAB"
  },
  "143525": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143526": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143527": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143528": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143529": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143530": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143531": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143532": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143533": {
    "city": "Pathankot",
    "state": "Punjab"
  },
  "143534": {
    "city": "Pathankot",
    "state": "Punjab"
  },
  "143535": {
    "city": "PATHANKOT",
    "state": "PUNJAB"
  },
  "143536": {
    "city": "PATHANKOT",
    "state": "PUNJAB"
  },
  "143537": {
    "city": "GURDASPUR",
    "state": "PUNJAB"
  },
  "143538": {
    "city": "PATHANKOT",
    "state": "PUNJAB"
  },
  "143601": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143602": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143603": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143604": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143605": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "143606": {
    "city": "Amritsar",
    "state": "Punjab"
  },
  "143607": {
    "city": "MAJITHA",
    "state": "PUNJAB"
  },
  "144000": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "144001": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144002": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144003": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144004": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144005": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144006": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144007": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144008": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144009": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144010": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144011": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144012": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144013": {
    "city": "JALANDHAR",
    "state": "PUNJAB"
  },
  "144014": {
    "city": "JALANDHAR",
    "state": "PUNJAB"
  },
  "144015": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "144019": {
    "city": "JALLANDHAR",
    "state": "PUNJAB"
  },
  "144020": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144021": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144022": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144023": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144024": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144025": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144026": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144027": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144028": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144029": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144030": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144031": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144032": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144033": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144034": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144035": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144036": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144037": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144038": {
    "city": "JALANDHAR",
    "state": "PUNJAB"
  },
  "144039": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144040": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144041": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144042": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144043": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144044": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144046": {
    "city": "NAKODAR",
    "state": "PUNJAB"
  },
  "144047": {
    "city": "NAKODAR",
    "state": "PUNJAB"
  },
  "144048": {
    "city": "NAKODAR",
    "state": "PUNJAB"
  },
  "144049": {
    "city": "NAKODAR",
    "state": "PUNJAB"
  },
  "144050": {
    "city": "NAKODAR",
    "state": "PUNJAB"
  },
  "144051": {
    "city": "NAKODAR",
    "state": "PUNJAB"
  },
  "144052": {
    "city": "NAKODAR",
    "state": "PUNJAB"
  },
  "144053": {
    "city": "NAKODAR",
    "state": "PUNJAB"
  },
  "144101": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144102": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144103": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144104": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144105": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144106": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144109": {
    "city": "HOSHIARPUR",
    "state": "PUNJAB"
  },
  "144116": {
    "city": "HOSHIARPUR",
    "state": "PUNJAB"
  },
  "144121": {
    "city": "HOSHIARPUR",
    "state": "PUNJAB"
  },
  "144201": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144202": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144203": {
    "city": "GURDASPUR",
    "state": "PUNJAB"
  },
  "144204": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144205": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144206": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144207": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144208": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144209": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144210": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144211": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144212": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144213": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144214": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144216": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144218": {
    "city": "DASUYA",
    "state": "PUNJAB"
  },
  "144221": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144222": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144223": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144224": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144225": {
    "city": "TALWARA",
    "state": "PUNJAB"
  },
  "144241": {
    "city": "TALWARA",
    "state": "PUNJAB"
  },
  "144301": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144302": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144303": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144304": {
    "city": "BEGOWAL",
    "state": "PUNJAB"
  },
  "144305": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144306": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144308": {
    "city": "MUKERIAN",
    "state": "PUNJAB"
  },
  "144311": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144316": {
    "city": "PHAGWARA",
    "state": "PUNJAB"
  },
  "144318": {
    "city": "PHAGWARA",
    "state": "PUNJAB"
  },
  "144401": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144402": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144403": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144404": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144405": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144406": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144407": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144408": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144409": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144410": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144411": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144415": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144416": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144417": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144418": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144419": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144421": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144422": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144423": {
    "city": "NAWANSHAHR",
    "state": "PUNJAB"
  },
  "144424": {
    "city": "NAWANSHAHR",
    "state": "PUNJAB"
  },
  "144501": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144502": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144503": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144504": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144505": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144506": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144507": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144508": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144509": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144510": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144511": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144512": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144513": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144514": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144515": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144516": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144517": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144518": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144519": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144520": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144521": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144522": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144523": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144524": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144525": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144526": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144527": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144528": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144529": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144530": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144531": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "144532": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144533": {
    "city": "Nawanshahr",
    "state": "Punjab"
  },
  "144601": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144602": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144603": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144606": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144619": {
    "city": "BEGOWAL",
    "state": "PUNJAB"
  },
  "144620": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144621": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144622": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144623": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144624": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144625": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144626": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144628": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144629": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144630": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144631": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144632": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144633": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144701": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144702": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144703": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144801": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144802": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144803": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144804": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "144805": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144806": {
    "city": "Jalandhar",
    "state": "Punjab"
  },
  "144819": {
    "city": "Kapurthala",
    "state": "Punjab"
  },
  "145001": {
    "city": "Gurdaspur",
    "state": "Punjab"
  },
  "145002": {
    "city": "PATHANKOT",
    "state": "PUNJAB"
  },
  "145003": {
    "city": "PATHANKOT",
    "state": "PUNJAB"
  },
  "145004": {
    "city": "Pathankot",
    "state": "PUNJAB"
  },
  "145005": {
    "city": "Pathankot",
    "state": "PUNJAB"
  },
  "145021": {
    "city": "PATHANKOT",
    "state": "PUNJAB"
  },
  "145022": {
    "city": "Pathankot",
    "state": "Punjab"
  },
  "145023": {
    "city": "Pathankot",
    "state": "Punjab"
  },
  "145024": {
    "city": "Pathankot",
    "state": "Punjab"
  },
  "145025": {
    "city": "Pathankot",
    "state": "Punjab"
  },
  "145026": {
    "city": "Pathankot",
    "state": "Punjab"
  },
  "145027": {
    "city": "Pathankot",
    "state": "Punjab"
  },
  "145029": {
    "city": "Pathankot",
    "state": "Punjab"
  },
  "145101": {
    "city": "Pathankot",
    "state": "Punjab"
  },
  "145105": {
    "city": "HOSHIARPUR",
    "state": "PUNJAB"
  },
  "146001": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146002": {
    "city": "HOSHIARPUR",
    "state": "PUNJAB"
  },
  "146006": {
    "city": "HOSHIARPUR",
    "state": "PUNJAB"
  },
  "146021": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146022": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146023": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146024": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146101": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146102": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146103": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146104": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146105": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146106": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146107": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146108": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146109": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146110": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146111": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146112": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146113": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146114": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146115": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146116": {
    "city": "Hoshiarpur",
    "state": "Punjab"
  },
  "146416": {
    "city": "SHRI GOVINDPUR",
    "state": "PUNJAB"
  },
  "146519": {
    "city": "SHRI GOVINDPUR",
    "state": "PUNJAB"
  },
  "147001": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147002": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147003": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147004": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147005": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147006": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147007": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147021": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147023": {
    "city": "PATIALA",
    "state": "PUNJAB"
  },
  "147101": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147102": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147103": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147104": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147105": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147111": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147201": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147202": {
    "city": "Patiala",
    "state": "Punjab"
  },
  "147203": {
    "city": "Fatehgarh Sahib",
    "state": "Punjab"
  },
  "147204": {
    "city": "MANDIGOBINDGARH",
    "state": "PUNJAB"
  },
  "147205": {
    "city": "MANDIGOBINDGARH",
    "state": "PUNJAB"
  },
  "147301": {
    "city": "Fatehgarh Sahib",
    "state": "Punjab"
  },
  "147506": {
    "city": "DERA BASSI",
    "state": "PUNJAB"
  },
  "148000": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148001": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148002": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148004": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148005": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148006": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148007": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148008": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148009": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148017": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148018": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148019": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148020": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148021": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148022": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148023": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148024": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148025": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148026": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148027": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148028": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148029": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148030": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148031": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148032": {
    "city": "LEHRAGAGA",
    "state": "PUNJAB"
  },
  "148033": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148034": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148035": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148036": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148038": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148039": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148040": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148041": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148042": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148043": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148044": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148045": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148046": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148047": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148048": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148049": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148050": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148051": {
    "city": "SANGRUR",
    "state": "PUNJAB"
  },
  "148100": {
    "city": "Barnala",
    "state": "Punjab"
  },
  "148101": {
    "city": "Barnala",
    "state": "Punjab"
  },
  "148102": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148103": {
    "city": "Barnala",
    "state": "Punjab"
  },
  "148104": {
    "city": "Barnala",
    "state": "Punjab"
  },
  "148105": {
    "city": "Barnala",
    "state": "Punjab"
  },
  "148106": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148107": {
    "city": "Ludhiana",
    "state": "Punjab"
  },
  "148108": {
    "city": "Sangrur",
    "state": "Punjab"
  },
  "148109": {
    "city": "Barnala",
    "state": "Punjab"
  },
  "148110": {
    "city": "BARNALA",
    "state": "PUNJAB"
  },
  "148111": {
    "city": "BARNALA",
    "state": "PUNJAB"
  },
  "148112": {
    "city": "BARNALA",
    "state": "PUNJAB"
  },
  "148113": {
    "city": "BARNALA",
    "state": "PUNJAB"
  },
  "148114": {
    "city": "BARNALA",
    "state": "PUNJAB"
  },
  "148115": {
    "city": "BARNALA",
    "state": "PUNJAB"
  },
  "148116": {
    "city": "BARNALA",
    "state": "PUNJAB"
  },
  "148117": {
    "city": "BARNALA",
    "state": "PUNJAB"
  },
  "151001": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151002": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151003": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151004": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151005": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151006": {
    "city": "BHATINDA",
    "state": "PUNJAB"
  },
  "151007": {
    "city": "BHATINDA",
    "state": "PUNJAB"
  },
  "151101": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151102": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151103": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151104": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151105": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151106": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151107": {
    "city": "BHADAUR",
    "state": "PUNJAB"
  },
  "151108": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151110": {
    "city": "RAMPURA PHUL",
    "state": "PUNJAB"
  },
  "151111": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151201": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151202": {
    "city": "Faridkot",
    "state": "Punjab"
  },
  "151203": {
    "city": "Faridkot",
    "state": "Punjab"
  },
  "151204": {
    "city": "Faridkot",
    "state": "Punjab"
  },
  "151205": {
    "city": "Faridkot",
    "state": "Punjab"
  },
  "151206": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151207": {
    "city": "Faridkot",
    "state": "Punjab"
  },
  "151208": {
    "city": "Faridkot",
    "state": "Punjab"
  },
  "151209": {
    "city": "Faridkot",
    "state": "Punjab"
  },
  "151210": {
    "city": "Muktsar",
    "state": "Punjab"
  },
  "151211": {
    "city": "Muktsar",
    "state": "Punjab"
  },
  "151212": {
    "city": "Faridkot",
    "state": "Punjab"
  },
  "151213": {
    "city": "Faridkot",
    "state": "Punjab"
  },
  "151215": {
    "city": "MUKTSAR",
    "state": "PUNJAB"
  },
  "151301": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151302": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151401": {
    "city": "Bathinda",
    "state": "Punjab"
  },
  "151501": {
    "city": "Mansa",
    "state": "Punjab"
  },
  "151502": {
    "city": "Mansa",
    "state": "Punjab"
  },
  "151503": {
    "city": "Mansa",
    "state": "Punjab"
  },
  "151504": {
    "city": "Mansa",
    "state": "Punjab"
  },
  "151505": {
    "city": "Mansa",
    "state": "Punjab"
  },
  "151506": {
    "city": "Mansa",
    "state": "Punjab"
  },
  "151507": {
    "city": "Mansa",
    "state": "Punjab"
  },
  "151508": {
    "city": "Mansa",
    "state": "Punjab"
  },
  "151509": {
    "city": "Mansa",
    "state": "Punjab"
  },
  "151510": {
    "city": "Mansa",
    "state": "Punjab"
  },
  "151511": {
    "city": "MANSA",
    "state": "PUNJAB"
  },
  "152001": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152002": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152003": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152004": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152005": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152020": {
    "city": "Fazilka",
    "state": "Punjab"
  },
  "152021": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152022": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152023": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152024": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152025": {
    "city": "Muktsar",
    "state": "Punjab"
  },
  "152026": {
    "city": "Muktsar",
    "state": "Punjab"
  },
  "152028": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152031": {
    "city": "Muktsar",
    "state": "Punjab"
  },
  "152032": {
    "city": "Muktsar",
    "state": "Punjab"
  },
  "152033": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152101": {
    "city": "Muktsar",
    "state": "Punjab"
  },
  "152102": {
    "city": "MALOUT",
    "state": "PUNJAB"
  },
  "152103": {
    "city": "MALOUT",
    "state": "PUNJAB"
  },
  "152104": {
    "city": "MUKTSAR",
    "state": "PUNJAB"
  },
  "152107": {
    "city": "Muktsar",
    "state": "Punjab"
  },
  "152112": {
    "city": "Muktsar",
    "state": "Punjab"
  },
  "152113": {
    "city": "Muktsar",
    "state": "Punjab"
  },
  "152114": {
    "city": "Muktsar",
    "state": "Punjab"
  },
  "152115": {
    "city": "Muktsar",
    "state": "Punjab"
  },
  "152116": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152117": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152118": {
    "city": "Fazilka",
    "state": "Punjab"
  },
  "152120": {
    "city": "FAZILKA",
    "state": "PUNJAB"
  },
  "152121": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152122": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152123": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152124": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152125": {
    "city": "ABOHAR",
    "state": "PUNJAB"
  },
  "152126": {
    "city": "ABOHAR",
    "state": "PUNJAB"
  },
  "152127": {
    "city": "ABOHAR",
    "state": "PUNJAB"
  },
  "152128": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "152129": {
    "city": "ABOHAR",
    "state": "PUNJAB"
  },
  "152130": {
    "city": "ABOHAR",
    "state": "PUNJAB"
  },
  "152131": {
    "city": "ABOHAR",
    "state": "PUNJAB"
  },
  "152132": {
    "city": "Firozpur",
    "state": "Punjab"
  },
  "160001": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160002": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160003": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160004": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160005": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160006": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160007": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160008": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160009": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160010": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160011": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160012": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160013": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160014": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160015": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160016": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160017": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160018": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160019": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160020": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160021": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160022": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160023": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160024": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160025": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160026": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160027": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160028": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160029": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160030": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160031": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160032": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160033": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160034": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160035": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160036": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160037": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160038": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160039": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160040": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160041": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160042": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160043": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160044": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160045": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160046": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160047": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160048": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160049": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160050": {
    "city": "CHANDIGARH",
    "state": "UTTARAKHAND"
  },
  "160051": {
    "city": "CHANDIGARH",
    "state": "PUNJAB"
  },
  "160052": {
    "city": "CHANDIGARH",
    "state": "PUNJAB"
  },
  "160053": {
    "city": "CHANDIGARH",
    "state": "PUNJAB"
  },
  "160054": {
    "city": "CHANDIGARH",
    "state": "PUNJAB"
  },
  "160055": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "160056": {
    "city": "CHANDIGARH",
    "state": "PUNJAB"
  },
  "160057": {
    "city": "CHANDIGARH",
    "state": "PUNJAB"
  },
  "160058": {
    "city": "CHANDIGARH",
    "state": "PUNJAB"
  },
  "160059": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "160060": {
    "city": "MOHALI",
    "state": "PUNJAB"
  },
  "160061": {
    "city": "CHANDIGARH",
    "state": "PUNJAB"
  },
  "160062": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "160063": {
    "city": "MOHALI",
    "state": "PUNJAB"
  },
  "160064": {
    "city": "MOHALI",
    "state": "PUNJAB"
  },
  "160065": {
    "city": "MOHALI",
    "state": "PUNJAB"
  },
  "160066": {
    "city": "MOHALI",
    "state": "PUNJAB"
  },
  "160067": {
    "city": "MOHALI",
    "state": "PUNJAB"
  },
  "160068": {
    "city": "MOHALI",
    "state": "PUNJAB"
  },
  "160069": {
    "city": "MOHALI",
    "state": "PUNJAB"
  },
  "160070": {
    "city": "MOHALI",
    "state": "PUNJAB"
  },
  "160071": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "160073": {
    "city": "MOHALI",
    "state": "PUNJAB"
  },
  "160074": {
    "city": "MOHALI",
    "state": "PUNJAB"
  },
  "160077": {
    "city": "Mohali",
    "state": "PUNJAB"
  },
  "160078": {
    "city": "Mohali",
    "state": "PUNJAB"
  },
  "160079": {
    "city": "MOHALI",
    "state": "PUNJAB"
  },
  "160101": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160102": {
    "city": "Chandigarh",
    "state": "Chandigarh"
  },
  "160103": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "160104": {
    "city": "Mohali",
    "state": "Punjab"
  },
  "160106": {
    "city": "CHANDIGARH",
    "state": "CHANDIGARH"
  },
  "160107": {
    "city": "Mohali",
    "state": "PUNJAB"
  },
  "166031": {
    "city": "CHANDIGARH",
    "state": "UTTARAKHAND"
  },
  "171001": {
    "city": "SHIMLA",
    "state": "HIMACHAL PRADESH"
  },
  "171002": {
    "city": "SHIMLA",
    "state": "HIMACHAL PRADESH"
  },
  "171003": {
    "city": "SHIMLA",
    "state": "HIMACHAL PRADESH"
  },
  "171004": {
    "city": "SHIMLA",
    "state": "HIMACHAL PRADESH"
  },
  "171005": {
    "city": "SHIMLA",
    "state": "HIMACHAL PRADESH"
  },
  "171006": {
    "city": "SHIMLA",
    "state": "HIMACHAL PRADESH"
  },
  "171008": {
    "city": "Shimla",
    "state": "HIMACHAL PRADESH"
  },
  "171009": {
    "city": "SHIMLA",
    "state": "HIMACHAL PRADESH"
  },
  "171010": {
    "city": "SHIMLA",
    "state": "HIMACHAL PRADESH"
  },
  "171011": {
    "city": "Shimla",
    "state": "HIMACHAL PRADESH"
  },
  "171012": {
    "city": "SANJAULI",
    "state": "HIMACHAL PRADESH"
  },
  "171013": {
    "city": "Shimla",
    "state": "HIMACHAL PRADESH"
  },
  "171102": {
    "city": "DARLAGHAT",
    "state": "HIMACHAL PRADESH"
  },
  "171201": {
    "city": "THEOG",
    "state": "HIMACHAL PRADESH"
  },
  "171207": {
    "city": "ROHRU",
    "state": "HIMACHAL PRADESH"
  },
  "172001": {
    "city": "RAMPUR HP",
    "state": "HIMACHAL PRADESH"
  },
  "172034": {
    "city": "JEORI HP",
    "state": "HIMACHAL PRADESH"
  },
  "172101": {
    "city": "JEORI HP",
    "state": "HIMACHAL PRADESH"
  },
  "172102": {
    "city": "JEORI HP",
    "state": "HIMACHAL PRADESH"
  },
  "172201": {
    "city": "JEORI HP",
    "state": "HIMACHAL PRADESH"
  },
  "173001": {
    "city": "SIRMAUR",
    "state": "HIMACHAL PRADESH"
  },
  "173021": {
    "city": "PONTASAHIB",
    "state": "HIMACHAL PRADESH"
  },
  "173025": {
    "city": "SIRMAUR",
    "state": "HIMACHAL PRADESH"
  },
  "173030": {
    "city": "NARAINGARH",
    "state": "HARYANA"
  },
  "173202": {
    "city": "DHARAMPUR",
    "state": "HIMACHAL PRADESH"
  },
  "173204": {
    "city": "DHARAMPUR",
    "state": "HIMACHAL PRADESH"
  },
  "173205": {
    "city": "SOLAN",
    "state": "HIMACHAL PRADESH"
  },
  "173206": {
    "city": "KUNIHAR HP",
    "state": "HIMACHAL PRADESH"
  },
  "173207": {
    "city": "KUNIHAR HP",
    "state": "HIMACHAL PRADESH"
  },
  "173208": {
    "city": "DARLAGHAT",
    "state": "HIMACHAL PRADESH"
  },
  "173209": {
    "city": "DHARAMPUR",
    "state": "HIMACHAL PRADESH"
  },
  "173210": {
    "city": "SOLAN",
    "state": "HIMACHAL PRADESH"
  },
  "173211": {
    "city": "SOLAN",
    "state": "HIMACHAL PRADESH"
  },
  "173212": {
    "city": "SOLAN",
    "state": "HIMACHAL PRADESH"
  },
  "173213": {
    "city": "SOLAN",
    "state": "HIMACHAL PRADESH"
  },
  "173214": {
    "city": "SOLAN",
    "state": "HIMACHAL PRADESH"
  },
  "173220": {
    "city": "SOLAN",
    "state": "HIMACHAL PRADESH"
  },
  "173229": {
    "city": "Solan",
    "state": "HIMACHAL PRADESH"
  },
  "174001": {
    "city": "BILASPUR (HP)",
    "state": "HIMACHAL PRADESH"
  },
  "174004": {
    "city": "GHUMARWIN",
    "state": "HIMACHAL PRADESH"
  },
  "174005": {
    "city": "BILASPUR",
    "state": "HIMACHAL PRADESH"
  },
  "174012": {
    "city": "BARMAN",
    "state": "HIMACHAL PRADESH"
  },
  "174013": {
    "city": "BILASPUR (HP)",
    "state": "HIMACHAL PRADESH"
  },
  "174021": {
    "city": "GHUMARWIN",
    "state": "HIMACHAL PRADESH"
  },
  "174023": {
    "city": "GHUMARWIN",
    "state": "HIMACHAL PRADESH"
  },
  "174027": {
    "city": "GHUMARWIN",
    "state": "HIMACHAL PRADESH"
  },
  "174028": {
    "city": "JAHU",
    "state": "HIMACHAL PRADESH"
  },
  "174029": {
    "city": "GHUMARWIN",
    "state": "HIMACHAL PRADESH"
  },
  "174031": {
    "city": "GHUMARWIN",
    "state": "HIMACHAL PRADESH"
  },
  "174034": {
    "city": "BILASPUR HP",
    "state": "HIMACHAL PRADESH"
  },
  "174036": {
    "city": "BARMAN",
    "state": "HIMACHAL PRADESH"
  },
  "174101": {
    "city": "SOLAN",
    "state": "HIMACHAL PRADESH"
  },
  "174102": {
    "city": "Baddi",
    "state": "HIMACHAL PRADESH"
  },
  "174103": {
    "city": "SOLAN",
    "state": "HIMACHAL PRADESH"
  },
  "174301": {
    "city": "UNA",
    "state": "HIMACHAL PRADESH"
  },
  "174302": {
    "city": "UNA",
    "state": "HIMACHAL PRADESH"
  },
  "174303": {
    "city": "UNA",
    "state": "HIMACHAL PRADESH"
  },
  "174304": {
    "city": "BANGANA",
    "state": "HIMACHAL PRADESH"
  },
  "174305": {
    "city": "BANGANA",
    "state": "HIMACHAL PRADESH"
  },
  "174306": {
    "city": "UNA",
    "state": "HIMACHAL PRADESH"
  },
  "174307": {
    "city": "BANGANA",
    "state": "HIMACHAL PRADESH"
  },
  "174308": {
    "city": "BANGANA",
    "state": "HIMACHAL PRADESH"
  },
  "174309": {
    "city": "BANGANA",
    "state": "HIMACHAL PRADESH"
  },
  "174311": {
    "city": "Hamirpur",
    "state": "HIMACHAL PRADESH"
  },
  "174312": {
    "city": "BANGANA",
    "state": "HIMACHAL PRADESH"
  },
  "174315": {
    "city": "UNA",
    "state": "HIMACHAL PRADESH"
  },
  "174317": {
    "city": "UNA",
    "state": "HIMACHAL PRADESH"
  },
  "174320": {
    "city": "BANGANA",
    "state": "HIMACHAL PRADESH"
  },
  "174321": {
    "city": "BANGANA",
    "state": "HIMACHAL PRADESH"
  },
  "174401": {
    "city": "MANDI",
    "state": "HIMACHAL PRADESH"
  },
  "174402": {
    "city": "MANDI",
    "state": "HIMACHAL PRADESH"
  },
  "174505": {
    "city": "Hamirpur",
    "state": "HIMACHAL PRADESH"
  },
  "174929": {
    "city": "GHUMARWIN",
    "state": "HIMACHAL PRADESH"
  },
  "175001": {
    "city": "MANDI",
    "state": "HIMACHAL PRADESH"
  },
  "175002": {
    "city": "MANDI",
    "state": "HIMACHAL PRADESH"
  },
  "175004": {
    "city": "JAHU",
    "state": "HIMACHAL PRADESH"
  },
  "175005": {
    "city": "MANDI",
    "state": "HIMACHAL PRADESH"
  },
  "175006": {
    "city": "Mandi",
    "state": "HIMACHAL PRADESH"
  },
  "175007": {
    "city": "SARKAGHAT",
    "state": "HIMACHAL PRADESH"
  },
  "175008": {
    "city": "MANDI",
    "state": "HIMACHAL PRADESH"
  },
  "175015": {
    "city": "BAIJNATH",
    "state": "HIMACHAL PRADESH"
  },
  "175019": {
    "city": "Mandi",
    "state": "HIMACHAL PRADESH"
  },
  "175021": {
    "city": "MANDI",
    "state": "HIMACHAL PRADESH"
  },
  "175024": {
    "city": "SARKAGHAT",
    "state": "HIMACHAL PRADESH"
  },
  "175025": {
    "city": "SARKAGHAT",
    "state": "HIMACHAL PRADESH"
  },
  "175027": {
    "city": "Mandi",
    "state": "HIMACHAL PRADESH"
  },
  "175030": {
    "city": "BARMAN",
    "state": "HIMACHAL PRADESH"
  },
  "175032": {
    "city": "BAIJNATH",
    "state": "HIMACHAL PRADESH"
  },
  "175033": {
    "city": "JAHU",
    "state": "HIMACHAL PRADESH"
  },
  "175037": {
    "city": "SARKAGHAT",
    "state": "HIMACHAL PRADESH"
  },
  "175040": {
    "city": "SARKAGHAT",
    "state": "HIMACHAL PRADESH"
  },
  "175042": {
    "city": "SARKAGHAT",
    "state": "HIMACHAL PRADESH"
  },
  "175101": {
    "city": "KULLU",
    "state": "HIMACHAL PRADESH"
  },
  "175102": {
    "city": "BHUNTER",
    "state": "HIMACHAL PRADESH"
  },
  "175103": {
    "city": "MANALI",
    "state": "HIMACHAL PRADESH"
  },
  "175124": {
    "city": "MANDI",
    "state": "HIMACHAL PRADESH"
  },
  "175125": {
    "city": "BHUNTER",
    "state": "HIMACHAL PRADESH"
  },
  "175126": {
    "city": "BHUNTER",
    "state": "HIMACHAL PRADESH"
  },
  "175128": {
    "city": "BHUNTER",
    "state": "HIMACHAL PRADESH"
  },
  "175129": {
    "city": "MANALI",
    "state": "HIMACHAL PRADESH"
  },
  "175130": {
    "city": "MANALI",
    "state": "HIMACHAL PRADESH"
  },
  "175131": {
    "city": "MANALI",
    "state": "HIMACHAL PRADESH"
  },
  "175136": {
    "city": "MANALI",
    "state": "HIMACHAL PRADESH"
  },
  "175143": {
    "city": "MANALI",
    "state": "HIMACHAL PRADESH"
  },
  "176001": {
    "city": "KANGRA",
    "state": "HIMACHAL PRADESH"
  },
  "176002": {
    "city": "NAGROTA BAGWAN",
    "state": "HIMACHAL PRADESH"
  },
  "176012": {
    "city": "BAIJNATH",
    "state": "HIMACHAL PRADESH"
  },
  "176020": {
    "city": "BAIJNATH",
    "state": "HIMACHAL PRADESH"
  },
  "176021": {
    "city": "JAWALI",
    "state": "HIMACHAL PRADESH"
  },
  "176022": {
    "city": "JAWALI",
    "state": "HIMACHAL PRADESH"
  },
  "176023": {
    "city": "JAWALI",
    "state": "HIMACHAL PRADESH"
  },
  "176024": {
    "city": "JAWALI",
    "state": "HIMACHAL PRADESH"
  },
  "176025": {
    "city": "JAWALI",
    "state": "HIMACHAL PRADESH"
  },
  "176026": {
    "city": "SHAHPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176027": {
    "city": "JAWALI",
    "state": "HIMACHAL PRADESH"
  },
  "176028": {
    "city": "NAGROTA SURIYAN",
    "state": "HIMACHAL PRADESH"
  },
  "176031": {
    "city": "DEHRA",
    "state": "HIMACHAL PRADESH"
  },
  "176033": {
    "city": "NAGROTA SURIYAN",
    "state": "HIMACHAL PRADESH"
  },
  "176036": {
    "city": "NADAUN",
    "state": "HIMACHAL PRADESH"
  },
  "176040": {
    "city": "Hamirpur",
    "state": "HIMACHAL PRADESH"
  },
  "176041": {
    "city": "Hamirpur",
    "state": "HIMACHAL PRADESH"
  },
  "176042": {
    "city": "Hamirpur",
    "state": "HIMACHAL PRADESH"
  },
  "176043": {
    "city": "JAHU",
    "state": "HIMACHAL PRADESH"
  },
  "176044": {
    "city": "JAHU",
    "state": "HIMACHAL PRADESH"
  },
  "176045": {
    "city": "JAHU",
    "state": "HIMACHAL PRADESH"
  },
  "176047": {
    "city": "KANGRA",
    "state": "HIMACHAL PRADESH"
  },
  "176048": {
    "city": "JAHU",
    "state": "HIMACHAL PRADESH"
  },
  "176049": {
    "city": "Hamirpur",
    "state": "HIMACHAL PRADESH"
  },
  "176051": {
    "city": "JASSUR",
    "state": "HIMACHAL PRADESH"
  },
  "176052": {
    "city": "Dharmshala",
    "state": "HIMACHAL PRADESH"
  },
  "176053": {
    "city": "JAWALI",
    "state": "HIMACHAL PRADESH"
  },
  "176056": {
    "city": "NAGROTA BAGWAN",
    "state": "HIMACHAL PRADESH"
  },
  "176057": {
    "city": "KANGRA",
    "state": "HIMACHAL PRADESH"
  },
  "176059": {
    "city": "PALAMPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176060": {
    "city": "PAROR",
    "state": "HIMACHAL PRADESH"
  },
  "176061": {
    "city": "KANGRA",
    "state": "HIMACHAL PRADESH"
  },
  "176062": {
    "city": "PALAMPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176063": {
    "city": "BAIJNATH",
    "state": "HIMACHAL PRADESH"
  },
  "176064": {
    "city": "PAROR",
    "state": "HIMACHAL PRADESH"
  },
  "176067": {
    "city": "PALAMPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176077": {
    "city": "BAIJNATH",
    "state": "HIMACHAL PRADESH"
  },
  "176081": {
    "city": "BAIJNATH",
    "state": "HIMACHAL PRADESH"
  },
  "176082": {
    "city": "SUJANPUR TIRA",
    "state": "HIMACHAL PRADESH"
  },
  "176083": {
    "city": "PALAMPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176084": {
    "city": "PAROR",
    "state": "HIMACHAL PRADESH"
  },
  "176085": {
    "city": "PAROR",
    "state": "HIMACHAL PRADESH"
  },
  "176087": {
    "city": "PALAMPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176092": {
    "city": "DAROH",
    "state": "HIMACHAL PRADESH"
  },
  "176093": {
    "city": "DAROH",
    "state": "HIMACHAL PRADESH"
  },
  "176094": {
    "city": "DAROH",
    "state": "HIMACHAL PRADESH"
  },
  "176096": {
    "city": "DAROH",
    "state": "HIMACHAL PRADESH"
  },
  "176097": {
    "city": "DAROH",
    "state": "HIMACHAL PRADESH"
  },
  "176101": {
    "city": "PAROR",
    "state": "HIMACHAL PRADESH"
  },
  "176102": {
    "city": "PALAMPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176103": {
    "city": "PALAMPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176107": {
    "city": "SUJANPUR TIRA",
    "state": "HIMACHAL PRADESH"
  },
  "176108": {
    "city": "SUJANPUR TIRA",
    "state": "HIMACHAL PRADESH"
  },
  "176110": {
    "city": "SUJANPUR TIRA",
    "state": "HIMACHAL PRADESH"
  },
  "176115": {
    "city": "PALAMPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176120": {
    "city": "BAIJNATH",
    "state": "HIMACHAL PRADESH"
  },
  "176125": {
    "city": "PALAMPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176128": {
    "city": "BAIJNATH",
    "state": "HIMACHAL PRADESH"
  },
  "176200": {
    "city": "JASSUR",
    "state": "HIMACHAL PRADESH"
  },
  "176201": {
    "city": "JASSUR",
    "state": "HIMACHAL PRADESH"
  },
  "176202": {
    "city": "JASSUR",
    "state": "HIMACHAL PRADESH"
  },
  "176204": {
    "city": "JASSUR",
    "state": "HIMACHAL PRADESH"
  },
  "176205": {
    "city": "SHAHPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176206": {
    "city": "SHAHPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176208": {
    "city": "SHAHPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176209": {
    "city": "KANGRA",
    "state": "HIMACHAL PRADESH"
  },
  "176211": {
    "city": "JASSUR",
    "state": "HIMACHAL PRADESH"
  },
  "176213": {
    "city": "Dharmshala",
    "state": "HIMACHAL PRADESH"
  },
  "176214": {
    "city": "GAGAL",
    "state": "HIMACHAL PRADESH"
  },
  "176215": {
    "city": "KANGRA",
    "state": "HIMACHAL PRADESH"
  },
  "176216": {
    "city": "DHARAMSHALA",
    "state": "HIMACHAL PRADESH"
  },
  "176217": {
    "city": "Dharmshala",
    "state": "HIMACHAL PRADESH"
  },
  "176218": {
    "city": "DHARAMSHALA",
    "state": "HIMACHAL PRADESH"
  },
  "176219": {
    "city": "KANGRA",
    "state": "HIMACHAL PRADESH"
  },
  "176223": {
    "city": "SHAHPUR",
    "state": "HIMACHAL PRADESH"
  },
  "176301": {
    "city": "DALHOUSIE",
    "state": "HIMACHAL PRADESH"
  },
  "176302": {
    "city": "DHAR KALAN",
    "state": "PUNJAB"
  },
  "176303": {
    "city": "DALHOUSIE",
    "state": "HIMACHAL PRADESH"
  },
  "176304": {
    "city": "DALHOUSIE",
    "state": "HIMACHAL PRADESH"
  },
  "176305": {
    "city": "DALHOUSIE",
    "state": "HIMACHAL PRADESH"
  },
  "176306": {
    "city": "DALHOUSIE",
    "state": "HIMACHAL PRADESH"
  },
  "176308": {
    "city": "SUNDLA",
    "state": "HIMACHAL PRADESH"
  },
  "176310": {
    "city": "CHAMBA",
    "state": "HIMACHAL PRADESH"
  },
  "176312": {
    "city": "SUNDLA",
    "state": "HIMACHAL PRADESH"
  },
  "176314": {
    "city": "CHAMBA",
    "state": "HIMACHAL PRADESH"
  },
  "176317": {
    "city": "SUNDLA",
    "state": "HIMACHAL PRADESH"
  },
  "176318": {
    "city": "CHAMBA",
    "state": "HIMACHAL PRADESH"
  },
  "176319": {
    "city": "SUNDLA",
    "state": "HIMACHAL PRADESH"
  },
  "176320": {
    "city": "SUNDLA",
    "state": "HIMACHAL PRADESH"
  },
  "176325": {
    "city": "DALHOUSIE",
    "state": "HIMACHAL PRADESH"
  },
  "176401": {
    "city": "INDORA",
    "state": "HIMACHAL PRADESH"
  },
  "176402": {
    "city": "INDORA",
    "state": "HIMACHAL PRADESH"
  },
  "176403": {
    "city": "INDORA",
    "state": "HIMACHAL PRADESH"
  },
  "176404": {
    "city": "INDORA",
    "state": "HIMACHAL PRADESH"
  },
  "177001": {
    "city": "HAMIRPUR",
    "state": "HIMACHAL PRADESH"
  },
  "177002": {
    "city": "HAMIRPUR",
    "state": "HIMACHAL PRADESH"
  },
  "177005": {
    "city": "HAMIRPUR(HP)",
    "state": "HIMACHAL PRADESH"
  },
  "177006": {
    "city": "GALORE",
    "state": "HIMACHAL PRADESH"
  },
  "177020": {
    "city": "Hamirpur",
    "state": "HIMACHAL PRADESH"
  },
  "177024": {
    "city": "JAHU",
    "state": "HIMACHAL PRADESH"
  },
  "177026": {
    "city": "GALORE",
    "state": "HIMACHAL PRADESH"
  },
  "177027": {
    "city": "Hamirpur",
    "state": "HIMACHAL PRADESH"
  },
  "177029": {
    "city": "Hamirpur",
    "state": "HIMACHAL PRADESH"
  },
  "177031": {
    "city": "BANGANA",
    "state": "HIMACHAL PRADESH"
  },
  "177033": {
    "city": "NADAUN",
    "state": "HIMACHAL PRADESH"
  },
  "177038": {
    "city": "NADAUN",
    "state": "HIMACHAL PRADESH"
  },
  "177039": {
    "city": "BANGANA",
    "state": "HIMACHAL PRADESH"
  },
  "177040": {
    "city": "GALORE",
    "state": "HIMACHAL PRADESH"
  },
  "177041": {
    "city": "BANGANA",
    "state": "HIMACHAL PRADESH"
  },
  "177042": {
    "city": "NADAUN",
    "state": "HIMACHAL PRADESH"
  },
  "177044": {
    "city": "NADAUN",
    "state": "HIMACHAL PRADESH"
  },
  "177045": {
    "city": "NADAUN",
    "state": "HIMACHAL PRADESH"
  },
  "177046": {
    "city": "NADAUN",
    "state": "HIMACHAL PRADESH"
  },
  "177048": {
    "city": "NADAUN",
    "state": "HIMACHAL PRADESH"
  },
  "177101": {
    "city": "DEHRA",
    "state": "HIMACHAL PRADESH"
  },
  "177103": {
    "city": "DEHRA",
    "state": "HIMACHAL PRADESH"
  },
  "177104": {
    "city": "DEHRA",
    "state": "HIMACHAL PRADESH"
  },
  "177107": {
    "city": "DEHRA",
    "state": "HIMACHAL PRADESH"
  },
  "177108": {
    "city": "DEHRA",
    "state": "HIMACHAL PRADESH"
  },
  "177109": {
    "city": "GONDPUR",
    "state": "HIMACHAL PRADESH"
  },
  "177114": {
    "city": "DEHRA",
    "state": "HIMACHAL PRADESH"
  },
  "177117": {
    "city": "DEHRA",
    "state": "HIMACHAL PRADESH"
  },
  "177118": {
    "city": "NADAUN",
    "state": "HIMACHAL PRADESH"
  },
  "177119": {
    "city": "BANGANA",
    "state": "HIMACHAL PRADESH"
  },
  "177201": {
    "city": "AMB",
    "state": "HIMACHAL PRADESH"
  },
  "177202": {
    "city": "AMB",
    "state": "HIMACHAL PRADESH"
  },
  "177203": {
    "city": "AMB",
    "state": "HIMACHAL PRADESH"
  },
  "177204": {
    "city": "GONDPUR",
    "state": "HIMACHAL PRADESH"
  },
  "177205": {
    "city": "AMB",
    "state": "HIMACHAL PRADESH"
  },
  "177206": {
    "city": "AMB",
    "state": "HIMACHAL PRADESH"
  },
  "177207": {
    "city": "AMB",
    "state": "HIMACHAL PRADESH"
  },
  "177208": {
    "city": "AMB",
    "state": "HIMACHAL PRADESH"
  },
  "177210": {
    "city": "AMB",
    "state": "HIMACHAL PRADESH"
  },
  "177211": {
    "city": "AMB",
    "state": "HIMACHAL PRADESH"
  },
  "177212": {
    "city": "GONDPUR",
    "state": "HIMACHAL PRADESH"
  },
  "177213": {
    "city": "GONDPUR",
    "state": "HIMACHAL PRADESH"
  },
  "177301": {
    "city": "NADAUN",
    "state": "HIMACHAL PRADESH"
  },
  "177401": {
    "city": "Hamirpur",
    "state": "HIMACHAL PRADESH"
  },
  "177501": {
    "city": "Hamirpur",
    "state": "HIMACHAL PRADESH"
  },
  "177601": {
    "city": "JAHU",
    "state": "HIMACHAL PRADESH"
  },
  "179092": {
    "city": "PALAMPUR",
    "state": "HIMACHAL PRADESH"
  },
  "180001": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180002": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180003": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180004": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180005": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180006": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180007": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180008": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180009": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180010": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180011": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180012": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180013": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180014": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180015": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180016": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180017": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "180018": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180019": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "180020": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "181008": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181101": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "181102": {
    "city": "MIRANSAHIB",
    "state": "JAMMU AND KASHMIR"
  },
  "181103": {
    "city": "MIRANSAHIB",
    "state": "JAMMU AND KASHMIR"
  },
  "181104": {
    "city": "MIRANSAHIB",
    "state": "JAMMU AND KASHMIR"
  },
  "181105": {
    "city": "MIRANSAHIB",
    "state": "JAMMU AND KASHMIR"
  },
  "181111": {
    "city": "MIRANSAHIB",
    "state": "JAMMU AND KASHMIR"
  },
  "181112": {
    "city": "MIRANSAHIB",
    "state": "JAMMU AND KASHMIR"
  },
  "181113": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181114": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181121": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "181122": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181123": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "181124": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "181131": {
    "city": "MIRANSAHIB",
    "state": "JAMMU AND KASHMIR"
  },
  "181132": {
    "city": "MIRANSAHIB",
    "state": "JAMMU AND KASHMIR"
  },
  "181133": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "181134": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181141": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181142": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181143": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181144": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181145": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181151": {
    "city": "BATHINDI",
    "state": "JAMMU AND KASHMIR"
  },
  "181152": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "181201": {
    "city": "AKHNOOR",
    "state": "JAMMU AND KASHMIR"
  },
  "181202": {
    "city": "AKHNOOR",
    "state": "JAMMU AND KASHMIR"
  },
  "181203": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181204": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181205": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "181206": {
    "city": "AKHNOOR",
    "state": "JAMMU AND KASHMIR"
  },
  "181207": {
    "city": "AKHNOOR",
    "state": "JAMMU AND KASHMIR"
  },
  "181208": {
    "city": "AKHNOOR",
    "state": "JAMMU AND KASHMIR"
  },
  "181209": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181221": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "181223": {
    "city": "JAMMU",
    "state": "JAMMU AND KASHMIR"
  },
  "181224": {
    "city": "MANWAL",
    "state": "JAMMU AND KASHMIR"
  },
  "181256": {
    "city": "Jammu",
    "state": "JAMMU AND KASHMIR"
  },
  "182101": {
    "city": "UDHAMPUR",
    "state": "JAMMU & KASHMIR"
  },
  "182103": {
    "city": "UDHAMPUR",
    "state": "JAMMU AND KASHMIR"
  },
  "182104": {
    "city": "UDHAMPUR",
    "state": "JAMMU & KASHMIR"
  },
  "182117": {
    "city": "MANWAL",
    "state": "JAMMU AND KASHMIR"
  },
  "182121": {
    "city": "UDHAMPUR",
    "state": "JAMMU & KASHMIR"
  },
  "182122": {
    "city": "UDHAMPUR",
    "state": "JAMMU AND KASHMIR"
  },
  "182123": {
    "city": "UDHAMPUR",
    "state": "JAMMU AND KASHMIR"
  },
  "182127": {
    "city": "MANWAL",
    "state": "JAMMU AND KASHMIR"
  },
  "182144": {
    "city": "RAMBAN",
    "state": "JAMMU AND KASHMIR"
  },
  "182202": {
    "city": "DODA",
    "state": "JAMMU AND KASHMIR"
  },
  "182222": {
    "city": "BAHDERWAH",
    "state": "JAMMU AND KASHMIR"
  },
  "182301": {
    "city": "KATRA",
    "state": "JAMMU AND KASHMIR"
  },
  "182302": {
    "city": "KATRA",
    "state": "JAMMU AND KASHMIR"
  },
  "182311": {
    "city": "KATRA",
    "state": "JAMMU AND KASHMIR"
  },
  "182312": {
    "city": "KATRA",
    "state": "JAMMU AND KASHMIR"
  },
  "182313": {
    "city": "KATRA",
    "state": "JAMMU AND KASHMIR"
  },
  "182314": {
    "city": "KATRA",
    "state": "JAMMU AND KASHMIR"
  },
  "184101": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184102": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184103": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184104": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184120": {
    "city": "SAMBA",
    "state": "JAMMU AND KASHMIR"
  },
  "184121": {
    "city": "JAMMU",
    "state": "JAMMU & KASHMIR"
  },
  "184141": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184142": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184143": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184144": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184145": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184146": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184147": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184148": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184151": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184152": {
    "city": "KATHUA",
    "state": "JAMMU AND KASHMIR"
  },
  "184201": {
    "city": "DHAR KALAN",
    "state": "PUNJAB"
  },
  "184204": {
    "city": "BILLAWAR",
    "state": "JAMMU AND KASHMIR"
  },
  "185101": {
    "city": "POONCH",
    "state": "JAMMU AND KASHMIR"
  },
  "185131": {
    "city": "RAJOURI",
    "state": "JAMMU AND KASHMIR"
  },
  "185132": {
    "city": "RAJOURI",
    "state": "JAMMU AND KASHMIR"
  },
  "185151": {
    "city": "NOWSHERA",
    "state": "JAMMU AND KASHMIR"
  },
  "185152": {
    "city": "NOWSHERA",
    "state": "JAMMU AND KASHMIR"
  },
  "185153": {
    "city": "SUNDERBANI",
    "state": "JAMMU AND KASHMIR"
  },
  "190000": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190001": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190002": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190003": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190004": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190005": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190006": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190007": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190008": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190009": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190010": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190011": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190012": {
    "city": "NARBAL",
    "state": "JAMMU AND KASHMIR"
  },
  "190013": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190014": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190016": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190017": {
    "city": "NARBAL",
    "state": "JAMMU AND KASHMIR"
  },
  "190018": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190019": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190020": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190021": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190022": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190023": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190024": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "190025": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "191101": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "191111": {
    "city": "BUDGAM",
    "state": "JAMMU AND KASHMIR"
  },
  "191112": {
    "city": "BUDGAM",
    "state": "JAMMU AND KASHMIR"
  },
  "191113": {
    "city": "BUDGAM",
    "state": "JAMMU AND KASHMIR"
  },
  "191121": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "191123": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "191131": {
    "city": "GANDERBAL",
    "state": "JAMMU AND KASHMIR"
  },
  "191132": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "191141": {
    "city": "SRINAGAR",
    "state": "JAMMU AND KASHMIR"
  },
  "191201": {
    "city": "GANDERBAL",
    "state": "JAMMU AND KASHMIR"
  },
  "191202": {
    "city": "GANDERBAL",
    "state": "JAMMU AND KASHMIR"
  },
  "191203": {
    "city": "GANDERBAL",
    "state": "JAMMU AND KASHMIR"
  },
  "191204": {
    "city": "GANDERBAL",
    "state": "JAMMU AND KASHMIR"
  },
  "191205": {
    "city": "GANDERBAL",
    "state": "JAMMU AND KASHMIR"
  },
  "192101": {
    "city": "ANANTNAG",
    "state": "JAMMU AND KASHMIR"
  },
  "192102": {
    "city": "ANANTNAG",
    "state": "JAMMU AND KASHMIR"
  },
  "192122": {
    "city": "BIJBIHARA",
    "state": "JAMMU AND KASHMIR"
  },
  "192123": {
    "city": "BIJBIHARA",
    "state": "JAMMU AND KASHMIR"
  },
  "192124": {
    "city": "BIJBIHARA",
    "state": "JAMMU AND KASHMIR"
  },
  "192125": {
    "city": "BIJBIHARA",
    "state": "JAMMU AND KASHMIR"
  },
  "192126": {
    "city": "ANANTNAG",
    "state": "JAMMU AND KASHMIR"
  },
  "192127": {
    "city": "ANANTNAG",
    "state": "JAMMU AND KASHMIR"
  },
  "192202": {
    "city": "ANANTNAG",
    "state": "JAMMU AND KASHMIR"
  },
  "192203": {
    "city": "ANANTNAG",
    "state": "JAMMU AND KASHMIR"
  },
  "192211": {
    "city": "ANANTNAG",
    "state": "JAMMU AND KASHMIR"
  },
  "192212": {
    "city": "ANANTNAG",
    "state": "JAMMU AND KASHMIR"
  },
  "192230": {
    "city": "KULGAM",
    "state": "JAMMU AND KASHMIR"
  },
  "192231": {
    "city": "KULGAM",
    "state": "JAMMU AND KASHMIR"
  },
  "192232": {
    "city": "KULGAM",
    "state": "JAMMU AND KASHMIR"
  },
  "192233": {
    "city": "KULGAM",
    "state": "JAMMU AND KASHMIR"
  },
  "192234": {
    "city": "KULGAM",
    "state": "JAMMU AND KASHMIR"
  },
  "192301": {
    "city": "PULWAMA",
    "state": "JAMMU AND KASHMIR"
  },
  "192302": {
    "city": "SHOPIAN",
    "state": "JAMMU AND KASHMIR"
  },
  "192303": {
    "city": "SHOPIAN",
    "state": "JAMMU AND KASHMIR"
  },
  "192304": {
    "city": "PULWAMA",
    "state": "JAMMU AND KASHMIR"
  },
  "192305": {
    "city": "SHOPIAN",
    "state": "JAMMU AND KASHMIR"
  },
  "192306": {
    "city": "PULWAMA",
    "state": "JAMMU AND KASHMIR"
  },
  "192307": {
    "city": "PULWAMA",
    "state": "JAMMU AND KASHMIR"
  },
  "192308": {
    "city": "PULWAMA",
    "state": "JAMMU AND KASHMIR"
  },
  "192309": {
    "city": "PULWAMA",
    "state": "JAMMU AND KASHMIR"
  },
  "192401": {
    "city": "BIJBIHARA",
    "state": "JAMMU AND KASHMIR"
  },
  "192403": {
    "city": "BIJBIHARA",
    "state": "JAMMU AND KASHMIR"
  },
  "193101": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193102": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193103": {
    "city": "PATTAN",
    "state": "JAMMU AND KASHMIR"
  },
  "193105": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193106": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193107": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193108": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193109": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193121": {
    "city": "PATTAN",
    "state": "JAMMU AND KASHMIR"
  },
  "193123": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193124": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193125": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193130": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193131": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193132": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193201": {
    "city": "SOPORE",
    "state": "JAMMU AND KASHMIR"
  },
  "193202": {
    "city": "SOPORE",
    "state": "JAMMU AND KASHMIR"
  },
  "193208": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193209": {
    "city": "SOPORE",
    "state": "JAMMU AND KASHMIR"
  },
  "193211": {
    "city": "SOPORE",
    "state": "JAMMU AND KASHMIR"
  },
  "193212": {
    "city": "SOPORE",
    "state": "JAMMU AND KASHMIR"
  },
  "193301": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193302": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193303": {
    "city": "BARAMULLA",
    "state": "JAMMU AND KASHMIR"
  },
  "193401": {
    "city": "NARBAL",
    "state": "JAMMU AND KASHMIR"
  },
  "193402": {
    "city": "NARBAL",
    "state": "JAMMU AND KASHMIR"
  },
  "193403": {
    "city": "NARBAL",
    "state": "JAMMU AND KASHMIR"
  },
  "193411": {
    "city": "BUDGAM",
    "state": "JAMMU AND KASHMIR"
  },
  "201000": {
    "city": "GHAZIABAD",
    "state": "UTTAR PRADESH"
  },
  "201001": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201002": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201003": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201004": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201005": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201006": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201007": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201008": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201009": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201010": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201011": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201012": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201013": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201014": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201015": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201016": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201017": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201018": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201019": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201020": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201036": {
    "city": "Delhi",
    "state": "DELHI"
  },
  "201101": {
    "city": "BAGHPAT",
    "state": "UTTAR PRADESH"
  },
  "201102": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201103": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201106": {
    "city": "GHAZIABAD",
    "state": "UTTAR PRADESH"
  },
  "201111": {
    "city": "NOIDA-ETAIL DELIVERY/RTO",
    "state": "UTTAR PRADESH"
  },
  "201112": {
    "city": "UNCHAHAR",
    "state": "UTTAR PRADESH"
  },
  "201201": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201202": {
    "city": "MODINAGAR",
    "state": "UTTAR PRADESH"
  },
  "201204": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201205": {
    "city": "MODINAGAR",
    "state": "UTTAR PRADESH"
  },
  "201206": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "201208": {
    "city": "Ghaziabad",
    "state": "UTTAR PRADESH"
  },
  "201300": {
    "city": "NOIDA",
    "state": "UTTAR PRADESH"
  },
  "201301": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201302": {
    "city": "NOIDA",
    "state": "UTTAR PRADESH"
  },
  "201303": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201304": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201305": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201306": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201307": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201308": {
    "city": "NOIDA",
    "state": "UTTAR PRADESH"
  },
  "201309": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201310": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201311": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201312": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201313": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201314": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201315": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201316": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "201317": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "202001": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202002": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202004": {
    "city": "ALIGARH",
    "state": "UTTAR PRADESH"
  },
  "202117": {
    "city": "ALIGARH",
    "state": "UTTAR PRADESH"
  },
  "202118": {
    "city": "ALIGARH",
    "state": "UTTAR PRADESH"
  },
  "202119": {
    "city": "ALIGARH",
    "state": "UTTAR PRADESH"
  },
  "202120": {
    "city": "SIKANDRA RAO",
    "state": "UTTAR PRADESH"
  },
  "202121": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202122": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202123": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202124": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202125": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202126": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202127": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202128": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202129": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202130": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202131": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202132": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202133": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202134": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202135": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202136": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202137": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202138": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202139": {
    "city": "Hathras",
    "state": "Uttar Pradesh"
  },
  "202140": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202141": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202142": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202143": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202144": {
    "city": "IGLAS",
    "state": "UTTAR PRADESH"
  },
  "202145": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202146": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202150": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202151": {
    "city": "ALIGARH",
    "state": "UTTAR PRADESH"
  },
  "202155": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202165": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202170": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202171": {
    "city": "ALIGARH",
    "state": "UTTAR PRADESH"
  },
  "202280": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202281": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202282": {
    "city": "Aligarh",
    "state": "Uttar Pradesh"
  },
  "202305": {
    "city": "ATRAULI",
    "state": "UTTAR PRADESH"
  },
  "202308": {
    "city": "ATRAULI",
    "state": "UTTAR PRADESH"
  },
  "202383": {
    "city": "ATRAULI",
    "state": "UTTAR PRADESH"
  },
  "202389": {
    "city": "DIBAI",
    "state": "UTTAR PRADESH"
  },
  "202390": {
    "city": "ANUPSHAHAR",
    "state": "UTTAR PRADESH"
  },
  "202391": {
    "city": "ANUPSHAHAR",
    "state": "UTTAR PRADESH"
  },
  "202392": {
    "city": "DIBAI",
    "state": "UTTAR PRADESH"
  },
  "202393": {
    "city": "DIBAI",
    "state": "UTTAR PRADESH"
  },
  "202394": {
    "city": "ANUPSHAHAR",
    "state": "UTTAR PRADESH"
  },
  "202395": {
    "city": "KHURJA",
    "state": "UTTAR PRADESH"
  },
  "202396": {
    "city": "DIBAI",
    "state": "UTTAR PRADESH"
  },
  "202397": {
    "city": "DIBAI",
    "state": "UTTAR PRADESH"
  },
  "202398": {
    "city": "ANUPSHAHAR",
    "state": "UTTAR PRADESH"
  },
  "202399": {
    "city": "DIBAI",
    "state": "UTTAR PRADESH"
  },
  "202410": {
    "city": "CHANDAUSI",
    "state": "UTTAR PRADESH"
  },
  "202411": {
    "city": "BILARI",
    "state": "UTTAR PRADESH"
  },
  "202412": {
    "city": "CHANDAUSI",
    "state": "UTTAR PRADESH"
  },
  "202413": {
    "city": "BILARI",
    "state": "UTTAR PRADESH"
  },
  "202414": {
    "city": "CHANDAUSI",
    "state": "UTTAR PRADESH"
  },
  "202415": {
    "city": "BILARI",
    "state": "UTTAR PRADESH"
  },
  "202416": {
    "city": "ATRAULI",
    "state": "UTTAR PRADESH"
  },
  "202720": {
    "city": "ATRAULI",
    "state": "UTTAR PRADESH"
  },
  "202721": {
    "city": "ATRAULI",
    "state": "UTTAR PRADESH"
  },
  "202722": {
    "city": "ATRAULI",
    "state": "UTTAR PRADESH"
  },
  "202723": {
    "city": "ATRAULI",
    "state": "UTTAR PRADESH"
  },
  "202724": {
    "city": "ATRAULI",
    "state": "UTTAR PRADESH"
  },
  "203001": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203002": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203121": {
    "city": "BULANDSHAHR",
    "state": "UTTAR PRADESH"
  },
  "203129": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203131": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203132": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203133": {
    "city": "KHURJA",
    "state": "UTTAR PRADESH"
  },
  "203135": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "203141": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203145": {
    "city": "BULANDSHAHR",
    "state": "UTTAR PRADESH"
  },
  "203150": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203155": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203201": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "203202": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "203203": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "203205": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203206": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203207": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "203208": {
    "city": "DHAULANA",
    "state": "UTTAR PRADESH"
  },
  "203209": {
    "city": "Gautam Buddha Nagar",
    "state": "Uttar Pradesh"
  },
  "203298": {
    "city": "BULANDSHAHR",
    "state": "UTTAR PRADESH"
  },
  "203389": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203390": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203391": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203392": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203393": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203394": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203395": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203396": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203397": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203398": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203399": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203401": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203402": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203403": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203405": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203407": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203408": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203409": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203411": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203412": {
    "city": "Bulandshahr",
    "state": "Uttar Pradesh"
  },
  "203428": {
    "city": "BULANDSHAHR",
    "state": "UTTAR PRADESH"
  },
  "203551": {
    "city": "FIROZABAD",
    "state": "UTTAR PRADESH"
  },
  "203636": {
    "city": "SIYANA",
    "state": "UTTAR PRADESH"
  },
  "204101": {
    "city": "Hathras",
    "state": "Uttar Pradesh"
  },
  "204102": {
    "city": "Hathras",
    "state": "Uttar Pradesh"
  },
  "204103": {
    "city": "HATHRAS",
    "state": "UTTAR PRADESH"
  },
  "204104": {
    "city": "HATHRAS",
    "state": "UTTAR PRADESH"
  },
  "204105": {
    "city": "HATHRAS",
    "state": "UTTAR PRADESH"
  },
  "204106": {
    "city": "HATHRAS",
    "state": "UTTAR PRADESH"
  },
  "204141": {
    "city": "HATHRAS",
    "state": "UTTAR PRADESH"
  },
  "204205": {
    "city": "HATHRAS",
    "state": "UTTAR PRADESH"
  },
  "204206": {
    "city": "HATHRAS",
    "state": "UTTAR PRADESH"
  },
  "204207": {
    "city": "HATHRAS",
    "state": "UTTAR PRADESH"
  },
  "204208": {
    "city": "HATHRAS",
    "state": "UTTAR PRADESH"
  },
  "204209": {
    "city": "HATHRAS",
    "state": "UTTAR PRADESH"
  },
  "204210": {
    "city": "SIKANDRA RAO",
    "state": "UTTAR PRADESH"
  },
  "204211": {
    "city": "Hathras",
    "state": "Uttar Pradesh"
  },
  "204212": {
    "city": "Hathras",
    "state": "Uttar Pradesh"
  },
  "204213": {
    "city": "Hathras",
    "state": "Uttar Pradesh"
  },
  "204214": {
    "city": "Hathras",
    "state": "Uttar Pradesh"
  },
  "204215": {
    "city": "Hathras",
    "state": "Uttar Pradesh"
  },
  "204216": {
    "city": "Hathras",
    "state": "Uttar Pradesh"
  },
  "205001": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "205119": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "205120": {
    "city": "JASRANA",
    "state": "UTTAR PRADESH"
  },
  "205121": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "205122": {
    "city": "JASRANA",
    "state": "UTTAR PRADESH"
  },
  "205125": {
    "city": "JASRANA",
    "state": "UTTAR PRADESH"
  },
  "205126": {
    "city": "JASRANA",
    "state": "UTTAR PRADESH"
  },
  "205130": {
    "city": "JASRANA",
    "state": "UTTAR PRADESH"
  },
  "205135": {
    "city": "JASRANA",
    "state": "UTTAR PRADESH"
  },
  "205247": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "205261": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "205262": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "205263": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "205264": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "205265": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "205266": {
    "city": "MAINPURI",
    "state": "UTTAR PRADESH"
  },
  "205267": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "205268": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "205301": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "205302": {
    "city": "FARRUKHABAD",
    "state": "UTTAR PRADESH"
  },
  "205303": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "205304": {
    "city": "Mainpuri",
    "state": "Uttar Pradesh"
  },
  "206001": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206002": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206003": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206120": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206121": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206122": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206123": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206124": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206125": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206126": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206127": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206128": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206129": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206130": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206131": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206167": {
    "city": "BAKEWAR",
    "state": "UTTAR PRADESH"
  },
  "206241": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206242": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206243": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206244": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206245": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206246": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206247": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206248": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206249": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206250": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206251": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206252": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206253": {
    "city": "Etawah",
    "state": "Uttar Pradesh"
  },
  "206254": {
    "city": "RASULABAD",
    "state": "UTTAR PRADESH"
  },
  "206255": {
    "city": "Auraiya",
    "state": "Uttar Pradesh"
  },
  "206308": {
    "city": "RASULABAD",
    "state": "UTTAR PRADESH"
  },
  "207001": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207002": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207003": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207023": {
    "city": "ETAH",
    "state": "UTTAR PRADESH"
  },
  "207120": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207121": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207122": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207123": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207124": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207125": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207126": {
    "city": "KASGANJ",
    "state": "UTTAR PRADESH"
  },
  "207241": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207242": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207243": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207244": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207245": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207246": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207247": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207248": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207249": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207250": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207301": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207302": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207401": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207402": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207403": {
    "city": "Etah",
    "state": "Uttar Pradesh"
  },
  "207404": {
    "city": "KASGANJ",
    "state": "UTTAR PRADESH"
  },
  "207441": {
    "city": "KASGANJ",
    "state": "UTTAR PRADESH"
  },
  "208001": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208002": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208003": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208004": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208005": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208006": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208007": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208008": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208009": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208010": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208011": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208012": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208013": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208014": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208015": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208016": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208017": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208018": {
    "city": "KANPUR",
    "state": "UTTAR PRADESH"
  },
  "208019": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208020": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208021": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208022": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208023": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208024": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208025": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208026": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208027": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "208039": {
    "city": "KANPUR",
    "state": "UTTAR PRADESH"
  },
  "208120": {
    "city": "UNNAO",
    "state": "UTTAR PRADESH"
  },
  "209025": {
    "city": "BHOGNIPUR",
    "state": "UTTAR PRADESH"
  },
  "209101": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209111": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209112": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209115": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209121": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209125": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209201": {
    "city": "BILHAUR",
    "state": "UTTAR PRADESH"
  },
  "209202": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209203": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209204": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209205": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209206": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209207": {
    "city": "GHATAMPUR",
    "state": "UTTAR PRADESH"
  },
  "209208": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209209": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209210": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209214": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "209217": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "209261": {
    "city": "KANPUR",
    "state": "UTTAR PRADESH"
  },
  "209293": {
    "city": "BHOGNIPUR",
    "state": "UTTAR PRADESH"
  },
  "209301": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209302": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209303": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209304": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "209305": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "209306": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209307": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209308": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209309": {
    "city": "RASULABAD",
    "state": "UTTAR PRADESH"
  },
  "209310": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209311": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209312": {
    "city": "Kanpur Dehat",
    "state": "Uttar Pradesh"
  },
  "209393": {
    "city": "GHATAMPUR",
    "state": "UTTAR PRADESH"
  },
  "209401": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "209402": {
    "city": "Kanpur Nagar",
    "state": "Uttar Pradesh"
  },
  "209407": {
    "city": "BINDKI",
    "state": "UTTAR PRADESH"
  },
  "209501": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209502": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209503": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209504": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209505": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209506": {
    "city": "BIGHAPUR",
    "state": "UTTAR PRADESH"
  },
  "209601": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209602": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209608": {
    "city": "FARRUKHABAD",
    "state": "UTTAR PRADESH"
  },
  "209621": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209622": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209624": {
    "city": "FARRUKHABAD",
    "state": "UTTAR PRADESH"
  },
  "209625": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209651": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209652": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209701": {
    "city": "KAIMGANJ",
    "state": "UTTAR PRADESH"
  },
  "209715": {
    "city": "AURAIYA",
    "state": "UTTAR PRADESH"
  },
  "209720": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209721": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209722": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209723": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209724": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209725": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209726": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209727": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209728": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209729": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209731": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209732": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209733": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209734": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209735": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209736": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209738": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209739": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209743": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209744": {
    "city": "FARRUKHABAD",
    "state": "UTTAR PRADESH"
  },
  "209745": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209746": {
    "city": "KANNAUJ",
    "state": "UTTAR PRADESH"
  },
  "209747": {
    "city": "Kannauj",
    "state": "Uttar Pradesh"
  },
  "209748": {
    "city": "FARRUKHABAD",
    "state": "UTTAR PRADESH"
  },
  "209749": {
    "city": "Farrukhabad",
    "state": "Uttar Pradesh"
  },
  "209800": {
    "city": "UNNAO",
    "state": "UTTAR PRADESH"
  },
  "209801": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209808": {
    "city": "UNNAO",
    "state": "UTTAR PRADESH"
  },
  "209821": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209822": {
    "city": "MOHANLALGANJ",
    "state": "UTTAR PRADESH"
  },
  "209825": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209827": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209831": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209841": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209859": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209860": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209861": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209862": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209863": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209864": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209865": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209866": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209867": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209868": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209869": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209870": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209871": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "209881": {
    "city": "Unnao",
    "state": "Uttar Pradesh"
  },
  "210001": {
    "city": "Banda",
    "state": "Uttar Pradesh"
  },
  "210002": {
    "city": "BANDA-UP",
    "state": "UTTAR PRADESH"
  },
  "210003": {
    "city": "BANDA-UP",
    "state": "UTTAR PRADESH"
  },
  "210004": {
    "city": "BANDA-UP",
    "state": "UTTAR PRADESH"
  },
  "210005": {
    "city": "BANDA-UP",
    "state": "UTTAR PRADESH"
  },
  "210006": {
    "city": "BANDA-UP",
    "state": "UTTAR PRADESH"
  },
  "210007": {
    "city": "BANDA-UP",
    "state": "UTTAR PRADESH"
  },
  "210008": {
    "city": "BANDA-UP",
    "state": "UTTAR PRADESH"
  },
  "210009": {
    "city": "ALLAHABAD",
    "state": "UTTAR PRADESH"
  },
  "210010": {
    "city": "ALLAHABAD",
    "state": "UTTAR PRADESH"
  },
  "210011": {
    "city": "GHAZIABAD",
    "state": "UTTAR PRADESH"
  },
  "210012": {
    "city": "GHAZIABAD",
    "state": "UTTAR PRADESH"
  },
  "210100": {
    "city": "ALLAHABAD",
    "state": "UTTAR PRADESH"
  },
  "210101": {
    "city": "ALLAHABAD",
    "state": "UTTAR PRADESH"
  },
  "210105": {
    "city": "CHITRAKOOT",
    "state": "UTTAR PRADESH"
  },
  "210120": {
    "city": "Banda",
    "state": "Uttar Pradesh"
  },
  "210121": {
    "city": "Banda",
    "state": "Uttar Pradesh"
  },
  "210123": {
    "city": "Banda",
    "state": "Uttar Pradesh"
  },
  "210125": {
    "city": "Banda",
    "state": "Uttar Pradesh"
  },
  "210126": {
    "city": "Banda",
    "state": "Uttar Pradesh"
  },
  "210128": {
    "city": "Banda",
    "state": "Uttar Pradesh"
  },
  "210129": {
    "city": "Banda",
    "state": "Uttar Pradesh"
  },
  "210201": {
    "city": "Banda",
    "state": "Uttar Pradesh"
  },
  "210202": {
    "city": "Banda",
    "state": "Uttar Pradesh"
  },
  "210203": {
    "city": "Banda",
    "state": "Uttar Pradesh"
  },
  "210204": {
    "city": "Chitrakoot",
    "state": "Uttar Pradesh"
  },
  "210205": {
    "city": "Chitrakoot",
    "state": "Uttar Pradesh"
  },
  "210206": {
    "city": "Banda",
    "state": "Uttar Pradesh"
  },
  "210207": {
    "city": "Chitrakoot",
    "state": "Uttar Pradesh"
  },
  "210208": {
    "city": "Chitrakoot",
    "state": "Uttar Pradesh"
  },
  "210209": {
    "city": "Chitrakoot",
    "state": "Uttar Pradesh"
  },
  "210301": {
    "city": "Hamirpur",
    "state": "Uttar Pradesh"
  },
  "210302": {
    "city": "HAMIRPUR",
    "state": "UTTAR PRADESH"
  },
  "210341": {
    "city": "Hamirpur",
    "state": "Uttar Pradesh"
  },
  "210421": {
    "city": "Mahoba",
    "state": "Uttar Pradesh"
  },
  "210422": {
    "city": "Hamirpur",
    "state": "Uttar Pradesh"
  },
  "210423": {
    "city": "Mahoba",
    "state": "Uttar Pradesh"
  },
  "210424": {
    "city": "Mahoba",
    "state": "Uttar Pradesh"
  },
  "210425": {
    "city": "Mahoba",
    "state": "Uttar Pradesh"
  },
  "210426": {
    "city": "Mahoba",
    "state": "Uttar Pradesh"
  },
  "210427": {
    "city": "Mahoba",
    "state": "Uttar Pradesh"
  },
  "210428": {
    "city": "Hamirpur",
    "state": "Uttar Pradesh"
  },
  "210429": {
    "city": "Mahoba",
    "state": "Uttar Pradesh"
  },
  "210430": {
    "city": "Hamirpur",
    "state": "Uttar Pradesh"
  },
  "210431": {
    "city": "Hamirpur",
    "state": "Uttar Pradesh"
  },
  "210432": {
    "city": "Hamirpur",
    "state": "Uttar Pradesh"
  },
  "210433": {
    "city": "Mahoba",
    "state": "Uttar Pradesh"
  },
  "210434": {
    "city": "MAHOBA",
    "state": "UTTAR PRADESH"
  },
  "210501": {
    "city": "Hamirpur",
    "state": "Uttar Pradesh"
  },
  "210502": {
    "city": "Hamirpur",
    "state": "Uttar Pradesh"
  },
  "210504": {
    "city": "Hamirpur",
    "state": "Uttar Pradesh"
  },
  "210505": {
    "city": "Hamirpur",
    "state": "Uttar Pradesh"
  },
  "210506": {
    "city": "Hamirpur",
    "state": "Uttar Pradesh"
  },
  "210507": {
    "city": "Hamirpur",
    "state": "Uttar Pradesh"
  },
  "210526": {
    "city": "MAUDAHA",
    "state": "UTTAR PRADESH"
  },
  "210594": {
    "city": "MAUDAHA",
    "state": "UTTAR PRADESH"
  },
  "211001": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211002": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211003": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211004": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211005": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211006": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211007": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211008": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211009": {
    "city": "ALLAHABAD",
    "state": "UTTAR PRADESH"
  },
  "211010": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211011": {
    "city": "Kaushambi",
    "state": "Uttar Pradesh"
  },
  "211012": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211013": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211014": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211015": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211016": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211017": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211018": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211019": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211021": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211022": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "211104": {
    "city": "ALLAHABAD",
    "state": "UTTAR PRADESH"
  },
  "212104": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212105": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212106": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212107": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212108": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212109": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212111": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212128": {
    "city": "ALLAHABAD",
    "state": "UTTAR PRADESH"
  },
  "212141": {
    "city": "ALLAHABAD",
    "state": "UTTAR PRADESH"
  },
  "212165": {
    "city": "ALLAHABAD",
    "state": "UTTAR PRADESH"
  },
  "212201": {
    "city": "Kaushambi",
    "state": "Uttar Pradesh"
  },
  "212202": {
    "city": "Kaushambi",
    "state": "Uttar Pradesh"
  },
  "212203": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212204": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212205": {
    "city": "Kaushambi",
    "state": "Uttar Pradesh"
  },
  "212206": {
    "city": "Kaushambi",
    "state": "Uttar Pradesh"
  },
  "212207": {
    "city": "Kaushambi",
    "state": "Uttar Pradesh"
  },
  "212208": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212211": {
    "city": "CHAIL",
    "state": "UTTAR PRADESH"
  },
  "212212": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212213": {
    "city": "Kaushambi",
    "state": "Uttar Pradesh"
  },
  "212214": {
    "city": "Kaushambi",
    "state": "Uttar Pradesh"
  },
  "212215": {
    "city": "MAU-UP",
    "state": "UTTAR PRADESH"
  },
  "212216": {
    "city": "Kaushambi",
    "state": "Uttar Pradesh"
  },
  "212217": {
    "city": "Kaushambi",
    "state": "Uttar Pradesh"
  },
  "212218": {
    "city": "Kaushambi",
    "state": "Uttar Pradesh"
  },
  "212301": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212302": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212303": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212304": {
    "city": "MEJA ROAD",
    "state": "UTTAR PRADESH"
  },
  "212305": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212306": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212307": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212308": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212401": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212402": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212403": {
    "city": "PHOOLPUR",
    "state": "UTTAR PRADESH"
  },
  "212404": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212405": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212410": {
    "city": "PHOOLPUR",
    "state": "UTTAR PRADESH"
  },
  "212501": {
    "city": "PHOOLPUR",
    "state": "UTTAR PRADESH"
  },
  "212502": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212503": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212507": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "212508": {
    "city": "PHOOLPUR",
    "state": "UTTAR PRADESH"
  },
  "212601": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212620": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212621": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212622": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212623": {
    "city": "KHAGA",
    "state": "UTTAR PRADESH"
  },
  "212631": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212635": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212641": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212645": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212650": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212651": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212652": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212653": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212654": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212655": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212656": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212657": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212658": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212659": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212660": {
    "city": "KHAGA",
    "state": "UTTAR PRADESH"
  },
  "212661": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212662": {
    "city": "FATEHPUR-UP",
    "state": "UTTAR PRADESH"
  },
  "212663": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212664": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212665": {
    "city": "Fatehpur",
    "state": "Uttar Pradesh"
  },
  "212666": {
    "city": "BINDKI",
    "state": "UTTAR PRADESH"
  },
  "220006": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "220007": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "220009": {
    "city": "BINDKI",
    "state": "UTTAR PRADESH"
  },
  "220016": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "221001": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221002": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221003": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221004": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221005": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221006": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221007": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221008": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221009": {
    "city": "Chandauli",
    "state": "Uttar Pradesh"
  },
  "221010": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221011": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221012": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221060": {
    "city": "VARANASI",
    "state": "UTTAR PRADESH"
  },
  "221101": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221102": {
    "city": "VARANASI",
    "state": "UTTAR PRADESH"
  },
  "221103": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221104": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221105": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221106": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221107": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221108": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221109": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221110": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221111": {
    "city": "SAIDPUR",
    "state": "UTTAR PRADESH"
  },
  "221112": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221113": {
    "city": "SAIDPUR",
    "state": "UTTAR PRADESH"
  },
  "221115": {
    "city": "Chandauli",
    "state": "Uttar Pradesh"
  },
  "221116": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221131": {
    "city": "SAIDPUR",
    "state": "UTTAR PRADESH"
  },
  "221201": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221202": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221204": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221205": {
    "city": "PINDRA",
    "state": "UTTAR PRADESH"
  },
  "221206": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221207": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221208": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221209": {
    "city": "PINDRA",
    "state": "UTTAR PRADESH"
  },
  "221210": {
    "city": "PINDRA",
    "state": "UTTAR PRADESH"
  },
  "221211": {
    "city": "PINDRA",
    "state": "UTTAR PRADESH"
  },
  "221301": {
    "city": "Sant Ravidas Nagar",
    "state": "Uttar Pradesh"
  },
  "221302": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221303": {
    "city": "Sant Ravidas Nagar",
    "state": "Uttar Pradesh"
  },
  "221304": {
    "city": "Sant Ravidas Nagar",
    "state": "Uttar Pradesh"
  },
  "221305": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221306": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221307": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221308": {
    "city": "Sant Ravidas Nagar",
    "state": "Uttar Pradesh"
  },
  "221309": {
    "city": "Sant Ravidas Nagar",
    "state": "Uttar Pradesh"
  },
  "221310": {
    "city": "Sant Ravidas Nagar",
    "state": "Uttar Pradesh"
  },
  "221311": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221312": {
    "city": "BHADOHI",
    "state": "UTTAR PRADESH"
  },
  "221313": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221314": {
    "city": "Sant Ravidas Nagar",
    "state": "Uttar Pradesh"
  },
  "221401": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221402": {
    "city": "Sant Ravidas Nagar",
    "state": "Uttar Pradesh"
  },
  "221403": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221404": {
    "city": "Sant Ravidas Nagar",
    "state": "Uttar Pradesh"
  },
  "221405": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "221406": {
    "city": "Sant Ravidas Nagar",
    "state": "Uttar Pradesh"
  },
  "221407": {
    "city": "BHADOHI",
    "state": "UTTAR PRADESH"
  },
  "221408": {
    "city": "BHADOHI",
    "state": "UTTAR PRADESH"
  },
  "221409": {
    "city": "Sant Ravidas Nagar",
    "state": "Uttar Pradesh"
  },
  "221501": {
    "city": "HANDIA",
    "state": "UTTAR PRADESH"
  },
  "221502": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "221503": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "221504": {
    "city": "HANDIA",
    "state": "UTTAR PRADESH"
  },
  "221505": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "221506": {
    "city": "ALLAHABAD",
    "state": "UTTAR PRADESH"
  },
  "221507": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "221508": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "221601": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "221602": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "221603": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "221605": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "221701": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "221705": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "221706": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "221709": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "221711": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "221712": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "221713": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "221714": {
    "city": "BELTHARA ROAD",
    "state": "UTTAR PRADESH"
  },
  "221715": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "221716": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "221717": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "221718": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "221719": {
    "city": "BELTHARA ROAD",
    "state": "UTTAR PRADESH"
  },
  "221720": {
    "city": "BELTHARA ROAD",
    "state": "UTTAR PRADESH"
  },
  "222001": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222002": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222003": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222101": {
    "city": "SHAHGANJ",
    "state": "UTTAR PRADESH"
  },
  "222102": {
    "city": "JAUNPUR",
    "state": "UTTAR PRADESH"
  },
  "222103": {
    "city": "JAUNPUR",
    "state": "UTTAR PRADESH"
  },
  "222104": {
    "city": "SHAHGANJ",
    "state": "UTTAR PRADESH"
  },
  "222105": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222107": {
    "city": "JAUNPUR",
    "state": "UTTAR PRADESH"
  },
  "222108": {
    "city": "BADLAPUR",
    "state": "UTTAR PRADESH"
  },
  "222109": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222110": {
    "city": "JAUNPUR",
    "state": "UTTAR PRADESH"
  },
  "222111": {
    "city": "BADLAPUR",
    "state": "UTTAR PRADESH"
  },
  "222112": {
    "city": "JAUNPUR",
    "state": "UTTAR PRADESH"
  },
  "222113": {
    "city": "SHAHGANJ",
    "state": "UTTAR PRADESH"
  },
  "222125": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222127": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222128": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222129": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222131": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222132": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222133": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222135": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222136": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222137": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222138": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222139": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222141": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222142": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222143": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222144": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222145": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222146": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222148": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222149": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222161": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222162": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222165": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222170": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222172": {
    "city": "KERAKAT",
    "state": "UTTAR PRADESH"
  },
  "222175": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222180": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222181": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222201": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222202": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222203": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222204": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "222222": {
    "city": "DELHI WAREHOUSE",
    "state": "DELHI"
  },
  "222226": {
    "city": "PHOOLPUR",
    "state": "UTTAR PRADESH"
  },
  "222301": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "222302": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "222303": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "222304": {
    "city": "LAMBHUA",
    "state": "UTTAR PRADESH"
  },
  "222333": {
    "city": "GURGAON CPC",
    "state": "HARYANA"
  },
  "223101": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "223102": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "223103": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "223104": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "223105": {
    "city": "Jaunpur",
    "state": "Uttar Pradesh"
  },
  "223106": {
    "city": "SHAHGANJ",
    "state": "UTTAR PRADESH"
  },
  "223107": {
    "city": "SHAHGANJ",
    "state": "UTTAR PRADESH"
  },
  "223221": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "223222": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "223223": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "223224": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "223225": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "223226": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "223227": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "224001": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224116": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224117": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224118": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224119": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224120": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224121": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224122": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224123": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224125": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224126": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224127": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224129": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224132": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224133": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224135": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224137": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224138": {
    "city": "BURHANPUR",
    "state": "UTTAR PRADESH"
  },
  "224139": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224141": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224143": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224145": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224146": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224147": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224149": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224151": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224152": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224153": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224155": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224157": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224158": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224159": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224161": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224164": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224166": {
    "city": "SHAHGANJ",
    "state": "UTTAR PRADESH"
  },
  "224167": {
    "city": "AKBARPUR-AMBEDKAR NAGAR",
    "state": "UTTAR PRADESH"
  },
  "224168": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224171": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224172": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224175": {
    "city": "BURHANPUR",
    "state": "UTTAR PRADESH"
  },
  "224176": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224181": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224182": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224183": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224184": {
    "city": "BURHANPUR",
    "state": "UTTAR PRADESH"
  },
  "224186": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224188": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224189": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224190": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224195": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224198": {
    "city": "FAIZABAD",
    "state": "UTTAR PRADESH"
  },
  "224201": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224202": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224203": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224204": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224205": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224206": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224207": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224208": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224209": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224210": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224211": {
    "city": "FAIZABAD",
    "state": "UTTAR PRADESH"
  },
  "224212": {
    "city": "TANDA",
    "state": "UTTAR PRADESH"
  },
  "224213": {
    "city": "TANDA",
    "state": "UTTAR PRADESH"
  },
  "224214": {
    "city": "TANDA",
    "state": "UTTAR PRADESH"
  },
  "224215": {
    "city": "TANDA",
    "state": "UTTAR PRADESH"
  },
  "224216": {
    "city": "TANDA",
    "state": "UTTAR PRADESH"
  },
  "224217": {
    "city": "TANDA",
    "state": "UTTAR PRADESH"
  },
  "224218": {
    "city": "TANDA",
    "state": "UTTAR PRADESH"
  },
  "224219": {
    "city": "TANDA",
    "state": "UTTAR PRADESH"
  },
  "224220": {
    "city": "TANDA",
    "state": "UTTAR PRADESH"
  },
  "224221": {
    "city": "TANDA",
    "state": "UTTAR PRADESH"
  },
  "224222": {
    "city": "TANDA",
    "state": "UTTAR PRADESH"
  },
  "224223": {
    "city": "FAIZABAD",
    "state": "UTTAR PRADESH"
  },
  "224224": {
    "city": "MILKIPUR",
    "state": "UTTAR PRADESH"
  },
  "224225": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224226": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "224227": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224228": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224229": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224230": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224231": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224232": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224233": {
    "city": "HARAIYA",
    "state": "UTTAR PRADESH"
  },
  "224234": {
    "city": "Faizabad",
    "state": "Uttar Pradesh"
  },
  "224235": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224236": {
    "city": "AKBARPUR-AMBEDKAR NAGAR",
    "state": "UTTAR PRADESH"
  },
  "224237": {
    "city": "AKBARPUR-AMBEDKAR NAGAR",
    "state": "UTTAR PRADESH"
  },
  "224238": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224264": {
    "city": "BIKAPUR",
    "state": "UTTAR PRADESH"
  },
  "224284": {
    "city": "Ambedkar Nagar",
    "state": "Uttar Pradesh"
  },
  "224401": {
    "city": "BIKAPUR",
    "state": "UTTAR PRADESH"
  },
  "224409": {
    "city": "BIKAPUR",
    "state": "UTTAR PRADESH"
  },
  "225001": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225002": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225003": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225016": {
    "city": "BARA BANKI",
    "state": "UTTAR PRADESH"
  },
  "225119": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225120": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225121": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225122": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225123": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225124": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225125": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225126": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225131": {
    "city": "HAIDARGARH",
    "state": "UTTAR PRADESH"
  },
  "225201": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225202": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225203": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225204": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225205": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225206": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225207": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225208": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225301": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225302": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225303": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225304": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225305": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225306": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225401": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225402": {
    "city": "RAM SANEHI GHAT",
    "state": "UTTAR PRADESH"
  },
  "225403": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225404": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225405": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225406": {
    "city": "RAM SANEHI GHAT",
    "state": "UTTAR PRADESH"
  },
  "225407": {
    "city": "RAM SANEHI GHAT",
    "state": "UTTAR PRADESH"
  },
  "225408": {
    "city": "RAM SANEHI GHAT",
    "state": "UTTAR PRADESH"
  },
  "225409": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225411": {
    "city": "RUDAULI",
    "state": "UTTAR PRADESH"
  },
  "225412": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225413": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225414": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225415": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "225416": {
    "city": "Barabanki",
    "state": "Uttar Pradesh"
  },
  "226000": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "226001": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226002": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226003": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226004": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226005": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226006": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226007": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226008": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226009": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226010": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226011": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226012": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226013": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226014": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226015": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226016": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226017": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226018": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226019": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226020": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226021": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226022": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226023": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226024": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226025": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226026": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226027": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226028": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226029": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226030": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226031": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226101": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226102": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226103": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226104": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226106": {
    "city": "MALIHABAD",
    "state": "UTTAR PRADESH"
  },
  "226201": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226202": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226203": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226204": {
    "city": "ITAUNJA",
    "state": "UTTAR PRADESH"
  },
  "226301": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226302": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226303": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226375": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "226401": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "226501": {
    "city": "Lucknow",
    "state": "Uttar Pradesh"
  },
  "227000": {
    "city": "MOHANLALGANJ",
    "state": "UTTAR PRADESH"
  },
  "227005": {
    "city": "ITAUNJA",
    "state": "UTTAR PRADESH"
  },
  "227015": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "227101": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "227105": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "227106": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "227107": {
    "city": "MALIHABAD",
    "state": "UTTAR PRADESH"
  },
  "227115": {
    "city": "MALIHABAD",
    "state": "UTTAR PRADESH"
  },
  "227116": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "227119": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "227120": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "227125": {
    "city": "MOHANLALGANJ",
    "state": "UTTAR PRADESH"
  },
  "227131": {
    "city": "HAIDARGARH",
    "state": "UTTAR PRADESH"
  },
  "227132": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "227202": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "227205": {
    "city": "ITAUNJA",
    "state": "UTTAR PRADESH"
  },
  "227207": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "227208": {
    "city": "LUCKNOW",
    "state": "UTTAR PRADESH"
  },
  "227302": {
    "city": "HAIDARGARH",
    "state": "UTTAR PRADESH"
  },
  "227304": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227305": {
    "city": "MOHANLALGANJ",
    "state": "UTTAR PRADESH"
  },
  "227308": {
    "city": "MOHANLALGANJ",
    "state": "UTTAR PRADESH"
  },
  "227309": {
    "city": "BACHRARAWAN",
    "state": "UTTAR PRADESH"
  },
  "227405": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227406": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227407": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227408": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227409": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227411": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227412": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227413": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227801": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227802": {
    "city": "MUSAFIRKHANA",
    "state": "UTTAR PRADESH"
  },
  "227805": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227806": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227807": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227808": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227809": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227811": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227812": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227813": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227814": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227815": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227816": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "227817": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228001": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228115": {
    "city": "SULTANPUR",
    "state": "UTTAR PRADESH"
  },
  "228118": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228119": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228120": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228121": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228124": {
    "city": "KUREBHAR",
    "state": "UTTAR PRADESH"
  },
  "228125": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228131": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228132": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228133": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228141": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228142": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228145": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228150": {
    "city": "KUREBHAR",
    "state": "UTTAR PRADESH"
  },
  "228151": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228155": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228159": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228161": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "228171": {
    "city": "Sultanpur",
    "state": "Uttar Pradesh"
  },
  "229001": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229002": {
    "city": "RAI BAREILY",
    "state": "UTTAR PRADESH"
  },
  "229003": {
    "city": "RAI BAREILY",
    "state": "UTTAR PRADESH"
  },
  "229010": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229103": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229120": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229121": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229122": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229123": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229124": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229125": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229126": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229127": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229128": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229129": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229130": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229135": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229201": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229202": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229203": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229204": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229205": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229206": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229207": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229208": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229209": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229210": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229211": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229212": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229215": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229216": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229301": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229302": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229303": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229304": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229305": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229306": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229307": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229308": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229309": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229310": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229311": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229313": {
    "city": "MOHANLALGANJ",
    "state": "UTTAR PRADESH"
  },
  "229315": {
    "city": "RAI BAREILY",
    "state": "UTTAR PRADESH"
  },
  "229316": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229401": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229402": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229403": {
    "city": "UNCHAHAR",
    "state": "UTTAR PRADESH"
  },
  "229404": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229405": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229406": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229407": {
    "city": "UNCHAHAR",
    "state": "UTTAR PRADESH"
  },
  "229408": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "229409": {
    "city": "GAURIGANJ",
    "state": "UTTAR PRADESH"
  },
  "229410": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "229411": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "229412": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "229413": {
    "city": "Allahabad",
    "state": "Uttar Pradesh"
  },
  "229414": {
    "city": "KUNDA",
    "state": "UTTAR PRADESH"
  },
  "229415": {
    "city": "KUNDA",
    "state": "UTTAR PRADESH"
  },
  "229501": {
    "city": "BIGHAPUR",
    "state": "UTTAR PRADESH"
  },
  "229502": {
    "city": "BIGHAPUR",
    "state": "UTTAR PRADESH"
  },
  "229503": {
    "city": "BIGHAPUR",
    "state": "UTTAR PRADESH"
  },
  "229504": {
    "city": "BIGHAPUR",
    "state": "UTTAR PRADESH"
  },
  "229801": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229802": {
    "city": "Raebareli",
    "state": "Uttar Pradesh"
  },
  "229827": {
    "city": "HAIDARGARH",
    "state": "UTTAR PRADESH"
  },
  "229841": {
    "city": "HASANGANJ",
    "state": "UTTAR PRADESH"
  },
  "229881": {
    "city": "HASANGANJ",
    "state": "UTTAR PRADESH"
  },
  "230001": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230002": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230121": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230122": {
    "city": "BADLAPUR",
    "state": "UTTAR PRADESH"
  },
  "230123": {
    "city": "BADLAPUR",
    "state": "UTTAR PRADESH"
  },
  "230124": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230125": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230126": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230127": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230128": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230129": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230130": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230131": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230132": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230133": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230134": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230135": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230136": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230137": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230138": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230139": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230140": {
    "city": "UNCHAHAR",
    "state": "UTTAR PRADESH"
  },
  "230141": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230142": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230143": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230144": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230145": {
    "city": "PRATAPGARH-UP",
    "state": "UTTAR PRADESH"
  },
  "230146": {
    "city": "PRATAPGARH-UP",
    "state": "UTTAR PRADESH"
  },
  "230201": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230202": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230204": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230301": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230302": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230303": {
    "city": "PRATAPGARH-UP",
    "state": "UTTAR PRADESH"
  },
  "230304": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230305": {
    "city": "PRATAPGARH-UP",
    "state": "UTTAR PRADESH"
  },
  "230306": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230401": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230402": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230403": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230404": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230405": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230406": {
    "city": "PRATAPGARH-UP",
    "state": "UTTAR PRADESH"
  },
  "230501": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230502": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "230503": {
    "city": "Pratapgarh",
    "state": "Uttar Pradesh"
  },
  "231001": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231002": {
    "city": "MIRZAPUR",
    "state": "UTTAR PRADESH"
  },
  "231205": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231206": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231207": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231208": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231209": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231210": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231211": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231212": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231213": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231214": {
    "city": "ROBERTSGANJ",
    "state": "UTTAR PRADESH"
  },
  "231215": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231216": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231217": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231218": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231219": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231220": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231221": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231222": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231223": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231224": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231225": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231226": {
    "city": "Sonbhadra",
    "state": "Uttar Pradesh"
  },
  "231301": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231302": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231303": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231304": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231305": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231306": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231307": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231309": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231310": {
    "city": "MARIHAN",
    "state": "UTTAR PRADESH"
  },
  "231311": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231312": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231313": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231314": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "231501": {
    "city": "Mirzapur",
    "state": "Uttar Pradesh"
  },
  "232101": {
    "city": "Chandauli",
    "state": "Uttar Pradesh"
  },
  "232102": {
    "city": "Chandauli",
    "state": "Uttar Pradesh"
  },
  "232103": {
    "city": "Chandauli",
    "state": "Uttar Pradesh"
  },
  "232104": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "232105": {
    "city": "Chandauli",
    "state": "Uttar Pradesh"
  },
  "232106": {
    "city": "Chandauli",
    "state": "Uttar Pradesh"
  },
  "232107": {
    "city": "Chandauli",
    "state": "Uttar Pradesh"
  },
  "232108": {
    "city": "Chandauli",
    "state": "Uttar Pradesh"
  },
  "232109": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "232110": {
    "city": "Chandauli",
    "state": "Uttar Pradesh"
  },
  "232111": {
    "city": "Chandauli",
    "state": "Uttar Pradesh"
  },
  "232112": {
    "city": "CHAKIA",
    "state": "UTTAR PRADESH"
  },
  "232113": {
    "city": "CHAKIA",
    "state": "UTTAR PRADESH"
  },
  "232114": {
    "city": "CHAKIA",
    "state": "UTTAR PRADESH"
  },
  "232115": {
    "city": "CHAKIA",
    "state": "UTTAR PRADESH"
  },
  "232116": {
    "city": "CHAKIA",
    "state": "UTTAR PRADESH"
  },
  "232117": {
    "city": "CHAKIA",
    "state": "UTTAR PRADESH"
  },
  "232118": {
    "city": "Chandauli",
    "state": "Uttar Pradesh"
  },
  "232119": {
    "city": "CHANDAULI",
    "state": "UTTAR PRADESH"
  },
  "232120": {
    "city": "Chandauli",
    "state": "Uttar Pradesh"
  },
  "232325": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "232326": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "232327": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "232328": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "232329": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "232330": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "232331": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "232332": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "232333": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "232334": {
    "city": "ZAMANIA",
    "state": "UTTAR PRADESH"
  },
  "232335": {
    "city": "ZAMANIA",
    "state": "UTTAR PRADESH"
  },
  "232336": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "232338": {
    "city": "ZAMANIA",
    "state": "UTTAR PRADESH"
  },
  "232339": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "232340": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "232341": {
    "city": "ZAMANIA",
    "state": "UTTAR PRADESH"
  },
  "232342": {
    "city": "ZAMANIA",
    "state": "UTTAR PRADESH"
  },
  "232398": {
    "city": "ZAMANIA",
    "state": "UTTAR PRADESH"
  },
  "233001": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233002": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233221": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233222": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233223": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233224": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233225": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233226": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233227": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233228": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233229": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233230": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233231": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233232": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233233": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233234": {
    "city": "MUHAMMADABAD",
    "state": "UTTAR PRADESH"
  },
  "233235": {
    "city": "MUHAMMADABAD",
    "state": "UTTAR PRADESH"
  },
  "233300": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233301": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233302": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233303": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233304": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233305": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233306": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233307": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233308": {
    "city": "MARDAH",
    "state": "UTTAR PRADESH"
  },
  "233309": {
    "city": "MARDAH",
    "state": "UTTAR PRADESH"
  },
  "233310": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233311": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "233312": {
    "city": "GHAZIPUR",
    "state": "UTTAR PRADESH"
  },
  "241001": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241121": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241122": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241123": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241124": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241125": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241126": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241127": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241201": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241202": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241203": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241204": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241301": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241302": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241303": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241304": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241305": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241401": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241402": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241403": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241404": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241405": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241406": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241407": {
    "city": "Hardoi",
    "state": "Uttar Pradesh"
  },
  "241501": {
    "city": "SAFIPUR",
    "state": "UTTAR PRADESH"
  },
  "241502": {
    "city": "SAFIPUR",
    "state": "UTTAR PRADESH"
  },
  "241503": {
    "city": "SAFIPUR",
    "state": "UTTAR PRADESH"
  },
  "241504": {
    "city": "SAFIPUR",
    "state": "UTTAR PRADESH"
  },
  "242001": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242005": {
    "city": "SHAHJAHANPUR",
    "state": "UTTAR PRADESH"
  },
  "242021": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "242042": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242123": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242127": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242220": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242221": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242222": {
    "city": "JALALABAD-SHAHJAHANPUR",
    "state": "UTTAR PRADESH"
  },
  "242223": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242225": {
    "city": "SHAHJAHANPUR",
    "state": "UTTAR PRADESH"
  },
  "242226": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242227": {
    "city": "SHAHJAHANPUR",
    "state": "UTTAR PRADESH"
  },
  "242228": {
    "city": "SHAHJAHANPUR",
    "state": "UTTAR PRADESH"
  },
  "242301": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242302": {
    "city": "DATAGANJ",
    "state": "UTTAR PRADESH"
  },
  "242303": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242305": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242306": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242307": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242308": {
    "city": "TILHAR",
    "state": "UTTAR PRADESH"
  },
  "242309": {
    "city": "TILHAR",
    "state": "UTTAR PRADESH"
  },
  "242401": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242402": {
    "city": "POWAYAN",
    "state": "UTTAR PRADESH"
  },
  "242404": {
    "city": "POWAYAN",
    "state": "UTTAR PRADESH"
  },
  "242405": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242406": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242407": {
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh"
  },
  "242408": {
    "city": "TILHAR",
    "state": "UTTAR PRADESH"
  },
  "242409": {
    "city": "TILHAR",
    "state": "UTTAR PRADESH"
  },
  "243001": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243002": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243003": {
    "city": "Pilibhit",
    "state": "Uttar Pradesh"
  },
  "243004": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243005": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243006": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243121": {
    "city": "Bareilly",
    "state": "UTTAR PRADESH"
  },
  "243122": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243123": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243124": {
    "city": "FARIDPUR",
    "state": "UTTAR PRADESH"
  },
  "243125": {
    "city": "FARIDPUR",
    "state": "UTTAR PRADESH"
  },
  "243126": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243127": {
    "city": "FARIDPUR",
    "state": "UTTAR PRADESH"
  },
  "243201": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243202": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243203": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243204": {
    "city": "BAHERI",
    "state": "UTTAR PRADESH"
  },
  "243205": {
    "city": "BAHERI",
    "state": "UTTAR PRADESH"
  },
  "243206": {
    "city": "BAHERI",
    "state": "UTTAR PRADESH"
  },
  "243208": {
    "city": "BAHERI",
    "state": "UTTAR PRADESH"
  },
  "243215": {
    "city": "BAHERI",
    "state": "UTTAR PRADESH"
  },
  "243301": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243302": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243303": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243304": {
    "city": "MIRGANJ",
    "state": "UTTAR PRADESH"
  },
  "243305": {
    "city": "MIRGANJ",
    "state": "UTTAR PRADESH"
  },
  "243400": {
    "city": "AONIA",
    "state": "UTTAR PRADESH"
  },
  "243401": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243402": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243403": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243404": {
    "city": "AONIA",
    "state": "UTTAR PRADESH"
  },
  "243406": {
    "city": "NAWABGANJ",
    "state": "UTTAR PRADESH"
  },
  "243407": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243408": {
    "city": "NAWABGANJ",
    "state": "UTTAR PRADESH"
  },
  "243501": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243502": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243503": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243504": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243505": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243506": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "243509": {
    "city": "BAHERI",
    "state": "UTTAR PRADESH"
  },
  "243601": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243630": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243631": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243632": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243633": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243634": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243635": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243636": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243637": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243638": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243639": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243641": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243642": {
    "city": "KAIMGANJ",
    "state": "UTTAR PRADESH"
  },
  "243643": {
    "city": "KAIMGANJ",
    "state": "UTTAR PRADESH"
  },
  "243701": {
    "city": "MIRGANJ",
    "state": "UTTAR PRADESH"
  },
  "243720": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243722": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243723": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243724": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243725": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243726": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243727": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "243751": {
    "city": "Budaun",
    "state": "Uttar Pradesh"
  },
  "244001": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244002": {
    "city": "MORADABAD",
    "state": "UTTAR PRADESH"
  },
  "244003": {
    "city": "SAMBHAL",
    "state": "UTTAR PRADESH"
  },
  "244004": {
    "city": "MORADABAD",
    "state": "UTTAR PRADESH"
  },
  "244102": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244103": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244104": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244105": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244221": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244222": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244223": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244224": {
    "city": "KANTH",
    "state": "UTTAR PRADESH"
  },
  "244225": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244226": {
    "city": "KANTH",
    "state": "UTTAR PRADESH"
  },
  "244231": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244232": {
    "city": "GAJRAULA",
    "state": "UTTAR PRADESH"
  },
  "244235": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244236": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244241": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244242": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244245": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244249": {
    "city": "MORADABAD",
    "state": "UTTAR PRADESH"
  },
  "244251": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244255": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244301": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244302": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244303": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244304": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244401": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244402": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244410": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244411": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244412": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244413": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244414": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244415": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244443": {
    "city": "BILARI",
    "state": "UTTAR PRADESH"
  },
  "244500": {
    "city": "KANTH",
    "state": "UTTAR PRADESH"
  },
  "244501": {
    "city": "Jyotiba Phule Nagar",
    "state": "Uttar Pradesh"
  },
  "244502": {
    "city": "KANTH",
    "state": "UTTAR PRADESH"
  },
  "244504": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244601": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244602": {
    "city": "Moradabad",
    "state": "Uttar Pradesh"
  },
  "244701": {
    "city": "Rampur",
    "state": "Uttar Pradesh"
  },
  "244711": {
    "city": "MORADABAD",
    "state": "UTTAR PRADESH"
  },
  "244712": {
    "city": "KASHIPUR",
    "state": "UTTARAKHAND"
  },
  "244713": {
    "city": "UDHAM SINGH NAGAR",
    "state": "UTTARAKHAND"
  },
  "244714": {
    "city": "KASHIPUR",
    "state": "UTTARAKHAND"
  },
  "244715": {
    "city": "KASHIPUR",
    "state": "UTTARAKHAND"
  },
  "244716": {
    "city": "KASHIPUR",
    "state": "UTTARAKHAND"
  },
  "244801": {
    "city": "MORADABAD",
    "state": "UTTAR PRADESH"
  },
  "244901": {
    "city": "Rampur",
    "state": "Uttar Pradesh"
  },
  "244902": {
    "city": "RAMPUR",
    "state": "UTTAR PRADESH"
  },
  "244921": {
    "city": "Rampur",
    "state": "Uttar Pradesh"
  },
  "244922": {
    "city": "Rampur",
    "state": "Uttar Pradesh"
  },
  "244923": {
    "city": "Rampur",
    "state": "Uttar Pradesh"
  },
  "244924": {
    "city": "Rampur",
    "state": "Uttar Pradesh"
  },
  "244925": {
    "city": "Rampur",
    "state": "Uttar Pradesh"
  },
  "244926": {
    "city": "Rampur",
    "state": "Uttar Pradesh"
  },
  "244927": {
    "city": "Rampur",
    "state": "Uttar Pradesh"
  },
  "244928": {
    "city": "Rampur",
    "state": "Uttar Pradesh"
  },
  "245101": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "245102": {
    "city": "HAPUR",
    "state": "UTTAR PRADESH"
  },
  "245201": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "245205": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "245206": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "245207": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "245208": {
    "city": "Ghaziabad",
    "state": "Uttar Pradesh"
  },
  "245301": {
    "city": "Hapur",
    "state": "Uttar Pradesh"
  },
  "245304": {
    "city": "Hapur",
    "state": "Uttar Pradesh"
  },
  "245401": {
    "city": "SIYANA",
    "state": "UTTAR PRADESH"
  },
  "245402": {
    "city": "SIYANA",
    "state": "UTTAR PRADESH"
  },
  "245403": {
    "city": "SIYANA",
    "state": "UTTAR PRADESH"
  },
  "245405": {
    "city": "SIYANA",
    "state": "UTTAR PRADESH"
  },
  "245406": {
    "city": "JEWAR",
    "state": "UTTAR PRADESH"
  },
  "245407": {
    "city": "SIYANA",
    "state": "UTTAR PRADESH"
  },
  "245408": {
    "city": "DHAULANA",
    "state": "UTTAR PRADESH"
  },
  "245409": {
    "city": "BULANDSHAHR",
    "state": "UTTAR PRADESH"
  },
  "245411": {
    "city": "SIYANA",
    "state": "UTTAR PRADESH"
  },
  "245412": {
    "city": "SIYANA",
    "state": "UTTAR PRADESH"
  },
  "246001": {
    "city": "PAURI",
    "state": "UTTARAKHAND"
  },
  "246149": {
    "city": "Kotdwara",
    "state": "UTTARAKHAND"
  },
  "246174": {
    "city": "SRINAGAR GARHWAL",
    "state": "UTTARAKHAND"
  },
  "246700": {
    "city": "BIJNOR",
    "state": "UTTAR PRADESH"
  },
  "246701": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246721": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246722": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246723": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246724": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246725": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246726": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246727": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246728": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246729": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246731": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246732": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246733": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246734": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246735": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246736": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246737": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246738": {
    "city": "CHANDPUR",
    "state": "UTTAR PRADESH"
  },
  "246745": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246746": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246747": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246748": {
    "city": "NAJIBABAD",
    "state": "UTTAR PRADESH"
  },
  "246749": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246751": {
    "city": "NAJIBABAD",
    "state": "UTTAR PRADESH"
  },
  "246761": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246762": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246763": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246764": {
    "city": "Bijnor",
    "state": "Uttar Pradesh"
  },
  "246765": {
    "city": "NAGINA",
    "state": "UTTAR PRADESH"
  },
  "246766": {
    "city": "NAGINA",
    "state": "UTTAR PRADESH"
  },
  "247001": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247002": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247111": {
    "city": "BEHAT",
    "state": "UTTAR PRADESH"
  },
  "247120": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247121": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247122": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247129": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247231": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247232": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247239": {
    "city": "SAHARANPUR",
    "state": "UTTAR PRADESH"
  },
  "247323": {
    "city": "SAHARANPUR",
    "state": "UTTAR PRADESH"
  },
  "247325": {
    "city": "SAHARANPUR",
    "state": "UTTAR PRADESH"
  },
  "247340": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247341": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247342": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247343": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247402": {
    "city": "SAHARANPUR",
    "state": "UTTAR PRADESH"
  },
  "247451": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247452": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247453": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247470": {
    "city": "DEOBAND",
    "state": "UTTAR PRADESH"
  },
  "247471": {
    "city": "DEOBAND",
    "state": "UTTAR PRADESH"
  },
  "247551": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247554": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247656": {
    "city": "ROORKEE",
    "state": "UTTARAKHAND"
  },
  "247661": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "247662": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247663": {
    "city": "ROORKEE",
    "state": "UTTARAKHAND"
  },
  "247664": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "247665": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247666": {
    "city": "ROORKEE",
    "state": "UTTARAKHAND"
  },
  "247667": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "247668": {
    "city": "ROORKEE",
    "state": "UTTARAKHAND"
  },
  "247669": {
    "city": "Saharanpur",
    "state": "Uttar Pradesh"
  },
  "247670": {
    "city": "ROORKEE",
    "state": "UTTARAKHAND"
  },
  "247671": {
    "city": "ROORKEE",
    "state": "UTTAR PRADESH"
  },
  "247672": {
    "city": "SAHARANPUR",
    "state": "UTTAR PRADESH"
  },
  "247673": {
    "city": "SAHARANPUR",
    "state": "UTTAR PRADESH"
  },
  "247769": {
    "city": "SAHARANPUR",
    "state": "UTTAR PRADESH"
  },
  "247771": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "247772": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "247773": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "247774": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "247775": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "247776": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "247777": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "247778": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "248001": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248002": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248003": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248004": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248005": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248006": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248007": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248008": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248009": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248010": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248011": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248012": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248013": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248014": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248015": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248102": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248110": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248115": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248116": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248119": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248121": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248122": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248123": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248124": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248125": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248126": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248140": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248141": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248142": {
    "city": "HARBERTPUR",
    "state": "UTTARAKHAND"
  },
  "248143": {
    "city": "RISHIKESH",
    "state": "UTTARAKHAND"
  },
  "248144": {
    "city": "RISHIKESH",
    "state": "UTTARAKHAND"
  },
  "248145": {
    "city": "RISHIKESH",
    "state": "UTTARAKHAND"
  },
  "248146": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248147": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248148": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248158": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248159": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248160": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248161": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248165": {
    "city": "Dehradun",
    "state": "UTTARAKHAND"
  },
  "248171": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248179": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248195": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248196": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248197": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248198": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248199": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248201": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248202": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "248203": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "249103": {
    "city": "Rishikesh",
    "state": "UTTARAKHAND"
  },
  "249104": {
    "city": "Rishikesh",
    "state": "UTTARAKHAND"
  },
  "249135": {
    "city": "RISHIKESH",
    "state": "UTTARAKHAND"
  },
  "249137": {
    "city": "RISHIKESH",
    "state": "UTTARAKHAND"
  },
  "249161": {
    "city": "TEHRI GARHWAL",
    "state": "UTTARAKHAND"
  },
  "249191": {
    "city": "RISHIKESH",
    "state": "UTTARAKHAND"
  },
  "249194": {
    "city": "RISHIKESH",
    "state": "UTTARAKHAND"
  },
  "249201": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "249202": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "249203": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "249204": {
    "city": "DEHRADUN",
    "state": "UTTARAKHAND"
  },
  "249205": {
    "city": "RISHIKESH",
    "state": "UTTARAKHAND"
  },
  "249206": {
    "city": "RISHIKESH",
    "state": "UTTARAKHAND"
  },
  "249302": {
    "city": "PAURI GARHWAL",
    "state": "UTTARAKHAND"
  },
  "249306": {
    "city": "RISHIKESH",
    "state": "UTTARAKHAND"
  },
  "249401": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "249402": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "249403": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "249404": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "249405": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "249406": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "249407": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "249408": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "249409": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "249410": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "249411": {
    "city": "HARIDWAR",
    "state": "UTTARAKHAND"
  },
  "250001": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250002": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250003": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250004": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250005": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250006": {
    "city": "MEERUT",
    "state": "UTTAR PRADESH"
  },
  "250007": {
    "city": "MEERUT",
    "state": "UTTAR PRADESH"
  },
  "250010": {
    "city": "MEERUT",
    "state": "UTTAR PRADESH"
  },
  "250013": {
    "city": "MEERUT",
    "state": "UTTAR PRADESH"
  },
  "250020": {
    "city": "MEERUT",
    "state": "UTTAR PRADESH"
  },
  "250101": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250102": {
    "city": "MEERUT",
    "state": "UTTAR PRADESH"
  },
  "250103": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250104": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250105": {
    "city": "MEERUT",
    "state": "UTTAR PRADESH"
  },
  "250106": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250110": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250134": {
    "city": "MEERUT",
    "state": "UTTAR PRADESH"
  },
  "250205": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250211": {
    "city": "MEERUT",
    "state": "UTTAR PRADESH"
  },
  "250221": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250222": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250223": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250233": {
    "city": "NAGINA",
    "state": "UTTAR PRADESH"
  },
  "250341": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250342": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250344": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250345": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250401": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250402": {
    "city": "Varanasi",
    "state": "Uttar Pradesh"
  },
  "250403": {
    "city": "MAWANA",
    "state": "UTTAR PRADESH"
  },
  "250404": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250406": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250501": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250502": {
    "city": "Meerut",
    "state": "Uttar Pradesh"
  },
  "250601": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250602": {
    "city": "BARAUT",
    "state": "UTTAR PRADESH"
  },
  "250604": {
    "city": "BARAUT",
    "state": "UTTAR PRADESH"
  },
  "250606": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250609": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250611": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250612": {
    "city": "BARAUT",
    "state": "UTTAR PRADESH"
  },
  "250615": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250617": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250619": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250620": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250621": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250622": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250623": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250625": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "250626": {
    "city": "Bagpat",
    "state": "Uttar Pradesh"
  },
  "251001": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251002": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251003": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251201": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251202": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251203": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251210": {
    "city": "MUZZAFARNAGAR",
    "state": "UTTAR PRADESH"
  },
  "251301": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251305": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251306": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251307": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251308": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251309": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251310": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251311": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251314": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251315": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251316": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251317": {
    "city": "MUZZAFARNAGAR",
    "state": "UTTAR PRADESH"
  },
  "251318": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251319": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251320": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "251327": {
    "city": "Muzaffarnagar",
    "state": "Uttar Pradesh"
  },
  "261001": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261121": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261125": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261131": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261135": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261136": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261141": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261145": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261151": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261201": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261202": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261203": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261204": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261205": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261206": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261207": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261208": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261301": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261302": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261303": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261401": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261402": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261403": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261404": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261405": {
    "city": "Sitapur",
    "state": "Uttar Pradesh"
  },
  "261501": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "261502": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "261505": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "261506": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262001": {
    "city": "Pilibhit",
    "state": "Uttar Pradesh"
  },
  "262121": {
    "city": "Pilibhit",
    "state": "Uttar Pradesh"
  },
  "262122": {
    "city": "Pilibhit",
    "state": "Uttar Pradesh"
  },
  "262123": {
    "city": "PURANPUR",
    "state": "UTTAR PRADESH"
  },
  "262124": {
    "city": "Pilibhit",
    "state": "Uttar Pradesh"
  },
  "262125": {
    "city": "PURANPUR",
    "state": "UTTAR PRADESH"
  },
  "262201": {
    "city": "Pilibhit",
    "state": "Uttar Pradesh"
  },
  "262202": {
    "city": "Pilibhit",
    "state": "Uttar Pradesh"
  },
  "262203": {
    "city": "Pilibhit",
    "state": "Uttar Pradesh"
  },
  "262301": {
    "city": "PILIBHIT",
    "state": "UTTAR PRADESH"
  },
  "262302": {
    "city": "Pilibhit",
    "state": "Uttar Pradesh"
  },
  "262305": {
    "city": "Pilibhit",
    "state": "Uttar Pradesh"
  },
  "262308": {
    "city": "KHATIMA",
    "state": "UTTARAKHAND"
  },
  "262309": {
    "city": "TANAKPUR",
    "state": "UTTARAKHAND"
  },
  "262310": {
    "city": "TANAKPUR",
    "state": "UTTARAKHAND"
  },
  "262311": {
    "city": "NANAKMATTA",
    "state": "UTTAR PRADESH"
  },
  "262401": {
    "city": "BAZPUR",
    "state": "UTTARAKHAND"
  },
  "262402": {
    "city": "Rudrapur",
    "state": "UTTARAKHAND"
  },
  "262405": {
    "city": "UDHAM SINGH NAGAR",
    "state": "UTTARAKHAND"
  },
  "262406": {
    "city": "Bareilly",
    "state": "Uttar Pradesh"
  },
  "262407": {
    "city": "NAWABGANJ",
    "state": "UTTAR PRADESH"
  },
  "262408": {
    "city": "NAWABGANJ",
    "state": "UTTAR PRADESH"
  },
  "262409": {
    "city": "NAWABGANJ",
    "state": "UTTAR PRADESH"
  },
  "262410": {
    "city": "NAWABGANJ",
    "state": "UTTAR PRADESH"
  },
  "262411": {
    "city": "NAWABGANJ",
    "state": "UTTAR PRADESH"
  },
  "262412": {
    "city": "NAWABGANJ",
    "state": "UTTAR PRADESH"
  },
  "262501": {
    "city": "PITHORAGARH",
    "state": "UTTARAKHAND"
  },
  "262502": {
    "city": "PITHORAGARH",
    "state": "UTTARAKHAND"
  },
  "262505": {
    "city": "PIHANI",
    "state": "UTTAR PRADESH"
  },
  "262520": {
    "city": "PITHORAGARH",
    "state": "UTTARAKHAND"
  },
  "262521": {
    "city": "PITHORAGARH",
    "state": "UTTARAKHAND"
  },
  "262530": {
    "city": "PITHORAGARH",
    "state": "UTTARAKHAND"
  },
  "262701": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262702": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262721": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262722": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262723": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262724": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262725": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262726": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262727": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262728": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262801": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262802": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262803": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262804": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262805": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262901": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262902": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262903": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262904": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262905": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262906": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262907": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "262908": {
    "city": "Kheri",
    "state": "Uttar Pradesh"
  },
  "263001": {
    "city": "NAINITAL",
    "state": "UTTARAKHAND"
  },
  "263002": {
    "city": "NAINITAL",
    "state": "UTTARAKHAND"
  },
  "263126": {
    "city": "Haldwani",
    "state": "UTTARAKHAND"
  },
  "263139": {
    "city": "NAINITAL",
    "state": "UTTARAKHAND"
  },
  "263141": {
    "city": "NAINITAL",
    "state": "UTTARAKHAND"
  },
  "263143": {
    "city": "RUDRAPUR",
    "state": "UTTARAKHAND"
  },
  "263145": {
    "city": "RUDRAPUR",
    "state": "UTTARAKHAND"
  },
  "263146": {
    "city": "RUDRAPUR",
    "state": "UTTARAKHAND"
  },
  "263147": {
    "city": "RUDRAPUR",
    "state": "UTTARAKHAND"
  },
  "263148": {
    "city": "UDHAM SINGH NAGAR",
    "state": "UTTARAKHAND"
  },
  "263149": {
    "city": "Rudrapur",
    "state": "UTTARAKHAND"
  },
  "263150": {
    "city": "RUDRAPUR",
    "state": "UTTARAKHAND"
  },
  "263152": {
    "city": "RUDRAPUR",
    "state": "UTTARAKHAND"
  },
  "263153": {
    "city": "UDHAM SINGH NAGAR",
    "state": "UTTARAKHAND"
  },
  "263154": {
    "city": "RUDRAPUR",
    "state": "UTTARAKHAND"
  },
  "263155": {
    "city": "RUDRAPUR",
    "state": "UTTARAKHAND"
  },
  "263160": {
    "city": "Rudrapur",
    "state": "UTTARAKHAND"
  },
  "271001": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271002": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271003": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271006": {
    "city": "GONDA",
    "state": "UTTAR PRADESH"
  },
  "271122": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271123": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271124": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271125": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271126": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271127": {
    "city": "COLONELGANJ",
    "state": "UTTAR PRADESH"
  },
  "271128": {
    "city": "MANKAPUR",
    "state": "UTTAR PRADESH"
  },
  "271129": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271130": {
    "city": "MANKAPUR",
    "state": "UTTAR PRADESH"
  },
  "271201": {
    "city": "Balrampur",
    "state": "Uttar Pradesh"
  },
  "271202": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271203": {
    "city": "Balrampur",
    "state": "Uttar Pradesh"
  },
  "271204": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271205": {
    "city": "Balrampur",
    "state": "Uttar Pradesh"
  },
  "271206": {
    "city": "Balrampur",
    "state": "Uttar Pradesh"
  },
  "271207": {
    "city": "Balrampur",
    "state": "Uttar Pradesh"
  },
  "271208": {
    "city": "Balrampur",
    "state": "Uttar Pradesh"
  },
  "271209": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271210": {
    "city": "Balrampur",
    "state": "Uttar Pradesh"
  },
  "271211": {
    "city": "TULSIPUR",
    "state": "UTTAR PRADESH"
  },
  "271212": {
    "city": "TULSIPUR",
    "state": "UTTAR PRADESH"
  },
  "271213": {
    "city": "TULSIPUR",
    "state": "UTTAR PRADESH"
  },
  "271214": {
    "city": "UTRAULA",
    "state": "UTTAR PRADESH"
  },
  "271215": {
    "city": "Balrampur",
    "state": "Uttar Pradesh"
  },
  "271301": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271302": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271303": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271304": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271305": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271306": {
    "city": "Balrampur",
    "state": "Uttar Pradesh"
  },
  "271307": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271308": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271309": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271310": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271311": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271312": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271313": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271314": {
    "city": "HARAIYA",
    "state": "UTTAR PRADESH"
  },
  "271315": {
    "city": "HARAIYA",
    "state": "UTTAR PRADESH"
  },
  "271316": {
    "city": "HARAIYA",
    "state": "UTTAR PRADESH"
  },
  "271317": {
    "city": "DOMARIYAGANJ",
    "state": "UTTAR PRADESH"
  },
  "271318": {
    "city": "FAIZABAD",
    "state": "UTTAR PRADESH"
  },
  "271319": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271320": {
    "city": "FAIZABAD",
    "state": "UTTAR PRADESH"
  },
  "271321": {
    "city": "FAIZABAD",
    "state": "UTTAR PRADESH"
  },
  "271401": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271402": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271403": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271404": {
    "city": "TARAPGANJ",
    "state": "UTTAR PRADESH"
  },
  "271405": {
    "city": "TARAPGANJ",
    "state": "UTTAR PRADESH"
  },
  "271406": {
    "city": "TARAPGANJ",
    "state": "UTTAR PRADESH"
  },
  "271407": {
    "city": "TARAPGANJ",
    "state": "UTTAR PRADESH"
  },
  "271408": {
    "city": "TARAPGANJ",
    "state": "UTTAR PRADESH"
  },
  "271502": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271503": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271504": {
    "city": "Balrampur",
    "state": "Uttar Pradesh"
  },
  "271506": {
    "city": "COLONELGANJ",
    "state": "UTTAR PRADESH"
  },
  "271601": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271602": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271603": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271604": {
    "city": "Gonda",
    "state": "Uttar Pradesh"
  },
  "271605": {
    "city": "UTRAULA",
    "state": "UTTAR PRADESH"
  },
  "271606": {
    "city": "UTRAULA",
    "state": "UTTAR PRADESH"
  },
  "271607": {
    "city": "Balrampur",
    "state": "Uttar Pradesh"
  },
  "271608": {
    "city": "UTRAULA",
    "state": "UTTAR PRADESH"
  },
  "271609": {
    "city": "Balrampur",
    "state": "Uttar Pradesh"
  },
  "271801": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271802": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271803": {
    "city": "Shrawasti",
    "state": "Uttar Pradesh"
  },
  "271804": {
    "city": "Shrawasti",
    "state": "Uttar Pradesh"
  },
  "271805": {
    "city": "Shrawasti",
    "state": "Uttar Pradesh"
  },
  "271806": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271821": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271822": {
    "city": "PAYAGPUR",
    "state": "UTTAR PRADESH"
  },
  "271823": {
    "city": "MAHASI",
    "state": "UTTAR PRADESH"
  },
  "271824": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271825": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271826": {
    "city": "MAHASI",
    "state": "UTTAR PRADESH"
  },
  "271827": {
    "city": "GONDA",
    "state": "UTTAR PRADESH"
  },
  "271828": {
    "city": "GONDA",
    "state": "UTTAR PRADESH"
  },
  "271829": {
    "city": "NANPARA",
    "state": "UTTAR PRADESH"
  },
  "271830": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271831": {
    "city": "Shrawasti",
    "state": "Uttar Pradesh"
  },
  "271832": {
    "city": "BHINGA",
    "state": "UTTAR PRADESH"
  },
  "271833": {
    "city": "BAHRAICH",
    "state": "UTTAR PRADESH"
  },
  "271834": {
    "city": "BAHRAICH",
    "state": "UTTAR PRADESH"
  },
  "271835": {
    "city": "Shrawasti",
    "state": "Uttar Pradesh"
  },
  "271836": {
    "city": "BAHRAICH",
    "state": "UTTAR PRADESH"
  },
  "271840": {
    "city": "Shrawasti",
    "state": "Uttar Pradesh"
  },
  "271841": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271845": {
    "city": "Shrawasti",
    "state": "Uttar Pradesh"
  },
  "271851": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271855": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271857": {
    "city": "DHAURAHARA",
    "state": "UTTAR PRADESH"
  },
  "271861": {
    "city": "Balrampur",
    "state": "Uttar Pradesh"
  },
  "271864": {
    "city": "NANPARA",
    "state": "UTTAR PRADESH"
  },
  "271865": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271870": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271871": {
    "city": "Shrawasti",
    "state": "Uttar Pradesh"
  },
  "271872": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271875": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271880": {
    "city": "NANPARA",
    "state": "UTTAR PRADESH"
  },
  "271881": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271882": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271901": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271902": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271903": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271904": {
    "city": "Bahraich",
    "state": "Uttar Pradesh"
  },
  "271905": {
    "city": "KAISARGANJ",
    "state": "UTTAR PRADESH"
  },
  "272001": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272002": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272003": {
    "city": "BASTI",
    "state": "UTTAR PRADESH"
  },
  "272102": {
    "city": "BASTI",
    "state": "UTTAR PRADESH"
  },
  "272105": {
    "city": "BASTI",
    "state": "UTTAR PRADESH"
  },
  "272123": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272124": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272125": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272126": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272127": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272128": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272129": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272130": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272131": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272148": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272150": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272151": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272152": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272153": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272154": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272155": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272159": {
    "city": "HARAIYA",
    "state": "UTTAR PRADESH"
  },
  "272161": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272162": {
    "city": "Sant Kabir Nagar",
    "state": "Uttar Pradesh"
  },
  "272163": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272164": {
    "city": "Sant Kabir Nagar",
    "state": "Uttar Pradesh"
  },
  "272165": {
    "city": "Sant Kabir Nagar",
    "state": "Uttar Pradesh"
  },
  "272170": {
    "city": "KHALILABAD",
    "state": "UTTAR PRADESH"
  },
  "272171": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272172": {
    "city": "Sant Kabir Nagar",
    "state": "Uttar Pradesh"
  },
  "272173": {
    "city": "Sant Kabir Nagar",
    "state": "Uttar Pradesh"
  },
  "272175": {
    "city": "Sant Kabir Nagar",
    "state": "Uttar Pradesh"
  },
  "272176": {
    "city": "Sant Kabir Nagar",
    "state": "Uttar Pradesh"
  },
  "272177": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272178": {
    "city": "Sant Kabir Nagar",
    "state": "Uttar Pradesh"
  },
  "272179": {
    "city": "HARAIYA",
    "state": "UTTAR PRADESH"
  },
  "272181": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272182": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272183": {
    "city": "BASTI",
    "state": "UTTAR PRADESH"
  },
  "272189": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272190": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272191": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272192": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272193": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272194": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272195": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272199": {
    "city": "Sant Kabir Nagar",
    "state": "Uttar Pradesh"
  },
  "272201": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272202": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272203": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272204": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272205": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272206": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272207": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272208": {
    "city": "Siddharthnagar",
    "state": "Uttar Pradesh"
  },
  "272209": {
    "city": "TETRI BAZAR",
    "state": "UTTAR PRADESH"
  },
  "272270": {
    "city": "Sant Kabir Nagar",
    "state": "Uttar Pradesh"
  },
  "272271": {
    "city": "Sant Kabir Nagar",
    "state": "Uttar Pradesh"
  },
  "272272": {
    "city": "CAMPIERGANJ",
    "state": "UTTAR PRADESH"
  },
  "272290": {
    "city": "TANDA",
    "state": "UTTAR PRADESH"
  },
  "272301": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "272302": {
    "city": "Basti",
    "state": "Uttar Pradesh"
  },
  "273001": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273002": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273003": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273004": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273005": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273006": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273007": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273008": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273009": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273010": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273011": {
    "city": "GORAKHPUR",
    "state": "UTTAR PRADESH"
  },
  "273012": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273013": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273014": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273015": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273016": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273017": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273149": {
    "city": "MAHARAJGANJ",
    "state": "UTTAR PRADESH"
  },
  "273151": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273152": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273153": {
    "city": "MAHARAJGANJ",
    "state": "UTTAR PRADESH"
  },
  "273155": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273157": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273158": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273161": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273162": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273163": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273164": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273165": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273200": {
    "city": "CHAURI CHAURA",
    "state": "UTTAR PRADESH"
  },
  "273201": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273202": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273203": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273207": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273209": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273211": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273212": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273213": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273301": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273302": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273303": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273304": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273305": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273306": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273307": {
    "city": "MAHARAJGANJ",
    "state": "UTTAR PRADESH"
  },
  "273308": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273309": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273310": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273311": {
    "city": "Maharajganj",
    "state": "Uttar Pradesh"
  },
  "273401": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273402": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273403": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273404": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273405": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273406": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273407": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273408": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273409": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273410": {
    "city": "GOLA",
    "state": "UTTAR PRADESH"
  },
  "273411": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273412": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273413": {
    "city": "Gorakhpur",
    "state": "Uttar Pradesh"
  },
  "273414": {
    "city": "BANSGAON",
    "state": "UTTAR PRADESH"
  },
  "273415": {
    "city": "BANSGAON",
    "state": "UTTAR PRADESH"
  },
  "274001": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274002": {
    "city": "DEORIA",
    "state": "UTTAR PRADESH"
  },
  "274003": {
    "city": "DEORIA",
    "state": "UTTAR PRADESH"
  },
  "274121": {
    "city": "CHAURI CHAURA",
    "state": "UTTAR PRADESH"
  },
  "274122": {
    "city": "CHAURI CHAURA",
    "state": "UTTAR PRADESH"
  },
  "274149": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274182": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274201": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274202": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274203": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274204": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274205": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274206": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274207": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274208": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274301": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274302": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274303": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274304": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274305": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274306": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274401": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274402": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274403": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274404": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274405": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274406": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274407": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274408": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274409": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274501": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274502": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274505": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274506": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274508": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274509": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274557": {
    "city": "BARHAJ",
    "state": "UTTAR PRADESH"
  },
  "274601": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274602": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274603": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274604": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274701": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274702": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274703": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274704": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274705": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274801": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274802": {
    "city": "Kushinagar",
    "state": "Uttar Pradesh"
  },
  "274806": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274807": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "274808": {
    "city": "Deoria",
    "state": "Uttar Pradesh"
  },
  "275101": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "275102": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "275103": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "275105": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "275107": {
    "city": "GHOSI",
    "state": "UTTAR PRADESH"
  },
  "275120": {
    "city": "GHOSI",
    "state": "UTTAR PRADESH"
  },
  "275201": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "275202": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "275203": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "275204": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "275205": {
    "city": "Ghazipur",
    "state": "Uttar Pradesh"
  },
  "275206": {
    "city": "MARDAH",
    "state": "UTTAR PRADESH"
  },
  "275207": {
    "city": "MARDAH",
    "state": "UTTAR PRADESH"
  },
  "275301": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "275302": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "275303": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "275304": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "275305": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "275306": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "275307": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "276001": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276103": {
    "city": "AZAMGARH",
    "state": "UTTAR PRADESH"
  },
  "276121": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276122": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276123": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276124": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276125": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276126": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276127": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276128": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276129": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276131": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276135": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276136": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276137": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276138": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276139": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276140": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276141": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276142": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276143": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276201": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276202": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276203": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276204": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276205": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276206": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276207": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276208": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276225": {
    "city": "AZAMGARH",
    "state": "UTTAR PRADESH"
  },
  "276288": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276301": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276302": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276303": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276304": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276305": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276306": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "276401": {
    "city": "MAUNATH BHANJAN",
    "state": "UTTAR PRADESH"
  },
  "276402": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "276403": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "276404": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "276405": {
    "city": "Mau",
    "state": "Uttar Pradesh"
  },
  "276406": {
    "city": "Azamgarh",
    "state": "Uttar Pradesh"
  },
  "277001": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277011": {
    "city": "BALLIA",
    "state": "UTTAR PRADESH"
  },
  "277121": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277122": {
    "city": "SIKANDERPUR",
    "state": "UTTAR PRADESH"
  },
  "277123": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277124": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277201": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277202": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277203": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277204": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277205": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277206": {
    "city": "SIKANDERPUR",
    "state": "UTTAR PRADESH"
  },
  "277207": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277208": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277209": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277210": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277211": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277212": {
    "city": "SIKANDERPUR",
    "state": "UTTAR PRADESH"
  },
  "277213": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277214": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277215": {
    "city": "BARIYA",
    "state": "UTTAR PRADESH"
  },
  "277216": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277218": {
    "city": "BALLIA",
    "state": "UTTAR PRADESH"
  },
  "277219": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277301": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277302": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277303": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277304": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277305": {
    "city": "BALLIA",
    "state": "UTTAR PRADESH"
  },
  "277306": {
    "city": "BALLIA",
    "state": "UTTAR PRADESH"
  },
  "277401": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277402": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277403": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277404": {
    "city": "BARIYA",
    "state": "UTTAR PRADESH"
  },
  "277405": {
    "city": "KUSHINAGAR",
    "state": "UTTAR PRADESH"
  },
  "277406": {
    "city": "KUSHINAGAR",
    "state": "UTTAR PRADESH"
  },
  "277501": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277502": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277503": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277504": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277506": {
    "city": "Ballia",
    "state": "Uttar Pradesh"
  },
  "277514": {
    "city": "BALLIA",
    "state": "UTTAR PRADESH"
  },
  "281001": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281002": {
    "city": "MATHURA",
    "state": "UTTAR PRADESH"
  },
  "281003": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281004": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281005": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281006": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281010": {
    "city": "AGRA",
    "state": "UTTAR PRADESH"
  },
  "281104": {
    "city": "Hathras",
    "state": "Uttar Pradesh"
  },
  "281112": {
    "city": "FARAH",
    "state": "UTTAR PRADESH"
  },
  "281121": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281122": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281123": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281124": {
    "city": "GOVARDHAN",
    "state": "UTTAR PRADESH"
  },
  "281201": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281202": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281203": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281204": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281205": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281206": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281301": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281302": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281303": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281304": {
    "city": "JALESAR",
    "state": "UTTAR PRADESH"
  },
  "281305": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281306": {
    "city": "Hathras",
    "state": "Uttar Pradesh"
  },
  "281307": {
    "city": "Hathras",
    "state": "Uttar Pradesh"
  },
  "281308": {
    "city": "Hathras",
    "state": "Uttar Pradesh"
  },
  "281401": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281402": {
    "city": "CHHATA",
    "state": "UTTAR PRADESH"
  },
  "281403": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281404": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281405": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281406": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281501": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281502": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "281503": {
    "city": "GOVARDHAN",
    "state": "UTTAR PRADESH"
  },
  "281504": {
    "city": "Mathura",
    "state": "Uttar Pradesh"
  },
  "282001": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "282002": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "282003": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "282004": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "282005": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "282006": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "282007": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "282008": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "282009": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "282010": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283101": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283102": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283103": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "283104": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283105": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283107": {
    "city": "KIRAULI",
    "state": "UTTAR PRADESH"
  },
  "283110": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283111": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283112": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283113": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283114": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283115": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283119": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283121": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283122": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283123": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283124": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283125": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283126": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283130": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "283135": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "283136": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "283141": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "283142": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "283145": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "283151": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "283152": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "283201": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283202": {
    "city": "Agra",
    "state": "Uttar Pradesh"
  },
  "283203": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "283204": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "283205": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "283206": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "283207": {
    "city": "Firozabad",
    "state": "Uttar Pradesh"
  },
  "284001": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284002": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284003": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284120": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284121": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284122": {
    "city": "Lalitpur",
    "state": "Uttar Pradesh"
  },
  "284123": {
    "city": "Lalitpur",
    "state": "Uttar Pradesh"
  },
  "284124": {
    "city": "Lalitpur",
    "state": "Uttar Pradesh"
  },
  "284125": {
    "city": "Lalitpur",
    "state": "Uttar Pradesh"
  },
  "284126": {
    "city": "Lalitpur",
    "state": "Uttar Pradesh"
  },
  "284127": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284128": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284129": {
    "city": "JHANSI",
    "state": "UTTAR PRADESH"
  },
  "284135": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284136": {
    "city": "Lalitpur",
    "state": "Uttar Pradesh"
  },
  "284201": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284202": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284203": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284204": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284205": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284206": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284301": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284302": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284303": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284304": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284305": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284306": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284401": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284402": {
    "city": "Lalitpur",
    "state": "Uttar Pradesh"
  },
  "284403": {
    "city": "Lalitpur",
    "state": "Uttar Pradesh"
  },
  "284404": {
    "city": "Lalitpur",
    "state": "Uttar Pradesh"
  },
  "284405": {
    "city": "Lalitpur",
    "state": "Uttar Pradesh"
  },
  "284406": {
    "city": "Lalitpur",
    "state": "Uttar Pradesh"
  },
  "284407": {
    "city": "MAHRAUNI",
    "state": "UTTAR PRADESH"
  },
  "284419": {
    "city": "Jhansi",
    "state": "Uttar Pradesh"
  },
  "284501": {
    "city": "Lalitpur",
    "state": "Uttar Pradesh"
  },
  "285001": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285121": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285122": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285123": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285124": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285125": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285126": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285127": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285128": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285129": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285130": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285131": {
    "city": "JALAUN",
    "state": "UTTAR PRADESH"
  },
  "285132": {
    "city": "JALAUN",
    "state": "UTTAR PRADESH"
  },
  "285197": {
    "city": "KONCH",
    "state": "UTTAR PRADESH"
  },
  "285201": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285202": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285203": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285204": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285205": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285206": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285221": {
    "city": "KONCH",
    "state": "UTTAR PRADESH"
  },
  "285222": {
    "city": "KONCH",
    "state": "UTTAR PRADESH"
  },
  "285223": {
    "city": "Jalaun",
    "state": "Uttar Pradesh"
  },
  "285224": {
    "city": "KONCH",
    "state": "UTTAR PRADESH"
  },
  "301001": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301002": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301017": {
    "city": "BHIWADI",
    "state": "RAJASTHAN"
  },
  "301018": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301019": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301020": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301021": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301022": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301023": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301024": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301025": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301026": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301027": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301028": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301029": {
    "city": "ALWAR",
    "state": "RAJASTHAN"
  },
  "301030": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301031": {
    "city": "ALWAR",
    "state": "RAJASTHAN"
  },
  "301032": {
    "city": "ALWAR",
    "state": "RAJASTHAN"
  },
  "301033": {
    "city": "ALWAR",
    "state": "RAJASTHAN"
  },
  "301034": {
    "city": "NAGAR",
    "state": "RAJASTHAN"
  },
  "301035": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301036": {
    "city": "TIJARA",
    "state": "RAJASTHAN"
  },
  "301037": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "301042": {
    "city": "ALWAR",
    "state": "RAJASTHAN"
  },
  "301043": {
    "city": "BANSUR",
    "state": "RAJASTHAN"
  },
  "301044": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "301101": {
    "city": "BHILWARA",
    "state": "RAJASTHAN"
  },
  "301106": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "301160": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "301211": {
    "city": "ALWAR",
    "state": "RAJASTHAN"
  },
  "301301": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "301306": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "301307": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "301308": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "301401": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301402": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301403": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301404": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301405": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301406": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301407": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301408": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301409": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301410": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301411": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301412": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301413": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301414": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301415": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301416": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301417": {
    "city": "BHIWADI",
    "state": "RAJASTHAN"
  },
  "301418": {
    "city": "BANSUR",
    "state": "RAJASTHAN"
  },
  "301419": {
    "city": "BHIWADI",
    "state": "RAJASTHAN"
  },
  "301420": {
    "city": "BHIWADI",
    "state": "RAJASTHAN"
  },
  "301421": {
    "city": "BHIWADI",
    "state": "RAJASTHAN"
  },
  "301422": {
    "city": "BHIWADI",
    "state": "RAJASTHAN"
  },
  "301423": {
    "city": "BHIWADI",
    "state": "RAJASTHAN"
  },
  "301424": {
    "city": "BHIWADI",
    "state": "RAJASTHAN"
  },
  "301425": {
    "city": "BHIWADI",
    "state": "RAJASTHAN"
  },
  "301426": {
    "city": "VIRATNAGAR",
    "state": "RAJASTHAN"
  },
  "301427": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301604": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301607": {
    "city": "NAGAR",
    "state": "RAJASTHAN"
  },
  "301701": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301702": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301703": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301704": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301705": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301706": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301707": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301708": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301709": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301710": {
    "city": "BEHROR",
    "state": "RAJASTHAN"
  },
  "301711": {
    "city": "BEHROR",
    "state": "RAJASTHAN"
  },
  "301712": {
    "city": "TIJARA",
    "state": "RAJASTHAN"
  },
  "301713": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "301714": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "302000": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302001": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302002": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302003": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302004": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302005": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302006": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302007": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302008": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302009": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302010": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302011": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302012": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302013": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302014": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302015": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302016": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302017": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302018": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302019": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302020": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302021": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302022": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302023": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302024": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302025": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302026": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302027": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302028": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302029": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302030": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302031": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302032": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302033": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302034": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302035": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302036": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302037": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302038": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302039": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302040": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302041": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302042": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302043": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "302051": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302052": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302053": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302054": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302055": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "302111": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "303001": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303002": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303003": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303004": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303005": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303006": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303007": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303008": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303009": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303010": {
    "city": "PHAGI",
    "state": "RAJASTHAN"
  },
  "303011": {
    "city": "BASSI",
    "state": "RAJASTHAN"
  },
  "303012": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303092": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "303101": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "303102": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303103": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303104": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303105": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303106": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303107": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303108": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303109": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303110": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303111": {
    "city": "VIRATNAGAR",
    "state": "RAJASTHAN"
  },
  "303112": {
    "city": "VIRATNAGAR",
    "state": "RAJASTHAN"
  },
  "303113": {
    "city": "VIRATNAGAR",
    "state": "RAJASTHAN"
  },
  "303114": {
    "city": "VIRATNAGAR",
    "state": "RAJASTHAN"
  },
  "303115": {
    "city": "BANSUR",
    "state": "RAJASTHAN"
  },
  "303116": {
    "city": "VIRATNAGAR",
    "state": "RAJASTHAN"
  },
  "303117": {
    "city": "VIRATNAGAR",
    "state": "RAJASTHAN"
  },
  "303118": {
    "city": "VIRATNAGAR",
    "state": "RAJASTHAN"
  },
  "303119": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303120": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303121": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303122": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303123": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303209": {
    "city": "DEGANA",
    "state": "RAJASTHAN"
  },
  "303301": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303302": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303303": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303304": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303305": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303306": {
    "city": "BASSI",
    "state": "RAJASTHAN"
  },
  "303307": {
    "city": "BASSI",
    "state": "RAJASTHAN"
  },
  "303308": {
    "city": "BASSI",
    "state": "RAJASTHAN"
  },
  "303309": {
    "city": "BASSI",
    "state": "RAJASTHAN"
  },
  "303310": {
    "city": "BASSI",
    "state": "RAJASTHAN"
  },
  "303313": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303314": {
    "city": "DAUSA",
    "state": "RAJASTHAN"
  },
  "303315": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303323": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303324": {
    "city": "BANDIKUI",
    "state": "RAJASTHAN"
  },
  "303325": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303326": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303327": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303328": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303329": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303330": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "303331": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "303338": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303339": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "303340": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "303341": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "303348": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303349": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "303372": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "303501": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303502": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303503": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303504": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303505": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303506": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303507": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303508": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303509": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303510": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303511": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "303601": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303602": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303603": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303604": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303606": {
    "city": "CHOMU",
    "state": "RAJASTHAN"
  },
  "303607": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "303608": {
    "city": "PALI",
    "state": "RAJASTHAN"
  },
  "303609": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "303610": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "303611": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "303701": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303702": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303703": {
    "city": "CHOMU",
    "state": "RAJASTHAN"
  },
  "303704": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303705": {
    "city": "CHOMU",
    "state": "RAJASTHAN"
  },
  "303706": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303712": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303801": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303802": {
    "city": "CHOMU",
    "state": "RAJASTHAN"
  },
  "303803": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303804": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303805": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303806": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303807": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303901": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303902": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "303903": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303904": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303905": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "303906": {
    "city": "CHAKSU",
    "state": "RAJASTHAN"
  },
  "303907": {
    "city": "CHAKSU",
    "state": "RAJASTHAN"
  },
  "303908": {
    "city": "Jaipur",
    "state": "Rajasthan"
  },
  "304001": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304005": {
    "city": "KOTA",
    "state": "RAJASTHAN"
  },
  "304020": {
    "city": "NIWAI",
    "state": "RAJASTHAN"
  },
  "304021": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304022": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304023": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304024": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304025": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304026": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304042": {
    "city": "NIWAI",
    "state": "RAJASTHAN"
  },
  "304105": {
    "city": "NIWAI",
    "state": "RAJASTHAN"
  },
  "304201": {
    "city": "NIWAI",
    "state": "RAJASTHAN"
  },
  "304230": {
    "city": "NIWAI",
    "state": "RAJASTHAN"
  },
  "304501": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304502": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304503": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304504": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304505": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304506": {
    "city": "MALPURA",
    "state": "RAJASTHAN"
  },
  "304507": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304508": {
    "city": "DEOLI",
    "state": "RAJASTHAN"
  },
  "304509": {
    "city": "MALPURA",
    "state": "RAJASTHAN"
  },
  "304510": {
    "city": "DEOLI",
    "state": "RAJASTHAN"
  },
  "304511": {
    "city": "DEOLI",
    "state": "RAJASTHAN"
  },
  "304640": {
    "city": "BARDOLI",
    "state": "GUJARAT"
  },
  "304801": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304802": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304803": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304804": {
    "city": "Tonk",
    "state": "Rajasthan"
  },
  "304805": {
    "city": "DEOLI",
    "state": "RAJASTHAN"
  },
  "304806": {
    "city": "DEOLI",
    "state": "RAJASTHAN"
  },
  "304807": {
    "city": "DEOLI",
    "state": "RAJASTHAN"
  },
  "305001": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305002": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305003": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305004": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305005": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305006": {
    "city": "AJMER",
    "state": "RAJASTHAN"
  },
  "305007": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305008": {
    "city": "AJMER",
    "state": "RAJASTHAN"
  },
  "305009": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305011": {
    "city": "AJMER",
    "state": "RAJASTHAN"
  },
  "305012": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305014": {
    "city": "AJMER",
    "state": "RAJASTHAN"
  },
  "305021": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305022": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305023": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305024": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305025": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305026": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "305201": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305202": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305203": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305204": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305205": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305206": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305207": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305401": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305402": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305403": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305404": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305405": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305406": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305407": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305408": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305409": {
    "city": "KEKRI",
    "state": "RAJASTHAN"
  },
  "305410": {
    "city": "KEKRI",
    "state": "RAJASTHAN"
  },
  "305411": {
    "city": "NASIRABAD",
    "state": "RAJASTHAN"
  },
  "305412": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305413": {
    "city": "NASIRABAD",
    "state": "RAJASTHAN"
  },
  "305414": {
    "city": "KEKRI",
    "state": "RAJASTHAN"
  },
  "305415": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305416": {
    "city": "KEKRI",
    "state": "RAJASTHAN"
  },
  "305601": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305621": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305622": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305623": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305624": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305625": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305626": {
    "city": "NASIRABAD",
    "state": "RAJASTHAN"
  },
  "305627": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305628": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305629": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305630": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305801": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305802": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305805": {
    "city": "KISHANGARH",
    "state": "RAJASTHAN"
  },
  "305811": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305812": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305813": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305814": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305815": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305816": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305817": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305818": {
    "city": "KISHANGARH",
    "state": "RAJASTHAN"
  },
  "305819": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305820": {
    "city": "KISHANGARH",
    "state": "RAJASTHAN"
  },
  "305824": {
    "city": "KISHANGARH",
    "state": "RAJASTHAN"
  },
  "305901": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305912": {
    "city": "DEVGARH",
    "state": "RAJASTHAN"
  },
  "305921": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "305922": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305923": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305924": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305925": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305926": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305927": {
    "city": "Ajmer",
    "state": "Rajasthan"
  },
  "305928": {
    "city": "BEAWAR",
    "state": "RAJASTHAN"
  },
  "305929": {
    "city": "BEAWAR",
    "state": "RAJASTHAN"
  },
  "306001": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306021": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306022": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306023": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306024": {
    "city": "SOJAT",
    "state": "RAJASTHAN"
  },
  "306025": {
    "city": "SOJAT",
    "state": "RAJASTHAN"
  },
  "306026": {
    "city": "SOJAT",
    "state": "RAJASTHAN"
  },
  "306027": {
    "city": "SOJAT",
    "state": "RAJASTHAN"
  },
  "306028": {
    "city": "SOJAT",
    "state": "RAJASTHAN"
  },
  "306101": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306102": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306103": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306104": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306105": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306106": {
    "city": "SOJAT",
    "state": "RAJASTHAN"
  },
  "306107": {
    "city": "BEAWAR",
    "state": "RAJASTHAN"
  },
  "306108": {
    "city": "BEAWAR",
    "state": "RAJASTHAN"
  },
  "306114": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306115": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306116": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306117": {
    "city": "FALNA",
    "state": "RAJASTHAN"
  },
  "306118": {
    "city": "PALI",
    "state": "RAJASTHAN"
  },
  "306119": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306126": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306127": {
    "city": "SUMERPUR",
    "state": "RAJASTHAN"
  },
  "306128": {
    "city": "SUMERPUR",
    "state": "RAJASTHAN"
  },
  "306301": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306302": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306303": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306304": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306305": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306306": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306307": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306308": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306309": {
    "city": "BILARA",
    "state": "RAJASTHAN"
  },
  "306310": {
    "city": "JAITARAN",
    "state": "RAJASTHAN"
  },
  "306401": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306421": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306422": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306501": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306502": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306503": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306504": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306505": {
    "city": "SUMERPUR",
    "state": "RAJASTHAN"
  },
  "306601": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306602": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306603": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306622": {
    "city": "DESURI",
    "state": "RAJASTHAN"
  },
  "306701": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306702": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306703": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306704": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306705": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306706": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306707": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306708": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306709": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306710": {
    "city": "JAITARAN",
    "state": "RAJASTHAN"
  },
  "306901": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306902": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306912": {
    "city": "Pali",
    "state": "Rajasthan"
  },
  "306913": {
    "city": "SUMERPUR",
    "state": "RAJASTHAN"
  },
  "307001": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307002": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307019": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307020": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307021": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307022": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307023": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307024": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307025": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "307026": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307027": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307028": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307029": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "307030": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "307031": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307032": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307033": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307034": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307035": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307036": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307037": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307038": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307039": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307040": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307041": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307042": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307043": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307044": {
    "city": "ABU ROAD",
    "state": "RAJASTHAN"
  },
  "307045": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307501": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307510": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307511": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307512": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307513": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307514": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307515": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "307526": {
    "city": "BHINMAL",
    "state": "RAJASTHAN"
  },
  "307710": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "307801": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307802": {
    "city": "Sirohi",
    "state": "Rajasthan"
  },
  "307803": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "307804": {
    "city": "SIROHI",
    "state": "RAJASTHAN"
  },
  "311001": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311011": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311012": {
    "city": "BHILWARA",
    "state": "RAJASTHAN"
  },
  "311013": {
    "city": "BHILWARA",
    "state": "RAJASTHAN"
  },
  "311020": {
    "city": "BIJAINAGAR",
    "state": "RAJASTHAN"
  },
  "311021": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311022": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311023": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311024": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311025": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311026": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311027": {
    "city": "KOTRI",
    "state": "RAJASTHAN"
  },
  "311028": {
    "city": "BHILWARA",
    "state": "RAJASTHAN"
  },
  "311029": {
    "city": "BIJAINAGAR",
    "state": "RAJASTHAN"
  },
  "311030": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311031": {
    "city": "MANDALGARH",
    "state": "RAJASTHAN"
  },
  "311032": {
    "city": "ASIND",
    "state": "RAJASTHAN"
  },
  "311201": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311202": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311203": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311204": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311301": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311302": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311303": {
    "city": "ASIND",
    "state": "RAJASTHAN"
  },
  "311401": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311402": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311403": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311404": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311405": {
    "city": "BHILWARA",
    "state": "RAJASTHAN"
  },
  "311406": {
    "city": "KEKRI",
    "state": "RAJASTHAN"
  },
  "311407": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311408": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311601": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311602": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311603": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311604": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311605": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311606": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311607": {
    "city": "MANDALGARH",
    "state": "RAJASTHAN"
  },
  "311608": {
    "city": "MANDALGARH",
    "state": "RAJASTHAN"
  },
  "311609": {
    "city": "MANDALGARH",
    "state": "RAJASTHAN"
  },
  "311801": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311802": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311803": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311804": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311805": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311806": {
    "city": "Bhilwara",
    "state": "Rajasthan"
  },
  "311807": {
    "city": "SAHARA",
    "state": "RAJASTHAN"
  },
  "311808": {
    "city": "SAHARA",
    "state": "RAJASTHAN"
  },
  "311809": {
    "city": "SAHARA",
    "state": "RAJASTHAN"
  },
  "311810": {
    "city": "SAHARA",
    "state": "RAJASTHAN"
  },
  "312000": {
    "city": "CHITTOR GARH",
    "state": "RAJASTHAN"
  },
  "312001": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312002": {
    "city": "CHITTOR GARH",
    "state": "RAJASTHAN"
  },
  "312006": {
    "city": "CHITTOR GARH",
    "state": "RAJASTHAN"
  },
  "312021": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312022": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312023": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312024": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312025": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312026": {
    "city": "CHITTOR GARH",
    "state": "RAJASTHAN"
  },
  "312027": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312033": {
    "city": "KAPASAN",
    "state": "RAJASTHAN"
  },
  "312201": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312202": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312203": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312204": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312205": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312206": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312207": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312208": {
    "city": "CHITTOR GARH",
    "state": "RAJASTHAN"
  },
  "312337": {
    "city": "BARI SADRI",
    "state": "RAJASTHAN"
  },
  "312401": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312402": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312403": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312404": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312601": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312602": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312603": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312604": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312605": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312606": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312607": {
    "city": "NIMBAHERA",
    "state": "RAJASTHAN"
  },
  "312608": {
    "city": "NIMBAHERA",
    "state": "RAJASTHAN"
  },
  "312609": {
    "city": "NIMBAHERA",
    "state": "RAJASTHAN"
  },
  "312610": {
    "city": "NIMBAHERA",
    "state": "RAJASTHAN"
  },
  "312611": {
    "city": "NIMBAHERA",
    "state": "RAJASTHAN"
  },
  "312612": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312613": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312614": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312615": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312616": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312617": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312618": {
    "city": "BANSWARA",
    "state": "RAJASTHAN"
  },
  "312619": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312620": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312621": {
    "city": "CHITTOR GARH",
    "state": "RAJASTHAN"
  },
  "312622": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312623": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312624": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312625": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312626": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312627": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312901": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "312902": {
    "city": "CHITTOR GARH",
    "state": "RAJASTHAN"
  },
  "313001": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313002": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313003": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313004": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313011": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313012": {
    "city": "GOGUNDA",
    "state": "RAJASTHAN"
  },
  "313013": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313014": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313015": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313016": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313021": {
    "city": "CHITTOR GARH",
    "state": "RAJASTHAN"
  },
  "313022": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313023": {
    "city": "BHATEWAR",
    "state": "RAJASTHAN"
  },
  "313024": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313025": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313026": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313027": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313028": {
    "city": "DHARIAWAD",
    "state": "RAJASTHAN"
  },
  "313029": {
    "city": "DHARIAWAD",
    "state": "RAJASTHAN"
  },
  "313030": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313031": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313032": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313033": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313034": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "313036": {
    "city": "SARADA",
    "state": "RAJASTHAN"
  },
  "313038": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313201": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313202": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313203": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313204": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313205": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313206": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313207": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313209": {
    "city": "SAHARA",
    "state": "RAJASTHAN"
  },
  "313210": {
    "city": "FATEHNAGAR",
    "state": "RAJASTHAN"
  },
  "313211": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313212": {
    "city": "FATEHNAGAR",
    "state": "RAJASTHAN"
  },
  "313301": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313303": {
    "city": "NATHDWARA",
    "state": "RAJASTHAN"
  },
  "313321": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313322": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313323": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313324": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313325": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313326": {
    "city": "RAJSAMAND",
    "state": "RAJASTHAN"
  },
  "313327": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313328": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313329": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313330": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313331": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313332": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313333": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313334": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313335": {
    "city": "DESURI",
    "state": "RAJASTHAN"
  },
  "313336": {
    "city": "DESURI",
    "state": "RAJASTHAN"
  },
  "313337": {
    "city": "DESURI",
    "state": "RAJASTHAN"
  },
  "313338": {
    "city": "RAJSAMAND",
    "state": "RAJASTHAN"
  },
  "313340": {
    "city": "DEVGARH",
    "state": "RAJASTHAN"
  },
  "313341": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313342": {
    "city": "Rajsamand",
    "state": "Rajasthan"
  },
  "313601": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313602": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313603": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313604": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313605": {
    "city": "DHARIAWAD",
    "state": "RAJASTHAN"
  },
  "313606": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313607": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313608": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313609": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313610": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313611": {
    "city": "DHARIAWAD",
    "state": "RAJASTHAN"
  },
  "313612": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313613": {
    "city": "UDAIPUR",
    "state": "RAJASTHAN"
  },
  "313701": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313702": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313703": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313704": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313705": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313706": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313707": {
    "city": "GOGUNDA",
    "state": "RAJASTHAN"
  },
  "313708": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313709": {
    "city": "GOGUNDA",
    "state": "RAJASTHAN"
  },
  "313710": {
    "city": "GOGUNDA",
    "state": "RAJASTHAN"
  },
  "313801": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313802": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313803": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313804": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313805": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "313806": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "313901": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313902": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313903": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313904": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313905": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313906": {
    "city": "Udaipur",
    "state": "Rajasthan"
  },
  "313907": {
    "city": "KOTRA",
    "state": "RAJASTHAN"
  },
  "314001": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314011": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314012": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "314013": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "314021": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314022": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314023": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314024": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314025": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314026": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314027": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314028": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314029": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314030": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314031": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314032": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314033": {
    "city": "SARADA",
    "state": "RAJASTHAN"
  },
  "314034": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314035": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314036": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314037": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314038": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314401": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314402": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314403": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314404": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314405": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "314406": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314407": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "314801": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314802": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "314803": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "314804": {
    "city": "Dungarpur",
    "state": "Rajasthan"
  },
  "314806": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "320000": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "320001": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "320002": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "320003": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "320004": {
    "city": "KOTA",
    "state": "RAJASTHAN"
  },
  "320005": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "320006": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "320007": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "320008": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "320009": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "320010": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "320012": {
    "city": "DUNGARPUR",
    "state": "RAJASTHAN"
  },
  "321001": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321006": {
    "city": "BHARATPUR",
    "state": "RAJASTHAN"
  },
  "321021": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321022": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321023": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321024": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321025": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321026": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321027": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321028": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321029": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321030": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321031": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321032": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321033": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321034": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321035": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321036": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321201": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321202": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321203": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321204": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321205": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321206": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321207": {
    "city": "RAJGARH-RJ",
    "state": "RAJASTHAN"
  },
  "321208": {
    "city": "DEEG",
    "state": "RAJASTHAN"
  },
  "321209": {
    "city": "DEEG",
    "state": "RAJASTHAN"
  },
  "321210": {
    "city": "DEEG",
    "state": "RAJASTHAN"
  },
  "321211": {
    "city": "DEEG",
    "state": "RAJASTHAN"
  },
  "321301": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321302": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321303": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321304": {
    "city": "SADULPUR",
    "state": "RAJASTHAN"
  },
  "321305": {
    "city": "BHARATPUR",
    "state": "RAJASTHAN"
  },
  "321401": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321402": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321403": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321404": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321405": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321406": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321407": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321408": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321409": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321410": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321411": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321412": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321413": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321414": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321415": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321416": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321417": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321418": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321419": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321420": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321421": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321422": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321423": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321424": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321425": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321426": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321427": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321428": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321429": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321430": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321506": {
    "city": "BAYANA",
    "state": "RAJASTHAN"
  },
  "321601": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321602": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321603": {
    "city": "BHARATPUR",
    "state": "RAJASTHAN"
  },
  "321604": {
    "city": "NAGAR",
    "state": "RAJASTHAN"
  },
  "321605": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "321606": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "321607": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "321608": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "321609": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "321610": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "321611": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "321612": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "321613": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "321614": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321615": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "321616": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321617": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321618": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321619": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321620": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321621": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321622": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321623": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321625": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321626": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321628": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321629": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321630": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321631": {
    "city": "MAHWA",
    "state": "RAJASTHAN"
  },
  "321632": {
    "city": "RAJGARH-RJ",
    "state": "RAJASTHAN"
  },
  "321633": {
    "city": "Alwar",
    "state": "Rajasthan"
  },
  "321634": {
    "city": "RAJGARH-RJ",
    "state": "RAJASTHAN"
  },
  "321636": {
    "city": "RAJGARH-RJ",
    "state": "RAJASTHAN"
  },
  "321637": {
    "city": "RAJGARH-RJ",
    "state": "RAJASTHAN"
  },
  "321638": {
    "city": "RAJGARH-RJ",
    "state": "RAJASTHAN"
  },
  "321639": {
    "city": "RAJGARH-RJ",
    "state": "RAJASTHAN"
  },
  "321640": {
    "city": "RAJGARH-RJ",
    "state": "RAJASTHAN"
  },
  "321641": {
    "city": "NAGAR",
    "state": "RAJASTHAN"
  },
  "321642": {
    "city": "Bharatpur",
    "state": "Rajasthan"
  },
  "322001": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322021": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322022": {
    "city": "JAIPUR",
    "state": "RAJASTHAN"
  },
  "322023": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322024": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322025": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322026": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322027": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322028": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322029": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322030": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322031": {
    "city": "LALSOT",
    "state": "RAJASTHAN"
  },
  "322032": {
    "city": "KHANDAR",
    "state": "RAJASTHAN"
  },
  "322033": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322034": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322035": {
    "city": "SAWAI MADHOPUR",
    "state": "RAJASTHAN"
  },
  "322036": {
    "city": "SAWAI MADHOPUR",
    "state": "RAJASTHAN"
  },
  "322201": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322202": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322203": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322204": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322205": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322206": {
    "city": "SAWAI MADHOPUR",
    "state": "RAJASTHAN"
  },
  "322209": {
    "city": "GANGAPUR",
    "state": "RAJASTHAN"
  },
  "322211": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322212": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322213": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322214": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322215": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322216": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322217": {
    "city": "GANGAPUR",
    "state": "RAJASTHAN"
  },
  "322218": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322219": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322220": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322221": {
    "city": "NADOTI",
    "state": "RAJASTHAN"
  },
  "322222": {
    "city": "NADOTI",
    "state": "RAJASTHAN"
  },
  "322223": {
    "city": "NADOTI",
    "state": "RAJASTHAN"
  },
  "322224": {
    "city": "NADOTI",
    "state": "RAJASTHAN"
  },
  "322228": {
    "city": "GANGAPUR",
    "state": "RAJASTHAN"
  },
  "322230": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322231": {
    "city": "HINDAUN",
    "state": "RAJASTHAN"
  },
  "322232": {
    "city": "HINDAUN",
    "state": "RAJASTHAN"
  },
  "322233": {
    "city": "KARAULI",
    "state": "RAJASTHAN"
  },
  "322234": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322235": {
    "city": "HINDAUN",
    "state": "RAJASTHAN"
  },
  "322236": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322238": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322240": {
    "city": "Dausa",
    "state": "Rajasthan"
  },
  "322241": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322242": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322243": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322244": {
    "city": "KHANDAR",
    "state": "RAJASTHAN"
  },
  "322245": {
    "city": "KARAULI",
    "state": "RAJASTHAN"
  },
  "322246": {
    "city": "KHANDAR",
    "state": "RAJASTHAN"
  },
  "322247": {
    "city": "KHANDAR",
    "state": "RAJASTHAN"
  },
  "322248": {
    "city": "KARAULI",
    "state": "RAJASTHAN"
  },
  "322249": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322251": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322252": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322254": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322255": {
    "city": "Karauli",
    "state": "Rajasthan"
  },
  "322327": {
    "city": "KARAULI",
    "state": "RAJASTHAN"
  },
  "322701": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322702": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322703": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "322704": {
    "city": "Sawai Madhopur",
    "state": "Rajasthan"
  },
  "323001": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323021": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323022": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323023": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323024": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323025": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323026": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323301": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323302": {
    "city": "RAWATBHATA",
    "state": "RAJASTHAN"
  },
  "323303": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "323304": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "323305": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "323306": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "323307": {
    "city": "Chittorgarh",
    "state": "Rajasthan"
  },
  "323601": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323602": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323603": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323604": {
    "city": "LAKHERI",
    "state": "RAJASTHAN"
  },
  "323606": {
    "city": "LAKHERI",
    "state": "RAJASTHAN"
  },
  "323613": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323614": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323615": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323616": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323801": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323802": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "323803": {
    "city": "Bundi",
    "state": "Rajasthan"
  },
  "324001": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "324002": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "324003": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "324004": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "324005": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "324006": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "324007": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "324008": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "324009": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "324010": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "325001": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "325003": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "325004": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "325006": {
    "city": "LAKHERI",
    "state": "RAJASTHAN"
  },
  "325007": {
    "city": "KOTA",
    "state": "RAJASTHAN"
  },
  "325008": {
    "city": "LAKHERI",
    "state": "RAJASTHAN"
  },
  "325009": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "325201": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "325202": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325203": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "325204": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "325205": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325206": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325207": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325208": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "325209": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325210": {
    "city": "SANGOD",
    "state": "RAJASTHAN"
  },
  "325214": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "325215": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325216": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325217": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325218": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325219": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325220": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325221": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325222": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325223": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325224": {
    "city": "Baran",
    "state": "Rajasthan"
  },
  "325225": {
    "city": "AKLERA",
    "state": "RAJASTHAN"
  },
  "325226": {
    "city": "RAMGANJ MANDI",
    "state": "RAJASTHAN"
  },
  "325227": {
    "city": "RAMGANJ MANDI",
    "state": "RAJASTHAN"
  },
  "325601": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "325602": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "326001": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326003": {
    "city": "AKLERA",
    "state": "RAJASTHAN"
  },
  "326021": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326022": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326023": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326024": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326030": {
    "city": "AKLERA",
    "state": "RAJASTHAN"
  },
  "326033": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326034": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326035": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326036": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326037": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326038": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326039": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326040": {
    "city": "JHALAWAR",
    "state": "RAJASTHAN"
  },
  "326041": {
    "city": "JHALAWAR",
    "state": "RAJASTHAN"
  },
  "326501": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326502": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326503": {
    "city": "RAMGANJ MANDI",
    "state": "RAJASTHAN"
  },
  "326510": {
    "city": "RAMGANJ MANDI",
    "state": "RAJASTHAN"
  },
  "326512": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326513": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326514": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326515": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326516": {
    "city": "Jhalawar",
    "state": "Rajasthan"
  },
  "326517": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "326518": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "326519": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "326520": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "326521": {
    "city": "RAMGANJ MANDI",
    "state": "RAJASTHAN"
  },
  "326529": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "326530": {
    "city": "Kota",
    "state": "Rajasthan"
  },
  "327001": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327002": {
    "city": "BANSWARA",
    "state": "RAJASTHAN"
  },
  "327007": {
    "city": "BANSWARA",
    "state": "RAJASTHAN"
  },
  "327021": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327022": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327023": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327024": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327025": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327026": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327027": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327028": {
    "city": "GHATOL",
    "state": "RAJASTHAN"
  },
  "327029": {
    "city": "GHATOL",
    "state": "RAJASTHAN"
  },
  "327030": {
    "city": "BANSWARA",
    "state": "RAJASTHAN"
  },
  "327031": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327032": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327033": {
    "city": "BANSWARA",
    "state": "RAJASTHAN"
  },
  "327034": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327601": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327602": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327603": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327604": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327605": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327606": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "327608": {
    "city": "SAJJANGARH",
    "state": "RAJASTHAN"
  },
  "327801": {
    "city": "Banswara",
    "state": "Rajasthan"
  },
  "328001": {
    "city": "Dholpur",
    "state": "Rajasthan"
  },
  "328021": {
    "city": "Dholpur",
    "state": "Rajasthan"
  },
  "328022": {
    "city": "Dholpur",
    "state": "Rajasthan"
  },
  "328023": {
    "city": "Dholpur",
    "state": "Rajasthan"
  },
  "328024": {
    "city": "Dholpur",
    "state": "Rajasthan"
  },
  "328025": {
    "city": "Dholpur",
    "state": "Rajasthan"
  },
  "328026": {
    "city": "Dholpur",
    "state": "Rajasthan"
  },
  "328027": {
    "city": "Dholpur",
    "state": "Rajasthan"
  },
  "328028": {
    "city": "Dholpur",
    "state": "Rajasthan"
  },
  "328029": {
    "city": "Dholpur",
    "state": "Rajasthan"
  },
  "328030": {
    "city": "Dholpur",
    "state": "Rajasthan"
  },
  "328031": {
    "city": "Dholpur",
    "state": "Rajasthan"
  },
  "328032": {
    "city": "BARI",
    "state": "RAJASTHAN"
  },
  "328033": {
    "city": "BARI",
    "state": "RAJASTHAN"
  },
  "328034": {
    "city": "BARI",
    "state": "RAJASTHAN"
  },
  "328035": {
    "city": "BARI",
    "state": "RAJASTHAN"
  },
  "328036": {
    "city": "BARI",
    "state": "RAJASTHAN"
  },
  "328037": {
    "city": "BARI",
    "state": "RAJASTHAN"
  },
  "328038": {
    "city": "BARI",
    "state": "RAJASTHAN"
  },
  "328039": {
    "city": "BARI",
    "state": "RAJASTHAN"
  },
  "328040": {
    "city": "BARI",
    "state": "RAJASTHAN"
  },
  "328041": {
    "city": "Dholpur",
    "state": "Rajasthan"
  },
  "329090": {
    "city": "KOTA",
    "state": "RAJASTHAN"
  },
  "331001": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331002": {
    "city": "TARANAGAR",
    "state": "RAJASTHAN"
  },
  "331003": {
    "city": "SADULPUR",
    "state": "RAJASTHAN"
  },
  "331020": {
    "city": "CHURU",
    "state": "RAJASTHAN"
  },
  "331021": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331022": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331023": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331024": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "331025": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "331026": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "331027": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "331028": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "331029": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331030": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "331031": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331032": {
    "city": "CHURU",
    "state": "RAJASTHAN"
  },
  "331033": {
    "city": "FATEHPUR-RJ",
    "state": "RAJASTHAN"
  },
  "331034": {
    "city": "CHURU",
    "state": "RAJASTHAN"
  },
  "331035": {
    "city": "CHURU",
    "state": "RAJASTHAN"
  },
  "331301": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331302": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331303": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331304": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331305": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331306": {
    "city": "PILANI",
    "state": "RAJASTHAN"
  },
  "331307": {
    "city": "PILANI",
    "state": "RAJASTHAN"
  },
  "331321": {
    "city": "PILANI",
    "state": "RAJASTHAN"
  },
  "331401": {
    "city": "SARDARSHAHAR",
    "state": "RAJASTHAN"
  },
  "331402": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331403": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331404": {
    "city": "SARDARSHAHAR",
    "state": "RAJASTHAN"
  },
  "331411": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331501": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331502": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331503": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331504": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331505": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331506": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331507": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331508": {
    "city": "SUJANGARH",
    "state": "RAJASTHAN"
  },
  "331509": {
    "city": "SUJANGARH",
    "state": "RAJASTHAN"
  },
  "331510": {
    "city": "SUJANGARH",
    "state": "RAJASTHAN"
  },
  "331517": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331518": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331701": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331715": {
    "city": "SADULPUR",
    "state": "RAJASTHAN"
  },
  "331801": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "331802": {
    "city": "Churu",
    "state": "Rajasthan"
  },
  "331803": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "331804": {
    "city": "SRI DUNGARGARH",
    "state": "RAJASTHAN"
  },
  "331805": {
    "city": "SRI DUNGARGARH",
    "state": "RAJASTHAN"
  },
  "331811": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "332001": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332002": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332021": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332022": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332023": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332024": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332025": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332026": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332027": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332028": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332029": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332030": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332031": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332032": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332033": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332034": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332035": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332036": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332037": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332038": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332039": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332040": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332041": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332042": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332043": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332044": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332045": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332301": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332302": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332303": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332304": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332305": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332306": {
    "city": "FATEHPUR-RJ",
    "state": "RAJASTHAN"
  },
  "332307": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332308": {
    "city": "FATEHPUR-RJ",
    "state": "RAJASTHAN"
  },
  "332311": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332312": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332313": {
    "city": "LAXMANGARH",
    "state": "RAJASTHAN"
  },
  "332314": {
    "city": "LAXMANGARH",
    "state": "RAJASTHAN"
  },
  "332315": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332316": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332317": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332318": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332400": {
    "city": "LAXMANGARH",
    "state": "RAJASTHAN"
  },
  "332401": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332402": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332403": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332404": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332405": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332406": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332407": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332408": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332409": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "332410": {
    "city": "REENGUS",
    "state": "RAJASTHAN"
  },
  "332411": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332412": {
    "city": "REENGUS",
    "state": "RAJASTHAN"
  },
  "332413": {
    "city": "REENGUS",
    "state": "RAJASTHAN"
  },
  "332601": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332602": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332603": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332604": {
    "city": "REENGUS",
    "state": "RAJASTHAN"
  },
  "332605": {
    "city": "REENGUS",
    "state": "RAJASTHAN"
  },
  "332701": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332702": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332703": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332704": {
    "city": "NEEM KA THANA",
    "state": "RAJASTHAN"
  },
  "332705": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332706": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332707": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332708": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332709": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332710": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332711": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332712": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332713": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332714": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332715": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332716": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "332717": {
    "city": "NEEM KA THANA",
    "state": "RAJASTHAN"
  },
  "332718": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332719": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332721": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332722": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332723": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332724": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332725": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332726": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332727": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332728": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332729": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332730": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332731": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332732": {
    "city": "NEEM KA THANA",
    "state": "RAJASTHAN"
  },
  "332733": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332734": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332735": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332736": {
    "city": "NEEM KA THANA",
    "state": "RAJASTHAN"
  },
  "332737": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332738": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332739": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332740": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "332741": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "332742": {
    "city": "Sikar",
    "state": "Rajasthan"
  },
  "332743": {
    "city": "KUCHAMAN CITY",
    "state": "RAJASTHAN"
  },
  "332744": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "332745": {
    "city": "SURATGARH",
    "state": "RAJASTHAN"
  },
  "332746": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "332747": {
    "city": "SURATGARH",
    "state": "RAJASTHAN"
  },
  "332748": {
    "city": "SURATGARH",
    "state": "RAJASTHAN"
  },
  "333001": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333011": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333012": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333014": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333015": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333016": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333021": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333022": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333023": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333024": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333025": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333026": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333027": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333028": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333029": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333030": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333031": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333032": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333033": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333034": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333035": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333036": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333037": {
    "city": "KHETRI",
    "state": "RAJASTHAN"
  },
  "333038": {
    "city": "KHETRI",
    "state": "RAJASTHAN"
  },
  "333039": {
    "city": "KHETRI",
    "state": "RAJASTHAN"
  },
  "333040": {
    "city": "JHUNJHUNU",
    "state": "RAJASTHAN"
  },
  "333041": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333042": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333043": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "333044": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "333045": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "333046": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "333047": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "333048": {
    "city": "SIKAR",
    "state": "RAJASTHAN"
  },
  "333052": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333053": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333111": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333301": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333302": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333303": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333304": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333305": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333306": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333307": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333308": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333309": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333310": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333311": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333312": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333313": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333314": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333315": {
    "city": "UDAIPURWATI",
    "state": "RAJASTHAN"
  },
  "333333": {
    "city": "VADODARA",
    "state": "GUJARAT"
  },
  "333501": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333502": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333503": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333504": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333514": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333515": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333516": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333517": {
    "city": "KHETRI",
    "state": "RAJASTHAN"
  },
  "333701": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333702": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333703": {
    "city": "FATEHPUR-RJ",
    "state": "RAJASTHAN"
  },
  "333704": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333705": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333706": {
    "city": "JHUNJHUNU",
    "state": "RAJASTHAN"
  },
  "333707": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "333709": {
    "city": "JHUNJHUNU",
    "state": "RAJASTHAN"
  },
  "333801": {
    "city": "Jhujhunu",
    "state": "Rajasthan"
  },
  "334001": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334002": {
    "city": "BIKANER",
    "state": "RAJASTHAN"
  },
  "334003": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334004": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334005": {
    "city": "BIKANER",
    "state": "RAJASTHAN"
  },
  "334006": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334021": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334022": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334023": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334101": {
    "city": "KHAJUWALA",
    "state": "RAJASTHAN"
  },
  "334201": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334202": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334301": {
    "city": "KOLAYAT",
    "state": "RAJASTHAN"
  },
  "334302": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334303": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334304": {
    "city": "KHAJUWALA",
    "state": "RAJASTHAN"
  },
  "334305": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334306": {
    "city": "KHAJUWALA",
    "state": "RAJASTHAN"
  },
  "334401": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334402": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334403": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334404": {
    "city": "BIKANER",
    "state": "RAJASTHAN"
  },
  "334601": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334602": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334603": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334604": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334801": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334802": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334803": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334804": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "334808": {
    "city": "Bikaner",
    "state": "Rajasthan"
  },
  "335001": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335002": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335021": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335022": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335023": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335024": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335025": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335026": {
    "city": "SRIGANGANAGAR",
    "state": "RAJASTHAN"
  },
  "335027": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335037": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335038": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335039": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335040": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335041": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335042": {
    "city": "SRIGANGANAGAR",
    "state": "RAJASTHAN"
  },
  "335043": {
    "city": "SRIGANGANAGAR",
    "state": "RAJASTHAN"
  },
  "335051": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335061": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335062": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335063": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335064": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335065": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335073": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335074": {
    "city": "RAISINGHNAGAR",
    "state": "RAJASTHAN"
  },
  "335501": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335502": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335503": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335504": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335505": {
    "city": "BHADRA",
    "state": "RAJASTHAN"
  },
  "335511": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335512": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335513": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335514": {
    "city": "MANDI ADAMPUR",
    "state": "HARYANA"
  },
  "335515": {
    "city": "HANUMANGARH",
    "state": "RAJASTHAN"
  },
  "335523": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335524": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335525": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335526": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335527": {
    "city": "NOHAR",
    "state": "RAJASTHAN"
  },
  "335528": {
    "city": "NOHAR",
    "state": "RAJASTHAN"
  },
  "335701": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335702": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335703": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335704": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335705": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335706": {
    "city": "CHHATARGARH",
    "state": "RAJASTHAN"
  },
  "335707": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335708": {
    "city": "CHHATARGARH",
    "state": "RAJASTHAN"
  },
  "335710": {
    "city": "ANUPGARH",
    "state": "RAJASTHAN"
  },
  "335711": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335771": {
    "city": "ANUPGARH",
    "state": "RAJASTHAN"
  },
  "335801": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335802": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335803": {
    "city": "Hanumangarh",
    "state": "Rajasthan"
  },
  "335804": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335805": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335806": {
    "city": "SURATGARH",
    "state": "RAJASTHAN"
  },
  "335807": {
    "city": "SURATGARH",
    "state": "RAJASTHAN"
  },
  "335901": {
    "city": "Ganganagar",
    "state": "Rajasthan"
  },
  "335902": {
    "city": "SRIGANGANAGAR",
    "state": "RAJASTHAN"
  },
  "341001": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341002": {
    "city": "NAGAUR",
    "state": "RAJASTHAN"
  },
  "341011": {
    "city": "NAGAUR",
    "state": "RAJASTHAN"
  },
  "341012": {
    "city": "NAGAUR",
    "state": "RAJASTHAN"
  },
  "341013": {
    "city": "NAGAUR",
    "state": "RAJASTHAN"
  },
  "341021": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341022": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341023": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341024": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341025": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341026": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341027": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341028": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341029": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341030": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341031": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341032": {
    "city": "PISANGAN",
    "state": "RAJASTHAN"
  },
  "341033": {
    "city": "PISANGAN",
    "state": "RAJASTHAN"
  },
  "341034": {
    "city": "PISANGAN",
    "state": "RAJASTHAN"
  },
  "341035": {
    "city": "PISANGAN",
    "state": "RAJASTHAN"
  },
  "341259": {
    "city": "DEGANA",
    "state": "RAJASTHAN"
  },
  "341301": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341302": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341303": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341304": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341305": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341306": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341313": {
    "city": "SUJANGARH",
    "state": "RAJASTHAN"
  },
  "341316": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341317": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341318": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341319": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341501": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341502": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341503": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341504": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341505": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341506": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341507": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341508": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341509": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341510": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341511": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341512": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341513": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341514": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341515": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341516": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341517": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341518": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341519": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341520": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341521": {
    "city": "MAKRANA",
    "state": "RAJASTHAN"
  },
  "341522": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "341523": {
    "city": "KUCHAMAN CITY",
    "state": "RAJASTHAN"
  },
  "341524": {
    "city": "KISHANGARH",
    "state": "RAJASTHAN"
  },
  "341525": {
    "city": "KUCHAMAN CITY",
    "state": "RAJASTHAN"
  },
  "341526": {
    "city": "KUCHAMAN CITY",
    "state": "RAJASTHAN"
  },
  "341527": {
    "city": "KUCHAMAN CITY",
    "state": "RAJASTHAN"
  },
  "341528": {
    "city": "KUCHAMAN CITY",
    "state": "RAJASTHAN"
  },
  "341529": {
    "city": "MAKRANA",
    "state": "RAJASTHAN"
  },
  "341530": {
    "city": "DEGANA",
    "state": "RAJASTHAN"
  },
  "341531": {
    "city": "DEGANA",
    "state": "RAJASTHAN"
  },
  "341532": {
    "city": "DEGANA",
    "state": "RAJASTHAN"
  },
  "341533": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341534": {
    "city": "DEGANA",
    "state": "RAJASTHAN"
  },
  "341535": {
    "city": "MAKRANA",
    "state": "RAJASTHAN"
  },
  "341536": {
    "city": "KUCHAMAN CITY",
    "state": "RAJASTHAN"
  },
  "341537": {
    "city": "KUCHAMAN CITY",
    "state": "RAJASTHAN"
  },
  "341538": {
    "city": "PHULERA",
    "state": "RAJASTHAN"
  },
  "341539": {
    "city": "KUCHAMAN CITY",
    "state": "RAJASTHAN"
  },
  "341540": {
    "city": "MAKRANA",
    "state": "RAJASTHAN"
  },
  "341541": {
    "city": "DEGANA",
    "state": "RAJASTHAN"
  },
  "341542": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "341544": {
    "city": "MERTA",
    "state": "RAJASTHAN"
  },
  "341545": {
    "city": "MERTA",
    "state": "RAJASTHAN"
  },
  "341546": {
    "city": "MERTA",
    "state": "RAJASTHAN"
  },
  "341547": {
    "city": "MERTA",
    "state": "RAJASTHAN"
  },
  "341548": {
    "city": "MAKRANA",
    "state": "RAJASTHAN"
  },
  "341549": {
    "city": "DEGANA",
    "state": "RAJASTHAN"
  },
  "341550": {
    "city": "DIDWANA",
    "state": "RAJASTHAN"
  },
  "341551": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "342001": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342002": {
    "city": "JODHPUR(RAJ)",
    "state": "RAJASTHAN"
  },
  "342003": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342004": {
    "city": "JODHPUR(RAJ)",
    "state": "RAJASTHAN"
  },
  "342005": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342006": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342007": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342008": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342009": {
    "city": "JODHPUR(RAJ)",
    "state": "RAJASTHAN"
  },
  "342010": {
    "city": "JODHPUR(RAJ)",
    "state": "RAJASTHAN"
  },
  "342011": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342012": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342013": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342014": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342015": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342016": {
    "city": "JODHPUR",
    "state": "RAJASTHAN"
  },
  "342017": {
    "city": "JODHPUR",
    "state": "RAJASTHAN"
  },
  "342018": {
    "city": "SHIKARGARH",
    "state": "RAJASTHAN"
  },
  "342019": {
    "city": "JODHPUR",
    "state": "RAJASTHAN"
  },
  "342020": {
    "city": "DEGANA",
    "state": "RAJASTHAN"
  },
  "342021": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342022": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342023": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342024": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342025": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342026": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342027": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342028": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342029": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342030": {
    "city": "BALESAR",
    "state": "RAJASTHAN"
  },
  "342031": {
    "city": "BALESAR",
    "state": "RAJASTHAN"
  },
  "342032": {
    "city": "BALESAR",
    "state": "RAJASTHAN"
  },
  "342033": {
    "city": "BALESAR",
    "state": "RAJASTHAN"
  },
  "342034": {
    "city": "BALESAR",
    "state": "RAJASTHAN"
  },
  "342037": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342301": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342302": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342303": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342304": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342305": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342306": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342307": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342308": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342309": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342310": {
    "city": "Jaisalmer",
    "state": "Rajasthan"
  },
  "342311": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342312": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342314": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342601": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342602": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342603": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342604": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342605": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342606": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342607": {
    "city": "BHOPALGARH",
    "state": "RAJASTHAN"
  },
  "342608": {
    "city": "BHOPALGARH",
    "state": "RAJASTHAN"
  },
  "342609": {
    "city": "BHOPALGARH",
    "state": "RAJASTHAN"
  },
  "342611": {
    "city": "BHOPALGARH",
    "state": "RAJASTHAN"
  },
  "342612": {
    "city": "BHOPALGARH",
    "state": "RAJASTHAN"
  },
  "342705": {
    "city": "BHOPALGARH",
    "state": "RAJASTHAN"
  },
  "342801": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342802": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342803": {
    "city": "JODHPUR",
    "state": "RAJASTHAN"
  },
  "342804": {
    "city": "LUNI",
    "state": "RAJASTHAN"
  },
  "342901": {
    "city": "Jodhpur",
    "state": "Rajasthan"
  },
  "342902": {
    "city": "Nagaur",
    "state": "Rajasthan"
  },
  "343001": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343002": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343011": {
    "city": "JALORE",
    "state": "RAJASTHAN"
  },
  "343021": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343022": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343023": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343024": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343025": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343026": {
    "city": "JALORE",
    "state": "RAJASTHAN"
  },
  "343027": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343028": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343029": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343030": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343031": {
    "city": "SINDHARI",
    "state": "RAJASTHAN"
  },
  "343032": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343033": {
    "city": "SINDHARI",
    "state": "RAJASTHAN"
  },
  "343034": {
    "city": "SANCHORE",
    "state": "RAJASTHAN"
  },
  "343039": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343040": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343041": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343042": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343043": {
    "city": "BALOTRA",
    "state": "RAJASTHAN"
  },
  "343044": {
    "city": "BALOTRA",
    "state": "RAJASTHAN"
  },
  "343045": {
    "city": "JALORE",
    "state": "RAJASTHAN"
  },
  "343046": {
    "city": "JALORE",
    "state": "RAJASTHAN"
  },
  "343047": {
    "city": "JALORE",
    "state": "RAJASTHAN"
  },
  "343048": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "343049": {
    "city": "Jalor",
    "state": "Rajasthan"
  },
  "344001": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344011": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344012": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344013": {
    "city": "SHEO",
    "state": "RAJASTHAN"
  },
  "344014": {
    "city": "BARMER",
    "state": "RAJASTHAN"
  },
  "344015": {
    "city": "BARMER",
    "state": "RAJASTHAN"
  },
  "344021": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344022": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344023": {
    "city": "BALOTRA",
    "state": "RAJASTHAN"
  },
  "344024": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344025": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344026": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344027": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344028": {
    "city": "BALOTRA",
    "state": "RAJASTHAN"
  },
  "344029": {
    "city": "BALOTRA",
    "state": "RAJASTHAN"
  },
  "344030": {
    "city": "DHORIMANA",
    "state": "RAJASTHAN"
  },
  "344031": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344032": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344033": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344034": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344035": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344036": {
    "city": "BAYTU",
    "state": "RAJASTHAN"
  },
  "344037": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344038": {
    "city": "BAYTU",
    "state": "RAJASTHAN"
  },
  "344039": {
    "city": "BAYTU",
    "state": "RAJASTHAN"
  },
  "344043": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344044": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344501": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344502": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344503": {
    "city": "BARMER",
    "state": "RAJASTHAN"
  },
  "344601": {
    "city": "BARMER",
    "state": "RAJASTHAN"
  },
  "344701": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344702": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344703": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344704": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344705": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344706": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344708": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "344709": {
    "city": "SHEO",
    "state": "RAJASTHAN"
  },
  "344801": {
    "city": "Barmer",
    "state": "Rajasthan"
  },
  "345001": {
    "city": "Jaisalmer",
    "state": "Rajasthan"
  },
  "345002": {
    "city": "JAISALMER",
    "state": "RAJASTHAN"
  },
  "345021": {
    "city": "Jaisalmer",
    "state": "Rajasthan"
  },
  "345022": {
    "city": "Jaisalmer",
    "state": "Rajasthan"
  },
  "345023": {
    "city": "Jaisalmer",
    "state": "Rajasthan"
  },
  "345024": {
    "city": "Jaisalmer",
    "state": "Rajasthan"
  },
  "345025": {
    "city": "Jaisalmer",
    "state": "Rajasthan"
  },
  "345026": {
    "city": "Jaisalmer",
    "state": "Rajasthan"
  },
  "345027": {
    "city": "Jaisalmer",
    "state": "Rajasthan"
  },
  "345028": {
    "city": "Jaisalmer",
    "state": "Rajasthan"
  },
  "345029": {
    "city": "MOHANGARH",
    "state": "RAJASTHAN"
  },
  "345030": {
    "city": "MOHANGARH",
    "state": "RAJASTHAN"
  },
  "345031": {
    "city": "Jaisalmer",
    "state": "Rajasthan"
  },
  "345032": {
    "city": "JAISALMER",
    "state": "RAJASTHAN"
  },
  "345033": {
    "city": "Jaisalmer",
    "state": "Rajasthan"
  },
  "345034": {
    "city": "Jaisalmer",
    "state": "Rajasthan"
  },
  "345110": {
    "city": "JAISALMER",
    "state": "RAJASTHAN"
  },
  "360000": {
    "city": "RAJKOT",
    "state": "GUJARAT"
  },
  "360001": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360002": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360003": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360004": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360005": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360006": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360007": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360008": {
    "city": "RAJKOT",
    "state": "GUJARAT"
  },
  "360009": {
    "city": "RAJKOT",
    "state": "GUJARAT"
  },
  "360011": {
    "city": "RAJKOT",
    "state": "GUJARAT"
  },
  "360012": {
    "city": "RAJKOT",
    "state": "GUJARAT"
  },
  "360013": {
    "city": "RAJKOT",
    "state": "GUJARAT"
  },
  "360018": {
    "city": "RAJKOT",
    "state": "GUJARAT"
  },
  "360020": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360021": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360022": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360023": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360024": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360025": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360026": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360030": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360032": {
    "city": "JASDAN",
    "state": "GUJARAT"
  },
  "360034": {
    "city": "RAJKOT",
    "state": "GUJARAT"
  },
  "360035": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360040": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360045": {
    "city": "JASDAN",
    "state": "GUJARAT"
  },
  "360050": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360055": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360060": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360070": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360075": {
    "city": "GONDAL",
    "state": "GUJARAT"
  },
  "360080": {
    "city": "JASDAN",
    "state": "GUJARAT"
  },
  "360110": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360150": {
    "city": "BHANVAD",
    "state": "GUJARAT"
  },
  "360311": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360312": {
    "city": "GONDAL",
    "state": "GUJARAT"
  },
  "360320": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360330": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360335": {
    "city": "GONDAL",
    "state": "GUJARAT"
  },
  "360360": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360370": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360375": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360380": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360405": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360410": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360411": {
    "city": "JUNAGADH",
    "state": "GUJARAT"
  },
  "360421": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360430": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360440": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360450": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360452": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360460": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360470": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360480": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360490": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "360510": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "360515": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "360520": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "360521": {
    "city": "JAMJODHPUR",
    "state": "GUJARAT"
  },
  "360530": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "360531": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "360535": {
    "city": "JAMJODHPUR",
    "state": "GUJARAT"
  },
  "360540": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "360545": {
    "city": "Porbandar",
    "state": "Gujarat"
  },
  "360550": {
    "city": "Porbandar",
    "state": "Gujarat"
  },
  "360560": {
    "city": "PORBANDAR",
    "state": "GUJARAT"
  },
  "360570": {
    "city": "Porbandar",
    "state": "Gujarat"
  },
  "360571": {
    "city": "KUTIYANA",
    "state": "GUJARAT"
  },
  "360572": {
    "city": "KUTIYANA",
    "state": "GUJARAT"
  },
  "360575": {
    "city": "Porbandar",
    "state": "Gujarat"
  },
  "360576": {
    "city": "Porbandar",
    "state": "Gujarat"
  },
  "360577": {
    "city": "Porbandar",
    "state": "Gujarat"
  },
  "360578": {
    "city": "Porbandar",
    "state": "Gujarat"
  },
  "360579": {
    "city": "Porbandar",
    "state": "Gujarat"
  },
  "360583": {
    "city": "PORBANDAR",
    "state": "GUJARAT"
  },
  "360585": {
    "city": "PORBANDAR",
    "state": "GUJARAT"
  },
  "360590": {
    "city": "Porbandar",
    "state": "Gujarat"
  },
  "360592": {
    "city": "SODHANA",
    "state": "GUJARAT"
  },
  "360595": {
    "city": "SODHANA",
    "state": "GUJARAT"
  },
  "360650": {
    "city": "KUTIYANA",
    "state": "GUJARAT"
  },
  "361001": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361002": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361003": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361004": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361005": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361006": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361007": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361008": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361009": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361010": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361011": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361012": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361013": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361110": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361120": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361130": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361140": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361141": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361142": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361150": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361160": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361162": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361170": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361210": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361220": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361230": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361240": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361250": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361280": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361285": {
    "city": "MAHADEVIYA",
    "state": "GUJARAT"
  },
  "361290": {
    "city": "MAHADEVIYA",
    "state": "GUJARAT"
  },
  "361295": {
    "city": "SODHANA",
    "state": "GUJARAT"
  },
  "361301": {
    "city": "KALAVAD",
    "state": "GUJARAT"
  },
  "361305": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361306": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361310": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361315": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361316": {
    "city": "MAHADEVIYA",
    "state": "GUJARAT"
  },
  "361320": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361321": {
    "city": "SODHANA",
    "state": "GUJARAT"
  },
  "361322": {
    "city": "SODHANA",
    "state": "GUJARAT"
  },
  "361325": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361330": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361335": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361336": {
    "city": "DWARKA",
    "state": "GUJARAT"
  },
  "361345": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361347": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "361350": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "362001": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362002": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362003": {
    "city": "JUNAGADH",
    "state": "GUJARAT"
  },
  "362004": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362005": {
    "city": "DHROL",
    "state": "GUJARAT"
  },
  "362011": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362012": {
    "city": "JUNAGADH",
    "state": "GUJARAT"
  },
  "362013": {
    "city": "JUNAGADH",
    "state": "GUJARAT"
  },
  "362014": {
    "city": "JUNAGADH",
    "state": "GUJARAT"
  },
  "362015": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362020": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362021": {
    "city": "RANPUR",
    "state": "GUJARAT"
  },
  "362030": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362036": {
    "city": "UNA-GJ",
    "state": "GUJARAT"
  },
  "362037": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362110": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362111": {
    "city": "VISAVADAR",
    "state": "GUJARAT"
  },
  "362120": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362130": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362132": {
    "city": "VISAVADAR",
    "state": "GUJARAT"
  },
  "362133": {
    "city": "VISAVADAR",
    "state": "GUJARAT"
  },
  "362135": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362136": {
    "city": "TALALA",
    "state": "GUJARAT"
  },
  "362140": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362142": {
    "city": "TALALA",
    "state": "GUJARAT"
  },
  "362150": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362151": {
    "city": "TALALA",
    "state": "GUJARAT"
  },
  "362152": {
    "city": "TALALA",
    "state": "GUJARAT"
  },
  "362155": {
    "city": "TALALA",
    "state": "GUJARAT"
  },
  "362205": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362215": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362216": {
    "city": "KESHOD",
    "state": "GUJARAT"
  },
  "362220": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362221": {
    "city": "KESHOD",
    "state": "GUJARAT"
  },
  "362222": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362223": {
    "city": "KESHOD",
    "state": "GUJARAT"
  },
  "362224": {
    "city": "KESHOD",
    "state": "GUJARAT"
  },
  "362225": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362226": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362227": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362228": {
    "city": "KESHOD",
    "state": "GUJARAT"
  },
  "362229": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362230": {
    "city": "Porbandar",
    "state": "Gujarat"
  },
  "362231": {
    "city": "KESHOD",
    "state": "GUJARAT"
  },
  "362235": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362240": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362242": {
    "city": "MANGROL",
    "state": "GUJARAT"
  },
  "362245": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362246": {
    "city": "KESHOD",
    "state": "GUJARAT"
  },
  "362247": {
    "city": "KESHOD",
    "state": "GUJARAT"
  },
  "362248": {
    "city": "KESHOD",
    "state": "GUJARAT"
  },
  "362249": {
    "city": "KESHOD",
    "state": "GUJARAT"
  },
  "362250": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362255": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362256": {
    "city": "VERAVAL",
    "state": "GUJARAT"
  },
  "362257": {
    "city": "VERAVAL",
    "state": "GUJARAT"
  },
  "362258": {
    "city": "VERAVAL",
    "state": "GUJARAT"
  },
  "362259": {
    "city": "VERAVAL",
    "state": "GUJARAT"
  },
  "362260": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362263": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362265": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362266": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362267": {
    "city": "VEERAVAL",
    "state": "GUJARAT"
  },
  "362268": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362269": {
    "city": "JUNAGADH",
    "state": "GUJARAT"
  },
  "362271": {
    "city": "KODINAR",
    "state": "GUJARAT"
  },
  "362275": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362276": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362277": {
    "city": "KODINAR",
    "state": "GUJARAT"
  },
  "362278": {
    "city": "KODINAR",
    "state": "GUJARAT"
  },
  "362310": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362315": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362510": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362515": {
    "city": "UNA-GJ",
    "state": "GUJARAT"
  },
  "362520": {
    "city": "Diu",
    "state": "Daman And Diu"
  },
  "362530": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362540": {
    "city": "Diu",
    "state": "Daman And Diu"
  },
  "362550": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362551": {
    "city": "UNA-GJ",
    "state": "GUJARAT"
  },
  "362552": {
    "city": "UNA-GJ",
    "state": "GUJARAT"
  },
  "362554": {
    "city": "UNA-GJ",
    "state": "GUJARAT"
  },
  "362560": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362565": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362570": {
    "city": "Diu",
    "state": "Daman And Diu"
  },
  "362571": {
    "city": "UNA-GJ",
    "state": "GUJARAT"
  },
  "362610": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362615": {
    "city": "JUNAGADH",
    "state": "GUJARAT"
  },
  "362620": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362621": {
    "city": "KUTIYANA",
    "state": "GUJARAT"
  },
  "362623": {
    "city": "KUTIYANA",
    "state": "GUJARAT"
  },
  "362624": {
    "city": "KUTIYANA",
    "state": "GUJARAT"
  },
  "362625": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362626": {
    "city": "MANAVADAR",
    "state": "GUJARAT"
  },
  "362627": {
    "city": "MANAVADAR",
    "state": "GUJARAT"
  },
  "362630": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362633": {
    "city": "MANAVADAR",
    "state": "GUJARAT"
  },
  "362634": {
    "city": "MANAVADAR",
    "state": "GUJARAT"
  },
  "362640": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362650": {
    "city": "Porbandar",
    "state": "Gujarat"
  },
  "362652": {
    "city": "KUTIYANA",
    "state": "GUJARAT"
  },
  "362653": {
    "city": "KUTIYANA",
    "state": "GUJARAT"
  },
  "362710": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362715": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362720": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362721": {
    "city": "KODINAR",
    "state": "GUJARAT"
  },
  "362722": {
    "city": "KODINAR",
    "state": "GUJARAT"
  },
  "362725": {
    "city": "Junagadh",
    "state": "Gujarat"
  },
  "362726": {
    "city": "KODINAR",
    "state": "GUJARAT"
  },
  "362727": {
    "city": "KODINAR",
    "state": "GUJARAT"
  },
  "362730": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "362733": {
    "city": "KODINAR",
    "state": "GUJARAT"
  },
  "363001": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363002": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363007": {
    "city": "SURENDRANAGAR",
    "state": "GUJARAT"
  },
  "363020": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363022": {
    "city": "SURENDRANAGAR",
    "state": "GUJARAT"
  },
  "363023": {
    "city": "SURENDRANAGAR",
    "state": "GUJARAT"
  },
  "363030": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363031": {
    "city": "SURENDRANAGAR",
    "state": "GUJARAT"
  },
  "363035": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363039": {
    "city": "SURENDRANAGAR",
    "state": "GUJARAT"
  },
  "363040": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363041": {
    "city": "SURENDRANAGAR",
    "state": "GUJARAT"
  },
  "363045": {
    "city": "SURENDRANAGAR",
    "state": "GUJARAT"
  },
  "363110": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363115": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363250": {
    "city": "Chotila",
    "state": "GUJARAT"
  },
  "363310": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363312": {
    "city": "DHANGADHRA",
    "state": "GUJARAT"
  },
  "363315": {
    "city": "DHANGADHRA",
    "state": "GUJARAT"
  },
  "363320": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363330": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363331": {
    "city": "Morbi",
    "state": "Gujarat"
  },
  "363332": {
    "city": "HALVAD",
    "state": "GUJARAT"
  },
  "363333": {
    "city": "HALVAD",
    "state": "GUJARAT"
  },
  "363334": {
    "city": "HALVAD",
    "state": "GUJARAT"
  },
  "363351": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363410": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363411": {
    "city": "RANPUR",
    "state": "GUJARAT"
  },
  "363412": {
    "city": "RANPUR",
    "state": "GUJARAT"
  },
  "363415": {
    "city": "RANPUR",
    "state": "GUJARAT"
  },
  "363416": {
    "city": "RANPUR",
    "state": "GUJARAT"
  },
  "363420": {
    "city": "LIMDI",
    "state": "GUJARAT"
  },
  "363421": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363422": {
    "city": "LIMDI",
    "state": "GUJARAT"
  },
  "363423": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363424": {
    "city": "LIMBDI",
    "state": "GUJARAT"
  },
  "363425": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363426": {
    "city": "LIMBDI",
    "state": "GUJARAT"
  },
  "363427": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363430": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363435": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363440": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363510": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363520": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363522": {
    "city": "CHOTILA",
    "state": "GUJARAT"
  },
  "363530": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "363535": {
    "city": "CHOTILA",
    "state": "GUJARAT"
  },
  "363610": {
    "city": "RANPUR",
    "state": "GUJARAT"
  },
  "363621": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "363622": {
    "city": "WANKANER",
    "state": "GUJARAT"
  },
  "363626": {
    "city": "CHOTILA",
    "state": "GUJARAT"
  },
  "363630": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "363631": {
    "city": "VERAVAL",
    "state": "GUJARAT"
  },
  "363635": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "363636": {
    "city": "VERAVAL",
    "state": "GUJARAT"
  },
  "363641": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "363642": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "363643": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "363650": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "363655": {
    "city": "Jamnagar",
    "state": "Gujarat"
  },
  "363660": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "363665": {
    "city": "VERAVAL",
    "state": "GUJARAT"
  },
  "363666": {
    "city": "VERAVAL",
    "state": "GUJARAT"
  },
  "363667": {
    "city": "VERAVAL",
    "state": "GUJARAT"
  },
  "363668": {
    "city": "VERAVAL",
    "state": "GUJARAT"
  },
  "363669": {
    "city": "VERAVAL",
    "state": "GUJARAT"
  },
  "363670": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "364001": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364002": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364003": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364004": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364005": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364006": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364021": {
    "city": "BHAVNAGAR",
    "state": "GUJARAT"
  },
  "364022": {
    "city": "BHAVNAGAR",
    "state": "GUJARAT"
  },
  "364050": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364055": {
    "city": "RAJKOT",
    "state": "GUJARAT"
  },
  "364060": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364061": {
    "city": "BHAVNAGAR",
    "state": "GUJARAT"
  },
  "364070": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364071": {
    "city": "BHAVNAGAR",
    "state": "GUJARAT"
  },
  "364081": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364110": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364120": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364130": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364131": {
    "city": "TALAJA",
    "state": "GUJARAT"
  },
  "364135": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364140": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364145": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364146": {
    "city": "PALITANA",
    "state": "GUJARAT"
  },
  "364150": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364151": {
    "city": "TALAJA",
    "state": "GUJARAT"
  },
  "364210": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364215": {
    "city": "UMRALA",
    "state": "GUJARAT"
  },
  "364220": {
    "city": "GARIADHAR",
    "state": "GUJARAT"
  },
  "364225": {
    "city": "GARIADHAR",
    "state": "GUJARAT"
  },
  "364230": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364231": {
    "city": "PALITANA",
    "state": "GUJARAT"
  },
  "364240": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364241": {
    "city": "BHAVNAGAR",
    "state": "GUJARAT"
  },
  "364245": {
    "city": "BHAVNAGAR",
    "state": "GUJARAT"
  },
  "364250": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364251": {
    "city": "PALITANA",
    "state": "GUJARAT"
  },
  "364260": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364261": {
    "city": "PALITANA",
    "state": "GUJARAT"
  },
  "364262": {
    "city": "PALITANA",
    "state": "GUJARAT"
  },
  "364265": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364270": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364275": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364276": {
    "city": "GARIADHAR",
    "state": "GUJARAT"
  },
  "364280": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364290": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364292": {
    "city": "MAHUVA BHAVNAGAR",
    "state": "GUJARAT"
  },
  "364293": {
    "city": "MAHUVA BHAVNAGAR",
    "state": "GUJARAT"
  },
  "364295": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364296": {
    "city": "MAHUVA BHAVNAGAR",
    "state": "GUJARAT"
  },
  "364297": {
    "city": "MAHUVA BHAVNAGAR",
    "state": "GUJARAT"
  },
  "364298": {
    "city": "MAHUVA BHAVNAGAR",
    "state": "GUJARAT"
  },
  "364310": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364311": {
    "city": "UMRALA",
    "state": "GUJARAT"
  },
  "364312": {
    "city": "UMRALA",
    "state": "GUJARAT"
  },
  "364313": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364315": {
    "city": "BOTAD",
    "state": "GUJARAT"
  },
  "364320": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364330": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364335": {
    "city": "UMRALA",
    "state": "GUJARAT"
  },
  "364365": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364410": {
    "city": "UMRALA",
    "state": "GUJARAT"
  },
  "364421": {
    "city": "RAJKOT",
    "state": "GUJARAT"
  },
  "364430": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364431": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364432": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364435": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364436": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364440": {
    "city": "JETPUR",
    "state": "GUJARAT"
  },
  "364445": {
    "city": "DHARI",
    "state": "GUJARAT"
  },
  "364450": {
    "city": "VADIA",
    "state": "GUJARAT"
  },
  "364455": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364456": {
    "city": "SAVARKUNDLA",
    "state": "GUJARAT"
  },
  "364457": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364458": {
    "city": "DHARI",
    "state": "GUJARAT"
  },
  "364460": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364465": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "364470": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "364480": {
    "city": "VADIA",
    "state": "GUJARAT"
  },
  "364481": {
    "city": "DHARI",
    "state": "GUJARAT"
  },
  "364485": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "364490": {
    "city": "Rajkot",
    "state": "Gujarat"
  },
  "364505": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364506": {
    "city": "GARIADHAR",
    "state": "GUJARAT"
  },
  "364507": {
    "city": "GARIADHAR",
    "state": "GUJARAT"
  },
  "364508": {
    "city": "GARIADHAR",
    "state": "GUJARAT"
  },
  "364510": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364515": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "364517": {
    "city": "SAVARKUNDLA",
    "state": "GUJARAT"
  },
  "364518": {
    "city": "SAVARKUNDLA",
    "state": "GUJARAT"
  },
  "364519": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364521": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "364522": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "364523": {
    "city": "SAVARKUNDLA",
    "state": "GUJARAT"
  },
  "364524": {
    "city": "SAVARKUNDLA",
    "state": "GUJARAT"
  },
  "364525": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "364526": {
    "city": "GARIADHAR",
    "state": "GUJARAT"
  },
  "364530": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "364535": {
    "city": "JUNAGADH",
    "state": "GUJARAT"
  },
  "364536": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364537": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364540": {
    "city": "RAJKOT",
    "state": "GUJARAT"
  },
  "364545": {
    "city": "UNA-GJ",
    "state": "GUJARAT"
  },
  "364550": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364555": {
    "city": "RAJULA",
    "state": "GUJARAT"
  },
  "364560": {
    "city": "RAJULA",
    "state": "GUJARAT"
  },
  "364561": {
    "city": "BARDOLI",
    "state": "GUJARAT"
  },
  "364565": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364570": {
    "city": "RAJULA",
    "state": "GUJARAT"
  },
  "364601": {
    "city": "NASVADI",
    "state": "GUJARAT"
  },
  "364610": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364615": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364616": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364620": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "364622": {
    "city": "BOTAD",
    "state": "GUJARAT"
  },
  "364630": {
    "city": "RAJKOT",
    "state": "GUJARAT"
  },
  "364632": {
    "city": "BABRA",
    "state": "GUJARAT"
  },
  "364633": {
    "city": "SAVARKUNDLA",
    "state": "GUJARAT"
  },
  "364635": {
    "city": "SAVARKUNDLA",
    "state": "GUJARAT"
  },
  "364640": {
    "city": "BABRA",
    "state": "GUJARAT"
  },
  "364641": {
    "city": "BABRA",
    "state": "GUJARAT"
  },
  "364645": {
    "city": "JUNAGADH",
    "state": "GUJARAT"
  },
  "364650": {
    "city": "RAJULA",
    "state": "GUJARAT"
  },
  "364660": {
    "city": "DHARI",
    "state": "GUJARAT"
  },
  "364710": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364712": {
    "city": "BOTAD",
    "state": "GUJARAT"
  },
  "364713": {
    "city": "BOTAD",
    "state": "GUJARAT"
  },
  "364714": {
    "city": "BOTAD",
    "state": "GUJARAT"
  },
  "364720": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364730": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364740": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364741": {
    "city": "GADHADA",
    "state": "GUJARAT"
  },
  "364750": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364760": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "364765": {
    "city": "Bhavnagar",
    "state": "Gujarat"
  },
  "365001": {
    "city": "RAJKOT",
    "state": "GUJARAT"
  },
  "365220": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365410": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365421": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365422": {
    "city": "BABRA",
    "state": "GUJARAT"
  },
  "365430": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365435": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365440": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365450": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365455": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365456": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365460": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365480": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365535": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365540": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365541": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365545": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365550": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365555": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365560": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365565": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365601": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365610": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365615": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "365616": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "365620": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365630": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365632": {
    "city": "DHARI",
    "state": "GUJARAT"
  },
  "365635": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365640": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365645": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365650": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365660": {
    "city": "Amreli",
    "state": "Gujarat"
  },
  "365665": {
    "city": "AMRELI",
    "state": "GUJARAT"
  },
  "365730": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "370001": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370002": {
    "city": "BHUJ",
    "state": "GUJARAT"
  },
  "370006": {
    "city": "BHUJ",
    "state": "GUJARAT"
  },
  "370007": {
    "city": "BHUJ",
    "state": "GUJARAT"
  },
  "370015": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370020": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370030": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370040": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370061": {
    "city": "BHUJ",
    "state": "GUJARAT"
  },
  "370105": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370110": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370111": {
    "city": "GANDHIDHAM",
    "state": "GUJARAT"
  },
  "370115": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370130": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370132": {
    "city": "GANDHIDHAM",
    "state": "GUJARAT"
  },
  "370135": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370140": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370141": {
    "city": "BACHAU",
    "state": "GUJARAT"
  },
  "370145": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370146": {
    "city": "BACHAU",
    "state": "GUJARAT"
  },
  "370147": {
    "city": "BACHAU",
    "state": "GUJARAT"
  },
  "370150": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370155": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370156": {
    "city": "RAPAR",
    "state": "GUJARAT"
  },
  "370157": {
    "city": "RAPAR",
    "state": "GUJARAT"
  },
  "370160": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370165": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370168": {
    "city": "RAPAR",
    "state": "GUJARAT"
  },
  "370169": {
    "city": "RAPAR",
    "state": "GUJARAT"
  },
  "370170": {
    "city": "GANDHIDHAM",
    "state": "GUJARAT"
  },
  "370201": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370202": {
    "city": "GANDHIDHAM",
    "state": "GUJARAT"
  },
  "370203": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370204": {
    "city": "GANDHIDHAM",
    "state": "GUJARAT"
  },
  "370205": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370210": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370230": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370240": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370405": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370406": {
    "city": "MUNDRA",
    "state": "GUJARAT"
  },
  "370410": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370411": {
    "city": "MUNDRA",
    "state": "GUJARAT"
  },
  "370415": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370421": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370422": {
    "city": "MUNDRA",
    "state": "GUJARAT"
  },
  "370425": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370427": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370429": {
    "city": "BHUJ",
    "state": "GUJARAT"
  },
  "370430": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370435": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370440": {
    "city": "MUNDRA",
    "state": "GUJARAT"
  },
  "370445": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370450": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370455": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370460": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370465": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370471": {
    "city": "MANDVI",
    "state": "GUJARAT"
  },
  "370472": {
    "city": "MANDVI",
    "state": "GUJARAT"
  },
  "370475": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370485": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370490": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370510": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370511": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370515": {
    "city": "NALIYA",
    "state": "GUJARAT"
  },
  "370601": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370602": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370605": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370610": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370611": {
    "city": "BHUJ",
    "state": "GUJARAT"
  },
  "370615": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370620": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370625": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370627": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370630": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370635": {
    "city": "BHUJ",
    "state": "GUJARAT"
  },
  "370640": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370645": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370650": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370655": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370660": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370665": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370670": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "370675": {
    "city": "Kachchh",
    "state": "Gujarat"
  },
  "380000": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380001": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380002": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380003": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380004": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380005": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380006": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380007": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380008": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380009": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380010": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380011": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380012": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380013": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380014": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380015": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380016": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380017": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380018": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380019": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380020": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380021": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380022": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380023": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380024": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380025": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380026": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380027": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380028": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380029": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380030": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380038": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380041": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380043": {
    "city": "Ahmedabad",
    "state": "GUJARAT"
  },
  "380045": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380049": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380050": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380051": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380052": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380053": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380054": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380055": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380056": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380057": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380058": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380059": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380060": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380061": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380062": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380063": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "380075": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380081": {
    "city": "Ahmedabad",
    "state": "GUJARAT"
  },
  "380123": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380151": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380152": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380202": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380210": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380215": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380316": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380330": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380452": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "380481": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "381001": {
    "city": "TALOD",
    "state": "GUJARAT"
  },
  "381156": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "381520": {
    "city": "VALSAD",
    "state": "GUJARAT"
  },
  "382000": {
    "city": "GANDHI NAGAR",
    "state": "GUJARAT"
  },
  "382001": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382002": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382003": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382004": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382005": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382006": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382007": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382008": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382009": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382010": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382011": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382012": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382013": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382014": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382015": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382016": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382017": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382018": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382019": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382020": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382021": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382022": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382023": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382024": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382025": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382026": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382027": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382028": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382029": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382030": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382041": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382042": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382043": {
    "city": "GANDHI NAGAR",
    "state": "GUJARAT"
  },
  "382044": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382045": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382051": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382110": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382115": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382120": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382121": {
    "city": "VIRAMGAM",
    "state": "GUJARAT"
  },
  "382130": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382140": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382145": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382150": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382155": {
    "city": "VIRAMGAM",
    "state": "GUJARAT"
  },
  "382160": {
    "city": "VIRAMGAM",
    "state": "GUJARAT"
  },
  "382165": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382166": {
    "city": "VIRAMGAM",
    "state": "GUJARAT"
  },
  "382170": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382210": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382211": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "382213": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382220": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382225": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382230": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382240": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382241": {
    "city": "BAGODARA",
    "state": "GUJARAT"
  },
  "382245": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382250": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382255": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382260": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382265": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382270": {
    "city": "BAVLA",
    "state": "GUJARAT"
  },
  "382276": {
    "city": "BAGODARA",
    "state": "GUJARAT"
  },
  "382305": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382308": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382310": {
    "city": "DEHGAM",
    "state": "GUJARAT"
  },
  "382315": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382316": {
    "city": "TALOD",
    "state": "GUJARAT"
  },
  "382320": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382321": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382324": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "382325": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "382327": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "382330": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382333": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "382340": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382345": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382346": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "382350": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382352": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "382355": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382360": {
    "city": "DEHGAM",
    "state": "GUJARAT"
  },
  "382404": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "382405": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382410": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "382415": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382418": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382420": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "382421": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382422": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382423": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382424": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382425": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382426": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382427": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382428": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382430": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382433": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382435": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382440": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "382442": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "382443": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382445": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382449": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382450": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382451": {
    "city": "BOTAD",
    "state": "GUJARAT"
  },
  "382455": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382460": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382463": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382465": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382470": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382475": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382480": {
    "city": "Ahmedabad",
    "state": "Gujarat"
  },
  "382481": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382610": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382620": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382625": {
    "city": "GANDHINAGAR",
    "state": "GUJARAT"
  },
  "382630": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382640": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382644": {
    "city": "MANSA",
    "state": "GUJARAT"
  },
  "382650": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382655": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "382704": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382705": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382706": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382707": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382708": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382709": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382710": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382711": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "382712": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "382713": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "382715": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382716": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382717": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382718": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382719": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382720": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382721": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382722": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382723": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382724": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382725": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382726": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382727": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382728": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382729": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382730": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382731": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382732": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382733": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382734": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382735": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382736": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382737": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382739": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382740": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382741": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382742": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382743": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382745": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "382750": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "382755": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "382760": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "382765": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "382770": {
    "city": "VIRAMGAM",
    "state": "GUJARAT"
  },
  "382775": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "382780": {
    "city": "Surendra Nagar",
    "state": "Gujarat"
  },
  "382797": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382805": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382806": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382810": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382812": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382815": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382816": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382820": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382823": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382825": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382826": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "382830": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382831": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382832": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382833": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382835": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382836": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382840": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382845": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382850": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382851": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382855": {
    "city": "Gandhi Nagar",
    "state": "Gujarat"
  },
  "382856": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382857": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382860": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382861": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382862": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382863": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382865": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382867": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "382868": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382870": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "382871": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "382875": {
    "city": "VIJAPUR",
    "state": "GUJARAT"
  },
  "383001": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383002": {
    "city": "HIMATNAGAR",
    "state": "GUJARAT"
  },
  "383006": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383010": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383030": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383110": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383120": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383201": {
    "city": "TALOD",
    "state": "GUJARAT"
  },
  "383205": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383206": {
    "city": "TALOD",
    "state": "GUJARAT"
  },
  "383207": {
    "city": "TALOD",
    "state": "GUJARAT"
  },
  "383210": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383215": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383220": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383225": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383230": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383235": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383240": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383245": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383246": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383250": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383251": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383255": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383260": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383270": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383275": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383276": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383305": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383307": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383310": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383315": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383316": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383317": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383320": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383325": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383326": {
    "city": "BAYAD",
    "state": "GUJARAT"
  },
  "383327": {
    "city": "BAYAD",
    "state": "GUJARAT"
  },
  "383330": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383331": {
    "city": "BAYAD",
    "state": "GUJARAT"
  },
  "383332": {
    "city": "BAYAD",
    "state": "GUJARAT"
  },
  "383335": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383340": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383341": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "383345": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383350": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383355": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383410": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383421": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383422": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383430": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383434": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383440": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383450": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383460": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "383462": {
    "city": "Sabarkantha",
    "state": "Gujarat"
  },
  "384001": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384002": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384003": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384004": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "384011": {
    "city": "BECHARAJI",
    "state": "GUJARAT"
  },
  "384012": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384110": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384111": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384112": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384120": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384121": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "384122": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "384130": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384131": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384132": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384133": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384140": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384151": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384152": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384153": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384154": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384160": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384165": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384170": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384171": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384172": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384174": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "384175": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "384176": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "384177": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384178": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "384205": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384206": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "384207": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "384210": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384211": {
    "city": "BECHARAJI",
    "state": "GUJARAT"
  },
  "384212": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384213": {
    "city": "BECHARAJI",
    "state": "GUJARAT"
  },
  "384215": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384220": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384221": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384222": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384225": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384226": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384227": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384228": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384229": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384230": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384231": {
    "city": "BECHARAJI",
    "state": "GUJARAT"
  },
  "384235": {
    "city": "BECHARAJI",
    "state": "GUJARAT"
  },
  "384240": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384241": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384242": {
    "city": "SHANKHESHWAR",
    "state": "GUJARAT"
  },
  "384245": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384246": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384247": {
    "city": "SHANKHESHWAR",
    "state": "GUJARAT"
  },
  "384250": {
    "city": "SHANKHESHWAR",
    "state": "GUJARAT"
  },
  "384255": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384256": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384257": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384260": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384261": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384265": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384266": {
    "city": "Patan",
    "state": "GUJARAT"
  },
  "384270": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "384271": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384272": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384273": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384274": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384275": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384276": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384277": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384278": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384280": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384285": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384290": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "384291": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384292": {
    "city": "PATAN-GJ",
    "state": "GUJARAT"
  },
  "384305": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384310": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384311": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "384312": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "384315": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384318": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "384319": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384320": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384321": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384323": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384325": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384327": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384328": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384329": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384330": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384335": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384340": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384345": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384350": {
    "city": "KHERALU",
    "state": "GUJARAT"
  },
  "384355": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384360": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384410": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384411": {
    "city": "MEHSANA",
    "state": "GUJARAT"
  },
  "384421": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384430": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384435": {
    "city": "Mahesana",
    "state": "Gujarat"
  },
  "384440": {
    "city": "KALOL",
    "state": "GUJARAT"
  },
  "385001": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385002": {
    "city": "PALANPUR",
    "state": "GUJARAT"
  },
  "385007": {
    "city": "PALANPUR",
    "state": "GUJARAT"
  },
  "385010": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385011": {
    "city": "PALANPUR",
    "state": "GUJARAT"
  },
  "385012": {
    "city": "PALANPUR",
    "state": "GUJARAT"
  },
  "385110": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385111": {
    "city": "DANTA",
    "state": "GUJARAT"
  },
  "385112": {
    "city": "DANTA",
    "state": "GUJARAT"
  },
  "385120": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385130": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385135": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385210": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385215": {
    "city": "VADGAM",
    "state": "GUJARAT"
  },
  "385310": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385315": {
    "city": "DHANERA",
    "state": "GUJARAT"
  },
  "385320": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385325": {
    "city": "DEODAR",
    "state": "GUJARAT"
  },
  "385326": {
    "city": "DEODAR",
    "state": "GUJARAT"
  },
  "385330": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385340": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "385350": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "385360": {
    "city": "Patan",
    "state": "Gujarat"
  },
  "385410": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385421": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385505": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385506": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385510": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385515": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385516": {
    "city": "PALANPUR",
    "state": "GUJARAT"
  },
  "385517": {
    "city": "PALANPUR",
    "state": "GUJARAT"
  },
  "385518": {
    "city": "PALANPUR",
    "state": "GUJARAT"
  },
  "385519": {
    "city": "PALANPUR",
    "state": "GUJARAT"
  },
  "385520": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385521": {
    "city": "PALANPUR",
    "state": "GUJARAT"
  },
  "385522": {
    "city": "PALANPUR",
    "state": "GUJARAT"
  },
  "385525": {
    "city": "PALANPUR",
    "state": "GUJARAT"
  },
  "385526": {
    "city": "PALANPUR",
    "state": "GUJARAT"
  },
  "385530": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385531": {
    "city": "SHIHORI",
    "state": "GUJARAT"
  },
  "385533": {
    "city": "SHIHORI",
    "state": "GUJARAT"
  },
  "385535": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385540": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385541": {
    "city": "DHANERA",
    "state": "GUJARAT"
  },
  "385542": {
    "city": "DEESA",
    "state": "GUJARAT"
  },
  "385543": {
    "city": "DEESA",
    "state": "GUJARAT"
  },
  "385545": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385546": {
    "city": "DHANERA",
    "state": "GUJARAT"
  },
  "385550": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385551": {
    "city": "SHIHORI",
    "state": "GUJARAT"
  },
  "385554": {
    "city": "DEODAR",
    "state": "GUJARAT"
  },
  "385555": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385560": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385565": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385566": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385570": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "385571": {
    "city": "VAV",
    "state": "GUJARAT"
  },
  "385575": {
    "city": "Banaskantha",
    "state": "Gujarat"
  },
  "387001": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387002": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387003": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387100": {
    "city": "NADIAD",
    "state": "GUJARAT"
  },
  "387110": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387111": {
    "city": "MEHMEDABAD",
    "state": "GUJARAT"
  },
  "387113": {
    "city": "NADIAD",
    "state": "GUJARAT"
  },
  "387115": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387120": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387130": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387135": {
    "city": "NADIAD",
    "state": "GUJARAT"
  },
  "387140": {
    "city": "NADIAD",
    "state": "GUJARAT"
  },
  "387210": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "387220": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "387230": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387240": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "387305": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387310": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "387315": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387320": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387325": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387330": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387331": {
    "city": "NADIAD",
    "state": "GUJARAT"
  },
  "387335": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387340": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387345": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387350": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387355": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387360": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387365": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387366": {
    "city": "KAPADWANJ",
    "state": "GUJARAT"
  },
  "387370": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387375": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387380": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387382": {
    "city": "NADIAD",
    "state": "GUJARAT"
  },
  "387385": {
    "city": "NADIAD",
    "state": "GUJARAT"
  },
  "387411": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387420": {
    "city": "NADIAD",
    "state": "GUJARAT"
  },
  "387421": {
    "city": "NADIAD",
    "state": "GUJARAT"
  },
  "387430": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387435": {
    "city": "NADIAD",
    "state": "GUJARAT"
  },
  "387510": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387515": {
    "city": "NADIAD",
    "state": "GUJARAT"
  },
  "387520": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387530": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387531": {
    "city": "NADIAD",
    "state": "GUJARAT"
  },
  "387540": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387550": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387560": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387570": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387600": {
    "city": "KAPADWANJ",
    "state": "GUJARAT"
  },
  "387610": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387620": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387630": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387635": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387640": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387650": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "387651": {
    "city": "KAPADWANJ",
    "state": "GUJARAT"
  },
  "387655": {
    "city": "KAPADWANJ",
    "state": "GUJARAT"
  },
  "387710": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "387810": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "388001": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388011": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388020": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388051": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388052": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388105": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388110": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388120": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388121": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388122": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388130": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388131": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388132": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388140": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388150": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388160": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388170": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388180": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388201": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388205": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388210": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388211": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "388212": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388213": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "388215": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388216": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "388217": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "388220": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "388225": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "388226": {
    "city": "KAPADWANJ",
    "state": "GUJARAT"
  },
  "388230": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "388235": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388236": {
    "city": "BALASINOR",
    "state": "GUJARAT"
  },
  "388238": {
    "city": "BALASINOR",
    "state": "GUJARAT"
  },
  "388239": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "388240": {
    "city": "BORSAD",
    "state": "GUJARAT"
  },
  "388244": {
    "city": "BALASINOR",
    "state": "GUJARAT"
  },
  "388245": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "388250": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "388254": {
    "city": "BALASINOR",
    "state": "GUJARAT"
  },
  "388255": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "388256": {
    "city": "BALASINOR",
    "state": "GUJARAT"
  },
  "388257": {
    "city": "BALASINOR",
    "state": "GUJARAT"
  },
  "388258": {
    "city": "BALASINOR",
    "state": "GUJARAT"
  },
  "388259": {
    "city": "LUNAWADA",
    "state": "GUJARAT"
  },
  "388260": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "388261": {
    "city": "LUNAWADA",
    "state": "GUJARAT"
  },
  "388262": {
    "city": "LUNAWADA",
    "state": "GUJARAT"
  },
  "388265": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "388266": {
    "city": "BALASINOR",
    "state": "GUJARAT"
  },
  "388267": {
    "city": "BALASINOR",
    "state": "GUJARAT"
  },
  "388270": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "388275": {
    "city": "BALASINOR",
    "state": "GUJARAT"
  },
  "388305": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388306": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388307": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388308": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388310": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388315": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388320": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388321": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388325": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388330": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388335": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388336": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388340": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388345": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388350": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388355": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388360": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388365": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388370": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388410": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "388421": {
    "city": "Kheda",
    "state": "Gujarat"
  },
  "388425": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388430": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388435": {
    "city": "TARAPUR",
    "state": "GUJARAT"
  },
  "388440": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388445": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388450": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388460": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388461": {
    "city": "TARAPUR",
    "state": "GUJARAT"
  },
  "388465": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388466": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388470": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388480": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388485": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388510": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388515": {
    "city": "BORSAD",
    "state": "GUJARAT"
  },
  "388520": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388530": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388531": {
    "city": "BORSAD",
    "state": "GUJARAT"
  },
  "388540": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388543": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388544": {
    "city": "ANAND",
    "state": "GUJARAT"
  },
  "388545": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388550": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388555": {
    "city": "KHAMBHAT",
    "state": "GUJARAT"
  },
  "388556": {
    "city": "KHAMBHAT",
    "state": "GUJARAT"
  },
  "388560": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388570": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388580": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388585": {
    "city": "KHAMBHAT",
    "state": "GUJARAT"
  },
  "388590": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388600": {
    "city": "KHAMBHAT",
    "state": "GUJARAT"
  },
  "388610": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388620": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388625": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388630": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388640": {
    "city": "Anand",
    "state": "Gujarat"
  },
  "388641": {
    "city": "KHAMBHAT",
    "state": "GUJARAT"
  },
  "388710": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "388711": {
    "city": "KAPADWANJ",
    "state": "GUJARAT"
  },
  "388712": {
    "city": "KAPADWANJ",
    "state": "GUJARAT"
  },
  "388713": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "388714": {
    "city": "GODHRA",
    "state": "GUJARAT"
  },
  "388715": {
    "city": "GODHRA",
    "state": "GUJARAT"
  },
  "388716": {
    "city": "GODHRA",
    "state": "GUJARAT"
  },
  "388888": {
    "city": "GODHRA",
    "state": "GUJARAT"
  },
  "389001": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389002": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389110": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389111": {
    "city": "SANTRAMPUR",
    "state": "GUJARAT"
  },
  "389115": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389120": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389121": {
    "city": "GODHRA",
    "state": "GUJARAT"
  },
  "389122": {
    "city": "GODHRA",
    "state": "GUJARAT"
  },
  "389123": {
    "city": "GODHRA",
    "state": "GUJARAT"
  },
  "389130": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389135": {
    "city": "LIMKHEDA",
    "state": "GUJARAT"
  },
  "389140": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389145": {
    "city": "LIMKHEDA",
    "state": "GUJARAT"
  },
  "389146": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389150": {
    "city": "DAHOD",
    "state": "GUJARAT"
  },
  "389151": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389152": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389154": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389155": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389156": {
    "city": "DAHOD",
    "state": "GUJARAT"
  },
  "389157": {
    "city": "DAHOD",
    "state": "GUJARAT"
  },
  "389158": {
    "city": "DAHOD",
    "state": "GUJARAT"
  },
  "389160": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389170": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389172": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389175": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389180": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389190": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389210": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389220": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389230": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389232": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389235": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389240": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389250": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389260": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389265": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389310": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389320": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389322": {
    "city": "HALOL",
    "state": "GUJARAT"
  },
  "389325": {
    "city": "HALOL",
    "state": "GUJARAT"
  },
  "389330": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389340": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389341": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389342": {
    "city": "LIMKHEDA",
    "state": "GUJARAT"
  },
  "389343": {
    "city": "LIMKHEDA",
    "state": "GUJARAT"
  },
  "389344": {
    "city": "LIMKHEDA",
    "state": "GUJARAT"
  },
  "389345": {
    "city": "GOGHOMBA",
    "state": "GUJARAT"
  },
  "389346": {
    "city": "LIMKHEDA",
    "state": "GUJARAT"
  },
  "389347": {
    "city": "HALOL",
    "state": "GUJARAT"
  },
  "389348": {
    "city": "HALOL",
    "state": "GUJARAT"
  },
  "389350": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389351": {
    "city": "HALOL",
    "state": "GUJARAT"
  },
  "389352": {
    "city": "HALOL",
    "state": "GUJARAT"
  },
  "389355": {
    "city": "HALOL",
    "state": "GUJARAT"
  },
  "389360": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389365": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389370": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "389380": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389382": {
    "city": "Dahod",
    "state": "Gujarat"
  },
  "389390": {
    "city": "Panch Mahals",
    "state": "Gujarat"
  },
  "390000": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "390001": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390002": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390003": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390004": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390005": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "390006": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390007": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390008": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390009": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390010": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390011": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390012": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390013": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390014": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390015": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "390016": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390017": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390018": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390019": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390020": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390021": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390022": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390023": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390024": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390025": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "390034": {
    "city": "Vadodara",
    "state": "GUJARAT"
  },
  "390915": {
    "city": "AHMEDABAD",
    "state": "GUJARAT"
  },
  "391101": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391105": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391107": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391108": {
    "city": "DABHOI",
    "state": "GUJARAT"
  },
  "391110": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391111": {
    "city": "DABHOI",
    "state": "GUJARAT"
  },
  "391115": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391116": {
    "city": "DABHOI",
    "state": "GUJARAT"
  },
  "391120": {
    "city": "Narmada",
    "state": "Gujarat"
  },
  "391121": {
    "city": "Narmada",
    "state": "Gujarat"
  },
  "391125": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391126": {
    "city": "JETPUR-PAVI",
    "state": "GUJARAT"
  },
  "391130": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391135": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391136": {
    "city": "JETPUR-PAVI",
    "state": "GUJARAT"
  },
  "391137": {
    "city": "NASVADI",
    "state": "GUJARAT"
  },
  "391140": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391141": {
    "city": "NASVADI",
    "state": "GUJARAT"
  },
  "391142": {
    "city": "JETPUR-PAVI",
    "state": "GUJARAT"
  },
  "391145": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391146": {
    "city": "JETPUR-PAVI",
    "state": "GUJARAT"
  },
  "391150": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391151": {
    "city": "NASVADI",
    "state": "GUJARAT"
  },
  "391152": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391155": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391156": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391157": {
    "city": "JETPUR-PAVI",
    "state": "GUJARAT"
  },
  "391160": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391165": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391168": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391169": {
    "city": "KAVANT",
    "state": "GUJARAT"
  },
  "391170": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391175": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391210": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391220": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391230": {
    "city": "KARJAN",
    "state": "GUJARAT"
  },
  "391240": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391241": {
    "city": "KARJAN",
    "state": "GUJARAT"
  },
  "391242": {
    "city": "KARJAN",
    "state": "GUJARAT"
  },
  "391243": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391244": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391245": {
    "city": "KARJAN",
    "state": "GUJARAT"
  },
  "391250": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391310": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391320": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391330": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391340": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391345": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391346": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391347": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "391350": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391351": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "391352": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "391353": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "391354": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "391380": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "391410": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391411": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "391421": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391430": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391431": {
    "city": "KARJAN",
    "state": "GUJARAT"
  },
  "391440": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391441": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "391442": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "391443": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "391445": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391447": {
    "city": "HALOL",
    "state": "GUJARAT"
  },
  "391450": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391460": {
    "city": "JAMBUSAR",
    "state": "GUJARAT"
  },
  "391461": {
    "city": "JAMBUSAR",
    "state": "GUJARAT"
  },
  "391510": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391520": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391530": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391535": {
    "city": "HALOL",
    "state": "GUJARAT"
  },
  "391740": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391742": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "391745": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391750": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391760": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391761": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391770": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391773": {
    "city": "BARODA",
    "state": "GUJARAT"
  },
  "391774": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391775": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391776": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391780": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "391810": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "391815": {
    "city": "JAMBUSAR",
    "state": "GUJARAT"
  },
  "391816": {
    "city": "JAMBUSAR",
    "state": "GUJARAT"
  },
  "391817": {
    "city": "JAMBUSAR",
    "state": "GUJARAT"
  },
  "391818": {
    "city": "RAJPIPLA",
    "state": "GUJARAT"
  },
  "392001": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392002": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392003": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392004": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392005": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392011": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392012": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392013": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392014": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392015": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392020": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392021": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392025": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392026": {
    "city": "VYARA",
    "state": "GUJARAT"
  },
  "392030": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392031": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392035": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392040": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392105": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392110": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "392111": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392115": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392130": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392135": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392140": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392150": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392153": {
    "city": "MANGAROL",
    "state": "GUJARAT"
  },
  "392155": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392160": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "392161": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392162": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392163": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "392165": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392170": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392180": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392210": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392215": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392220": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392221": {
    "city": "KARJAN",
    "state": "GUJARAT"
  },
  "392230": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392240": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "392310": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "393001": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "393002": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "393003": {
    "city": "ANKLESHWAR",
    "state": "GUJARAT"
  },
  "393004": {
    "city": "ANKLESHWAR",
    "state": "GUJARAT"
  },
  "393005": {
    "city": "ANKLESHWAR",
    "state": "GUJARAT"
  },
  "393006": {
    "city": "ANKLESHWAR",
    "state": "GUJARAT"
  },
  "393010": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "393016": {
    "city": "ANKLESHWAR",
    "state": "GUJARAT"
  },
  "393017": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "393018": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "393020": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "393021": {
    "city": "ANKLESHWAR",
    "state": "GUJARAT"
  },
  "393025": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "393030": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "393035": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "393040": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "393041": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "393050": {
    "city": "Narmada",
    "state": "Gujarat"
  },
  "393105": {
    "city": "Vadodara",
    "state": "Gujarat"
  },
  "393107": {
    "city": "DABHOI",
    "state": "GUJARAT"
  },
  "393110": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "393111": {
    "city": "NETRANG",
    "state": "GUJARAT"
  },
  "393115": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "393120": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "393125": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "393130": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "393131": {
    "city": "NETRANG",
    "state": "GUJARAT"
  },
  "393133": {
    "city": "NAVSARI",
    "state": "GUJARAT"
  },
  "393135": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "393140": {
    "city": "Narmada",
    "state": "Gujarat"
  },
  "393145": {
    "city": "Narmada",
    "state": "Gujarat"
  },
  "393150": {
    "city": "Narmada",
    "state": "Gujarat"
  },
  "393151": {
    "city": "Narmada",
    "state": "Gujarat"
  },
  "393155": {
    "city": "Narmada",
    "state": "Gujarat"
  },
  "393236": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "393340": {
    "city": "MANDVI",
    "state": "GUJARAT"
  },
  "394010": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "394101": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394105": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394107": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394110": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394111": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394114": {
    "city": "VYARA",
    "state": "GUJARAT"
  },
  "394115": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "394116": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "394120": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394125": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394130": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394140": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394150": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394155": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394160": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394163": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394170": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394180": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394185": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394190": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394210": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394211": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "394212": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "394218": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "394220": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "394221": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394230": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394235": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394240": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394241": {
    "city": "BARDOLI",
    "state": "GUJARAT"
  },
  "394242": {
    "city": "BARDOLI",
    "state": "GUJARAT"
  },
  "394243": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "394244": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "394245": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394246": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394248": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394250": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394265": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "394270": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394296": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "394305": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394307": {
    "city": "VALSAD",
    "state": "GUJARAT"
  },
  "394310": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394311": {
    "city": "UCHCHHAL",
    "state": "GUJARAT"
  },
  "394315": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394317": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394320": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394325": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394326": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394327": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394330": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394335": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394340": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394345": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394350": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394352": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394355": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394360": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394363": {
    "city": "UMARPADA",
    "state": "GUJARAT"
  },
  "394364": {
    "city": "UMARPADA",
    "state": "GUJARAT"
  },
  "394365": {
    "city": "Tapi",
    "state": "Gujarat"
  },
  "394370": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394375": {
    "city": "Tapi",
    "state": "Gujarat"
  },
  "394378": {
    "city": "BANSDA",
    "state": "GUJARAT"
  },
  "394380": {
    "city": "Tapi",
    "state": "Gujarat"
  },
  "394405": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394410": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394421": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394430": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394440": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394444": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "394445": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394510": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394515": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394516": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394517": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394518": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394520": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394530": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394540": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394541": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394550": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394601": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394602": {
    "city": "BARDOLI",
    "state": "GUJARAT"
  },
  "394608": {
    "city": "DEDIAPADA",
    "state": "GUJARAT"
  },
  "394620": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394630": {
    "city": "Tapi",
    "state": "Gujarat"
  },
  "394631": {
    "city": "ANKLESHWAR",
    "state": "GUJARAT"
  },
  "394632": {
    "city": "UMBERGAON",
    "state": "GUJARAT"
  },
  "394633": {
    "city": "Tapi",
    "state": "Gujarat"
  },
  "394635": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394640": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394641": {
    "city": "Tapi",
    "state": "Gujarat"
  },
  "394650": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394651": {
    "city": "Tapi",
    "state": "Gujarat"
  },
  "394652": {
    "city": "Tapi",
    "state": "Gujarat"
  },
  "394655": {
    "city": "Tapi",
    "state": "Gujarat"
  },
  "394660": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394664": {
    "city": "VYARA",
    "state": "GUJARAT"
  },
  "394670": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394675": {
    "city": "NAVSARI",
    "state": "GUJARAT"
  },
  "394680": {
    "city": "Tapi",
    "state": "Gujarat"
  },
  "394690": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394710": {
    "city": "The Dangs",
    "state": "Gujarat"
  },
  "394715": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "394716": {
    "city": "The Dangs",
    "state": "Gujarat"
  },
  "394720": {
    "city": "The Dangs",
    "state": "Gujarat"
  },
  "394730": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "394810": {
    "city": "Bharuch",
    "state": "Gujarat"
  },
  "395001": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395002": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395003": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395004": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395005": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395006": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395007": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395008": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395009": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395010": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395011": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395012": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395013": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395016": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "395017": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395018": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "395021": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "395023": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "395163": {
    "city": "MANDVI",
    "state": "GUJARAT"
  },
  "395210": {
    "city": "SURAT",
    "state": "GUJARAT"
  },
  "395345": {
    "city": "BARDOLI",
    "state": "GUJARAT"
  },
  "395375": {
    "city": "BARDOLI",
    "state": "GUJARAT"
  },
  "395620": {
    "city": "BARDOLI",
    "state": "GUJARAT"
  },
  "395650": {
    "city": "VYARA",
    "state": "GUJARAT"
  },
  "396001": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396002": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396006": {
    "city": "VALSAD",
    "state": "GUJARAT"
  },
  "396007": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396015": {
    "city": "VALSAD",
    "state": "GUJARAT"
  },
  "396020": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396021": {
    "city": "VALSAD",
    "state": "GUJARAT"
  },
  "396025": {
    "city": "BANSDA",
    "state": "GUJARAT"
  },
  "396030": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396031": {
    "city": "VALSAD",
    "state": "GUJARAT"
  },
  "396035": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396040": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396041": {
    "city": "JAMBUSAR",
    "state": "GUJARAT"
  },
  "396042": {
    "city": "JAMBUSAR",
    "state": "GUJARAT"
  },
  "396045": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396050": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396051": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396055": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396060": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396065": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396067": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396068": {
    "city": "BANSDA",
    "state": "GUJARAT"
  },
  "396091": {
    "city": "BANSDA",
    "state": "GUJARAT"
  },
  "396101": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "396105": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396106": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "396107": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "396108": {
    "city": "BILIMORA",
    "state": "GUJARAT"
  },
  "396110": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396112": {
    "city": "BILIMORA",
    "state": "GUJARAT"
  },
  "396115": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396117": {
    "city": "BANSDA",
    "state": "GUJARAT"
  },
  "396120": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396125": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396126": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396130": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396135": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396140": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396142": {
    "city": "BILIMORA",
    "state": "GUJARAT"
  },
  "396145": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396150": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396155": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396156": {
    "city": "UMBERGAON",
    "state": "GUJARAT"
  },
  "396165": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396170": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396171": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396175": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "396180": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396185": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396191": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396192": {
    "city": "VAPI",
    "state": "DADRA AND NAGAR HAVELI"
  },
  "396193": {
    "city": "Dadra And Nagar Haveli",
    "state": "Dadra And Nagar Haveli"
  },
  "396194": {
    "city": "SILVASSA",
    "state": "DADRA AND NAGAR HAVELI"
  },
  "396195": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396196": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "396197": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "396200": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "396201": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "396202": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "396209": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "396210": {
    "city": "Daman",
    "state": "Daman And Diu"
  },
  "396211": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "396215": {
    "city": "Daman",
    "state": "Daman And Diu"
  },
  "396217": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "396220": {
    "city": "Daman",
    "state": "Daman And Diu"
  },
  "396223": {
    "city": "VAPI",
    "state": "GUJARAT"
  },
  "396228": {
    "city": "SILVASSA",
    "state": "DADRA AND NAGAR HAVELI"
  },
  "396230": {
    "city": "Dadra And Nagar Haveli",
    "state": "Dadra And Nagar Haveli"
  },
  "396235": {
    "city": "Dadra And Nagar Haveli",
    "state": "Dadra And Nagar Haveli"
  },
  "396236": {
    "city": "SILVASSA",
    "state": "DADRA AND NAGAR HAVELI"
  },
  "396238": {
    "city": "SILVASSA",
    "state": "DADRA AND NAGAR HAVELI"
  },
  "396240": {
    "city": "Dadra And Nagar Haveli",
    "state": "Dadra And Nagar Haveli"
  },
  "396245": {
    "city": "SILVASSA",
    "state": "DADRA AND NAGAR HAVELI"
  },
  "396250": {
    "city": "SILVASSA",
    "state": "DADRA AND NAGAR HAVELI"
  },
  "396301": {
    "city": "BILIMORA",
    "state": "GUJARAT"
  },
  "396310": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396321": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396325": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396330": {
    "city": "BILIMORA",
    "state": "GUJARAT"
  },
  "396331": {
    "city": "BILIMORA",
    "state": "GUJARAT"
  },
  "396340": {
    "city": "BILIMORA",
    "state": "GUJARAT"
  },
  "396350": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396360": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396370": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396375": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396380": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396385": {
    "city": "Valsad",
    "state": "Gujarat"
  },
  "396400": {
    "city": "BILIMORA",
    "state": "GUJARAT"
  },
  "396403": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396406": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396409": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396412": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396415": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396418": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396421": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396424": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396425": {
    "city": "NAVSARI",
    "state": "GUJARAT"
  },
  "396427": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396430": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396431": {
    "city": "BILIMORA",
    "state": "GUJARAT"
  },
  "396433": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396436": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396439": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396440": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396443": {
    "city": "NAVSARI",
    "state": "GUJARAT"
  },
  "396445": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396450": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396452": {
    "city": "NAVSARI",
    "state": "GUJARAT"
  },
  "396460": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396463": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396466": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396469": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396472": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396475": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396480": {
    "city": "NAVSARI",
    "state": "GUJARAT"
  },
  "396510": {
    "city": "Surat",
    "state": "Gujarat"
  },
  "396516": {
    "city": "MANGAROL",
    "state": "GUJARAT"
  },
  "396521": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396523": {
    "city": "BILIMORA",
    "state": "GUJARAT"
  },
  "396525": {
    "city": "BILIMORA",
    "state": "GUJARAT"
  },
  "396526": {
    "city": "BILIMORA",
    "state": "GUJARAT"
  },
  "396527": {
    "city": "JAMBUSAR",
    "state": "GUJARAT"
  },
  "396528": {
    "city": "JAMBUSAR",
    "state": "GUJARAT"
  },
  "396530": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396540": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396560": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396562": {
    "city": "BHARUCH",
    "state": "GUJARAT"
  },
  "396570": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396571": {
    "city": "BANSDA",
    "state": "GUJARAT"
  },
  "396575": {
    "city": "BANSDA",
    "state": "GUJARAT"
  },
  "396580": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "396590": {
    "city": "Navsari",
    "state": "Gujarat"
  },
  "399999": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400000": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400001": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400002": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400003": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400004": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400005": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400006": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400007": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400008": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400009": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400010": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400011": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400012": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400013": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400014": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400015": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400016": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400017": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400018": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400019": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400020": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400021": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400022": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400023": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400024": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400025": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400026": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400027": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400028": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400029": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400030": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400031": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400032": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400033": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400034": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400035": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400036": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400037": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400038": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400039": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400040": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400041": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400042": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400043": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400044": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400045": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400046": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400047": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400048": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400049": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400050": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400051": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400052": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400053": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400054": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400055": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400056": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400057": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400058": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400059": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400060": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400061": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400062": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400063": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400064": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400065": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400066": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400067": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400068": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400069": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400070": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400071": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400072": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400073": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400074": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400075": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400076": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400077": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400078": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400079": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400080": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400081": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400082": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400083": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400084": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400085": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400086": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400087": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400088": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400089": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400090": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400091": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400092": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400093": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400094": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400095": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400096": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400097": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400098": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400099": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400100": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400101": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400102": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400103": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400104": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400105": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "400106": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400107": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400108": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400109": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400110": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400111": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400112": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400113": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400114": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400125": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400162": {
    "city": "MUMBRA",
    "state": "MAHARASHTRA"
  },
  "400167": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400201": {
    "city": "THANE",
    "state": "MAHARASHTRA"
  },
  "400202": {
    "city": "THANE",
    "state": "MAHARASHTRA"
  },
  "400206": {
    "city": "THANE",
    "state": "MAHARASHTRA"
  },
  "400207": {
    "city": "THANE",
    "state": "MAHARASHTRA"
  },
  "400208": {
    "city": "THANE",
    "state": "MAHARASHTRA"
  },
  "400209": {
    "city": "THANE",
    "state": "MAHARASHTRA"
  },
  "400210": {
    "city": "THANE",
    "state": "MAHARASHTRA"
  },
  "400218": {
    "city": "KAMOTHE",
    "state": "MAHARASHTRA"
  },
  "400401": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400410": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400547": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400601": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400602": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400603": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400604": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400605": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400606": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400607": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400608": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400609": {
    "city": "THANE (W)",
    "state": "MAHARASHTRA"
  },
  "400610": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400611": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400612": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400613": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400614": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400615": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400617": {
    "city": "THANE",
    "state": "MAHARASHTRA"
  },
  "400700": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400701": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400702": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400703": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400704": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400705": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400706": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400707": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "400708": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400709": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400710": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400713": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "400806": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "400901": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "401100": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "401101": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401102": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401103": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401104": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "401105": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401106": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401107": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401200": {
    "city": "VASAI",
    "state": "MAHARASHTRA"
  },
  "401201": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401202": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401203": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401204": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401205": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "401206": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401207": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401208": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401209": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401210": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "401214": {
    "city": "VASAI",
    "state": "MAHARASHTRA"
  },
  "401301": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401302": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401303": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401304": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401305": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401400": {
    "city": "PALGHAR",
    "state": "MAHARASHTRA"
  },
  "401401": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401402": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401403": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401404": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401405": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401406": {
    "city": "PALGHAR",
    "state": "MAHARASHTRA"
  },
  "401407": {
    "city": "PALGHAR",
    "state": "MAHARASHTRA"
  },
  "401501": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401502": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401503": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401504": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401505": {
    "city": "PALGHAR",
    "state": "MAHARASHTRA"
  },
  "401506": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401601": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401602": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401603": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401604": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401605": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401606": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401607": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401608": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401609": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401610": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401616": {
    "city": "TALASARI",
    "state": "MAHARASHTRA"
  },
  "401701": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401702": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401703": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "401706": {
    "city": "TALASARI",
    "state": "MAHARASHTRA"
  },
  "402100": {
    "city": "ROHA",
    "state": "MAHARASHTRA"
  },
  "402101": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402102": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402103": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402104": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402105": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402106": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402107": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402108": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402109": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402110": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402111": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402112": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402113": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402114": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402115": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402116": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402117": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402118": {
    "city": "MANGAON",
    "state": "MAHARASHTRA"
  },
  "402120": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402121": {
    "city": "MULSHI",
    "state": "MAHARASHTRA"
  },
  "402122": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402123": {
    "city": "MANGAON",
    "state": "MAHARASHTRA"
  },
  "402124": {
    "city": "ROHA",
    "state": "MAHARASHTRA"
  },
  "402125": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402126": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402201": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402202": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402203": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402204": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402205": {
    "city": "ALIBAGH",
    "state": "MAHARASHTRA"
  },
  "402206": {
    "city": "ALIBAGH",
    "state": "MAHARASHTRA"
  },
  "402207": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402208": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402209": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402225": {
    "city": "ALIBAGH",
    "state": "MAHARASHTRA"
  },
  "402301": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402302": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402303": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402304": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402305": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402306": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402307": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402308": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402309": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402401": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402402": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402403": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402404": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "402405": {
    "city": "SRIVARDHAN",
    "state": "MAHARASHTRA"
  },
  "402406": {
    "city": "MURUD",
    "state": "MAHARASHTRA"
  },
  "402416": {
    "city": "SRIVARDHAN",
    "state": "MAHARASHTRA"
  },
  "402601": {
    "city": "AHMEDNAGAR",
    "state": "MAHARASHTRA"
  },
  "403001": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403002": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403003": {
    "city": "PANAJI",
    "state": "GOA"
  },
  "403004": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403005": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403006": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403101": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403102": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403103": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403104": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403105": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403106": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403107": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403108": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403109": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403110": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403111": {
    "city": "PANJIM",
    "state": "GOA"
  },
  "403112": {
    "city": "PANJIM",
    "state": "GOA"
  },
  "403114": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403115": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403201": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403202": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403203": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403204": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403206": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403325": {
    "city": "GOA",
    "state": "GOA"
  },
  "403401": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403402": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403403": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403404": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403405": {
    "city": "SALCETE",
    "state": "GOA"
  },
  "403406": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403407": {
    "city": "SALCETE",
    "state": "GOA"
  },
  "403408": {
    "city": "PONDA",
    "state": "GOA"
  },
  "403409": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403410": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403501": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403502": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403503": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403504": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403505": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403506": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403507": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403508": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403509": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403510": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403511": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403512": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403513": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403514": {
    "city": "PANAJI",
    "state": "GOA"
  },
  "403515": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403516": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403517": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403518": {
    "city": "PANAJI",
    "state": "GOA"
  },
  "403519": {
    "city": "PANAJI",
    "state": "GOA"
  },
  "403520": {
    "city": "MAPUSA",
    "state": "GOA"
  },
  "403521": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403523": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403524": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403526": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403527": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403529": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403530": {
    "city": "North Goa",
    "state": "Goa"
  },
  "403531": {
    "city": "MAPUSA",
    "state": "GOA"
  },
  "403601": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403602": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403603": {
    "city": "QUEPEM",
    "state": "GOA"
  },
  "403604": {
    "city": "SALCETE",
    "state": "GOA"
  },
  "403701": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403702": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403703": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403704": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403705": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403706": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403707": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403708": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403709": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403710": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403711": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403712": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403713": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403714": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403715": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403716": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403717": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403718": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403719": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403720": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403721": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403722": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403723": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403724": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403725": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403726": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403727": {
    "city": "VERNA",
    "state": "GOA"
  },
  "403728": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403729": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403730": {
    "city": "MARGAO",
    "state": "GOA"
  },
  "403731": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403801": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403802": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403803": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403804": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403806": {
    "city": "South Goa",
    "state": "Goa"
  },
  "403808": {
    "city": "VERNA",
    "state": "GOA"
  },
  "404001": {
    "city": "Panjim",
    "state": "GOA"
  },
  "404100": {
    "city": "AHMEDNAGAR",
    "state": "MAHARASHTRA"
  },
  "404220": {
    "city": "AHMEDNAGAR",
    "state": "MAHARASHTRA"
  },
  "404221": {
    "city": "AHMEDNAGAR",
    "state": "MAHARASHTRA"
  },
  "404404": {
    "city": "AHMEDNAGAR",
    "state": "MAHARASHTRA"
  },
  "404411": {
    "city": "AHMEDNAGAR",
    "state": "MAHARASHTRA"
  },
  "404502": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "407001": {
    "city": "NAGPUR",
    "state": "MAHARASHTRA"
  },
  "410000": {
    "city": "PUNE WAREHOUSE",
    "state": "MAHARASHTRA"
  },
  "410005": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "410062": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "410101": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "410102": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "410105": {
    "city": "KARJAT - RAIGARH",
    "state": "MAHARASHTRA"
  },
  "410107": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "410200": {
    "city": "KARJAT - RAIGARH",
    "state": "MAHARASHTRA"
  },
  "410201": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "410202": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "410203": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "410204": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "410205": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "410206": {
    "city": "Raigarh",
    "state": "Maharashtra"
  },
  "410207": {
    "city": "Raigarh",
    "state": "Maharashtra"
  },
  "410208": {
    "city": "Raigarh",
    "state": "Maharashtra"
  },
  "410209": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "410210": {
    "city": "Raigarh",
    "state": "Maharashtra"
  },
  "410211": {
    "city": "PANVEL",
    "state": "MAHARASHTRA"
  },
  "410213": {
    "city": "PANVEL",
    "state": "MAHARASHTRA"
  },
  "410216": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "410217": {
    "city": "NAVI MUMBAI",
    "state": "MAHARASHTRA"
  },
  "410218": {
    "city": "Raigarh",
    "state": "Maharashtra"
  },
  "410219": {
    "city": "KAMOTHE",
    "state": "MAHARASHTRA"
  },
  "410220": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "410221": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "410222": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "410301": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410302": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410303": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "410401": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410402": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410403": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410405": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410406": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410410": {
    "city": "KAMSHETH",
    "state": "MAHARASHTRA"
  },
  "410501": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410502": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410503": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410504": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410505": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410506": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410507": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410508": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410509": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410510": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410511": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410512": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410513": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410514": {
    "city": "JUNNAR",
    "state": "MAHARASHTRA"
  },
  "410515": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410516": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "410520": {
    "city": "AMBEGOAN",
    "state": "MAHARASHTRA"
  },
  "410613": {
    "city": "NAVI MUMBAI",
    "state": "MAHARASHTRA"
  },
  "410615": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "410707": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "410708": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411000": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411001": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411002": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411003": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411004": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411005": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411006": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411007": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411008": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411009": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411010": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411011": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411012": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411013": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411014": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411015": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411016": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411017": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411018": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411019": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411020": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411021": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411022": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411023": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411024": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411025": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411026": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411027": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411028": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411029": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411030": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411031": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411032": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411033": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411034": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411035": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411036": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411037": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411038": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411039": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411040": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411041": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411042": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411043": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411044": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411045": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411046": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411047": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411048": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411049": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411050": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411051": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411052": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411053": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411054": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411055": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411056": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411057": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411058": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411060": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411061": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411062": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411067": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411068": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "411099": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411100": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411105": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411107": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411111": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411125": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411201": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411208": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411220": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411230": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411406": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411412": {
    "city": "ALEPHATA",
    "state": "MAHARASHTRA"
  },
  "411501": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "411925": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "412001": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "412042": {
    "city": "MULSHI",
    "state": "MAHARASHTRA"
  },
  "412101": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412102": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412103": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412104": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412105": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412106": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412107": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412108": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412109": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412110": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412111": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "412112": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412113": {
    "city": "TALEGAON",
    "state": "MAHARASHTRA"
  },
  "412114": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "412115": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412120": {
    "city": "MULSHI",
    "state": "MAHARASHTRA"
  },
  "412201": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412202": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412203": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412204": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412205": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412206": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412207": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412208": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412209": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412210": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412211": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412212": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412213": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412214": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412215": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412216": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412217": {
    "city": "WAGHOLI",
    "state": "MAHARASHTRA"
  },
  "412218": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412219": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412220": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412223": {
    "city": "RANJANGAON",
    "state": "MAHARASHTRA"
  },
  "412224": {
    "city": "RANJANGAON",
    "state": "MAHARASHTRA"
  },
  "412225": {
    "city": "RANJANGAON",
    "state": "MAHARASHTRA"
  },
  "412237": {
    "city": "SHIRUR",
    "state": "MAHARASHTRA"
  },
  "412301": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412302": {
    "city": "SASWAD",
    "state": "MAHARASHTRA"
  },
  "412303": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412304": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412305": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412306": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412307": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412308": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412309": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "412310": {
    "city": "SHIRWAL",
    "state": "MAHARASHTRA"
  },
  "412311": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412312": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412401": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412402": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412403": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412404": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412405": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412406": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412407": {
    "city": "AMBEGOAN",
    "state": "MAHARASHTRA"
  },
  "412408": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412409": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412410": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412411": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412412": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "412413": {
    "city": "JUNNAR",
    "state": "MAHARASHTRA"
  },
  "412415": {
    "city": "JUNNAR",
    "state": "MAHARASHTRA"
  },
  "412425": {
    "city": "OTUR",
    "state": "MAHARASHTRA"
  },
  "412501": {
    "city": "SHIRWAL",
    "state": "MAHARASHTRA"
  },
  "412502": {
    "city": "SHIRWAL",
    "state": "MAHARASHTRA"
  },
  "412507": {
    "city": "SHIRWAL",
    "state": "MAHARASHTRA"
  },
  "412801": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "412802": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "412803": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "412804": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "412805": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "412806": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "412903": {
    "city": "WAI",
    "state": "MAHARASHTRA"
  },
  "413001": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413002": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413003": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413004": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413005": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413006": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413007": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413008": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413009": {
    "city": "SOLAPUR",
    "state": "MAHARASHTRA"
  },
  "413010": {
    "city": "SOLAPUR",
    "state": "MAHARASHTRA"
  },
  "413011": {
    "city": "TEMBURNI",
    "state": "MAHARASHTRA"
  },
  "413012": {
    "city": "SONARI MH",
    "state": "MAHARASHTRA"
  },
  "413013": {
    "city": "SONARI MH",
    "state": "MAHARASHTRA"
  },
  "413024": {
    "city": "SONARI MH",
    "state": "MAHARASHTRA"
  },
  "413025": {
    "city": "SONARI MH",
    "state": "MAHARASHTRA"
  },
  "413026": {
    "city": "SONARI MH",
    "state": "MAHARASHTRA"
  },
  "413101": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413102": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413103": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413104": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413105": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413106": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413107": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413108": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413109": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413110": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413111": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413112": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413113": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413114": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413115": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413116": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413117": {
    "city": "BARAMATI",
    "state": "MAHARASHTRA"
  },
  "413118": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413119": {
    "city": "MALSIRAS",
    "state": "MAHARASHTRA"
  },
  "413120": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413121": {
    "city": "INDAPUR",
    "state": "MAHARASHTRA"
  },
  "413122": {
    "city": "BEED",
    "state": "MAHARASHTRA"
  },
  "413123": {
    "city": "INDAPUR",
    "state": "MAHARASHTRA"
  },
  "413124": {
    "city": "INDAPUR",
    "state": "MAHARASHTRA"
  },
  "413125": {
    "city": "BARAMATI",
    "state": "MAHARASHTRA"
  },
  "413126": {
    "city": "BARAMATI",
    "state": "MAHARASHTRA"
  },
  "413127": {
    "city": "BARAMATI",
    "state": "MAHARASHTRA"
  },
  "413128": {
    "city": "BARAMATI",
    "state": "MAHARASHTRA"
  },
  "413129": {
    "city": "BARAMATI",
    "state": "MAHARASHTRA"
  },
  "413130": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413132": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413133": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413137": {
    "city": "INDAPUR",
    "state": "MAHARASHTRA"
  },
  "413138": {
    "city": "INDAPUR",
    "state": "MAHARASHTRA"
  },
  "413196": {
    "city": "INDAPUR",
    "state": "MAHARASHTRA"
  },
  "413197": {
    "city": "BARAMATI",
    "state": "MAHARASHTRA"
  },
  "413198": {
    "city": "INDAPUR",
    "state": "MAHARASHTRA"
  },
  "413201": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413202": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413203": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413204": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413205": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413206": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413207": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "413208": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413209": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413210": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413211": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413212": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413213": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413214": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413215": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413216": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413217": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413218": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413219": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413220": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413221": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413222": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413223": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413224": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413225": {
    "city": "SOLAPUR",
    "state": "MAHARASHTRA"
  },
  "413226": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413227": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413228": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413229": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "413230": {
    "city": "JAMKHED",
    "state": "MAHARASHTRA"
  },
  "413231": {
    "city": "JAMKHED",
    "state": "MAHARASHTRA"
  },
  "413232": {
    "city": "JAMKHED",
    "state": "MAHARASHTRA"
  },
  "413233": {
    "city": "JAMKHED",
    "state": "MAHARASHTRA"
  },
  "413234": {
    "city": "JAMKHED",
    "state": "MAHARASHTRA"
  },
  "413235": {
    "city": "JAMKHED",
    "state": "MAHARASHTRA"
  },
  "413236": {
    "city": "JAMKHED",
    "state": "MAHARASHTRA"
  },
  "413237": {
    "city": "JAMKHED",
    "state": "MAHARASHTRA"
  },
  "413238": {
    "city": "JAMKHED",
    "state": "MAHARASHTRA"
  },
  "413239": {
    "city": "JAMKHED",
    "state": "MAHARASHTRA"
  },
  "413240": {
    "city": "MOHOL",
    "state": "MAHARASHTRA"
  },
  "413241": {
    "city": "MOHOL",
    "state": "MAHARASHTRA"
  },
  "413242": {
    "city": "MOHOL",
    "state": "MAHARASHTRA"
  },
  "413243": {
    "city": "MOHOL",
    "state": "MAHARASHTRA"
  },
  "413244": {
    "city": "MOHOL",
    "state": "MAHARASHTRA"
  },
  "413245": {
    "city": "MOHOL",
    "state": "MAHARASHTRA"
  },
  "413246": {
    "city": "MOHOL",
    "state": "MAHARASHTRA"
  },
  "413248": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413249": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "413250": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413251": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413252": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413253": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413254": {
    "city": "SOLAPUR",
    "state": "MAHARASHTRA"
  },
  "413255": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413275": {
    "city": "KARMALA",
    "state": "MAHARASHTRA"
  },
  "413276": {
    "city": "TEMBURNI",
    "state": "MAHARASHTRA"
  },
  "413279": {
    "city": "JEUR",
    "state": "MAHARASHTRA"
  },
  "413280": {
    "city": "JEUR",
    "state": "MAHARASHTRA"
  },
  "413287": {
    "city": "KURDUWADI",
    "state": "MAHARASHTRA"
  },
  "413288": {
    "city": "KURDUWADI",
    "state": "MAHARASHTRA"
  },
  "413297": {
    "city": "MAHISGAON",
    "state": "MAHARASHTRA"
  },
  "413298": {
    "city": "MAHISGAON",
    "state": "MAHARASHTRA"
  },
  "413301": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413302": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413303": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413304": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413305": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413306": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413307": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413308": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413309": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413310": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413311": {
    "city": "MALSIRAS",
    "state": "MAHARASHTRA"
  },
  "413312": {
    "city": "MALSIRAS",
    "state": "MAHARASHTRA"
  },
  "413313": {
    "city": "ATPADI",
    "state": "MAHARASHTRA"
  },
  "413314": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413315": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413316": {
    "city": "PANDHARPUR",
    "state": "MAHARASHTRA"
  },
  "413317": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413318": {
    "city": "PANDHARPUR",
    "state": "MAHARASHTRA"
  },
  "413319": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413322": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413324": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413347": {
    "city": "PANDHARPUR",
    "state": "MAHARASHTRA"
  },
  "413348": {
    "city": "PANDHARPUR",
    "state": "MAHARASHTRA"
  },
  "413401": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413402": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413403": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413404": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413405": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413406": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413409": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413410": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413411": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413412": {
    "city": "Solapur",
    "state": "Maharashtra"
  },
  "413413": {
    "city": "MOHOL",
    "state": "MAHARASHTRA"
  },
  "413416": {
    "city": "MOHOL",
    "state": "MAHARASHTRA"
  },
  "413501": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413502": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413503": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413504": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413505": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413506": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413507": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413508": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413509": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413510": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413511": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413512": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413513": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413514": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413515": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413516": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413517": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413518": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413519": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413520": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413521": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413522": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413523": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413524": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413525": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413526": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413527": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413528": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413529": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413530": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413531": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413532": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413533": {
    "city": "UDGIR",
    "state": "MAHARASHTRA"
  },
  "413534": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413535": {
    "city": "BHUM",
    "state": "MAHARASHTRA"
  },
  "413536": {
    "city": "BHUM",
    "state": "MAHARASHTRA"
  },
  "413537": {
    "city": "BHUM",
    "state": "MAHARASHTRA"
  },
  "413538": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413539": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413540": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413541": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413542": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413543": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413544": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413545": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413546": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413547": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413548": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413549": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413550": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413551": {
    "city": "KARMALA",
    "state": "MAHARASHTRA"
  },
  "413552": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413553": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413554": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413555": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413556": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413557": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413558": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413559": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413560": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413561": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413562": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413563": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413564": {
    "city": "SHIRUR ANANTPAL",
    "state": "MAHARASHTRA"
  },
  "413565": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413566": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413567": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413568": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413569": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413570": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413571": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413572": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413573": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413574": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413575": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413576": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413577": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413578": {
    "city": "PARANDA",
    "state": "MAHARASHTRA"
  },
  "413579": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413580": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413581": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413582": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413592": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413593": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413594": {
    "city": "OSMANABAD",
    "state": "MAHARASHTRA"
  },
  "413601": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413602": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413603": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413604": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413605": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413606": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413607": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "413608": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413612": {
    "city": "LOHARA",
    "state": "MAHARASHTRA"
  },
  "413613": {
    "city": "LOHARA",
    "state": "MAHARASHTRA"
  },
  "413614": {
    "city": "LOHARA",
    "state": "MAHARASHTRA"
  },
  "413615": {
    "city": "TULJAPUR",
    "state": "MAHARASHTRA"
  },
  "413616": {
    "city": "TULJAPUR",
    "state": "MAHARASHTRA"
  },
  "413623": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413624": {
    "city": "Osmanabad",
    "state": "Maharashtra"
  },
  "413701": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413702": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413703": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413704": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413705": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413706": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413707": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413708": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413709": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413710": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413711": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413712": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413713": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413714": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413715": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413716": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413717": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413718": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413719": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413720": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413721": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413722": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413723": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413724": {
    "city": "SHRIMPUR",
    "state": "MAHARASHTRA"
  },
  "413725": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413726": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413727": {
    "city": "SHRIGONDA",
    "state": "MAHARASHTRA"
  },
  "413728": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413732": {
    "city": "SHIRDI",
    "state": "MAHARASHTRA"
  },
  "413736": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413737": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413738": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413739": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "413801": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413802": {
    "city": "Pune",
    "state": "Maharashtra"
  },
  "413901": {
    "city": "LATUR",
    "state": "MAHARASHTRA"
  },
  "414001": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414002": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414003": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414004": {
    "city": "AHMEDNAGAR",
    "state": "MAHARASHTRA"
  },
  "414005": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414006": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414011": {
    "city": "AHMEDNAGAR",
    "state": "MAHARASHTRA"
  },
  "414101": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414102": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414103": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414104": {
    "city": "PARNER",
    "state": "MAHARASHTRA"
  },
  "414105": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414106": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414107": {
    "city": "AHMEDNAGAR",
    "state": "MAHARASHTRA"
  },
  "414108": {
    "city": "AHMEDNAGAR",
    "state": "MAHARASHTRA"
  },
  "414109": {
    "city": "AHMEDNAGAR",
    "state": "MAHARASHTRA"
  },
  "414110": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414111": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414112": {
    "city": "SHEVGAON",
    "state": "MAHARASHTRA"
  },
  "414113": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414201": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414202": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "414203": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "414204": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "414205": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "414206": {
    "city": "BEED",
    "state": "MAHARASHTRA"
  },
  "414207": {
    "city": "JAMKHED",
    "state": "MAHARASHTRA"
  },
  "414208": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "414301": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414302": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414303": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414304": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414305": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414306": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414307": {
    "city": "PARNER",
    "state": "MAHARASHTRA"
  },
  "414401": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414402": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414403": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414404": {
    "city": "KARJAT - AHMADNAGAR",
    "state": "MAHARASHTRA"
  },
  "414405": {
    "city": "KARJAT - AHMADNAGAR",
    "state": "MAHARASHTRA"
  },
  "414410": {
    "city": "KARJAT - AHMADNAGAR",
    "state": "MAHARASHTRA"
  },
  "414501": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414502": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414503": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414504": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414505": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414506": {
    "city": "SHEVGAON",
    "state": "MAHARASHTRA"
  },
  "414507": {
    "city": "SHEVGAON",
    "state": "MAHARASHTRA"
  },
  "414508": {
    "city": "SHEVGAON",
    "state": "MAHARASHTRA"
  },
  "414578": {
    "city": "AHMEDNAGAR",
    "state": "MAHARASHTRA"
  },
  "414601": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414602": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414603": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414604": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414605": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414606": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414607": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414608": {
    "city": "NEVASA",
    "state": "MAHARASHTRA"
  },
  "414609": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414701": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "414702": {
    "city": "DAUND",
    "state": "MAHARASHTRA"
  },
  "414703": {
    "city": "DAUND",
    "state": "MAHARASHTRA"
  },
  "414709": {
    "city": "DAUND",
    "state": "MAHARASHTRA"
  },
  "415001": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415002": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415003": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415004": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415005": {
    "city": "SATARA",
    "state": "MAHARASHTRA"
  },
  "415010": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415011": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415012": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415013": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415014": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415015": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415016": {
    "city": "SATARA",
    "state": "MAHARASHTRA"
  },
  "415017": {
    "city": "KOREGOAN",
    "state": "MAHARASHTRA"
  },
  "415019": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415020": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415021": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415022": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415023": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415035": {
    "city": "SAIDAPURA SATARA",
    "state": "MAHARASHTRA"
  },
  "415045": {
    "city": "VADUJ",
    "state": "MAHARASHTRA"
  },
  "415051": {
    "city": "SAIDAPURA SATARA",
    "state": "MAHARASHTRA"
  },
  "415101": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "415102": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415103": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415104": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415105": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415106": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415107": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415108": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415109": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415110": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415111": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415112": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415114": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415115": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415116": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415117": {
    "city": "KOREGOAN",
    "state": "MAHARASHTRA"
  },
  "415118": {
    "city": "KARAD",
    "state": "MAHARASHTRA"
  },
  "415119": {
    "city": "KARAD",
    "state": "MAHARASHTRA"
  },
  "415120": {
    "city": "KARAD",
    "state": "MAHARASHTRA"
  },
  "415122": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415124": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415201": {
    "city": "DAPOLI",
    "state": "MAHARASHTRA"
  },
  "415202": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415203": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415204": {
    "city": "PATAN-MH",
    "state": "MAHARASHTRA"
  },
  "415205": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415206": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415207": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415208": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415209": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415210": {
    "city": "KARAD",
    "state": "MAHARASHTRA"
  },
  "415211": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415212": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415213": {
    "city": "Raigarh(Mh)",
    "state": "Maharashtra"
  },
  "415214": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415225": {
    "city": "SRIVARDHAN",
    "state": "MAHARASHTRA"
  },
  "415301": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415302": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415303": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415304": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415305": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415306": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415307": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415308": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415309": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415310": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415311": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415312": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415313": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415315": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415345": {
    "city": "ATPADI",
    "state": "MAHARASHTRA"
  },
  "415401": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415402": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415403": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415404": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415405": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415406": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415407": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415408": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415409": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415410": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415411": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415412": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415413": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415414": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415415": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "415416": {
    "city": "SHAHUWADI",
    "state": "MAHARASHTRA"
  },
  "415417": {
    "city": "ISLAMPUR - MH",
    "state": "MAHARASHTRA"
  },
  "415418": {
    "city": "ISLAMPUR - MH",
    "state": "MAHARASHTRA"
  },
  "415501": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415502": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415503": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415504": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415505": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415506": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415507": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415508": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415509": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415510": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415511": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415512": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415513": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415514": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415515": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415516": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415517": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415518": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415519": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415520": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415521": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415522": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415523": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415524": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415525": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415526": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415527": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415528": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415529": {
    "city": "WAI",
    "state": "MAHARASHTRA"
  },
  "415530": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415531": {
    "city": "WAI",
    "state": "MAHARASHTRA"
  },
  "415532": {
    "city": "WAI",
    "state": "MAHARASHTRA"
  },
  "415536": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415537": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415538": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415539": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415540": {
    "city": "Satara",
    "state": "Maharashtra"
  },
  "415570": {
    "city": "AURANGABAD - MH",
    "state": "MAHARASHTRA"
  },
  "415601": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415602": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415603": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415604": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415605": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415606": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415607": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415608": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415609": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415610": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415611": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415612": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415613": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415614": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415615": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415616": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415617": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415618": {
    "city": "RATNAGIRI",
    "state": "MAHARASHTRA"
  },
  "415619": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415620": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415621": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415622": {
    "city": "KHED",
    "state": "MAHARASHTRA"
  },
  "415626": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415627": {
    "city": "RATNAGIRI",
    "state": "MAHARASHTRA"
  },
  "415628": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415629": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415630": {
    "city": "RATNAGIRI",
    "state": "MAHARASHTRA"
  },
  "415631": {
    "city": "GUHAGAR",
    "state": "MAHARASHTRA"
  },
  "415633": {
    "city": "GUHAGAR",
    "state": "MAHARASHTRA"
  },
  "415634": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415637": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415639": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415640": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415641": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415643": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415701": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415702": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415703": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415704": {
    "city": "GUHAGAR",
    "state": "MAHARASHTRA"
  },
  "415705": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415706": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415707": {
    "city": "GUHAGAR",
    "state": "MAHARASHTRA"
  },
  "415708": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415709": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415710": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415711": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415712": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415713": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415714": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415715": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415716": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415717": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415718": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415719": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415720": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415721": {
    "city": "KHED",
    "state": "MAHARASHTRA"
  },
  "415722": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415724": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415726": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415727": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415728": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415729": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415730": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415801": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415802": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415803": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415804": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415805": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415806": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "415807": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "416001": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416002": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416003": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416004": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416005": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416006": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416007": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416008": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416009": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416010": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416011": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416012": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416013": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416014": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416015": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416019": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416022": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416034": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416051": {
    "city": "Gadhingalaj",
    "state": "MAHARASHTRA"
  },
  "416101": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416102": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416103": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416104": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416105": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416106": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416107": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416108": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416109": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416110": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416111": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416112": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416113": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416114": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416115": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416116": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416117": {
    "city": "ICHALKARANJI",
    "state": "MAHARASHTRA"
  },
  "416118": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416119": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416120": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416121": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416122": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416123": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416125": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416127": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416129": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416130": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416132": {
    "city": "SANGLI",
    "state": "MAHARASHTRA"
  },
  "416134": {
    "city": "SANGLI",
    "state": "MAHARASHTRA"
  },
  "416137": {
    "city": "SANGLI",
    "state": "MAHARASHTRA"
  },
  "416138": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416143": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416144": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416145": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416146": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416201": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416202": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416203": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416204": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416205": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416206": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416207": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416208": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416209": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416210": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416211": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416212": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416213": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416214": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416215": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416216": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416217": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416218": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416219": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416220": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416221": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416222": {
    "city": "GARGOTI",
    "state": "MAHARASHTRA"
  },
  "416223": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416224": {
    "city": "GARGOTI",
    "state": "MAHARASHTRA"
  },
  "416225": {
    "city": "GARGOTI",
    "state": "MAHARASHTRA"
  },
  "416227": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416228": {
    "city": "KOLHAPUR",
    "state": "MAHARASHTRA"
  },
  "416229": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416230": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416231": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416232": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416234": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416235": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416236": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416301": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416302": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416303": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416304": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416305": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416306": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416307": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416308": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416309": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416310": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416311": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416312": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416313": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416314": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416315": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416316": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416317": {
    "city": "TASGAON",
    "state": "MAHARASHTRA"
  },
  "416319": {
    "city": "TASGAON",
    "state": "MAHARASHTRA"
  },
  "416320": {
    "city": "ISLAMPUR - MH",
    "state": "MAHARASHTRA"
  },
  "416321": {
    "city": "ISLAMPUR - MH",
    "state": "MAHARASHTRA"
  },
  "416322": {
    "city": "ISLAMPUR - MH",
    "state": "MAHARASHTRA"
  },
  "416401": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416402": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416403": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416404": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416405": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416406": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416407": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416408": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416409": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416410": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416411": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416412": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416413": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416414": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416415": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416416": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416417": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416418": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416419": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416420": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416421": {
    "city": "MIRAJ",
    "state": "MAHARASHTRA"
  },
  "416422": {
    "city": "MIRAJ",
    "state": "MAHARASHTRA"
  },
  "416423": {
    "city": "SANGLI",
    "state": "MAHARASHTRA"
  },
  "416425": {
    "city": "SANGLI",
    "state": "MAHARASHTRA"
  },
  "416426": {
    "city": "SANGLI",
    "state": "MAHARASHTRA"
  },
  "416428": {
    "city": "MIRAJ",
    "state": "MAHARASHTRA"
  },
  "416429": {
    "city": "SANGLI",
    "state": "MAHARASHTRA"
  },
  "416435": {
    "city": "SANGLI",
    "state": "MAHARASHTRA"
  },
  "416436": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416437": {
    "city": "Sangli",
    "state": "Maharashtra"
  },
  "416501": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416502": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416503": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416504": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416505": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416506": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416507": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416508": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416509": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416510": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416511": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416512": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416513": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416514": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416515": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416516": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416517": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416518": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416519": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416520": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416521": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416522": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416523": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416524": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416525": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416526": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416527": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416528": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416529": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416530": {
    "city": "SAWANTWADI",
    "state": "MAHARASHTRA"
  },
  "416531": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416532": {
    "city": "SAWANTWADI",
    "state": "MAHARASHTRA"
  },
  "416534": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416536": {
    "city": "GADHINGLAJ",
    "state": "MAHARASHTRA"
  },
  "416537": {
    "city": "OROS BUDRUK",
    "state": "MAHARASHTRA"
  },
  "416538": {
    "city": "OROS BUDRUK",
    "state": "MAHARASHTRA"
  },
  "416539": {
    "city": "SAWANTWADI",
    "state": "MAHARASHTRA"
  },
  "416540": {
    "city": "SAWANTWADI",
    "state": "MAHARASHTRA"
  },
  "416541": {
    "city": "SAWANTWADI",
    "state": "MAHARASHTRA"
  },
  "416542": {
    "city": "SAWANTWADI",
    "state": "MAHARASHTRA"
  },
  "416544": {
    "city": "SAWANTWADI",
    "state": "MAHARASHTRA"
  },
  "416549": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416550": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416551": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416552": {
    "city": "Kolhapur",
    "state": "Maharashtra"
  },
  "416601": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416602": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416603": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416604": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416605": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416606": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416607": {
    "city": "KANKAVALI",
    "state": "MAHARASHTRA"
  },
  "416608": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416609": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416610": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416611": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416612": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416613": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416614": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416615": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416616": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416618": {
    "city": "KANKAVALI",
    "state": "MAHARASHTRA"
  },
  "416620": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416621": {
    "city": "KANKAVALI",
    "state": "MAHARASHTRA"
  },
  "416622": {
    "city": "KANKAVALI",
    "state": "MAHARASHTRA"
  },
  "416623": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416624": {
    "city": "MALWAN",
    "state": "MAHARASHTRA"
  },
  "416625": {
    "city": "MALWAN",
    "state": "MAHARASHTRA"
  },
  "416626": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416628": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416630": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416632": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416701": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "416702": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "416703": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416704": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "416705": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "416707": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "416709": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "416710": {
    "city": "DEVGARH",
    "state": "MAHARASHTRA"
  },
  "416712": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "416713": {
    "city": "Ratnagiri",
    "state": "Maharashtra"
  },
  "416801": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416802": {
    "city": "KANKAVALI",
    "state": "MAHARASHTRA"
  },
  "416803": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416804": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416805": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416806": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416807": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416809": {
    "city": "KANKAVALI",
    "state": "MAHARASHTRA"
  },
  "416810": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416811": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416812": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "416813": {
    "city": "Sindhudurg",
    "state": "Maharashtra"
  },
  "418010": {
    "city": "KANKAVALI",
    "state": "MAHARASHTRA"
  },
  "418101": {
    "city": "KANKAVALI",
    "state": "MAHARASHTRA"
  },
  "418110": {
    "city": "KANKAVALI",
    "state": "MAHARASHTRA"
  },
  "418115": {
    "city": "KANKAVALI",
    "state": "MAHARASHTRA"
  },
  "419209": {
    "city": "RANJANGAON",
    "state": "MAHARASHTRA"
  },
  "420007": {
    "city": "Indore",
    "state": "MADHYA PRADESH"
  },
  "420421": {
    "city": "THANE",
    "state": "MAHARASHTRA"
  },
  "421000": {
    "city": "BHIWANDI",
    "state": "MAHARASHTRA"
  },
  "421001": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "421002": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421003": {
    "city": "Mumbai",
    "state": "Maharashtra"
  },
  "421004": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421005": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421006": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "421032": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "421051": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "421101": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421102": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421103": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421111": {
    "city": "BHIWANDI",
    "state": "MAHARASHTRA"
  },
  "421201": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421202": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421203": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421204": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421205": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "421206": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "421300": {
    "city": "BHIWANDI",
    "state": "MAHARASHTRA"
  },
  "421301": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421302": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421303": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421304": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "421305": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421306": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421307": {
    "city": "THANE",
    "state": "MAHARASHTRA"
  },
  "421308": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421311": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421312": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421313": {
    "city": "KUDUS",
    "state": "MAHARASHTRA"
  },
  "421329": {
    "city": "KUDUS",
    "state": "MAHARASHTRA"
  },
  "421401": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421402": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421403": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421405": {
    "city": "MURBAD",
    "state": "MAHARASHTRA"
  },
  "421421": {
    "city": "MURBAD",
    "state": "MAHARASHTRA"
  },
  "421501": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421502": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421503": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421504": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "421505": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421506": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421507": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "421600": {
    "city": "SAHAPUR",
    "state": "MAHARASHTRA"
  },
  "421601": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421602": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421603": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421604": {
    "city": "SAHAPUR",
    "state": "MAHARASHTRA"
  },
  "421605": {
    "city": "Thane",
    "state": "Maharashtra"
  },
  "421607": {
    "city": "MUMBAI",
    "state": "MAHARASHTRA"
  },
  "422001": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422002": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422003": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422004": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422005": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422006": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422007": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422008": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422009": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422010": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422011": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422012": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422013": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422101": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422102": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422103": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422104": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422105": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422106": {
    "city": "NASIK",
    "state": "MAHARASHTRA"
  },
  "422107": {
    "city": "NASIK",
    "state": "MAHARASHTRA"
  },
  "422108": {
    "city": "NASIK",
    "state": "MAHARASHTRA"
  },
  "422109": {
    "city": "SINNAR",
    "state": "MAHARASHTRA"
  },
  "422110": {
    "city": "SATANA",
    "state": "MAHARASHTRA"
  },
  "422111": {
    "city": "NASIK",
    "state": "MAHARASHTRA"
  },
  "422112": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422113": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422201": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422202": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422203": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422204": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422205": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422206": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422207": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422208": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422209": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422210": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422211": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422212": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422213": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422214": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422215": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422216": {
    "city": "NASIK",
    "state": "MAHARASHTRA"
  },
  "422217": {
    "city": "NASIK",
    "state": "MAHARASHTRA"
  },
  "422218": {
    "city": "YEOLA",
    "state": "MAHARASHTRA"
  },
  "422219": {
    "city": "KALVAN",
    "state": "MAHARASHTRA"
  },
  "422220": {
    "city": "NASIK",
    "state": "MAHARASHTRA"
  },
  "422221": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422222": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422301": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422302": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422303": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422304": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422305": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422306": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422307": {
    "city": "NIPHAD",
    "state": "MAHARASHTRA"
  },
  "422308": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422401": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422402": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422403": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422404": {
    "city": "IGATPURI",
    "state": "MAHARASHTRA"
  },
  "422405": {
    "city": "IGATPURI",
    "state": "MAHARASHTRA"
  },
  "422501": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422502": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422503": {
    "city": "NASIK",
    "state": "MAHARASHTRA"
  },
  "422509": {
    "city": "NASIK",
    "state": "MAHARASHTRA"
  },
  "422601": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "422602": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "422603": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "422604": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "422605": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "422606": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "422607": {
    "city": "SINNAR",
    "state": "MAHARASHTRA"
  },
  "422608": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "422610": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "422611": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "422615": {
    "city": "SANGAMNER",
    "state": "MAHARASHTRA"
  },
  "422617": {
    "city": "SANGAMNER",
    "state": "MAHARASHTRA"
  },
  "422619": {
    "city": "SANGAMNER",
    "state": "MAHARASHTRA"
  },
  "422620": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "422621": {
    "city": "SANGAMNER",
    "state": "MAHARASHTRA"
  },
  "422622": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "423101": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423102": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423103": {
    "city": "MALEGAON",
    "state": "MAHARASHTRA"
  },
  "423104": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423105": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423106": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423107": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "423108": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423109": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "423110": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423111": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423112": {
    "city": "AURANGABAD",
    "state": "MAHARASHTRA"
  },
  "423113": {
    "city": "SHIRDI",
    "state": "MAHARASHTRA"
  },
  "423114": {
    "city": "NIPHAD",
    "state": "MAHARASHTRA"
  },
  "423115": {
    "city": "LASUR",
    "state": "MAHARASHTRA"
  },
  "423116": {
    "city": "NANDGAON",
    "state": "MAHARASHTRA"
  },
  "423117": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423120": {
    "city": "Jalna",
    "state": "MAHARASHTRA"
  },
  "423201": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423202": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423203": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423204": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423205": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423206": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423207": {
    "city": "MALEGAON",
    "state": "MAHARASHTRA"
  },
  "423208": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423209": {
    "city": "MALEGAON",
    "state": "MAHARASHTRA"
  },
  "423210": {
    "city": "MALEGAON",
    "state": "MAHARASHTRA"
  },
  "423211": {
    "city": "MALEGAON",
    "state": "MAHARASHTRA"
  },
  "423212": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423213": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423301": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423302": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423303": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423304": {
    "city": "KALVAN",
    "state": "MAHARASHTRA"
  },
  "423305": {
    "city": "SAKRI",
    "state": "MAHARASHTRA"
  },
  "423401": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423402": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423403": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423501": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423502": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "423601": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "423602": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "423603": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "423604": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "423605": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "423607": {
    "city": "Ahmed Nagar",
    "state": "Maharashtra"
  },
  "423701": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "423702": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "423703": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "423704": {
    "city": "VAIJAPUR",
    "state": "MAHARASHTRA"
  },
  "423705": {
    "city": "VAIJAPUR",
    "state": "MAHARASHTRA"
  },
  "424001": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424002": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424003": {
    "city": "DHULE",
    "state": "MAHARASHTRA"
  },
  "424004": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424005": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424006": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424026": {
    "city": "DHULE",
    "state": "MAHARASHTRA"
  },
  "424027": {
    "city": "DHULE",
    "state": "MAHARASHTRA"
  },
  "424101": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424102": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424103": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424104": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424105": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424106": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424107": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424108": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424109": {
    "city": "Nashik",
    "state": "Maharashtra"
  },
  "424110": {
    "city": "CHALISGAON",
    "state": "MAHARASHTRA"
  },
  "424111": {
    "city": "PACHORA",
    "state": "MAHARASHTRA"
  },
  "424112": {
    "city": "CHALISGAON",
    "state": "MAHARASHTRA"
  },
  "424113": {
    "city": "DHULE",
    "state": "MAHARASHTRA"
  },
  "424114": {
    "city": "CHALISGAON",
    "state": "MAHARASHTRA"
  },
  "424115": {
    "city": "NANDGAON",
    "state": "MAHARASHTRA"
  },
  "424116": {
    "city": "CHALISGAON",
    "state": "MAHARASHTRA"
  },
  "424117": {
    "city": "CHALISGAON",
    "state": "MAHARASHTRA"
  },
  "424119": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424201": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424202": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424203": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424204": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424205": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424206": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424207": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424208": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "424209": {
    "city": "JAMNER",
    "state": "MAHARASHTRA"
  },
  "424210": {
    "city": "JAMNER",
    "state": "MAHARASHTRA"
  },
  "424301": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424302": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424303": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424304": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424305": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424306": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424307": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424308": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424309": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424310": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424311": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "424312": {
    "city": "DHULE",
    "state": "MAHARASHTRA"
  },
  "424313": {
    "city": "DHULE",
    "state": "MAHARASHTRA"
  },
  "424314": {
    "city": "SAKRI",
    "state": "MAHARASHTRA"
  },
  "424315": {
    "city": "DHULE",
    "state": "MAHARASHTRA"
  },
  "424316": {
    "city": "DHULE",
    "state": "MAHARASHTRA"
  },
  "424317": {
    "city": "SAKRI",
    "state": "MAHARASHTRA"
  },
  "424318": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "425001": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425002": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425003": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425004": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425101": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425102": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425103": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425104": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425105": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425106": {
    "city": "AMALNER",
    "state": "MAHARASHTRA"
  },
  "425107": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425108": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425109": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425110": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425111": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425112": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425113": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425114": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425115": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425116": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425117": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425118": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425119": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425120": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425121": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425122": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425123": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425124": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425125": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425126": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425127": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425128": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425129": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425130": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425131": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425132": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425133": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425134": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425135": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425136": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425201": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425202": {
    "city": "JALGAON",
    "state": "MAHARASHTRA"
  },
  "425203": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425204": {
    "city": "BHUSAWAL",
    "state": "MAHARASHTRA"
  },
  "425211": {
    "city": "JAMNER",
    "state": "MAHARASHTRA"
  },
  "425301": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425302": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425303": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425304": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425305": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425306": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425307": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425308": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425309": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425310": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425311": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425312": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425313": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425314": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425315": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425316": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425317": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425318": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425319": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425320": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425321": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425322": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425323": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425324": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425325": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425326": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425327": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425336": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "425401": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425402": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425403": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "425404": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "425405": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "425406": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "425407": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "425408": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "425409": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425410": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425411": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425412": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425413": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425414": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425415": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425416": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425417": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425418": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425419": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425420": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425421": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "425422": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425423": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425424": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425425": {
    "city": "TALODA",
    "state": "MAHARASHTRA"
  },
  "425426": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425427": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "425428": {
    "city": "Dhule",
    "state": "Maharashtra"
  },
  "425429": {
    "city": "NANDURBAR",
    "state": "MAHARASHTRA"
  },
  "425430": {
    "city": "SAKRI",
    "state": "MAHARASHTRA"
  },
  "425431": {
    "city": "SHAHADA",
    "state": "MAHARASHTRA"
  },
  "425432": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425433": {
    "city": "SHAHADA",
    "state": "MAHARASHTRA"
  },
  "425434": {
    "city": "CHOPDA",
    "state": "MAHARASHTRA"
  },
  "425435": {
    "city": "AMALNER",
    "state": "MAHARASHTRA"
  },
  "425436": {
    "city": "SHAHADA",
    "state": "MAHARASHTRA"
  },
  "425437": {
    "city": "AMALNER",
    "state": "MAHARASHTRA"
  },
  "425438": {
    "city": "SHAHADA",
    "state": "MAHARASHTRA"
  },
  "425439": {
    "city": "TALODA",
    "state": "MAHARASHTRA"
  },
  "425440": {
    "city": "SHAHADA",
    "state": "MAHARASHTRA"
  },
  "425441": {
    "city": "TALODA",
    "state": "MAHARASHTRA"
  },
  "425442": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425443": {
    "city": "NANDURBAR",
    "state": "MAHARASHTRA"
  },
  "425444": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425445": {
    "city": "NANDURBAR",
    "state": "MAHARASHTRA"
  },
  "425446": {
    "city": "SINDKHEDA",
    "state": "MAHARASHTRA"
  },
  "425447": {
    "city": "SHAHADA",
    "state": "MAHARASHTRA"
  },
  "425448": {
    "city": "SHAHADA",
    "state": "MAHARASHTRA"
  },
  "425449": {
    "city": "NANDURBAR",
    "state": "MAHARASHTRA"
  },
  "425450": {
    "city": "NANDURBAR",
    "state": "MAHARASHTRA"
  },
  "425451": {
    "city": "NANDURBAR",
    "state": "MAHARASHTRA"
  },
  "425452": {
    "city": "Nandurbar",
    "state": "Maharashtra"
  },
  "425453": {
    "city": "NANDURBAR",
    "state": "MAHARASHTRA"
  },
  "425501": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425502": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425503": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425504": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425505": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425506": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425507": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425508": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "425509": {
    "city": "RAVER",
    "state": "MAHARASHTRA"
  },
  "425510": {
    "city": "RAVER",
    "state": "MAHARASHTRA"
  },
  "425511": {
    "city": "RAVER",
    "state": "MAHARASHTRA"
  },
  "425512": {
    "city": "RAVER",
    "state": "MAHARASHTRA"
  },
  "425513": {
    "city": "RAVER",
    "state": "MAHARASHTRA"
  },
  "425514": {
    "city": "RAVER",
    "state": "MAHARASHTRA"
  },
  "425515": {
    "city": "RAVER",
    "state": "MAHARASHTRA"
  },
  "425516": {
    "city": "RAVER",
    "state": "MAHARASHTRA"
  },
  "425517": {
    "city": "BHUSAWAL",
    "state": "MAHARASHTRA"
  },
  "425518": {
    "city": "BHUSAWAL",
    "state": "MAHARASHTRA"
  },
  "425519": {
    "city": "BHUSAWAL",
    "state": "MAHARASHTRA"
  },
  "425520": {
    "city": "BHUSAWAL",
    "state": "MAHARASHTRA"
  },
  "425521": {
    "city": "BHUSAWAL",
    "state": "MAHARASHTRA"
  },
  "425522": {
    "city": "BHUSAWAL",
    "state": "MAHARASHTRA"
  },
  "425523": {
    "city": "BHUSAWAL",
    "state": "MAHARASHTRA"
  },
  "425524": {
    "city": "Jalgaon",
    "state": "Maharashtra"
  },
  "430005": {
    "city": "AURANGABAD - MH",
    "state": "MAHARASHTRA"
  },
  "430006": {
    "city": "AURANGABAD - MH",
    "state": "MAHARASHTRA"
  },
  "430007": {
    "city": "AURANGABAD - MH",
    "state": "MAHARASHTRA"
  },
  "430507": {
    "city": "BICHOLIM",
    "state": "GOA"
  },
  "431001": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431002": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431003": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431004": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431005": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431006": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431007": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431008": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431009": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431010": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431100": {
    "city": "AURANGABAD - MH",
    "state": "MAHARASHTRA"
  },
  "431101": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431102": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431103": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431104": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431105": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431106": {
    "city": "SELU",
    "state": "MAHARASHTRA"
  },
  "431107": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431108": {
    "city": "PAITHAN",
    "state": "MAHARASHTRA"
  },
  "431109": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431110": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431111": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431112": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431113": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431114": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431115": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431116": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431117": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431118": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431119": {
    "city": "CHIKALTHANA",
    "state": "MAHARASHTRA"
  },
  "431120": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431121": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431122": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431123": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431124": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431125": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431126": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431127": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431128": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431129": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431130": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431131": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431132": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431133": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431134": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431135": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431136": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431137": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431138": {
    "city": "PAITHAN",
    "state": "MAHARASHTRA"
  },
  "431139": {
    "city": "KANNAD",
    "state": "MAHARASHTRA"
  },
  "431140": {
    "city": "MANJLEGAON",
    "state": "MAHARASHTRA"
  },
  "431141": {
    "city": "MANJLEGAON",
    "state": "MAHARASHTRA"
  },
  "431142": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431143": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431144": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431145": {
    "city": "MANJLEGAON",
    "state": "MAHARASHTRA"
  },
  "431146": {
    "city": "KANNAD",
    "state": "MAHARASHTRA"
  },
  "431147": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431148": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431150": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431151": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431153": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431154": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431200": {
    "city": "JALNA",
    "state": "MAHARASHTRA"
  },
  "431201": {
    "city": "AURANGABAD",
    "state": "MAHARASHTRA"
  },
  "431202": {
    "city": "Aurangabad",
    "state": "Maharashtra"
  },
  "431203": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431204": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431205": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431206": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431207": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431208": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431209": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431210": {
    "city": "AURANGABAD",
    "state": "MAHARASHTRA"
  },
  "431211": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431212": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431213": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431214": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431215": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431216": {
    "city": "AMBAD",
    "state": "MAHARASHTRA"
  },
  "431217": {
    "city": "PARTUR",
    "state": "MAHARASHTRA"
  },
  "431219": {
    "city": "PARTUR",
    "state": "MAHARASHTRA"
  },
  "431302": {
    "city": "BHIWANDI",
    "state": "MAHARASHTRA"
  },
  "431401": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431402": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431406": {
    "city": "PARBHANI",
    "state": "MAHARASHTRA"
  },
  "431407": {
    "city": "PARBHANI",
    "state": "MAHARASHTRA"
  },
  "431501": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431502": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431503": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431504": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431505": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431506": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431507": {
    "city": "Jalna",
    "state": "Maharashtra"
  },
  "431508": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431509": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431510": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431511": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431512": {
    "city": "Hingoli",
    "state": "Maharashtra"
  },
  "431513": {
    "city": "Hingoli",
    "state": "Maharashtra"
  },
  "431514": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431515": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431516": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431517": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431518": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431519": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431520": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431521": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431522": {
    "city": "Latur",
    "state": "Maharashtra"
  },
  "431523": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431524": {
    "city": "AMBAJOGAI",
    "state": "MAHARASHTRA"
  },
  "431525": {
    "city": "AMBAJOGAI",
    "state": "MAHARASHTRA"
  },
  "431526": {
    "city": "AMBAJOGAI",
    "state": "MAHARASHTRA"
  },
  "431527": {
    "city": "PARLI VAIJNATH",
    "state": "MAHARASHTRA"
  },
  "431528": {
    "city": "PARLI VAIJNATH",
    "state": "MAHARASHTRA"
  },
  "431529": {
    "city": "PARLI VAIJNATH",
    "state": "MAHARASHTRA"
  },
  "431530": {
    "city": "Beed",
    "state": "Maharashtra"
  },
  "431531": {
    "city": "HINGOLI",
    "state": "MAHARASHTRA"
  },
  "431532": {
    "city": "GANGAKHER",
    "state": "MAHARASHTRA"
  },
  "431533": {
    "city": "GANGAKHER",
    "state": "MAHARASHTRA"
  },
  "431534": {
    "city": "GANGAKHER",
    "state": "MAHARASHTRA"
  },
  "431536": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431537": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431538": {
    "city": "MANWAT",
    "state": "MAHARASHTRA"
  },
  "431539": {
    "city": "PARBHANI",
    "state": "MAHARASHTRA"
  },
  "431540": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431541": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431542": {
    "city": "Hingoli",
    "state": "Maharashtra"
  },
  "431601": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431602": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431603": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431604": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431605": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431606": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431646": {
    "city": "KANDAHAR",
    "state": "MAHARASHTRA"
  },
  "431701": {
    "city": "Hingoli",
    "state": "Maharashtra"
  },
  "431702": {
    "city": "Hingoli",
    "state": "Maharashtra"
  },
  "431703": {
    "city": "Hingoli",
    "state": "Maharashtra"
  },
  "431704": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431705": {
    "city": "Hingoli",
    "state": "Maharashtra"
  },
  "431706": {
    "city": "KANDAHAR",
    "state": "MAHARASHTRA"
  },
  "431707": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431708": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431709": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431710": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431711": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431712": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431713": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431714": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431715": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431716": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431717": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431718": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431719": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431720": {
    "city": "Parbhani",
    "state": "Maharashtra"
  },
  "431721": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431722": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431723": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431724": {
    "city": "DEGLUR",
    "state": "MAHARASHTRA"
  },
  "431725": {
    "city": "DEGLUR",
    "state": "MAHARASHTRA"
  },
  "431726": {
    "city": "DEGLUR",
    "state": "MAHARASHTRA"
  },
  "431727": {
    "city": "DEGLUR",
    "state": "MAHARASHTRA"
  },
  "431728": {
    "city": "DHARMABAD",
    "state": "MAHARASHTRA"
  },
  "431730": {
    "city": "DHARMABAD",
    "state": "MAHARASHTRA"
  },
  "431731": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431732": {
    "city": "DHARMABAD",
    "state": "MAHARASHTRA"
  },
  "431733": {
    "city": "DHARMABAD",
    "state": "MAHARASHTRA"
  },
  "431734": {
    "city": "NAYAGAON KHAIRGAON",
    "state": "MAHARASHTRA"
  },
  "431735": {
    "city": "NAYAGAON KHAIRGAON",
    "state": "MAHARASHTRA"
  },
  "431736": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431737": {
    "city": "NAYAGAON KHAIRGAON",
    "state": "MAHARASHTRA"
  },
  "431738": {
    "city": "NAYAGAON KHAIRGAON",
    "state": "MAHARASHTRA"
  },
  "431739": {
    "city": "DEGLUR",
    "state": "MAHARASHTRA"
  },
  "431740": {
    "city": "DEGLUR",
    "state": "MAHARASHTRA"
  },
  "431741": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431742": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431743": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431744": {
    "city": "MUDKHED",
    "state": "MAHARASHTRA"
  },
  "431745": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431746": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431750": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431801": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431802": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431803": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431804": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431805": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431806": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431807": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431808": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431809": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431810": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431811": {
    "city": "Nanded",
    "state": "Maharashtra"
  },
  "431812": {
    "city": "KINWAT",
    "state": "MAHARASHTRA"
  },
  "431813": {
    "city": "KINWAT",
    "state": "MAHARASHTRA"
  },
  "431814": {
    "city": "KINWAT",
    "state": "MAHARASHTRA"
  },
  "431815": {
    "city": "MUKHER",
    "state": "MAHARASHTRA"
  },
  "440000": {
    "city": "NAGPUR",
    "state": "MAHARASHTRA"
  },
  "440001": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440002": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440003": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440004": {
    "city": "NAGPUR",
    "state": "MAHARASHTRA"
  },
  "440005": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440006": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440007": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440008": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440009": {
    "city": "NAGPUR",
    "state": "MAHARASHTRA"
  },
  "440010": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440011": {
    "city": "NAGPUR",
    "state": "MAHARASHTRA"
  },
  "440012": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440013": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440014": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440015": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440016": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440017": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440018": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440019": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440020": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440021": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440022": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440023": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440024": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440025": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440026": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440027": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440028": {
    "city": "NAGPUR",
    "state": "MAHARASHTRA"
  },
  "440029": {
    "city": "NAGPUR",
    "state": "MAHARASHTRA"
  },
  "440030": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440031": {
    "city": "NAGPUR",
    "state": "MAHARASHTRA"
  },
  "440032": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440033": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440034": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440035": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440036": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440037": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "440038": {
    "city": "NAGPUR",
    "state": "MAHARASHTRA"
  },
  "440104": {
    "city": "NAGPUR",
    "state": "MAHARASHTRA"
  },
  "440531": {
    "city": "NAGPUR",
    "state": "MAHARASHTRA"
  },
  "440705": {
    "city": "KAMTHI",
    "state": "MAHARASHTRA"
  },
  "441001": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441002": {
    "city": "NAGPUR",
    "state": "MAHARASHTRA"
  },
  "441008": {
    "city": "KAMTHI",
    "state": "MAHARASHTRA"
  },
  "441101": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441102": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441103": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441104": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441105": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441106": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441107": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441108": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441109": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441110": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441111": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441112": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441113": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441114": {
    "city": "BUTIBORI",
    "state": "MAHARASHTRA"
  },
  "441115": {
    "city": "UMRED",
    "state": "MAHARASHTRA"
  },
  "441116": {
    "city": "KAMTHI",
    "state": "MAHARASHTRA"
  },
  "441117": {
    "city": "WARDHA",
    "state": "MAHARASHTRA"
  },
  "441118": {
    "city": "WARDHA",
    "state": "MAHARASHTRA"
  },
  "441121": {
    "city": "WARDHA",
    "state": "MAHARASHTRA"
  },
  "441122": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441123": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441125": {
    "city": "NAGPUR",
    "state": "MAHARASHTRA"
  },
  "441201": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441202": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441203": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441204": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441205": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "441206": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "441207": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "441208": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "441209": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "441210": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441212": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "441213": {
    "city": "UMRED",
    "state": "MAHARASHTRA"
  },
  "441214": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441215": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "441216": {
    "city": "TUMSAR",
    "state": "MAHARASHTRA"
  },
  "441217": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "441221": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "441222": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "441223": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "441224": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "441225": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "441226": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "441227": {
    "city": "GONDPIPARI",
    "state": "MAHARASHTRA"
  },
  "441228": {
    "city": "GONDPIPARI",
    "state": "MAHARASHTRA"
  },
  "441301": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441302": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441303": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441304": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441305": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441306": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441400": {
    "city": "RAMTEK",
    "state": "MAHARASHTRA"
  },
  "441401": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441402": {
    "city": "RAMTEK",
    "state": "MAHARASHTRA"
  },
  "441403": {
    "city": "RAMTEK",
    "state": "MAHARASHTRA"
  },
  "441404": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441405": {
    "city": "KAMTHI",
    "state": "MAHARASHTRA"
  },
  "441406": {
    "city": "RAMTEK",
    "state": "MAHARASHTRA"
  },
  "441407": {
    "city": "KAMTHI",
    "state": "MAHARASHTRA"
  },
  "441408": {
    "city": "RAMTEK",
    "state": "MAHARASHTRA"
  },
  "441409": {
    "city": "KAMTHI",
    "state": "MAHARASHTRA"
  },
  "441501": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441502": {
    "city": "Nagpur",
    "state": "Maharashtra"
  },
  "441503": {
    "city": "KATUL",
    "state": "MAHARASHTRA"
  },
  "441504": {
    "city": "KATUL",
    "state": "MAHARASHTRA"
  },
  "441601": {
    "city": "Gondia",
    "state": "Maharashtra"
  },
  "441602": {
    "city": "GONDIA",
    "state": "MAHARASHTRA"
  },
  "441603": {
    "city": "GONDIA",
    "state": "MAHARASHTRA"
  },
  "441604": {
    "city": "GONDIA",
    "state": "MAHARASHTRA"
  },
  "441605": {
    "city": "GONDIA",
    "state": "MAHARASHTRA"
  },
  "441606": {
    "city": "GONDIA",
    "state": "MAHARASHTRA"
  },
  "441607": {
    "city": "GONDIA",
    "state": "MAHARASHTRA"
  },
  "441608": {
    "city": "GONDIA",
    "state": "MAHARASHTRA"
  },
  "441609": {
    "city": "GONDIA",
    "state": "MAHARASHTRA"
  },
  "441611": {
    "city": "GONDIA",
    "state": "MAHARASHTRA"
  },
  "441612": {
    "city": "GONDIA",
    "state": "MAHARASHTRA"
  },
  "441613": {
    "city": "GONDIA",
    "state": "MAHARASHTRA"
  },
  "441614": {
    "city": "Gondia",
    "state": "Maharashtra"
  },
  "441701": {
    "city": "Gondia",
    "state": "Maharashtra"
  },
  "441702": {
    "city": "Gondia",
    "state": "Maharashtra"
  },
  "441703": {
    "city": "ARJUNI MORGAON",
    "state": "MAHARASHTRA"
  },
  "441801": {
    "city": "Gondia",
    "state": "Maharashtra"
  },
  "441802": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441803": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441804": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441805": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441806": {
    "city": "Gondia",
    "state": "Maharashtra"
  },
  "441807": {
    "city": "Gondia",
    "state": "Maharashtra"
  },
  "441808": {
    "city": "SADAK ARJUNI",
    "state": "MAHARASHTRA"
  },
  "441809": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441810": {
    "city": "SAKOLI",
    "state": "MAHARASHTRA"
  },
  "441811": {
    "city": "SAKOLI",
    "state": "MAHARASHTRA"
  },
  "441901": {
    "city": "Gondia",
    "state": "Maharashtra"
  },
  "441902": {
    "city": "Gondia",
    "state": "Maharashtra"
  },
  "441903": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441904": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441905": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441906": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441907": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441908": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441909": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441910": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441911": {
    "city": "Gondia",
    "state": "Maharashtra"
  },
  "441912": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441913": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441914": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441915": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441916": {
    "city": "Gondia",
    "state": "Maharashtra"
  },
  "441917": {
    "city": "AMGAON",
    "state": "MAHARASHTRA"
  },
  "441918": {
    "city": "AMGAON",
    "state": "MAHARASHTRA"
  },
  "441919": {
    "city": "AMGAON",
    "state": "MAHARASHTRA"
  },
  "441920": {
    "city": "AMGAON",
    "state": "MAHARASHTRA"
  },
  "441921": {
    "city": "BHANDARA",
    "state": "MAHARASHTRA"
  },
  "441922": {
    "city": "BHANDARA",
    "state": "MAHARASHTRA"
  },
  "441923": {
    "city": "BHANDARA",
    "state": "MAHARASHTRA"
  },
  "441924": {
    "city": "Bhandara",
    "state": "Maharashtra"
  },
  "441928": {
    "city": "BHANDARA",
    "state": "MAHARASHTRA"
  },
  "441930": {
    "city": "BHANDARA",
    "state": "MAHARASHTRA"
  },
  "441991": {
    "city": "Gondia",
    "state": "MAHARASHTRA"
  },
  "442001": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442002": {
    "city": "WARDHA",
    "state": "MAHARASHTRA"
  },
  "442003": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442004": {
    "city": "WARDHA",
    "state": "MAHARASHTRA"
  },
  "442005": {
    "city": "WARDHA",
    "state": "MAHARASHTRA"
  },
  "442006": {
    "city": "WARDHA",
    "state": "MAHARASHTRA"
  },
  "442101": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442102": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442103": {
    "city": "WARDHA",
    "state": "MAHARASHTRA"
  },
  "442104": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442105": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442106": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442107": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442108": {
    "city": "WARDHA",
    "state": "MAHARASHTRA"
  },
  "442109": {
    "city": "WARDHA",
    "state": "MAHARASHTRA"
  },
  "442110": {
    "city": "WARDHA",
    "state": "MAHARASHTRA"
  },
  "442111": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442112": {
    "city": "WARDHA",
    "state": "MAHARASHTRA"
  },
  "442201": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442202": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442203": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442204": {
    "city": "ARVI",
    "state": "MAHARASHTRA"
  },
  "442205": {
    "city": "KARANJA - WASHIM",
    "state": "MAHARASHTRA"
  },
  "442206": {
    "city": "KARANJA - WASHIM",
    "state": "MAHARASHTRA"
  },
  "442207": {
    "city": "KARANJA - WASHIM",
    "state": "MAHARASHTRA"
  },
  "442301": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442302": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442303": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442304": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442305": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442306": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442307": {
    "city": "Wardha",
    "state": "Maharashtra"
  },
  "442308": {
    "city": "HINGANGHAT",
    "state": "MAHARASHTRA"
  },
  "442309": {
    "city": "HINGANGHAT",
    "state": "MAHARASHTRA"
  },
  "442310": {
    "city": "HINGANGHAT",
    "state": "MAHARASHTRA"
  },
  "442311": {
    "city": "HINGANGHAT",
    "state": "MAHARASHTRA"
  },
  "442312": {
    "city": "ARVI",
    "state": "MAHARASHTRA"
  },
  "442401": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442402": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442403": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442404": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442405": {
    "city": "CHANDRAPUR",
    "state": "MAHARASHTRA"
  },
  "442406": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442501": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442502": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442503": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442504": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "442505": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442506": {
    "city": "CHANDRAPUR",
    "state": "MAHARASHTRA"
  },
  "442507": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442603": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "442604": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "442605": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "442606": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "442608": {
    "city": "KURKHERA",
    "state": "MAHARASHTRA"
  },
  "442700": {
    "city": "GONDPIPARI",
    "state": "MAHARASHTRA"
  },
  "442701": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442702": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442703": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "442704": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "442705": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "442706": {
    "city": "GADCHANDUR",
    "state": "MAHARASHTRA"
  },
  "442707": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "442708": {
    "city": "CHAMURSI",
    "state": "MAHARASHTRA"
  },
  "442709": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "442710": {
    "city": "Gadchiroli",
    "state": "Maharashtra"
  },
  "442901": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442902": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442903": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442904": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442905": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442906": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442907": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442908": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442909": {
    "city": "CHANDRAPUR",
    "state": "MAHARASHTRA"
  },
  "442910": {
    "city": "CHANDRAPUR",
    "state": "MAHARASHTRA"
  },
  "442911": {
    "city": "CHANDRAPUR",
    "state": "MAHARASHTRA"
  },
  "442912": {
    "city": "WARORA",
    "state": "MAHARASHTRA"
  },
  "442913": {
    "city": "WARORA",
    "state": "MAHARASHTRA"
  },
  "442914": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442915": {
    "city": "WANI - YAVATMAL",
    "state": "MAHARASHTRA"
  },
  "442916": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442917": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "442918": {
    "city": "Chandrapur",
    "state": "Maharashtra"
  },
  "443001": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443002": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443101": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443102": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443103": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443104": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443105": {
    "city": "BULDANA",
    "state": "MAHARASHTRA"
  },
  "443106": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443107": {
    "city": "JAFRABAD",
    "state": "MAHARASHTRA"
  },
  "443108": {
    "city": "BULDANA",
    "state": "MAHARASHTRA"
  },
  "443109": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "443110": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "443111": {
    "city": "MALKAPUR",
    "state": "MAHARASHTRA"
  },
  "443112": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443201": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443202": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443203": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443204": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443205": {
    "city": "DEOLGAON RAJA",
    "state": "MAHARASHTRA"
  },
  "443206": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443207": {
    "city": "DEOLGAON RAJA",
    "state": "MAHARASHTRA"
  },
  "443208": {
    "city": "DEOLGAON RAJA",
    "state": "MAHARASHTRA"
  },
  "443209": {
    "city": "MEHEKAR",
    "state": "MAHARASHTRA"
  },
  "443211": {
    "city": "DEOLGAON RAJA",
    "state": "MAHARASHTRA"
  },
  "443301": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443302": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443303": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443304": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443305": {
    "city": "MEHEKAR",
    "state": "MAHARASHTRA"
  },
  "443306": {
    "city": "MEHEKAR",
    "state": "MAHARASHTRA"
  },
  "443307": {
    "city": "MEHEKAR",
    "state": "MAHARASHTRA"
  },
  "443308": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443401": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443402": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443403": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443404": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "443405": {
    "city": "NANDURA",
    "state": "MAHARASHTRA"
  },
  "443406": {
    "city": "NANDURA",
    "state": "MAHARASHTRA"
  },
  "443407": {
    "city": "NANDURA",
    "state": "MAHARASHTRA"
  },
  "444001": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444002": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444003": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444004": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444005": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444006": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444101": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444102": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444103": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444104": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444105": {
    "city": "Washim",
    "state": "Maharashtra"
  },
  "444106": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444107": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444108": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444109": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444110": {
    "city": "Washim",
    "state": "Maharashtra"
  },
  "444111": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444112": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444113": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444114": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444115": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444116": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444117": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444118": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444119": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444120": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444121": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444122": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444123": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444124": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444125": {
    "city": "AKOLA",
    "state": "MAHARASHTRA"
  },
  "444126": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444129": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444200": {
    "city": "SANGRAMPUR",
    "state": "MAHARASHTRA"
  },
  "444201": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "444202": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "444203": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "444204": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "444301": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "444302": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444303": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "444304": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "444305": {
    "city": "SANGRAMPUR",
    "state": "MAHARASHTRA"
  },
  "444306": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "444307": {
    "city": "BULDANA",
    "state": "MAHARASHTRA"
  },
  "444308": {
    "city": "AKOLA",
    "state": "MAHARASHTRA"
  },
  "444309": {
    "city": "AKOLA",
    "state": "MAHARASHTRA"
  },
  "444311": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444312": {
    "city": "Buldhana",
    "state": "Maharashtra"
  },
  "444401": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444402": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444403": {
    "city": "Washim",
    "state": "Maharashtra"
  },
  "444404": {
    "city": "Washim",
    "state": "Maharashtra"
  },
  "444405": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444406": {
    "city": "MANGRUL PIR",
    "state": "MAHARASHTRA"
  },
  "444407": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444408": {
    "city": "TALEGAON WARDHA",
    "state": "MAHARASHTRA"
  },
  "444409": {
    "city": "Washim",
    "state": "Maharashtra"
  },
  "444410": {
    "city": "MANGRUL PIR",
    "state": "MAHARASHTRA"
  },
  "444441": {
    "city": "MANGRUL PIR",
    "state": "MAHARASHTRA"
  },
  "444442": {
    "city": "MANGRUL PIR",
    "state": "MAHARASHTRA"
  },
  "444444": {
    "city": "MANGRUL PIR",
    "state": "MAHARASHTRA"
  },
  "444445": {
    "city": "MANGRUL PIR",
    "state": "MAHARASHTRA"
  },
  "444501": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444502": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444503": {
    "city": "Washim",
    "state": "Maharashtra"
  },
  "444504": {
    "city": "Washim",
    "state": "Maharashtra"
  },
  "444505": {
    "city": "Washim",
    "state": "Maharashtra"
  },
  "444506": {
    "city": "Washim",
    "state": "Maharashtra"
  },
  "444507": {
    "city": "Washim",
    "state": "Maharashtra"
  },
  "444508": {
    "city": "WASHIM",
    "state": "MAHARASHTRA"
  },
  "444509": {
    "city": "WASHIM",
    "state": "MAHARASHTRA"
  },
  "444510": {
    "city": "Washim",
    "state": "Maharashtra"
  },
  "444511": {
    "city": "Akola",
    "state": "Maharashtra"
  },
  "444512": {
    "city": "PATUR",
    "state": "MAHARASHTRA"
  },
  "444601": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444602": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444603": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444604": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444605": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444606": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444607": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444608": {
    "city": "AMRAVATI",
    "state": "MAHARASHTRA"
  },
  "444609": {
    "city": "AMRAVATI",
    "state": "MAHARASHTRA"
  },
  "444701": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444702": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444703": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444704": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444705": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444706": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444707": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444708": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444709": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444710": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444711": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444712": {
    "city": "DAMANGAON",
    "state": "MAHARASHTRA"
  },
  "444713": {
    "city": "DARYAPUR",
    "state": "MAHARASHTRA"
  },
  "444714": {
    "city": "DAMANGAON",
    "state": "MAHARASHTRA"
  },
  "444715": {
    "city": "DAMANGAON",
    "state": "MAHARASHTRA"
  },
  "444716": {
    "city": "DAMANGAON",
    "state": "MAHARASHTRA"
  },
  "444717": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444718": {
    "city": "AKOT",
    "state": "MAHARASHTRA"
  },
  "444719": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444720": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444721": {
    "city": "CHANDUR BAZAR",
    "state": "MAHARASHTRA"
  },
  "444722": {
    "city": "CHANDUR BAZAR",
    "state": "MAHARASHTRA"
  },
  "444723": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444724": {
    "city": "ACHALPUR",
    "state": "MAHARASHTRA"
  },
  "444725": {
    "city": "ACHALPUR",
    "state": "MAHARASHTRA"
  },
  "444726": {
    "city": "CHANDUR BAZAR",
    "state": "MAHARASHTRA"
  },
  "444727": {
    "city": "ACHALPUR",
    "state": "MAHARASHTRA"
  },
  "444728": {
    "city": "ACHALPUR",
    "state": "MAHARASHTRA"
  },
  "444801": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444802": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444803": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444804": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444805": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444806": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444807": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444808": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444809": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444810": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444811": {
    "city": "CHANDUR BAZAR",
    "state": "MAHARASHTRA"
  },
  "444812": {
    "city": "CHANDUR BAZAR",
    "state": "MAHARASHTRA"
  },
  "444813": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444814": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444815": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444816": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444817": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444818": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444819": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444820": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444821": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444822": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444823": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444824": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444825": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444826": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444827": {
    "city": "DHARNI",
    "state": "MAHARASHTRA"
  },
  "444900": {
    "city": "AMRAVATI",
    "state": "MAHARASHTRA"
  },
  "444901": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444902": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444903": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444904": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444905": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444906": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444907": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444908": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444909": {
    "city": "DAMANGAON",
    "state": "MAHARASHTRA"
  },
  "444910": {
    "city": "WARUD",
    "state": "MAHARASHTRA"
  },
  "444911": {
    "city": "WARUD",
    "state": "MAHARASHTRA"
  },
  "444912": {
    "city": "WARUD",
    "state": "MAHARASHTRA"
  },
  "444913": {
    "city": "WARUD",
    "state": "MAHARASHTRA"
  },
  "444914": {
    "city": "WARUD",
    "state": "MAHARASHTRA"
  },
  "444915": {
    "city": "Amravati",
    "state": "Maharashtra"
  },
  "444921": {
    "city": "WARUD",
    "state": "MAHARASHTRA"
  },
  "445001": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445002": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445003": {
    "city": "YAVATMAL",
    "state": "MAHARASHTRA"
  },
  "445101": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445102": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445103": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445104": {
    "city": "ARNI - MH",
    "state": "MAHARASHTRA"
  },
  "445105": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445106": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445107": {
    "city": "ARNI - MH",
    "state": "MAHARASHTRA"
  },
  "445108": {
    "city": "GHATANJI",
    "state": "MAHARASHTRA"
  },
  "445109": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445110": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445201": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445202": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445203": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445204": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445205": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445206": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445207": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445208": {
    "city": "PUSAD",
    "state": "MAHARASHTRA"
  },
  "445209": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445210": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445211": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445212": {
    "city": "UMARKHED",
    "state": "MAHARASHTRA"
  },
  "445213": {
    "city": "UMARKHED",
    "state": "MAHARASHTRA"
  },
  "445214": {
    "city": "PUSAD",
    "state": "MAHARASHTRA"
  },
  "445215": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445216": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445217": {
    "city": "PUSAD",
    "state": "MAHARASHTRA"
  },
  "445230": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445232": {
    "city": "MAHUR",
    "state": "MAHARASHTRA"
  },
  "445301": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445302": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445303": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445304": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445305": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445306": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445307": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445308": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445309": {
    "city": "WANI - YAVATMAL",
    "state": "MAHARASHTRA"
  },
  "445310": {
    "city": "PANDHARKAWADA",
    "state": "MAHARASHTRA"
  },
  "445311": {
    "city": "PANDHARKAWADA",
    "state": "MAHARASHTRA"
  },
  "445319": {
    "city": "WANI - YAVATMAL",
    "state": "MAHARASHTRA"
  },
  "445322": {
    "city": "PANDHARKAWADA",
    "state": "MAHARASHTRA"
  },
  "445323": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445401": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445402": {
    "city": "Yavatmal",
    "state": "Maharashtra"
  },
  "445677": {
    "city": "HINGANGHAT",
    "state": "MAHARASHTRA"
  },
  "449202": {
    "city": "WARORA",
    "state": "MAHARASHTRA"
  },
  "450001": {
    "city": "East Nimar",
    "state": "Madhya Pradesh"
  },
  "450003": {
    "city": "KHANDWA",
    "state": "MADHYA PRADESH"
  },
  "450006": {
    "city": "KHANDWA",
    "state": "MADHYA PRADESH"
  },
  "450017": {
    "city": "KHANDWA",
    "state": "MADHYA PRADESH"
  },
  "450051": {
    "city": "East Nimar",
    "state": "Madhya Pradesh"
  },
  "450052": {
    "city": "HARSUD",
    "state": "MADHYA PRADESH"
  },
  "450053": {
    "city": "HARSUD",
    "state": "MADHYA PRADESH"
  },
  "450110": {
    "city": "East Nimar",
    "state": "Madhya Pradesh"
  },
  "450111": {
    "city": "MUNDI",
    "state": "MADHYA PRADESH"
  },
  "450112": {
    "city": "East Nimar",
    "state": "Madhya Pradesh"
  },
  "450113": {
    "city": "MUNDI",
    "state": "MADHYA PRADESH"
  },
  "450114": {
    "city": "East Nimar",
    "state": "Madhya Pradesh"
  },
  "450115": {
    "city": "HARSUD",
    "state": "MADHYA PRADESH"
  },
  "450116": {
    "city": "East Nimar",
    "state": "Madhya Pradesh"
  },
  "450117": {
    "city": "East Nimar",
    "state": "Madhya Pradesh"
  },
  "450118": {
    "city": "MUNDI",
    "state": "MADHYA PRADESH"
  },
  "450119": {
    "city": "East Nimar",
    "state": "Madhya Pradesh"
  },
  "450124": {
    "city": "MUNDI",
    "state": "MADHYA PRADESH"
  },
  "450220": {
    "city": "NEPANAGAR",
    "state": "MADHYA PRADESH"
  },
  "450221": {
    "city": "Burhanpur",
    "state": "Madhya Pradesh"
  },
  "450223": {
    "city": "NEPANAGAR",
    "state": "MADHYA PRADESH"
  },
  "450331": {
    "city": "Burhanpur",
    "state": "Madhya Pradesh"
  },
  "450332": {
    "city": "Burhanpur",
    "state": "Madhya Pradesh"
  },
  "450333": {
    "city": "NEPANAGAR",
    "state": "MADHYA PRADESH"
  },
  "450334": {
    "city": "NEPANAGAR",
    "state": "MADHYA PRADESH"
  },
  "450335": {
    "city": "NEPANAGAR",
    "state": "MADHYA PRADESH"
  },
  "450337": {
    "city": "East Nimar",
    "state": "Madhya Pradesh"
  },
  "450338": {
    "city": "PANDHANA",
    "state": "MADHYA PRADESH"
  },
  "450339": {
    "city": "PANDHANA",
    "state": "MADHYA PRADESH"
  },
  "450340": {
    "city": "PANDHANA",
    "state": "MADHYA PRADESH"
  },
  "450341": {
    "city": "PANDHANA",
    "state": "MADHYA PRADESH"
  },
  "450342": {
    "city": "PANDHANA",
    "state": "MADHYA PRADESH"
  },
  "450343": {
    "city": "PANDHANA",
    "state": "MADHYA PRADESH"
  },
  "450346": {
    "city": "PANDHANA",
    "state": "MADHYA PRADESH"
  },
  "450348": {
    "city": "PANDHANA",
    "state": "MADHYA PRADESH"
  },
  "450445": {
    "city": "Burhanpur",
    "state": "Madhya Pradesh"
  },
  "450551": {
    "city": "Khandwa",
    "state": "Madhya Pradesh"
  },
  "450552": {
    "city": "MUNDI",
    "state": "MADHYA PRADESH"
  },
  "450554": {
    "city": "Khandwa",
    "state": "Madhya Pradesh"
  },
  "450555": {
    "city": "BARWAH",
    "state": "MADHYA PRADESH"
  },
  "450661": {
    "city": "East Nimar",
    "state": "Madhya Pradesh"
  },
  "450771": {
    "city": "East Nimar",
    "state": "Madhya Pradesh"
  },
  "450772": {
    "city": "PANDHANA",
    "state": "MADHYA PRADESH"
  },
  "450881": {
    "city": "East Nimar",
    "state": "Madhya Pradesh"
  },
  "450991": {
    "city": "East Nimar",
    "state": "Madhya Pradesh"
  },
  "450992": {
    "city": "MUNDI",
    "state": "MADHYA PRADESH"
  },
  "451001": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451010": {
    "city": "KHARGONE",
    "state": "MADHYA PRADESH"
  },
  "451110": {
    "city": "BARWAH",
    "state": "MADHYA PRADESH"
  },
  "451111": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451112": {
    "city": "BHIKANGAON",
    "state": "MADHYA PRADESH"
  },
  "451113": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451115": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451117": {
    "city": "BARWAH",
    "state": "MADHYA PRADESH"
  },
  "451220": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451221": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451222": {
    "city": "MAHESHWAR",
    "state": "MADHYA PRADESH"
  },
  "451223": {
    "city": "MAHESHWAR",
    "state": "MADHYA PRADESH"
  },
  "451224": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451225": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451228": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451229": {
    "city": "THIKRI/RAJPUR",
    "state": "MADHYA PRADESH"
  },
  "451239": {
    "city": "MAHESHWAR",
    "state": "MADHYA PRADESH"
  },
  "451327": {
    "city": "BHIKANGAON",
    "state": "MADHYA PRADESH"
  },
  "451331": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451332": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451335": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451337": {
    "city": "KHARGONE",
    "state": "MADHYA PRADESH"
  },
  "451338": {
    "city": "KHARGONE",
    "state": "MADHYA PRADESH"
  },
  "451341": {
    "city": "KHARGONE",
    "state": "MADHYA PRADESH"
  },
  "451376": {
    "city": "KHARGONE",
    "state": "MADHYA PRADESH"
  },
  "451381": {
    "city": "KHARGONE",
    "state": "MADHYA PRADESH"
  },
  "451411": {
    "city": "KHARGONE",
    "state": "MADHYA PRADESH"
  },
  "451435": {
    "city": "KHARGONE",
    "state": "MADHYA PRADESH"
  },
  "451440": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451441": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451442": {
    "city": "West Nimar",
    "state": "Madhya Pradesh"
  },
  "451443": {
    "city": "KHARGONE",
    "state": "MADHYA PRADESH"
  },
  "451444": {
    "city": "SENDHWA",
    "state": "MADHYA PRADESH"
  },
  "451447": {
    "city": "Barwani",
    "state": "Madhya Pradesh"
  },
  "451448": {
    "city": "SENDHWA",
    "state": "MADHYA PRADESH"
  },
  "451449": {
    "city": "Barwani",
    "state": "Madhya Pradesh"
  },
  "451451": {
    "city": "SENDHWA",
    "state": "MADHYA PRADESH"
  },
  "451550": {
    "city": "BARWANI",
    "state": "MADHYA PRADESH"
  },
  "451551": {
    "city": "Barwani",
    "state": "Madhya Pradesh"
  },
  "451552": {
    "city": "BARWANI",
    "state": "MADHYA PRADESH"
  },
  "451553": {
    "city": "BARWANI",
    "state": "MADHYA PRADESH"
  },
  "451555": {
    "city": "BARWANI",
    "state": "MADHYA PRADESH"
  },
  "451556": {
    "city": "Barwani",
    "state": "Madhya Pradesh"
  },
  "451557": {
    "city": "BARWANI",
    "state": "MADHYA PRADESH"
  },
  "451558": {
    "city": "BARWANI",
    "state": "MADHYA PRADESH"
  },
  "451559": {
    "city": "BARWANI",
    "state": "MADHYA PRADESH"
  },
  "451563": {
    "city": "BARWANI",
    "state": "MADHYA PRADESH"
  },
  "451659": {
    "city": "THIKRI/RAJPUR",
    "state": "MADHYA PRADESH"
  },
  "451660": {
    "city": "Barwani",
    "state": "Madhya Pradesh"
  },
  "451661": {
    "city": "THIKRI/RAJPUR",
    "state": "MADHYA PRADESH"
  },
  "451663": {
    "city": "THIKRI/RAJPUR",
    "state": "MADHYA PRADESH"
  },
  "451664": {
    "city": "THIKRI/RAJPUR",
    "state": "MADHYA PRADESH"
  },
  "451665": {
    "city": "SENDHWA",
    "state": "MADHYA PRADESH"
  },
  "451666": {
    "city": "Barwani",
    "state": "Madhya Pradesh"
  },
  "451667": {
    "city": "SENDHWA",
    "state": "MADHYA PRADESH"
  },
  "451669": {
    "city": "SENDHWA",
    "state": "MADHYA PRADESH"
  },
  "451695": {
    "city": "SENDHWA",
    "state": "MADHYA PRADESH"
  },
  "451770": {
    "city": "Barwani",
    "state": "Madhya Pradesh"
  },
  "451877": {
    "city": "PANSEMAL",
    "state": "MADHYA PRADESH"
  },
  "451881": {
    "city": "Barwani",
    "state": "Madhya Pradesh"
  },
  "452001": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452002": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452003": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452004": {
    "city": "INDORE",
    "state": "MADHYA PRADESH"
  },
  "452005": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452006": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452007": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452008": {
    "city": "INDORE",
    "state": "MADHYA PRADESH"
  },
  "452009": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452010": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452011": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452012": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452013": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452014": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452015": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452016": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452017": {
    "city": "INDORE",
    "state": "MADHYA PRADESH"
  },
  "452018": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452019": {
    "city": "INDORE",
    "state": "MADHYA PRADESH"
  },
  "452020": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "452023": {
    "city": "SIMROL",
    "state": "MADHYA PRADESH"
  },
  "452052": {
    "city": "SIMROL",
    "state": "MADHYA PRADESH"
  },
  "452056": {
    "city": "INDORE",
    "state": "MADHYA PRADESH"
  },
  "453000": {
    "city": "BETMA",
    "state": "MADHYA PRADESH"
  },
  "453001": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453010": {
    "city": "BETMA",
    "state": "MADHYA PRADESH"
  },
  "453111": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453112": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453115": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453116": {
    "city": "DEPALPUR",
    "state": "MADHYA PRADESH"
  },
  "453220": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453235": {
    "city": "DEPALPUR",
    "state": "MADHYA PRADESH"
  },
  "453236": {
    "city": "DEPALPUR",
    "state": "MADHYA PRADESH"
  },
  "453246": {
    "city": "DEPALPUR",
    "state": "MADHYA PRADESH"
  },
  "453331": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453332": {
    "city": "INDORE",
    "state": "MADHYA PRADESH"
  },
  "453441": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453446": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453463": {
    "city": "SIMROL",
    "state": "MADHYA PRADESH"
  },
  "453477": {
    "city": "SIMROL",
    "state": "MADHYA PRADESH"
  },
  "453485": {
    "city": "SIMROL",
    "state": "MADHYA PRADESH"
  },
  "453488": {
    "city": "SIMROL",
    "state": "MADHYA PRADESH"
  },
  "453490": {
    "city": "SIMROL",
    "state": "MADHYA PRADESH"
  },
  "453495": {
    "city": "SIMROL",
    "state": "MADHYA PRADESH"
  },
  "453530": {
    "city": "SIMROL",
    "state": "MADHYA PRADESH"
  },
  "453545": {
    "city": "SANWER",
    "state": "MADHYA PRADESH"
  },
  "453551": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453552": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453555": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453556": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453562": {
    "city": "INDORE",
    "state": "MADHYA PRADESH"
  },
  "453576": {
    "city": "INDORE",
    "state": "MADHYA PRADESH"
  },
  "453643": {
    "city": "INDORE",
    "state": "MADHYA PRADESH"
  },
  "453652": {
    "city": "BETMA",
    "state": "MADHYA PRADESH"
  },
  "453661": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453771": {
    "city": "Indore",
    "state": "Madhya Pradesh"
  },
  "453777": {
    "city": "INDORE",
    "state": "MADHYA PRADESH"
  },
  "453831": {
    "city": "INDORE",
    "state": "MADHYA PRADESH"
  },
  "453999": {
    "city": "DHAR",
    "state": "MADHYA PRADESH"
  },
  "454001": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454010": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454020": {
    "city": "DHAR",
    "state": "MADHYA PRADESH"
  },
  "454051": {
    "city": "DHAR",
    "state": "MADHYA PRADESH"
  },
  "454102": {
    "city": "RAJGARH-MP",
    "state": "MADHYA PRADESH"
  },
  "454111": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454112": {
    "city": "RAJGARH-MP",
    "state": "MADHYA PRADESH"
  },
  "454116": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454221": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454276": {
    "city": "KUKSHI",
    "state": "MADHYA PRADESH"
  },
  "454280": {
    "city": "KUKSHI",
    "state": "MADHYA PRADESH"
  },
  "454331": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454333": {
    "city": "KUKSHI",
    "state": "MADHYA PRADESH"
  },
  "454334": {
    "city": "BARWANI",
    "state": "MADHYA PRADESH"
  },
  "454335": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454341": {
    "city": "BARWANI",
    "state": "MADHYA PRADESH"
  },
  "454345": {
    "city": "MANAWAR",
    "state": "MADHYA PRADESH"
  },
  "454350": {
    "city": "MANAWAR",
    "state": "MADHYA PRADESH"
  },
  "454365": {
    "city": "KUKSHI",
    "state": "MADHYA PRADESH"
  },
  "454435": {
    "city": "DHAR",
    "state": "MADHYA PRADESH"
  },
  "454441": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454446": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454448": {
    "city": "MANAWAR",
    "state": "MADHYA PRADESH"
  },
  "454449": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454552": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454554": {
    "city": "DHARAMPURI",
    "state": "MADHYA PRADESH"
  },
  "454560": {
    "city": "DHARAMPURI",
    "state": "MADHYA PRADESH"
  },
  "454571": {
    "city": "DHARAMPURI",
    "state": "MADHYA PRADESH"
  },
  "454648": {
    "city": "BADNAWAR",
    "state": "MADHYA PRADESH"
  },
  "454660": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454665": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454666": {
    "city": "BADNAWAR",
    "state": "MADHYA PRADESH"
  },
  "454667": {
    "city": "BADNAWAR",
    "state": "MADHYA PRADESH"
  },
  "454668": {
    "city": "BADNAWAR",
    "state": "MADHYA PRADESH"
  },
  "454669": {
    "city": "BADNAWAR",
    "state": "MADHYA PRADESH"
  },
  "454678": {
    "city": "BADNAWAR",
    "state": "MADHYA PRADESH"
  },
  "454729": {
    "city": "BADNAWAR",
    "state": "MADHYA PRADESH"
  },
  "454730": {
    "city": "BADNAWAR",
    "state": "MADHYA PRADESH"
  },
  "454749": {
    "city": "BADNAWAR",
    "state": "MADHYA PRADESH"
  },
  "454772": {
    "city": "PITHAMPUR",
    "state": "MADHYA PRADESH"
  },
  "454773": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454774": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "454775": {
    "city": "Dhar",
    "state": "Madhya Pradesh"
  },
  "455001": {
    "city": "Dewas",
    "state": "Madhya Pradesh"
  },
  "455002": {
    "city": "DEWAS",
    "state": "MADHYA PRADESH"
  },
  "455003": {
    "city": "DEWAS",
    "state": "MADHYA PRADESH"
  },
  "455048": {
    "city": "DEWAS",
    "state": "MADHYA PRADESH"
  },
  "455111": {
    "city": "Dewas",
    "state": "Madhya Pradesh"
  },
  "455112": {
    "city": "HATPIPLIYA",
    "state": "MADHYA PRADESH"
  },
  "455113": {
    "city": "DEWAS",
    "state": "MADHYA PRADESH"
  },
  "455114": {
    "city": "DEWAS",
    "state": "MADHYA PRADESH"
  },
  "455115": {
    "city": "Dewas",
    "state": "Madhya Pradesh"
  },
  "455116": {
    "city": "Dewas",
    "state": "Madhya Pradesh"
  },
  "455117": {
    "city": "SONKATCH",
    "state": "MADHYA PRADESH"
  },
  "455118": {
    "city": "Dewas",
    "state": "Madhya Pradesh"
  },
  "455119": {
    "city": "SONKATCH",
    "state": "MADHYA PRADESH"
  },
  "455120": {
    "city": "SONKATCH",
    "state": "MADHYA PRADESH"
  },
  "455133": {
    "city": "SONKATCH",
    "state": "MADHYA PRADESH"
  },
  "455178": {
    "city": "SONKATCH",
    "state": "MADHYA PRADESH"
  },
  "455179": {
    "city": "SONKATCH",
    "state": "MADHYA PRADESH"
  },
  "455180": {
    "city": "SONKATCH",
    "state": "MADHYA PRADESH"
  },
  "455221": {
    "city": "Dewas",
    "state": "Madhya Pradesh"
  },
  "455223": {
    "city": "Dewas",
    "state": "Madhya Pradesh"
  },
  "455224": {
    "city": "DEWAS",
    "state": "MADHYA PRADESH"
  },
  "455225": {
    "city": "HATPIPLIYA",
    "state": "MADHYA PRADESH"
  },
  "455227": {
    "city": "Dewas",
    "state": "Madhya Pradesh"
  },
  "455302": {
    "city": "BAGLI",
    "state": "MADHYA PRADESH"
  },
  "455305": {
    "city": "BAGLI",
    "state": "MADHYA PRADESH"
  },
  "455308": {
    "city": "BAGLI",
    "state": "MADHYA PRADESH"
  },
  "455311": {
    "city": "BAGLI",
    "state": "MADHYA PRADESH"
  },
  "455332": {
    "city": "Dewas",
    "state": "Madhya Pradesh"
  },
  "455334": {
    "city": "KANNOD",
    "state": "MADHYA PRADESH"
  },
  "455335": {
    "city": "KHATEGAON",
    "state": "MADHYA PRADESH"
  },
  "455336": {
    "city": "Dewas",
    "state": "Madhya Pradesh"
  },
  "455337": {
    "city": "KHATEGAON",
    "state": "MADHYA PRADESH"
  },
  "455339": {
    "city": "Dewas",
    "state": "Madhya Pradesh"
  },
  "455342": {
    "city": "KHATEGAON",
    "state": "MADHYA PRADESH"
  },
  "455344": {
    "city": "KHATEGAON",
    "state": "MADHYA PRADESH"
  },
  "455348": {
    "city": "KHATEGAON",
    "state": "MADHYA PRADESH"
  },
  "455435": {
    "city": "BAGLI",
    "state": "MADHYA PRADESH"
  },
  "455440": {
    "city": "Dewas",
    "state": "Madhya Pradesh"
  },
  "455445": {
    "city": "BAGLI",
    "state": "MADHYA PRADESH"
  },
  "455459": {
    "city": "Dewas",
    "state": "Madhya Pradesh"
  },
  "455463": {
    "city": "KANNOD",
    "state": "MADHYA PRADESH"
  },
  "455467": {
    "city": "KANNOD",
    "state": "MADHYA PRADESH"
  },
  "455480": {
    "city": "KANNOD",
    "state": "MADHYA PRADESH"
  },
  "455552": {
    "city": "KANNOD",
    "state": "MADHYA PRADESH"
  },
  "456001": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456002": {
    "city": "UJJAIN",
    "state": "MADHYA PRADESH"
  },
  "456003": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456004": {
    "city": "UJJAIN",
    "state": "MADHYA PRADESH"
  },
  "456005": {
    "city": "UJJAIN",
    "state": "MADHYA PRADESH"
  },
  "456006": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456007": {
    "city": "UJJAIN",
    "state": "MADHYA PRADESH"
  },
  "456008": {
    "city": "UJJAIN",
    "state": "MADHYA PRADESH"
  },
  "456009": {
    "city": "UJJAIN",
    "state": "MADHYA PRADESH"
  },
  "456010": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456213": {
    "city": "MAHIDPUR",
    "state": "MADHYA PRADESH"
  },
  "456221": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456222": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456224": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456300": {
    "city": "NAGDA",
    "state": "MADHYA PRADESH"
  },
  "456313": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456331": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456335": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456337": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456440": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456441": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456443": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456444": {
    "city": "MAHIDPUR",
    "state": "MADHYA PRADESH"
  },
  "456445": {
    "city": "MAHIDPUR",
    "state": "MADHYA PRADESH"
  },
  "456446": {
    "city": "MAHIDPUR",
    "state": "MADHYA PRADESH"
  },
  "456450": {
    "city": "MAHIDPUR",
    "state": "MADHYA PRADESH"
  },
  "456452": {
    "city": "MAHIDPUR",
    "state": "MADHYA PRADESH"
  },
  "456457": {
    "city": "MAHIDPUR",
    "state": "MADHYA PRADESH"
  },
  "456550": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456551": {
    "city": "TARANA",
    "state": "MADHYA PRADESH"
  },
  "456552": {
    "city": "TARANA",
    "state": "MADHYA PRADESH"
  },
  "456661": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456662": {
    "city": "UJJAIN",
    "state": "MADHYA PRADESH"
  },
  "456663": {
    "city": "SANWER",
    "state": "MADHYA PRADESH"
  },
  "456664": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456665": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456666": {
    "city": "TARANA",
    "state": "MADHYA PRADESH"
  },
  "456668": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456673": {
    "city": "TARANA",
    "state": "MADHYA PRADESH"
  },
  "456770": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456771": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "456773": {
    "city": "BADNAGAR",
    "state": "MADHYA PRADESH"
  },
  "456776": {
    "city": "Ujjain",
    "state": "Madhya Pradesh"
  },
  "457001": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457002": {
    "city": "RATLAM",
    "state": "MADHYA PRADESH"
  },
  "457003": {
    "city": "RATLAM",
    "state": "MADHYA PRADESH"
  },
  "457111": {
    "city": "RATLAM",
    "state": "MADHYA PRADESH"
  },
  "457112": {
    "city": "RATLAM",
    "state": "MADHYA PRADESH"
  },
  "457114": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457115": {
    "city": "A LOT",
    "state": "MADHYA PRADESH"
  },
  "457118": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457119": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457222": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457223": {
    "city": "JAORA",
    "state": "MADHYA PRADESH"
  },
  "457226": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457227": {
    "city": "JAORA",
    "state": "MADHYA PRADESH"
  },
  "457228": {
    "city": "JAORA",
    "state": "MADHYA PRADESH"
  },
  "457330": {
    "city": "JAORA",
    "state": "MADHYA PRADESH"
  },
  "457331": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457332": {
    "city": "JAORA",
    "state": "MADHYA PRADESH"
  },
  "457333": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457334": {
    "city": "JAORA",
    "state": "MADHYA PRADESH"
  },
  "457335": {
    "city": "JAORA",
    "state": "MADHYA PRADESH"
  },
  "457336": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457337": {
    "city": "JAORA",
    "state": "MADHYA PRADESH"
  },
  "457339": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457340": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457426": {
    "city": "JAORA",
    "state": "MADHYA PRADESH"
  },
  "457440": {
    "city": "RATLAM",
    "state": "MADHYA PRADESH"
  },
  "457441": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457550": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457551": {
    "city": "RATLAM",
    "state": "MADHYA PRADESH"
  },
  "457552": {
    "city": "RATLAM",
    "state": "MADHYA PRADESH"
  },
  "457553": {
    "city": "RATLAM",
    "state": "MADHYA PRADESH"
  },
  "457555": {
    "city": "Ratlam",
    "state": "Madhya Pradesh"
  },
  "457556": {
    "city": "THANDLA",
    "state": "MADHYA PRADESH"
  },
  "457583": {
    "city": "THANDLA",
    "state": "MADHYA PRADESH"
  },
  "457661": {
    "city": "Jhabua",
    "state": "Madhya Pradesh"
  },
  "457662": {
    "city": "JHABUA",
    "state": "MADHYA PRADESH"
  },
  "457664": {
    "city": "JHABUA",
    "state": "MADHYA PRADESH"
  },
  "457665": {
    "city": "JHABUA",
    "state": "MADHYA PRADESH"
  },
  "457769": {
    "city": "RATLAM",
    "state": "MADHYA PRADESH"
  },
  "457770": {
    "city": "Jhabua",
    "state": "Madhya Pradesh"
  },
  "457771": {
    "city": "THANDLA",
    "state": "MADHYA PRADESH"
  },
  "457772": {
    "city": "Jhabua",
    "state": "Madhya Pradesh"
  },
  "457773": {
    "city": "Jhabua",
    "state": "Madhya Pradesh"
  },
  "457774": {
    "city": "RAJGARH-MP",
    "state": "MADHYA PRADESH"
  },
  "457775": {
    "city": "Jhabua",
    "state": "Madhya Pradesh"
  },
  "457776": {
    "city": "THANDLA",
    "state": "MADHYA PRADESH"
  },
  "457777": {
    "city": "Jhabua",
    "state": "Madhya Pradesh"
  },
  "457778": {
    "city": "JHABUA",
    "state": "MADHYA PRADESH"
  },
  "457779": {
    "city": "Jhabua",
    "state": "Madhya Pradesh"
  },
  "457780": {
    "city": "JHABUA",
    "state": "MADHYA PRADESH"
  },
  "457880": {
    "city": "JHABUA",
    "state": "MADHYA PRADESH"
  },
  "457881": {
    "city": "BHABRA",
    "state": "MADHYA PRADESH"
  },
  "457882": {
    "city": "Jhabua",
    "state": "Madhya Pradesh"
  },
  "457883": {
    "city": "BHABRA",
    "state": "MADHYA PRADESH"
  },
  "457884": {
    "city": "BHABRA",
    "state": "MADHYA PRADESH"
  },
  "457885": {
    "city": "Alirajpur",
    "state": "Madhya Pradesh"
  },
  "457886": {
    "city": "ALIRAJPUR",
    "state": "MADHYA PRADESH"
  },
  "457887": {
    "city": "Alirajpur",
    "state": "Madhya Pradesh"
  },
  "457888": {
    "city": "Alirajpur",
    "state": "Madhya Pradesh"
  },
  "457889": {
    "city": "ALIRAJPUR",
    "state": "MADHYA PRADESH"
  },
  "457890": {
    "city": "ALIRAJPUR",
    "state": "MADHYA PRADESH"
  },
  "457891": {
    "city": "ALIRAJPUR",
    "state": "MADHYA PRADESH"
  },
  "457892": {
    "city": "ALIRAJPUR",
    "state": "MADHYA PRADESH"
  },
  "457893": {
    "city": "ALIRAJPUR",
    "state": "MADHYA PRADESH"
  },
  "457990": {
    "city": "Jhabua",
    "state": "Madhya Pradesh"
  },
  "457991": {
    "city": "ALIRAJPUR",
    "state": "MADHYA PRADESH"
  },
  "457993": {
    "city": "Jhabua",
    "state": "Madhya Pradesh"
  },
  "457994": {
    "city": "JOBAT",
    "state": "MADHYA PRADESH"
  },
  "457995": {
    "city": "JOBAT",
    "state": "MADHYA PRADESH"
  },
  "457996": {
    "city": "JOBAT",
    "state": "MADHYA PRADESH"
  },
  "458001": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458002": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458110": {
    "city": "Neemuch",
    "state": "Madhya Pradesh"
  },
  "458113": {
    "city": "Neemuch",
    "state": "Madhya Pradesh"
  },
  "458116": {
    "city": "Neemuch",
    "state": "Madhya Pradesh"
  },
  "458118": {
    "city": "Neemuch",
    "state": "Madhya Pradesh"
  },
  "458220": {
    "city": "Neemuch",
    "state": "Madhya Pradesh"
  },
  "458224": {
    "city": "MANASA",
    "state": "MADHYA PRADESH"
  },
  "458226": {
    "city": "Neemuch",
    "state": "Madhya Pradesh"
  },
  "458228": {
    "city": "Neemuch",
    "state": "Madhya Pradesh"
  },
  "458232": {
    "city": "MANASA",
    "state": "MADHYA PRADESH"
  },
  "458254": {
    "city": "MANASA",
    "state": "MADHYA PRADESH"
  },
  "458265": {
    "city": "MANASA",
    "state": "MADHYA PRADESH"
  },
  "458272": {
    "city": "MANASA",
    "state": "MADHYA PRADESH"
  },
  "458330": {
    "city": "Neemuch",
    "state": "Madhya Pradesh"
  },
  "458335": {
    "city": "JIRAN",
    "state": "MADHYA PRADESH"
  },
  "458336": {
    "city": "Neemuch",
    "state": "Madhya Pradesh"
  },
  "458338": {
    "city": "MANDSAUR",
    "state": "MADHYA PRADESH"
  },
  "458339": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458348": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458354": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458376": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458382": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458385": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458389": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458393": {
    "city": "SITAMAU",
    "state": "MADHYA PRADESH"
  },
  "458441": {
    "city": "Neemuch",
    "state": "Madhya Pradesh"
  },
  "458442": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458445": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458468": {
    "city": "Neemuch",
    "state": "Madhya Pradesh"
  },
  "458470": {
    "city": "Neemuch",
    "state": "Madhya Pradesh"
  },
  "458474": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458485": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458491": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458493": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458495": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458499": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458521": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458525": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458538": {
    "city": "NIMACH",
    "state": "MADHYA PRADESH"
  },
  "458553": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458556": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458558": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458576": {
    "city": "SITAMAU",
    "state": "MADHYA PRADESH"
  },
  "458581": {
    "city": "SITAMAU",
    "state": "MADHYA PRADESH"
  },
  "458588": {
    "city": "SITAMAU",
    "state": "MADHYA PRADESH"
  },
  "458595": {
    "city": "SITAMAU",
    "state": "MADHYA PRADESH"
  },
  "458660": {
    "city": "MANDSAUR",
    "state": "MADHYA PRADESH"
  },
  "458664": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458667": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458668": {
    "city": "SITAMAU",
    "state": "MADHYA PRADESH"
  },
  "458669": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458676": {
    "city": "SITAMAU",
    "state": "MADHYA PRADESH"
  },
  "458688": {
    "city": "SITAMAU",
    "state": "MADHYA PRADESH"
  },
  "458770": {
    "city": "BHANPURA",
    "state": "MADHYA PRADESH"
  },
  "458771": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458772": {
    "city": "BHANPURA",
    "state": "MADHYA PRADESH"
  },
  "458775": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458777": {
    "city": "BHANPURA",
    "state": "MADHYA PRADESH"
  },
  "458778": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458880": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458883": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458886": {
    "city": "SHAMGARH",
    "state": "MADHYA PRADESH"
  },
  "458888": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458889": {
    "city": "MANDSAUR",
    "state": "MADHYA PRADESH"
  },
  "458895": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "458976": {
    "city": "MANDSAUR",
    "state": "MADHYA PRADESH"
  },
  "458982": {
    "city": "MANDSAUR",
    "state": "MADHYA PRADESH"
  },
  "458990": {
    "city": "Mandsaur",
    "state": "Madhya Pradesh"
  },
  "460001": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460002": {
    "city": "BETUL",
    "state": "MADHYA PRADESH"
  },
  "460004": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460005": {
    "city": "BETUL",
    "state": "MADHYA PRADESH"
  },
  "460008": {
    "city": "BETUL",
    "state": "MADHYA PRADESH"
  },
  "460050": {
    "city": "BETUL",
    "state": "MADHYA PRADESH"
  },
  "460110": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460111": {
    "city": "BHAINSDEHI",
    "state": "MADHYA PRADESH"
  },
  "460220": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460225": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460226": {
    "city": "BHAINSDEHI",
    "state": "MADHYA PRADESH"
  },
  "460329": {
    "city": "SHAHPUR",
    "state": "MADHYA PRADESH"
  },
  "460330": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460400": {
    "city": "SHAHPUR",
    "state": "MADHYA PRADESH"
  },
  "460440": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460443": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460444": {
    "city": "SHAHPUR",
    "state": "MADHYA PRADESH"
  },
  "460447": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460449": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460551": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460553": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460554": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460557": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460660": {
    "city": "MULTAI",
    "state": "MADHYA PRADESH"
  },
  "460661": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460663": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460665": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460666": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460667": {
    "city": "MULTAI",
    "state": "MADHYA PRADESH"
  },
  "460668": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "460669": {
    "city": "MULTAI",
    "state": "MADHYA PRADESH"
  },
  "461001": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461005": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461110": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461111": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461114": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461115": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461116": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461118": {
    "city": "ITARSI",
    "state": "MADHYA PRADESH"
  },
  "461122": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461166": {
    "city": "ITARSI",
    "state": "MADHYA PRADESH"
  },
  "461221": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461222": {
    "city": "SEONI-MALWA",
    "state": "MADHYA PRADESH"
  },
  "461223": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461224": {
    "city": "SEONI-MALWA",
    "state": "MADHYA PRADESH"
  },
  "461225": {
    "city": "SEONI-MALWA",
    "state": "MADHYA PRADESH"
  },
  "461227": {
    "city": "SIRALI",
    "state": "MADHYA PRADESH"
  },
  "461228": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461251": {
    "city": "SIRALI",
    "state": "MADHYA PRADESH"
  },
  "461281": {
    "city": "SIRALI",
    "state": "MADHYA PRADESH"
  },
  "461331": {
    "city": "Harda",
    "state": "Madhya Pradesh"
  },
  "461335": {
    "city": "SIRALI",
    "state": "MADHYA PRADESH"
  },
  "461338": {
    "city": "HARDA",
    "state": "MADHYA PRADESH"
  },
  "461381": {
    "city": "HARDA",
    "state": "MADHYA PRADESH"
  },
  "461427": {
    "city": "SIRALI",
    "state": "MADHYA PRADESH"
  },
  "461441": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461444": {
    "city": "SIRALI",
    "state": "MADHYA PRADESH"
  },
  "461445": {
    "city": "ITARSI",
    "state": "MADHYA PRADESH"
  },
  "461446": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461551": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461553": {
    "city": "ITARSI",
    "state": "MADHYA PRADESH"
  },
  "461555": {
    "city": "ITARSI",
    "state": "MADHYA PRADESH"
  },
  "461661": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461668": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461771": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461772": {
    "city": "PIPARIYA",
    "state": "MADHYA PRADESH"
  },
  "461775": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461785": {
    "city": "PIPARIYA",
    "state": "MADHYA PRADESH"
  },
  "461881": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "461951": {
    "city": "PIPARIYA",
    "state": "MADHYA PRADESH"
  },
  "461990": {
    "city": "Hoshangabad",
    "state": "Madhya Pradesh"
  },
  "462001": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462002": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462003": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462004": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462005": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462006": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462007": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462008": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462010": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462011": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462012": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462013": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462014": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462015": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462016": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462017": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462018": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462019": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462020": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462021": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462022": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462023": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462024": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462025": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462026": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462027": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462028": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462029": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462030": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462031": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462032": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462033": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462034": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462035": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462036": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462037": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462038": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462039": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462040": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462041": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462042": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462043": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462044": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462045": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462046": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "462047": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462048": {
    "city": "MANDIDEEP",
    "state": "MADHYA PRADESH"
  },
  "462051": {
    "city": "BHOPAL",
    "state": "MADHYA PRADESH"
  },
  "462066": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462100": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462101": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "462120": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "463106": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "463111": {
    "city": "Bhopal",
    "state": "Madhya Pradesh"
  },
  "463120": {
    "city": "BERASIA",
    "state": "MADHYA PRADESH"
  },
  "464001": {
    "city": "Vidisha",
    "state": "Madhya Pradesh"
  },
  "464002": {
    "city": "VIDISHA",
    "state": "MADHYA PRADESH"
  },
  "464010": {
    "city": "VIDISHA",
    "state": "MADHYA PRADESH"
  },
  "464016": {
    "city": "VIDISHA",
    "state": "MADHYA PRADESH"
  },
  "464101": {
    "city": "BERASIA",
    "state": "MADHYA PRADESH"
  },
  "464111": {
    "city": "Vidisha",
    "state": "Madhya Pradesh"
  },
  "464112": {
    "city": "VIDISHA",
    "state": "MADHYA PRADESH"
  },
  "464113": {
    "city": "Vidisha",
    "state": "Madhya Pradesh"
  },
  "464114": {
    "city": "Vidisha",
    "state": "Madhya Pradesh"
  },
  "464118": {
    "city": "LATERI",
    "state": "MADHYA PRADESH"
  },
  "464220": {
    "city": "Vidisha",
    "state": "Madhya Pradesh"
  },
  "464221": {
    "city": "Vidisha",
    "state": "Madhya Pradesh"
  },
  "464224": {
    "city": "Vidisha",
    "state": "Madhya Pradesh"
  },
  "464226": {
    "city": "Vidisha",
    "state": "Madhya Pradesh"
  },
  "464228": {
    "city": "Vidisha",
    "state": "Madhya Pradesh"
  },
  "464240": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "464258": {
    "city": "Vidisha",
    "state": "Madhya Pradesh"
  },
  "464331": {
    "city": "Vidisha",
    "state": "Madhya Pradesh"
  },
  "464334": {
    "city": "Vidisha",
    "state": "Madhya Pradesh"
  },
  "464337": {
    "city": "Vidisha",
    "state": "Madhya Pradesh"
  },
  "464551": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464556": {
    "city": "RAISEN",
    "state": "MADHYA PRADESH"
  },
  "464570": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464573": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464651": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464661": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464665": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464668": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464670": {
    "city": "BARELI",
    "state": "MADHYA PRADESH"
  },
  "464671": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464672": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464676": {
    "city": "SILWANI",
    "state": "MADHYA PRADESH"
  },
  "464770": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464774": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464776": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464881": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464884": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464886": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464986": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464990": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464993": {
    "city": "Raisen",
    "state": "Madhya Pradesh"
  },
  "464995": {
    "city": "MANDIDEEP",
    "state": "MADHYA PRADESH"
  },
  "464996": {
    "city": "MANDIDEEP",
    "state": "MADHYA PRADESH"
  },
  "465001": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465106": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465110": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465113": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465116": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465118": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465220": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465221": {
    "city": "SHAJAPUR",
    "state": "MADHYA PRADESH"
  },
  "465223": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465226": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465227": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465230": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465231": {
    "city": "AGAR",
    "state": "MADHYA PRADESH"
  },
  "465331": {
    "city": "SHUJALPUR",
    "state": "MADHYA PRADESH"
  },
  "465333": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465335": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465336": {
    "city": "SHUJALPUR",
    "state": "MADHYA PRADESH"
  },
  "465337": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465339": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465418": {
    "city": "SHUJALPUR",
    "state": "MADHYA PRADESH"
  },
  "465440": {
    "city": "SOYAT KALAN",
    "state": "MADHYA PRADESH"
  },
  "465441": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465445": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465446": {
    "city": "Nalkheda",
    "state": "MADHYA PRADESH"
  },
  "465447": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465448": {
    "city": "Nalkheda",
    "state": "MADHYA PRADESH"
  },
  "465449": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465516": {
    "city": "AGAR",
    "state": "MADHYA PRADESH"
  },
  "465550": {
    "city": "Shajapur",
    "state": "Madhya Pradesh"
  },
  "465567": {
    "city": "AGAR",
    "state": "MADHYA PRADESH"
  },
  "465597": {
    "city": "AGAR",
    "state": "MADHYA PRADESH"
  },
  "465661": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465667": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465669": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465670": {
    "city": "NARSINGHGARH",
    "state": "MADHYA PRADESH"
  },
  "465672": {
    "city": "NARSINGHGARH",
    "state": "MADHYA PRADESH"
  },
  "465674": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465677": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465679": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465680": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465683": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465685": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465686": {
    "city": "SARANGPUR",
    "state": "MADHYA PRADESH"
  },
  "465687": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465689": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465691": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465693": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465695": {
    "city": "SARANGPUR",
    "state": "MADHYA PRADESH"
  },
  "465697": {
    "city": "Rajgarh",
    "state": "Madhya Pradesh"
  },
  "465889": {
    "city": "SARANGPUR",
    "state": "MADHYA PRADESH"
  },
  "465977": {
    "city": "SEHORE",
    "state": "MADHYA PRADESH"
  },
  "466001": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466002": {
    "city": "SEHORE",
    "state": "MADHYA PRADESH"
  },
  "466003": {
    "city": "SEHORE",
    "state": "MADHYA PRADESH"
  },
  "466011": {
    "city": "SEHORE",
    "state": "MADHYA PRADESH"
  },
  "466111": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466112": {
    "city": "SEHORE",
    "state": "MADHYA PRADESH"
  },
  "466113": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466114": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466115": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466116": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466117": {
    "city": "ASHTA",
    "state": "MADHYA PRADESH"
  },
  "466118": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466119": {
    "city": "ASHTA",
    "state": "MADHYA PRADESH"
  },
  "466120": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466125": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466221": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466331": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466445": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466446": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466448": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466554": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466644": {
    "city": "SEHORE",
    "state": "MADHYA PRADESH"
  },
  "466651": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466661": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466665": {
    "city": "Sehore",
    "state": "Madhya Pradesh"
  },
  "466666": {
    "city": "PANVEL",
    "state": "MAHARASHTRA"
  },
  "470000": {
    "city": "SAGAR",
    "state": "MADHYA PRADESH"
  },
  "470001": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470002": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470003": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470004": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470005": {
    "city": "SAGAR",
    "state": "MADHYA PRADESH"
  },
  "470006": {
    "city": "SAGAR",
    "state": "MADHYA PRADESH"
  },
  "470007": {
    "city": "SAGAR",
    "state": "MADHYA PRADESH"
  },
  "470008": {
    "city": "SAGAR",
    "state": "MADHYA PRADESH"
  },
  "470013": {
    "city": "SAGAR",
    "state": "MADHYA PRADESH"
  },
  "470021": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470051": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470111": {
    "city": "BINA",
    "state": "MADHYA PRADESH"
  },
  "470113": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470114": {
    "city": "SAGAR",
    "state": "MADHYA PRADESH"
  },
  "470115": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470117": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470118": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470119": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470120": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470121": {
    "city": "RAHATGARH",
    "state": "MADHYA PRADESH"
  },
  "470122": {
    "city": "RAHATGARH",
    "state": "MADHYA PRADESH"
  },
  "470124": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470125": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470221": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470223": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470226": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470227": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470228": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470229": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470230": {
    "city": "GARHAKOTA",
    "state": "MADHYA PRADESH"
  },
  "470232": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470235": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470335": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470337": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470339": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470341": {
    "city": "SHAHGARH",
    "state": "MADHYA PRADESH"
  },
  "470441": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470442": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470661": {
    "city": "Damoh",
    "state": "Madhya Pradesh"
  },
  "470662": {
    "city": "DAMOH",
    "state": "MADHYA PRADESH"
  },
  "470663": {
    "city": "Damoh",
    "state": "Madhya Pradesh"
  },
  "470664": {
    "city": "Damoh",
    "state": "Madhya Pradesh"
  },
  "470666": {
    "city": "Damoh",
    "state": "Madhya Pradesh"
  },
  "470669": {
    "city": "Sagar",
    "state": "Madhya Pradesh"
  },
  "470672": {
    "city": "Damoh",
    "state": "Madhya Pradesh"
  },
  "470673": {
    "city": "Damoh",
    "state": "Madhya Pradesh"
  },
  "470675": {
    "city": "Damoh",
    "state": "Madhya Pradesh"
  },
  "470771": {
    "city": "Damoh",
    "state": "Madhya Pradesh"
  },
  "470772": {
    "city": "Damoh",
    "state": "Madhya Pradesh"
  },
  "470773": {
    "city": "HATTA",
    "state": "MADHYA PRADESH"
  },
  "470775": {
    "city": "Damoh",
    "state": "Madhya Pradesh"
  },
  "470880": {
    "city": "Damoh",
    "state": "Madhya Pradesh"
  },
  "470881": {
    "city": "Damoh",
    "state": "Madhya Pradesh"
  },
  "471001": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471101": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471105": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471111": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471123": {
    "city": "HARPALPUR",
    "state": "MADHYA PRADESH"
  },
  "471150": {
    "city": "HARPALPUR",
    "state": "MADHYA PRADESH"
  },
  "471201": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471202": {
    "city": "NOWGONG",
    "state": "MADHYA PRADESH"
  },
  "471227": {
    "city": "BALOD",
    "state": "CHHATTISGARH"
  },
  "471301": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471311": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471313": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471315": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471318": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471401": {
    "city": "BIJAWAR",
    "state": "MADHYA PRADESH"
  },
  "471405": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471406": {
    "city": "BIJAWAR",
    "state": "MADHYA PRADESH"
  },
  "471408": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471411": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471501": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471505": {
    "city": "KHAJURAHO",
    "state": "MADHYA PRADESH"
  },
  "471510": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471515": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471516": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471525": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471606": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "471625": {
    "city": "Chhatarpur",
    "state": "Madhya Pradesh"
  },
  "472001": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472005": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472010": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472101": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472111": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472115": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472118": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472221": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472246": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472331": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472336": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472337": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472338": {
    "city": "PRITHVIPUR",
    "state": "MADHYA PRADESH"
  },
  "472339": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472442": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472445": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472446": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "472447": {
    "city": "Tikamgarh",
    "state": "Madhya Pradesh"
  },
  "473001": {
    "city": "Guna",
    "state": "Madhya Pradesh"
  },
  "473002": {
    "city": "GUNA",
    "state": "MADHYA PRADESH"
  },
  "473101": {
    "city": "Guna",
    "state": "Madhya Pradesh"
  },
  "473105": {
    "city": "Guna",
    "state": "Madhya Pradesh"
  },
  "473110": {
    "city": "Guna",
    "state": "Madhya Pradesh"
  },
  "473111": {
    "city": "Guna",
    "state": "Madhya Pradesh"
  },
  "473112": {
    "city": "Guna",
    "state": "Madhya Pradesh"
  },
  "473113": {
    "city": "Guna",
    "state": "Madhya Pradesh"
  },
  "473115": {
    "city": "Guna",
    "state": "Madhya Pradesh"
  },
  "473118": {
    "city": "Guna",
    "state": "Madhya Pradesh"
  },
  "473222": {
    "city": "Guna",
    "state": "Madhya Pradesh"
  },
  "473226": {
    "city": "Guna",
    "state": "Madhya Pradesh"
  },
  "473229": {
    "city": "GUNA",
    "state": "MADHYA PRADESH"
  },
  "473249": {
    "city": "Guna",
    "state": "Madhya Pradesh"
  },
  "473287": {
    "city": "Guna",
    "state": "Madhya Pradesh"
  },
  "473330": {
    "city": "Ashok Nagar",
    "state": "Madhya Pradesh"
  },
  "473331": {
    "city": "Ashok Nagar",
    "state": "Madhya Pradesh"
  },
  "473332": {
    "city": "Ashok Nagar",
    "state": "Madhya Pradesh"
  },
  "473333": {
    "city": "BADARWAS",
    "state": "MADHYA PRADESH"
  },
  "473335": {
    "city": "Ashok Nagar",
    "state": "Madhya Pradesh"
  },
  "473338": {
    "city": "ISAGARH",
    "state": "MADHYA PRADESH"
  },
  "473440": {
    "city": "Ashok Nagar",
    "state": "Madhya Pradesh"
  },
  "473443": {
    "city": "Ashok Nagar",
    "state": "Madhya Pradesh"
  },
  "473444": {
    "city": "Ashok Nagar",
    "state": "Madhya Pradesh"
  },
  "473445": {
    "city": "Ashok Nagar",
    "state": "Madhya Pradesh"
  },
  "473446": {
    "city": "Ashok Nagar",
    "state": "Madhya Pradesh"
  },
  "473551": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473554": {
    "city": "SHIVPURI",
    "state": "MADHYA PRADESH"
  },
  "473583": {
    "city": "CHANDERI",
    "state": "MADHYA PRADESH"
  },
  "473585": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473638": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473660": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473662": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473664": {
    "city": "DATIA",
    "state": "MADHYA PRADESH"
  },
  "473665": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473670": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473770": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473774": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473775": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473781": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473785": {
    "city": "BADARWAS",
    "state": "MADHYA PRADESH"
  },
  "473793": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473865": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473880": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473885": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473990": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "473993": {
    "city": "PICHHORE",
    "state": "MADHYA PRADESH"
  },
  "473995": {
    "city": "Shivpuri",
    "state": "Madhya Pradesh"
  },
  "474001": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474002": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474003": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474004": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474005": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474006": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474007": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474008": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474009": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474010": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474011": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474012": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474013": {
    "city": "GWALIOR",
    "state": "MADHYA PRADESH"
  },
  "474015": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474020": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "474040": {
    "city": "GWALIOR",
    "state": "MADHYA PRADESH"
  },
  "474041": {
    "city": "GWALIOR",
    "state": "MADHYA PRADESH"
  },
  "474042": {
    "city": "GWALIOR",
    "state": "MADHYA PRADESH"
  },
  "474050": {
    "city": "GWALIOR",
    "state": "MADHYA PRADESH"
  },
  "474055": {
    "city": "GWALIOR",
    "state": "MADHYA PRADESH"
  },
  "475001": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "475002": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "475003": {
    "city": "PICHHORE",
    "state": "MADHYA PRADESH"
  },
  "475005": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "475110": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "475112": {
    "city": "DABRA-MP",
    "state": "MADHYA PRADESH"
  },
  "475115": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "475220": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "475330": {
    "city": "Gwalior",
    "state": "Madhya Pradesh"
  },
  "475335": {
    "city": "Datia",
    "state": "Madhya Pradesh"
  },
  "475336": {
    "city": "Datia",
    "state": "Madhya Pradesh"
  },
  "475533": {
    "city": "BHANDER",
    "state": "MADHYA PRADESH"
  },
  "475561": {
    "city": "PICHHORE",
    "state": "MADHYA PRADESH"
  },
  "475661": {
    "city": "Datia",
    "state": "Madhya Pradesh"
  },
  "475668": {
    "city": "BHANDER",
    "state": "MADHYA PRADESH"
  },
  "475671": {
    "city": "Datia",
    "state": "Madhya Pradesh"
  },
  "475673": {
    "city": "Datia",
    "state": "Madhya Pradesh"
  },
  "475675": {
    "city": "Datia",
    "state": "Madhya Pradesh"
  },
  "475677": {
    "city": "INDERGARH",
    "state": "MADHYA PRADESH"
  },
  "475682": {
    "city": "Datia",
    "state": "Madhya Pradesh"
  },
  "475684": {
    "city": "DATIA",
    "state": "MADHYA PRADESH"
  },
  "475685": {
    "city": "Datia",
    "state": "Madhya Pradesh"
  },
  "475686": {
    "city": "Datia",
    "state": "Madhya Pradesh"
  },
  "475687": {
    "city": "PACHORE",
    "state": "MADHYA PRADESH"
  },
  "475693": {
    "city": "DATIA",
    "state": "MADHYA PRADESH"
  },
  "476001": {
    "city": "Morena",
    "state": "Madhya Pradesh"
  },
  "476006": {
    "city": "MORENA",
    "state": "MADHYA PRADESH"
  },
  "476026": {
    "city": "MORENA",
    "state": "MADHYA PRADESH"
  },
  "476027": {
    "city": "MORENA",
    "state": "MADHYA PRADESH"
  },
  "476031": {
    "city": "MORENA",
    "state": "MADHYA PRADESH"
  },
  "476111": {
    "city": "Morena",
    "state": "Madhya Pradesh"
  },
  "476115": {
    "city": "Morena",
    "state": "Madhya Pradesh"
  },
  "476133": {
    "city": "AMBAH",
    "state": "MADHYA PRADESH"
  },
  "476134": {
    "city": "Morena",
    "state": "Madhya Pradesh"
  },
  "476219": {
    "city": "Morena",
    "state": "Madhya Pradesh"
  },
  "476221": {
    "city": "Morena",
    "state": "Madhya Pradesh"
  },
  "476224": {
    "city": "Morena",
    "state": "Madhya Pradesh"
  },
  "476228": {
    "city": "Morena",
    "state": "Madhya Pradesh"
  },
  "476229": {
    "city": "Morena",
    "state": "Madhya Pradesh"
  },
  "476235": {
    "city": "SABALGARH",
    "state": "MADHYA PRADESH"
  },
  "476332": {
    "city": "Sheopur",
    "state": "Madhya Pradesh"
  },
  "476335": {
    "city": "Sheopur",
    "state": "Madhya Pradesh"
  },
  "476337": {
    "city": "Sheopur",
    "state": "Madhya Pradesh"
  },
  "476339": {
    "city": "Sheopur",
    "state": "Madhya Pradesh"
  },
  "476345": {
    "city": "SHEOPUR",
    "state": "MADHYA PRADESH"
  },
  "476355": {
    "city": "Sheopur",
    "state": "Madhya Pradesh"
  },
  "476444": {
    "city": "Morena",
    "state": "Madhya Pradesh"
  },
  "476554": {
    "city": "Morena",
    "state": "Madhya Pradesh"
  },
  "477001": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477105": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477111": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477114": {
    "city": "GOHAD",
    "state": "MADHYA PRADESH"
  },
  "477116": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477117": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477222": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477227": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477331": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477332": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477333": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477335": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477441": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477445": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477446": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477447": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477449": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477555": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477556": {
    "city": "GORMI",
    "state": "MADHYA PRADESH"
  },
  "477557": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477566": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "477660": {
    "city": "Bhind",
    "state": "Madhya Pradesh"
  },
  "480000": {
    "city": "CHHINDWARA",
    "state": "MADHYA PRADESH"
  },
  "480001": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480002": {
    "city": "CHITANVISGANJ",
    "state": "MADHYA PRADESH"
  },
  "480003": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480004": {
    "city": "CHHINDWARA",
    "state": "MADHYA PRADESH"
  },
  "480015": {
    "city": "Chinddwara",
    "state": "MADHYA PRADESH"
  },
  "480101": {
    "city": "CHHINDWARA",
    "state": "MADHYA PRADESH"
  },
  "480102": {
    "city": "CHHINDWARA",
    "state": "MADHYA PRADESH"
  },
  "480104": {
    "city": "SAUSAR",
    "state": "MADHYA PRADESH"
  },
  "480105": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480106": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480107": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480108": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480109": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480110": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480111": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480112": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480114": {
    "city": "AMARWARA",
    "state": "MADHYA PRADESH"
  },
  "480115": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480116": {
    "city": "AMARWARA",
    "state": "MADHYA PRADESH"
  },
  "480121": {
    "city": "AMARWARA",
    "state": "MADHYA PRADESH"
  },
  "480221": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480223": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480224": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480225": {
    "city": "PATAN-MP",
    "state": "MADHYA PRADESH"
  },
  "480228": {
    "city": "PATAN-MP",
    "state": "MADHYA PRADESH"
  },
  "480331": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480334": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480337": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480338": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480339": {
    "city": "PANDHURNA",
    "state": "MADHYA PRADESH"
  },
  "480357": {
    "city": "PANDHURNA",
    "state": "MADHYA PRADESH"
  },
  "480441": {
    "city": "Betul",
    "state": "Madhya Pradesh"
  },
  "480443": {
    "city": "CHHINDWARA",
    "state": "MADHYA PRADESH"
  },
  "480444": {
    "city": "CHHINDWARA",
    "state": "MADHYA PRADESH"
  },
  "480447": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480449": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480551": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480553": {
    "city": "JUNNARDEO",
    "state": "MADHYA PRADESH"
  },
  "480554": {
    "city": "JUNNARDEO",
    "state": "MADHYA PRADESH"
  },
  "480555": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480557": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480559": {
    "city": "Chhindwara",
    "state": "Madhya Pradesh"
  },
  "480661": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480664": {
    "city": "SEONI",
    "state": "MADHYA PRADESH"
  },
  "480667": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480669": {
    "city": "SEONI",
    "state": "MADHYA PRADESH"
  },
  "480771": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480880": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480881": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480882": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480884": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480886": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480887": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480888": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480990": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480991": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480994": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480996": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480997": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "480999": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "481001": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481015": {
    "city": "BALAGHAT",
    "state": "MADHYA PRADESH"
  },
  "481022": {
    "city": "BALAGHAT",
    "state": "MADHYA PRADESH"
  },
  "481051": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481101": {
    "city": "BALAGHAT",
    "state": "MADHYA PRADESH"
  },
  "481102": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481104": {
    "city": "BAIHAR",
    "state": "MADHYA PRADESH"
  },
  "481105": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481106": {
    "city": "BAIHAR",
    "state": "MADHYA PRADESH"
  },
  "481111": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481115": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481116": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481117": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481118": {
    "city": "BAIHAR",
    "state": "MADHYA PRADESH"
  },
  "481125": {
    "city": "BICHHIYA",
    "state": "MADHYA PRADESH"
  },
  "481222": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481224": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481226": {
    "city": "Seoni",
    "state": "Madhya Pradesh"
  },
  "481331": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481332": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481335": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481337": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481441": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481445": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481449": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481551": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481554": {
    "city": "BAIHAR",
    "state": "MADHYA PRADESH"
  },
  "481556": {
    "city": "Balaghat",
    "state": "Madhya Pradesh"
  },
  "481584": {
    "city": "BAIHAR",
    "state": "MADHYA PRADESH"
  },
  "481661": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481662": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481663": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481664": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481665": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481666": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481667": {
    "city": "NAINPUR",
    "state": "MADHYA PRADESH"
  },
  "481668": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481672": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481768": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481771": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481776": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481778": {
    "city": "Dindori",
    "state": "Madhya Pradesh"
  },
  "481879": {
    "city": "Dindori",
    "state": "Madhya Pradesh"
  },
  "481880": {
    "city": "Dindori",
    "state": "Madhya Pradesh"
  },
  "481882": {
    "city": "Dindori",
    "state": "Madhya Pradesh"
  },
  "481883": {
    "city": "Dindori",
    "state": "Madhya Pradesh"
  },
  "481884": {
    "city": "Dindori",
    "state": "Madhya Pradesh"
  },
  "481885": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481990": {
    "city": "Dindori",
    "state": "Madhya Pradesh"
  },
  "481993": {
    "city": "BICHHIYA",
    "state": "MADHYA PRADESH"
  },
  "481995": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481996": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "481998": {
    "city": "Mandla",
    "state": "Madhya Pradesh"
  },
  "482001": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "482002": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "482003": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "482004": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "482005": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "482006": {
    "city": "JABALPUR",
    "state": "MADHYA PRADESH"
  },
  "482007": {
    "city": "JABALPUR",
    "state": "MADHYA PRADESH"
  },
  "482008": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "482009": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "482010": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "482011": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "482016": {
    "city": "JABALPUR",
    "state": "MADHYA PRADESH"
  },
  "482020": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "482021": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "482036": {
    "city": "GOTEGAON",
    "state": "MADHYA PRADESH"
  },
  "482050": {
    "city": "JABALPUR",
    "state": "MADHYA PRADESH"
  },
  "482051": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "482053": {
    "city": "JABALPUR",
    "state": "MADHYA PRADESH"
  },
  "482056": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "483001": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "483050": {
    "city": "JABALPUR",
    "state": "MADHYA PRADESH"
  },
  "483053": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "483105": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "483110": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "483113": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "483119": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "483220": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "483222": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "483225": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "483330": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "483331": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "483332": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "483334": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "483336": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "483440": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "483442": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "483443": {
    "city": "PAN UMARIYA",
    "state": "MADHYA PRADESH"
  },
  "483445": {
    "city": "PAN UMARIYA",
    "state": "MADHYA PRADESH"
  },
  "483446": {
    "city": "PAN UMARIYA",
    "state": "MADHYA PRADESH"
  },
  "483501": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "483503": {
    "city": "KATNI",
    "state": "MADHYA PRADESH"
  },
  "483504": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "483507": {
    "city": "KATNI",
    "state": "MADHYA PRADESH"
  },
  "483770": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "483773": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "483775": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "483778": {
    "city": "BIJERAGHOGARH",
    "state": "MADHYA PRADESH"
  },
  "483880": {
    "city": "Jabalpur",
    "state": "Madhya Pradesh"
  },
  "483886": {
    "city": "BIJERAGHOGARH",
    "state": "MADHYA PRADESH"
  },
  "483990": {
    "city": "Katni",
    "state": "Madhya Pradesh"
  },
  "484001": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484002": {
    "city": "SHAHDOL",
    "state": "MADHYA PRADESH"
  },
  "484110": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484112": {
    "city": "KOTMA",
    "state": "MADHYA PRADESH"
  },
  "484113": {
    "city": "Anuppur",
    "state": "Madhya Pradesh"
  },
  "484114": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484116": {
    "city": "Anuppur",
    "state": "Madhya Pradesh"
  },
  "484117": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484120": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484220": {
    "city": "Anuppur",
    "state": "Madhya Pradesh"
  },
  "484224": {
    "city": "Anuppur",
    "state": "Madhya Pradesh"
  },
  "484330": {
    "city": "Anuppur",
    "state": "Madhya Pradesh"
  },
  "484334": {
    "city": "Anuppur",
    "state": "Madhya Pradesh"
  },
  "484336": {
    "city": "Anuppur",
    "state": "Madhya Pradesh"
  },
  "484440": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484444": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484446": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484447": {
    "city": "Anuppur",
    "state": "Madhya Pradesh"
  },
  "484551": {
    "city": "Umaria",
    "state": "Madhya Pradesh"
  },
  "484552": {
    "city": "PALI-MP",
    "state": "MADHYA PRADESH"
  },
  "484555": {
    "city": "Umaria",
    "state": "Madhya Pradesh"
  },
  "484660": {
    "city": "Umaria",
    "state": "Madhya Pradesh"
  },
  "484661": {
    "city": "Umaria",
    "state": "Madhya Pradesh"
  },
  "484664": {
    "city": "Umaria",
    "state": "Madhya Pradesh"
  },
  "484665": {
    "city": "Umaria",
    "state": "Madhya Pradesh"
  },
  "484669": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484770": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484771": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484774": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484776": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484881": {
    "city": "Shahdol",
    "state": "Madhya Pradesh"
  },
  "484886": {
    "city": "Anuppur",
    "state": "Madhya Pradesh"
  },
  "484887": {
    "city": "Anuppur",
    "state": "Madhya Pradesh"
  },
  "485001": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485002": {
    "city": "SATNA",
    "state": "MADHYA PRADESH"
  },
  "485003": {
    "city": "SATNA",
    "state": "MADHYA PRADESH"
  },
  "485004": {
    "city": "SATNA",
    "state": "MADHYA PRADESH"
  },
  "485005": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485081": {
    "city": "REWA",
    "state": "MADHYA PRADESH"
  },
  "485111": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485112": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485113": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485114": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485115": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485116": {
    "city": "REWA",
    "state": "MADHYA PRADESH"
  },
  "485133": {
    "city": "REWA",
    "state": "MADHYA PRADESH"
  },
  "485221": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485226": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485331": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485334": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485336": {
    "city": "CHITRAKOOT",
    "state": "MADHYA PRADESH"
  },
  "485344": {
    "city": "BIRSINGHPUR",
    "state": "MADHYA PRADESH"
  },
  "485441": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485446": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485447": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485551": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485661": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485666": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485771": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485772": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485773": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485774": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485775": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485778": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "485881": {
    "city": "Satna",
    "state": "Madhya Pradesh"
  },
  "486001": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486002": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486003": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486004": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486005": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486006": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486007": {
    "city": "REWA",
    "state": "MADHYA PRADESH"
  },
  "486008": {
    "city": "REWA",
    "state": "MADHYA PRADESH"
  },
  "486009": {
    "city": "REWA",
    "state": "MADHYA PRADESH"
  },
  "486010": {
    "city": "REWA",
    "state": "MADHYA PRADESH"
  },
  "486111": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486112": {
    "city": "MANGAWAN",
    "state": "MADHYA PRADESH"
  },
  "486113": {
    "city": "MANGAWAN",
    "state": "MADHYA PRADESH"
  },
  "486114": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486115": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486117": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486123": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486220": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486223": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486226": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486228": {
    "city": "TEONTHAR",
    "state": "MADHYA PRADESH"
  },
  "486331": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486333": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486335": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486338": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486340": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486341": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486342": {
    "city": "MAUGANJ",
    "state": "MADHYA PRADESH"
  },
  "486343": {
    "city": "MAUGANJ",
    "state": "MADHYA PRADESH"
  },
  "486355": {
    "city": "MAUGANJ",
    "state": "MADHYA PRADESH"
  },
  "486440": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486441": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486442": {
    "city": "MANGAWAN",
    "state": "MADHYA PRADESH"
  },
  "486443": {
    "city": "MANGAWAN",
    "state": "MADHYA PRADESH"
  },
  "486444": {
    "city": "SIRMAUR",
    "state": "MADHYA PRADESH"
  },
  "486445": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486446": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486447": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486448": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486449": {
    "city": "REWA",
    "state": "MADHYA PRADESH"
  },
  "486450": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486451": {
    "city": "REWA",
    "state": "MADHYA PRADESH"
  },
  "486536": {
    "city": "REWA",
    "state": "MADHYA PRADESH"
  },
  "486550": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486552": {
    "city": "MANGAWAN",
    "state": "MADHYA PRADESH"
  },
  "486553": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486554": {
    "city": "MANGAWAN",
    "state": "MADHYA PRADESH"
  },
  "486556": {
    "city": "Rewa",
    "state": "Madhya Pradesh"
  },
  "486661": {
    "city": "Sidhi",
    "state": "Madhya Pradesh"
  },
  "486666": {
    "city": "Sidhi",
    "state": "Madhya Pradesh"
  },
  "486669": {
    "city": "Sidhi",
    "state": "Madhya Pradesh"
  },
  "486670": {
    "city": "Sidhi",
    "state": "Madhya Pradesh"
  },
  "486675": {
    "city": "Sidhi",
    "state": "Madhya Pradesh"
  },
  "486771": {
    "city": "Sidhi",
    "state": "Madhya Pradesh"
  },
  "486775": {
    "city": "Sidhi",
    "state": "Madhya Pradesh"
  },
  "486776": {
    "city": "Sidhi",
    "state": "Madhya Pradesh"
  },
  "486881": {
    "city": "Sidhi",
    "state": "Madhya Pradesh"
  },
  "486882": {
    "city": "Sidhi",
    "state": "Madhya Pradesh"
  },
  "486884": {
    "city": "Sidhi",
    "state": "Madhya Pradesh"
  },
  "486885": {
    "city": "Singrauli",
    "state": "Madhya Pradesh"
  },
  "486886": {
    "city": "Singrauli",
    "state": "Madhya Pradesh"
  },
  "486887": {
    "city": "Singrauli",
    "state": "Madhya Pradesh"
  },
  "486888": {
    "city": "Singrauli",
    "state": "Madhya Pradesh"
  },
  "486889": {
    "city": "Singrauli",
    "state": "Madhya Pradesh"
  },
  "486890": {
    "city": "Sidhi",
    "state": "Madhya Pradesh"
  },
  "486892": {
    "city": "Sidhi",
    "state": "Madhya Pradesh"
  },
  "486894": {
    "city": "SINGRAULI",
    "state": "MADHYA PRADESH"
  },
  "487001": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487081": {
    "city": "NARSIMHAPUR",
    "state": "MADHYA PRADESH"
  },
  "487095": {
    "city": "NARSIMHAPUR",
    "state": "MADHYA PRADESH"
  },
  "487110": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487114": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487118": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487221": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487225": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487330": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487334": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487337": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487441": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487551": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487555": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487661": {
    "city": "Sainkheda",
    "state": "Madhya Pradesh"
  },
  "487770": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487771": {
    "city": "GADARWARA",
    "state": "MADHYA PRADESH"
  },
  "487881": {
    "city": "Narsinghpur",
    "state": "Madhya Pradesh"
  },
  "487885": {
    "city": "GADARWARA",
    "state": "MADHYA PRADESH"
  },
  "488001": {
    "city": "Panna",
    "state": "Madhya Pradesh"
  },
  "488050": {
    "city": "Panna",
    "state": "Madhya Pradesh"
  },
  "488051": {
    "city": "Panna",
    "state": "Madhya Pradesh"
  },
  "488058": {
    "city": "PAWAI",
    "state": "MADHYA PRADESH"
  },
  "488059": {
    "city": "Panna",
    "state": "Madhya Pradesh"
  },
  "488101": {
    "city": "PANNA",
    "state": "MADHYA PRADESH"
  },
  "488220": {
    "city": "Panna",
    "state": "Madhya Pradesh"
  },
  "488222": {
    "city": "Panna",
    "state": "Madhya Pradesh"
  },
  "488333": {
    "city": "Panna",
    "state": "Madhya Pradesh"
  },
  "488441": {
    "city": "Panna",
    "state": "Madhya Pradesh"
  },
  "488442": {
    "city": "Panna",
    "state": "Madhya Pradesh"
  },
  "488443": {
    "city": "Panna",
    "state": "Madhya Pradesh"
  },
  "488446": {
    "city": "Panna",
    "state": "Madhya Pradesh"
  },
  "488448": {
    "city": "Panna",
    "state": "Madhya Pradesh"
  },
  "488888": {
    "city": "BHIWANDI",
    "state": "MAHARASHTRA"
  },
  "490001": {
    "city": "DURG",
    "state": "Chhattisgarh"
  },
  "490002": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "490003": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "490004": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "490005": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "490006": {
    "city": "DURG",
    "state": "Chhattisgarh"
  },
  "490007": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "490008": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "490009": {
    "city": "DURG",
    "state": "Chhattisgarh"
  },
  "490010": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "490011": {
    "city": "DURG",
    "state": "Chhattisgarh"
  },
  "490012": {
    "city": "BHILAI",
    "state": "Chhattisgarh"
  },
  "490013": {
    "city": "BHILAI",
    "state": "Chhattisgarh"
  },
  "490015": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "490020": {
    "city": "DURG",
    "state": "Chhattisgarh"
  },
  "490021": {
    "city": "DURG",
    "state": "Chhattisgarh"
  },
  "490022": {
    "city": "DURG",
    "state": "Chhattisgarh"
  },
  "490023": {
    "city": "DURG",
    "state": "Chhattisgarh"
  },
  "490024": {
    "city": "DURG",
    "state": "Chhattisgarh"
  },
  "490025": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "490026": {
    "city": "DURG",
    "state": "Chhattisgarh"
  },
  "490027": {
    "city": "BHILAI",
    "state": "Chhattisgarh"
  },
  "490028": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "490036": {
    "city": "DURG",
    "state": "Chhattisgarh"
  },
  "490042": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "490054": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "491001": {
    "city": "DURG",
    "state": "Chhattisgarh"
  },
  "491002": {
    "city": "BHILAI",
    "state": "Chhattisgarh"
  },
  "491003": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "491004": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "491009": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "491107": {
    "city": "BHILAI",
    "state": "CHHATTISGARH"
  },
  "491111": {
    "city": "PATAN-CG",
    "state": "CHHATTISGARH"
  },
  "491113": {
    "city": "PATAN-CG",
    "state": "CHHATTISGARH"
  },
  "491221": {
    "city": "GUNDERDEHI",
    "state": "CHHATTISGARH"
  },
  "491222": {
    "city": "GUNDERDEHI",
    "state": "CHHATTISGARH"
  },
  "491223": {
    "city": "GUNDERDEHI",
    "state": "CHHATTISGARH"
  },
  "491225": {
    "city": "GUNDERDEHI",
    "state": "CHHATTISGARH"
  },
  "491226": {
    "city": "BALOD",
    "state": "CHHATTISGARH"
  },
  "491227": {
    "city": "DHAMTARI",
    "state": "CHHATTISGARH"
  },
  "491228": {
    "city": "DALLI RAJHARA",
    "state": "CHHATTISGARH"
  },
  "491229": {
    "city": "BHANUPRATAPPUR",
    "state": "CHHATTISGARH"
  },
  "491230": {
    "city": "DALLI RAJHARA",
    "state": "CHHATTISGARH"
  },
  "491331": {
    "city": "DHAMDHA",
    "state": "CHHATTISGARH"
  },
  "491332": {
    "city": "DHAMDHA",
    "state": "CHHATTISGARH"
  },
  "491335": {
    "city": "BEMETARA",
    "state": "CHHATTISGARH"
  },
  "491336": {
    "city": "KABIRDHAM",
    "state": "CHHATTISGARH"
  },
  "491337": {
    "city": "MUNGELI",
    "state": "CHHATTISGARH"
  },
  "491338": {
    "city": "BEMETARA",
    "state": "CHHATTISGARH"
  },
  "491340": {
    "city": "BHATAPARA",
    "state": "CHHATTISGARH"
  },
  "491441": {
    "city": "RAJNANDGAON",
    "state": "Chhattisgarh"
  },
  "491443": {
    "city": "KHAIRAGARH-CG",
    "state": "CHHATTISGARH"
  },
  "491444": {
    "city": "KHAIRAGARH-CG",
    "state": "CHHATTISGARH"
  },
  "491445": {
    "city": "DONGARGARH",
    "state": "CHHATTISGARH"
  },
  "491557": {
    "city": "DONGARGARH",
    "state": "CHHATTISGARH"
  },
  "491558": {
    "city": "DONGARGAON",
    "state": "CHHATTISGARH"
  },
  "491559": {
    "city": "PANDARIYA",
    "state": "CHHATTISGARH"
  },
  "491661": {
    "city": "DONGARGAON",
    "state": "CHHATTISGARH"
  },
  "491665": {
    "city": "CHOWKI",
    "state": "CHHATTISGARH"
  },
  "491666": {
    "city": "CHOWKI",
    "state": "CHHATTISGARH"
  },
  "491668": {
    "city": "CHOWKI",
    "state": "CHHATTISGARH"
  },
  "491771": {
    "city": "BALOD",
    "state": "CHHATTISGARH"
  },
  "491881": {
    "city": "KHAIRAGARH-CG",
    "state": "CHHATTISGARH"
  },
  "491885": {
    "city": "KHAIRAGARH-CG",
    "state": "CHHATTISGARH"
  },
  "491888": {
    "city": "GANDAI",
    "state": "CHHATTISGARH"
  },
  "491991": {
    "city": "GANDAI",
    "state": "CHHATTISGARH"
  },
  "491993": {
    "city": "GANDAI",
    "state": "CHHATTISGARH"
  },
  "491995": {
    "city": "KABIRDHAM",
    "state": "CHHATTISGARH"
  },
  "491996": {
    "city": "KABIRDHAM",
    "state": "CHHATTISGARH"
  },
  "492001": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492002": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492003": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492004": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492005": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492006": {
    "city": "RAIPUR",
    "state": "Chhattisgarh"
  },
  "492007": {
    "city": "RAIPUR",
    "state": "Chhattisgarh"
  },
  "492008": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492009": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492010": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492011": {
    "city": "RAIPUR",
    "state": "CHHATTISGARH"
  },
  "492012": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492013": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492014": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492015": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492016": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492017": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492021": {
    "city": "RAIPUR",
    "state": "CHHATTISGARH"
  },
  "492042": {
    "city": "RAIPUR",
    "state": "CHHATTISGARH"
  },
  "492099": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492100": {
    "city": "RAIPUR",
    "state": "CHHATTISGARH"
  },
  "492101": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492102": {
    "city": "RAIPUR",
    "state": "CHHATTISGARH"
  },
  "492103": {
    "city": "RAIPUR",
    "state": "CHHATTISGARH"
  },
  "492104": {
    "city": "RAIPUR",
    "state": "CHHATTISGARH"
  },
  "492105": {
    "city": "RAIPUR",
    "state": "CHHATTISGARH"
  },
  "492106": {
    "city": "RAIPUR",
    "state": "CHHATTISGARH"
  },
  "492107": {
    "city": "RAIPUR",
    "state": "CHHATTISGARH"
  },
  "492108": {
    "city": "KUNKURI",
    "state": "CHHATTISGARH"
  },
  "492109": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "492110": {
    "city": "KUNKURI",
    "state": "CHHATTISGARH"
  },
  "492112": {
    "city": "Mahasamund",
    "state": "Chhattisgarh"
  },
  "493002": {
    "city": "RAIPUR",
    "state": "CHHATTISGARH"
  },
  "493004": {
    "city": "RAIPUR",
    "state": "CHHATTISGARH"
  },
  "493101": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493111": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493112": {
    "city": "BASNA",
    "state": "CHHATTISGARH"
  },
  "493113": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493114": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493116": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493118": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493195": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493196": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493211": {
    "city": "RAIPUR",
    "state": "CHHATTISGARH"
  },
  "493221": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493222": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493225": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493228": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493229": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493330": {
    "city": "BALODA BAZAR",
    "state": "CHHATTISGARH"
  },
  "493331": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493332": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493335": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493338": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493344": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493354": {
    "city": "KASDOL",
    "state": "CHHATTISGARH"
  },
  "493441": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493445": {
    "city": "Mahasamund",
    "state": "Chhattisgarh"
  },
  "493448": {
    "city": "Mahasamund",
    "state": "Chhattisgarh"
  },
  "493449": {
    "city": "Mahasamund",
    "state": "Chhattisgarh"
  },
  "493526": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493551": {
    "city": "Mahasamund",
    "state": "Chhattisgarh"
  },
  "493554": {
    "city": "Mahasamund",
    "state": "Chhattisgarh"
  },
  "493555": {
    "city": "Mahasamund",
    "state": "Chhattisgarh"
  },
  "493558": {
    "city": "Mahasamund",
    "state": "Chhattisgarh"
  },
  "493559": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493562": {
    "city": "SARANGARH",
    "state": "CHHATTISGARH"
  },
  "493661": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493662": {
    "city": "Dhamtari",
    "state": "Chhattisgarh"
  },
  "493663": {
    "city": "Dhamtari",
    "state": "Chhattisgarh"
  },
  "493770": {
    "city": "Dhamtari",
    "state": "Chhattisgarh"
  },
  "493773": {
    "city": "Dhamtari",
    "state": "Chhattisgarh"
  },
  "493776": {
    "city": "Dhamtari",
    "state": "Chhattisgarh"
  },
  "493778": {
    "city": "Dhamtari",
    "state": "Chhattisgarh"
  },
  "493881": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493885": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493887": {
    "city": "Gariaband",
    "state": "Chhattisgarh"
  },
  "493888": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493889": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493890": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493891": {
    "city": "Gariaband",
    "state": "Chhattisgarh"
  },
  "493895": {
    "city": "GARIABAND",
    "state": "CHHATTISGARH"
  },
  "493992": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "493996": {
    "city": "Raipur",
    "state": "Chhattisgarh"
  },
  "494001": {
    "city": "JAGDALPUR",
    "state": "CHHATTISGARH"
  },
  "494002": {
    "city": "JAGDALPUR",
    "state": "CHHATTISGARH"
  },
  "494003": {
    "city": "JAGDALPUR",
    "state": "CHHATTISGARH"
  },
  "494004": {
    "city": "JAGDALPUR",
    "state": "CHHATTISGARH"
  },
  "494005": {
    "city": "JAGDALPUR",
    "state": "CHHATTISGARH"
  },
  "494010": {
    "city": "LOHANDIGUDA",
    "state": "CHHATTISGARH"
  },
  "494111": {
    "city": "SUKMA",
    "state": "CHHATTISGARH"
  },
  "494114": {
    "city": "SUKMA",
    "state": "CHHATTISGARH"
  },
  "494115": {
    "city": "SUKMA",
    "state": "CHHATTISGARH"
  },
  "494122": {
    "city": "SUKMA",
    "state": "CHHATTISGARH"
  },
  "494221": {
    "city": "JAGDALPUR",
    "state": "CHHATTISGARH"
  },
  "494222": {
    "city": "JAGDALPUR",
    "state": "CHHATTISGARH"
  },
  "494223": {
    "city": "JAGDALPUR",
    "state": "CHHATTISGARH"
  },
  "494224": {
    "city": "KONDAGAON",
    "state": "CHHATTISGARH"
  },
  "494225": {
    "city": "KONDAGAON",
    "state": "CHHATTISGARH"
  },
  "494226": {
    "city": "KONDAGAON",
    "state": "CHHATTISGARH"
  },
  "494227": {
    "city": "KONDAGAON",
    "state": "CHHATTISGARH"
  },
  "494228": {
    "city": "KONDAGAON",
    "state": "CHHATTISGARH"
  },
  "494229": {
    "city": "KONDAGAON",
    "state": "CHHATTISGARH"
  },
  "494230": {
    "city": "KESKAL",
    "state": "CHHATTISGARH"
  },
  "494237": {
    "city": "KONDAGAON",
    "state": "CHHATTISGARH"
  },
  "494331": {
    "city": "KESKAL",
    "state": "CHHATTISGARH"
  },
  "494332": {
    "city": "KANKER",
    "state": "CHHATTISGARH"
  },
  "494333": {
    "city": "KANKER",
    "state": "CHHATTISGARH"
  },
  "494334": {
    "city": "KANKER",
    "state": "CHHATTISGARH"
  },
  "494335": {
    "city": "KANKER",
    "state": "CHHATTISGARH"
  },
  "494336": {
    "city": "CHARAMA",
    "state": "CHHATTISGARH"
  },
  "494337": {
    "city": "CHARAMA",
    "state": "CHHATTISGARH"
  },
  "494347": {
    "city": "KESKAL",
    "state": "CHHATTISGARH"
  },
  "494435": {
    "city": "KESKAL",
    "state": "CHHATTISGARH"
  },
  "494440": {
    "city": "DANTEWADA",
    "state": "CHHATTISGARH"
  },
  "494441": {
    "city": "DANTEWADA",
    "state": "CHHATTISGARH"
  },
  "494442": {
    "city": "JAGDALPUR",
    "state": "CHHATTISGARH"
  },
  "494444": {
    "city": "BIJAPUR",
    "state": "CHHATTISGARH"
  },
  "494445": {
    "city": "BIJAPUR",
    "state": "CHHATTISGARH"
  },
  "494446": {
    "city": "BIJAPUR",
    "state": "CHHATTISGARH"
  },
  "494447": {
    "city": "BIJAPUR",
    "state": "CHHATTISGARH"
  },
  "494448": {
    "city": "BIJAPUR",
    "state": "CHHATTISGARH"
  },
  "494449": {
    "city": "DANTEWADA",
    "state": "CHHATTISGARH"
  },
  "494450": {
    "city": "BHAIRAMGARH",
    "state": "CHHATTISGARH"
  },
  "494551": {
    "city": "DANTEWADA",
    "state": "CHHATTISGARH"
  },
  "494552": {
    "city": "DANTEWADA",
    "state": "CHHATTISGARH"
  },
  "494553": {
    "city": "KIRANDUL",
    "state": "CHHATTISGARH"
  },
  "494554": {
    "city": "KIRANDUL",
    "state": "CHHATTISGARH"
  },
  "494556": {
    "city": "KIRANDUL",
    "state": "CHHATTISGARH"
  },
  "494572": {
    "city": "KIRANDUL",
    "state": "CHHATTISGARH"
  },
  "494635": {
    "city": "BHANUPRATAPPUR",
    "state": "CHHATTISGARH"
  },
  "494661": {
    "city": "NARAYANPUR",
    "state": "CHHATTISGARH"
  },
  "494662": {
    "city": "NARAYANPUR",
    "state": "CHHATTISGARH"
  },
  "494664": {
    "city": "BHANUPRATAPPUR",
    "state": "CHHATTISGARH"
  },
  "494665": {
    "city": "ANTAGARH",
    "state": "CHHATTISGARH"
  },
  "494669": {
    "city": "BHANUPRATAPPUR",
    "state": "CHHATTISGARH"
  },
  "494670": {
    "city": "KANKER",
    "state": "CHHATTISGARH"
  },
  "494678": {
    "city": "KANKER",
    "state": "CHHATTISGARH"
  },
  "494679": {
    "city": "KANKER",
    "state": "CHHATTISGARH"
  },
  "494771": {
    "city": "ANTAGARH",
    "state": "CHHATTISGARH"
  },
  "494775": {
    "city": "BHANUPRATAPPUR",
    "state": "CHHATTISGARH"
  },
  "494776": {
    "city": "ANTAGARH",
    "state": "CHHATTISGARH"
  },
  "494777": {
    "city": "ANTAGARH",
    "state": "CHHATTISGARH"
  },
  "495001": {
    "city": "BILASPUR(CGH)",
    "state": "Chhattisgarh"
  },
  "495002": {
    "city": "BILASPUR - CG",
    "state": "CHHATTISGARH"
  },
  "495003": {
    "city": "BILASPUR - CG",
    "state": "CHHATTISGARH"
  },
  "495004": {
    "city": "BILASPUR(CGH)",
    "state": "Chhattisgarh"
  },
  "495005": {
    "city": "BILASPUR (CG)",
    "state": "Chhattisgarh"
  },
  "495006": {
    "city": "BILASPUR(CGH)",
    "state": "Chhattisgarh"
  },
  "495007": {
    "city": "BILASPUR - CG",
    "state": "CHHATTISGARH"
  },
  "495009": {
    "city": "BILASPUR(CGH)",
    "state": "Chhattisgarh"
  },
  "495011": {
    "city": "Bilaspur",
    "state": "CHHATTISGARH"
  },
  "495112": {
    "city": "KOTA",
    "state": "CHHATTISGARH"
  },
  "495113": {
    "city": "KOTA",
    "state": "CHHATTISGARH"
  },
  "495115": {
    "city": "MUNGELI",
    "state": "CHHATTISGARH"
  },
  "495116": {
    "city": "KOTA",
    "state": "CHHATTISGARH"
  },
  "495117": {
    "city": "PENDRA ROAD",
    "state": "CHHATTISGARH"
  },
  "495118": {
    "city": "MARWAHI",
    "state": "CHHATTISGARH"
  },
  "495119": {
    "city": "PENDRA ROAD",
    "state": "CHHATTISGARH"
  },
  "495220": {
    "city": "BILASPUR",
    "state": "Chhattisgarh"
  },
  "495222": {
    "city": "BILASPUR - CG",
    "state": "CHHATTISGARH"
  },
  "495223": {
    "city": "BILASPUR(CGH)",
    "state": "Chhattisgarh"
  },
  "495224": {
    "city": "BILASPUR - CG",
    "state": "CHHATTISGARH"
  },
  "495330": {
    "city": "MUNGELI",
    "state": "CHHATTISGARH"
  },
  "495334": {
    "city": "MUNGELI",
    "state": "CHHATTISGARH"
  },
  "495335": {
    "city": "MUNGELI",
    "state": "CHHATTISGARH"
  },
  "495336": {
    "city": "MUNGELI",
    "state": "CHHATTISGARH"
  },
  "495337": {
    "city": "MUNGELI",
    "state": "CHHATTISGARH"
  },
  "495442": {
    "city": "KOTA",
    "state": "CHHATTISGARH"
  },
  "495444": {
    "city": "KATGHORA",
    "state": "CHHATTISGARH"
  },
  "495445": {
    "city": "KATGHORA",
    "state": "CHHATTISGARH"
  },
  "495446": {
    "city": "PALI-CG",
    "state": "CHHATTISGARH"
  },
  "495447": {
    "city": "KATGHORA",
    "state": "CHHATTISGARH"
  },
  "495448": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495449": {
    "city": "PALI-CG",
    "state": "CHHATTISGARH"
  },
  "495450": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495452": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495453": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495454": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495455": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495549": {
    "city": "BILASPUR - CG",
    "state": "CHHATTISGARH"
  },
  "495550": {
    "city": "BILASPUR - CG",
    "state": "CHHATTISGARH"
  },
  "495551": {
    "city": "BILASPUR - CG",
    "state": "CHHATTISGARH"
  },
  "495552": {
    "city": "AKALTARA",
    "state": "CHHATTISGARH"
  },
  "495553": {
    "city": "AKALTARA",
    "state": "CHHATTISGARH"
  },
  "495554": {
    "city": "AKALTARA",
    "state": "CHHATTISGARH"
  },
  "495555": {
    "city": "AKALTARA",
    "state": "CHHATTISGARH"
  },
  "495556": {
    "city": "SEOBRI NARAYAN",
    "state": "CHHATTISGARH"
  },
  "495557": {
    "city": "SEOBRI NARAYAN",
    "state": "CHHATTISGARH"
  },
  "495559": {
    "city": "AKALTARA",
    "state": "CHHATTISGARH"
  },
  "495660": {
    "city": "CHAMPA",
    "state": "CHHATTISGARH"
  },
  "495661": {
    "city": "JAIJAIPUR",
    "state": "CHHATTISGARH"
  },
  "495663": {
    "city": "AKALTARA",
    "state": "CHHATTISGARH"
  },
  "495668": {
    "city": "CHAMPA",
    "state": "CHHATTISGARH"
  },
  "495671": {
    "city": "CHAMPA",
    "state": "MAHARASHTRA"
  },
  "495674": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495677": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495678": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495679": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495680": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495681": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495682": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495683": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495684": {
    "city": "KORBA",
    "state": "CHHATTISGARH"
  },
  "495685": {
    "city": "JAIJAIPUR",
    "state": "CHHATTISGARH"
  },
  "495686": {
    "city": "CHAMPA",
    "state": "CHHATTISGARH"
  },
  "495687": {
    "city": "SAKTI",
    "state": "CHHATTISGARH"
  },
  "495688": {
    "city": "DABRA-CG",
    "state": "CHHATTISGARH"
  },
  "495689": {
    "city": "SAKTI",
    "state": "CHHATTISGARH"
  },
  "495690": {
    "city": "JAIJAIPUR",
    "state": "CHHATTISGARH"
  },
  "495691": {
    "city": "DABRA-CG",
    "state": "CHHATTISGARH"
  },
  "495692": {
    "city": "DABRA-CG",
    "state": "CHHATTISGARH"
  },
  "495695": {
    "city": "SAKTI",
    "state": "CHHATTISGARH"
  },
  "496001": {
    "city": "RAIGARH",
    "state": "Chhattisgarh"
  },
  "496004": {
    "city": "RAIGARH",
    "state": "CHHATTISGARH"
  },
  "496005": {
    "city": "RAIGARH",
    "state": "Chhattisgarh"
  },
  "496100": {
    "city": "RAIGARH",
    "state": "CHHATTISGARH"
  },
  "496107": {
    "city": "GHARGHODA",
    "state": "CHHATTISGARH"
  },
  "496108": {
    "city": "GHARGHODA",
    "state": "CHHATTISGARH"
  },
  "496109": {
    "city": "GHARGHODA",
    "state": "CHHATTISGARH"
  },
  "496111": {
    "city": "GHARGHODA",
    "state": "CHHATTISGARH"
  },
  "496113": {
    "city": "LAILUNGA",
    "state": "CHHATTISGARH"
  },
  "496115": {
    "city": "LAILUNGA",
    "state": "CHHATTISGARH"
  },
  "496116": {
    "city": "DHARAMJAYGARH",
    "state": "CHHATTISGARH"
  },
  "496118": {
    "city": "PATHALGAON",
    "state": "CHHATTISGARH"
  },
  "496197": {
    "city": "GHARGHODA",
    "state": "CHHATTISGARH"
  },
  "496220": {
    "city": "PATHALGAON",
    "state": "CHHATTISGARH"
  },
  "496223": {
    "city": "KUNKURI",
    "state": "CHHATTISGARH"
  },
  "496224": {
    "city": "BAGICHA",
    "state": "CHHATTISGARH"
  },
  "496225": {
    "city": "KUNKURI",
    "state": "CHHATTISGARH"
  },
  "496227": {
    "city": "KUNKURI",
    "state": "CHHATTISGARH"
  },
  "496242": {
    "city": "KUNKURI",
    "state": "CHHATTISGARH"
  },
  "496245": {
    "city": "LAILUNGA",
    "state": "CHHATTISGARH"
  },
  "496330": {
    "city": "JASHPUR NAGAR",
    "state": "CHHATTISGARH"
  },
  "496331": {
    "city": "JASHPUR NAGAR",
    "state": "CHHATTISGARH"
  },
  "496334": {
    "city": "KUNKURI",
    "state": "CHHATTISGARH"
  },
  "496336": {
    "city": "KUSMI-CG",
    "state": "CHHATTISGARH"
  },
  "496338": {
    "city": "JASHPUR NAGAR",
    "state": "CHHATTISGARH"
  },
  "496440": {
    "city": "RAIGARH",
    "state": "CHHATTISGARH"
  },
  "496445": {
    "city": "SARANGARH",
    "state": "CHHATTISGARH"
  },
  "496450": {
    "city": "SARANGARH",
    "state": "CHHATTISGARH"
  },
  "496460": {
    "city": "SARANGARH",
    "state": "CHHATTISGARH"
  },
  "496551": {
    "city": "SARANGARH",
    "state": "CHHATTISGARH"
  },
  "496553": {
    "city": "SARANGARH",
    "state": "CHHATTISGARH"
  },
  "496554": {
    "city": "SARANGARH",
    "state": "CHHATTISGARH"
  },
  "496660": {
    "city": "KHARSIA",
    "state": "CHHATTISGARH"
  },
  "496661": {
    "city": "KHARSIA",
    "state": "CHHATTISGARH"
  },
  "496665": {
    "city": "KHARSIA",
    "state": "CHHATTISGARH"
  },
  "497001": {
    "city": "AMBIKAPUR",
    "state": "CHHATTISGARH"
  },
  "497020": {
    "city": "AMBIKAPUR",
    "state": "CHHATTISGARH"
  },
  "497101": {
    "city": "BATAULI",
    "state": "CHHATTISGARH"
  },
  "497110": {
    "city": "BATAULI",
    "state": "CHHATTISGARH"
  },
  "497111": {
    "city": "PATHALGAON",
    "state": "CHHATTISGARH"
  },
  "497114": {
    "city": "PATHALGAON",
    "state": "CHHATTISGARH"
  },
  "497116": {
    "city": "LAKHANPUR",
    "state": "CHHATTISGARH"
  },
  "497117": {
    "city": "LAKHANPUR",
    "state": "CHHATTISGARH"
  },
  "497118": {
    "city": "Rajpur",
    "state": "CHHATTISGARH"
  },
  "497119": {
    "city": "RAMANUJGANJ",
    "state": "CHHATTISGARH"
  },
  "497210": {
    "city": "RAMANUJGANJ",
    "state": "CHHATTISGARH"
  },
  "497220": {
    "city": "RAMANUJGANJ",
    "state": "CHHATTISGARH"
  },
  "497222": {
    "city": "PRATAPPUR",
    "state": "CHHATTISGARH"
  },
  "497223": {
    "city": "PRATAPPUR",
    "state": "CHHATTISGARH"
  },
  "497224": {
    "city": "KUSMI-CG",
    "state": "CHHATTISGARH"
  },
  "497225": {
    "city": "WADAFNAGAR",
    "state": "CHHATTISGARH"
  },
  "497226": {
    "city": "BISHRAMPUR",
    "state": "CHHATTISGARH"
  },
  "497229": {
    "city": "BISHRAMPUR",
    "state": "CHHATTISGARH"
  },
  "497231": {
    "city": "BHAIYATHAN",
    "state": "CHHATTISGARH"
  },
  "497235": {
    "city": "Bhatgaon",
    "state": "CHHATTISGARH"
  },
  "497331": {
    "city": "BHAIYATHAN",
    "state": "CHHATTISGARH"
  },
  "497333": {
    "city": "UDAIPUR",
    "state": "CHHATTISGARH"
  },
  "497335": {
    "city": "BAIKUNTHPUR",
    "state": "CHHATTISGARH"
  },
  "497339": {
    "city": "BAIKUNTHPUR",
    "state": "CHHATTISGARH"
  },
  "497437": {
    "city": "MANENDRAGARH",
    "state": "CHHATTISGARH"
  },
  "497442": {
    "city": "MANENDRAGARH",
    "state": "CHHATTISGARH"
  },
  "497446": {
    "city": "MANENDRAGARH",
    "state": "CHHATTISGARH"
  },
  "497447": {
    "city": "MANENDRAGARH",
    "state": "CHHATTISGARH"
  },
  "497448": {
    "city": "MANENDRAGARH",
    "state": "CHHATTISGARH"
  },
  "497449": {
    "city": "CHIRIMI",
    "state": "CHHATTISGARH"
  },
  "497450": {
    "city": "MANENDRAGARH",
    "state": "CHHATTISGARH"
  },
  "497451": {
    "city": "CHIRIMI",
    "state": "CHHATTISGARH"
  },
  "497553": {
    "city": "CHIRIMI",
    "state": "CHHATTISGARH"
  },
  "497555": {
    "city": "CHIRIMI",
    "state": "CHHATTISGARH"
  },
  "497557": {
    "city": "CHIRIMI",
    "state": "CHHATTISGARH"
  },
  "497559": {
    "city": "CHIRIMI",
    "state": "CHHATTISGARH"
  },
  "497773": {
    "city": "CHIRIMI",
    "state": "CHHATTISGARH"
  },
  "497778": {
    "city": "BHARATPUR",
    "state": "CHHATTISGARH"
  },
  "499999": {
    "city": "BHIWANDI",
    "state": "MAHARASHTRA"
  },
  "500000": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500001": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500002": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500003": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500004": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500005": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500006": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500007": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500008": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500009": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500010": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500011": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500012": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500013": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500014": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500015": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500016": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500017": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500018": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500019": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500020": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500021": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500022": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500023": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500024": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500025": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500026": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500027": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500028": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500029": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500030": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500031": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500032": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500033": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500034": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500035": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500036": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500037": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500038": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500039": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500040": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500041": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500042": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500043": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500044": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500045": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500046": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500047": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500048": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500049": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500050": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500051": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500052": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500053": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500054": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500055": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500056": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500057": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500058": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500059": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500060": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500061": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500062": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500063": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500064": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500065": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500066": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500067": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500068": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500069": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500070": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500071": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500072": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500073": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500074": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500075": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500076": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500077": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500078": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500079": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500080": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500081": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500082": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500083": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500084": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500085": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500086": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500087": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500088": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500089": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500090": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500091": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500092": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500093": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500094": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500095": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500096": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500097": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500098": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500099": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500100": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500101": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500102": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500103": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500104": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500105": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500106": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500107": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500108": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500109": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500110": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500111": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "500123": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500133": {
    "city": "Hyderabad",
    "state": "TELANGANA"
  },
  "500146": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500170": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500177": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500178": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500195": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500252": {
    "city": "HYDERABAD",
    "state": "ANDHRA PRADESH"
  },
  "500253": {
    "city": "HYDERABAD",
    "state": "ANDHRA PRADESH"
  },
  "500264": {
    "city": "HYDERABAD",
    "state": "ANDHRA PRADESH"
  },
  "500265": {
    "city": "HYDERABAD",
    "state": "ANDHRA PRADESH"
  },
  "500267": {
    "city": "HYDERABAD",
    "state": "ANDHRA PRADESH"
  },
  "500361": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500380": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500409": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500472": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500475": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500476": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500482": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500484": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500486": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500488": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500594": {
    "city": "HYDERABAD",
    "state": "ANDHRA PRADESH"
  },
  "500605": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500660": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500762": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500768": {
    "city": "SECUNDERABAD",
    "state": "TELANGANA"
  },
  "500789": {
    "city": "SECUNDERABAD",
    "state": "TELANGANA"
  },
  "500855": {
    "city": "Hyderabad",
    "state": "TELANGANA"
  },
  "500873": {
    "city": "Hyderabad",
    "state": "TELANGANA"
  },
  "500890": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500960": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "500991": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "501101": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "501102": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "501103": {
    "city": "VIKARABAD",
    "state": "TELANGANA"
  },
  "501104": {
    "city": "VIKARABAD",
    "state": "TELANGANA"
  },
  "501105": {
    "city": "VIKARABAD",
    "state": "TELANGANA"
  },
  "501106": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501108": {
    "city": "VIKARABAD",
    "state": "TELANGANA"
  },
  "501109": {
    "city": "VIKARABAD",
    "state": "TELANGANA"
  },
  "501110": {
    "city": "VIKARABAD",
    "state": "TELANGANA"
  },
  "501111": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501112": {
    "city": "VIKARABAD",
    "state": "TELANGANA"
  },
  "501113": {
    "city": "VIKARABAD",
    "state": "TELANGANA"
  },
  "501121": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501141": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501142": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501143": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501144": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501145": {
    "city": "TANDUR",
    "state": "TELANGANA"
  },
  "501146": {
    "city": "TANDUR",
    "state": "TELANGANA"
  },
  "501156": {
    "city": "TANDUR",
    "state": "TELANGANA"
  },
  "501157": {
    "city": "TANDUR",
    "state": "TELANGANA"
  },
  "501158": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501201": {
    "city": "PARGI",
    "state": "TELANGANA"
  },
  "501202": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501203": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501204": {
    "city": "CHEVELLA",
    "state": "TELANGANA"
  },
  "501205": {
    "city": "CHEVELLA",
    "state": "TELANGANA"
  },
  "501217": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "501218": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501301": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "501323": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "501325": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "501359": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501401": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "501403": {
    "city": "MEDCHAL",
    "state": "TELANGANA"
  },
  "501501": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501502": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501503": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501504": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501505": {
    "city": "Hyderabad",
    "state": "Telangana"
  },
  "501506": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501507": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "501508": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501509": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501510": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501511": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501512": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "501513": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "501514": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "501515": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "502001": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502002": {
    "city": "SANGAREDDY",
    "state": "TELANGANA"
  },
  "502032": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502101": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502102": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502103": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502104": {
    "city": "SIDDIPET",
    "state": "TELANGANA"
  },
  "502107": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502108": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502109": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502110": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502113": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502114": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502115": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502117": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502125": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502130": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502205": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502210": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502211": {
    "city": "ZAHEERABAD",
    "state": "TELANGANA"
  },
  "502212": {
    "city": "ZAHEERABAD",
    "state": "TELANGANA"
  },
  "502220": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502221": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502228": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502246": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502247": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502248": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502249": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502251": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502255": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502256": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502257": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502267": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502269": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502270": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502271": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502273": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502276": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502277": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502278": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502279": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502280": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502281": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502284": {
    "city": "SANGAREDDY",
    "state": "TELANGANA"
  },
  "502285": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502286": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502287": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502288": {
    "city": "NARAYANKHED",
    "state": "TELANGANA"
  },
  "502289": {
    "city": "NARAYANKHED",
    "state": "TELANGANA"
  },
  "502290": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502291": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502292": {
    "city": "SANGAREDDY",
    "state": "TELANGANA"
  },
  "502293": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502294": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502295": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502296": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502297": {
    "city": "NARSAPUR - TS",
    "state": "TELANGANA"
  },
  "502299": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "502300": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502301": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502302": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502303": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502304": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "502305": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502306": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502307": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502308": {
    "city": "SANGAREDDY",
    "state": "TELANGANA"
  },
  "502310": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502311": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502312": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502313": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502314": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502316": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502318": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502319": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502321": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502322": {
    "city": "ZAHEERABAD",
    "state": "TELANGANA"
  },
  "502323": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "502324": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502325": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502329": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502330": {
    "city": "MEDAK",
    "state": "TELANGANA"
  },
  "502331": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502334": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502335": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502336": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502345": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502371": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502372": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502374": {
    "city": "SIDDIPET",
    "state": "TELANGANA"
  },
  "502375": {
    "city": "Medak",
    "state": "Telangana"
  },
  "502381": {
    "city": "Medak",
    "state": "Telangana"
  },
  "503000": {
    "city": "NIZAMABAD",
    "state": "TELANGANA"
  },
  "503001": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503002": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503003": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503101": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503102": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503103": {
    "city": "KAMAREDDY",
    "state": "TELANGANA"
  },
  "503108": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503110": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503111": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503112": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503114": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503115": {
    "city": "BANSWADA",
    "state": "TELANGANA"
  },
  "503116": {
    "city": "BANSWADA",
    "state": "TELANGANA"
  },
  "503120": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503122": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503123": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503124": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503125": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503144": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503145": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503164": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503165": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503166": {
    "city": "DICHPALLE",
    "state": "TELANGANA"
  },
  "503174": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503175": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503176": {
    "city": "NIZAMABAD",
    "state": "TELANGANA"
  },
  "503177": {
    "city": "NIZAMABAD",
    "state": "TELANGANA"
  },
  "503178": {
    "city": "BODHAN",
    "state": "TELANGANA"
  },
  "503180": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503185": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503186": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503187": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503188": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503201": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503202": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503203": {
    "city": "BODHAN",
    "state": "TELANGANA"
  },
  "503206": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503207": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503212": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503213": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503214": {
    "city": "NIZAMABAD",
    "state": "TELANGANA"
  },
  "503215": {
    "city": "BALKONDA",
    "state": "TELANGANA"
  },
  "503217": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503218": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503219": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503220": {
    "city": "BALKONDA",
    "state": "TELANGANA"
  },
  "503221": {
    "city": "ARMOOR",
    "state": "TELANGANA"
  },
  "503222": {
    "city": "ARMOOR",
    "state": "TELANGANA"
  },
  "503223": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503224": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503225": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503226": {
    "city": "BALKONDA",
    "state": "TELANGANA"
  },
  "503227": {
    "city": "BALKONDA",
    "state": "TELANGANA"
  },
  "503228": {
    "city": "NIZAMABAD",
    "state": "TELANGANA"
  },
  "503230": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503231": {
    "city": "NIZAMABAD",
    "state": "TELANGANA"
  },
  "503235": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503236": {
    "city": "BODHAN",
    "state": "TELANGANA"
  },
  "503245": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503246": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503301": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503302": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503305": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503306": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503307": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503308": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503309": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503310": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503311": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503313": {
    "city": "ARMOOR",
    "state": "TELANGANA"
  },
  "503321": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "503322": {
    "city": "Nizamabad",
    "state": "Telangana"
  },
  "504001": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504002": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504003": {
    "city": "ICHODA",
    "state": "TELANGANA"
  },
  "504101": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504102": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504103": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504104": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504105": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504106": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504107": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504109": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504110": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504201": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504202": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504203": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504204": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504205": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504206": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504207": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504208": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504209": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504214": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504215": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504216": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504217": {
    "city": "BELLAMPALLI",
    "state": "TELANGANA"
  },
  "504218": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504219": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504220": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504231": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504232": {
    "city": "MANCHERIAL",
    "state": "TELANGANA"
  },
  "504251": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504272": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504273": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504292": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504293": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504294": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504295": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504296": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504297": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504299": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504301": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504302": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504303": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504304": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504305": {
    "city": "NIRMAL",
    "state": "TELANGANA"
  },
  "504306": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504307": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504308": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504309": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504310": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504311": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504312": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504313": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504321": {
    "city": "BOATH",
    "state": "TELANGANA"
  },
  "504322": {
    "city": "BOATH",
    "state": "TELANGANA"
  },
  "504323": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "504324": {
    "city": "BOATH",
    "state": "TELANGANA"
  },
  "504325": {
    "city": "BOATH",
    "state": "TELANGANA"
  },
  "504344": {
    "city": "UTNOOR",
    "state": "TELANGANA"
  },
  "504346": {
    "city": "Adilabad",
    "state": "Telangana"
  },
  "505001": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505002": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505101": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505102": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505122": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505129": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505152": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505153": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505162": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505171": {
    "city": "PEDDAPALLI",
    "state": "TELANGANA"
  },
  "505172": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505173": {
    "city": "PEDDAPALLI",
    "state": "TELANGANA"
  },
  "505174": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505184": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505185": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505186": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505187": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505188": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505208": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505209": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505210": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505211": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505212": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505214": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505215": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505301": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505302": {
    "city": "Rajanna Sircilla",
    "state": "Telangana"
  },
  "505303": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505304": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505305": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505306": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505307": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505309": {
    "city": "VEMULAWADA",
    "state": "TELANGANA"
  },
  "505325": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505326": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505327": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505330": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505331": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505401": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505402": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505403": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505404": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505405": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505407": {
    "city": "SIRICILLA",
    "state": "TELANGANA"
  },
  "505413": {
    "city": "CHOPPADANDI",
    "state": "TELANGANA"
  },
  "505415": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505416": {
    "city": "Peddapalli",
    "state": "Andhra Pradesh"
  },
  "505417": {
    "city": "CHOPPADANDI",
    "state": "TELANGANA"
  },
  "505425": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505445": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505450": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505451": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505452": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505453": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505454": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505455": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505459": {
    "city": "JAGTIAL",
    "state": "TELANGANA"
  },
  "505460": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505462": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505466": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505467": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505468": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505469": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505470": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505471": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505472": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505473": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505474": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505475": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505476": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505480": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505481": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505490": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505497": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505498": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505501": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505502": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505503": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505504": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505505": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505514": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505524": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505525": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505526": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505527": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505528": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505529": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505530": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505531": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505532": {
    "city": "Karim Nagar",
    "state": "Telangana"
  },
  "505533": {
    "city": "JAGTIAL",
    "state": "TELANGANA"
  },
  "506000": {
    "city": "WARANGAL",
    "state": "TELANGANA"
  },
  "506001": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506002": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506003": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506004": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506005": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506006": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506007": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506008": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506009": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506010": {
    "city": "WARANGAL",
    "state": "TELANGANA"
  },
  "506011": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506012": {
    "city": "WARANGAL",
    "state": "TELANGANA"
  },
  "506013": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506015": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506101": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506102": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506103": {
    "city": "Mahabubabad",
    "state": "Telangana"
  },
  "506104": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506105": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506112": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506122": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506132": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506133": {
    "city": "NARSAMPET",
    "state": "TELANGANA"
  },
  "506134": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506135": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506142": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506143": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506144": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506145": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506146": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506151": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506163": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506164": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506165": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506166": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506167": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506168": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506169": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506170": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506172": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506175": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506201": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506221": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506222": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506223": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506224": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506244": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506252": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506301": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506302": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506303": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506310": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506313": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506314": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506315": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506316": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506317": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506318": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506319": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506321": {
    "city": "PARKAL",
    "state": "TELANGANA"
  },
  "506324": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506329": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506330": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506331": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506332": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506342": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506343": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506344": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506345": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506347": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506348": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506349": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506352": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506353": {
    "city": "STATION GHANPUR",
    "state": "TELANGANA"
  },
  "506355": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506356": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506365": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506366": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506367": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506368": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506369": {
    "city": "Mahabubabad",
    "state": "Telangana"
  },
  "506370": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506371": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506381": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "506391": {
    "city": "Warangal",
    "state": "Telangana"
  },
  "507001": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507002": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507003": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507004": {
    "city": "KHAMMAM",
    "state": "TELANGANA"
  },
  "507101": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507103": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507111": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507112": {
    "city": "BHADRACHALAM",
    "state": "TELANGANA"
  },
  "507113": {
    "city": "BHADRACHALAM",
    "state": "TELANGANA"
  },
  "507114": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507115": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507116": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507117": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507118": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507119": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507120": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507121": {
    "city": "BHADRACHALAM",
    "state": "TELANGANA"
  },
  "507122": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507123": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507124": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507125": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507126": {
    "city": "BHADRACHALAM",
    "state": "TELANGANA"
  },
  "507127": {
    "city": "BHADRACHALAM",
    "state": "TELANGANA"
  },
  "507128": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507129": {
    "city": "BHADRACHALAM",
    "state": "TELANGANA"
  },
  "507130": {
    "city": "BHADRACHALAM",
    "state": "TELANGANA"
  },
  "507131": {
    "city": "BHADRACHALAM",
    "state": "TELANGANA"
  },
  "507132": {
    "city": "BHADRACHALAM",
    "state": "TELANGANA"
  },
  "507133": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507134": {
    "city": "BHADRACHALAM",
    "state": "TELANGANA"
  },
  "507135": {
    "city": "BHADRACHALAM",
    "state": "TELANGANA"
  },
  "507136": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507137": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507138": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507139": {
    "city": "BHADRACHALAM",
    "state": "TELANGANA"
  },
  "507140": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507141": {
    "city": "BHADRACHALAM",
    "state": "TELANGANA"
  },
  "507152": {
    "city": "PALWANCHA",
    "state": "TELANGANA"
  },
  "507153": {
    "city": "PALWANCHA",
    "state": "TELANGANA"
  },
  "507154": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507156": {
    "city": "PALAIR",
    "state": "TELANGANA"
  },
  "507157": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507158": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507159": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507160": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507161": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507162": {
    "city": "PALAIR",
    "state": "TELANGANA"
  },
  "507163": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507164": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507165": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507166": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507167": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507168": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507169": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507170": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507172": {
    "city": "PALAIR",
    "state": "TELANGANA"
  },
  "507182": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507183": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507201": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507202": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507203": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507204": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507206": {
    "city": "WYRA",
    "state": "TELANGANA"
  },
  "507207": {
    "city": "WYRA",
    "state": "TELANGANA"
  },
  "507208": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507209": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507210": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507211": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507212": {
    "city": "MAHABUBABAD",
    "state": "TELANGANA"
  },
  "507213": {
    "city": "MAHABUBABAD",
    "state": "TELANGANA"
  },
  "507301": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507302": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507303": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507304": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507305": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507306": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507316": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "507318": {
    "city": "Khammam",
    "state": "Telangana"
  },
  "508001": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508002": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508004": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508101": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508102": {
    "city": "ALER",
    "state": "TELANGANA"
  },
  "508105": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508111": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508112": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508113": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508114": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508115": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508116": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508117": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508125": {
    "city": "BHONGIR",
    "state": "TELANGANA"
  },
  "508126": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508127": {
    "city": "BHONGIR",
    "state": "TELANGANA"
  },
  "508201": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508202": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508203": {
    "city": "MACHERLA",
    "state": "ANDHRA PRADESH"
  },
  "508204": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508205": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508206": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508207": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508208": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508210": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508211": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508212": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508213": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508214": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508215": {
    "city": "MIRYALGUDA",
    "state": "TELANGANA"
  },
  "508216": {
    "city": "MIRYALGUDA",
    "state": "TELANGANA"
  },
  "508217": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508218": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508219": {
    "city": "HUZURNAGAR",
    "state": "TELANGANA"
  },
  "508220": {
    "city": "SURYAPET",
    "state": "TELANGANA"
  },
  "508221": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508222": {
    "city": "SURYAPET",
    "state": "TELANGANA"
  },
  "508223": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508224": {
    "city": "Suryapet",
    "state": "Telangana"
  },
  "508225": {
    "city": "SURYAPET",
    "state": "TELANGANA"
  },
  "508233": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508234": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508238": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508243": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508244": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508245": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508246": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508247": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508248": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508250": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508252": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508253": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508254": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508255": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508256": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508257": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508258": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508259": {
    "city": "DEVARAKONDA",
    "state": "TELANGANA"
  },
  "508265": {
    "city": "DEVARAKONDA",
    "state": "TELANGANA"
  },
  "508266": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508268": {
    "city": "DEVARAKONDA",
    "state": "TELANGANA"
  },
  "508277": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508278": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508279": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508280": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508281": {
    "city": "SURYAPET",
    "state": "TELANGANA"
  },
  "508282": {
    "city": "POCHAMPALLY",
    "state": "TELANGANA"
  },
  "508283": {
    "city": "POCHAMPALLY",
    "state": "TELANGANA"
  },
  "508284": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508285": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508286": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508287": {
    "city": "ALER",
    "state": "TELANGANA"
  },
  "508288": {
    "city": "ALER",
    "state": "TELANGANA"
  },
  "508353": {
    "city": "MIRYALGUDA",
    "state": "TELANGANA"
  },
  "508355": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508357": {
    "city": "MIRYALGUDA",
    "state": "TELANGANA"
  },
  "508373": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508374": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508375": {
    "city": "SURYAPET",
    "state": "TELANGANA"
  },
  "508376": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "508377": {
    "city": "Nalgonda",
    "state": "Telangana"
  },
  "509001": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509002": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509102": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509103": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509104": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509105": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509106": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509107": {
    "city": "WANAPARTHY",
    "state": "TELANGANA"
  },
  "509108": {
    "city": "WANAPARTHY",
    "state": "TELANGANA"
  },
  "509109": {
    "city": "WANAPARTHY",
    "state": "TELANGANA"
  },
  "509110": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509111": {
    "city": "WANAPARTHY",
    "state": "TELANGANA"
  },
  "509112": {
    "city": "WANAPARTHY",
    "state": "TELANGANA"
  },
  "509120": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509125": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509126": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509127": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509128": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509129": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509130": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509131": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509132": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509133": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509134": {
    "city": "IEEJA",
    "state": "TELANGANA"
  },
  "509135": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509136": {
    "city": "IEEJA",
    "state": "TELANGANA"
  },
  "509137": {
    "city": "IEEJA",
    "state": "TELANGANA"
  },
  "509138": {
    "city": "IEEJA",
    "state": "TELANGANA"
  },
  "509142": {
    "city": "ALAMPUR",
    "state": "TELANGANA"
  },
  "509143": {
    "city": "ALAMPUR",
    "state": "TELANGANA"
  },
  "509144": {
    "city": "ALAMPUR",
    "state": "TELANGANA"
  },
  "509145": {
    "city": "ALAMPUR",
    "state": "TELANGANA"
  },
  "509146": {
    "city": "ALAMPUR",
    "state": "TELANGANA"
  },
  "509150": {
    "city": "KURNOOL",
    "state": "ANDHRA PRADESH"
  },
  "509151": {
    "city": "KURNOOL",
    "state": "ANDHRA PRADESH"
  },
  "509152": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509153": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509154": {
    "city": "KURNOOL",
    "state": "ANDHRA PRADESH"
  },
  "509155": {
    "city": "KURNOOL",
    "state": "ANDHRA PRADESH"
  },
  "509201": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509202": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509203": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509204": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509205": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509206": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509207": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509208": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509209": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509210": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509211": {
    "city": "NARAYANPET",
    "state": "TELANGANA"
  },
  "509212": {
    "city": "NARAYANPET",
    "state": "TELANGANA"
  },
  "509213": {
    "city": "NAGARKURNOOL",
    "state": "TELANGANA"
  },
  "509214": {
    "city": "NAGARKURNOOL",
    "state": "TELANGANA"
  },
  "509215": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509216": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509217": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "509218": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "509219": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509220": {
    "city": "WANAPARTHY",
    "state": "TELANGANA"
  },
  "509221": {
    "city": "WANAPARTHY",
    "state": "TELANGANA"
  },
  "509226": {
    "city": "SHADNAGAR",
    "state": "TELANGANA"
  },
  "509227": {
    "city": "SHADNAGAR",
    "state": "TELANGANA"
  },
  "509228": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509235": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509301": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509302": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509303": {
    "city": "JADCHERLA",
    "state": "TELANGANA"
  },
  "509307": {
    "city": "JADCHERLA",
    "state": "TELANGANA"
  },
  "509309": {
    "city": "JADCHERLA",
    "state": "TELANGANA"
  },
  "509311": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509320": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509321": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509323": {
    "city": "KALWAKURTHY",
    "state": "TELANGANA"
  },
  "509324": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509325": {
    "city": "K.V.Rangareddy",
    "state": "Telangana"
  },
  "509326": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509327": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509328": {
    "city": "DEVARAKONDA",
    "state": "TELANGANA"
  },
  "509329": {
    "city": "DEVARAKONDA",
    "state": "TELANGANA"
  },
  "509332": {
    "city": "MAHBUBNAGAR",
    "state": "TELANGANA"
  },
  "509333": {
    "city": "MAHBUBNAGAR",
    "state": "TELANGANA"
  },
  "509334": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509335": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509336": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509337": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509338": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509339": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509340": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509341": {
    "city": "JADCHERLA",
    "state": "TELANGANA"
  },
  "509342": {
    "city": "JADCHERLA",
    "state": "TELANGANA"
  },
  "509347": {
    "city": "KALWAKURTHY",
    "state": "TELANGANA"
  },
  "509348": {
    "city": "KALWAKURTHY",
    "state": "TELANGANA"
  },
  "509349": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509350": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509351": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509352": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509353": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509357": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509358": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509359": {
    "city": "KALWAKURTHY",
    "state": "TELANGANA"
  },
  "509360": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509361": {
    "city": "KALWAKURTHY",
    "state": "TELANGANA"
  },
  "509362": {
    "city": "KALWAKURTHY",
    "state": "TELANGANA"
  },
  "509371": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509375": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509376": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509380": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509381": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509382": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509383": {
    "city": "JADCHERLA",
    "state": "TELANGANA"
  },
  "509384": {
    "city": "NAGARKURNOOL",
    "state": "TELANGANA"
  },
  "509385": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509401": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509406": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509407": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509408": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509409": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509410": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509411": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509412": {
    "city": "Mahabub Nagar",
    "state": "Telangana"
  },
  "509413": {
    "city": "NAGARKURNOOL",
    "state": "TELANGANA"
  },
  "509414": {
    "city": "NAGARKURNOOL",
    "state": "TELANGANA"
  },
  "511100": {
    "city": "Hyderabad",
    "state": "TELANGANA"
  },
  "511111": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "514015": {
    "city": "Satara",
    "state": "MAHARASHTRA"
  },
  "515001": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515002": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515003": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515004": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515005": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515101": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515102": {
    "city": "DHARMAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "515110": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515121": {
    "city": "PENUKONDA",
    "state": "ANDHRA PRADESH"
  },
  "515122": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515123": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515124": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515133": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515134": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515144": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515154": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515159": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515161": {
    "city": "PUTTAPARTHI",
    "state": "ANDHRA PRADESH"
  },
  "515164": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515201": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515202": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515211": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515212": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515213": {
    "city": "HINDUPUR",
    "state": "ANDHRA PRADESH"
  },
  "515214": {
    "city": "KALYANDURG",
    "state": "ANDHRA PRADESH"
  },
  "515231": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515232": {
    "city": "GORANTLA",
    "state": "ANDHRA PRADESH"
  },
  "515233": {
    "city": "GORANTLA",
    "state": "ANDHRA PRADESH"
  },
  "515241": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515261": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515271": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515281": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515282": {
    "city": "DHARMAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "515286": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515291": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515292": {
    "city": "MADAKASIRA",
    "state": "ANDHRA PRADESH"
  },
  "515301": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515302": {
    "city": "MADAKASIRA",
    "state": "ANDHRA PRADESH"
  },
  "515303": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515305": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515306": {
    "city": "MADAKASIRA",
    "state": "ANDHRA PRADESH"
  },
  "515307": {
    "city": "MADAKASIRA",
    "state": "ANDHRA PRADESH"
  },
  "515311": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515321": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515322": {
    "city": "MADAKASIRA",
    "state": "ANDHRA PRADESH"
  },
  "515331": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515332": {
    "city": "HINDUPUR",
    "state": "ANDHRA PRADESH"
  },
  "515341": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515401": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515402": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515404": {
    "city": "DHARMAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "515405": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515408": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515409": {
    "city": "TADIPATRI",
    "state": "ANDHRA PRADESH"
  },
  "515411": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515412": {
    "city": "TADIPATRI",
    "state": "ANDHRA PRADESH"
  },
  "515413": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515414": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515415": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515416": {
    "city": "TADIPATRI",
    "state": "ANDHRA PRADESH"
  },
  "515419": {
    "city": "TADIPATRI",
    "state": "ANDHRA PRADESH"
  },
  "515421": {
    "city": "TADIPATRI",
    "state": "ANDHRA PRADESH"
  },
  "515422": {
    "city": "TADIPATRI",
    "state": "ANDHRA PRADESH"
  },
  "515425": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515426": {
    "city": "SINGANAMALA",
    "state": "ANDHRA PRADESH"
  },
  "515427": {
    "city": "SINGANAMALA",
    "state": "ANDHRA PRADESH"
  },
  "515434": {
    "city": "SINGANAMALA",
    "state": "ANDHRA PRADESH"
  },
  "515435": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515445": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515446": {
    "city": "DHARMAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "515455": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515456": {
    "city": "GUNTAKAL",
    "state": "ANDHRA PRADESH"
  },
  "515457": {
    "city": "GOOTY",
    "state": "ANDHRA PRADESH"
  },
  "515458": {
    "city": "GOOTY",
    "state": "ANDHRA PRADESH"
  },
  "515465": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515466": {
    "city": "TADIPATRI",
    "state": "ANDHRA PRADESH"
  },
  "515501": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515502": {
    "city": "KADRI",
    "state": "ANDHRA PRADESH"
  },
  "515511": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515521": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515531": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515541": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515551": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515556": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515561": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515566": {
    "city": "GORANTLA",
    "state": "ANDHRA PRADESH"
  },
  "515571": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515572": {
    "city": "KADRI",
    "state": "ANDHRA PRADESH"
  },
  "515581": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515583": {
    "city": "KADRI",
    "state": "ANDHRA PRADESH"
  },
  "515591": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515601": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515611": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515621": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515631": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515641": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515651": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515661": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515662": {
    "city": "DHARMAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "515671": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515672": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515701": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515711": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515712": {
    "city": "RAYADURG",
    "state": "ANDHRA PRADESH"
  },
  "515721": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515722": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515731": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515736": {
    "city": "SINGANAMALA",
    "state": "ANDHRA PRADESH"
  },
  "515741": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515751": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515752": {
    "city": "KALYANDURG",
    "state": "ANDHRA PRADESH"
  },
  "515761": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515762": {
    "city": "KALYANDURG",
    "state": "ANDHRA PRADESH"
  },
  "515763": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515765": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515766": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515767": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515774": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515775": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515787": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515801": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515803": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515812": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515813": {
    "city": "URAVAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "515814": {
    "city": "GOOTY",
    "state": "ANDHRA PRADESH"
  },
  "515822": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515823": {
    "city": "URAVAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "515824": {
    "city": "URAVAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "515832": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515833": {
    "city": "URAVAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "515834": {
    "city": "URAVAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "515835": {
    "city": "GUNTAKAL",
    "state": "ANDHRA PRADESH"
  },
  "515842": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515843": {
    "city": "GUNTAKAL",
    "state": "ANDHRA PRADESH"
  },
  "515844": {
    "city": "GUNTAKAL",
    "state": "ANDHRA PRADESH"
  },
  "515862": {
    "city": "RAYADURG",
    "state": "ANDHRA PRADESH"
  },
  "515863": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515865": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515866": {
    "city": "GORANTLA",
    "state": "ANDHRA PRADESH"
  },
  "515867": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515870": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515871": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "515872": {
    "city": "Ananthapur",
    "state": "Andhra Pradesh"
  },
  "516001": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516002": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516003": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516004": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516005": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516006": {
    "city": "KADAPA",
    "state": "ANDHRA PRADESH"
  },
  "516101": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516102": {
    "city": "RLY KODURU",
    "state": "ANDHRA PRADESH"
  },
  "516103": {
    "city": "YERRAGUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "516104": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516105": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516106": {
    "city": "RAJAMPET",
    "state": "ANDHRA PRADESH"
  },
  "516107": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516108": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516109": {
    "city": "YERRAGUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "516110": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516111": {
    "city": "RAJAMPET",
    "state": "ANDHRA PRADESH"
  },
  "516112": {
    "city": "RLY KODURU",
    "state": "ANDHRA PRADESH"
  },
  "516113": {
    "city": "RAJAMPET",
    "state": "ANDHRA PRADESH"
  },
  "516114": {
    "city": "PRODDATUR",
    "state": "ANDHRA PRADESH"
  },
  "516115": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516116": {
    "city": "RAJAMPET",
    "state": "ANDHRA PRADESH"
  },
  "516117": {
    "city": "RAJAMPET",
    "state": "ANDHRA PRADESH"
  },
  "516118": {
    "city": "PULIVENDULA",
    "state": "ANDHRA PRADESH"
  },
  "516119": {
    "city": "RAJAMPET",
    "state": "ANDHRA PRADESH"
  },
  "516120": {
    "city": "RAYACHOTI",
    "state": "ANDHRA PRADESH"
  },
  "516126": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516127": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516128": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516129": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516130": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516131": {
    "city": "RAJAMPET",
    "state": "ANDHRA PRADESH"
  },
  "516132": {
    "city": "RAJAMPET",
    "state": "ANDHRA PRADESH"
  },
  "516133": {
    "city": "RAYACHOTI",
    "state": "ANDHRA PRADESH"
  },
  "516134": {
    "city": "RAJAMPET",
    "state": "ANDHRA PRADESH"
  },
  "516150": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516151": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516152": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516153": {
    "city": "RAJAMPET",
    "state": "ANDHRA PRADESH"
  },
  "516155": {
    "city": "BADVEL",
    "state": "ANDHRA PRADESH"
  },
  "516162": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516163": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516164": {
    "city": "YERRAGUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "516165": {
    "city": "YERRAGUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "516166": {
    "city": "YERRAGUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "516172": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516173": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516175": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516193": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516203": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516213": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516214": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516215": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516216": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516217": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516218": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516219": {
    "city": "YERRAGUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "516223": {
    "city": "PRODDATUR",
    "state": "ANDHRA PRADESH"
  },
  "516227": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516228": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516233": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516237": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516238": {
    "city": "PULIVENDULA",
    "state": "ANDHRA PRADESH"
  },
  "516241": {
    "city": "RAYACHOTI",
    "state": "ANDHRA PRADESH"
  },
  "516247": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516248": {
    "city": "RAJAMPET",
    "state": "ANDHRA PRADESH"
  },
  "516257": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516259": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516260": {
    "city": "PULIVENDULA",
    "state": "ANDHRA PRADESH"
  },
  "516267": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516268": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516269": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516270": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516271": {
    "city": "LAKKIREDDY PALLI",
    "state": "ANDHRA PRADESH"
  },
  "516272": {
    "city": "LAKKIREDDY PALLI",
    "state": "ANDHRA PRADESH"
  },
  "516289": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516290": {
    "city": "YERRAGUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "516291": {
    "city": "BADVEL",
    "state": "ANDHRA PRADESH"
  },
  "516292": {
    "city": "YERRAGUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "516293": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516309": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516310": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516311": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516312": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516319": {
    "city": "BADVEL",
    "state": "ANDHRA PRADESH"
  },
  "516321": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516329": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516330": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516339": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516349": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516350": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516355": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516356": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516357": {
    "city": "RAJAMPET",
    "state": "ANDHRA PRADESH"
  },
  "516359": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516360": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516361": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516362": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516363": {
    "city": "RAJAMPET",
    "state": "ANDHRA PRADESH"
  },
  "516364": {
    "city": "PRODDATUR",
    "state": "ANDHRA PRADESH"
  },
  "516365": {
    "city": "RAYACHOTI",
    "state": "ANDHRA PRADESH"
  },
  "516366": {
    "city": "PRODDATUR",
    "state": "ANDHRA PRADESH"
  },
  "516380": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516390": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516391": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516392": {
    "city": "YERRAGUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "516396": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516401": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516411": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516412": {
    "city": "JAMMALAMADUGU",
    "state": "ANDHRA PRADESH"
  },
  "516413": {
    "city": "JAMMALAMADUGU",
    "state": "ANDHRA PRADESH"
  },
  "516421": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516431": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516432": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516433": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516434": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516437": {
    "city": "BADVEL",
    "state": "ANDHRA PRADESH"
  },
  "516438": {
    "city": "JAMMALAMADUGU",
    "state": "ANDHRA PRADESH"
  },
  "516439": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516440": {
    "city": "JAMMALAMADUGU",
    "state": "ANDHRA PRADESH"
  },
  "516441": {
    "city": "JAMMALAMADUGU",
    "state": "ANDHRA PRADESH"
  },
  "516444": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516454": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516464": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516474": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516484": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516486": {
    "city": "PULIVENDULA",
    "state": "ANDHRA PRADESH"
  },
  "516501": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516502": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516503": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516504": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516505": {
    "city": "Cuddapah",
    "state": "Andhra Pradesh"
  },
  "516506": {
    "city": "VELDURTHI",
    "state": "ANDHRA PRADESH"
  },
  "517001": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517002": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517003": {
    "city": "CHITTOOR",
    "state": "ANDHRA PRADESH"
  },
  "517004": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517007": {
    "city": "Chittoor",
    "state": "ANDHRA PRADESH"
  },
  "517101": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517102": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517103": {
    "city": "CHANDRAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "517104": {
    "city": "CHANDRAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "517110": {
    "city": "IRALA",
    "state": "ANDHRA PRADESH"
  },
  "517111": {
    "city": "IRALA",
    "state": "ANDHRA PRADESH"
  },
  "517112": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517113": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517114": {
    "city": "PILERU",
    "state": "ANDHRA PRADESH"
  },
  "517115": {
    "city": "PILERU",
    "state": "ANDHRA PRADESH"
  },
  "517123": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517124": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517125": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517126": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517127": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517128": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517129": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517130": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517131": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517132": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517133": {
    "city": "CHITTOOR",
    "state": "ANDHRA PRADESH"
  },
  "517134": {
    "city": "CHITTOOR",
    "state": "ANDHRA PRADESH"
  },
  "517150": {
    "city": "IRALA",
    "state": "ANDHRA PRADESH"
  },
  "517151": {
    "city": "IRALA",
    "state": "ANDHRA PRADESH"
  },
  "517152": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517153": {
    "city": "IRALA",
    "state": "ANDHRA PRADESH"
  },
  "517154": {
    "city": "IRALA",
    "state": "ANDHRA PRADESH"
  },
  "517165": {
    "city": "NAGARI",
    "state": "ANDHRA PRADESH"
  },
  "517166": {
    "city": "NAGARI",
    "state": "ANDHRA PRADESH"
  },
  "517167": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517172": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517173": {
    "city": "PILERU",
    "state": "ANDHRA PRADESH"
  },
  "517192": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517193": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517194": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517195": {
    "city": "PILERU",
    "state": "ANDHRA PRADESH"
  },
  "517196": {
    "city": "PILERU",
    "state": "ANDHRA PRADESH"
  },
  "517213": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517214": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517215": {
    "city": "PILERU",
    "state": "ANDHRA PRADESH"
  },
  "517216": {
    "city": "PILERU",
    "state": "ANDHRA PRADESH"
  },
  "517234": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517235": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517236": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517237": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517238": {
    "city": "VAYALPAD",
    "state": "ANDHRA PRADESH"
  },
  "517239": {
    "city": "VAYALPAD",
    "state": "ANDHRA PRADESH"
  },
  "517247": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517248": {
    "city": "PUNGANUR",
    "state": "ANDHRA PRADESH"
  },
  "517249": {
    "city": "PUNGANUR",
    "state": "ANDHRA PRADESH"
  },
  "517257": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517258": {
    "city": "PUNGANUR",
    "state": "ANDHRA PRADESH"
  },
  "517259": {
    "city": "PUNGANUR",
    "state": "ANDHRA PRADESH"
  },
  "517277": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517278": {
    "city": "VAYALPAD",
    "state": "ANDHRA PRADESH"
  },
  "517280": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517291": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517292": {
    "city": "VAYALPAD",
    "state": "ANDHRA PRADESH"
  },
  "517297": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517298": {
    "city": "VAYALPAD",
    "state": "ANDHRA PRADESH"
  },
  "517299": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517301": {
    "city": "VAYALPAD",
    "state": "ANDHRA PRADESH"
  },
  "517305": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517319": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517325": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517326": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517327": {
    "city": "MADANEPALLE",
    "state": "ANDHRA PRADESH"
  },
  "517330": {
    "city": "MADANEPALLE",
    "state": "ANDHRA PRADESH"
  },
  "517350": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517351": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517352": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517370": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517390": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517391": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517401": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517403": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517408": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517414": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517415": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517416": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517417": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517418": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517419": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517421": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517422": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517423": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517424": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517425": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517426": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517429": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517431": {
    "city": "PALAMANER",
    "state": "ANDHRA PRADESH"
  },
  "517432": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517501": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517502": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517503": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517504": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517505": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517506": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517507": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517520": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517526": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517527": {
    "city": "PUTTUR",
    "state": "ANDHRA PRADESH"
  },
  "517536": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517541": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517551": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517561": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517562": {
    "city": "CHANDRAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "517567": {
    "city": "CHANDRAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "517569": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517571": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517581": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517582": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517583": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517584": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517586": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517587": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517588": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517589": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517590": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517591": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517592": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517599": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517619": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517620": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517621": {
    "city": "SRIKALAHASTI",
    "state": "ANDHRA PRADESH"
  },
  "517640": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517641": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517642": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517643": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517644": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517645": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "517646": {
    "city": "Chittoor",
    "state": "Andhra Pradesh"
  },
  "518001": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518002": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518003": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518004": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518005": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518006": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518007": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518008": {
    "city": "KURNOOL",
    "state": "ANDHRA PRADESH"
  },
  "518010": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518011": {
    "city": "VELDURTHI",
    "state": "ANDHRA PRADESH"
  },
  "518015": {
    "city": "KURNOOL",
    "state": "ANDHRA PRADESH"
  },
  "518016": {
    "city": "PATTIKANDA",
    "state": "ANDHRA PRADESH"
  },
  "518017": {
    "city": "GOOTY",
    "state": "ANDHRA PRADESH"
  },
  "518018": {
    "city": "KURNOOL",
    "state": "ANDHRA PRADESH"
  },
  "518019": {
    "city": "KURNOOL",
    "state": "ANDHRA PRADESH"
  },
  "518020": {
    "city": "KURNOOL",
    "state": "ANDHRA PRADESH"
  },
  "518021": {
    "city": "KURNOOL",
    "state": "ANDHRA PRADESH"
  },
  "518022": {
    "city": "KURNOOL",
    "state": "ANDHRA PRADESH"
  },
  "518023": {
    "city": "KURNOOL",
    "state": "ANDHRA PRADESH"
  },
  "518101": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518102": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518112": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518115": {
    "city": "CHIIPPAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "518122": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518123": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518124": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518134": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518135": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518137": {
    "city": "KOILKUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "518138": {
    "city": "KOILKUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "518145": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518146": {
    "city": "KOILKUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "518150": {
    "city": "KOILKUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "518155": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518157": {
    "city": "KOILKUNTLA",
    "state": "ANDHRA PRADESH"
  },
  "518158": {
    "city": "YEMMIGANUR",
    "state": "ANDHRA PRADESH"
  },
  "518165": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518166": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518176": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518186": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518196": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518202": {
    "city": "NANDYAL",
    "state": "ANDHRA PRADESH"
  },
  "518206": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518216": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518217": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518218": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518219": {
    "city": "VELDURTHI",
    "state": "ANDHRA PRADESH"
  },
  "518220": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518221": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518222": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518225": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518301": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518302": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518308": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518313": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518323": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518333": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518343": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518344": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518345": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518346": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518347": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518348": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518349": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518350": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518360": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518363": {
    "city": "NANDYAL",
    "state": "ANDHRA PRADESH"
  },
  "518380": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518382": {
    "city": "SINGANAMALA",
    "state": "ANDHRA PRADESH"
  },
  "518385": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518390": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518395": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518396": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518397": {
    "city": "VELDURTHI",
    "state": "ANDHRA PRADESH"
  },
  "518398": {
    "city": "ALUR",
    "state": "ANDHRA PRADESH"
  },
  "518399": {
    "city": "CHIIPPAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "518401": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518402": {
    "city": "ATMAKUR KURNOOL",
    "state": "ANDHRA PRADESH"
  },
  "518405": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518411": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518412": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518422": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518426": {
    "city": "PATTIKANDA",
    "state": "ANDHRA PRADESH"
  },
  "518432": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518442": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518452": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518462": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518463": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518464": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518465": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518466": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518467": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518468": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518470": {
    "city": "KODUMUR",
    "state": "ANDHRA PRADESH"
  },
  "518501": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518502": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518503": {
    "city": "NANDYAL",
    "state": "ANDHRA PRADESH"
  },
  "518508": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518510": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518511": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518512": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518513": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518515": {
    "city": "CHIIPPAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "518517": {
    "city": "NANDIKOTKUR",
    "state": "ANDHRA PRADESH"
  },
  "518523": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518533": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518543": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518550": {
    "city": "ALLAGADDA",
    "state": "ANDHRA PRADESH"
  },
  "518553": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518555": {
    "city": "ALLAGADDA",
    "state": "ANDHRA PRADESH"
  },
  "518563": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518573": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518583": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518593": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518594": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518596": {
    "city": "NANDYAL",
    "state": "ANDHRA PRADESH"
  },
  "518598": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518599": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518607": {
    "city": "ALLAGADDA",
    "state": "ANDHRA PRADESH"
  },
  "518669": {
    "city": "NANDYAL",
    "state": "ANDHRA PRADESH"
  },
  "518673": {
    "city": "NANDYAL",
    "state": "ANDHRA PRADESH"
  },
  "518674": {
    "city": "Kurnool",
    "state": "Andhra Pradesh"
  },
  "518675": {
    "city": "NANDYAL",
    "state": "ANDHRA PRADESH"
  },
  "520000": {
    "city": "Vijayawada",
    "state": "ANDHRA PRADESH"
  },
  "520001": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "520002": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "520003": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "520004": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "520005": {
    "city": "VIJAYAWADA",
    "state": "ANDHRA PRADESH"
  },
  "520006": {
    "city": "VIJAYAWADA",
    "state": "ANDHRA PRADESH"
  },
  "520007": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "520008": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "520009": {
    "city": "VIJAYAWADA",
    "state": "ANDHRA PRADESH"
  },
  "520010": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "520011": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "520012": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "520013": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "520014": {
    "city": "VIJAYAWADA",
    "state": "ANDHRA PRADESH"
  },
  "520015": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "520016": {
    "city": "VIJAYAWADA",
    "state": "ANDHRA PRADESH"
  },
  "520028": {
    "city": "VIJAYAWADA",
    "state": "ANDHRA PRADESH"
  },
  "520040": {
    "city": "VIJAYAWADA",
    "state": "ANDHRA PRADESH"
  },
  "520050": {
    "city": "AVANIGADDA",
    "state": "ANDHRA PRADESH"
  },
  "521001": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521002": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521003": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521011": {
    "city": "KAIKALURU",
    "state": "ANDHRA PRADESH"
  },
  "521101": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521102": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521103": {
    "city": "GANNAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "521104": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521105": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521106": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521107": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521108": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521109": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521110": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521111": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521112": {
    "city": "GANNAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "521113": {
    "city": "KANKIPADU",
    "state": "ANDHRA PRADESH"
  },
  "521114": {
    "city": "KANKIPADU",
    "state": "ANDHRA PRADESH"
  },
  "521116": {
    "city": "KANKIPADU",
    "state": "ANDHRA PRADESH"
  },
  "521117": {
    "city": "KAIKALURU",
    "state": "ANDHRA PRADESH"
  },
  "521118": {
    "city": "AVANIGADDA",
    "state": "ANDHRA PRADESH"
  },
  "521120": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521121": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521122": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521123": {
    "city": "NUZVID",
    "state": "ANDHRA PRADESH"
  },
  "521124": {
    "city": "GUDIVADA",
    "state": "ANDHRA PRADESH"
  },
  "521125": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521126": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521128": {
    "city": "KANKIPADU",
    "state": "ANDHRA PRADESH"
  },
  "521129": {
    "city": "AVANIGADDA",
    "state": "ANDHRA PRADESH"
  },
  "521130": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521131": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521132": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521133": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521134": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521135": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521136": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521137": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521138": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521139": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521140": {
    "city": "VUYYURU",
    "state": "ANDHRA PRADESH"
  },
  "521144": {
    "city": "NUZVID",
    "state": "ANDHRA PRADESH"
  },
  "521148": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521149": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521150": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521151": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521153": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521155": {
    "city": "KANKIPADU",
    "state": "ANDHRA PRADESH"
  },
  "521156": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521157": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521158": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521162": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521163": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521164": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521165": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521170": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521171": {
    "city": "MYLAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "521175": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521176": {
    "city": "JAGGAYYAPETA",
    "state": "ANDHRA PRADESH"
  },
  "521177": {
    "city": "KANKIPADU",
    "state": "ANDHRA PRADESH"
  },
  "521178": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521179": {
    "city": "NANDIGAMA",
    "state": "ANDHRA PRADESH"
  },
  "521180": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521181": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521182": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521183": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521184": {
    "city": "MYLAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "521185": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521190": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521201": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521202": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521206": {
    "city": "NUZVID",
    "state": "ANDHRA PRADESH"
  },
  "521207": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521211": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521212": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521213": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521214": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521215": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521225": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521226": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521227": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521228": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521229": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521230": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521231": {
    "city": "MYLAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "521235": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521241": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521245": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521246": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521247": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521250": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521251": {
    "city": "VUYYURU",
    "state": "ANDHRA PRADESH"
  },
  "521255": {
    "city": "MACHILIPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "521256": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521260": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521261": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521263": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521265": {
    "city": "GANNAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "521286": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521301": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521311": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521312": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521321": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521322": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521323": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521324": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521325": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521326": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521327": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521328": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521329": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521330": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521331": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521332": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521333": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521338": {
    "city": "BHOGAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "521340": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521343": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521344": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521345": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521356": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521366": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521369": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521370": {
    "city": "KANKIPADU",
    "state": "ANDHRA PRADESH"
  },
  "521372": {
    "city": "GANNAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "521390": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521391": {
    "city": "MUDINEPALLE",
    "state": "ANDHRA PRADESH"
  },
  "521401": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521402": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521403": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521424": {
    "city": "GUDIVADA",
    "state": "ANDHRA PRADESH"
  },
  "521429": {
    "city": "GUDIVADA",
    "state": "ANDHRA PRADESH"
  },
  "521436": {
    "city": "NANDIGAMA",
    "state": "ANDHRA PRADESH"
  },
  "521456": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521457": {
    "city": "Krishna",
    "state": "Andhra Pradesh"
  },
  "521459": {
    "city": "JAGGAYYAPETA",
    "state": "ANDHRA PRADESH"
  },
  "522001": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522002": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522003": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522004": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522005": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522006": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522007": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522008": {
    "city": "GUNTUR",
    "state": "ANDHRA PRADESH"
  },
  "522009": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522010": {
    "city": "GUNTUR",
    "state": "ANDHRA PRADESH"
  },
  "522013": {
    "city": "GUNTUR",
    "state": "ANDHRA PRADESH"
  },
  "522014": {
    "city": "GUNTUR",
    "state": "ANDHRA PRADESH"
  },
  "522015": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522016": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522017": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522018": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522019": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522020": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522021": {
    "city": "AMARAVATI",
    "state": "ANDHRA PRADESH"
  },
  "522022": {
    "city": "GUNTUR",
    "state": "ANDHRA PRADESH"
  },
  "522024": {
    "city": "GUNTUR",
    "state": "ANDHRA PRADESH"
  },
  "522026": {
    "city": "AMARAVATI",
    "state": "ANDHRA PRADESH"
  },
  "522033": {
    "city": "GUNTUR",
    "state": "ANDHRA PRADESH"
  },
  "522034": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522035": {
    "city": "GUNTUR",
    "state": "ANDHRA PRADESH"
  },
  "522036": {
    "city": "GUNTUR",
    "state": "ANDHRA PRADESH"
  },
  "522050": {
    "city": "MANGALAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "522101": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522102": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522111": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522112": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522113": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522116": {
    "city": "BAPATLA",
    "state": "ANDHRA PRADESH"
  },
  "522123": {
    "city": "PONNUR",
    "state": "ANDHRA PRADESH"
  },
  "522124": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522125": {
    "city": "PONNUR",
    "state": "ANDHRA PRADESH"
  },
  "522180": {
    "city": "MANGALAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "522201": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522202": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522203": {
    "city": "TENALI",
    "state": "ANDHRA PRADESH"
  },
  "522210": {
    "city": "CHEBROLU",
    "state": "ANDHRA PRADESH"
  },
  "522211": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522212": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522213": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522214": {
    "city": "TENALI",
    "state": "ANDHRA PRADESH"
  },
  "522215": {
    "city": "PRATHIPADU_GUNTUR",
    "state": "ANDHRA PRADESH"
  },
  "522216": {
    "city": "CHEBROLU",
    "state": "ANDHRA PRADESH"
  },
  "522222": {
    "city": "PONNUR",
    "state": "ANDHRA PRADESH"
  },
  "522233": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522234": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522235": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522236": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522237": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522238": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522249": {
    "city": "CHILAKALURIPET",
    "state": "ANDHRA PRADESH"
  },
  "522256": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522257": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522258": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522259": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522260": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522261": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522262": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522263": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522264": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522265": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522266": {
    "city": "DUGGIRALA",
    "state": "ANDHRA PRADESH"
  },
  "522267": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522268": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522269": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522270": {
    "city": "PRATHIPADU_GUNTUR",
    "state": "ANDHRA PRADESH"
  },
  "522271": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522272": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522273": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522274": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522275": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522276": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522277": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522278": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522279": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522280": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522281": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522282": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522290": {
    "city": "DUGGIRALA",
    "state": "ANDHRA PRADESH"
  },
  "522291": {
    "city": "MANGALAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "522292": {
    "city": "DUGGIRALA",
    "state": "ANDHRA PRADESH"
  },
  "522293": {
    "city": "DUGGIRALA",
    "state": "ANDHRA PRADESH"
  },
  "522294": {
    "city": "DUGGIRALA",
    "state": "ANDHRA PRADESH"
  },
  "522295": {
    "city": "DUGGIRALA",
    "state": "ANDHRA PRADESH"
  },
  "522296": {
    "city": "VINUKONDA",
    "state": "ANDHRA PRADESH"
  },
  "522297": {
    "city": "DUGGIRALA",
    "state": "ANDHRA PRADESH"
  },
  "522298": {
    "city": "DUGGIRALA",
    "state": "ANDHRA PRADESH"
  },
  "522299": {
    "city": "DUGGIRALA",
    "state": "ANDHRA PRADESH"
  },
  "522301": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522302": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522303": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522304": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522305": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522306": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522307": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522308": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522309": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522310": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522311": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522312": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522313": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522314": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522315": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522316": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522317": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522318": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522321": {
    "city": "PONNUR",
    "state": "ANDHRA PRADESH"
  },
  "522324": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522325": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522329": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522330": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522332": {
    "city": "MANGALAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "522340": {
    "city": "PONNUR",
    "state": "ANDHRA PRADESH"
  },
  "522341": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522354": {
    "city": "PONNUR",
    "state": "ANDHRA PRADESH"
  },
  "522401": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522402": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522403": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522407": {
    "city": "AMARAVATI",
    "state": "ANDHRA PRADESH"
  },
  "522408": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522409": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522410": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522411": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522412": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522413": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522414": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522415": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522418": {
    "city": "BELLAMKONDA",
    "state": "ANDHRA PRADESH"
  },
  "522421": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522426": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522435": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522436": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522437": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522438": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522439": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522501": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522502": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522503": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522508": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522509": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522510": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522511": {
    "city": "MANGALAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "522515": {
    "city": "MANGALAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "522529": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522549": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522601": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522602": {
    "city": "NARASARAOPET",
    "state": "ANDHRA PRADESH"
  },
  "522603": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522608": {
    "city": "CHILAKALURIPET",
    "state": "ANDHRA PRADESH"
  },
  "522611": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522612": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522613": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522614": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522615": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522616": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522617": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522619": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522620": {
    "city": "DACHEPALLI",
    "state": "ANDHRA PRADESH"
  },
  "522626": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522630": {
    "city": "VINUKONDA",
    "state": "ANDHRA PRADESH"
  },
  "522631": {
    "city": "CHILAKALURIPET",
    "state": "ANDHRA PRADESH"
  },
  "522646": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522647": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522649": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522655": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "522657": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522658": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522659": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522660": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522661": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522663": {
    "city": "Guntur",
    "state": "Andhra Pradesh"
  },
  "522668": {
    "city": "VINUKONDA",
    "state": "ANDHRA PRADESH"
  },
  "523001": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523002": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523101": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523102": {
    "city": "SINGARAYAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "523104": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523105": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523106": {
    "city": "SINGARAYAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "523108": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523109": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523110": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523111": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523112": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523113": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523114": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523115": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523116": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523117": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523121": {
    "city": "KANIGIRI",
    "state": "ANDHRA PRADESH"
  },
  "523124": {
    "city": "SINGARAYAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "523125": {
    "city": "KANDUKURU",
    "state": "ANDHRA PRADESH"
  },
  "523135": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523155": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523156": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523157": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523165": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523166": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523167": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523168": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523169": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523170": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523171": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523180": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523181": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523182": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523183": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523184": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523185": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523186": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523187": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523188": {
    "city": "CHIRALA",
    "state": "ANDHRA PRADESH"
  },
  "523189": {
    "city": "CHIRALA",
    "state": "ANDHRA PRADESH"
  },
  "523190": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523194": {
    "city": "CHIRALA",
    "state": "ANDHRA PRADESH"
  },
  "523195": {
    "city": "CHIRALA",
    "state": "ANDHRA PRADESH"
  },
  "523201": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523205": {
    "city": "MARKAPUR",
    "state": "ANDHRA PRADESH"
  },
  "523211": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523212": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523213": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523214": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523216": {
    "city": "MARKAPUR",
    "state": "ANDHRA PRADESH"
  },
  "523219": {
    "city": "ADDANKI",
    "state": "ANDHRA PRADESH"
  },
  "523223": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523224": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523225": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523226": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523227": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523228": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523230": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523240": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523241": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523243": {
    "city": "PODILI",
    "state": "ANDHRA PRADESH"
  },
  "523245": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523246": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523247": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523252": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523253": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523254": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523260": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523261": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523262": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523263": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523264": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523265": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523267": {
    "city": "PODILI",
    "state": "ANDHRA PRADESH"
  },
  "523269": {
    "city": "ADDANKI",
    "state": "ANDHRA PRADESH"
  },
  "523270": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523271": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523272": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523273": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523274": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523277": {
    "city": "KANDUKURU",
    "state": "ANDHRA PRADESH"
  },
  "523279": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523280": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523281": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523285": {
    "city": "PAMUR",
    "state": "ANDHRA PRADESH"
  },
  "523286": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523290": {
    "city": "SINGARAYAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "523291": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523292": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523297": {
    "city": "KONDAPI",
    "state": "ANDHRA PRADESH"
  },
  "523301": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523302": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523303": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523304": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523305": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523315": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523316": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523320": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523326": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523327": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523328": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523329": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523330": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523331": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523332": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523333": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523334": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523335": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523336": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523338": {
    "city": "PODILI",
    "state": "ANDHRA PRADESH"
  },
  "523345": {
    "city": "GIDDALUR",
    "state": "ANDHRA PRADESH"
  },
  "523346": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523356": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523357": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523367": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523368": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523369": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523370": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523371": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523372": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "523373": {
    "city": "Prakasam",
    "state": "Andhra Pradesh"
  },
  "524001": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524002": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524003": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524004": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524005": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524101": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524102": {
    "city": "GUDUR",
    "state": "ANDHRA PRADESH"
  },
  "524119": {
    "city": "KALIGIRI",
    "state": "ANDHRA PRADESH"
  },
  "524121": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524123": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524124": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524126": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524127": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524129": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524131": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524132": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524134": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524137": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524142": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524152": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524201": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524202": {
    "city": "KAVALI",
    "state": "ANDHRA PRADESH"
  },
  "524203": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524221": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524222": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524223": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524224": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524225": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524226": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524227": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524228": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524230": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524234": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524236": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524239": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524240": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524301": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524302": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524303": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524304": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524305": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524306": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524307": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524308": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524309": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524310": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524311": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524312": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524313": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524314": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524315": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524316": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524317": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524318": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524319": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524320": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524321": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524322": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524323": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524324": {
    "city": "UDAYAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "524329": {
    "city": "ALLUR",
    "state": "ANDHRA PRADESH"
  },
  "524333": {
    "city": "BUCHI",
    "state": "ANDHRA PRADESH"
  },
  "524341": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524342": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524343": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524344": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524345": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524346": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524347": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524366": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524401": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524402": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524403": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524404": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524405": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524406": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524407": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524408": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524409": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524410": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524411": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524412": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524413": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524414": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524415": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524416": {
    "city": "SULLURPET",
    "state": "ANDHRA PRADESH"
  },
  "524421": {
    "city": "Nellore",
    "state": "Andhra Pradesh"
  },
  "524431": {
    "city": "GUDUR",
    "state": "ANDHRA PRADESH"
  },
  "524441": {
    "city": "NAIDUPETA",
    "state": "ANDHRA PRADESH"
  },
  "530001": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530002": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530003": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530004": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530005": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530006": {
    "city": "VIZAG",
    "state": "ANDHRA PRADESH"
  },
  "530007": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530008": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530009": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530010": {
    "city": "VIZAG",
    "state": "ANDHRA PRADESH"
  },
  "530011": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530012": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530013": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530014": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530015": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530016": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530017": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530018": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530019": {
    "city": "VISAKHAPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "530020": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530021": {
    "city": "VIZAG",
    "state": "ANDHRA PRADESH"
  },
  "530022": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530023": {
    "city": "VIZAG",
    "state": "ANDHRA PRADESH"
  },
  "530024": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530025": {
    "city": "VISHAKHAPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "530026": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530027": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530028": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530029": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530030": {
    "city": "KOTHAVALASA",
    "state": "ANDHRA PRADESH"
  },
  "530031": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530032": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530033": {
    "city": "VISAKHAPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "530034": {
    "city": "VISAKHAPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "530035": {
    "city": "VISAKHAPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "530036": {
    "city": "VISAKHAPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "530037": {
    "city": "VIZAG",
    "state": "ANDHRA PRADESH"
  },
  "530038": {
    "city": "BHEEMUNIPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "530039": {
    "city": "BHEEMUNIPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "530040": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530041": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530042": {
    "city": "BHEEMUNIPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "530043": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530044": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530045": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530046": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530047": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530048": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530049": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530051": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530052": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "530053": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531001": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531002": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531011": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531019": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531020": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531021": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531022": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531023": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531024": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531025": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531026": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531027": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531028": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531029": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531030": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531031": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531032": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531033": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531034": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531035": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531036": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531040": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531055": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531060": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531061": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531075": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531077": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531081": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531082": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531083": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531084": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531085": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531087": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531091": {
    "city": "PARVATHIPURAM",
    "state": "ANDHRA PRADESH"
  },
  "531105": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531110": {
    "city": "GUDEM KOTHA VEEDHI",
    "state": "ANDHRA PRADESH"
  },
  "531111": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531113": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531114": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531115": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531116": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531117": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531118": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531126": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531127": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531133": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531135": {
    "city": "CHODAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "531145": {
    "city": "ANANTAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "531148": {
    "city": "BHEEMUNIPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "531149": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531151": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531152": {
    "city": "ANANTAGIRI",
    "state": "ANDHRA PRADESH"
  },
  "531160": {
    "city": "BHEEMUNIPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "531161": {
    "city": "BHEEMUNIPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "531162": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531163": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531172": {
    "city": "PENDURTHI",
    "state": "ANDHRA PRADESH"
  },
  "531173": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531183": {
    "city": "KOMARADA",
    "state": "ANDHRA PRADESH"
  },
  "531201": {
    "city": "KOMARADA",
    "state": "ANDHRA PRADESH"
  },
  "531202": {
    "city": "THERLAM",
    "state": "ANDHRA PRADESH"
  },
  "531203": {
    "city": "KOMARADA",
    "state": "ANDHRA PRADESH"
  },
  "531204": {
    "city": "BHOGAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "531211": {
    "city": "SRUNGAVARAPUKOTA",
    "state": "ANDHRA PRADESH"
  },
  "531213": {
    "city": "SRUNGAVARAPUKOTA",
    "state": "ANDHRA PRADESH"
  },
  "531214": {
    "city": "SRUNGAVARAPUKOTA",
    "state": "ANDHRA PRADESH"
  },
  "531215": {
    "city": "SRUNGAVARAPUKOTA",
    "state": "ANDHRA PRADESH"
  },
  "531216": {
    "city": "BHOGAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "531217": {
    "city": "BHOGAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "531218": {
    "city": "BHOGAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "531219": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "531220": {
    "city": "CHIPURUPALLE",
    "state": "ANDHRA PRADESH"
  },
  "531221": {
    "city": "GAJAPATHINAGARAM",
    "state": "ANDHRA PRADESH"
  },
  "531230": {
    "city": "KANDUKURU",
    "state": "ANDHRA PRADESH"
  },
  "531240": {
    "city": "KOTHAVALASA",
    "state": "ANDHRA PRADESH"
  },
  "531241": {
    "city": "BHOGAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "531242": {
    "city": "GAJAPATHINAGARAM",
    "state": "ANDHRA PRADESH"
  },
  "531250": {
    "city": "SRUNGAVARAPUKOTA",
    "state": "ANDHRA PRADESH"
  },
  "531260": {
    "city": "CHIPURUPALLE",
    "state": "ANDHRA PRADESH"
  },
  "531270": {
    "city": "GAJAPATHINAGARAM",
    "state": "ANDHRA PRADESH"
  },
  "531273": {
    "city": "GAJAPATHINAGARAM",
    "state": "ANDHRA PRADESH"
  },
  "531280": {
    "city": "BHOGAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "531281": {
    "city": "CHODAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "531303": {
    "city": "SRUNGAVARAPUKOTA",
    "state": "ANDHRA PRADESH"
  },
  "532001": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532005": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532015": {
    "city": "NARASANNAPETA",
    "state": "ANDHRA PRADESH"
  },
  "532100": {
    "city": "PALAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "532101": {
    "city": "AMADALAVALASA",
    "state": "ANDHRA PRADESH"
  },
  "532102": {
    "city": "RAJAM",
    "state": "ANDHRA PRADESH"
  },
  "532122": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532123": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532124": {
    "city": "RAJAM",
    "state": "ANDHRA PRADESH"
  },
  "532125": {
    "city": "RAJAM",
    "state": "ANDHRA PRADESH"
  },
  "532126": {
    "city": "RAJAM",
    "state": "ANDHRA PRADESH"
  },
  "532127": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532128": {
    "city": "THERLAM",
    "state": "ANDHRA PRADESH"
  },
  "532137": {
    "city": "BOBBILI",
    "state": "ANDHRA PRADESH"
  },
  "532148": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532168": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532185": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532186": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532189": {
    "city": "AMADALAVALASA",
    "state": "ANDHRA PRADESH"
  },
  "532190": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532195": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532201": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532202": {
    "city": "TEKKALI",
    "state": "ANDHRA PRADESH"
  },
  "532203": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532206": {
    "city": "NARASANNAPETA",
    "state": "ANDHRA PRADESH"
  },
  "532208": {
    "city": "TEKKALI",
    "state": "ANDHRA PRADESH"
  },
  "532209": {
    "city": "TEKKALI",
    "state": "ANDHRA PRADESH"
  },
  "532211": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532212": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532213": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532214": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532215": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532216": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532217": {
    "city": "BHOGAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "532218": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532219": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532220": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532221": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532222": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532242": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532243": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532244": {
    "city": "SOMPETA",
    "state": "ANDHRA PRADESH"
  },
  "532248": {
    "city": "SOMPETA",
    "state": "ANDHRA PRADESH"
  },
  "532263": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532264": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532265": {
    "city": "RAJAM",
    "state": "ANDHRA PRADESH"
  },
  "532270": {
    "city": "KONDAPI",
    "state": "ANDHRA PRADESH"
  },
  "532284": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532290": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532291": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532292": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532293": {
    "city": "ICHAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "532294": {
    "city": "ICHAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "532312": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532322": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532323": {
    "city": "ICHAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "532401": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532402": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532403": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532404": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532405": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532406": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532407": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "532408": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532409": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532410": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532417": {
    "city": "NARASANNAPETA",
    "state": "ANDHRA PRADESH"
  },
  "532421": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532425": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532426": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532427": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532428": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532429": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532430": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532432": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532440": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532443": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532445": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532455": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532456": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532457": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532458": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532459": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532460": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532461": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532462": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532463": {
    "city": "PALAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "532464": {
    "city": "PALAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "532470": {
    "city": "RAJAM",
    "state": "ANDHRA PRADESH"
  },
  "532474": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532484": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "532485": {
    "city": "AMADALAVALASA",
    "state": "ANDHRA PRADESH"
  },
  "532501": {
    "city": "PARVATHIPURAM",
    "state": "ANDHRA PRADESH"
  },
  "532502": {
    "city": "PARVATHIPURAM",
    "state": "ANDHRA PRADESH"
  },
  "532521": {
    "city": "KOMARADA",
    "state": "ANDHRA PRADESH"
  },
  "532522": {
    "city": "PARVATHIPURAM",
    "state": "ANDHRA PRADESH"
  },
  "532523": {
    "city": "PARVATHIPURAM",
    "state": "ANDHRA PRADESH"
  },
  "532524": {
    "city": "PARVATHIPURAM",
    "state": "ANDHRA PRADESH"
  },
  "532525": {
    "city": "GAJAPATHINAGARAM",
    "state": "ANDHRA PRADESH"
  },
  "532526": {
    "city": "PARVATHIPURAM",
    "state": "ANDHRA PRADESH"
  },
  "532527": {
    "city": "PARVATHIPURAM",
    "state": "ANDHRA PRADESH"
  },
  "532534": {
    "city": "PARVATHIPURAM",
    "state": "ANDHRA PRADESH"
  },
  "532546": {
    "city": "BOBBILI",
    "state": "ANDHRA PRADESH"
  },
  "532547": {
    "city": "SALUR",
    "state": "ANDHRA PRADESH"
  },
  "532550": {
    "city": "PALAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "532551": {
    "city": "AMADALAVALASA",
    "state": "ANDHRA PRADESH"
  },
  "532552": {
    "city": "PALAKONDA",
    "state": "ANDHRA PRADESH"
  },
  "532557": {
    "city": "THERLAM",
    "state": "ANDHRA PRADESH"
  },
  "532558": {
    "city": "BOBBILI",
    "state": "ANDHRA PRADESH"
  },
  "532568": {
    "city": "BOBBILI",
    "state": "ANDHRA PRADESH"
  },
  "532573": {
    "city": "BOBBILI",
    "state": "ANDHRA PRADESH"
  },
  "532578": {
    "city": "SALUR",
    "state": "ANDHRA PRADESH"
  },
  "532579": {
    "city": "SALUR",
    "state": "ANDHRA PRADESH"
  },
  "532580": {
    "city": "GAJAPATHINAGARAM",
    "state": "ANDHRA PRADESH"
  },
  "532581": {
    "city": "BOBBILI",
    "state": "ANDHRA PRADESH"
  },
  "532591": {
    "city": "SALUR",
    "state": "ANDHRA PRADESH"
  },
  "532592": {
    "city": "SALUR",
    "state": "ANDHRA PRADESH"
  },
  "532593": {
    "city": "SALUR",
    "state": "ANDHRA PRADESH"
  },
  "532599": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "532612": {
    "city": "KOTHAVALASA",
    "state": "ANDHRA PRADESH"
  },
  "532617": {
    "city": "REPALLE",
    "state": "ANDHRA PRADESH"
  },
  "532663": {
    "city": "BOBBILI",
    "state": "ANDHRA PRADESH"
  },
  "533001": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533002": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533003": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533004": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533005": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533006": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533007": {
    "city": "KAKINADA",
    "state": "ANDHRA PRADESH"
  },
  "533008": {
    "city": "KAKINADA",
    "state": "ANDHRA PRADESH"
  },
  "533014": {
    "city": "KAKINADA",
    "state": "ANDHRA PRADESH"
  },
  "533016": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533101": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533102": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533103": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533104": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533105": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533106": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533107": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533108": {
    "city": "RAJAHMUNDRY",
    "state": "ANDHRA PRADESH"
  },
  "533109": {
    "city": "RAJAHMUNDRY",
    "state": "ANDHRA PRADESH"
  },
  "533124": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533125": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533126": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533133": {
    "city": "KADIAM",
    "state": "ANDHRA PRADESH"
  },
  "533201": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533202": {
    "city": "AMALAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "533203": {
    "city": "ALLAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "533210": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533211": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533212": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533213": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533214": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533215": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533216": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533217": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533218": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533219": {
    "city": "KADIAM",
    "state": "ANDHRA PRADESH"
  },
  "533220": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533221": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533222": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533223": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533224": {
    "city": "KOTHAPETA",
    "state": "ANDHRA PRADESH"
  },
  "533225": {
    "city": "MUMMIDIVARAM",
    "state": "ANDHRA PRADESH"
  },
  "533226": {
    "city": "NARASARAOPET",
    "state": "ANDHRA PRADESH"
  },
  "533227": {
    "city": "MUMMIDIVARAM",
    "state": "ANDHRA PRADESH"
  },
  "533228": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533229": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533230": {
    "city": "KOTHAPETA",
    "state": "ANDHRA PRADESH"
  },
  "533232": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533233": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533234": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533235": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533236": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533237": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533238": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533239": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533240": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533241": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533242": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533243": {
    "city": "KOTHAPETA",
    "state": "ANDHRA PRADESH"
  },
  "533244": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533247": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533248": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533249": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533250": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533251": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533252": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533253": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533254": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533255": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533256": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533258": {
    "city": "RAZOLE",
    "state": "ANDHRA PRADESH"
  },
  "533260": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533261": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533262": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533263": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533264": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533271": {
    "city": "RAMACHANDRAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "533274": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533275": {
    "city": "KADIAM",
    "state": "ANDHRA PRADESH"
  },
  "533277": {
    "city": "KADIAM",
    "state": "ANDHRA PRADESH"
  },
  "533284": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533285": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533286": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533287": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533288": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533289": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533290": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533291": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533292": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533293": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533294": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533295": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533296": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533297": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533305": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533306": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533307": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533308": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533309": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533333": {
    "city": "KADIAM",
    "state": "ANDHRA PRADESH"
  },
  "533339": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533340": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533341": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533342": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533343": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533344": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533345": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533346": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533401": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533406": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533407": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533408": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533409": {
    "city": "TANUKU",
    "state": "ANDHRA PRADESH"
  },
  "533410": {
    "city": "NARSIPATNAM",
    "state": "ANDHRA PRADESH"
  },
  "533428": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533429": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533430": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533431": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533432": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533433": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533434": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533435": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533436": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533437": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533439": {
    "city": "JAGGAMPETA",
    "state": "ANDHRA PRADESH"
  },
  "533440": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533444": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533445": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533446": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533447": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533448": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533449": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533450": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533460": {
    "city": "PEDDAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "533461": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533462": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533463": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533464": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533468": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533483": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "533502": {
    "city": "MUMMIDIVARAM",
    "state": "ANDHRA PRADESH"
  },
  "533503": {
    "city": "AVANIGADDA",
    "state": "ANDHRA PRADESH"
  },
  "533514": {
    "city": "MUMMIDIVARAM",
    "state": "ANDHRA PRADESH"
  },
  "533541": {
    "city": "CUMBUM - AP",
    "state": "ANDHRA PRADESH"
  },
  "533551": {
    "city": "VINUKONDA",
    "state": "ANDHRA PRADESH"
  },
  "533554": {
    "city": "MUMMIDIVARAM",
    "state": "ANDHRA PRADESH"
  },
  "533557": {
    "city": "BOBBILI",
    "state": "ANDHRA PRADESH"
  },
  "533566": {
    "city": "RAZOLE",
    "state": "ANDHRA PRADESH"
  },
  "533577": {
    "city": "East Godavari",
    "state": "Andhra Pradesh"
  },
  "534000": {
    "city": "ELURU",
    "state": "ANDHRA PRADESH"
  },
  "534001": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534002": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534003": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534004": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534005": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534006": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534007": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534015": {
    "city": "ELURU",
    "state": "ANDHRA PRADESH"
  },
  "534101": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534102": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534107": {
    "city": "BHIMADOLE",
    "state": "ANDHRA PRADESH"
  },
  "534108": {
    "city": "TADEPALLIGUDEM",
    "state": "ANDHRA PRADESH"
  },
  "534111": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534112": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534116": {
    "city": "TADEPALLIGUDEM",
    "state": "ANDHRA PRADESH"
  },
  "534122": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534123": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534124": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534126": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534127": {
    "city": "ATCHANTA",
    "state": "ANDHRA PRADESH"
  },
  "534129": {
    "city": "PALAKOLLU",
    "state": "ANDHRA PRADESH"
  },
  "534134": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534136": {
    "city": "ATCHANTA",
    "state": "ANDHRA PRADESH"
  },
  "534137": {
    "city": "TADEPALLIGUDEM",
    "state": "ANDHRA PRADESH"
  },
  "534145": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534146": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534152": {
    "city": "BHIMADOLE",
    "state": "ANDHRA PRADESH"
  },
  "534154": {
    "city": "BHIMADOLE",
    "state": "ANDHRA PRADESH"
  },
  "534156": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534160": {
    "city": "TADEPALLIGUDEM",
    "state": "ANDHRA PRADESH"
  },
  "534165": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534166": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534176": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534186": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534195": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534196": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534197": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534198": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534199": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534201": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534202": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534203": {
    "city": "BHIMAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "534204": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534206": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534207": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534208": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534209": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534210": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534211": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534215": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534216": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534217": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534218": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534222": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534225": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534227": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534230": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534235": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534236": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534237": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534238": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534239": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534240": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534243": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534244": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534245": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534247": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534250": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534251": {
    "city": "PALAKOLLU",
    "state": "ANDHRA PRADESH"
  },
  "534260": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534261": {
    "city": "PALAKOLLU",
    "state": "ANDHRA PRADESH"
  },
  "534265": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534266": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534267": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534268": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534269": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534271": {
    "city": "NARSAPUR - AP",
    "state": "ANDHRA PRADESH"
  },
  "534272": {
    "city": "KOVVUR",
    "state": "ANDHRA PRADESH"
  },
  "534275": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534280": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534281": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534291": {
    "city": "NARSAPUR - AP",
    "state": "ANDHRA PRADESH"
  },
  "534293": {
    "city": "BHIMAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "534301": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534302": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534303": {
    "city": "TADEPALLIGUDEM",
    "state": "ANDHRA PRADESH"
  },
  "534305": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534311": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534312": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534313": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534314": {
    "city": "GOPALAPURAM",
    "state": "ANDHRA PRADESH"
  },
  "534315": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534316": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534318": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534320": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534324": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534326": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534327": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534328": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534329": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534330": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534331": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534338": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534339": {
    "city": "TANUKU",
    "state": "ANDHRA PRADESH"
  },
  "534340": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534341": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534342": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534343": {
    "city": "KOVVUR",
    "state": "ANDHRA PRADESH"
  },
  "534350": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534351": {
    "city": "KOVVUR",
    "state": "ANDHRA PRADESH"
  },
  "534352": {
    "city": "KOVVUR",
    "state": "ANDHRA PRADESH"
  },
  "534362": {
    "city": "BHIMAVARAM",
    "state": "ANDHRA PRADESH"
  },
  "534390": {
    "city": "BHIMADOLE",
    "state": "ANDHRA PRADESH"
  },
  "534392": {
    "city": "KOVVUR",
    "state": "ANDHRA PRADESH"
  },
  "534401": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534406": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534407": {
    "city": "TADEPALLIGUDEM",
    "state": "ANDHRA PRADESH"
  },
  "534411": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534416": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534425": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534426": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534427": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534429": {
    "city": "BHIMADOLE",
    "state": "ANDHRA PRADESH"
  },
  "534432": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534435": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534437": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534442": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534444": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534447": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534448": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534449": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534450": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534451": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534452": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534455": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534456": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534459": {
    "city": "CHINTALAPUDI",
    "state": "ANDHRA PRADESH"
  },
  "534460": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534461": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534462": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534467": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534475": {
    "city": "West Godavari",
    "state": "Andhra Pradesh"
  },
  "534486": {
    "city": "LINGAPALEM",
    "state": "ANDHRA PRADESH"
  },
  "535001": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535002": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535003": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535004": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535005": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "535006": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535101": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535102": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535124": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535125": {
    "city": "Srikakulam",
    "state": "Andhra Pradesh"
  },
  "535126": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535128": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535145": {
    "city": "Visakhapatnam",
    "state": "Andhra Pradesh"
  },
  "535148": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535160": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535161": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535183": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535202": {
    "city": "KOVVUR",
    "state": "ANDHRA PRADESH"
  },
  "535204": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535213": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535214": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535215": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535216": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535217": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535218": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535220": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535221": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535231": {
    "city": "PARVATHIPURAM",
    "state": "ANDHRA PRADESH"
  },
  "535240": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535250": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535260": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535270": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535273": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535280": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535281": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535463": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535501": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535502": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535521": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535522": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535523": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535524": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535525": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535526": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535527": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535532": {
    "city": "BOBBILI",
    "state": "ANDHRA PRADESH"
  },
  "535534": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535546": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535547": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535557": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535558": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535559": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535568": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535573": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535578": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535579": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535580": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535581": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535591": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535592": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535593": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "535594": {
    "city": "Vizianagaram",
    "state": "Andhra Pradesh"
  },
  "555555": {
    "city": "KVY KARVY",
    "state": "TELANGANA"
  },
  "560000": {
    "city": "BLR GROUND HUB",
    "state": "KARNATAKA"
  },
  "560001": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560002": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560003": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560004": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560005": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560006": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560007": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560008": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560009": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560010": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560011": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560012": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560013": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560014": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "560015": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560016": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560017": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560018": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560019": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "560020": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560021": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560022": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560023": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560024": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560025": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560026": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560027": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560028": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "560029": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560030": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560031": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "560032": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560033": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560034": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560035": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560036": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560037": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560038": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560039": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "560040": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560041": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560042": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560043": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560044": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "560045": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560046": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560047": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560048": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560049": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560050": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560051": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560052": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "560053": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560054": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560055": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560056": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560057": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560058": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560059": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560060": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "560061": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560062": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560063": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560064": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560065": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560066": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560067": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "560068": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "560069": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "560070": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560071": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560072": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560073": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560074": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560075": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560076": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560077": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560078": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560079": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560080": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560081": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560082": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "560083": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "560084": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560085": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560086": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560087": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560088": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "560089": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "560090": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "560091": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "560092": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560093": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560094": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560095": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560096": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560097": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560098": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560099": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "560100": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560101": {
    "city": "Bengaluru",
    "state": "KARNATAKA"
  },
  "560102": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560103": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560104": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560105": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560106": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "560107": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "560108": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560109": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560110": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560111": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560112": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560114": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "560242": {
    "city": "BENGALURU",
    "state": "KARNATAKA"
  },
  "560300": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "561000": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "561101": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "561111": {
    "city": "ST MARKS",
    "state": "KARNATAKA"
  },
  "561201": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "561202": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "561203": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "561204": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "561205": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "561206": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "561207": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "561208": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "561209": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "561210": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "561211": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "561212": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "561213": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "561214": {
    "city": "GAURIBIDANUR",
    "state": "KARNATAKA"
  },
  "561215": {
    "city": "GAURIBIDANUR",
    "state": "KARNATAKA"
  },
  "561217": {
    "city": "MULABAGILU",
    "state": "KARNATAKA"
  },
  "561218": {
    "city": "MULABAGILU",
    "state": "KARNATAKA"
  },
  "561219": {
    "city": "MULABAGILU",
    "state": "KARNATAKA"
  },
  "561220": {
    "city": "MULABAGILU",
    "state": "KARNATAKA"
  },
  "561221": {
    "city": "MULABAGILU",
    "state": "KARNATAKA"
  },
  "561225": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "561226": {
    "city": "GAURIBIDANUR",
    "state": "KARNATAKA"
  },
  "561227": {
    "city": "GAURIBIDANUR",
    "state": "KARNATAKA"
  },
  "561228": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "561229": {
    "city": "GAURIBIDANUR",
    "state": "KARNATAKA"
  },
  "562101": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "562102": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "562103": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "562104": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "562105": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "562106": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "562107": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "562108": {
    "city": "Ramanagar",
    "state": "Karnataka"
  },
  "562109": {
    "city": "Ramanagar",
    "state": "Karnataka"
  },
  "562110": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562111": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562112": {
    "city": "Ramanagar",
    "state": "Karnataka"
  },
  "562114": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562115": {
    "city": "HOSAKOTE",
    "state": "KARNATAKA"
  },
  "562116": {
    "city": "KANAKPURA",
    "state": "KARNATAKA"
  },
  "562117": {
    "city": "Ramanagar",
    "state": "Karnataka"
  },
  "562118": {
    "city": "KANAKPURA",
    "state": "KARNATAKA"
  },
  "562119": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562120": {
    "city": "Ramanagar",
    "state": "Karnataka"
  },
  "562121": {
    "city": "Ramanagar",
    "state": "Karnataka"
  },
  "562122": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562123": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562124": {
    "city": "BENGALURU",
    "state": "KARNATAKA"
  },
  "562125": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "562126": {
    "city": "Ramanagar",
    "state": "Karnataka"
  },
  "562127": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562128": {
    "city": "Ramanagar",
    "state": "Karnataka"
  },
  "562129": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562130": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562131": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562132": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562134": {
    "city": "BENGALURU",
    "state": "KARNATAKA"
  },
  "562135": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562136": {
    "city": "BENGALURU",
    "state": "KARNATAKA"
  },
  "562137": {
    "city": "RAMNAGARA",
    "state": "KARNATAKA"
  },
  "562138": {
    "city": "Ramanagar",
    "state": "Karnataka"
  },
  "562139": {
    "city": "RAMNAGARA",
    "state": "KARNATAKA"
  },
  "562140": {
    "city": "RAMNAGARA",
    "state": "KARNATAKA"
  },
  "562145": {
    "city": "HOSUR",
    "state": "KARNATAKA"
  },
  "562147": {
    "city": "BENGALURU",
    "state": "KARNATAKA"
  },
  "562148": {
    "city": "BENGALURU",
    "state": "KARNATAKA"
  },
  "562149": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "562150": {
    "city": "BENGALURU",
    "state": "KARNATAKA"
  },
  "562151": {
    "city": "BENGALURU",
    "state": "KARNATAKA"
  },
  "562152": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "562156": {
    "city": "BENGALURU",
    "state": "KARNATAKA"
  },
  "562157": {
    "city": "Bengaluru",
    "state": "Karnataka"
  },
  "562158": {
    "city": "BENGALURU",
    "state": "KARNATAKA"
  },
  "562159": {
    "city": "Ramanagar",
    "state": "Karnataka"
  },
  "562160": {
    "city": "Ramanagar",
    "state": "Karnataka"
  },
  "562161": {
    "city": "Ramanagar",
    "state": "Karnataka"
  },
  "562162": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562163": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562164": {
    "city": "Bangalore Rural",
    "state": "Karnataka"
  },
  "562201": {
    "city": "MAGADI",
    "state": "KARNATAKA"
  },
  "562300": {
    "city": "BENGALURU",
    "state": "KARNATAKA"
  },
  "563101": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563102": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563103": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563113": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563114": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563115": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563116": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563117": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563118": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563119": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563120": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563121": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "563122": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563123": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "563124": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "563125": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "563126": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563127": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563128": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563129": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563130": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563131": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563132": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563133": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563134": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563135": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563136": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563137": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563138": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "563139": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563140": {
    "city": "MALUR",
    "state": "KARNATAKA"
  },
  "563141": {
    "city": "MALUR",
    "state": "KARNATAKA"
  },
  "563144": {
    "city": "CHINTAMANI",
    "state": "KARNATAKA"
  },
  "563145": {
    "city": "CHINTAMANI",
    "state": "KARNATAKA"
  },
  "563146": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "563147": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563148": {
    "city": "BANGARAPET",
    "state": "KARNATAKA"
  },
  "563149": {
    "city": "KOLAR",
    "state": "KARNATAKA"
  },
  "563150": {
    "city": "KOLAR",
    "state": "KARNATAKA"
  },
  "563151": {
    "city": "KOLAR",
    "state": "KARNATAKA"
  },
  "563152": {
    "city": "KOLAR",
    "state": "KARNATAKA"
  },
  "563153": {
    "city": "KOLAR",
    "state": "KARNATAKA"
  },
  "563156": {
    "city": "KOLAR",
    "state": "KARNATAKA"
  },
  "563157": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563158": {
    "city": "CHINTAMANI",
    "state": "KARNATAKA"
  },
  "563159": {
    "city": "Chikkaballapur",
    "state": "Karnataka"
  },
  "563160": {
    "city": "MALUR",
    "state": "KARNATAKA"
  },
  "563161": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "563162": {
    "city": "Kolar",
    "state": "Karnataka"
  },
  "566105": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "566666": {
    "city": "FLIPKART",
    "state": "KARNATAKA"
  },
  "566667": {
    "city": "ETAIL PROCESSING UNIT",
    "state": "KARNATAKA"
  },
  "566668": {
    "city": "MYNTRA",
    "state": "KARNATAKA"
  },
  "569999": {
    "city": "BLR REGIONAL OFFICE",
    "state": "KARNATAKA"
  },
  "570000": {
    "city": "MYSORE",
    "state": "KARNATAKA"
  },
  "570001": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570002": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570003": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570004": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570005": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570006": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570007": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570008": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570009": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570010": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570011": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570012": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570013": {
    "city": "MYSORE",
    "state": "KARNATAKA"
  },
  "570014": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570015": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570016": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570017": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570018": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570019": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570020": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570021": {
    "city": "MYSORE",
    "state": "KARNATAKA"
  },
  "570022": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570023": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570024": {
    "city": "MYSORE",
    "state": "KARNATAKA"
  },
  "570025": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570026": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570027": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570028": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570029": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570030": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570031": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570032": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "570301": {
    "city": "NANJANGUD",
    "state": "KARNATAKA"
  },
  "571101": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571102": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571103": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571104": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571105": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571106": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571107": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571108": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571109": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571110": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571111": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571114": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571115": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571116": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571117": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571118": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571119": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571120": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571121": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571122": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571123": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571124": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571125": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571126": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571127": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571128": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571129": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571130": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571131": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571132": {
    "city": "KUSHALNAGAR",
    "state": "KARNATAKA"
  },
  "571133": {
    "city": "KRISHNARAJANAGARA",
    "state": "KARNATAKA"
  },
  "571134": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571135": {
    "city": "KRISHNARAJANAGARA",
    "state": "KARNATAKA"
  },
  "571136": {
    "city": "KRISHNARAJANAGARA",
    "state": "KARNATAKA"
  },
  "571137": {
    "city": "MADDUR, MANDYA",
    "state": "KARNATAKA"
  },
  "571138": {
    "city": "RAMNAGARA",
    "state": "KARNATAKA"
  },
  "571139": {
    "city": "KRISHNARAJANAGARA",
    "state": "KARNATAKA"
  },
  "571140": {
    "city": "KRISHNARAJANAGARA",
    "state": "KARNATAKA"
  },
  "571141": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571142": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571143": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571144": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571145": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571146": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571147": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571148": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571153": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571154": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571155": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571156": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571157": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571158": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571159": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571160": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571161": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571162": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571163": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571164": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571165": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571166": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571167": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571168": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571169": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571170": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571171": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571172": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571173": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571174": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571175": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571176": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571177": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571178": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571180": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571182": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571183": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571184": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571185": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571186": {
    "city": "MYSORE",
    "state": "KARNATAKA"
  },
  "571187": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571188": {
    "city": "KRISHNARAJANAGARA",
    "state": "KARNATAKA"
  },
  "571189": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571201": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571211": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571212": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571213": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571214": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571215": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571216": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571217": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571218": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571219": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571220": {
    "city": "VIRAJPET",
    "state": "KARNATAKA"
  },
  "571221": {
    "city": "VIRAJPET",
    "state": "KARNATAKA"
  },
  "571231": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571232": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571233": {
    "city": "KUSHALNAGAR",
    "state": "KARNATAKA"
  },
  "571234": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571235": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571236": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571237": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571238": {
    "city": "MADIKERI",
    "state": "KARNATAKA"
  },
  "571239": {
    "city": "MADIKERI",
    "state": "KARNATAKA"
  },
  "571245": {
    "city": "MADIKERI",
    "state": "KARNATAKA"
  },
  "571246": {
    "city": "MADIKERI",
    "state": "KARNATAKA"
  },
  "571247": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571248": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571249": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571250": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571251": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571252": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571253": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571254": {
    "city": "Kodagu",
    "state": "Karnataka"
  },
  "571255": {
    "city": "VIRAJPET",
    "state": "KARNATAKA"
  },
  "571256": {
    "city": "VIRAJPET",
    "state": "KARNATAKA"
  },
  "571262": {
    "city": "MADIKERI",
    "state": "KARNATAKA"
  },
  "571263": {
    "city": "MADIKERI",
    "state": "KARNATAKA"
  },
  "571264": {
    "city": "MADIKERI",
    "state": "KARNATAKA"
  },
  "571265": {
    "city": "MADIKERI",
    "state": "KARNATAKA"
  },
  "571266": {
    "city": "MADIKERI",
    "state": "KARNATAKA"
  },
  "571301": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571302": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571304": {
    "city": "NANJANGUD",
    "state": "KARNATAKA"
  },
  "571311": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571312": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571313": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571314": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571315": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571316": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571317": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571318": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571319": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571320": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571321": {
    "city": "MYSORE",
    "state": "KARNATAKA"
  },
  "571322": {
    "city": "MYSORE",
    "state": "KARNATAKA"
  },
  "571323": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571324": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571325": {
    "city": "NANJANGUD",
    "state": "KARNATAKA"
  },
  "571326": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571327": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571328": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571329": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571330": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571331": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571332": {
    "city": "H.D.KOTE",
    "state": "KARNATAKA"
  },
  "571333": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571334": {
    "city": "MYSORE",
    "state": "KARNATAKA"
  },
  "571335": {
    "city": "MYSORE",
    "state": "KARNATAKA"
  },
  "571336": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571337": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571339": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571340": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571341": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571342": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571401": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571402": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571403": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571404": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571405": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571406": {
    "city": "MANDYA",
    "state": "KARNATAKA"
  },
  "571415": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571416": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571417": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571418": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571419": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571421": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571422": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571423": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571424": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571425": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571426": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571427": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571428": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571429": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571430": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571431": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571432": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571433": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571434": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571435": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571436": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571437": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571438": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571439": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571440": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571441": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571442": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571443": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571444": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571445": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571446": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571448": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571449": {
    "city": "MADDUR, MANDYA",
    "state": "KARNATAKA"
  },
  "571450": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571451": {
    "city": "MADDUR, MANDYA",
    "state": "KARNATAKA"
  },
  "571452": {
    "city": "MADDUR, MANDYA",
    "state": "KARNATAKA"
  },
  "571453": {
    "city": "SRIRANGAPATNA",
    "state": "KARNATAKA"
  },
  "571454": {
    "city": "SRIRANGAPATNA",
    "state": "KARNATAKA"
  },
  "571455": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571456": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571457": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571458": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571459": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571461": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571462": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571463": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571464": {
    "city": "TIRUMAKUDAL NARSIPUR",
    "state": "KARNATAKA"
  },
  "571465": {
    "city": "RAMNAGARA",
    "state": "KARNATAKA"
  },
  "571466": {
    "city": "RAMNAGARA",
    "state": "KARNATAKA"
  },
  "571467": {
    "city": "RAMNAGARA",
    "state": "KARNATAKA"
  },
  "571468": {
    "city": "RAMNAGARA",
    "state": "KARNATAKA"
  },
  "571469": {
    "city": "RAMNAGARA",
    "state": "KARNATAKA"
  },
  "571473": {
    "city": "MADDUR, MANDYA",
    "state": "KARNATAKA"
  },
  "571474": {
    "city": "MADDUR, MANDYA",
    "state": "KARNATAKA"
  },
  "571475": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571476": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571477": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571478": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571479": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571480": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571481": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571482": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571483": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571484": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571485": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571487": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571488": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571489": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571490": {
    "city": "Chamrajnagar",
    "state": "Karnataka"
  },
  "571491": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571492": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571493": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "571494": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571495": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571496": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571497": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571498": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571499": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571500": {
    "city": "CHAMARAJANAGAR",
    "state": "KARNATAKA"
  },
  "571501": {
    "city": "RAMNAGARA",
    "state": "KARNATAKA"
  },
  "571502": {
    "city": "RAMNAGARA",
    "state": "KARNATAKA"
  },
  "571511": {
    "city": "CHAMRAJNAGAR",
    "state": "KARNATAKA"
  },
  "571512": {
    "city": "RAMNAGARA",
    "state": "KARNATAKA"
  },
  "571601": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571602": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571603": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571604": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571605": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571606": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571607": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571608": {
    "city": "KRISHNARAJANAGARA",
    "state": "KARNATAKA"
  },
  "571609": {
    "city": "KRISHNARAJANAGARA",
    "state": "KARNATAKA"
  },
  "571610": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571611": {
    "city": "KRISHNARAJANAGARA",
    "state": "KARNATAKA"
  },
  "571612": {
    "city": "KRISHNARAJANAGARA",
    "state": "KARNATAKA"
  },
  "571613": {
    "city": "KRISHNARAJANAGARA",
    "state": "KARNATAKA"
  },
  "571614": {
    "city": "KUSHALNAGAR",
    "state": "KARNATAKA"
  },
  "571615": {
    "city": "KRISHNARAJANAGARA",
    "state": "KARNATAKA"
  },
  "571616": {
    "city": "KRISHNARAJANAGARA",
    "state": "KARNATAKA"
  },
  "571617": {
    "city": "Mysuru",
    "state": "Karnataka"
  },
  "571801": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571802": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571803": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571804": {
    "city": "KOLLEGAL",
    "state": "KARNATAKA"
  },
  "571805": {
    "city": "SRIRANGAPATNA",
    "state": "KARNATAKA"
  },
  "571806": {
    "city": "SRIRANGAPATNA",
    "state": "KARNATAKA"
  },
  "571807": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571808": {
    "city": "SRIRANGAPATNA",
    "state": "KARNATAKA"
  },
  "571809": {
    "city": "NAGAMANGALA",
    "state": "KARNATAKA"
  },
  "571811": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "571812": {
    "city": "Mandya",
    "state": "Karnataka"
  },
  "572101": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572102": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572103": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572104": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572105": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572106": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572107": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572108": {
    "city": "TUMKUR",
    "state": "KARNATAKA"
  },
  "572111": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572112": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572113": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572114": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572115": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572116": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572117": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572118": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572119": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572120": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572121": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572122": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572123": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572124": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572125": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572126": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572127": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572128": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572129": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572130": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572131": {
    "city": "KUNIGAL",
    "state": "KARNATAKA"
  },
  "572132": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572133": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572134": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572135": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572136": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572137": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572138": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572139": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572140": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572141": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572142": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572143": {
    "city": "HIRIYUR",
    "state": "KARNATAKA"
  },
  "572144": {
    "city": "HIRIYUR",
    "state": "KARNATAKA"
  },
  "572159": {
    "city": "HIRIYUR",
    "state": "KARNATAKA"
  },
  "572160": {
    "city": "HIRIYUR",
    "state": "KARNATAKA"
  },
  "572161": {
    "city": "HIRIYUR",
    "state": "KARNATAKA"
  },
  "572162": {
    "city": "HIRIYUR",
    "state": "KARNATAKA"
  },
  "572163": {
    "city": "HIRIYUR",
    "state": "KARNATAKA"
  },
  "572166": {
    "city": "TUMKUR",
    "state": "KARNATAKA"
  },
  "572167": {
    "city": "TUMKUR",
    "state": "KARNATAKA"
  },
  "572168": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572169": {
    "city": "TUMKUR",
    "state": "KARNATAKA"
  },
  "572170": {
    "city": "TUMKUR",
    "state": "KARNATAKA"
  },
  "572173": {
    "city": "MADHUGIRI",
    "state": "KARNATAKA"
  },
  "572174": {
    "city": "MADHUGIRI",
    "state": "KARNATAKA"
  },
  "572175": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572201": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572202": {
    "city": "TIPTUR",
    "state": "KARNATAKA"
  },
  "572207": {
    "city": "HASAN",
    "state": "KARNATAKA"
  },
  "572211": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572212": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572213": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572214": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572215": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572216": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572217": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572218": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572219": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572220": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572221": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572222": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572223": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572224": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572225": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572226": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572227": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572228": {
    "city": "Tumakuru",
    "state": "Karnataka"
  },
  "572229": {
    "city": "TIPTUR",
    "state": "KARNATAKA"
  },
  "572230": {
    "city": "TIPTUR",
    "state": "KARNATAKA"
  },
  "573101": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573102": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573103": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573111": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573112": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573113": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573114": {
    "city": "BELUR",
    "state": "KARNATAKA"
  },
  "573115": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573116": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573117": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573118": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573119": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573120": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573121": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573122": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573123": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573124": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573125": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573126": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573127": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573128": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573129": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573130": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573131": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573132": {
    "city": "KADURU",
    "state": "KARNATAKA"
  },
  "573133": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573134": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573135": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573136": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573137": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573138": {
    "city": "SAKLESHPUR",
    "state": "KARNATAKA"
  },
  "573139": {
    "city": "CHANNARAYAPATNA",
    "state": "KARNATAKA"
  },
  "573140": {
    "city": "CHANNARAYAPATNA",
    "state": "KARNATAKA"
  },
  "573141": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573142": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573143": {
    "city": "ARSIKERE",
    "state": "KARNATAKA"
  },
  "573144": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573145": {
    "city": "SAKLESHPUR",
    "state": "KARNATAKA"
  },
  "573146": {
    "city": "ARKALGUD",
    "state": "KARNATAKA"
  },
  "573147": {
    "city": "ARKALGUD",
    "state": "KARNATAKA"
  },
  "573148": {
    "city": "ARKALGUD",
    "state": "KARNATAKA"
  },
  "573149": {
    "city": "ARKALGUD",
    "state": "KARNATAKA"
  },
  "573150": {
    "city": "ARKALGUD",
    "state": "KARNATAKA"
  },
  "573151": {
    "city": "CHANNARAYAPATNA",
    "state": "KARNATAKA"
  },
  "573152": {
    "city": "CHANNARAYAPATNA",
    "state": "KARNATAKA"
  },
  "573153": {
    "city": "CHANNARAYAPATNA",
    "state": "KARNATAKA"
  },
  "573157": {
    "city": "CHANNARAYAPATNA",
    "state": "KARNATAKA"
  },
  "573158": {
    "city": "CHANNARAYAPATNA",
    "state": "KARNATAKA"
  },
  "573159": {
    "city": "CHANNARAYAPATNA",
    "state": "KARNATAKA"
  },
  "573160": {
    "city": "ARSIKERE",
    "state": "KARNATAKA"
  },
  "573161": {
    "city": "ARSIKERE",
    "state": "KARNATAKA"
  },
  "573162": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573163": {
    "city": "ARSIKERE",
    "state": "KARNATAKA"
  },
  "573164": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573165": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573201": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573202": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573210": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573211": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573212": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573213": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573214": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573215": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573216": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573217": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573218": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573219": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573220": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573221": {
    "city": "HASAN",
    "state": "KARNATAKA"
  },
  "573222": {
    "city": "HASAN",
    "state": "KARNATAKA"
  },
  "573223": {
    "city": "CHANNARAYAPATNA",
    "state": "KARNATAKA"
  },
  "573224": {
    "city": "CHANNARAYAPATNA",
    "state": "KARNATAKA"
  },
  "573225": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573226": {
    "city": "Hassan",
    "state": "Karnataka"
  },
  "573508": {
    "city": "ISHWARAMANGALA",
    "state": "KARNATAKA"
  },
  "574101": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574102": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574103": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574104": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574105": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574106": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574107": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574108": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574109": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574110": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574111": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574112": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574113": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574114": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574115": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574116": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574117": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574118": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574119": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574120": {
    "city": "PADUBIDRI",
    "state": "KARNATAKA"
  },
  "574121": {
    "city": "KARKALA",
    "state": "KARNATAKA"
  },
  "574122": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574123": {
    "city": "KARKALA",
    "state": "KARNATAKA"
  },
  "574124": {
    "city": "KARKALA",
    "state": "KARNATAKA"
  },
  "574128": {
    "city": "MOODBIDRI",
    "state": "KARNATAKA"
  },
  "574129": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574130": {
    "city": "MOODBIDRI",
    "state": "KARNATAKA"
  },
  "574131": {
    "city": "MOODBIDRI",
    "state": "KARNATAKA"
  },
  "574139": {
    "city": "MOODBIDRI",
    "state": "KARNATAKA"
  },
  "574140": {
    "city": "MOODBIDRI",
    "state": "KARNATAKA"
  },
  "574141": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574142": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574143": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574144": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574145": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574146": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574147": {
    "city": "PADUBIDRI",
    "state": "KARNATAKA"
  },
  "574148": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574149": {
    "city": "PADUBIDRI",
    "state": "KARNATAKA"
  },
  "574150": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574151": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574152": {
    "city": "B.C ROAD",
    "state": "KARNATAKA"
  },
  "574153": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574154": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574156": {
    "city": "PADUBIDRI",
    "state": "KARNATAKA"
  },
  "574161": {
    "city": "MANGALORE",
    "state": "KARNATAKA"
  },
  "574173": {
    "city": "Mangalore",
    "state": "KARNATAKA"
  },
  "574194": {
    "city": "MANGALORE",
    "state": "KARNATAKA"
  },
  "574195": {
    "city": "MOODBIDRI",
    "state": "KARNATAKA"
  },
  "574196": {
    "city": "MOODBIDRI",
    "state": "KARNATAKA"
  },
  "574197": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574198": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574199": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574201": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574202": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574203": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574208": {
    "city": "PUTTUR",
    "state": "KARNATAKA"
  },
  "574210": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574211": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574212": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574213": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574214": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574216": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574217": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574218": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574219": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574220": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574221": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574222": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574223": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574224": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574225": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574226": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574227": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574228": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574229": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574230": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574231": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574232": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574233": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574234": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574235": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574236": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574237": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574238": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574239": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574240": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574241": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574242": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574243": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574244": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "574245": {
    "city": "KARKALA",
    "state": "KARNATAKA"
  },
  "574246": {
    "city": "SULLIA",
    "state": "KARNATAKA"
  },
  "574247": {
    "city": "SULLIA",
    "state": "KARNATAKA"
  },
  "574248": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574249": {
    "city": "SULLIA",
    "state": "KARNATAKA"
  },
  "574250": {
    "city": "SULLIA",
    "state": "KARNATAKA"
  },
  "574251": {
    "city": "VITLA",
    "state": "KARNATAKA"
  },
  "574252": {
    "city": "VITLA",
    "state": "KARNATAKA"
  },
  "574253": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574254": {
    "city": "VITLA",
    "state": "KARNATAKA"
  },
  "574255": {
    "city": "VITLA",
    "state": "KARNATAKA"
  },
  "574257": {
    "city": "PUTTUR",
    "state": "KARNATAKA"
  },
  "574258": {
    "city": "PUTTUR",
    "state": "KARNATAKA"
  },
  "574259": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574260": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574261": {
    "city": "VITLA",
    "state": "KARNATAKA"
  },
  "574262": {
    "city": "VITLA",
    "state": "KARNATAKA"
  },
  "574263": {
    "city": "B.C ROAD",
    "state": "KARNATAKA"
  },
  "574264": {
    "city": "B.C ROAD",
    "state": "KARNATAKA"
  },
  "574265": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574266": {
    "city": "MOODBIDRI",
    "state": "KARNATAKA"
  },
  "574267": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574268": {
    "city": "MOODBIDRI",
    "state": "KARNATAKA"
  },
  "574269": {
    "city": "MOODBIDRI",
    "state": "KARNATAKA"
  },
  "574272": {
    "city": "PUTTUR",
    "state": "KARNATAKA"
  },
  "574273": {
    "city": "PUTTUR",
    "state": "KARNATAKA"
  },
  "574274": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574275": {
    "city": "PUTTUR",
    "state": "KARNATAKA"
  },
  "574276": {
    "city": "PUTTUR",
    "state": "KARNATAKA"
  },
  "574277": {
    "city": "VITLA",
    "state": "KARNATAKA"
  },
  "574278": {
    "city": "VITLA",
    "state": "KARNATAKA"
  },
  "574279": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574280": {
    "city": "VITLA",
    "state": "KARNATAKA"
  },
  "574281": {
    "city": "VITLA",
    "state": "KARNATAKA"
  },
  "574283": {
    "city": "KADABA",
    "state": "KARNATAKA"
  },
  "574284": {
    "city": "KADABA",
    "state": "KARNATAKA"
  },
  "574285": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574286": {
    "city": "KADABA",
    "state": "KARNATAKA"
  },
  "574287": {
    "city": "KADABA",
    "state": "KARNATAKA"
  },
  "574311": {
    "city": "SULLIA",
    "state": "KARNATAKA"
  },
  "574312": {
    "city": "SULLIA",
    "state": "KARNATAKA"
  },
  "574313": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574314": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574315": {
    "city": "SULLIA",
    "state": "KARNATAKA"
  },
  "574316": {
    "city": "SULLIA",
    "state": "KARNATAKA"
  },
  "574321": {
    "city": "VITLA",
    "state": "KARNATAKA"
  },
  "574323": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574324": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574325": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574326": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574327": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574328": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574507": {
    "city": "SURATHKAL",
    "state": "KARNATAKA"
  },
  "574508": {
    "city": "SURATHKAL",
    "state": "KARNATAKA"
  },
  "574509": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "574510": {
    "city": "SURATHKAL",
    "state": "KARNATAKA"
  },
  "575001": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575002": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575003": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575004": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575005": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575006": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575007": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575008": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575009": {
    "city": "SURATHKAL",
    "state": "KARNATAKA"
  },
  "575010": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575011": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575012": {
    "city": "MANGALORE",
    "state": "KARNATAKA"
  },
  "575013": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575014": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575015": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575016": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575017": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575018": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575019": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575020": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575021": {
    "city": "MANGALORE",
    "state": "KARNATAKA"
  },
  "575022": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575023": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575024": {
    "city": "SURATHKAL",
    "state": "KARNATAKA"
  },
  "575025": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575026": {
    "city": "MANGALORE",
    "state": "KARNATAKA"
  },
  "575027": {
    "city": "MANGALORE",
    "state": "KARNATAKA"
  },
  "575028": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575029": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "575030": {
    "city": "Dakshina Kannada",
    "state": "Karnataka"
  },
  "576001": {
    "city": "MANIPAL",
    "state": "KARNATAKA"
  },
  "576101": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576102": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576103": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576104": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576105": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576106": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576107": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576108": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576111": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576112": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576113": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576114": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576115": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576116": {
    "city": "KARKALA",
    "state": "KARNATAKA"
  },
  "576117": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576118": {
    "city": "MANIPAL",
    "state": "KARNATAKA"
  },
  "576119": {
    "city": "MANIPAL",
    "state": "KARNATAKA"
  },
  "576120": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576121": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576122": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576123": {
    "city": "MANIPAL",
    "state": "KARNATAKA"
  },
  "576124": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576125": {
    "city": "MANIPAL",
    "state": "KARNATAKA"
  },
  "576126": {
    "city": "MANIPAL",
    "state": "KARNATAKA"
  },
  "576127": {
    "city": "MANIPAL",
    "state": "KARNATAKA"
  },
  "576201": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576210": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576211": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576212": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576213": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576214": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576215": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576216": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576217": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576218": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576219": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576220": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576221": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576222": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576223": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576224": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576225": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576226": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576227": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576228": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576229": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576230": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576231": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576232": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576233": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576234": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576235": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576236": {
    "city": "KUNDAPURA",
    "state": "KARNATAKA"
  },
  "576237": {
    "city": "KUNDAPURA",
    "state": "KARNATAKA"
  },
  "576245": {
    "city": "KUNDAPURA",
    "state": "KARNATAKA"
  },
  "576246": {
    "city": "KUNDAPURA",
    "state": "KARNATAKA"
  },
  "576247": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576248": {
    "city": "KUNDAPURA",
    "state": "KARNATAKA"
  },
  "576249": {
    "city": "KUNDAPURA",
    "state": "KARNATAKA"
  },
  "576254": {
    "city": "KUNDAPURA",
    "state": "KARNATAKA"
  },
  "576255": {
    "city": "KUNDAPURA",
    "state": "KARNATAKA"
  },
  "576256": {
    "city": "KUNDAPURA",
    "state": "KARNATAKA"
  },
  "576257": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576258": {
    "city": "KUNDAPURA",
    "state": "KARNATAKA"
  },
  "576259": {
    "city": "KUNDAPURA",
    "state": "KARNATAKA"
  },
  "576280": {
    "city": "HOSANGADI",
    "state": "KARNATAKA"
  },
  "576281": {
    "city": "HOSANGADI",
    "state": "KARNATAKA"
  },
  "576282": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "576283": {
    "city": "Udupi",
    "state": "Karnataka"
  },
  "577001": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577002": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577003": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577004": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577005": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577006": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577101": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577102": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577111": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577112": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577113": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577114": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577115": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577116": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577117": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577118": {
    "city": "SRINGERI",
    "state": "KARNATAKA"
  },
  "577119": {
    "city": "SAKLESHPUR",
    "state": "KARNATAKA"
  },
  "577120": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577121": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577122": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577123": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577124": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577125": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577126": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577127": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577128": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577129": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577130": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577131": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577132": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577133": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577134": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577135": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577136": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577137": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577138": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577139": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577140": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577141": {
    "city": "SRINGERI",
    "state": "KARNATAKA"
  },
  "577142": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577144": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577145": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577146": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577147": {
    "city": "SAKLESHPUR",
    "state": "KARNATAKA"
  },
  "577148": {
    "city": "SRINGERI",
    "state": "KARNATAKA"
  },
  "577149": {
    "city": "CHICKAMAGALUR",
    "state": "KARNATAKA"
  },
  "577150": {
    "city": "SRINGERI",
    "state": "KARNATAKA"
  },
  "577151": {
    "city": "MUDIGERE",
    "state": "KARNATAKA"
  },
  "577152": {
    "city": "SRINGERI",
    "state": "KARNATAKA"
  },
  "577153": {
    "city": "SHIVAMOGA",
    "state": "KARNATAKA"
  },
  "577154": {
    "city": "SHIVAMOGA",
    "state": "KARNATAKA"
  },
  "577155": {
    "city": "CHICKAMAGALUR",
    "state": "KARNATAKA"
  },
  "577156": {
    "city": "CHICKAMAGALUR",
    "state": "KARNATAKA"
  },
  "577157": {
    "city": "SRINGERI",
    "state": "KARNATAKA"
  },
  "577158": {
    "city": "THIRTHAHALLI",
    "state": "KARNATAKA"
  },
  "577159": {
    "city": "SRINGERI",
    "state": "KARNATAKA"
  },
  "577160": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577161": {
    "city": "SRINGERI",
    "state": "KARNATAKA"
  },
  "577162": {
    "city": "SRINGERI",
    "state": "KARNATAKA"
  },
  "577163": {
    "city": "CHICKAMAGALUR",
    "state": "KARNATAKA"
  },
  "577164": {
    "city": "CHICKAMAGALUR",
    "state": "KARNATAKA"
  },
  "577165": {
    "city": "CHICKAMAGALUR",
    "state": "KARNATAKA"
  },
  "577167": {
    "city": "KADURU",
    "state": "KARNATAKA"
  },
  "577168": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577169": {
    "city": "CHICKAMAGALUR",
    "state": "KARNATAKA"
  },
  "577170": {
    "city": "MUDIGERE",
    "state": "KARNATAKA"
  },
  "577171": {
    "city": "MUDIGERE",
    "state": "KARNATAKA"
  },
  "577172": {
    "city": "MUDIGERE",
    "state": "KARNATAKA"
  },
  "577173": {
    "city": "CHICKAMAGALUR",
    "state": "KARNATAKA"
  },
  "577174": {
    "city": "CHICKAMAGALUR",
    "state": "KARNATAKA"
  },
  "577175": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577177": {
    "city": "SRINGERI",
    "state": "KARNATAKA"
  },
  "577178": {
    "city": "SRINGERI",
    "state": "KARNATAKA"
  },
  "577179": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577180": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577181": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577182": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577201": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577202": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577203": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577204": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577205": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577211": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577212": {
    "city": "SHIKARIPURA",
    "state": "KARNATAKA"
  },
  "577213": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577214": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577215": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577216": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577217": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577218": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577219": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577220": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577221": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577222": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577223": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577224": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577225": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577226": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577227": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577228": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577229": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577230": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577231": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577232": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577233": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577234": {
    "city": "CHANNAGIRI",
    "state": "KARNATAKA"
  },
  "577235": {
    "city": "SHIVAMOGA",
    "state": "KARNATAKA"
  },
  "577236": {
    "city": "SHIKARIPURA",
    "state": "KARNATAKA"
  },
  "577237": {
    "city": "SHIVAMOGA",
    "state": "KARNATAKA"
  },
  "577238": {
    "city": "SHIKARIPURA",
    "state": "KARNATAKA"
  },
  "577239": {
    "city": "THIRTHAHALLI",
    "state": "KARNATAKA"
  },
  "577240": {
    "city": "THIRTHAHALLI",
    "state": "KARNATAKA"
  },
  "577241": {
    "city": "BHADRAVATI",
    "state": "KARNATAKA"
  },
  "577242": {
    "city": "BHADRAVATI",
    "state": "KARNATAKA"
  },
  "577243": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577244": {
    "city": "SAGARA",
    "state": "KARNATAKA"
  },
  "577245": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577246": {
    "city": "THIRTHAHALLI",
    "state": "KARNATAKA"
  },
  "577247": {
    "city": "BHADRAVATI",
    "state": "KARNATAKA"
  },
  "577301": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577302": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577303": {
    "city": "BHADRAVATHI",
    "state": "KARNATAKA"
  },
  "577321": {
    "city": "BHADRAVATI",
    "state": "KARNATAKA"
  },
  "577401": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577411": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577412": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577413": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577414": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577415": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577416": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577417": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577418": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577419": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577421": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577422": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577423": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577424": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577425": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577426": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577427": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577428": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577429": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577430": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577431": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577432": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577433": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577434": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577435": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577436": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577437": {
    "city": "THIRTHAHALLI",
    "state": "KARNATAKA"
  },
  "577438": {
    "city": "THIRTHAHALLI",
    "state": "KARNATAKA"
  },
  "577439": {
    "city": "SAGARA",
    "state": "KARNATAKA"
  },
  "577440": {
    "city": "THIRTHAHALLI",
    "state": "KARNATAKA"
  },
  "577441": {
    "city": "SRINGERI",
    "state": "KARNATAKA"
  },
  "577442": {
    "city": "KOPPA",
    "state": "KARNATAKA"
  },
  "577443": {
    "city": "SAGARA",
    "state": "KARNATAKA"
  },
  "577444": {
    "city": "SAGARA",
    "state": "KARNATAKA"
  },
  "577445": {
    "city": "THIRTHAHALLI",
    "state": "KARNATAKA"
  },
  "577446": {
    "city": "SAGARA",
    "state": "KARNATAKA"
  },
  "577447": {
    "city": "THIRTHAHALLI",
    "state": "KARNATAKA"
  },
  "577448": {
    "city": "THIRTHAHALLI",
    "state": "KARNATAKA"
  },
  "577449": {
    "city": "SHIKARIPURA",
    "state": "KARNATAKA"
  },
  "577450": {
    "city": "SHIKARIPURA",
    "state": "KARNATAKA"
  },
  "577451": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577452": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577453": {
    "city": "Shivamogga",
    "state": "Karnataka"
  },
  "577501": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577502": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577503": {
    "city": "CHITRADURGA",
    "state": "KARNATAKA"
  },
  "577511": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577512": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577513": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577514": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "577515": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577516": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577517": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577518": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577519": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577520": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577521": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577522": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577523": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577524": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577525": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577526": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577527": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577528": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577529": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577530": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577531": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577532": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577533": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577534": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577535": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577536": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577537": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577538": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577539": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577540": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577541": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577542": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577543": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577544": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577545": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577546": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577547": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577548": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577549": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577550": {
    "city": "Chikkamagaluru",
    "state": "Karnataka"
  },
  "577551": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577552": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577553": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577554": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577555": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577556": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577557": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577558": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577560": {
    "city": "HIRIYUR",
    "state": "KARNATAKA"
  },
  "577564": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "577565": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "577566": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577567": {
    "city": "CHITRADURGA",
    "state": "KARNATAKA"
  },
  "577568": {
    "city": "CHITRADURGA",
    "state": "KARNATAKA"
  },
  "577569": {
    "city": "CHITRADURGA",
    "state": "KARNATAKA"
  },
  "577570": {
    "city": "CHITRADURGA",
    "state": "KARNATAKA"
  },
  "577571": {
    "city": "CHITRADURGA",
    "state": "KARNATAKA"
  },
  "577572": {
    "city": "MOLAKALMURU",
    "state": "KARNATAKA"
  },
  "577573": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "577574": {
    "city": "HONNALI",
    "state": "KARNATAKA"
  },
  "577575": {
    "city": "HONNALI",
    "state": "KARNATAKA"
  },
  "577576": {
    "city": "CHICKAMAGALUR",
    "state": "KARNATAKA"
  },
  "577577": {
    "city": "CHICKAMAGALUR",
    "state": "KARNATAKA"
  },
  "577579": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "577580": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "577581": {
    "city": "HOLALKERE",
    "state": "KARNATAKA"
  },
  "577582": {
    "city": "HOLALKERE",
    "state": "KARNATAKA"
  },
  "577583": {
    "city": "HOLALKERE",
    "state": "KARNATAKA"
  },
  "577584": {
    "city": "HIRIYUR",
    "state": "KARNATAKA"
  },
  "577585": {
    "city": "HIRIYUR",
    "state": "KARNATAKA"
  },
  "577586": {
    "city": "CHALLAKERE",
    "state": "KARNATAKA"
  },
  "577587": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "577588": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "577589": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577590": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "577591": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "577592": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "577593": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "577594": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "577595": {
    "city": "HIRIYUR",
    "state": "KARNATAKA"
  },
  "577596": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577597": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577598": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577599": {
    "city": "Chitradurga",
    "state": "Karnataka"
  },
  "577601": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "577602": {
    "city": "HARIHAR",
    "state": "KARNATAKA"
  },
  "577777": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "578103": {
    "city": "MANIPAL",
    "state": "KARNATAKA"
  },
  "578104": {
    "city": "MANIPAL",
    "state": "KARNATAKA"
  },
  "578105": {
    "city": "MANIPAL",
    "state": "KARNATAKA"
  },
  "580001": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580002": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580003": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580004": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580005": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580006": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580007": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580008": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580009": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580010": {
    "city": "DHARWAD",
    "state": "KARNATAKA"
  },
  "580011": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580020": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580021": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580022": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "580023": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580024": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580025": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580026": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580027": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580028": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580029": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580030": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580031": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580032": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580110": {
    "city": "DHARWAD",
    "state": "KARNATAKA"
  },
  "580112": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580113": {
    "city": "DHARWAD",
    "state": "KARNATAKA"
  },
  "580114": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580115": {
    "city": "DHARWAD",
    "state": "KARNATAKA"
  },
  "580116": {
    "city": "DHARWAD",
    "state": "KARNATAKA"
  },
  "580117": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "580118": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "580211": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "580212": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "580213": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "580214": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "580215": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "580216": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581101": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581102": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581103": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "581104": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581105": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "581106": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581107": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "581108": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581109": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581110": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581111": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581112": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581113": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "581115": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581116": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581117": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "581118": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581119": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "581120": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581121": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581122": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "581123": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581124": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581125": {
    "city": "HIREKERUR",
    "state": "KARNATAKA"
  },
  "581126": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581127": {
    "city": "HANGAL",
    "state": "KARNATAKA"
  },
  "581128": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581129": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581130": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581131": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581132": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581133": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581134": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581135": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581136": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581137": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581138": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581139": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581140": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581141": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581142": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581143": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581144": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581145": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581146": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581147": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581148": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581149": {
    "city": "HANGAL",
    "state": "KARNATAKA"
  },
  "581150": {
    "city": "HANGAL",
    "state": "KARNATAKA"
  },
  "581151": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581152": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581153": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581154": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581155": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581156": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581157": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581158": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581159": {
    "city": "SHIGGAON",
    "state": "KARNATAKA"
  },
  "581160": {
    "city": "SHIGGAON",
    "state": "KARNATAKA"
  },
  "581161": {
    "city": "SHIGGAON",
    "state": "KARNATAKA"
  },
  "581162": {
    "city": "SHIGGAON",
    "state": "KARNATAKA"
  },
  "581163": {
    "city": "SHIGGAON",
    "state": "KARNATAKA"
  },
  "581164": {
    "city": "SHIGGAON",
    "state": "KARNATAKA"
  },
  "581165": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "581166": {
    "city": "HANGAL",
    "state": "KARNATAKA"
  },
  "581167": {
    "city": "HANGAL",
    "state": "KARNATAKA"
  },
  "581168": {
    "city": "HANGAL",
    "state": "KARNATAKA"
  },
  "581169": {
    "city": "SHIGGAON",
    "state": "KARNATAKA"
  },
  "581170": {
    "city": "SHIGGAON",
    "state": "KARNATAKA"
  },
  "581171": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581172": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581173": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581174": {
    "city": "DHARWAD",
    "state": "KARNATAKA"
  },
  "581175": {
    "city": "DHARWAD",
    "state": "KARNATAKA"
  },
  "581176": {
    "city": "HANGAL",
    "state": "KARNATAKA"
  },
  "581177": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581178": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581179": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581180": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581181": {
    "city": "DHARWAD",
    "state": "KARNATAKA"
  },
  "581182": {
    "city": "DHARWAD",
    "state": "KARNATAKA"
  },
  "581183": {
    "city": "DHARWAD",
    "state": "KARNATAKA"
  },
  "581184": {
    "city": "BHATKAL",
    "state": "KARNATAKA"
  },
  "581185": {
    "city": "BHATKAL",
    "state": "KARNATAKA"
  },
  "581186": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581187": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581188": {
    "city": "BIJAPUR",
    "state": "KARNATAKA"
  },
  "581189": {
    "city": "HANGAL",
    "state": "KARNATAKA"
  },
  "581190": {
    "city": "HIREKERUR",
    "state": "KARNATAKA"
  },
  "581191": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581192": {
    "city": "HANGAL",
    "state": "KARNATAKA"
  },
  "581193": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581194": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581195": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "581196": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "581197": {
    "city": "HANGAL",
    "state": "KARNATAKA"
  },
  "581198": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581199": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581201": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "581202": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581203": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581204": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "581205": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581206": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "581207": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "581208": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581209": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "581210": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581211": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581212": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581213": {
    "city": "Haveri",
    "state": "Karnataka"
  },
  "581214": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "581215": {
    "city": "DHARWAD",
    "state": "KARNATAKA"
  },
  "581217": {
    "city": "HIREKERUR",
    "state": "KARNATAKA"
  },
  "581218": {
    "city": "HIREKERUR",
    "state": "KARNATAKA"
  },
  "581219": {
    "city": "HIREKERUR",
    "state": "KARNATAKA"
  },
  "581221": {
    "city": "KALAGHATAGI",
    "state": "KARNATAKA"
  },
  "581222": {
    "city": "KALAGHATAGI",
    "state": "KARNATAKA"
  },
  "581223": {
    "city": "KALAGHATAGI",
    "state": "KARNATAKA"
  },
  "581224": {
    "city": "KALAGHATAGI",
    "state": "KARNATAKA"
  },
  "581225": {
    "city": "KALAGHATAGI",
    "state": "KARNATAKA"
  },
  "581226": {
    "city": "KALAGHATAGI",
    "state": "KARNATAKA"
  },
  "581227": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581228": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581229": {
    "city": "RANEBENNUR",
    "state": "KARNATAKA"
  },
  "581230": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581231": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581232": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581233": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581234": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "581235": {
    "city": "SHIRAHATTI",
    "state": "KARNATAKA"
  },
  "581236": {
    "city": "HUKERI",
    "state": "KARNATAKA"
  },
  "581301": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581302": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581303": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581304": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581305": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581306": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581307": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581308": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581313": {
    "city": "ANKOLA",
    "state": "KARNATAKA"
  },
  "581314": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581315": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581316": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581317": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581318": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581319": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581320": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581321": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581322": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581323": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581324": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581325": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581326": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581327": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581328": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581329": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581330": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581331": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581332": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581333": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581334": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581335": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581336": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581337": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581338": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581339": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581340": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581341": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581342": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581343": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581344": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581345": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581346": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581347": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581348": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581349": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581350": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581351": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581352": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581353": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581354": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581355": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581356": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581357": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581358": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581359": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581360": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581361": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581362": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581363": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581364": {
    "city": "DANDELI",
    "state": "KARNATAKA"
  },
  "581365": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581366": {
    "city": "DANDELI",
    "state": "KARNATAKA"
  },
  "581367": {
    "city": "DANDELI",
    "state": "KARNATAKA"
  },
  "581382": {
    "city": "HONNAVAR",
    "state": "KARNATAKA"
  },
  "581383": {
    "city": "HONNAVAR",
    "state": "KARNATAKA"
  },
  "581384": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581394": {
    "city": "KAIGA",
    "state": "KARNATAKA"
  },
  "581395": {
    "city": "KAIGA",
    "state": "KARNATAKA"
  },
  "581396": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581398": {
    "city": "KAIGA",
    "state": "KARNATAKA"
  },
  "581400": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581401": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581402": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581403": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581405": {
    "city": "SIRSI",
    "state": "KARNATAKA"
  },
  "581411": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581412": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581413": {
    "city": "YELLAPUR",
    "state": "KARNATAKA"
  },
  "581414": {
    "city": "YELLAPUR",
    "state": "KARNATAKA"
  },
  "581419": {
    "city": "BHATKAL",
    "state": "KARNATAKA"
  },
  "581420": {
    "city": "BHATKAL",
    "state": "KARNATAKA"
  },
  "581421": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581422": {
    "city": "HONNAVAR",
    "state": "KARNATAKA"
  },
  "581423": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581424": {
    "city": "HONNAVAR",
    "state": "KARNATAKA"
  },
  "581425": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "581426": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "581427": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "581428": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "581438": {
    "city": "KUMTA",
    "state": "KARNATAKA"
  },
  "581439": {
    "city": "KUMTA",
    "state": "KARNATAKA"
  },
  "581440": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581441": {
    "city": "KUMTA",
    "state": "KARNATAKA"
  },
  "581442": {
    "city": "KUMTA",
    "state": "KARNATAKA"
  },
  "581448": {
    "city": "SIRSI",
    "state": "KARNATAKA"
  },
  "581449": {
    "city": "SIRSI",
    "state": "KARNATAKA"
  },
  "581450": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "581451": {
    "city": "SIRSI",
    "state": "KARNATAKA"
  },
  "581452": {
    "city": "DANDELI",
    "state": "KARNATAKA"
  },
  "581453": {
    "city": "Uttara Kannada",
    "state": "Karnataka"
  },
  "582101": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582102": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582103": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582109": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582111": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582112": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582113": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582114": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582115": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582116": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582117": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582118": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582119": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582120": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582121": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "582122": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "582123": {
    "city": "GADAG",
    "state": "KARNATAKA"
  },
  "582124": {
    "city": "GADAG",
    "state": "KARNATAKA"
  },
  "582125": {
    "city": "GADAG",
    "state": "KARNATAKA"
  },
  "582126": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582127": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582128": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "582131": {
    "city": "GADAG",
    "state": "KARNATAKA"
  },
  "582132": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582135": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "582136": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "582137": {
    "city": "SHIRAHATTI",
    "state": "KARNATAKA"
  },
  "582138": {
    "city": "SHIRAHATTI",
    "state": "KARNATAKA"
  },
  "582139": {
    "city": "SHIRAHATTI",
    "state": "KARNATAKA"
  },
  "582140": {
    "city": "SHIRAHATTI",
    "state": "KARNATAKA"
  },
  "582141": {
    "city": "SHIRAHATTI",
    "state": "KARNATAKA"
  },
  "582142": {
    "city": "SHIRAHATTI",
    "state": "KARNATAKA"
  },
  "582143": {
    "city": "SHIRAHATTI",
    "state": "KARNATAKA"
  },
  "582145": {
    "city": "SHIRAHATTI",
    "state": "KARNATAKA"
  },
  "582201": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "582202": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582203": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582204": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582205": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582206": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582207": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582208": {
    "city": "Dharwad",
    "state": "Karnataka"
  },
  "582209": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582210": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582211": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "582212": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "582213": {
    "city": "SHIRAHATTI",
    "state": "KARNATAKA"
  },
  "582214": {
    "city": "GADAG",
    "state": "KARNATAKA"
  },
  "582215": {
    "city": "HAVERI",
    "state": "KARNATAKA"
  },
  "582216": {
    "city": "HUBLI",
    "state": "KARNATAKA"
  },
  "582217": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582218": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582219": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582220": {
    "city": "CHITRADURGA",
    "state": "KARNATAKA"
  },
  "582221": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "582222": {
    "city": "DHARWAD",
    "state": "KARNATAKA"
  },
  "582223": {
    "city": "DHARWAD",
    "state": "KARNATAKA"
  },
  "582224": {
    "city": "SHIRAHATTI",
    "state": "KARNATAKA"
  },
  "582225": {
    "city": "SHIRAHATTI",
    "state": "KARNATAKA"
  },
  "582226": {
    "city": "SHIRAHATTI",
    "state": "KARNATAKA"
  },
  "582227": {
    "city": "GADAG",
    "state": "KARNATAKA"
  },
  "582228": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "582229": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "582230": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582231": {
    "city": "GADAG",
    "state": "KARNATAKA"
  },
  "582232": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582233": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "582234": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "582235": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582236": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582237": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "582238": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "582239": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582240": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582241": {
    "city": "RONA",
    "state": "KARNATAKA"
  },
  "582243": {
    "city": "JAMKHANDI",
    "state": "KARNATAKA"
  },
  "583101": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583102": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583103": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583104": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583105": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583111": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583112": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583113": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583114": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583115": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583116": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583117": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583118": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583119": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583120": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583121": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583122": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583123": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583124": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583125": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "583126": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583127": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "583128": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583129": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583130": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583131": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "583132": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583133": {
    "city": "GANGAVATI",
    "state": "KARNATAKA"
  },
  "583134": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583135": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583136": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583137": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "583138": {
    "city": "BELLARY",
    "state": "KARNATAKA"
  },
  "583139": {
    "city": "BELLARY",
    "state": "KARNATAKA"
  },
  "583140": {
    "city": "SANDURU",
    "state": "KARNATAKA"
  },
  "583141": {
    "city": "SANDURU",
    "state": "KARNATAKA"
  },
  "583142": {
    "city": "TORANAGALLU",
    "state": "KARNATAKA"
  },
  "583143": {
    "city": "TORANAGALLU",
    "state": "KARNATAKA"
  },
  "583144": {
    "city": "GANGAVATI",
    "state": "KARNATAKA"
  },
  "583145": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "583146": {
    "city": "DAVANGERE",
    "state": "KARNATAKA"
  },
  "583147": {
    "city": "HARPANAHALLI",
    "state": "KARNATAKA"
  },
  "583148": {
    "city": "HARPANAHALLI",
    "state": "KARNATAKA"
  },
  "583149": {
    "city": "JAGALUR",
    "state": "KARNATAKA"
  },
  "583150": {
    "city": "TORANAGALLU",
    "state": "KARNATAKA"
  },
  "583151": {
    "city": "TORANAGALLU",
    "state": "KARNATAKA"
  },
  "583152": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583201": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583202": {
    "city": "HOSPET",
    "state": "KARNATAKA"
  },
  "583203": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583204": {
    "city": "HOSPET",
    "state": "KARNATAKA"
  },
  "583211": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583212": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583213": {
    "city": "Davangere",
    "state": "Karnataka"
  },
  "583214": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583215": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583216": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583217": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583218": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583219": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583220": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583221": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583222": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583223": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583224": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583225": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583226": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "583227": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "583228": {
    "city": "Koppal",
    "state": "Karnataka"
  },
  "583229": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "583230": {
    "city": "Koppal",
    "state": "Karnataka"
  },
  "583231": {
    "city": "Koppal",
    "state": "Karnataka"
  },
  "583232": {
    "city": "Koppal",
    "state": "Karnataka"
  },
  "583233": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "583234": {
    "city": "Koppal",
    "state": "Karnataka"
  },
  "583235": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "583236": {
    "city": "Koppal",
    "state": "Karnataka"
  },
  "583237": {
    "city": "Koppal",
    "state": "Karnataka"
  },
  "583238": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "583239": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583240": {
    "city": "HOSPET",
    "state": "KARNATAKA"
  },
  "583241": {
    "city": "HOSPET",
    "state": "KARNATAKA"
  },
  "583263": {
    "city": "KOPPAL",
    "state": "KARNATAKA"
  },
  "583264": {
    "city": "KOPPAL",
    "state": "KARNATAKA"
  },
  "583265": {
    "city": "KOPPAL",
    "state": "KARNATAKA"
  },
  "583266": {
    "city": "HAGARI BOMMANAHALLI",
    "state": "KARNATAKA"
  },
  "583267": {
    "city": "GANGAVATI",
    "state": "KARNATAKA"
  },
  "583268": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "583269": {
    "city": "KOPPAL",
    "state": "KARNATAKA"
  },
  "583270": {
    "city": "KOPPAL",
    "state": "KARNATAKA"
  },
  "583271": {
    "city": "KOPPAL",
    "state": "KARNATAKA"
  },
  "583272": {
    "city": "BELLARY",
    "state": "KARNATAKA"
  },
  "583273": {
    "city": "BELLARY",
    "state": "KARNATAKA"
  },
  "583274": {
    "city": "TORANAGALLU",
    "state": "KARNATAKA"
  },
  "583275": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583276": {
    "city": "Ballari",
    "state": "Karnataka"
  },
  "583277": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "583278": {
    "city": "Koppal",
    "state": "Karnataka"
  },
  "583279": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "583280": {
    "city": "Koppal",
    "state": "Karnataka"
  },
  "583281": {
    "city": "Koppal",
    "state": "Karnataka"
  },
  "583282": {
    "city": "Gadag",
    "state": "Karnataka"
  },
  "583283": {
    "city": "Koppal",
    "state": "Karnataka"
  },
  "584101": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584102": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584103": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584104": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584110": {
    "city": "RAICHUR",
    "state": "KARNATAKA"
  },
  "584111": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584112": {
    "city": "DEVADURGA",
    "state": "KARNATAKA"
  },
  "584113": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584114": {
    "city": "LINGASUGUR",
    "state": "KARNATAKA"
  },
  "584115": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584116": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584117": {
    "city": "MANVI",
    "state": "KARNATAKA"
  },
  "584118": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584119": {
    "city": "GANGAVATI",
    "state": "KARNATAKA"
  },
  "584120": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584121": {
    "city": "KUSHTAGI",
    "state": "KARNATAKA"
  },
  "584122": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584123": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584124": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584125": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584126": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584127": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584128": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584129": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584130": {
    "city": "GANGAVATI",
    "state": "KARNATAKA"
  },
  "584131": {
    "city": "KUSHTAGI",
    "state": "KARNATAKA"
  },
  "584132": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584133": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584134": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584135": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584136": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584138": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584139": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584140": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584141": {
    "city": "SINDHANUR",
    "state": "KARNATAKA"
  },
  "584142": {
    "city": "SINDHANUR",
    "state": "KARNATAKA"
  },
  "584143": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584144": {
    "city": "MANVI",
    "state": "KARNATAKA"
  },
  "584145": {
    "city": "MANVI",
    "state": "KARNATAKA"
  },
  "584146": {
    "city": "MANVI",
    "state": "KARNATAKA"
  },
  "584147": {
    "city": "MANVI",
    "state": "KARNATAKA"
  },
  "584148": {
    "city": "MANVI",
    "state": "KARNATAKA"
  },
  "584149": {
    "city": "GANGAVATI",
    "state": "KARNATAKA"
  },
  "584150": {
    "city": "GANGAVATI",
    "state": "KARNATAKA"
  },
  "584151": {
    "city": "LINGASUGUR",
    "state": "KARNATAKA"
  },
  "584153": {
    "city": "DEVADURGA",
    "state": "KARNATAKA"
  },
  "584154": {
    "city": "MANVI",
    "state": "KARNATAKA"
  },
  "584155": {
    "city": "DEVADURGA",
    "state": "KARNATAKA"
  },
  "584156": {
    "city": "DEVADURGA",
    "state": "KARNATAKA"
  },
  "584157": {
    "city": "DEVADURGA",
    "state": "KARNATAKA"
  },
  "584158": {
    "city": "JAGALUR",
    "state": "KARNATAKA"
  },
  "584159": {
    "city": "JAGALUR",
    "state": "KARNATAKA"
  },
  "584160": {
    "city": "RAICHUR",
    "state": "KARNATAKA"
  },
  "584161": {
    "city": "LINGASUGUR",
    "state": "KARNATAKA"
  },
  "584164": {
    "city": "SINDHANUR",
    "state": "KARNATAKA"
  },
  "584165": {
    "city": "SINDHANUR",
    "state": "KARNATAKA"
  },
  "584166": {
    "city": "SINDHANUR",
    "state": "KARNATAKA"
  },
  "584167": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584169": {
    "city": "RAICHUR",
    "state": "KARNATAKA"
  },
  "584170": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584201": {
    "city": "RAICHUR",
    "state": "KARNATAKA"
  },
  "584202": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "584203": {
    "city": "Raichur",
    "state": "Karnataka"
  },
  "585101": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585102": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585103": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585104": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585105": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585106": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585109": {
    "city": "GULBARGA",
    "state": "KARNATAKA"
  },
  "585201": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585202": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585210": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585211": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585212": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585213": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585214": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585215": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585216": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585217": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585218": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585219": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585220": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585221": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585222": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585223": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585224": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585225": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585226": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585227": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585228": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585229": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585233": {
    "city": "SHAHAPUR",
    "state": "KARNATAKA"
  },
  "585236": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585237": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585238": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585239": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585240": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585241": {
    "city": "WADI",
    "state": "KARNATAKA"
  },
  "585242": {
    "city": "AFZALPUR",
    "state": "KARNATAKA"
  },
  "585243": {
    "city": "GULBARGA",
    "state": "KARNATAKA"
  },
  "585244": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585245": {
    "city": "AFZALPUR",
    "state": "KARNATAKA"
  },
  "585246": {
    "city": "AFZALPUR",
    "state": "KARNATAKA"
  },
  "585247": {
    "city": "SHAHAPUR",
    "state": "KARNATAKA"
  },
  "585248": {
    "city": "AFZALPUR",
    "state": "KARNATAKA"
  },
  "585249": {
    "city": "AFZALPUR",
    "state": "KARNATAKA"
  },
  "585250": {
    "city": "SADAM",
    "state": "KARNATAKA"
  },
  "585251": {
    "city": "SADAM",
    "state": "KARNATAKA"
  },
  "585252": {
    "city": "SHAHAPUR",
    "state": "KARNATAKA"
  },
  "585253": {
    "city": "SHAHAPUR",
    "state": "KARNATAKA"
  },
  "585254": {
    "city": "WADI",
    "state": "KARNATAKA"
  },
  "585255": {
    "city": "WADI",
    "state": "KARNATAKA"
  },
  "585256": {
    "city": "BASAVAKALYAN",
    "state": "KARNATAKA"
  },
  "585257": {
    "city": "BASAVAKALYAN",
    "state": "KARNATAKA"
  },
  "585258": {
    "city": "HALLIKHEDA",
    "state": "KARNATAKA"
  },
  "585259": {
    "city": "AURAD",
    "state": "KARNATAKA"
  },
  "585260": {
    "city": "GULBARGA",
    "state": "KARNATAKA"
  },
  "585261": {
    "city": "HALLIKHEDA",
    "state": "KARNATAKA"
  },
  "585262": {
    "city": "HUMNABAD",
    "state": "KARNATAKA"
  },
  "585263": {
    "city": "HALLIKHEDA",
    "state": "KARNATAKA"
  },
  "585264": {
    "city": "HALLIKHEDA",
    "state": "KARNATAKA"
  },
  "585265": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585266": {
    "city": "GULBARGA",
    "state": "KARNATAKA"
  },
  "585267": {
    "city": "WADI",
    "state": "KARNATAKA"
  },
  "585268": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585269": {
    "city": "YADAGIRI TALUKU",
    "state": "KARNATAKA"
  },
  "585270": {
    "city": "HUMNABAD",
    "state": "KARNATAKA"
  },
  "585271": {
    "city": "WADI",
    "state": "KARNATAKA"
  },
  "585272": {
    "city": "WADI",
    "state": "KARNATAKA"
  },
  "585273": {
    "city": "SHAHAPUR",
    "state": "KARNATAKA"
  },
  "585274": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585275": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585276": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585277": {
    "city": "WADI",
    "state": "KARNATAKA"
  },
  "585278": {
    "city": "GULBARGA",
    "state": "KARNATAKA"
  },
  "585279": {
    "city": "YADAGIRI TALUKU",
    "state": "KARNATAKA"
  },
  "585280": {
    "city": "SADAM",
    "state": "KARNATAKA"
  },
  "585281": {
    "city": "GULBARGA",
    "state": "KARNATAKA"
  },
  "585282": {
    "city": "GULBARGA",
    "state": "KARNATAKA"
  },
  "585283": {
    "city": "SHORAPUR",
    "state": "KARNATAKA"
  },
  "585284": {
    "city": "YADAGIRI TALUKU",
    "state": "KARNATAKA"
  },
  "585285": {
    "city": "GULBARGA",
    "state": "KARNATAKA"
  },
  "585286": {
    "city": "GULBARGA",
    "state": "KARNATAKA"
  },
  "585287": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585288": {
    "city": "GULBARGA",
    "state": "KARNATAKA"
  },
  "585289": {
    "city": "GULBARGA",
    "state": "KARNATAKA"
  },
  "585290": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585291": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585292": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585301": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585302": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585303": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585304": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585305": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585306": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585307": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585308": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585309": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585310": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585311": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585312": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585313": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585314": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585315": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585316": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585317": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585318": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585319": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585320": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585321": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585322": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585323": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585324": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585325": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585326": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585327": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585328": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585329": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585330": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585331": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585332": {
    "city": "AFZALPUR",
    "state": "KARNATAKA"
  },
  "585333": {
    "city": "HUMNABAD",
    "state": "KARNATAKA"
  },
  "585334": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585335": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585336": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585337": {
    "city": "GULBARGA",
    "state": "KARNATAKA"
  },
  "585338": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585339": {
    "city": "JEVARGI",
    "state": "KARNATAKA"
  },
  "585340": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585341": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585342": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585343": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585344": {
    "city": "WADI",
    "state": "KARNATAKA"
  },
  "585345": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585346": {
    "city": "AURAD",
    "state": "KARNATAKA"
  },
  "585347": {
    "city": "AURAD",
    "state": "KARNATAKA"
  },
  "585348": {
    "city": "AURAD",
    "state": "KARNATAKA"
  },
  "585349": {
    "city": "BASAVAKALYAN",
    "state": "KARNATAKA"
  },
  "585350": {
    "city": "HUMNABAD",
    "state": "KARNATAKA"
  },
  "585351": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585352": {
    "city": "HUMNABAD",
    "state": "KARNATAKA"
  },
  "585353": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585354": {
    "city": "BASAVAKALYAN",
    "state": "KARNATAKA"
  },
  "585355": {
    "city": "Yadgir",
    "state": "Karnataka"
  },
  "585356": {
    "city": "BHALKI",
    "state": "KARNATAKA"
  },
  "585358": {
    "city": "HALLIKHEDA",
    "state": "KARNATAKA"
  },
  "585359": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585360": {
    "city": "HALLIKHEDA",
    "state": "KARNATAKA"
  },
  "585361": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585362": {
    "city": "JEVARGI",
    "state": "KARNATAKA"
  },
  "585363": {
    "city": "HALLIKHEDA",
    "state": "KARNATAKA"
  },
  "585364": {
    "city": "HALLIKHEDA",
    "state": "KARNATAKA"
  },
  "585365": {
    "city": "WADI",
    "state": "KARNATAKA"
  },
  "585366": {
    "city": "JEVARGI",
    "state": "KARNATAKA"
  },
  "585367": {
    "city": "Kalaburagi",
    "state": "Karnataka"
  },
  "585369": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585370": {
    "city": "JEVARGI",
    "state": "KARNATAKA"
  },
  "585371": {
    "city": "WADI",
    "state": "KARNATAKA"
  },
  "585372": {
    "city": "CHINCHOLI",
    "state": "KARNATAKA"
  },
  "585373": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585374": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585375": {
    "city": "SHAHAPUR",
    "state": "KARNATAKA"
  },
  "585377": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585378": {
    "city": "ALAND",
    "state": "KARNATAKA"
  },
  "585401": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585402": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585403": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585411": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585412": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585413": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585414": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585415": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585416": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585417": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585418": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585419": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585421": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585422": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585423": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585424": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585425": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585426": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585427": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585428": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585429": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585430": {
    "city": "BHALKI",
    "state": "KARNATAKA"
  },
  "585431": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585432": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585433": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585434": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585435": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585436": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585437": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585438": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585439": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585440": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585441": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585442": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585443": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585444": {
    "city": "Bidar",
    "state": "Karnataka"
  },
  "585603": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "585802": {
    "city": "BIDAR",
    "state": "KARNATAKA"
  },
  "586101": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586102": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586103": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586104": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586105": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586106": {
    "city": "BIJAPUR",
    "state": "KARNATAKA"
  },
  "586107": {
    "city": "BIJAPUR",
    "state": "KARNATAKA"
  },
  "586108": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586109": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586111": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586112": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586113": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "586114": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586115": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586116": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586117": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586118": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586119": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586120": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586121": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586122": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586123": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586124": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586125": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "586126": {
    "city": "JAMKHANDI",
    "state": "KARNATAKA"
  },
  "586127": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586128": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586129": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586130": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586131": {
    "city": "BIJAPUR",
    "state": "KARNATAKA"
  },
  "586132": {
    "city": "BIJAPUR",
    "state": "KARNATAKA"
  },
  "586133": {
    "city": "BIJAPUR",
    "state": "KARNATAKA"
  },
  "586134": {
    "city": "BIJAPUR",
    "state": "KARNATAKA"
  },
  "586135": {
    "city": "BIJAPUR",
    "state": "KARNATAKA"
  },
  "586136": {
    "city": "BIJAPUR",
    "state": "KARNATAKA"
  },
  "586137": {
    "city": "BIJAPUR",
    "state": "KARNATAKA"
  },
  "586138": {
    "city": "BIJAPUR",
    "state": "KARNATAKA"
  },
  "586139": {
    "city": "JAMKHANDI",
    "state": "KARNATAKA"
  },
  "586140": {
    "city": "JAMKHANDI",
    "state": "KARNATAKA"
  },
  "586141": {
    "city": "KOLHAR",
    "state": "KARNATAKA"
  },
  "586142": {
    "city": "SINDAGI",
    "state": "KARNATAKA"
  },
  "586143": {
    "city": "SINDAGI",
    "state": "KARNATAKA"
  },
  "586144": {
    "city": "SINDAGI",
    "state": "KARNATAKA"
  },
  "586145": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "586146": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "586147": {
    "city": "INDI",
    "state": "KARNATAKA"
  },
  "586148": {
    "city": "BIJAPUR",
    "state": "KARNATAKA"
  },
  "586149": {
    "city": "KOLHAR",
    "state": "KARNATAKA"
  },
  "586150": {
    "city": "KOLHAR",
    "state": "KARNATAKA"
  },
  "586151": {
    "city": "BIJAPUR",
    "state": "KARNATAKA"
  },
  "586152": {
    "city": "BASAVANA BAGEWADI",
    "state": "KARNATAKA"
  },
  "586153": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586154": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "586155": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "586156": {
    "city": "SINDAGI",
    "state": "KARNATAKA"
  },
  "586157": {
    "city": "SINDAGI",
    "state": "KARNATAKA"
  },
  "586158": {
    "city": "SINDAGI",
    "state": "KARNATAKA"
  },
  "586159": {
    "city": "SINDAGI",
    "state": "KARNATAKA"
  },
  "586160": {
    "city": "JAMKHANDI",
    "state": "KARNATAKA"
  },
  "586161": {
    "city": "INDI",
    "state": "KARNATAKA"
  },
  "586162": {
    "city": "INDI",
    "state": "KARNATAKA"
  },
  "586163": {
    "city": "SINDAGI",
    "state": "KARNATAKA"
  },
  "586164": {
    "city": "SINDAGI",
    "state": "KARNATAKA"
  },
  "586165": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586166": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586168": {
    "city": "SINDAGI",
    "state": "KARNATAKA"
  },
  "586169": {
    "city": "SINDAGI",
    "state": "KARNATAKA"
  },
  "586201": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586202": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586203": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586204": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586205": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586206": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586207": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586208": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586209": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586210": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586211": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586212": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586213": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586214": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586215": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586216": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586217": {
    "city": "Vijayapura",
    "state": "Karnataka"
  },
  "586218": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586219": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586220": {
    "city": "SINDAGI",
    "state": "KARNATAKA"
  },
  "586221": {
    "city": "KOLHAR",
    "state": "KARNATAKA"
  },
  "586222": {
    "city": "INDI",
    "state": "KARNATAKA"
  },
  "586223": {
    "city": "INDI",
    "state": "KARNATAKA"
  },
  "586224": {
    "city": "INDI",
    "state": "KARNATAKA"
  },
  "586225": {
    "city": "INDI",
    "state": "KARNATAKA"
  },
  "586226": {
    "city": "INDI",
    "state": "KARNATAKA"
  },
  "586227": {
    "city": "INDI",
    "state": "KARNATAKA"
  },
  "586228": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586229": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586230": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586231": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586232": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586233": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586234": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586235": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586236": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586237": {
    "city": "INDI",
    "state": "KARNATAKA"
  },
  "586238": {
    "city": "INDI",
    "state": "KARNATAKA"
  },
  "586239": {
    "city": "BASAVANA BAGEWADI",
    "state": "KARNATAKA"
  },
  "586241": {
    "city": "BASAVANA BAGEWADI",
    "state": "KARNATAKA"
  },
  "586242": {
    "city": "INDI",
    "state": "KARNATAKA"
  },
  "586243": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586244": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586245": {
    "city": "MUDDEBIHAL",
    "state": "KARNATAKA"
  },
  "586246": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "586247": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "587101": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587102": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587103": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587104": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587111": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587112": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587113": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587114": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587115": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587116": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587117": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587118": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587119": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587120": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587121": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587122": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587123": {
    "city": "BADAMI",
    "state": "KARNATAKA"
  },
  "587124": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587125": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587126": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "587127": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "587128": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "587129": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "587130": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "587131": {
    "city": "RAICHUR",
    "state": "KARNATAKA"
  },
  "587132": {
    "city": "RAICHUR",
    "state": "KARNATAKA"
  },
  "587133": {
    "city": "RAICHUR",
    "state": "KARNATAKA"
  },
  "587134": {
    "city": "MUDHOL",
    "state": "KARNATAKA"
  },
  "587135": {
    "city": "JAMKHANDI",
    "state": "KARNATAKA"
  },
  "587136": {
    "city": "MUDHOL",
    "state": "KARNATAKA"
  },
  "587137": {
    "city": "MUDHOL",
    "state": "KARNATAKA"
  },
  "587138": {
    "city": "BADAMI",
    "state": "KARNATAKA"
  },
  "587139": {
    "city": "BADAMI",
    "state": "KARNATAKA"
  },
  "587140": {
    "city": "BADAMI",
    "state": "KARNATAKA"
  },
  "587141": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "587142": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "587143": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "587144": {
    "city": "BADAMI",
    "state": "KARNATAKA"
  },
  "587145": {
    "city": "ILKAL",
    "state": "KARNATAKA"
  },
  "587146": {
    "city": "ILKAL",
    "state": "KARNATAKA"
  },
  "587147": {
    "city": "ILKAL",
    "state": "KARNATAKA"
  },
  "587148": {
    "city": "ILKAL",
    "state": "KARNATAKA"
  },
  "587149": {
    "city": "BADAMI",
    "state": "KARNATAKA"
  },
  "587151": {
    "city": "ILKAL",
    "state": "KARNATAKA"
  },
  "587152": {
    "city": "BADAMI",
    "state": "KARNATAKA"
  },
  "587153": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "587154": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587155": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587201": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587202": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587203": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587204": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587205": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587206": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587207": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587208": {
    "city": "BADAMI",
    "state": "KARNATAKA"
  },
  "587209": {
    "city": "BADAMI",
    "state": "KARNATAKA"
  },
  "587210": {
    "city": "BADAMI",
    "state": "KARNATAKA"
  },
  "587211": {
    "city": "BADAMI",
    "state": "KARNATAKA"
  },
  "587212": {
    "city": "BADAMI",
    "state": "KARNATAKA"
  },
  "587213": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "587214": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "587215": {
    "city": "BAGALKOT",
    "state": "KARNATAKA"
  },
  "587242": {
    "city": "BADAMI",
    "state": "KARNATAKA"
  },
  "587301": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587302": {
    "city": "JAMKHANDI",
    "state": "KARNATAKA"
  },
  "587311": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587312": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587313": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587314": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587315": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587316": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "587317": {
    "city": "MUDHOL",
    "state": "KARNATAKA"
  },
  "587318": {
    "city": "SINDAGI",
    "state": "KARNATAKA"
  },
  "587319": {
    "city": "MUDHOL",
    "state": "KARNATAKA"
  },
  "587320": {
    "city": "MUDHOL",
    "state": "KARNATAKA"
  },
  "587321": {
    "city": "JAMKHANDI",
    "state": "KARNATAKA"
  },
  "587322": {
    "city": "KOLHAR",
    "state": "KARNATAKA"
  },
  "587323": {
    "city": "KOLHAR",
    "state": "KARNATAKA"
  },
  "587324": {
    "city": "MUDHOL",
    "state": "KARNATAKA"
  },
  "587325": {
    "city": "MUDHOL",
    "state": "KARNATAKA"
  },
  "587326": {
    "city": "JAMKHANDI",
    "state": "KARNATAKA"
  },
  "587327": {
    "city": "JAMKHANDI",
    "state": "KARNATAKA"
  },
  "587328": {
    "city": "MUDHOL",
    "state": "KARNATAKA"
  },
  "587329": {
    "city": "JAMKHANDI",
    "state": "KARNATAKA"
  },
  "587330": {
    "city": "Bagalkot",
    "state": "Karnataka"
  },
  "590000": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "590001": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590002": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "590003": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590004": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "590005": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590006": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590007": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "590008": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590009": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590010": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590011": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590012": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "590013": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "590014": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590015": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590016": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590017": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590018": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590019": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590020": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "590543": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591101": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591102": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591103": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591104": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591105": {
    "city": "KITTUR",
    "state": "KARNATAKA"
  },
  "591106": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591107": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591108": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591109": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591110": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591111": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591112": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591113": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591114": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591115": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591116": {
    "city": "SAUNDATTI",
    "state": "KARNATAKA"
  },
  "591117": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591118": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591119": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591120": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591121": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591122": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591123": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591124": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591125": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591126": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591127": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591128": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591129": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591130": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591131": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591132": {
    "city": "KITTUR",
    "state": "KARNATAKA"
  },
  "591133": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591134": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591135": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591136": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591137": {
    "city": "KITTUR",
    "state": "KARNATAKA"
  },
  "591138": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591139": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591140": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591141": {
    "city": "KITTUR",
    "state": "KARNATAKA"
  },
  "591142": {
    "city": "KITTUR",
    "state": "KARNATAKA"
  },
  "591143": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591144": {
    "city": "KITTUR",
    "state": "KARNATAKA"
  },
  "591145": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591146": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591147": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591148": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591149": {
    "city": "JAMKHANDI",
    "state": "KARNATAKA"
  },
  "591150": {
    "city": "JAMKHANDI",
    "state": "KARNATAKA"
  },
  "591151": {
    "city": "MUDHOL",
    "state": "KARNATAKA"
  },
  "591152": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591153": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591154": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "591155": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "591156": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591157": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591158": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "591159": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "591160": {
    "city": "MUDHOL",
    "state": "KARNATAKA"
  },
  "591161": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591162": {
    "city": "SAUNDATTI",
    "state": "KARNATAKA"
  },
  "591163": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591164": {
    "city": "KITTUR",
    "state": "KARNATAKA"
  },
  "591167": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591168": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "591169": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591170": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591171": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591173": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591175": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591176": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591177": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591178": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591180": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591181": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591182": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591183": {
    "city": "SAUNDATTI",
    "state": "KARNATAKA"
  },
  "591184": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591185": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591186": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591187": {
    "city": "MUDHOL",
    "state": "KARNATAKA"
  },
  "591188": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591189": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591190": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591191": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591192": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591193": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591194": {
    "city": "KITTUR",
    "state": "KARNATAKA"
  },
  "591195": {
    "city": "KITTUR",
    "state": "KARNATAKA"
  },
  "591196": {
    "city": "SAUNDATTI",
    "state": "KARNATAKA"
  },
  "591197": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591198": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591201": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591211": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591212": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591213": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591214": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591215": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591216": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591217": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591218": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591219": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591220": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591221": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591222": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591223": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591224": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591225": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591226": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591227": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591228": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591229": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591230": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591231": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591232": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591233": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591234": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591235": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591236": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591237": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591238": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591239": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591240": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591241": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591242": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591243": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591244": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591245": {
    "city": "HUKERI",
    "state": "KARNATAKA"
  },
  "591246": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591247": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591248": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591249": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591250": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591251": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591252": {
    "city": "HUKERI",
    "state": "KARNATAKA"
  },
  "591253": {
    "city": "HUKERI",
    "state": "KARNATAKA"
  },
  "591254": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591255": {
    "city": "HUKERI",
    "state": "KARNATAKA"
  },
  "591256": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591257": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591258": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591259": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591260": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591261": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591262": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591263": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591264": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591265": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591266": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591267": {
    "city": "NIPANI",
    "state": "KARNATAKA"
  },
  "591268": {
    "city": "HUKERI",
    "state": "KARNATAKA"
  },
  "591269": {
    "city": "NIPANI",
    "state": "KARNATAKA"
  },
  "591270": {
    "city": "RAIBAG",
    "state": "KARNATAKA"
  },
  "591271": {
    "city": "RAIBAG",
    "state": "KARNATAKA"
  },
  "591272": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591273": {
    "city": "RAIBAG",
    "state": "KARNATAKA"
  },
  "591274": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591275": {
    "city": "NIPANI",
    "state": "KARNATAKA"
  },
  "591276": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591278": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591279": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591280": {
    "city": "NIPANI",
    "state": "KARNATAKA"
  },
  "591281": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591282": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591283": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591284": {
    "city": "NIPANI",
    "state": "KARNATAKA"
  },
  "591285": {
    "city": "NIPANI",
    "state": "KARNATAKA"
  },
  "591286": {
    "city": "HUKERI",
    "state": "KARNATAKA"
  },
  "591287": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591288": {
    "city": "NIPANI",
    "state": "KARNATAKA"
  },
  "591289": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591290": {
    "city": "NIPANI",
    "state": "KARNATAKA"
  },
  "591291": {
    "city": "HUKERI",
    "state": "KARNATAKA"
  },
  "591292": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591293": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591295": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591296": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591297": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591298": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591299": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591301": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591302": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591303": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591304": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591305": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591306": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591307": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591308": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591309": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591310": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591311": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591312": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591313": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591314": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591315": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591316": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591317": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591318": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591319": {
    "city": "RAIBAG",
    "state": "KARNATAKA"
  },
  "591320": {
    "city": "RAIBAG",
    "state": "KARNATAKA"
  },
  "591321": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591322": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591323": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591324": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591327": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591328": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591329": {
    "city": "RAIBAG",
    "state": "KARNATAKA"
  },
  "591330": {
    "city": "RAIBAG",
    "state": "KARNATAKA"
  },
  "591331": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591332": {
    "city": "RAIBAG",
    "state": "KARNATAKA"
  },
  "591333": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591334": {
    "city": "HUKERI",
    "state": "KARNATAKA"
  },
  "591337": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591338": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591339": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591340": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591341": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591342": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591343": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591344": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591345": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591346": {
    "city": "Belagavi",
    "state": "Karnataka"
  },
  "591501": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591502": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591503": {
    "city": "ATHANI",
    "state": "KARNATAKA"
  },
  "591504": {
    "city": "SAUNDATTI",
    "state": "KARNATAKA"
  },
  "591505": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591506": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591507": {
    "city": "NIPANI",
    "state": "KARNATAKA"
  },
  "591508": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591509": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591510": {
    "city": "HUKERI",
    "state": "KARNATAKA"
  },
  "591511": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591512": {
    "city": "CHIKODI",
    "state": "KARNATAKA"
  },
  "591513": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591514": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591515": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591516": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591517": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "591701": {
    "city": "BAILHONGAL",
    "state": "KARNATAKA"
  },
  "591702": {
    "city": "BELGAUM",
    "state": "KARNATAKA"
  },
  "591703": {
    "city": "NARGUND",
    "state": "KARNATAKA"
  },
  "591802": {
    "city": "SAUNDATTI",
    "state": "KARNATAKA"
  },
  "592236": {
    "city": "GOKAK",
    "state": "KARNATAKA"
  },
  "599991": {
    "city": "HYDERABAD",
    "state": "TELANGANA"
  },
  "600000": {
    "city": "MADRAS REGIONAL OFFICE",
    "state": "TAMIL NADU"
  },
  "600001": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600002": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600003": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600004": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600005": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600006": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600007": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600008": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600009": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600010": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600011": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600012": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600013": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600014": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600015": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600016": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600017": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600018": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600019": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600020": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600021": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600022": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600023": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600024": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600025": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600026": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600027": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "600028": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600029": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "600030": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600031": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600032": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600033": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600034": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600035": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600036": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600037": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600038": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600039": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600040": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600041": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600042": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600043": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600044": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600045": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600046": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600047": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600048": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600049": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600050": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600051": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600052": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600053": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600054": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600055": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600056": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600057": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600058": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600059": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600060": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600061": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600062": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600063": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600064": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600065": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "600066": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600067": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600068": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600069": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600070": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600071": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600072": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600073": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600074": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600075": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600076": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600077": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600078": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600079": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "600080": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "600081": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600082": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600083": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600084": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600085": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600086": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600087": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600088": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600089": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600090": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600091": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600092": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600093": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600094": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600095": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600096": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600097": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600098": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "600099": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600100": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600101": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600102": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600103": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600104": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600105": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "600106": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600107": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600108": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "600109": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "600110": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600111": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "600112": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "600113": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600114": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "600115": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600116": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600117": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600118": {
    "city": "Chennai",
    "state": "Tamil Nadu"
  },
  "600119": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600120": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600121": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "600122": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600123": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600124": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600125": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600126": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600127": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600128": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "600129": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600130": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600131": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600132": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "600222": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "601016": {
    "city": "Kollam",
    "state": "KERALA"
  },
  "601101": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "601102": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "601103": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "601104": {
    "city": "REDHILLS",
    "state": "TAMIL NADU"
  },
  "601105": {
    "city": "REDHILLS",
    "state": "TAMIL NADU"
  },
  "601201": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "601202": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "601203": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "601204": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "601205": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "601206": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "601207": {
    "city": "GUMMUDIPOONDI",
    "state": "TAMIL NADU"
  },
  "601208": {
    "city": "REDHILLS",
    "state": "TAMIL NADU"
  },
  "601209": {
    "city": "REDHILLS",
    "state": "TAMIL NADU"
  },
  "601210": {
    "city": "REDHILLS",
    "state": "TAMIL NADU"
  },
  "601211": {
    "city": "REDHILLS",
    "state": "TAMIL NADU"
  },
  "601212": {
    "city": "REDHILLS",
    "state": "TAMIL NADU"
  },
  "601213": {
    "city": "REDHILLS",
    "state": "TAMIL NADU"
  },
  "601214": {
    "city": "REDHILLS",
    "state": "TAMIL NADU"
  },
  "601295": {
    "city": "REDHILLS",
    "state": "TAMIL NADU"
  },
  "601301": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "601302": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "601303": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "601304": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "602001": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "602002": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "602003": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "602004": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "602021": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "602022": {
    "city": "UTHUKOTTAI",
    "state": "TAMIL NADU"
  },
  "602023": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "602024": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "602025": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "602026": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "602027": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "602028": {
    "city": "UTHUKOTTAI",
    "state": "TAMIL NADU"
  },
  "602029": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "602030": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "602031": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "602101": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "602102": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "602103": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "602104": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "602105": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "602106": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "602107": {
    "city": "CHENGALPATTU",
    "state": "TAMIL NADU"
  },
  "602108": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "602109": {
    "city": "SRIPERUMBUDUR",
    "state": "TAMIL NADU"
  },
  "602111": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "602112": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "602113": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "602114": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "602115": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "602116": {
    "city": "SRIPERUMBUDUR",
    "state": "TAMIL NADU"
  },
  "602117": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603001": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603002": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603003": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603004": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603011": {
    "city": "CHENGALPATTU",
    "state": "TAMIL NADU"
  },
  "603101": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603102": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603103": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603104": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603105": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603106": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603107": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603108": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603109": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603110": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603111": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603112": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603113": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "603114": {
    "city": "ARAKKONAM",
    "state": "TAMIL NADU"
  },
  "603115": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "603116": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "603117": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "603118": {
    "city": "KANCHIPURAM",
    "state": "TAMIL NADU"
  },
  "603119": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "603120": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "603121": {
    "city": "KALPAKKAM",
    "state": "TAMIL NADU"
  },
  "603122": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "603127": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603201": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603202": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603203": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603204": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603209": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603210": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603211": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603301": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603302": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603303": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603304": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603305": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603306": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603307": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603308": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603309": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603310": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603311": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603312": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603313": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603314": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603315": {
    "city": "MADURANTHAKAM",
    "state": "TAMIL NADU"
  },
  "603316": {
    "city": "MADURANTHAKAM",
    "state": "TAMIL NADU"
  },
  "603317": {
    "city": "KALPAKKAM",
    "state": "TAMIL NADU"
  },
  "603318": {
    "city": "KANCHIPURAM",
    "state": "TAMIL NADU"
  },
  "603319": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603320": {
    "city": "TINDIVANAM",
    "state": "TAMIL NADU"
  },
  "603401": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603402": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603403": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603404": {
    "city": "MADURANTHAKAM",
    "state": "TAMIL NADU"
  },
  "603405": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603406": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "603407": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "603408": {
    "city": "TIRUVALLUR",
    "state": "TAMIL NADU"
  },
  "604001": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604002": {
    "city": "TINDIVANAM",
    "state": "TAMIL NADU"
  },
  "604101": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604102": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604103": {
    "city": "TINDIVANAM",
    "state": "TAMIL NADU"
  },
  "604151": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604152": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604153": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604154": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604155": {
    "city": "GINGEE",
    "state": "TAMIL NADU"
  },
  "604201": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604202": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604203": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604204": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604205": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604206": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604207": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604208": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604210": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604211": {
    "city": "TINDIVANAM",
    "state": "TAMIL NADU"
  },
  "604212": {
    "city": "ARNI",
    "state": "TAMIL NADU"
  },
  "604213": {
    "city": "MUSIRI",
    "state": "TAMIL NADU"
  },
  "604301": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604302": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604303": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604304": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604305": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604306": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604307": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "604401": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604402": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604403": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604404": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604405": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604406": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604407": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604408": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604409": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604410": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604412": {
    "city": "MADURANTHAKAM",
    "state": "TAMIL NADU"
  },
  "604413": {
    "city": "MADURANTHAKAM",
    "state": "TAMIL NADU"
  },
  "604414": {
    "city": "MADURANTHAKAM",
    "state": "TAMIL NADU"
  },
  "604501": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604502": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604503": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604504": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604505": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604601": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "604914": {
    "city": "CHIDAMBARAM",
    "state": "TAMIL NADU"
  },
  "605001": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605002": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605003": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605004": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605005": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605006": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605007": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "605008": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605009": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605010": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605011": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605012": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605013": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605014": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605051": {
    "city": "VELLORE",
    "state": "TAMIL NADU"
  },
  "605101": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605102": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605103": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605104": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605105": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605106": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605107": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605108": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605109": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605110": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605111": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605113": {
    "city": "VELLORE",
    "state": "TAMIL NADU"
  },
  "605116": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605118": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605201": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605202": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605203": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605301": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605302": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605401": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605402": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605501": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605502": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605503": {
    "city": "PONDICHERRY",
    "state": "PONDICHERRY"
  },
  "605601": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605602": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605604": {
    "city": "VILLUPURAM",
    "state": "TAMIL NADU"
  },
  "605605": {
    "city": "VILLUPURAM",
    "state": "TAMIL NADU"
  },
  "605606": {
    "city": "VILLUPURAM",
    "state": "TAMIL NADU"
  },
  "605651": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605652": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605655": {
    "city": "VILLUPURAM",
    "state": "TAMIL NADU"
  },
  "605701": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605702": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605751": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605752": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605753": {
    "city": "GINGEE",
    "state": "TAMIL NADU"
  },
  "605754": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605755": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605756": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605757": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605758": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605759": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605766": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605801": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605802": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605803": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "605805": {
    "city": "TIRUKOVILUR",
    "state": "TAMIL NADU"
  },
  "605809": {
    "city": "GHENGAM",
    "state": "TAMIL NADU"
  },
  "606001": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "606002": {
    "city": "VRIDDHACHALAM",
    "state": "TAMIL NADU"
  },
  "606003": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "606102": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606103": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "606104": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "606105": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "606106": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "606107": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606108": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "606109": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "606110": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "606111": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "606112": {
    "city": "VRIDDHACHALAM",
    "state": "TAMIL NADU"
  },
  "606115": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606120": {
    "city": "ULUNDURPET",
    "state": "TAMIL NADU"
  },
  "606123": {
    "city": "KALLAKURICHI",
    "state": "TAMIL NADU"
  },
  "606201": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606202": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606203": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606204": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606205": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606206": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606207": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606208": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606209": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606213": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606221": {
    "city": "KALLAKURICHI",
    "state": "TAMIL NADU"
  },
  "606223": {
    "city": "MADURANTHAKAM",
    "state": "TAMIL NADU"
  },
  "606301": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606302": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "606303": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "606304": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "606305": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606306": {
    "city": "ULUNDURPET",
    "state": "TAMIL NADU"
  },
  "606307": {
    "city": "ULUNDURPET",
    "state": "TAMIL NADU"
  },
  "606401": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606402": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "606601": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606602": {
    "city": "THIRUVANNAMALAI",
    "state": "TAMIL NADU"
  },
  "606603": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606604": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606611": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606701": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606702": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606703": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606704": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606705": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606706": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606707": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606708": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606709": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606710": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606711": {
    "city": "GHENGAM",
    "state": "TAMIL NADU"
  },
  "606712": {
    "city": "TIRUVANNAMALAI",
    "state": "TAMIL NADU"
  },
  "606713": {
    "city": "GHENGAM",
    "state": "TAMIL NADU"
  },
  "606714": {
    "city": "TIRUVANNAMALAI",
    "state": "TAMIL NADU"
  },
  "606715": {
    "city": "GHENGAM",
    "state": "TAMIL NADU"
  },
  "606716": {
    "city": "GHENGAM",
    "state": "TAMIL NADU"
  },
  "606717": {
    "city": "TIRUVANNAMALAI",
    "state": "TAMIL NADU"
  },
  "606718": {
    "city": "VILLUPURAM",
    "state": "TAMIL NADU"
  },
  "606751": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606752": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606753": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606754": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606755": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606801": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606802": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606803": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606804": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606805": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606806": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606807": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606808": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606809": {
    "city": "TIRUVANNAMALAI",
    "state": "TAMIL NADU"
  },
  "606810": {
    "city": "CHIDAMBARAM",
    "state": "TAMIL NADU"
  },
  "606811": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606901": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606902": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606903": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606904": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606905": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606906": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606907": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606908": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "606909": {
    "city": "TIRUVANNAMALAI",
    "state": "TAMIL NADU"
  },
  "606910": {
    "city": "GHENGAM",
    "state": "TAMIL NADU"
  },
  "606911": {
    "city": "VILLUPURAM",
    "state": "TAMIL NADU"
  },
  "606912": {
    "city": "TIRUVANNAMALAI",
    "state": "TAMIL NADU"
  },
  "606914": {
    "city": "CUDDALORE",
    "state": "TAMIL NADU"
  },
  "606915": {
    "city": "TINDIVANAM",
    "state": "TAMIL NADU"
  },
  "607001": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607002": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607003": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607004": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607005": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607006": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607051": {
    "city": "CUDDALORE",
    "state": "TAMIL NADU"
  },
  "607101": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "607102": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607103": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607104": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607105": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607106": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607107": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "607108": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607109": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607110": {
    "city": "CUDDALORE",
    "state": "TAMIL NADU"
  },
  "607111": {
    "city": "CUDDALORE",
    "state": "TAMIL NADU"
  },
  "607112": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607113": {
    "city": "CUDDALORE",
    "state": "TAMIL NADU"
  },
  "607116": {
    "city": "VILLUPURAM",
    "state": "TAMIL NADU"
  },
  "607201": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "607202": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "607203": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "607204": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "607205": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607207": {
    "city": "ULUNDURPET",
    "state": "TAMIL NADU"
  },
  "607209": {
    "city": "Villupuram",
    "state": "Tamil Nadu"
  },
  "607301": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607302": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607303": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607305": {
    "city": "NEYVELI",
    "state": "TAMIL NADU"
  },
  "607307": {
    "city": "CUDDALORE",
    "state": "TAMIL NADU"
  },
  "607308": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607401": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607402": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607403": {
    "city": "CUDDALORE",
    "state": "PONDICHERRY"
  },
  "607404": {
    "city": "CUDDALORE",
    "state": "TAMIL NADU"
  },
  "607801": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607802": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607803": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607804": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607805": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "607807": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608001": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608002": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608102": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608201": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608301": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608302": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608303": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608304": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608305": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608306": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608401": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608402": {
    "city": "KARUNAPURAM",
    "state": "TAMIL NADU"
  },
  "608501": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608502": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608601": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608602": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608701": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608702": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608703": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608704": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608801": {
    "city": "Cuddalore",
    "state": "Tamil Nadu"
  },
  "608803": {
    "city": "CHIDAMBARAM",
    "state": "TAMIL NADU"
  },
  "608804": {
    "city": "CHIDAMBARAM",
    "state": "TAMIL NADU"
  },
  "608901": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "609001": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609002": {
    "city": "MAYILADUTHURAI",
    "state": "TAMIL NADU"
  },
  "609003": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609101": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609102": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609103": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609104": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609105": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609106": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609107": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609108": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609109": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609110": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609111": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609112": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609113": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609114": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609115": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609116": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609117": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609118": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609119": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609120": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609121": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609122": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609123": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609124": {
    "city": "CUDDALORE",
    "state": "TAMIL NADU"
  },
  "609125": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609126": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609127": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609128": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609129": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609130": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609131": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609201": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609202": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609203": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609204": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609205": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609301": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609302": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609303": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609304": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609305": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609306": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609307": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609308": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609309": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609310": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609311": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609312": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609313": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609314": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609401": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609402": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609403": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "609404": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609405": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "609406": {
    "city": "MAYILADUTHURAI",
    "state": "TAMIL NADU"
  },
  "609501": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609502": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "609503": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "609504": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609505": {
    "city": "NAGAPATTINAM",
    "state": "TAMIL NADU"
  },
  "609506": {
    "city": "MAYILADUTHURAI",
    "state": "TAMIL NADU"
  },
  "609507": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609508": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609601": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609602": {
    "city": "KARAIKAL",
    "state": "PONDICHERRY"
  },
  "609603": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "609604": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609605": {
    "city": "KARAIKAL",
    "state": "PONDICHERRY"
  },
  "609606": {
    "city": "KARAIKAL",
    "state": "PONDICHERRY"
  },
  "609607": {
    "city": "KARAIKAL",
    "state": "PONDICHERRY"
  },
  "609608": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "609609": {
    "city": "KARAIKAL",
    "state": "PONDICHERRY"
  },
  "609610": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "609701": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609702": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609703": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609704": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609705": {
    "city": "KARAIKAL",
    "state": "PONDICHERRY"
  },
  "609801": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609802": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609803": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609804": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609805": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609806": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609807": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609808": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609809": {
    "city": "MAYILADUTHURAI",
    "state": "TAMIL NADU"
  },
  "609810": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609811": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "609812": {
    "city": "MAYILADUTHURAI",
    "state": "TAMIL NADU"
  },
  "609813": {
    "city": "MAYILADUTHURAI",
    "state": "TAMIL NADU"
  },
  "609814": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "610001": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610002": {
    "city": "TIRUVARUR",
    "state": "TAMIL NADU"
  },
  "610003": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610004": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610005": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610051": {
    "city": "TIRUVARUR",
    "state": "TAMIL NADU"
  },
  "610101": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "610102": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610103": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610104": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610105": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610106": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610107": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610109": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610110": {
    "city": "THIRUVARUR",
    "state": "TAMIL NADU"
  },
  "610111": {
    "city": "THIRUVARUR",
    "state": "TAMIL NADU"
  },
  "610112": {
    "city": "THIRUVARUR",
    "state": "TAMIL NADU"
  },
  "610113": {
    "city": "THIRUVARUR",
    "state": "TAMIL NADU"
  },
  "610114": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "610115": {
    "city": "THIRUVARUR",
    "state": "TAMIL NADU"
  },
  "610116": {
    "city": "THIRUVARUR",
    "state": "TAMIL NADU"
  },
  "610201": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610202": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610203": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610204": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "610205": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610206": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "610207": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "610208": {
    "city": "THIRUVARUR",
    "state": "TAMIL NADU"
  },
  "610209": {
    "city": "THIRUVARUR",
    "state": "TAMIL NADU"
  },
  "610210": {
    "city": "THIRUVARUR",
    "state": "TAMIL NADU"
  },
  "610211": {
    "city": "THIRUVARUR",
    "state": "TAMIL NADU"
  },
  "610212": {
    "city": "SIRKAALI",
    "state": "TAMIL NADU"
  },
  "611001": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "611002": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "611003": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "611006": {
    "city": "KARAIKAL",
    "state": "TAMIL NADU"
  },
  "611008": {
    "city": "KARAIKAL",
    "state": "TAMIL NADU"
  },
  "611101": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "611102": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "611103": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "611104": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "611105": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "611106": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "611108": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "611109": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "611110": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "611111": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "611112": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "611113": {
    "city": "NAGAPATTINAM",
    "state": "TAMIL NADU"
  },
  "611114": {
    "city": "NAGAPATTINAM",
    "state": "TAMIL NADU"
  },
  "611115": {
    "city": "NAGAPATTINAM",
    "state": "TAMIL NADU"
  },
  "611116": {
    "city": "NAGAPATTINAM",
    "state": "TAMIL NADU"
  },
  "611117": {
    "city": "THIRUVARUR",
    "state": "TAMIL NADU"
  },
  "611119": {
    "city": "NAGAPATTINAM",
    "state": "TAMIL NADU"
  },
  "612001": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612002": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612101": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612102": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "612103": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612104": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612105": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612106": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612107": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "612108": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612109": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612110": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612201": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "612202": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612203": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "612204": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612205": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612206": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612301": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612302": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612303": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612304": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612401": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612402": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612501": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612502": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612503": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612504": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612505": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612506": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612601": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "612602": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612603": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "612604": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "612605": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "612606": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612607": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612608": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612609": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612610": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "612701": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "612702": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612703": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "612704": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612801": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "612802": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "612803": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "612804": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "612805": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612806": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612807": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "612901": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "612902": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "612903": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "612904": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "612905": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "613001": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613002": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613003": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613004": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613005": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613006": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613007": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613008": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613009": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613010": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613051": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613052": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613053": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613054": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613101": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613102": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613103": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613104": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613105": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613106": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613107": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613108": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613109": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613110": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613201": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613202": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613203": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613204": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613205": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613206": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613207": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613301": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "613302": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613303": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613304": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613305": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613307": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613308": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613401": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613402": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613403": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613406": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613501": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613502": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613503": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613504": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613505": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613506": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613601": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613602": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "613603": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613701": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "613702": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "613703": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "613704": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "613705": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "613706": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "613707": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "614001": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614010": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614012": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614013": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614014": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614015": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614016": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614017": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614018": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614019": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614020": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614021": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614022": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614023": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614024": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614025": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614026": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614027": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614028": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614029": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614030": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614031": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614101": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614102": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614103": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614201": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614202": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614203": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614204": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614205": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614206": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614207": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614208": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614209": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "614210": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614211": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614212": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614213": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614301": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614302": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614303": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614401": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614402": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614403": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614404": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614405": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614406": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614407": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614601": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614602": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614612": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614613": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614614": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614615": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614616": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "614617": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "614618": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "614619": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "614620": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "614621": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "614622": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "614623": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614624": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "614625": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614626": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614627": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614628": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614629": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "614630": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "614631": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614632": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "614633": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614634": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614635": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614636": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614637": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614638": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614639": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614640": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614641": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614642": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614643": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614644": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614645": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614647": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614701": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614702": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614703": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614704": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614705": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614706": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614707": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "614708": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614709": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614710": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614711": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614712": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "614713": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614714": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "614715": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614716": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614717": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614719": {
    "city": "THIRUVARUR",
    "state": "TAMIL NADU"
  },
  "614720": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614721": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614722": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614723": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614724": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614725": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614726": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614727": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614728": {
    "city": "CUDDALORE",
    "state": "TAMIL NADU"
  },
  "614729": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614730": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614731": {
    "city": "KUMBAKONAM",
    "state": "TAMIL NADU"
  },
  "614732": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614733": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614734": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614735": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614736": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614737": {
    "city": "PATTUKOTTAI",
    "state": "TAMIL NADU"
  },
  "614738": {
    "city": "Tiruvarur",
    "state": "Tamil Nadu"
  },
  "614801": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "614802": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614803": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614804": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614805": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "614806": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "614807": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "614808": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "614809": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "614810": {
    "city": "Nagapattinam",
    "state": "Tamil Nadu"
  },
  "614811": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614812": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614813": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614814": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614815": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614816": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614817": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614818": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614820": {
    "city": "VEDARANYAM",
    "state": "TAMIL NADU"
  },
  "614821": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614822": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614901": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614902": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614903": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614904": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614905": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614906": {
    "city": "Thanjavur",
    "state": "Tamil Nadu"
  },
  "614908": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614909": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614910": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614911": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614912": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614913": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614914": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "614915": {
    "city": "MANNARGUDI",
    "state": "TAMIL NADU"
  },
  "620001": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620002": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620003": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620004": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620005": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620006": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620007": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620008": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620009": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620010": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620011": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620012": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620013": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620014": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620015": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620016": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620017": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620018": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620019": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620020": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620021": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620022": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620023": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620024": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620025": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620026": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620051": {
    "city": "TIRUCHIRAPALLY",
    "state": "TAMIL NADU"
  },
  "620052": {
    "city": "TIRUCHIRAPALLY",
    "state": "TAMIL NADU"
  },
  "620101": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620102": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "620602": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "621001": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621002": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621003": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621004": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621005": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621006": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621007": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621008": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621009": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621010": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621011": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621012": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621014": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621015": {
    "city": "THURAIYUR",
    "state": "TAMIL NADU"
  },
  "621016": {
    "city": "THURAIYUR",
    "state": "TAMIL NADU"
  },
  "621017": {
    "city": "THURAIYUR",
    "state": "TAMIL NADU"
  },
  "621018": {
    "city": "THURAIYUR",
    "state": "TAMIL NADU"
  },
  "621019": {
    "city": "TIRUCHIRAPALLY",
    "state": "TAMIL NADU"
  },
  "621020": {
    "city": "TIRUCHIRAPALLY",
    "state": "TAMIL NADU"
  },
  "621021": {
    "city": "TIRUCHIRAPALLY",
    "state": "TAMIL NADU"
  },
  "621022": {
    "city": "THURAIYUR",
    "state": "TAMIL NADU"
  },
  "621023": {
    "city": "TIRUCHIRAPALLY",
    "state": "TAMIL NADU"
  },
  "621101": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621102": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621103": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621104": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621105": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621106": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621107": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621108": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621109": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621110": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621111": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621112": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621113": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621114": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621115": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621116": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621117": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621118": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621120": {
    "city": "PERAMBALUR",
    "state": "TAMIL NADU"
  },
  "621121": {
    "city": "PERAMBALUR",
    "state": "TAMIL NADU"
  },
  "621126": {
    "city": "PERAMBALUR",
    "state": "TAMIL NADU"
  },
  "621127": {
    "city": "MANAPPARAI",
    "state": "TAMIL NADU"
  },
  "621128": {
    "city": "PERAMBALUR",
    "state": "TAMIL NADU"
  },
  "621129": {
    "city": "PERAMBALUR",
    "state": "TAMIL NADU"
  },
  "621132": {
    "city": "SRIRANGAM",
    "state": "TAMIL NADU"
  },
  "621133": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621201": {
    "city": "MUSIRI",
    "state": "TAMIL NADU"
  },
  "621202": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621203": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621204": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621205": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621206": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621207": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621208": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621209": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621210": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621211": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621212": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621213": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621214": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621215": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621216": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621217": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621218": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621219": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621220": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621221": {
    "city": "MUSIRI",
    "state": "TAMIL NADU"
  },
  "621224": {
    "city": "MUSIRI",
    "state": "TAMIL NADU"
  },
  "621229": {
    "city": "SRIRANGAM",
    "state": "TAMIL NADU"
  },
  "621301": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "621302": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621303": {
    "city": "MANAPPARAI",
    "state": "TAMIL NADU"
  },
  "621304": {
    "city": "MANAPPARAI",
    "state": "TAMIL NADU"
  },
  "621305": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621306": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621307": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621308": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621309": {
    "city": "THURAIYUR",
    "state": "TAMIL NADU"
  },
  "621310": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621311": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "621312": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621313": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "621314": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621315": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621316": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "621317": {
    "city": "TIRUCHIRAPALLY",
    "state": "TAMIL NADU"
  },
  "621601": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621651": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621652": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621653": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621701": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621702": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621703": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621704": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621705": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621706": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621707": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621708": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621709": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621710": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621711": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621712": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621713": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621714": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621715": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621716": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621717": {
    "city": "Perambalur",
    "state": "Tamil Nadu"
  },
  "621718": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621719": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621722": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "621729": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621730": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621801": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621802": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621803": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621804": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621805": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621806": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621851": {
    "city": "Ariyalur",
    "state": "Tamil Nadu"
  },
  "621853": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "622001": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622002": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622003": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622004": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622005": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622009": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622052": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622053": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622054": {
    "city": "NAGAPATTINAM",
    "state": "TAMIL NADU"
  },
  "622055": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622056": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622101": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622102": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622103": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622104": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622105": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622106": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622107": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622108": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622201": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622202": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622203": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622204": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622205": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622206": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622207": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622208": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622209": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622210": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622211": {
    "city": "ARANTHANGI",
    "state": "TAMIL NADU"
  },
  "622212": {
    "city": "ARANTHANGI",
    "state": "TAMIL NADU"
  },
  "622213": {
    "city": "ARANTHANGI",
    "state": "TAMIL NADU"
  },
  "622301": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622302": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622303": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622304": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622305": {
    "city": "ARANTHANGI",
    "state": "TAMIL NADU"
  },
  "622306": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622307": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622309": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622310": {
    "city": "ARANTHANGI",
    "state": "TAMIL NADU"
  },
  "622311": {
    "city": "ARANTHANGI",
    "state": "TAMIL NADU"
  },
  "622312": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622313": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622314": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622315": {
    "city": "ARANTHANGI",
    "state": "TAMIL NADU"
  },
  "622316": {
    "city": "ARANTHANGI",
    "state": "TAMIL NADU"
  },
  "622317": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622401": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622402": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622403": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622404": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622405": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622406": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622407": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622408": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622409": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622410": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622411": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622412": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622413": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622414": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622415": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622416": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622417": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622419": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622420": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622421": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622422": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622501": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622502": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622503": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622504": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622505": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622506": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622507": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "622508": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622509": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622510": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622511": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622512": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622513": {
    "city": "TIRUCHIRAPALLY",
    "state": "TAMIL NADU"
  },
  "622514": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "622515": {
    "city": "Pudukkottai",
    "state": "Tamil Nadu"
  },
  "623001": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623002": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623003": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623004": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623005": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623006": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623101": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623102": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623103": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623104": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623105": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623106": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623107": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623108": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623109": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623110": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623111": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623115": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623120": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623135": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623201": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623202": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623203": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623204": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623205": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623206": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623207": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623208": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623209": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623210": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623211": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623212": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623213": {
    "city": "SIVAGANGAI",
    "state": "TAMIL NADU"
  },
  "623214": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623215": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623216": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623217": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623301": {
    "city": "DEVAKOTTAI",
    "state": "TAMIL NADU"
  },
  "623302": {
    "city": "DEVAKOTTAI",
    "state": "TAMIL NADU"
  },
  "623303": {
    "city": "DEVAKOTTAI",
    "state": "TAMIL NADU"
  },
  "623304": {
    "city": "SIVAGANGAI",
    "state": "TAMIL NADU"
  },
  "623305": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623306": {
    "city": "DEVAKOTTAI",
    "state": "TAMIL NADU"
  },
  "623307": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623308": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623309": {
    "city": "SIVAGANGAI",
    "state": "TAMIL NADU"
  },
  "623310": {
    "city": "DEVAKOTTAI",
    "state": "TAMIL NADU"
  },
  "623311": {
    "city": "DEVAKOTTAI",
    "state": "TAMIL NADU"
  },
  "623312": {
    "city": "DEVAKOTTAI",
    "state": "TAMIL NADU"
  },
  "623313": {
    "city": "DEVAKOTTAI",
    "state": "TAMIL NADU"
  },
  "623314": {
    "city": "DEVAKOTTAI",
    "state": "TAMIL NADU"
  },
  "623315": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623317": {
    "city": "DEVAKOTTAI",
    "state": "TAMIL NADU"
  },
  "623318": {
    "city": "CUDDALORE",
    "state": "TAMIL NADU"
  },
  "623319": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623320": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623321": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "623401": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623402": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623403": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623404": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623405": {
    "city": "KALAIYARKOVIL",
    "state": "TAMIL NADU"
  },
  "623406": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623407": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623408": {
    "city": "KALAIYARKOVIL",
    "state": "TAMIL NADU"
  },
  "623409": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623410": {
    "city": "THIRUVADANAI",
    "state": "TAMIL NADU"
  },
  "623501": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623502": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623503": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623504": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623512": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623513": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623514": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623515": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623516": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623517": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623518": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623519": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623520": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623521": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623522": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623523": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623524": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623525": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623526": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623527": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623528": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623529": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623530": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623531": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623532": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623533": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623534": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623535": {
    "city": "RAMNAD",
    "state": "TAMIL NADU"
  },
  "623536": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623537": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623538": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623539": {
    "city": "RAMNAD",
    "state": "TAMIL NADU"
  },
  "623543": {
    "city": "RAMNAD",
    "state": "TAMIL NADU"
  },
  "623544": {
    "city": "RAMESHWARAM",
    "state": "TAMIL NADU"
  },
  "623545": {
    "city": "RAMNAD",
    "state": "TAMIL NADU"
  },
  "623546": {
    "city": "RAMNAD",
    "state": "TAMIL NADU"
  },
  "623551": {
    "city": "KALAIYARKOVIL",
    "state": "TAMIL NADU"
  },
  "623552": {
    "city": "KALAIYARKOVIL",
    "state": "TAMIL NADU"
  },
  "623553": {
    "city": "KALAIYARKOVIL",
    "state": "TAMIL NADU"
  },
  "623554": {
    "city": "KALAIYARKOVIL",
    "state": "TAMIL NADU"
  },
  "623555": {
    "city": "RAMNAD",
    "state": "TAMIL NADU"
  },
  "623556": {
    "city": "KALAIYARKOVIL",
    "state": "TAMIL NADU"
  },
  "623557": {
    "city": "SIVAGANGAI",
    "state": "TAMIL NADU"
  },
  "623558": {
    "city": "SIVAGANGAI",
    "state": "TAMIL NADU"
  },
  "623559": {
    "city": "SIVAGANGAI",
    "state": "TAMIL NADU"
  },
  "623560": {
    "city": "SIVAGANGAI",
    "state": "TAMIL NADU"
  },
  "623561": {
    "city": "SIVAGANGAI",
    "state": "TAMIL NADU"
  },
  "623562": {
    "city": "RAMNAD",
    "state": "TAMIL NADU"
  },
  "623565": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "623566": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623601": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623602": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "623603": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623604": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623605": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623606": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "623607": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "623608": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623609": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "623610": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "623611": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "623612": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "623613": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "623617": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "623701": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623702": {
    "city": "PARAMUKUDAI",
    "state": "TAMIL NADU"
  },
  "623703": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623704": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623705": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623706": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623707": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623708": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623709": {
    "city": "PARAMUKUDAI",
    "state": "TAMIL NADU"
  },
  "623710": {
    "city": "PARAMUKUDAI",
    "state": "TAMIL NADU"
  },
  "623711": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623712": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623713": {
    "city": "THIRUVADANAI",
    "state": "TAMIL NADU"
  },
  "623716": {
    "city": "MUDUKULATHUR",
    "state": "TAMIL NADU"
  },
  "623718": {
    "city": "MUDUKULATHUR",
    "state": "TAMIL NADU"
  },
  "623719": {
    "city": "PARAMUKUDAI",
    "state": "TAMIL NADU"
  },
  "623721": {
    "city": "PARAMUKUDAI",
    "state": "TAMIL NADU"
  },
  "623801": {
    "city": "RAMNAD",
    "state": "TAMIL NADU"
  },
  "623802": {
    "city": "RAMNAD",
    "state": "TAMIL NADU"
  },
  "623804": {
    "city": "RAMESHWARAM",
    "state": "TAMIL NADU"
  },
  "623806": {
    "city": "Ramanathapuram",
    "state": "Tamil Nadu"
  },
  "623807": {
    "city": "RAMNAD",
    "state": "TAMIL NADU"
  },
  "624001": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624002": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624003": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624004": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624005": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624006": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624007": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624008": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624009": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624010": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624051": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624052": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624053": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624054": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624101": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624102": {
    "city": "KODAIKANAL",
    "state": "TAMIL NADU"
  },
  "624103": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624104": {
    "city": "KODAIKANAL",
    "state": "TAMIL NADU"
  },
  "624105": {
    "city": "KODAIKANAL",
    "state": "TAMIL NADU"
  },
  "624106": {
    "city": "KODAIKANAL",
    "state": "TAMIL NADU"
  },
  "624107": {
    "city": "KODAIKANAL",
    "state": "TAMIL NADU"
  },
  "624108": {
    "city": "KODAIKANAL",
    "state": "TAMIL NADU"
  },
  "624201": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624202": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624203": {
    "city": "BATLAGUNDU",
    "state": "TAMIL NADU"
  },
  "624204": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624205": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "624206": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624207": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "624208": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624209": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624210": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624211": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624212": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624213": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624214": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "624215": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624216": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624217": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "624218": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "624219": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624220": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624221": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "624222": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "624223": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "624224": {
    "city": "BATLAGUNDU",
    "state": "TAMIL NADU"
  },
  "624225": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "624226": {
    "city": "BATLAGUNDU",
    "state": "TAMIL NADU"
  },
  "624227": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "624228": {
    "city": "BATLAGUNDU",
    "state": "TAMIL NADU"
  },
  "624230": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "624231": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "624232": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "624233": {
    "city": "BATLAGUNDU",
    "state": "TAMIL NADU"
  },
  "624234": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "624235": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "624301": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624302": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624303": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624304": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624305": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624306": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624307": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624308": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624309": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624310": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624311": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624312": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624313": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624314": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624315": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624316": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624317": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624318": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624401": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624402": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624403": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624404": {
    "city": "NATHAM",
    "state": "TAMIL NADU"
  },
  "624405": {
    "city": "NATHAM",
    "state": "TAMIL NADU"
  },
  "624406": {
    "city": "NATHAM",
    "state": "TAMIL NADU"
  },
  "624501": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "624502": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "624503": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "624504": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "624505": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "624506": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "624507": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "624601": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624602": {
    "city": "PALANI",
    "state": "TAMIL NADU"
  },
  "624610": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624611": {
    "city": "PALANI",
    "state": "TAMIL NADU"
  },
  "624612": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624613": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624614": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624615": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624616": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624617": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624618": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624619": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624620": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624621": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624622": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624623": {
    "city": "PALANI",
    "state": "TAMIL NADU"
  },
  "624624": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624625": {
    "city": "DHARAPURAM",
    "state": "TAMIL NADU"
  },
  "624626": {
    "city": "PALANI",
    "state": "TAMIL NADU"
  },
  "624627": {
    "city": "PALANI",
    "state": "TAMIL NADU"
  },
  "624628": {
    "city": "PALANI",
    "state": "TAMIL NADU"
  },
  "624701": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624702": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624703": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624704": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624705": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624706": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624707": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624708": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624709": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624710": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624711": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624712": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624713": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624714": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624715": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624801": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624802": {
    "city": "Dindigul",
    "state": "Tamil Nadu"
  },
  "624803": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "624804": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "625001": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625002": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625003": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625004": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625005": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625006": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625007": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625008": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625009": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625010": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "625011": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625012": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625013": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "625014": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625015": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625016": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625017": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625018": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625019": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625020": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625021": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625022": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625023": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625051": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "625052": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "625101": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625102": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625103": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625104": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625105": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625106": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625107": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625108": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625109": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625110": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625111": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "625112": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625113": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625114": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625115": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "625116": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625117": {
    "city": "BATLAGUNDU",
    "state": "TAMIL NADU"
  },
  "625118": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625119": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625120": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625121": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625122": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625123": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625124": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625125": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625126": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625127": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625201": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625203": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625205": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625206": {
    "city": "DINDIGUL",
    "state": "TAMIL NADU"
  },
  "625207": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625214": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625217": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "625218": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625221": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625234": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625301": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625302": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625303": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625304": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "625305": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "625401": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "625402": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625403": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "625404": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "625501": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625502": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "625503": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625504": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "625512": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625513": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625514": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625515": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625516": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625517": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625518": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625519": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625520": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625521": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625522": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625523": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625524": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625525": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625526": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625527": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625528": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625529": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625530": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625531": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625532": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625533": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625534": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625535": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625536": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625537": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625538": {
    "city": "USILAMPATTI",
    "state": "TAMIL NADU"
  },
  "625539": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "625540": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625541": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "625547": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "625555": {
    "city": "CUMBUM - TN",
    "state": "TAMIL NADU"
  },
  "625556": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625562": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625565": {
    "city": "USILAMPATTI",
    "state": "TAMIL NADU"
  },
  "625566": {
    "city": "USILAMPATTI",
    "state": "TAMIL NADU"
  },
  "625571": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "625572": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "625577": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "625579": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625582": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625601": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625602": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625603": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625604": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625605": {
    "city": "Theni",
    "state": "Tamil Nadu"
  },
  "625701": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625702": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625703": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625704": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625705": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625706": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625707": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625708": {
    "city": "Madurai",
    "state": "Tamil Nadu"
  },
  "625709": {
    "city": "TIRUMANGALAM",
    "state": "TAMIL NADU"
  },
  "626001": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626002": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626003": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626004": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626005": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626008": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626051": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626052": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626053": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626054": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626055": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626056": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626057": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626058": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626059": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626100": {
    "city": "RAJAPALAYAM",
    "state": "TAMIL NADU"
  },
  "626101": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626102": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626103": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626104": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626105": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626106": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626107": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626108": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626109": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626110": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626111": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626112": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626113": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626114": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626115": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626116": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626117": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626118": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626119": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626120": {
    "city": "MUDUKULATHUR",
    "state": "TAMIL NADU"
  },
  "626121": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626122": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626123": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626124": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626125": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626126": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626127": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626128": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626129": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626130": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626131": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626132": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626133": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626134": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626135": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626136": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626137": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626138": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626139": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626140": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626141": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626142": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626143": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "626144": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "626145": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "626146": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626147": {
    "city": "ARUPPUKOTTAI",
    "state": "TAMIL NADU"
  },
  "626148": {
    "city": "ARUPPUKOTTAI",
    "state": "TAMIL NADU"
  },
  "626149": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626150": {
    "city": "ARUPPUKOTTAI",
    "state": "TAMIL NADU"
  },
  "626151": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "626152": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626153": {
    "city": "ARUPPUKOTTAI",
    "state": "TAMIL NADU"
  },
  "626154": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "626155": {
    "city": "ARUPPUKOTTAI",
    "state": "TAMIL NADU"
  },
  "626156": {
    "city": "ARUPPUKOTTAI",
    "state": "TAMIL NADU"
  },
  "626157": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626158": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626159": {
    "city": "ARUPPUKOTTAI",
    "state": "TAMIL NADU"
  },
  "626160": {
    "city": "ARUPPUKOTTAI",
    "state": "TAMIL NADU"
  },
  "626161": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626162": {
    "city": "ARUPPUKOTTAI",
    "state": "TAMIL NADU"
  },
  "626163": {
    "city": "ARUPPUKOTTAI",
    "state": "TAMIL NADU"
  },
  "626164": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "626165": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626166": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "626167": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626168": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "626169": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "626170": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "626171": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "626172": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626173": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "626175": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626176": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "626177": {
    "city": "ARUPPUKOTTAI",
    "state": "TAMIL NADU"
  },
  "626178": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "626179": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "626180": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "626181": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626182": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626183": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "626184": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "626186": {
    "city": "ARUPPUKOTTAI",
    "state": "TAMIL NADU"
  },
  "626187": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "626188": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626189": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626190": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "626195": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626201": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626202": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626203": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626204": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626205": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "626206": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "626207": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626208": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626209": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626210": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626211": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "626212": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "626213": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "626501": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626512": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626513": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626514": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "626515": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626516": {
    "city": "CUMBUM - TN",
    "state": "TAMIL NADU"
  },
  "626517": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626518": {
    "city": "CUMBUM - TN",
    "state": "TAMIL NADU"
  },
  "626519": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "626520": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626521": {
    "city": "CUMBUM - TN",
    "state": "TAMIL NADU"
  },
  "626522": {
    "city": "CUMBUM - TN",
    "state": "TAMIL NADU"
  },
  "626523": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626524": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626525": {
    "city": "CUMBUM - TN",
    "state": "TAMIL NADU"
  },
  "626526": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626527": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626528": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626529": {
    "city": "USILAMPATTI",
    "state": "TAMIL NADU"
  },
  "626530": {
    "city": "CUMBUM - TN",
    "state": "TAMIL NADU"
  },
  "626531": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626532": {
    "city": "USILAMPATTI",
    "state": "TAMIL NADU"
  },
  "626533": {
    "city": "CUMBUM - TN",
    "state": "TAMIL NADU"
  },
  "626534": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626535": {
    "city": "USILAMPATTI",
    "state": "TAMIL NADU"
  },
  "626536": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626537": {
    "city": "USILAMPATTI",
    "state": "TAMIL NADU"
  },
  "626538": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626539": {
    "city": "CUMBUM - TN",
    "state": "TAMIL NADU"
  },
  "626540": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "626541": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626544": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626547": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626549": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "626553": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626555": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626556": {
    "city": "CUMBUM - TN",
    "state": "TAMIL NADU"
  },
  "626562": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626565": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626566": {
    "city": "USILAMPATTI",
    "state": "TAMIL NADU"
  },
  "626569": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626571": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626572": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626579": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "626582": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "626601": {
    "city": "BATLAGUNDU",
    "state": "TAMIL NADU"
  },
  "626607": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626612": {
    "city": "Virudhunagar",
    "state": "Tamil Nadu"
  },
  "626701": {
    "city": "VIRUDUNAGAR",
    "state": "TAMIL NADU"
  },
  "626702": {
    "city": "TIRUMANGALAM",
    "state": "TAMIL NADU"
  },
  "626703": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "626704": {
    "city": "TIRUMANGALAM",
    "state": "TAMIL NADU"
  },
  "626705": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "626706": {
    "city": "TIRUMANGALAM",
    "state": "TAMIL NADU"
  },
  "626709": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "626712": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "626716": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "626717": {
    "city": "TIRUMANGALAM",
    "state": "TAMIL NADU"
  },
  "626719": {
    "city": "TIRUMANGALAM",
    "state": "TAMIL NADU"
  },
  "627001": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627002": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627003": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627004": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627005": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627006": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627007": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627008": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627009": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627010": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627011": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627012": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627013": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627015": {
    "city": "TIRUNELVELI",
    "state": "TAMIL NADU"
  },
  "627051": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627101": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627102": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627103": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627104": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627105": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627106": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627107": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627108": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627109": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627110": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627111": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627112": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627113": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627114": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627115": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627116": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627117": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627118": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627119": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627120": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627121": {
    "city": "VALLIOOR",
    "state": "TAMIL NADU"
  },
  "627122": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627123": {
    "city": "VALLIOOR",
    "state": "TAMIL NADU"
  },
  "627124": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "627125": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627126": {
    "city": "VALLIOOR",
    "state": "TAMIL NADU"
  },
  "627127": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627128": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "627129": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627130": {
    "city": "VALLIOOR",
    "state": "TAMIL NADU"
  },
  "627131": {
    "city": "VALLIOOR",
    "state": "TAMIL NADU"
  },
  "627132": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "627133": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627151": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627152": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627153": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627154": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627201": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627202": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627251": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627252": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627253": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627254": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627255": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627301": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627302": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627303": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627304": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627305": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "627351": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627352": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627353": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627354": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627355": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627356": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627357": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627358": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627359": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627360": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627361": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627401": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627412": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627413": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627414": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627415": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627416": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627417": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627418": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627419": {
    "city": "AMBASAMUDRAM",
    "state": "TAMIL NADU"
  },
  "627420": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627421": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627422": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627423": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627424": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627425": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627426": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627427": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627428": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627430": {
    "city": "AMBASAMUDRAM",
    "state": "TAMIL NADU"
  },
  "627431": {
    "city": "TENKASI",
    "state": "TAMIL NADU"
  },
  "627432": {
    "city": "TENKASI",
    "state": "TAMIL NADU"
  },
  "627433": {
    "city": "AMBASAMUDRAM",
    "state": "TAMIL NADU"
  },
  "627434": {
    "city": "AMBASAMUDRAM",
    "state": "TAMIL NADU"
  },
  "627435": {
    "city": "AMBASAMUDRAM",
    "state": "TAMIL NADU"
  },
  "627436": {
    "city": "TENKASI",
    "state": "TAMIL NADU"
  },
  "627451": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627452": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627453": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627501": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627502": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627551": {
    "city": "AMBASAMUDRAM",
    "state": "TAMIL NADU"
  },
  "627601": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627602": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627603": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627604": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627651": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627652": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627654": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627657": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627658": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "627659": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "627701": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627702": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627706": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627712": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627713": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627714": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627716": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627717": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627718": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627719": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627720": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627721": {
    "city": "PULIYANGUDI",
    "state": "TAMIL NADU"
  },
  "627722": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "627723": {
    "city": "TENKASI",
    "state": "TAMIL NADU"
  },
  "627724": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "627725": {
    "city": "MUDUKULATHUR",
    "state": "TAMIL NADU"
  },
  "627726": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "627727": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627751": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627752": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627753": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627754": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627755": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627756": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627757": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627758": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627759": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627760": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627761": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627762": {
    "city": "SIVAKASI",
    "state": "TAMIL NADU"
  },
  "627763": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "627764": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627765": {
    "city": "PULIYANGUDI",
    "state": "TAMIL NADU"
  },
  "627766": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627767": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627768": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627769": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627770": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "627771": {
    "city": "PULIYANGUDI",
    "state": "TAMIL NADU"
  },
  "627773": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627774": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627801": {
    "city": "TENKASI",
    "state": "TAMIL NADU"
  },
  "627802": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627803": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627804": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627805": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627806": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627807": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627808": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627809": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627810": {
    "city": "TENKASI",
    "state": "TAMIL NADU"
  },
  "627811": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627812": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627813": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627814": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627815": {
    "city": "TENKASI",
    "state": "TAMIL NADU"
  },
  "627816": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "627817": {
    "city": "TENKASI",
    "state": "TAMIL NADU"
  },
  "627818": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627819": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627820": {
    "city": "TENKASI",
    "state": "TAMIL NADU"
  },
  "627821": {
    "city": "AMBASAMUDRAM",
    "state": "TAMIL NADU"
  },
  "627822": {
    "city": "VALLIOOR",
    "state": "TAMIL NADU"
  },
  "627823": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627851": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627852": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627853": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627854": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627855": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627856": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627857": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627858": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627859": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627860": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627861": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627862": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627863": {
    "city": "PULIYANGUDI",
    "state": "TAMIL NADU"
  },
  "627864": {
    "city": "PULIYANGUDI",
    "state": "TAMIL NADU"
  },
  "627866": {
    "city": "PULIYANGUDI",
    "state": "TAMIL NADU"
  },
  "627867": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627901": {
    "city": "AMBASAMUDRAM",
    "state": "TAMIL NADU"
  },
  "627902": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627903": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627904": {
    "city": "ARUPPUKOTTAI",
    "state": "TAMIL NADU"
  },
  "627905": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627906": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627907": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627908": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627909": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627910": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "627911": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "627912": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627951": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627952": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627953": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "627954": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "627955": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "627956": {
    "city": "PULIYANGUDI",
    "state": "TAMIL NADU"
  },
  "627957": {
    "city": "PULIYANGUDI",
    "state": "TAMIL NADU"
  },
  "628001": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628002": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628003": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628004": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628005": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628006": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628007": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628008": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628051": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "628101": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628102": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628103": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628104": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628105": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628151": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628152": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628153": {
    "city": "TIRUCHENDUR",
    "state": "TAMIL NADU"
  },
  "628154": {
    "city": "TIRUCHENDUR",
    "state": "TAMIL NADU"
  },
  "628155": {
    "city": "TIRUCHENDUR",
    "state": "TAMIL NADU"
  },
  "628201": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628202": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628203": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628204": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628205": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628206": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628207": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628208": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628209": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628210": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628211": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628212": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628213": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628214": {
    "city": "TIRUCHENDUR",
    "state": "TAMIL NADU"
  },
  "628215": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628216": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628217": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628218": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628219": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628220": {
    "city": "TIRUCHENDUR",
    "state": "TAMIL NADU"
  },
  "628221": {
    "city": "TIRUCHENDUR",
    "state": "TAMIL NADU"
  },
  "628222": {
    "city": "TIRUCHENDUR",
    "state": "TAMIL NADU"
  },
  "628223": {
    "city": "TIRUCHENDUR",
    "state": "TAMIL NADU"
  },
  "628224": {
    "city": "TIRUCHENDUR",
    "state": "TAMIL NADU"
  },
  "628225": {
    "city": "TIRUCHENDUR",
    "state": "TAMIL NADU"
  },
  "628226": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "628227": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "628228": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "628229": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628251": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628252": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628301": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628302": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628303": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628304": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628305": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "628306": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "628307": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "628308": {
    "city": "RAJAPALYAM",
    "state": "TAMIL NADU"
  },
  "628309": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "628313": {
    "city": "TIRUNELVELI",
    "state": "TAMIL NADU"
  },
  "628401": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628402": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628404": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "628501": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628502": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628503": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628513": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "628552": {
    "city": "Tirunelveli",
    "state": "Tamil Nadu"
  },
  "628553": {
    "city": "KOVILPATTI",
    "state": "TAMIL NADU"
  },
  "628601": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628612": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628613": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628614": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628615": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628616": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628617": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628618": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628619": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628620": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628621": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628622": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628623": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628624": {
    "city": "TIRUCHENDUR",
    "state": "TAMIL NADU"
  },
  "628625": {
    "city": "TIRUCHENDUR",
    "state": "TAMIL NADU"
  },
  "628626": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628627": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628628": {
    "city": "TIRUCHENDUR",
    "state": "TAMIL NADU"
  },
  "628629": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628630": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628631": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628651": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628652": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628653": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628654": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628655": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628656": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628657": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628658": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628659": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628660": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628661": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "628662": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628663": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "628701": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628702": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628703": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628704": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628705": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628706": {
    "city": "SATTANKULAM",
    "state": "TAMIL NADU"
  },
  "628707": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "628712": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628714": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628716": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628718": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628720": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628721": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628722": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628751": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628752": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628753": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628801": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628802": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628803": {
    "city": "THOOTHUKKUDI",
    "state": "TAMIL NADU"
  },
  "628809": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628851": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628901": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628902": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628903": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628904": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628905": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628906": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628907": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628908": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "628952": {
    "city": "Tuticorin",
    "state": "Tamil Nadu"
  },
  "629001": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629002": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629003": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629004": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629005": {
    "city": "NAGERCOIL",
    "state": "TAMIL NADU"
  },
  "629051": {
    "city": "NAGERCOIL",
    "state": "TAMIL NADU"
  },
  "629101": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629102": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629103": {
    "city": "MARTHANDAM",
    "state": "TAMIL NADU"
  },
  "629151": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629152": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629153": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629154": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629155": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629156": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629157": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629158": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629159": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629160": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629161": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629162": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629163": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629164": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629165": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629166": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629167": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629168": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629169": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629170": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629171": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629172": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629173": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629174": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629175": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629176": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629177": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629178": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629179": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629180": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629181": {
    "city": "MARTHANDAM",
    "state": "TAMIL NADU"
  },
  "629182": {
    "city": "MARTHANDAM",
    "state": "TAMIL NADU"
  },
  "629183": {
    "city": "KALKULAM",
    "state": "TAMIL NADU"
  },
  "629187": {
    "city": "MARTHANDAM",
    "state": "TAMIL NADU"
  },
  "629188": {
    "city": "MARTHANDAM",
    "state": "TAMIL NADU"
  },
  "629189": {
    "city": "KALKULAM",
    "state": "TAMIL NADU"
  },
  "629190": {
    "city": "MARTHANDAM",
    "state": "TAMIL NADU"
  },
  "629191": {
    "city": "MARTHANDAM",
    "state": "TAMIL NADU"
  },
  "629192": {
    "city": "MARTHANDAM",
    "state": "TAMIL NADU"
  },
  "629193": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629195": {
    "city": "MARTHANDAM",
    "state": "TAMIL NADU"
  },
  "629196": {
    "city": "MARTHANDAM",
    "state": "TAMIL NADU"
  },
  "629197": {
    "city": "MARTHANDAM",
    "state": "TAMIL NADU"
  },
  "629201": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629202": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629203": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629204": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629205": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "629251": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629252": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629253": {
    "city": "NAGERCOIL",
    "state": "TAMIL NADU"
  },
  "629301": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629302": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629303": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "629304": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "629305": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "629401": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629402": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629403": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629404": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "629406": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "629501": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629502": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629503": {
    "city": "NAGERCOIL",
    "state": "TAMIL NADU"
  },
  "629504": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "629509": {
    "city": "NAGERCOIL",
    "state": "TAMIL NADU"
  },
  "629601": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629602": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629603": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "629664": {
    "city": "KANDUKURU",
    "state": "ANDHRA PRADESH"
  },
  "629701": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629702": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629703": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629704": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629706": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "629707": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "629708": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "629801": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629802": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629803": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629804": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629805": {
    "city": "MARTHANDAM",
    "state": "TAMIL NADU"
  },
  "629806": {
    "city": "NAGERCOIL",
    "state": "TAMIL NADU"
  },
  "629807": {
    "city": "NAGERCOIL",
    "state": "TAMIL NADU"
  },
  "629808": {
    "city": "MARTHANDAM",
    "state": "TAMIL NADU"
  },
  "629809": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629810": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629851": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629852": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629854": {
    "city": "KANYAKUMARI",
    "state": "TAMIL NADU"
  },
  "629855": {
    "city": "NAGERCOIL",
    "state": "TAMIL NADU"
  },
  "629901": {
    "city": "Kanyakumari",
    "state": "Tamil Nadu"
  },
  "629902": {
    "city": "NAGERCOIL",
    "state": "TAMIL NADU"
  },
  "630001": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630002": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630003": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630004": {
    "city": "SIVAGANGA",
    "state": "TAMIL NADU"
  },
  "630005": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630006": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "630009": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "630101": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630102": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630103": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630104": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630105": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630106": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630107": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630108": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630201": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630202": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630203": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630204": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630205": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630206": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630207": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630208": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630209": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "630210": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630211": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630212": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630214": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "630215": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "630301": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630302": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630303": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630304": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "630305": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630306": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630307": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630308": {
    "city": "MANAPPARAI",
    "state": "TAMIL NADU"
  },
  "630309": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630310": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "630311": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630312": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630313": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630314": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630315": {
    "city": "DEVAKOTTAI",
    "state": "TAMIL NADU"
  },
  "630317": {
    "city": "KARAIKUDI",
    "state": "TAMIL NADU"
  },
  "630318": {
    "city": "DEVAKOTTAI",
    "state": "TAMIL NADU"
  },
  "630319": {
    "city": "DEVAKOTTAI",
    "state": "TAMIL NADU"
  },
  "630321": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630403": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "630404": {
    "city": "PADUKOTTAI",
    "state": "TAMIL NADU"
  },
  "630405": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630407": {
    "city": "KALAIYARKOVIL",
    "state": "TAMIL NADU"
  },
  "630408": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630409": {
    "city": "MELUR",
    "state": "TAMIL NADU"
  },
  "630410": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630411": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630501": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630502": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630551": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630552": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630553": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630554": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630555": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630556": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630557": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630558": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630559": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630560": {
    "city": "SIVAGANGAI",
    "state": "TAMIL NADU"
  },
  "630561": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630562": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630565": {
    "city": "SIVAGANGAI",
    "state": "TAMIL NADU"
  },
  "630566": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630601": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "630602": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630603": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "630604": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "630605": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "630606": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630607": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "630608": {
    "city": "MANA MADURAI",
    "state": "TAMIL NADU"
  },
  "630609": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630610": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630611": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630612": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630613": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "630702": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630709": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630710": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "630713": {
    "city": "Sivaganga",
    "state": "Tamil Nadu"
  },
  "631001": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "631002": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "631003": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "631004": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "631005": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "631006": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "631027": {
    "city": "SHOLINGHUR",
    "state": "TAMIL NADU"
  },
  "631051": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "631052": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "631053": {
    "city": "KANCHIPURAM",
    "state": "TAMIL NADU"
  },
  "631057": {
    "city": "ARAKKONAM",
    "state": "TAMIL NADU"
  },
  "631060": {
    "city": "ARAKKONAM",
    "state": "TAMIL NADU"
  },
  "631061": {
    "city": "ARAKKONAM",
    "state": "TAMIL NADU"
  },
  "631101": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "631102": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "631104": {
    "city": "SHOLINGHUR",
    "state": "TAMIL NADU"
  },
  "631105": {
    "city": "SHOLINGHUR",
    "state": "TAMIL NADU"
  },
  "631118": {
    "city": "VELLORE",
    "state": "TAMIL NADU"
  },
  "631122": {
    "city": "SALEM",
    "state": "TAMIL NADU"
  },
  "631151": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "631152": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "631201": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631202": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631203": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631204": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631205": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631206": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631207": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631208": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631209": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631210": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631211": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631212": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631213": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631301": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631302": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631303": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631304": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631401": {
    "city": "SRIPERUMBUDUR",
    "state": "TAMIL NADU"
  },
  "631402": {
    "city": "Tiruvallur",
    "state": "Tamil Nadu"
  },
  "631404": {
    "city": "SRIPERUMBUDUR",
    "state": "TAMIL NADU"
  },
  "631501": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "631502": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "631503": {
    "city": "KANCHIPURAM",
    "state": "TAMIL NADU"
  },
  "631551": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "631552": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "631553": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "631561": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "631601": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "631602": {
    "city": "KANCHIPURAM",
    "state": "TAMIL NADU"
  },
  "631603": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "631604": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "631605": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "631606": {
    "city": "Kanchipuram",
    "state": "Tamil Nadu"
  },
  "631609": {
    "city": "KANCHIPURAM",
    "state": "TAMIL NADU"
  },
  "631701": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "631702": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "631703": {
    "city": "KANCHIPURAM",
    "state": "TAMIL NADU"
  },
  "632001": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632002": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632003": {
    "city": "VELLORE",
    "state": "TAMIL NADU"
  },
  "632004": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632005": {
    "city": "VELLORE",
    "state": "TAMIL NADU"
  },
  "632006": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632007": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632008": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632009": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632010": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632011": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632012": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632013": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632014": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632051": {
    "city": "CHEYYAR",
    "state": "TAMIL NADU"
  },
  "632052": {
    "city": "TIRUVANNAMALAI",
    "state": "TAMIL NADU"
  },
  "632053": {
    "city": "VELLORE",
    "state": "TAMIL NADU"
  },
  "632054": {
    "city": "VELLORE",
    "state": "TAMIL NADU"
  },
  "632055": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632057": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632058": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632059": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632101": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632102": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632103": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632104": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632105": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632106": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632107": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632108": {
    "city": "VELLORE",
    "state": "TAMIL NADU"
  },
  "632109": {
    "city": "GUDIYATTAM",
    "state": "TAMIL NADU"
  },
  "632110": {
    "city": "GUDIYATTAM",
    "state": "TAMIL NADU"
  },
  "632112": {
    "city": "VELLORE",
    "state": "TAMIL NADU"
  },
  "632113": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632114": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632115": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632201": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632202": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632203": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632204": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632205": {
    "city": "GUDIYATTAM",
    "state": "TAMIL NADU"
  },
  "632206": {
    "city": "VANIYAMBADI",
    "state": "TAMIL NADU"
  },
  "632207": {
    "city": "GUDIYATTAM",
    "state": "TAMIL NADU"
  },
  "632208": {
    "city": "GUDIYATTAM",
    "state": "TAMIL NADU"
  },
  "632209": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632211": {
    "city": "GUDIYATTAM",
    "state": "TAMIL NADU"
  },
  "632218": {
    "city": "ARNI",
    "state": "TAMIL NADU"
  },
  "632234": {
    "city": "ARNI",
    "state": "TAMIL NADU"
  },
  "632301": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "632311": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "632312": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632313": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "632314": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "632315": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "632316": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "632317": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "632318": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632319": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632320": {
    "city": "ARNI",
    "state": "TAMIL NADU"
  },
  "632321": {
    "city": "ARNI",
    "state": "TAMIL NADU"
  },
  "632322": {
    "city": "ARNI",
    "state": "TAMIL NADU"
  },
  "632323": {
    "city": "ARNI",
    "state": "TAMIL NADU"
  },
  "632324": {
    "city": "ARNI",
    "state": "TAMIL NADU"
  },
  "632325": {
    "city": "ARNI",
    "state": "TAMIL NADU"
  },
  "632326": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "632401": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632402": {
    "city": "RANIPET",
    "state": "TAMIL NADU"
  },
  "632403": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632404": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632405": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632406": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632501": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632502": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632503": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632504": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632505": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632506": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632507": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632508": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632509": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632510": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632511": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632512": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632513": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632514": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632515": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632516": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632517": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632518": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632519": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632520": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632521": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632522": {
    "city": "RANIPET",
    "state": "TAMIL NADU"
  },
  "632523": {
    "city": "RANIPET",
    "state": "TAMIL NADU"
  },
  "632524": {
    "city": "RANIPET",
    "state": "TAMIL NADU"
  },
  "632525": {
    "city": "CHEYYAR",
    "state": "TAMIL NADU"
  },
  "632526": {
    "city": "TINDIVANAM",
    "state": "TAMIL NADU"
  },
  "632527": {
    "city": "CHEYYAR",
    "state": "TAMIL NADU"
  },
  "632528": {
    "city": "KANCHIPURAM",
    "state": "TAMIL NADU"
  },
  "632529": {
    "city": "RANIPET",
    "state": "TAMIL NADU"
  },
  "632530": {
    "city": "RANIPET",
    "state": "TAMIL NADU"
  },
  "632531": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632601": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632602": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632603": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632604": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "632605": {
    "city": "GUDIYATTAM",
    "state": "TAMIL NADU"
  },
  "632606": {
    "city": "GUDIYATTAM",
    "state": "TAMIL NADU"
  },
  "632607": {
    "city": "GUDIYATTAM",
    "state": "TAMIL NADU"
  },
  "632608": {
    "city": "GUDIYATTAM",
    "state": "TAMIL NADU"
  },
  "632631": {
    "city": "RANIPET",
    "state": "TAMIL NADU"
  },
  "635001": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635002": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635101": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635102": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635103": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635104": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635105": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635106": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635107": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635108": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635109": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635110": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635111": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635112": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635113": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635114": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635115": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635116": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635117": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635118": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635119": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635120": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635121": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635122": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635123": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635124": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635125": {
    "city": "HOSUR",
    "state": "TAMIL NADU"
  },
  "635126": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635127": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635128": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635129": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635130": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635131": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635132": {
    "city": "HOSUR",
    "state": "KARNATAKA"
  },
  "635133": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635134": {
    "city": "HOSUR",
    "state": "KARNATAKA"
  },
  "635135": {
    "city": "HOSUR",
    "state": "KARNATAKA"
  },
  "635136": {
    "city": "HOSUR",
    "state": "KARNATAKA"
  },
  "635137": {
    "city": "HOSUR",
    "state": "KARNATAKA"
  },
  "635138": {
    "city": "TIRUPPATTUR",
    "state": "TAMIL NADU"
  },
  "635139": {
    "city": "HOSUR",
    "state": "KARNATAKA"
  },
  "635140": {
    "city": "HOSUR",
    "state": "KARNATAKA"
  },
  "635141": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635201": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "635202": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "635203": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635204": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635205": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "635206": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635207": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635208": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635209": {
    "city": "UTHANGARAI",
    "state": "TAMIL NADU"
  },
  "635210": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635211": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635212": {
    "city": "KAVERIPATTANAM",
    "state": "TAMIL NADU"
  },
  "635301": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "635302": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "635303": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "635304": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635305": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "635306": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635307": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "635308": {
    "city": "HARUR",
    "state": "TAMIL NADU"
  },
  "635309": {
    "city": "UTHANGARAI",
    "state": "TAMIL NADU"
  },
  "635310": {
    "city": "HARUR",
    "state": "TAMIL NADU"
  },
  "635311": {
    "city": "HARUR",
    "state": "TAMIL NADU"
  },
  "635312": {
    "city": "HARUR",
    "state": "TAMIL NADU"
  },
  "635313": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635601": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635602": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635611": {
    "city": "MUSIRI",
    "state": "TAMIL NADU"
  },
  "635651": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635652": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635653": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635654": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635655": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635656": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635657": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635659": {
    "city": "VANIYAMBADI",
    "state": "TAMIL NADU"
  },
  "635660": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635661": {
    "city": "UTHANGARAI",
    "state": "TAMIL NADU"
  },
  "635662": {
    "city": "UTHANGARAI",
    "state": "TAMIL NADU"
  },
  "635701": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635702": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635703": {
    "city": "Tiruvannamalai",
    "state": "Tamil Nadu"
  },
  "635704": {
    "city": "UTHANGARAI",
    "state": "TAMIL NADU"
  },
  "635705": {
    "city": "KAVERIPATTANAM",
    "state": "TAMIL NADU"
  },
  "635706": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635707": {
    "city": "KAVERIPATTANAM",
    "state": "TAMIL NADU"
  },
  "635708": {
    "city": "KAVERIPATTANAM",
    "state": "TAMIL NADU"
  },
  "635709": {
    "city": "UTHANGARAI",
    "state": "TAMIL NADU"
  },
  "635710": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635751": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635752": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635753": {
    "city": "VANIYAMBADI",
    "state": "TAMIL NADU"
  },
  "635754": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635755": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635756": {
    "city": "VANIYAMBADI",
    "state": "TAMIL NADU"
  },
  "635757": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635758": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635801": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635802": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635803": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635804": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635805": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635806": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635807": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635808": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635809": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635810": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635811": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635812": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635813": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635814": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635815": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635816": {
    "city": "KAVERIPATTANAM",
    "state": "TAMIL NADU"
  },
  "635817": {
    "city": "KAVERIPATTANAM",
    "state": "TAMIL NADU"
  },
  "635818": {
    "city": "KAVERIPATTANAM",
    "state": "TAMIL NADU"
  },
  "635819": {
    "city": "VANIYAMBADI",
    "state": "TAMIL NADU"
  },
  "635820": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635821": {
    "city": "TIRUPPATTUR",
    "state": "TAMIL NADU"
  },
  "635822": {
    "city": "KAVERIPATTANAM",
    "state": "TAMIL NADU"
  },
  "635823": {
    "city": "HOSUR",
    "state": "KARNATAKA"
  },
  "635824": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635825": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635826": {
    "city": "KAVERIPATTANAM",
    "state": "TAMIL NADU"
  },
  "635851": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635852": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635853": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635854": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "635855": {
    "city": "VELLAKOVIL",
    "state": "TAMIL NADU"
  },
  "635856": {
    "city": "TIRUPPATTUR",
    "state": "TAMIL NADU"
  },
  "635857": {
    "city": "KRISHNAGIRI",
    "state": "TAMIL NADU"
  },
  "635901": {
    "city": "Vellore",
    "state": "Tamil Nadu"
  },
  "636001": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636002": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636003": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636004": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636005": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636006": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636007": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636008": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636009": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636010": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636011": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636012": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636013": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636014": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636015": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636016": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636017": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636030": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636101": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636102": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636103": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636104": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636105": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636106": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636107": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636108": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636109": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636110": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636111": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636112": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636113": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636114": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636115": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636116": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636117": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636118": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "636119": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636121": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636122": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636124": {
    "city": "ARIYALUR",
    "state": "TAMIL NADU"
  },
  "636130": {
    "city": "ATTUR",
    "state": "TAMIL NADU"
  },
  "636137": {
    "city": "METTUR",
    "state": "TAMIL NADU"
  },
  "636138": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636139": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636140": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636141": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636142": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636201": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636202": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "636203": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636204": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636301": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "636302": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636303": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636304": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636305": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636306": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636307": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636308": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636309": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636316": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "636318": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "636319": {
    "city": "OMALUR",
    "state": "TAMIL NADU"
  },
  "636351": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636352": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636354": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636401": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636402": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636403": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636404": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636406": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636407": {
    "city": "METTUR",
    "state": "TAMIL NADU"
  },
  "636451": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636452": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636453": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636454": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636455": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636456": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636457": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636458": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636462": {
    "city": "METTUR",
    "state": "TAMIL NADU"
  },
  "636463": {
    "city": "METTUR",
    "state": "TAMIL NADU"
  },
  "636501": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636502": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636503": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636504": {
    "city": "OMALUR",
    "state": "TAMIL NADU"
  },
  "636505": {
    "city": "OMALUR",
    "state": "TAMIL NADU"
  },
  "636601": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636602": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "636604": {
    "city": "SALEM",
    "state": "TAMIL NADU"
  },
  "636701": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636702": {
    "city": "DHARAMAPURI",
    "state": "TAMIL NADU"
  },
  "636703": {
    "city": "DHARAMAPURI",
    "state": "TAMIL NADU"
  },
  "636704": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636705": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636751": {
    "city": "VANIYAMBADI",
    "state": "TAMIL NADU"
  },
  "636802": {
    "city": "PALLACODE",
    "state": "TAMIL NADU"
  },
  "636803": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636804": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636805": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636806": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636807": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636808": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636809": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636810": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636811": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636812": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636813": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636815": {
    "city": "MADURAI",
    "state": "TAMIL NADU"
  },
  "636816": {
    "city": "KAVERIPATTANAM",
    "state": "TAMIL NADU"
  },
  "636821": {
    "city": "KAVERIPATTANAM",
    "state": "TAMIL NADU"
  },
  "636902": {
    "city": "Krishnagiri",
    "state": "Tamil Nadu"
  },
  "636903": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636904": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636905": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636906": {
    "city": "Dharmapuri",
    "state": "Tamil Nadu"
  },
  "636908": {
    "city": "HARUR",
    "state": "TAMIL NADU"
  },
  "636915": {
    "city": "HARUR",
    "state": "TAMIL NADU"
  },
  "637001": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637002": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637003": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637013": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637014": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637015": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637017": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637018": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637019": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637020": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637021": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637023": {
    "city": "RASIPURAM",
    "state": "TAMIL NADU"
  },
  "637024": {
    "city": "NAMAKKAL",
    "state": "TAMIL NADU"
  },
  "637026": {
    "city": "NAMAKKAL",
    "state": "TAMIL NADU"
  },
  "637101": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "637102": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637103": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637104": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637105": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637107": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637109": {
    "city": "SANKARI",
    "state": "TAMIL NADU"
  },
  "637201": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637202": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637203": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637204": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637205": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637206": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637207": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637208": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637209": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637210": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637211": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637212": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637213": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637214": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637215": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637217": {
    "city": "SANKARI",
    "state": "TAMIL NADU"
  },
  "637301": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "637302": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637303": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637304": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637306": {
    "city": "SANKARI",
    "state": "TAMIL NADU"
  },
  "637401": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637402": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637403": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637404": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637405": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637406": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637407": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637408": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637409": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637410": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637411": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637412": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637413": {
    "city": "RASIPURAM",
    "state": "TAMIL NADU"
  },
  "637416": {
    "city": "RASIPURAM",
    "state": "TAMIL NADU"
  },
  "637417": {
    "city": "NAMAKKAL",
    "state": "TAMIL NADU"
  },
  "637418": {
    "city": "NAMAKKAL",
    "state": "TAMIL NADU"
  },
  "637420": {
    "city": "RASIPURAM",
    "state": "TAMIL NADU"
  },
  "637501": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "637502": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "637503": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637504": {
    "city": "Salem",
    "state": "Tamil Nadu"
  },
  "637505": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "637508": {
    "city": "SANKARI",
    "state": "TAMIL NADU"
  },
  "638001": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638002": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638003": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638004": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638005": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638006": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "638007": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "638008": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "638009": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638010": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638011": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638012": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638051": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638052": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638053": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638054": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638055": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638056": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638057": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638058": {
    "city": "ERODE",
    "state": "TAMIL NADU"
  },
  "638059": {
    "city": "GOPICHETTIPALAYAM",
    "state": "TAMIL NADU"
  },
  "638060": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638101": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638102": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638103": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638104": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638105": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638106": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638107": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638108": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638109": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638110": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638111": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638112": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638113": {
    "city": "ERODE",
    "state": "TAMIL NADU"
  },
  "638115": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638116": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638117": {
    "city": "ERODE",
    "state": "TAMIL NADU"
  },
  "638118": {
    "city": "VELLAKOVIL",
    "state": "TAMIL NADU"
  },
  "638129": {
    "city": "THENI",
    "state": "TAMIL NADU"
  },
  "638130": {
    "city": "VELLAKOVIL",
    "state": "TAMIL NADU"
  },
  "638151": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638152": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638153": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638154": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638181": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "638182": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "638183": {
    "city": "Namakkal",
    "state": "Tamil Nadu"
  },
  "638201": {
    "city": "KARUR",
    "state": "TAMIL NADU"
  },
  "638202": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "638203": {
    "city": "AVINASHI",
    "state": "TAMIL NADU"
  },
  "638204": {
    "city": "UDUMALAIPPATTAI",
    "state": "TAMIL NADU"
  },
  "638205": {
    "city": "CUMBUM - TN",
    "state": "TAMIL NADU"
  },
  "638206": {
    "city": "UDUMALAIPPATTAI",
    "state": "TAMIL NADU"
  },
  "638207": {
    "city": "DHARAPURAM",
    "state": "TAMIL NADU"
  },
  "638211": {
    "city": "GOPICHETTIPALAYAM",
    "state": "TAMIL NADU"
  },
  "638301": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638302": {
    "city": "BHAVANI",
    "state": "TAMIL NADU"
  },
  "638311": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638312": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638313": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638314": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638315": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638316": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638319": {
    "city": "ANTHIYUR",
    "state": "TAMIL NADU"
  },
  "638324": {
    "city": "ANTHIYUR",
    "state": "TAMIL NADU"
  },
  "638327": {
    "city": "ANTHIYUR",
    "state": "TAMIL NADU"
  },
  "638328": {
    "city": "METTUR",
    "state": "TAMIL NADU"
  },
  "638401": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638402": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638403": {
    "city": "PALLADAM",
    "state": "TAMIL NADU"
  },
  "638404": {
    "city": "SATHYAMANGALAM",
    "state": "TAMIL NADU"
  },
  "638406": {
    "city": "GOPICHETTIPALAYAM",
    "state": "TAMIL NADU"
  },
  "638451": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638452": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638453": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638454": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638455": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638456": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638457": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638458": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638459": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638460": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638461": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638462": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638464": {
    "city": "SATHYAMANGALAM",
    "state": "TAMIL NADU"
  },
  "638466": {
    "city": "SATHYAMANGALAM",
    "state": "TAMIL NADU"
  },
  "638469": {
    "city": "GOPICHETTIPALAYAM",
    "state": "TAMIL NADU"
  },
  "638470": {
    "city": "ANTHIYUR",
    "state": "TAMIL NADU"
  },
  "638471": {
    "city": "ANTHIYUR",
    "state": "TAMIL NADU"
  },
  "638476": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638501": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638502": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638503": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638504": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638505": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638506": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638511": {
    "city": "ANTHIYUR",
    "state": "TAMIL NADU"
  },
  "638512": {
    "city": "SATHYAMANGALAM",
    "state": "TAMIL NADU"
  },
  "638601": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "638602": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "638603": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "638605": {
    "city": "THANJAVUR",
    "state": "TAMIL NADU"
  },
  "638606": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "638607": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "638652": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "638653": {
    "city": "ANNUR",
    "state": "TAMIL NADU"
  },
  "638654": {
    "city": "AVINASHI",
    "state": "TAMIL NADU"
  },
  "638655": {
    "city": "DHARAPURAM",
    "state": "TAMIL NADU"
  },
  "638656": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638657": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638658": {
    "city": "ANNUR",
    "state": "TAMIL NADU"
  },
  "638660": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638661": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638662": {
    "city": "PALLADAM",
    "state": "TAMIL NADU"
  },
  "638663": {
    "city": "PALLADAM",
    "state": "TAMIL NADU"
  },
  "638664": {
    "city": "PALLADAM",
    "state": "TAMIL NADU"
  },
  "638665": {
    "city": "AVINASHI",
    "state": "TAMIL NADU"
  },
  "638666": {
    "city": "AVINASHI",
    "state": "TAMIL NADU"
  },
  "638667": {
    "city": "THIRUVARUR",
    "state": "TAMIL NADU"
  },
  "638668": {
    "city": "ANNUR",
    "state": "TAMIL NADU"
  },
  "638669": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "638670": {
    "city": "PALLADAM",
    "state": "TAMIL NADU"
  },
  "638671": {
    "city": "PALLADAM",
    "state": "TAMIL NADU"
  },
  "638672": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638673": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638675": {
    "city": "ERODE",
    "state": "TAMIL NADU"
  },
  "638683": {
    "city": "PALLADAM",
    "state": "TAMIL NADU"
  },
  "638684": {
    "city": "PALLADAM",
    "state": "TAMIL NADU"
  },
  "638687": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "638689": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "638696": {
    "city": "PALANI",
    "state": "TAMIL NADU"
  },
  "638697": {
    "city": "ANNUR",
    "state": "TAMIL NADU"
  },
  "638701": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638702": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638703": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638706": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638751": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638752": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638802": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "638806": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "638807": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "638812": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "638888": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "639001": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639002": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639003": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639004": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639005": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639006": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639007": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639008": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639101": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "639102": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639103": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "639104": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639105": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639106": {
    "city": "KARUR",
    "state": "TAMIL NADU"
  },
  "639107": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639108": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639109": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639110": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639111": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639112": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "639113": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639114": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639115": {
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu"
  },
  "639116": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639117": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639118": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639119": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639120": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639121": {
    "city": "MUSIRI",
    "state": "TAMIL NADU"
  },
  "639136": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639144": {
    "city": "NAMAKKAL",
    "state": "TAMIL NADU"
  },
  "639147": {
    "city": "MUSIRI",
    "state": "TAMIL NADU"
  },
  "639201": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639202": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639203": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639204": {
    "city": "UDUMALAIPPATTAI",
    "state": "TAMIL NADU"
  },
  "639205": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639206": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639207": {
    "city": "Karur",
    "state": "Tamil Nadu"
  },
  "639210": {
    "city": "GOPICHETTIPALAYAM",
    "state": "TAMIL NADU"
  },
  "639212": {
    "city": "GOPICHETTIPALAYAM",
    "state": "TAMIL NADU"
  },
  "641000": {
    "city": "COIMBATORE",
    "state": "TAMIL NADU"
  },
  "641001": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641002": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641003": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641004": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641005": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641006": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641007": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641008": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641009": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641010": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641011": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641012": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641013": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641014": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641015": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641016": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641017": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641018": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641019": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641020": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641021": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641022": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641023": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641024": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641025": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641026": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641027": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641028": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641029": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641030": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641031": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641032": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641033": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641034": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641035": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641036": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641037": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641038": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641039": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641040": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641041": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641042": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641043": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641044": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641045": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641046": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641047": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641048": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641049": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641050": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641061": {
    "city": "COIMBATORE",
    "state": "TAMIL NADU"
  },
  "641062": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641064": {
    "city": "COIMBATORE",
    "state": "TAMIL NADU"
  },
  "641065": {
    "city": "AVINASHI ROAD",
    "state": "TAMIL NADU"
  },
  "641101": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641102": {
    "city": "METTUPALAYAM",
    "state": "TAMIL NADU"
  },
  "641103": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641104": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641105": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641106": {
    "city": "ANNUR",
    "state": "TAMIL NADU"
  },
  "641107": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641108": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641109": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641110": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641111": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641112": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641113": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641114": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641115": {
    "city": "METTUPALAYAM",
    "state": "TAMIL NADU"
  },
  "641116": {
    "city": "METTUPALAYAM",
    "state": "TAMIL NADU"
  },
  "641117": {
    "city": "METTUPALAYAM",
    "state": "TAMIL NADU"
  },
  "641118": {
    "city": "METTUPALAYAM",
    "state": "TAMIL NADU"
  },
  "641120": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "641201": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641202": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641204": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "641301": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641302": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641303": {
    "city": "METTUPALAYAM",
    "state": "TAMIL NADU"
  },
  "641304": {
    "city": "ANNUR",
    "state": "TAMIL NADU"
  },
  "641305": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641401": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641402": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641404": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "641405": {
    "city": "COIMBATORE",
    "state": "TAMIL NADU"
  },
  "641406": {
    "city": "AVINASHI ROAD",
    "state": "TAMIL NADU"
  },
  "641407": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641408": {
    "city": "PALLADAM",
    "state": "TAMIL NADU"
  },
  "641601": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641602": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641603": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641604": {
    "city": "Tiruppur",
    "state": "Tamil Nadu"
  },
  "641605": {
    "city": "Erode",
    "state": "Tamil Nadu"
  },
  "641606": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641607": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641608": {
    "city": "TIRUPUR",
    "state": "TAMIL NADU"
  },
  "641652": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641653": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641654": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641655": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641658": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641659": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641662": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641663": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641664": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641665": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641666": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641667": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641668": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641669": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641670": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641671": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641687": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "641697": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642001": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642002": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642003": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642004": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642005": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642006": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642007": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642008": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642019": {
    "city": "KINATHUKADAVU",
    "state": "TAMIL NADU"
  },
  "642051": {
    "city": "PALLADAM",
    "state": "TAMIL NADU"
  },
  "642052": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642053": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642054": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642055": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642101": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642102": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642103": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642104": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642105": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642106": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642107": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642108": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642109": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642110": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642111": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642112": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642113": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642114": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642115": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642116": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642117": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642118": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642119": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642120": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642122": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642123": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642124": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642125": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642126": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642127": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642128": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642129": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642130": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642131": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642132": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642133": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642134": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642135": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642136": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642137": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642138": {
    "city": "UDUMALAIPPATTAI",
    "state": "TAMIL NADU"
  },
  "642139": {
    "city": "UDUMALAIPPATTAI",
    "state": "TAMIL NADU"
  },
  "642140": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642141": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642142": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642143": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642144": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642145": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642146": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642147": {
    "city": "METTUPALAYAM",
    "state": "TAMIL NADU"
  },
  "642148": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642149": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642152": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642153": {
    "city": "POLLACHI",
    "state": "TAMIL NADU"
  },
  "642154": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642201": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642202": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642203": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642204": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642205": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642206": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "642207": {
    "city": "Coimbatore",
    "state": "Tamil Nadu"
  },
  "643001": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643002": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643003": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643004": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643005": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643006": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643007": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643051": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643052": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643053": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643054": {
    "city": "TIRUNELVELLI",
    "state": "TAMIL NADU"
  },
  "643055": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643101": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643102": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643103": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643104": {
    "city": "COONOOR",
    "state": "TAMIL NADU"
  },
  "643105": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643106": {
    "city": "COONOOR",
    "state": "TAMIL NADU"
  },
  "643201": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643202": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643203": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643204": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643205": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643206": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643207": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643209": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643210": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643211": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643212": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643213": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643214": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643215": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643216": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643217": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643218": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643219": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643220": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643221": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643222": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643223": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643224": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643225": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643226": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643228": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643229": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643230": {
    "city": "COONOOR",
    "state": "TAMIL NADU"
  },
  "643231": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643232": {
    "city": "COONOOR",
    "state": "TAMIL NADU"
  },
  "643233": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643234": {
    "city": "COONOOR",
    "state": "TAMIL NADU"
  },
  "643235": {
    "city": "COONOOR",
    "state": "TAMIL NADU"
  },
  "643236": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643237": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643238": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643239": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643240": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643241": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643242": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643243": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643244": {
    "city": "COONOOR",
    "state": "TAMIL NADU"
  },
  "643245": {
    "city": "KOTGIRI",
    "state": "TAMIL NADU"
  },
  "643246": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643247": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643248": {
    "city": "COONOOR",
    "state": "TAMIL NADU"
  },
  "643249": {
    "city": "KOTGIRI",
    "state": "TAMIL NADU"
  },
  "643250": {
    "city": "GUDALUR",
    "state": "TAMIL NADU"
  },
  "643251": {
    "city": "GUDALUR",
    "state": "TAMIL NADU"
  },
  "643252": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643253": {
    "city": "Nilgiris",
    "state": "Tamil Nadu"
  },
  "643254": {
    "city": "GUDALUR",
    "state": "TAMIL NADU"
  },
  "643255": {
    "city": "GUDALUR",
    "state": "TAMIL NADU"
  },
  "643256": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643257": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643258": {
    "city": "COONOOR",
    "state": "TAMIL NADU"
  },
  "643259": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643260": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643261": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643263": {
    "city": "GUDALUR",
    "state": "TAMIL NADU"
  },
  "643264": {
    "city": "KOTGIRI",
    "state": "TAMIL NADU"
  },
  "643265": {
    "city": "KOTGIRI",
    "state": "TAMIL NADU"
  },
  "643266": {
    "city": "KOTGIRI",
    "state": "TAMIL NADU"
  },
  "643267": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643268": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643269": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643270": {
    "city": "GUDALUR",
    "state": "TAMIL NADU"
  },
  "643271": {
    "city": "KOTGIRI",
    "state": "TAMIL NADU"
  },
  "643272": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643273": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643276": {
    "city": "KOTGIRI",
    "state": "TAMIL NADU"
  },
  "643277": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643278": {
    "city": "COONOOR",
    "state": "TAMIL NADU"
  },
  "643279": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643280": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "643282": {
    "city": "COONOOR",
    "state": "TAMIL NADU"
  },
  "643518": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "666213": {
    "city": "OOTY",
    "state": "TAMIL NADU"
  },
  "666666": {
    "city": "MAA HUB HAL DELIVERY",
    "state": "TAMIL NADU"
  },
  "666677": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "666688": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "666699": {
    "city": "CHENNAI",
    "state": "TAMIL NADU"
  },
  "666777": {
    "city": "MAA-ROYAL IMAGES",
    "state": "TAMIL NADU"
  },
  "670001": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670002": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670003": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670004": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670005": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670006": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670007": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670008": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670009": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670010": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670011": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670012": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670013": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670014": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670015": {
    "city": "CANNANORE",
    "state": "KERALA"
  },
  "670016": {
    "city": "CANNANORE",
    "state": "KERALA"
  },
  "670017": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670018": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670022": {
    "city": "KANNUR",
    "state": "KERALA"
  },
  "670101": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670102": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670103": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670104": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670105": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670106": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670107": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670109": {
    "city": "THALASSERY",
    "state": "KERALA"
  },
  "670110": {
    "city": "THALASSERY",
    "state": "KERALA"
  },
  "670111": {
    "city": "THALASSERY",
    "state": "KERALA"
  },
  "670121": {
    "city": "THALASSERY",
    "state": "KERALA"
  },
  "670141": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670142": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670143": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670144": {
    "city": "Taliparamba",
    "state": "KERALA"
  },
  "670301": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670302": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670303": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670304": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670305": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670306": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670307": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670308": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670309": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670310": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670312": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670313": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670314": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670315": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670316": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670317": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670318": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670319": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670321": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670322": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670325": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670327": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670330": {
    "city": "KANNUR",
    "state": "KERALA"
  },
  "670331": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670332": {
    "city": "KANNUR",
    "state": "KERALA"
  },
  "670333": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670334": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670337": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670338": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670339": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670343": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670346": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670353": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670354": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670358": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670501": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670502": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670503": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670504": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670507": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670511": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670521": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670522": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "670543": {
    "city": "KANNUR",
    "state": "KERALA"
  },
  "670561": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670562": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670563": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670564": {
    "city": "KANNUR",
    "state": "KERALA"
  },
  "670565": {
    "city": "CANNANORE",
    "state": "KERALA"
  },
  "670566": {
    "city": "KANNUR",
    "state": "KERALA"
  },
  "670567": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670571": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670581": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670582": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670583": {
    "city": "IRITTY",
    "state": "KERALA"
  },
  "670591": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670592": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670593": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670594": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670595": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670597": {
    "city": "CANNANORE",
    "state": "KERALA"
  },
  "670601": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670602": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670603": {
    "city": "KANNUR",
    "state": "KERALA"
  },
  "670604": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670605": {
    "city": "KANNUR",
    "state": "KERALA"
  },
  "670611": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670612": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670613": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670614": {
    "city": "KANNUR",
    "state": "KERALA"
  },
  "670615": {
    "city": "KANNUR",
    "state": "KERALA"
  },
  "670621": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670622": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670631": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670632": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670633": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670641": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670642": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670643": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670644": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "670645": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "670646": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "670647": {
    "city": "Kuthuparamba",
    "state": "KERALA"
  },
  "670648": {
    "city": "THALASSERY",
    "state": "KERALA"
  },
  "670649": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670650": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670651": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670661": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670662": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670663": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670671": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670672": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670673": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670674": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670675": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670676": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670677": {
    "city": "THALASSERY",
    "state": "KERALA"
  },
  "670678": {
    "city": "THALASSERY",
    "state": "KERALA"
  },
  "670679": {
    "city": "THALASSERY",
    "state": "KERALA"
  },
  "670691": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670692": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670693": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670694": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670695": {
    "city": "THALASSERY",
    "state": "KERALA"
  },
  "670701": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670702": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670703": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670704": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670705": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670706": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "670721": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "670731": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "670732": {
    "city": "MANANTHAVADY",
    "state": "KERALA"
  },
  "670741": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "671121": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671122": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671123": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671124": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671125": {
    "city": "KASARAGOD",
    "state": "KERALA"
  },
  "671128": {
    "city": "KASARAGOD",
    "state": "KERALA"
  },
  "671221": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "671310": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671311": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671312": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671313": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671314": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671315": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671316": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671317": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671318": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671319": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671320": {
    "city": "KASARAGOD",
    "state": "KERALA"
  },
  "671321": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671322": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671323": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671324": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671326": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671328": {
    "city": "KANHANGAD",
    "state": "KERALA"
  },
  "671329": {
    "city": "KANHANGAD",
    "state": "KERALA"
  },
  "671341": {
    "city": "KANHANGAD",
    "state": "KERALA"
  },
  "671344": {
    "city": "VELLARIKUNDU",
    "state": "KERALA"
  },
  "671345": {
    "city": "VELLARIKUNDU",
    "state": "KERALA"
  },
  "671348": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671349": {
    "city": "PAYYANUR",
    "state": "KERALA"
  },
  "671350": {
    "city": "KANHANGAD",
    "state": "KERALA"
  },
  "671351": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671353": {
    "city": "KANHANGAD",
    "state": "KERALA"
  },
  "671357": {
    "city": "KANHANGAD",
    "state": "KERALA"
  },
  "671531": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671532": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671533": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671534": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671535": {
    "city": "VELLARIKUNDU",
    "state": "KERALA"
  },
  "671541": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671542": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671543": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671544": {
    "city": "KASARAGOD",
    "state": "KERALA"
  },
  "671545": {
    "city": "KASARAGOD",
    "state": "KERALA"
  },
  "671551": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "671552": {
    "city": "Kasargod",
    "state": "Kerala"
  },
  "672212": {
    "city": "KASARAGOD",
    "state": "KERALA"
  },
  "672301": {
    "city": "KASARAGOD",
    "state": "KERALA"
  },
  "673000": {
    "city": "KOZHIKODE",
    "state": "KERALA"
  },
  "673001": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673002": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673003": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673004": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673005": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673006": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673007": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673008": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673009": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673010": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673011": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673012": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673013": {
    "city": "CALICUT",
    "state": "KERALA"
  },
  "673014": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673015": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673016": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673017": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673018": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673019": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673020": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673021": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673022": {
    "city": "KOZHIKODE",
    "state": "KERALA"
  },
  "673023": {
    "city": "KOZHIKODE",
    "state": "KERALA"
  },
  "673024": {
    "city": "CALICUT",
    "state": "KERALA"
  },
  "673025": {
    "city": "CALICUT",
    "state": "KERALA"
  },
  "673026": {
    "city": "CALICUT",
    "state": "KERALA"
  },
  "673027": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673028": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673029": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673031": {
    "city": "CALICUT",
    "state": "KERALA"
  },
  "673032": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673035": {
    "city": "KOZHIKODE",
    "state": "KERALA"
  },
  "673037": {
    "city": "CALICUT",
    "state": "KERALA"
  },
  "673051": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673101": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673102": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673103": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673104": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673105": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673106": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673107": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673108": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673109": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673110": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673111": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673112": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673121": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673122": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673123": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673124": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673125": {
    "city": "KALPETTA",
    "state": "KERALA"
  },
  "673126": {
    "city": "KALPETTA",
    "state": "KERALA"
  },
  "673212": {
    "city": "KALPETTA",
    "state": "KERALA"
  },
  "673300": {
    "city": "KOZHIKODE",
    "state": "KERALA"
  },
  "673301": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673302": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673303": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673304": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673305": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673306": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673307": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673308": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673309": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673310": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673311": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "673312": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "673313": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "673314": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "673315": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673316": {
    "city": "Kannur",
    "state": "Kerala"
  },
  "673317": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673318": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673319": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673320": {
    "city": "THALASSERY",
    "state": "KERALA"
  },
  "673321": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673322": {
    "city": "KOZHIKODE",
    "state": "KERALA"
  },
  "673323": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673324": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673325": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673326": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673327": {
    "city": "KONDOTTY",
    "state": "KERALA"
  },
  "673328": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673330": {
    "city": "Nilambur",
    "state": "KERALA"
  },
  "673333": {
    "city": "THALASSERY",
    "state": "KERALA"
  },
  "673338": {
    "city": "KONDOTTY",
    "state": "KERALA"
  },
  "673500": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673501": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673502": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673503": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673504": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673505": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673506": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673507": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673508": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673509": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673510": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673511": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673512": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673513": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673514": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673515": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673516": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673517": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673518": {
    "city": "Perambra",
    "state": "KERALA"
  },
  "673519": {
    "city": "Perambra",
    "state": "KERALA"
  },
  "673520": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673521": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673522": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673523": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673524": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673525": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673526": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673527": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673528": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673529": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673530": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673531": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673532": {
    "city": "Perambra",
    "state": "KERALA"
  },
  "673533": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673534": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673535": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673541": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673542": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673543": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673544": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673555": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673557": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673558": {
    "city": "VADAKARA",
    "state": "KERALA"
  },
  "673570": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673571": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673572": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673573": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673574": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673575": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673576": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673577": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673578": {
    "city": "KALPETTA",
    "state": "KERALA"
  },
  "673579": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673580": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673581": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673582": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673583": {
    "city": "THAMARASSERY",
    "state": "KERALA"
  },
  "673584": {
    "city": "THAMARASSERY",
    "state": "KERALA"
  },
  "673585": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673586": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673587": {
    "city": "THAMARASSERY",
    "state": "KERALA"
  },
  "673588": {
    "city": "THAMARASSERY",
    "state": "KERALA"
  },
  "673589": {
    "city": "THAMARASSERY",
    "state": "KERALA"
  },
  "673591": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673592": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673593": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673595": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673596": {
    "city": "Wayanad",
    "state": "Kerala"
  },
  "673600": {
    "city": "THAMARASSERY",
    "state": "KERALA"
  },
  "673601": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673602": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673603": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673604": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673607": {
    "city": "THAMARASSERY",
    "state": "KERALA"
  },
  "673611": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673612": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673613": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673614": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673615": {
    "city": "THAMARASSERY",
    "state": "KERALA"
  },
  "673616": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673617": {
    "city": "KOZHIKODE",
    "state": "KERALA"
  },
  "673618": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673619": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673620": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673621": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673622": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673623": {
    "city": "THAMARASSERY",
    "state": "KERALA"
  },
  "673624": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673631": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673632": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673633": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673634": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "673635": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "673636": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "673637": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "673638": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "673639": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "673640": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "673641": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "673642": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "673643": {
    "city": "Mankavu",
    "state": "KERALA"
  },
  "673644": {
    "city": "KONDOTTY",
    "state": "KERALA"
  },
  "673645": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "673647": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "673648": {
    "city": "KONDOTTY",
    "state": "KERALA"
  },
  "673649": {
    "city": "KONDOTTY",
    "state": "KERALA"
  },
  "673650": {
    "city": "KONDOTTY",
    "state": "KERALA"
  },
  "673651": {
    "city": "KONDOTTY",
    "state": "KERALA"
  },
  "673652": {
    "city": "KONDOTTY",
    "state": "KERALA"
  },
  "673653": {
    "city": "KONDOTTY",
    "state": "KERALA"
  },
  "673654": {
    "city": "QUILANDY",
    "state": "KERALA"
  },
  "673655": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "673661": {
    "city": "Kozhikode",
    "state": "Kerala"
  },
  "676101": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676102": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676103": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676104": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676105": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676106": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676107": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676108": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676109": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676110": {
    "city": "PONNANI",
    "state": "KERALA"
  },
  "676111": {
    "city": "KOTTAKKAL",
    "state": "KERALA"
  },
  "676121": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676122": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676123": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676124": {
    "city": "MANJERI",
    "state": "KERALA"
  },
  "676125": {
    "city": "MANJERI",
    "state": "KERALA"
  },
  "676126": {
    "city": "MANJERI",
    "state": "KERALA"
  },
  "676127": {
    "city": "MANJERI",
    "state": "KERALA"
  },
  "676128": {
    "city": "MANJERI",
    "state": "KERALA"
  },
  "676161": {
    "city": "MANJERI",
    "state": "KERALA"
  },
  "676258": {
    "city": "KANNUR",
    "state": "KERALA"
  },
  "676301": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676302": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676303": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676304": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676305": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676306": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676307": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676308": {
    "city": "Chemmad",
    "state": "KERALA"
  },
  "676309": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676310": {
    "city": "KOTTAKKAL",
    "state": "KERALA"
  },
  "676311": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676312": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676313": {
    "city": "KOTTAKKAL",
    "state": "KERALA"
  },
  "676314": {
    "city": "Chemmad",
    "state": "KERALA"
  },
  "676315": {
    "city": "KONDOTTY",
    "state": "KERALA"
  },
  "676317": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676318": {
    "city": "KONDOTTY",
    "state": "KERALA"
  },
  "676319": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676320": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676322": {
    "city": "KOTTAKKAL",
    "state": "KERALA"
  },
  "676501": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676502": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676503": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676504": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676505": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676506": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676507": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676508": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676509": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676510": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676511": {
    "city": "KOTTAKKAL",
    "state": "KERALA"
  },
  "676512": {
    "city": "KOTTAKKAL",
    "state": "KERALA"
  },
  "676513": {
    "city": "MANJERI",
    "state": "KERALA"
  },
  "676514": {
    "city": "MANJERI",
    "state": "KERALA"
  },
  "676515": {
    "city": "KOTTAKKAL",
    "state": "KERALA"
  },
  "676516": {
    "city": "MANJERI",
    "state": "KERALA"
  },
  "676517": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676518": {
    "city": "MANJERI",
    "state": "KERALA"
  },
  "676519": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676520": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "676521": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676522": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676523": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676525": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676526": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "676528": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676541": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676542": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676551": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676552": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676553": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676554": {
    "city": "KOTTAKKAL",
    "state": "KERALA"
  },
  "676556": {
    "city": "KOTTAKKAL",
    "state": "KERALA"
  },
  "676557": {
    "city": "KOTTAKKAL",
    "state": "KERALA"
  },
  "676561": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676562": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "676577": {
    "city": "PONNANI",
    "state": "KERALA"
  },
  "676587": {
    "city": "ERNAKULAM",
    "state": "KERALA"
  },
  "678001": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678002": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678003": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678004": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678005": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678006": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678007": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678008": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678009": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678010": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678011": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678012": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678013": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678014": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678015": {
    "city": "PALAKKAD",
    "state": "KERALA"
  },
  "678016": {
    "city": "PALAKKAD",
    "state": "KERALA"
  },
  "678017": {
    "city": "PALAKKAD",
    "state": "KERALA"
  },
  "678018": {
    "city": "PALAKKAD",
    "state": "KERALA"
  },
  "678019": {
    "city": "PALAKKAD",
    "state": "KERALA"
  },
  "678020": {
    "city": "PALAKKAD",
    "state": "KERALA"
  },
  "678021": {
    "city": "PALAKKAD",
    "state": "KERALA"
  },
  "678030": {
    "city": "PALAKKAD",
    "state": "KERALA"
  },
  "678101": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678102": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678103": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678104": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678501": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678502": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678503": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678504": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678505": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678506": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678507": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678508": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678509": {
    "city": "ALATHUR",
    "state": "KERALA"
  },
  "678510": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678511": {
    "city": "ALATHUR",
    "state": "KERALA"
  },
  "678512": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678513": {
    "city": "ALATHUR",
    "state": "KERALA"
  },
  "678531": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678532": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678533": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678534": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678541": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678542": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678543": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678544": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678545": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678546": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678547": {
    "city": "ALATHUR",
    "state": "KERALA"
  },
  "678548": {
    "city": "ALATHUR",
    "state": "KERALA"
  },
  "678551": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678552": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678553": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678554": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678555": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678556": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678557": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678558": {
    "city": "PALAKKAD",
    "state": "KERALA"
  },
  "678559": {
    "city": "PALAKKAD",
    "state": "KERALA"
  },
  "678571": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678572": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678573": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678574": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678575": {
    "city": "ALATHUR",
    "state": "KERALA"
  },
  "678578": {
    "city": "PALAKKAD",
    "state": "KERALA"
  },
  "678581": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678582": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678583": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678584": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "678585": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "678586": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "678587": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "678589": {
    "city": "Mannarkkad",
    "state": "KERALA"
  },
  "678591": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678592": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678593": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678594": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678595": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678596": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678597": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678598": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678600": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "678601": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678605": {
    "city": "Mannarkkad",
    "state": "KERALA"
  },
  "678609": {
    "city": "Mannarkkad",
    "state": "KERALA"
  },
  "678611": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678612": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678613": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678614": {
    "city": "SHORNUR",
    "state": "KERALA"
  },
  "678615": {
    "city": "SHORNUR",
    "state": "KERALA"
  },
  "678616": {
    "city": "SHORNUR",
    "state": "KERALA"
  },
  "678621": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678622": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678623": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678624": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678631": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678632": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678633": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678634": {
    "city": "SHORNUR",
    "state": "KERALA"
  },
  "678635": {
    "city": "SHORNUR",
    "state": "KERALA"
  },
  "678637": {
    "city": "SHORNUR",
    "state": "KERALA"
  },
  "678641": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678642": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678651": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678661": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678671": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678678": {
    "city": "ALATHUR",
    "state": "KERALA"
  },
  "678681": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678682": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678683": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678684": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678685": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678686": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678687": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678688": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678689": {
    "city": "ALATHUR",
    "state": "KERALA"
  },
  "678701": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678702": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678703": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678704": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678705": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678706": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678707": {
    "city": "PALAKKAD",
    "state": "KERALA"
  },
  "678708": {
    "city": "ALATHUR",
    "state": "KERALA"
  },
  "678709": {
    "city": "ALATHUR",
    "state": "KERALA"
  },
  "678711": {
    "city": "ALATHUR",
    "state": "KERALA"
  },
  "678721": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678722": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678731": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678732": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678733": {
    "city": "PALAKKAD",
    "state": "KERALA"
  },
  "678752": {
    "city": "Mannarkkad",
    "state": "KERALA"
  },
  "678761": {
    "city": "Mannarkkad",
    "state": "KERALA"
  },
  "678762": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "678921": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "679101": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679102": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679103": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679104": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679105": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "679106": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "679121": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679122": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679123": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679124": {
    "city": "Pattambi",
    "state": "KERALA"
  },
  "679125": {
    "city": "SHORNUR",
    "state": "KERALA"
  },
  "679301": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679302": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679303": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679304": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679305": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679306": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679307": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679308": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679309": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679310": {
    "city": "Pattambi",
    "state": "KERALA"
  },
  "679311": {
    "city": "Pattambi",
    "state": "KERALA"
  },
  "679312": {
    "city": "Pattambi",
    "state": "KERALA"
  },
  "679313": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679314": {
    "city": "Pattambi",
    "state": "KERALA"
  },
  "679321": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679322": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679323": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679324": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679325": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679326": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679327": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679328": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679329": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679330": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679331": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679332": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679333": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679334": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679335": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679336": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679337": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679338": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679339": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679340": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679341": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679342": {
    "city": "Nilambur",
    "state": "KERALA"
  },
  "679343": {
    "city": "Nilambur",
    "state": "KERALA"
  },
  "679344": {
    "city": "Nilambur",
    "state": "KERALA"
  },
  "679348": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "679350": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "679351": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "679352": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "679354": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "679355": {
    "city": "Nilambur",
    "state": "KERALA"
  },
  "679356": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "679357": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679501": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679502": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679503": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679504": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679505": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679506": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679511": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679512": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679513": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679514": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679515": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679516": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679517": {
    "city": "SHORNUR",
    "state": "KERALA"
  },
  "679518": {
    "city": "SHORNUR",
    "state": "KERALA"
  },
  "679519": {
    "city": "PERINTHALMANNA",
    "state": "KERALA"
  },
  "679521": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679522": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679523": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679531": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "679532": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "679533": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679534": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679535": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679536": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679537": {
    "city": "KUNNAMKULAM",
    "state": "KERALA"
  },
  "679538": {
    "city": "KUNNAMKULAM",
    "state": "KERALA"
  },
  "679539": {
    "city": "KUNNAMKULAM",
    "state": "KERALA"
  },
  "679551": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679552": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679553": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679554": {
    "city": "Palakkad",
    "state": "Kerala"
  },
  "679556": {
    "city": "PONNANI",
    "state": "KERALA"
  },
  "679561": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "679562": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "679563": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "679564": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "679571": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679572": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679573": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679574": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679575": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679576": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679577": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679578": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679579": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679580": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679581": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679582": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679583": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679584": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679585": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679586": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679587": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679588": {
    "city": "PONNANI",
    "state": "KERALA"
  },
  "679589": {
    "city": "PONNANI",
    "state": "KERALA"
  },
  "679590": {
    "city": "PONNANI",
    "state": "KERALA"
  },
  "679591": {
    "city": "Malappuram",
    "state": "Kerala"
  },
  "679592": {
    "city": "PONNANI",
    "state": "KERALA"
  },
  "679594": {
    "city": "PONNANI",
    "state": "KERALA"
  },
  "679633": {
    "city": "KUNNAMKULAM",
    "state": "KERALA"
  },
  "680001": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680002": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680003": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680004": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680005": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680006": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680007": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680008": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680009": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680010": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680011": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680012": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680013": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680014": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680015": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680016": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680017": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680018": {
    "city": "TRICHUR",
    "state": "KERALA"
  },
  "680019": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680020": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680021": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680022": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680026": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680027": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680028": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680052": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680101": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680102": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680103": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680104": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680111": {
    "city": "KUNNAMKULAM",
    "state": "KERALA"
  },
  "680121": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680122": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680123": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680124": {
    "city": "THRIPRAYAR",
    "state": "KERALA"
  },
  "680125": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680203": {
    "city": "CHALAKUDY",
    "state": "KERALA"
  },
  "680221": {
    "city": "CHALAKUDY",
    "state": "KERALA"
  },
  "680301": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680302": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680303": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680304": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680305": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680306": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680307": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680308": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680309": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680310": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680311": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680312": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680313": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680314": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680315": {
    "city": "CHALAKUDY",
    "state": "KERALA"
  },
  "680316": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680317": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680318": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680319": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680320": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680321": {
    "city": "CHALAKUDY",
    "state": "KERALA"
  },
  "680322": {
    "city": "AMBALLUR",
    "state": "KERALA"
  },
  "680323": {
    "city": "CHALAKUDY",
    "state": "KERALA"
  },
  "680324": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680325": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680501": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680502": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680503": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680504": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680505": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680506": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680507": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680508": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680509": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680510": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680511": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680512": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680513": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680514": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680515": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680516": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680517": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680518": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680519": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680520": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680521": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680522": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680523": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680524": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680534": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680541": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680542": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680543": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680544": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680545": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680546": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680547": {
    "city": "KUNNAMKULAM",
    "state": "KERALA"
  },
  "680549": {
    "city": "KUNNAMKULAM",
    "state": "KERALA"
  },
  "680550": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680551": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680552": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680553": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680554": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680555": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680561": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680562": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680563": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680564": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680565": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680566": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680567": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680568": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680569": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680570": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680571": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680572": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680573": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680574": {
    "city": "THRIPRAYAR",
    "state": "KERALA"
  },
  "680575": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680581": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680582": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680583": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680584": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680585": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680586": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680587": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680588": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680589": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680590": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680591": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680592": {
    "city": "WADAKKANCHERY",
    "state": "KERALA"
  },
  "680593": {
    "city": "WADAKKANCHERY",
    "state": "KERALA"
  },
  "680594": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680595": {
    "city": "WADAKKANCHERY",
    "state": "KERALA"
  },
  "680596": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680597": {
    "city": "WADAKKANCHERY",
    "state": "KERALA"
  },
  "680600": {
    "city": "KUNNAMKULAM",
    "state": "KERALA"
  },
  "680601": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680602": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680603": {
    "city": "KUNNAMKULAM",
    "state": "KERALA"
  },
  "680604": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680608": {
    "city": "KUNNAMKULAM",
    "state": "KERALA"
  },
  "680609": {
    "city": "KUNNAMKULAM",
    "state": "KERALA"
  },
  "680610": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680611": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680612": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680613": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680614": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680615": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680616": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680617": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680618": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680619": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680620": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680621": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680623": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680631": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680641": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680642": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680651": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680652": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680653": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680654": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680655": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680656": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680657": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680661": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680662": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680663": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680664": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680665": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680666": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680667": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680668": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680669": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680670": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680671": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680672": {
    "city": "Kodungallur",
    "state": "KERALA"
  },
  "680673": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "680681": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680682": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680683": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680684": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680685": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680686": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680687": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680688": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680689": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680691": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680692": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "680693": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "680694": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "680695": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "680697": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680698": {
    "city": "CHALAKUDY",
    "state": "KERALA"
  },
  "680699": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680701": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680702": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680703": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680704": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680711": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680712": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680721": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680722": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680723": {
    "city": "CHALAKUDY",
    "state": "KERALA"
  },
  "680724": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680725": {
    "city": "CHALAKUDY",
    "state": "KERALA"
  },
  "680731": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680732": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680733": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680734": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680735": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "680736": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "680741": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680751": {
    "city": "Thrissur",
    "state": "Kerala"
  },
  "680752": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "680771": {
    "city": "WADAKKANCHERY",
    "state": "KERALA"
  },
  "681315": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "681528": {
    "city": "THRISSUR",
    "state": "KERALA"
  },
  "682000": {
    "city": "COCHIN",
    "state": "KERALA"
  },
  "682001": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682002": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682003": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682004": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682005": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682006": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682007": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682008": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682009": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682010": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682011": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682012": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682013": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682014": {
    "city": "COCHIN",
    "state": "KERALA"
  },
  "682015": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682016": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682017": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682018": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682019": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682020": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682021": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682022": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682023": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682024": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682025": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682026": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682027": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682028": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682029": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682030": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682031": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682032": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682033": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682034": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682035": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682036": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682037": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682038": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682039": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682040": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682041": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682042": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682044": {
    "city": "SHORNUR",
    "state": "KERALA"
  },
  "682050": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682051": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682204": {
    "city": "SHORNUR",
    "state": "KERALA"
  },
  "682222": {
    "city": "COCHIN",
    "state": "KERALA"
  },
  "682301": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682302": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682303": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682304": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682305": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682306": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682307": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682308": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682309": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682310": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682311": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682312": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682313": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682314": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682315": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682316": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682317": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682319": {
    "city": "PIRAVOM",
    "state": "KERALA"
  },
  "682320": {
    "city": "PIRAVOM",
    "state": "KERALA"
  },
  "682501": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682502": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682503": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682504": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682505": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682506": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682507": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682508": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682509": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "682510": {
    "city": "KOCHI",
    "state": "KERALA"
  },
  "682511": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683001": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "683012": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "683021": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "683101": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683102": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683103": {
    "city": "ALUVA",
    "state": "KERALA"
  },
  "683104": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683105": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683106": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683107": {
    "city": "ALUVA",
    "state": "KERALA"
  },
  "683108": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683109": {
    "city": "COCHIN",
    "state": "KERALA"
  },
  "683110": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683111": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683112": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683204": {
    "city": "ALUVA",
    "state": "KERALA"
  },
  "683302": {
    "city": "ALUVA",
    "state": "KERALA"
  },
  "683303": {
    "city": "ALUVA",
    "state": "KERALA"
  },
  "683473": {
    "city": "ANGAMALY",
    "state": "KERALA"
  },
  "683501": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683502": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683503": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683504": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "683511": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683512": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683513": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683514": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683515": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683516": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683517": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683518": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683519": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683520": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683521": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683522": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683523": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "683524": {
    "city": "Angamaly",
    "state": "KERALA"
  },
  "683525": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "683541": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683542": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683543": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683544": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683545": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683546": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683547": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683548": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683549": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683550": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683553": {
    "city": "ALUVA",
    "state": "KERALA"
  },
  "683554": {
    "city": "ERNAKULAM",
    "state": "KERALA"
  },
  "683555": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "683556": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683557": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "683561": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683562": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683563": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683564": {
    "city": "ALUVA",
    "state": "KERALA"
  },
  "683565": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683571": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683572": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683573": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683574": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683575": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683576": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683577": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683578": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683579": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683580": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683581": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683582": {
    "city": "Angamaly",
    "state": "KERALA"
  },
  "683583": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "683584": {
    "city": "ALUVA",
    "state": "KERALA"
  },
  "683585": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683586": {
    "city": "ANGAMALLY",
    "state": "KERALA"
  },
  "683587": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683589": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "683591": {
    "city": "ANGAMALLY",
    "state": "KERALA"
  },
  "683592": {
    "city": "ANGAMALLY",
    "state": "KERALA"
  },
  "683593": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "683594": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "685005": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "685025": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "685050": {
    "city": "NORTH PARAVUR",
    "state": "KERALA"
  },
  "685501": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685502": {
    "city": "KATTAPPANA",
    "state": "KERALA"
  },
  "685503": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685504": {
    "city": "KATTAPPANA",
    "state": "KERALA"
  },
  "685505": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685506": {
    "city": "KATTAPPANA",
    "state": "KERALA"
  },
  "685507": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685508": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685509": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685510": {
    "city": "KATTAPPANA",
    "state": "KERALA"
  },
  "685511": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685512": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685514": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685515": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685518": {
    "city": "KATTAPPANA",
    "state": "KERALA"
  },
  "685524": {
    "city": "KATTAPPANA",
    "state": "KERALA"
  },
  "685531": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685532": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685533": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685535": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685536": {
    "city": "KATTAPPANA",
    "state": "KERALA"
  },
  "685537": {
    "city": "KATTAPPANA",
    "state": "KERALA"
  },
  "685538": {
    "city": "Vandiperiyar",
    "state": "KERALA"
  },
  "685539": {
    "city": "KATTAPPANA",
    "state": "KERALA"
  },
  "685551": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685552": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685553": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685554": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685555": {
    "city": "KATTAPPANA",
    "state": "KERALA"
  },
  "685556": {
    "city": "KATTAPPANA",
    "state": "KERALA"
  },
  "685557": {
    "city": "KATTAPPANA",
    "state": "KERALA"
  },
  "685561": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685562": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685563": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685564": {
    "city": "MUNNAR",
    "state": "KERALA"
  },
  "685565": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685566": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685569": {
    "city": "KATTAPPANA",
    "state": "KERALA"
  },
  "685571": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685581": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685582": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685583": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685584": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685585": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685586": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685587": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685588": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685589": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685590": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685591": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685592": {
    "city": "THODUPUZHA",
    "state": "KERALA"
  },
  "685595": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685597": {
    "city": "THODUPUZHA",
    "state": "KERALA"
  },
  "685601": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685602": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685603": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685604": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685605": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685606": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685607": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685608": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685609": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685611": {
    "city": "MUNNAR",
    "state": "KERALA"
  },
  "685612": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685613": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685614": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685615": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685616": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685617": {
    "city": "MUNNAR",
    "state": "KERALA"
  },
  "685618": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685619": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685620": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "685621": {
    "city": "MUNNAR",
    "state": "KERALA"
  },
  "686001": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686002": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686003": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686004": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686005": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686006": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686007": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686008": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686009": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686010": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686011": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686012": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686013": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686014": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686015": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686016": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686017": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686018": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686019": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686020": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686021": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686022": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686023": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686024": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686025": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686026": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686027": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686028": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686029": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686030": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686031": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686032": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686033": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686034": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686035": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686036": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686037": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686038": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686039": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686040": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686041": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686101": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686102": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "686103": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686104": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686105": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686106": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686107": {
    "city": "CHANGANASSERY",
    "state": "KERALA"
  },
  "686108": {
    "city": "CHANGANASSERY",
    "state": "KERALA"
  },
  "686121": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686122": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686123": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686124": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686141": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686142": {
    "city": "THALAYOLAPARAMBU",
    "state": "KERALA"
  },
  "686143": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686144": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686145": {
    "city": "VAIKOM",
    "state": "KERALA"
  },
  "686146": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686307": {
    "city": "VAIKOM",
    "state": "KERALA"
  },
  "686501": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686502": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686503": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686504": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686505": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686506": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686507": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686508": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686509": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686510": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686511": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "686512": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686513": {
    "city": "Idukki",
    "state": "Kerala"
  },
  "686514": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686515": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686516": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686517": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686518": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686519": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686520": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686521": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686522": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686523": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686524": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686527": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686529": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686531": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686532": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686533": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686534": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "686535": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686536": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686537": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686538": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686539": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686540": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686541": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686542": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686543": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686544": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686545": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686546": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686547": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "686548": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686549": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "686550": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "686552": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "686553": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "686555": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686556": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "686560": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686561": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686562": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686563": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686564": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686565": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686566": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686567": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686568": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686571": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686572": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686573": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686574": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686575": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686576": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686577": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686578": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686579": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686580": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686581": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686582": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686583": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686584": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686585": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686586": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686587": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686588": {
    "city": "MALLAPPALLY",
    "state": "KERALA"
  },
  "686589": {
    "city": "PALAI",
    "state": "KERALA"
  },
  "686590": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686591": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686592": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686594": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686595": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686596": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686597": {
    "city": "PALAI",
    "state": "KERALA"
  },
  "686600": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686601": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686602": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686603": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686604": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686605": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686606": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686607": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686608": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686609": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686610": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686611": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686612": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686613": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686614": {
    "city": "VAIKOM",
    "state": "KERALA"
  },
  "686615": {
    "city": "VAIKOM",
    "state": "KERALA"
  },
  "686616": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686617": {
    "city": "PIRAVOM",
    "state": "KERALA"
  },
  "686619": {
    "city": "QUILON",
    "state": "KERALA"
  },
  "686620": {
    "city": "PIRAVOM",
    "state": "KERALA"
  },
  "686627": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686630": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686631": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686632": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686633": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686634": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686635": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686636": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686637": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686638": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686640": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686641": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686642": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686646": {
    "city": "KOTTAYAM",
    "state": "KERALA"
  },
  "686651": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686652": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686653": {
    "city": "Kottayam",
    "state": "Kerala"
  },
  "686654": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686655": {
    "city": "PALA",
    "state": "KERALA"
  },
  "686661": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686662": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686663": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686664": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686665": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686666": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686667": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686668": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686669": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686670": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686671": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686672": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686673": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686674": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "686676": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "686677": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "686679": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "686680": {
    "city": "QUILON",
    "state": "KERALA"
  },
  "686681": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686683": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "686686": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "686687": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "686689": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "686691": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686692": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686693": {
    "city": "Ernakulam",
    "state": "Kerala"
  },
  "686694": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "686695": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "686696": {
    "city": "THODUPUZHA",
    "state": "KERALA"
  },
  "686697": {
    "city": "THODUPUZHA",
    "state": "KERALA"
  },
  "686698": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "686702": {
    "city": "THODUPUZHA",
    "state": "KERALA"
  },
  "686721": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "686722": {
    "city": "THODUPUZHA",
    "state": "KERALA"
  },
  "686723": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "686726": {
    "city": "PIRAVOM",
    "state": "KERALA"
  },
  "686730": {
    "city": "MUVATTUPUZHA",
    "state": "KERALA"
  },
  "688001": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688002": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688003": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688004": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688005": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688006": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688007": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688008": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688009": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688010": {
    "city": "ALAPPUZHA,ALLEPEY",
    "state": "KERALA"
  },
  "688011": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688012": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688013": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688014": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688016": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688017": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688020": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688022": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688028": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688029": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688042": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688501": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688502": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688503": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688504": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688505": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688506": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688507": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688508": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688509": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688511": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688512": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688521": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688522": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688523": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688524": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688525": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688526": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688527": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688528": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688529": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688530": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688531": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688532": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688533": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688534": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688535": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688536": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688537": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688538": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688539": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688540": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688541": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688542": {
    "city": "ALAPPUZHA,ALLEPEY",
    "state": "KERALA"
  },
  "688543": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688544": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688545": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688546": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688547": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688548": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688549": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688550": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688552": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688554": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688555": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688556": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688557": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688558": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688559": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688560": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688561": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688562": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688563": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688564": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688565": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688566": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688567": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "688570": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688581": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688582": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "688583": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688584": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688585": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688586": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688587": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688625": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "688656": {
    "city": "CHERTHALA",
    "state": "KERALA"
  },
  "689101": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689102": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689103": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689104": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689105": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689106": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689107": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689108": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689109": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689110": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689111": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689112": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689113": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689114": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689115": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689121": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689122": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689123": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689124": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689125": {
    "city": "CHENGANNUR",
    "state": "KERALA"
  },
  "689126": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689501": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689502": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689503": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689504": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689505": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689506": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689507": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689508": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689509": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689510": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689511": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689512": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689513": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689514": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689515": {
    "city": "ADOOR",
    "state": "KERALA"
  },
  "689516": {
    "city": "ADOOR",
    "state": "KERALA"
  },
  "689517": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "689518": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689519": {
    "city": "CHENGANNUR",
    "state": "KERALA"
  },
  "689520": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689521": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689529": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689531": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689532": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689533": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689541": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689542": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689543": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689544": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689545": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689546": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689547": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689548": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689549": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689550": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689551": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689552": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689571": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689572": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689573": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689574": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689575": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689576": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689577": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689578": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689579": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689580": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689581": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689582": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689583": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689584": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689585": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689586": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689587": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689588": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689589": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689590": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689591": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689592": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689593": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689594": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689595": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689596": {
    "city": "MALLAPPALLY",
    "state": "KERALA"
  },
  "689597": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689598": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689600": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689602": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689603": {
    "city": "MALLAPPALLY",
    "state": "KERALA"
  },
  "689611": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689612": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689613": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689614": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689615": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689616": {
    "city": "MALLAPPALLY",
    "state": "KERALA"
  },
  "689620": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689621": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689622": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689623": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689624": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689625": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689626": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689627": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "689628": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "689629": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689630": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "689632": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "689641": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689642": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689643": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689644": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689645": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689646": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689647": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689648": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689649": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689650": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689652": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689653": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689654": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689656": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689657": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "689659": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "689660": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "689661": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689662": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689663": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689664": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689665": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "689666": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689667": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689668": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689671": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689672": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689673": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689674": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689675": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689676": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689677": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689678": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689680": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "689681": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "689682": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "689691": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689692": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689693": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689694": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689695": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "689696": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "689698": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689699": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689703": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "689705": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "689706": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "689711": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "689712": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "689713": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "689721": {
    "city": "THIRUVALLA",
    "state": "KERALA"
  },
  "689722": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "689723": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "689842": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "690001": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "690010": {
    "city": "PATHANAMTHITTA",
    "state": "KERALA"
  },
  "690101": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690102": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690103": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690104": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690105": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690106": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690107": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690108": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690109": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "690110": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690501": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690502": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690503": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690504": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690505": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690506": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690507": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690508": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690509": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690510": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690511": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690512": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690513": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690514": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690515": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690516": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690517": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690518": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690519": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690520": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690521": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690522": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690523": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690524": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690525": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690526": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690527": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690528": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690529": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690530": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690531": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690532": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690533": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690534": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690535": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690536": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690537": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690538": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690539": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690540": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690541": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "690542": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690543": {
    "city": "KARUNAGAPALLI",
    "state": "KERALA"
  },
  "690544": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690546": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690547": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690548": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690549": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "690550": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "690551": {
    "city": "ALAPPUZHA",
    "state": "KERALA"
  },
  "690552": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "690553": {
    "city": "KARUNAGAPALLI",
    "state": "KERALA"
  },
  "690554": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "690555": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "690556": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "690557": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "690558": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690559": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690560": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "690561": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690562": {
    "city": "THODIYOOR",
    "state": "KERALA"
  },
  "690563": {
    "city": "ADOOR",
    "state": "KERALA"
  },
  "690564": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "690565": {
    "city": "ADOOR",
    "state": "KERALA"
  },
  "690566": {
    "city": "ADOOR",
    "state": "KERALA"
  },
  "690567": {
    "city": "ADOOR",
    "state": "KERALA"
  },
  "690568": {
    "city": "ADOOR",
    "state": "KERALA"
  },
  "690569": {
    "city": "KARUNAGAPALLI",
    "state": "KERALA"
  },
  "690570": {
    "city": "MAVELIKARA",
    "state": "KERALA"
  },
  "690571": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690572": {
    "city": "Alappuzha",
    "state": "Kerala"
  },
  "690573": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690574": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "690575": {
    "city": "THODIYOOR",
    "state": "KERALA"
  },
  "691001": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691002": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691003": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691004": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691005": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691006": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691007": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691008": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691009": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691010": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691011": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691012": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691013": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691014": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691015": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691016": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691017": {
    "city": "QUILON",
    "state": "KERALA"
  },
  "691018": {
    "city": "KOLLAM",
    "state": "KERALA"
  },
  "691019": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691020": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691021": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691022": {
    "city": "KOLLAM",
    "state": "KERALA"
  },
  "691300": {
    "city": "KOLLAM",
    "state": "KERALA"
  },
  "691301": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691302": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691303": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691304": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691305": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691306": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691307": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691308": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691309": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691310": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691311": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691312": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691314": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "691315": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "691316": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "691317": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "691318": {
    "city": "KOLLAM",
    "state": "KERALA"
  },
  "691319": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691320": {
    "city": "AYOOR",
    "state": "KERALA"
  },
  "691321": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "691322": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691324": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "691325": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "691326": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "691329": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "691330": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "691331": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691332": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691333": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691334": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691335": {
    "city": "KOLLAM",
    "state": "KERALA"
  },
  "691500": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691501": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691502": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691503": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691504": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691505": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691506": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691507": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691508": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691509": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691510": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691511": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691512": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691513": {
    "city": "KOTTARAKARRA",
    "state": "KERALA"
  },
  "691514": {
    "city": "PUNALUR",
    "state": "KERALA"
  },
  "691515": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691516": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691517": {
    "city": "AYOOR",
    "state": "KERALA"
  },
  "691518": {
    "city": "AYOOR",
    "state": "KERALA"
  },
  "691519": {
    "city": "AYOOR",
    "state": "KERALA"
  },
  "691520": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691521": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691522": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691523": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "691524": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "691525": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "691526": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "691527": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691528": {
    "city": "ADOOR",
    "state": "KERALA"
  },
  "691529": {
    "city": "ADOOR",
    "state": "KERALA"
  },
  "691530": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "691531": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691532": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691533": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691534": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691535": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691536": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691537": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691538": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691539": {
    "city": "AYOOR",
    "state": "KERALA"
  },
  "691540": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691541": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691542": {
    "city": "KOTTARAKKARA",
    "state": "KERALA"
  },
  "691543": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691544": {
    "city": "KOTTARAKARRA",
    "state": "KERALA"
  },
  "691545": {
    "city": "KOTTARAKARRA",
    "state": "KERALA"
  },
  "691546": {
    "city": "KOTTARAKARRA",
    "state": "KERALA"
  },
  "691547": {
    "city": "KOTTARAKARRA",
    "state": "KERALA"
  },
  "691548": {
    "city": "KOTTARAKARRA",
    "state": "KERALA"
  },
  "691550": {
    "city": "ADOOR",
    "state": "KERALA"
  },
  "691551": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "691552": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "691553": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "691554": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "691555": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "691556": {
    "city": "Pathanamthitta",
    "state": "Kerala"
  },
  "691557": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691559": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691560": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691562": {
    "city": "KOTTARAKARRA",
    "state": "KERALA"
  },
  "691566": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691571": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691572": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691573": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691574": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691576": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691577": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691578": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691579": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691580": {
    "city": "KOLLAM",
    "state": "KERALA"
  },
  "691581": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691582": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691583": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691584": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691585": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691586": {
    "city": "THODIYOOR",
    "state": "KERALA"
  },
  "691587": {
    "city": "KARUNAGAPALLI",
    "state": "KERALA"
  },
  "691588": {
    "city": "KOLLAM",
    "state": "KERALA"
  },
  "691589": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691590": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691601": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691602": {
    "city": "Kollam",
    "state": "Kerala"
  },
  "691603": {
    "city": "KOLLAM",
    "state": "KERALA"
  },
  "691604": {
    "city": "KOLLAM",
    "state": "KERALA"
  },
  "691605": {
    "city": "QUILON",
    "state": "KERALA"
  },
  "691623": {
    "city": "KOTTARAKARRA",
    "state": "KERALA"
  },
  "691624": {
    "city": "KOLLAM",
    "state": "KERALA"
  },
  "691625": {
    "city": "KOLLAM",
    "state": "KERALA"
  },
  "691641": {
    "city": "KOLLAM",
    "state": "KERALA"
  },
  "694582": {
    "city": "QUILON",
    "state": "KERALA"
  },
  "695001": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695002": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695003": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695004": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695005": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695006": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695007": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695008": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695009": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695010": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695011": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695012": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695013": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695014": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695015": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695016": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695017": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695018": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695019": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695020": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695021": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695022": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695023": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695024": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695025": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695026": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695027": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695028": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695029": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695030": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695031": {
    "city": "THIRUVANTAPURAM",
    "state": "KERALA"
  },
  "695032": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695033": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695034": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695035": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695036": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695037": {
    "city": "THIRUVANTAPURAM",
    "state": "KERALA"
  },
  "695038": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695039": {
    "city": "THIRUVANTAPURAM",
    "state": "KERALA"
  },
  "695040": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695041": {
    "city": "THIRUVANTAPURAM",
    "state": "KERALA"
  },
  "695042": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695043": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695044": {
    "city": "THIRUVANTAPURAM",
    "state": "KERALA"
  },
  "695049": {
    "city": "THIRUVANTAPURAM",
    "state": "KERALA"
  },
  "695081": {
    "city": "THIRUVANANTHAPURAM",
    "state": "KERALA"
  },
  "695099": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695101": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695102": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695103": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695104": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695105": {
    "city": "ATTINGAL",
    "state": "KERALA"
  },
  "695106": {
    "city": "ATTINGAL",
    "state": "KERALA"
  },
  "695120": {
    "city": "NEYYATTINKARA",
    "state": "KERALA"
  },
  "695121": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695122": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695123": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695124": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695125": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695126": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695127": {
    "city": "NEYYATTINKARA",
    "state": "KERALA"
  },
  "695128": {
    "city": "NEYYATTINKARA",
    "state": "KERALA"
  },
  "695130": {
    "city": "NEYYATTINKARA",
    "state": "KERALA"
  },
  "695131": {
    "city": "NEYYATTINKARA",
    "state": "KERALA"
  },
  "695132": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695133": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695134": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695141": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695142": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695143": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695144": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695145": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695146": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695283": {
    "city": "TECHNOPARK CAMPUS",
    "state": "KERALA"
  },
  "695301": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695302": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695303": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695304": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695305": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695306": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695307": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695308": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695309": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695310": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695311": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695312": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695313": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695314": {
    "city": "ATTINGAL",
    "state": "KERALA"
  },
  "695315": {
    "city": "TECHNOPARK CAMPUS",
    "state": "KERALA"
  },
  "695316": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695317": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695318": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695323": {
    "city": "ATTINGAL",
    "state": "KERALA"
  },
  "695411": {
    "city": "ATTINGAL",
    "state": "KERALA"
  },
  "695501": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695502": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695503": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695504": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695505": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695506": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695507": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695508": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695509": {
    "city": "THIRUVANANATHAPURAM",
    "state": "KERALA"
  },
  "695510": {
    "city": "NEYYATTINKARA",
    "state": "KERALA"
  },
  "695512": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695513": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695521": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695522": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695523": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695524": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695525": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695526": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695527": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695528": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695541": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695542": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695543": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695544": {
    "city": "NEDUMANGAD",
    "state": "KERALA"
  },
  "695545": {
    "city": "TRIVANDRUM",
    "state": "KERALA"
  },
  "695547": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695551": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695557": {
    "city": "NEDUMANGAD",
    "state": "KERALA"
  },
  "695560": {
    "city": "THIRUVANANTHAPURAM",
    "state": "KERALA"
  },
  "695561": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695562": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695563": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695564": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695566": {
    "city": "TECHNOPARK CAMPUS",
    "state": "KERALA"
  },
  "695568": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695571": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695572": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695573": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695574": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695575": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695581": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695582": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695583": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695584": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695585": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695586": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695587": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695588": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695589": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695601": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695602": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695603": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695604": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695605": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695606": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695607": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695608": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695609": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695610": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695611": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695612": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695614": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695615": {
    "city": "Thiruvananthapuram",
    "state": "Kerala"
  },
  "695616": {
    "city": "NEDUMANGAD",
    "state": "KERALA"
  },
  "695618": {
    "city": "ATTINGAL",
    "state": "KERALA"
  },
  "700000": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "700001": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700002": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700003": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700004": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700005": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700006": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700007": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700008": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700009": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700010": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700011": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700012": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700013": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700014": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700015": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700016": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700017": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700018": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700019": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700020": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700021": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700022": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700023": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700024": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700025": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700026": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700027": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700028": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700029": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700030": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700031": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700032": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700033": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700034": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700035": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700036": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700037": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700038": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700039": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700040": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700041": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700042": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700043": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700044": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700045": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700046": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700047": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700048": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700049": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700050": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700051": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700052": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700053": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700054": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700055": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700056": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700057": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700058": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700059": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700060": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700061": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700062": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700063": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700064": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700065": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700066": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700067": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700068": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700069": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700070": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700071": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700072": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700073": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700074": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700075": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700076": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700077": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700078": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700079": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700080": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700081": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700082": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700083": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700084": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700085": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700086": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700087": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700088": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700089": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700090": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700091": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700092": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700093": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700094": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700095": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700096": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700097": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700098": {
    "city": "24 PARGANAS",
    "state": "WEST BENGAL"
  },
  "700099": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700100": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700101": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700102": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700103": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700104": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700105": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700106": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700107": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700108": {
    "city": "Kolkata",
    "state": "West Bengal"
  },
  "700109": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700110": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700111": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700112": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700113": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700114": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700115": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700116": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700117": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700118": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700119": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700120": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700121": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700122": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700123": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700124": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700125": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700126": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700127": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700128": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700129": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700130": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700131": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700132": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700133": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700134": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700135": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700136": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700137": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700138": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700139": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700140": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700141": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700142": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700143": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700144": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700145": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700146": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700147": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700148": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700149": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700150": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700151": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700152": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700153": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700154": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "700155": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700156": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700157": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700158": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700159": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700160": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700161": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "700162": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "701101": {
    "city": "HOWRAH",
    "state": "WEST BENGAL"
  },
  "701102": {
    "city": "HOWRAH",
    "state": "WEST BENGAL"
  },
  "701111": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "711000": {
    "city": "Kolkata",
    "state": "WEST BENGAL"
  },
  "711001": {
    "city": "HOWRAH",
    "state": "WEST BENGAL"
  },
  "711101": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711102": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711103": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711104": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711105": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711106": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711107": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711108": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711109": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711110": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711111": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711112": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711113": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711114": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711115": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711120": {
    "city": "BALLY",
    "state": "WEST BENGAL"
  },
  "711127": {
    "city": "BALLY",
    "state": "WEST BENGAL"
  },
  "711201": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711202": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711203": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711204": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711205": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711206": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711212": {
    "city": "BALLY",
    "state": "WEST BENGAL"
  },
  "711224": {
    "city": "BALLY",
    "state": "WEST BENGAL"
  },
  "711225": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711226": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711227": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711247": {
    "city": "HOWRAH",
    "state": "WEST BENGAL"
  },
  "711301": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711302": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711303": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711304": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711305": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711306": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711307": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711308": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711309": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711310": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711311": {
    "city": "HOWRAH",
    "state": "WEST BENGAL"
  },
  "711312": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711313": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711314": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711315": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711316": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711317": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711320": {
    "city": "HOWRAH",
    "state": "WEST BENGAL"
  },
  "711321": {
    "city": "HOWRAH",
    "state": "WEST BENGAL"
  },
  "711322": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711323": {
    "city": "BALLY",
    "state": "WEST BENGAL"
  },
  "711324": {
    "city": "ULUBERIA",
    "state": "WEST BENGAL"
  },
  "711325": {
    "city": "ULUBERIA",
    "state": "WEST BENGAL"
  },
  "711326": {
    "city": "SHYAMPUR",
    "state": "WEST BENGAL"
  },
  "711327": {
    "city": "ULUBERIA",
    "state": "WEST BENGAL"
  },
  "711328": {
    "city": "BALLY",
    "state": "WEST BENGAL"
  },
  "711401": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711402": {
    "city": "RANIHATI",
    "state": "WEST BENGAL"
  },
  "711403": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711404": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711405": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711406": {
    "city": "SHRIRAMPUR",
    "state": "WEST BENGAL"
  },
  "711408": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711409": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711410": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711411": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711412": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711413": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711414": {
    "city": "Howrah",
    "state": "West Bengal"
  },
  "711415": {
    "city": "RANIHATI",
    "state": "WEST BENGAL"
  },
  "711416": {
    "city": "UDAYNARAYANPUR",
    "state": "WEST BENGAL"
  },
  "712101": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712102": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712103": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712104": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712105": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712106": {
    "city": "CHANDANNAGAR",
    "state": "WEST BENGAL"
  },
  "712112": {
    "city": "CHANDANNAGAR",
    "state": "WEST BENGAL"
  },
  "712121": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712122": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712123": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712124": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712125": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712134": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712135": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712136": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712137": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712138": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712139": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712146": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712147": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712148": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712149": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712150": {
    "city": "CHANDANNAGAR",
    "state": "WEST BENGAL"
  },
  "712151": {
    "city": "KALNA",
    "state": "WEST BENGAL"
  },
  "712152": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712153": {
    "city": "CHANDANNAGAR",
    "state": "WEST BENGAL"
  },
  "712154": {
    "city": "CHANDANNAGAR",
    "state": "WEST BENGAL"
  },
  "712155": {
    "city": "CHANDANNAGAR",
    "state": "WEST BENGAL"
  },
  "712156": {
    "city": "KALNA",
    "state": "WEST BENGAL"
  },
  "712157": {
    "city": "KALNA",
    "state": "WEST BENGAL"
  },
  "712158": {
    "city": "KALNA",
    "state": "WEST BENGAL"
  },
  "712201": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712202": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712203": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712204": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712205": {
    "city": "KONNAGAR",
    "state": "WEST BENGAL"
  },
  "712206": {
    "city": "SHRIRAMPUR",
    "state": "WEST BENGAL"
  },
  "712208": {
    "city": "SHRIRAMPUR",
    "state": "WEST BENGAL"
  },
  "712216": {
    "city": "SHRIRAMPUR",
    "state": "WEST BENGAL"
  },
  "712221": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712222": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712223": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712224": {
    "city": "KONNAGAR",
    "state": "WEST BENGAL"
  },
  "712232": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712233": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712234": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712235": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712245": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712246": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712247": {
    "city": "KONNAGAR",
    "state": "WEST BENGAL"
  },
  "712248": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712249": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712250": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712258": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712301": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712302": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712303": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712304": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712305": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712306": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712307": {
    "city": "SHRIRAMPUR",
    "state": "WEST BENGAL"
  },
  "712308": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712309": {
    "city": "KONNAGAR",
    "state": "WEST BENGAL"
  },
  "712310": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712311": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712331": {
    "city": "KONNAGAR",
    "state": "WEST BENGAL"
  },
  "712344": {
    "city": "KONNAGAR",
    "state": "WEST BENGAL"
  },
  "712365": {
    "city": "ASANSOL",
    "state": "WEST BENGAL"
  },
  "712401": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712402": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712403": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712404": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712405": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712406": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712407": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712408": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712409": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712410": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712411": {
    "city": "SHRIRAMPUR",
    "state": "WEST BENGAL"
  },
  "712412": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712413": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712414": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712415": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712416": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712417": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712418": {
    "city": "KHANAKUL",
    "state": "WEST BENGAL"
  },
  "712419": {
    "city": "PURSURA",
    "state": "WEST BENGAL"
  },
  "712420": {
    "city": "PURSURA",
    "state": "WEST BENGAL"
  },
  "712421": {
    "city": "PURSURA",
    "state": "WEST BENGAL"
  },
  "712422": {
    "city": "KHANAKUL",
    "state": "WEST BENGAL"
  },
  "712423": {
    "city": "KHANAKUL",
    "state": "WEST BENGAL"
  },
  "712424": {
    "city": "UDAYNARAYANPUR",
    "state": "WEST BENGAL"
  },
  "712425": {
    "city": "SANTIPUR",
    "state": "WEST BENGAL"
  },
  "712426": {
    "city": "JAMALPUR",
    "state": "WEST BENGAL"
  },
  "712428": {
    "city": "CHANDANNAGAR",
    "state": "WEST BENGAL"
  },
  "712429": {
    "city": "KHANAKUL",
    "state": "WEST BENGAL"
  },
  "712501": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712502": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712503": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712504": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712512": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712513": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712514": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712515": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712601": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712602": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712611": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712612": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712613": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712614": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712615": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712616": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712617": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712701": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712702": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712703": {
    "city": "KONNAGAR",
    "state": "WEST BENGAL"
  },
  "712704": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712705": {
    "city": "KONNAGAR",
    "state": "WEST BENGAL"
  },
  "712706": {
    "city": "Hooghly",
    "state": "West Bengal"
  },
  "712707": {
    "city": "UDAYNARAYANPUR",
    "state": "WEST BENGAL"
  },
  "712708": {
    "city": "BALLY",
    "state": "WEST BENGAL"
  },
  "712712": {
    "city": "CHANDANNAGAR",
    "state": "WEST BENGAL"
  },
  "712906": {
    "city": "SHRIRAMPUR",
    "state": "WEST BENGAL"
  },
  "713101": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713102": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713103": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713104": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713121": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713122": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713123": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713124": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713125": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713126": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713127": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713128": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713129": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713130": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713131": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713140": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713141": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713142": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713143": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713144": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713145": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713146": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713147": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713148": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713149": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713150": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "713151": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713152": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713153": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713154": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713155": {
    "city": "BUDBUD",
    "state": "WEST BENGAL"
  },
  "713156": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713157": {
    "city": "KALNA",
    "state": "WEST BENGAL"
  },
  "713158": {
    "city": "BHATAR",
    "state": "WEST BENGAL"
  },
  "713159": {
    "city": "BURDWAN",
    "state": "WEST BENGAL"
  },
  "713160": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "713161": {
    "city": "BURDWAN",
    "state": "WEST BENGAL"
  },
  "713162": {
    "city": "GUSKURA",
    "state": "WEST BENGAL"
  },
  "713164": {
    "city": "BURDWAN",
    "state": "WEST BENGAL"
  },
  "713165": {
    "city": "BHATAR",
    "state": "WEST BENGAL"
  },
  "713166": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713167": {
    "city": "GUSKURA",
    "state": "WEST BENGAL"
  },
  "713168": {
    "city": "MALTESWAR",
    "state": "WEST BENGAL"
  },
  "713169": {
    "city": "BUDBUD",
    "state": "WEST BENGAL"
  },
  "713170": {
    "city": "KALNA",
    "state": "WEST BENGAL"
  },
  "713171": {
    "city": "GUSKURA",
    "state": "WEST BENGAL"
  },
  "713172": {
    "city": "ILAMBAZAR",
    "state": "WEST BENGAL"
  },
  "713173": {
    "city": "GUSKURA",
    "state": "WEST BENGAL"
  },
  "713174": {
    "city": "BURDWAN",
    "state": "WEST BENGAL"
  },
  "713201": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713202": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713203": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713204": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713205": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713206": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713207": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713208": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713209": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713210": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713211": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713212": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713213": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713214": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713215": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713216": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713217": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713218": {
    "city": "BARDHAMAN",
    "state": "WEST BENGAL"
  },
  "713219": {
    "city": "BARDHAMAN",
    "state": "WEST BENGAL"
  },
  "713301": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713302": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713303": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713304": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713305": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713308": {
    "city": "DURGAPUR",
    "state": "WEST BENGAL"
  },
  "713310": {
    "city": "ASANSOL",
    "state": "WEST BENGAL"
  },
  "713315": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713317": {
    "city": "DURGAPUR",
    "state": "WEST BENGAL"
  },
  "713321": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713322": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713323": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713324": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713325": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713326": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713330": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713331": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713332": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713333": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713334": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713335": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713336": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713337": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713338": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713339": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713340": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713341": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713342": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713343": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713344": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713345": {
    "city": "DURGAPUR",
    "state": "WEST BENGAL"
  },
  "713346": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713347": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713357": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713358": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713359": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713360": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713361": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713362": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713363": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713364": {
    "city": "SALANPUR",
    "state": "WEST BENGAL"
  },
  "713365": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713366": {
    "city": "DURGAPUR",
    "state": "WEST BENGAL"
  },
  "713367": {
    "city": "ASANSOL",
    "state": "WEST BENGAL"
  },
  "713368": {
    "city": "ASANSOL",
    "state": "WEST BENGAL"
  },
  "713369": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713370": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713371": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713372": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713373": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713374": {
    "city": "DURGAPUR",
    "state": "WEST BENGAL"
  },
  "713375": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "713376": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713377": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "713378": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713379": {
    "city": "DURGAPUR",
    "state": "WEST BENGAL"
  },
  "713380": {
    "city": "MEJHIA",
    "state": "WEST BENGAL"
  },
  "713381": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713382": {
    "city": "DURGAPUR",
    "state": "WEST BENGAL"
  },
  "713383": {
    "city": "ASANSOL",
    "state": "WEST BENGAL"
  },
  "713384": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713385": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713386": {
    "city": "Paschim Bardhaman",
    "state": "West Bengal"
  },
  "713387": {
    "city": "DURGAPUR",
    "state": "WEST BENGAL"
  },
  "713401": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713402": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713403": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713404": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713405": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713406": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713407": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713408": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713409": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713412": {
    "city": "KHANDAGHOSH",
    "state": "WEST BENGAL"
  },
  "713419": {
    "city": "DURGAPUR",
    "state": "WEST BENGAL"
  },
  "713420": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713421": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713422": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713423": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713424": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713425": {
    "city": "KALNA",
    "state": "WEST BENGAL"
  },
  "713426": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713427": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713428": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713429": {
    "city": "MALTESWAR",
    "state": "WEST BENGAL"
  },
  "713430": {
    "city": "KALNA",
    "state": "WEST BENGAL"
  },
  "713431": {
    "city": "BURDWAN",
    "state": "WEST BENGAL"
  },
  "713432": {
    "city": "KHANDAGHOSH",
    "state": "WEST BENGAL"
  },
  "713433": {
    "city": "BURDWAN",
    "state": "WEST BENGAL"
  },
  "713434": {
    "city": "KALNA",
    "state": "WEST BENGAL"
  },
  "713501": {
    "city": "KALNA",
    "state": "WEST BENGAL"
  },
  "713502": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713512": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713513": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "713514": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "713515": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713516": {
    "city": "KATWA",
    "state": "WEST BENGAL"
  },
  "713517": {
    "city": "KATWA",
    "state": "WEST BENGAL"
  },
  "713518": {
    "city": "PURBASTHALI",
    "state": "WEST BENGAL"
  },
  "713519": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "713520": {
    "city": "Purba Bardhaman",
    "state": "West Bengal"
  },
  "715513": {
    "city": "KATWA",
    "state": "WEST BENGAL"
  },
  "721060": {
    "city": "PURSURA",
    "state": "WEST BENGAL"
  },
  "721101": {
    "city": "Medinipur",
    "state": "West Bengal"
  },
  "721102": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721103": {
    "city": "MEDINIPUR",
    "state": "WEST BENGAL"
  },
  "721121": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721122": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721123": {
    "city": "CHANDRAKONA",
    "state": "WEST BENGAL"
  },
  "721124": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721125": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721126": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721127": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721128": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721129": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721130": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721131": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721132": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721133": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721134": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721135": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721136": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721137": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721138": {
    "city": "KESHIARI",
    "state": "WEST BENGAL"
  },
  "721139": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721140": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721141": {
    "city": "BINPUR",
    "state": "WEST BENGAL"
  },
  "721142": {
    "city": "MECHEDA",
    "state": "WEST BENGAL"
  },
  "721143": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721144": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721145": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721146": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721147": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721148": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721149": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721150": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721151": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721152": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721153": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721154": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721155": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721156": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721157": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721158": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721159": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721160": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721161": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721162": {
    "city": "PANSKURA",
    "state": "WEST BENGAL"
  },
  "721163": {
    "city": "HOWRAH",
    "state": "WEST BENGAL"
  },
  "721164": {
    "city": "SABANG",
    "state": "WEST BENGAL"
  },
  "721165": {
    "city": "CHANDRAKONA",
    "state": "WEST BENGAL"
  },
  "721166": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721167": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721168": {
    "city": "PANSKURA",
    "state": "WEST BENGAL"
  },
  "721169": {
    "city": "PANSKURA",
    "state": "WEST BENGAL"
  },
  "721170": {
    "city": "DASPUR",
    "state": "WEST BENGAL"
  },
  "721171": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721172": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721201": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721211": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721212": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721222": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721228": {
    "city": "CHANDRAKONA",
    "state": "WEST BENGAL"
  },
  "721232": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721242": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721252": {
    "city": "CHANDRAKONA",
    "state": "WEST BENGAL"
  },
  "721253": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721254": {
    "city": "CHANDRAKONA",
    "state": "WEST BENGAL"
  },
  "721256": {
    "city": "CHANDRAKONA",
    "state": "WEST BENGAL"
  },
  "721257": {
    "city": "CHANDRAKONA",
    "state": "WEST BENGAL"
  },
  "721258": {
    "city": "CHANDRAKONA",
    "state": "WEST BENGAL"
  },
  "721259": {
    "city": "DASPUR",
    "state": "WEST BENGAL"
  },
  "721260": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721301": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721302": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721303": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721304": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721305": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721306": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721307": {
    "city": "BHAGAWANPUR",
    "state": "WEST BENGAL"
  },
  "721315": {
    "city": "MEDINIPUR",
    "state": "WEST BENGAL"
  },
  "721359": {
    "city": "BHAGAWANPUR",
    "state": "WEST BENGAL"
  },
  "721363": {
    "city": "BHAGAWANPUR",
    "state": "WEST BENGAL"
  },
  "721401": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721420": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721421": {
    "city": "EGRA",
    "state": "WEST BENGAL"
  },
  "721422": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721423": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721424": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721425": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721426": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721427": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721428": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721429": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721430": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721431": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721432": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721433": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721434": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721435": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721436": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721437": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721438": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721439": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721440": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721441": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721442": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721443": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721444": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721445": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721446": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721447": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721448": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721449": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721450": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721451": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721452": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721453": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721454": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721455": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721456": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721457": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721458": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721459": {
    "city": "DANTAN",
    "state": "WEST BENGAL"
  },
  "721460": {
    "city": "CONTAI",
    "state": "WEST BENGAL"
  },
  "721461": {
    "city": "RAMNAGAR",
    "state": "WEST BENGAL"
  },
  "721462": {
    "city": "CONTAI",
    "state": "WEST BENGAL"
  },
  "721463": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721464": {
    "city": "CONTAI",
    "state": "WEST BENGAL"
  },
  "721465": {
    "city": "CONTAI",
    "state": "WEST BENGAL"
  },
  "721466": {
    "city": "EGRA",
    "state": "WEST BENGAL"
  },
  "721467": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721501": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721502": {
    "city": "BINPUR",
    "state": "WEST BENGAL"
  },
  "721503": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721504": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721505": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721506": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721507": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721513": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721514": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721515": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721516": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721517": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721518": {
    "city": "JHARGRAM",
    "state": "WEST BENGAL"
  },
  "721519": {
    "city": "BINPUR",
    "state": "WEST BENGAL"
  },
  "721601": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721602": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721603": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721604": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721605": {
    "city": "HALDIA",
    "state": "WEST BENGAL"
  },
  "721606": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721607": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721625": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721626": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721627": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721628": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721629": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721630": {
    "city": "TAMLUK",
    "state": "WEST BENGAL"
  },
  "721631": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721632": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721633": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721634": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721635": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721636": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721637": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721638": {
    "city": "PANSKURA",
    "state": "WEST BENGAL"
  },
  "721641": {
    "city": "West Midnapore",
    "state": "West Bengal"
  },
  "721642": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721643": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721644": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721645": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721646": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721647": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721648": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721649": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721650": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721651": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721652": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721653": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721654": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721655": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721656": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721657": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721658": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721659": {
    "city": "East Midnapore",
    "state": "West Bengal"
  },
  "721660": {
    "city": "JHARGRAM",
    "state": "WEST BENGAL"
  },
  "721661": {
    "city": "TAMLUK",
    "state": "WEST BENGAL"
  },
  "721662": {
    "city": "HALDIA",
    "state": "WEST BENGAL"
  },
  "721663": {
    "city": "DASPUR",
    "state": "WEST BENGAL"
  },
  "721664": {
    "city": "TAMLUK",
    "state": "WEST BENGAL"
  },
  "721665": {
    "city": "HALDIA",
    "state": "WEST BENGAL"
  },
  "721666": {
    "city": "HALDIA",
    "state": "WEST BENGAL"
  },
  "721667": {
    "city": "TAMLUK",
    "state": "WEST BENGAL"
  },
  "721668": {
    "city": "MECHEDA",
    "state": "WEST BENGAL"
  },
  "721669": {
    "city": "HALDIA",
    "state": "WEST BENGAL"
  },
  "721670": {
    "city": "HALDIA",
    "state": "WEST BENGAL"
  },
  "722101": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722102": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722103": {
    "city": "BANKURA",
    "state": "WEST BENGAL"
  },
  "722107": {
    "city": "BANKURA",
    "state": "WEST BENGAL"
  },
  "722110": {
    "city": "SONAMUKHI",
    "state": "WEST BENGAL"
  },
  "722111": {
    "city": "SONAMUKHI",
    "state": "WEST BENGAL"
  },
  "722112": {
    "city": "SONAMUKHI",
    "state": "WEST BENGAL"
  },
  "722121": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722122": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722132": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722133": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722134": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722135": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722136": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722137": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722138": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722139": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722140": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722141": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722142": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722143": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722144": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722145": {
    "city": "JAYPUR",
    "state": "WEST BENGAL"
  },
  "722146": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722147": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722148": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722149": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722150": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722151": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722152": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722153": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722154": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722155": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722156": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722157": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722158": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722159": {
    "city": "GANGAJALGHATI",
    "state": "WEST BENGAL"
  },
  "722160": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722161": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722162": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722163": {
    "city": "JAYPUR",
    "state": "WEST BENGAL"
  },
  "722164": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722165": {
    "city": "JAYPUR",
    "state": "WEST BENGAL"
  },
  "722166": {
    "city": "GANGAJALGHATI",
    "state": "WEST BENGAL"
  },
  "722168": {
    "city": "GANGAJALGHATI",
    "state": "WEST BENGAL"
  },
  "722169": {
    "city": "GANGAJALGHATI",
    "state": "WEST BENGAL"
  },
  "722170": {
    "city": "BANKURA",
    "state": "WEST BENGAL"
  },
  "722171": {
    "city": "KHATRA",
    "state": "WEST BENGAL"
  },
  "722172": {
    "city": "BANKURA",
    "state": "WEST BENGAL"
  },
  "722173": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722174": {
    "city": "JAYPUR",
    "state": "WEST BENGAL"
  },
  "722175": {
    "city": "GANGAJALGHATI",
    "state": "WEST BENGAL"
  },
  "722176": {
    "city": "GANGAJALGHATI",
    "state": "WEST BENGAL"
  },
  "722177": {
    "city": "GANGAJALGHATI",
    "state": "WEST BENGAL"
  },
  "722178": {
    "city": "JAYPUR",
    "state": "WEST BENGAL"
  },
  "722179": {
    "city": "BANKURA",
    "state": "WEST BENGAL"
  },
  "722180": {
    "city": "GANGAJALGHATI",
    "state": "WEST BENGAL"
  },
  "722181": {
    "city": "BANKURA",
    "state": "WEST BENGAL"
  },
  "722182": {
    "city": "GANGAJALGHATI",
    "state": "WEST BENGAL"
  },
  "722183": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722201": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722202": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722203": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722204": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722205": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722206": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722207": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722208": {
    "city": "Bankura",
    "state": "West Bengal"
  },
  "722209": {
    "city": "SONAMUKHI",
    "state": "WEST BENGAL"
  },
  "722213": {
    "city": "SHRIRAMPUR",
    "state": "WEST BENGAL"
  },
  "722222": {
    "city": "BEHRAGHORA",
    "state": "JHARKHAND"
  },
  "723101": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723102": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723103": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723104": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723121": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723126": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723127": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723128": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723129": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723130": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723131": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723132": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723133": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723142": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723143": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723144": {
    "city": "SANTURI",
    "state": "WEST BENGAL"
  },
  "723145": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723146": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723147": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723148": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723149": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723150": {
    "city": "ASANSOL",
    "state": "WEST BENGAL"
  },
  "723151": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723152": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723153": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723154": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723155": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723156": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723157": {
    "city": "SANTURI",
    "state": "WEST BENGAL"
  },
  "723158": {
    "city": "SANTURI",
    "state": "WEST BENGAL"
  },
  "723159": {
    "city": "PURULIA",
    "state": "WEST BENGAL"
  },
  "723160": {
    "city": "SANTURI",
    "state": "WEST BENGAL"
  },
  "723161": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723162": {
    "city": "RAGHUNATHPUR",
    "state": "WEST BENGAL"
  },
  "723163": {
    "city": "PURULIA",
    "state": "WEST BENGAL"
  },
  "723164": {
    "city": "PURULIA",
    "state": "WEST BENGAL"
  },
  "723165": {
    "city": "SANTURI",
    "state": "WEST BENGAL"
  },
  "723166": {
    "city": "RAGHUNATHPUR",
    "state": "WEST BENGAL"
  },
  "723167": {
    "city": "PURULIA",
    "state": "WEST BENGAL"
  },
  "723168": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723201": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723202": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723212": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723213": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723214": {
    "city": "KOTHSILA",
    "state": "WEST BENGAL"
  },
  "723215": {
    "city": "Purulia",
    "state": "West Bengal"
  },
  "723216": {
    "city": "KOTHSILA",
    "state": "WEST BENGAL"
  },
  "723413": {
    "city": "BARABAZAR",
    "state": "WEST BENGAL"
  },
  "726206": {
    "city": "BAROBISHA",
    "state": "WEST BENGAL"
  },
  "731101": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731102": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731103": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731104": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731121": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731122": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731123": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731124": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731125": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731126": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731127": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731128": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731129": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731130": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731131": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731132": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731133": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731134": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731135": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731136": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731137": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731138": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731139": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731140": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731141": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731142": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731143": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731144": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731145": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731146": {
    "city": "SIRUI",
    "state": "WEST BENGAL"
  },
  "731147": {
    "city": "KHOYRSOLE",
    "state": "WEST BENGAL"
  },
  "731201": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731202": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731203": {
    "city": "RAMPURHAT",
    "state": "WEST BENGAL"
  },
  "731204": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731212": {
    "city": "DURGAPUR",
    "state": "WEST BENGAL"
  },
  "731213": {
    "city": "MAYURESWAR",
    "state": "WEST BENGAL"
  },
  "731214": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731215": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731216": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731217": {
    "city": "RAMPURHAT",
    "state": "WEST BENGAL"
  },
  "731218": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731219": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731220": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731221": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731222": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731223": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731224": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731233": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731234": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731235": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731236": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731237": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731238": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731239": {
    "city": "RAMPURHAT",
    "state": "WEST BENGAL"
  },
  "731240": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731241": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731242": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731243": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731244": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731245": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731246": {
    "city": "MAYURESWAR",
    "state": "WEST BENGAL"
  },
  "731247": {
    "city": "RAMPURHAT",
    "state": "WEST BENGAL"
  },
  "731249": {
    "city": "RAMPURHAT",
    "state": "WEST BENGAL"
  },
  "731250": {
    "city": "RAMPURHAT",
    "state": "WEST BENGAL"
  },
  "731251": {
    "city": "RAMPURHAT",
    "state": "WEST BENGAL"
  },
  "731252": {
    "city": "RAMPURHAT",
    "state": "WEST BENGAL"
  },
  "731253": {
    "city": "RAMPURHAT",
    "state": "WEST BENGAL"
  },
  "731254": {
    "city": "MAYURESWAR",
    "state": "WEST BENGAL"
  },
  "731255": {
    "city": "SHANTINIKETAN",
    "state": "WEST BENGAL"
  },
  "731284": {
    "city": "SIRUI",
    "state": "WEST BENGAL"
  },
  "731301": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731302": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731303": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "731304": {
    "city": "Birbhum",
    "state": "West Bengal"
  },
  "732001": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "732013": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "732101": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732102": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732103": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732104": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732121": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732122": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732123": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732124": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732125": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732126": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732127": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732128": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732138": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732139": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732140": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732141": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732142": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732143": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732144": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732145": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732146": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732147": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732148": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732149": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732150": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732151": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732152": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732153": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732154": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732155": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732156": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732157": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732158": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732159": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732160": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732161": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732162": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732163": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "732201": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732202": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732203": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732204": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732205": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732206": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732207": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732208": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732209": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732210": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732211": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732212": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732213": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732214": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732215": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732216": {
    "city": "Malda",
    "state": "West Bengal"
  },
  "732236": {
    "city": "FARAKKA",
    "state": "WEST BENGAL"
  },
  "732312": {
    "city": "FARAKKA",
    "state": "WEST BENGAL"
  },
  "732706": {
    "city": "MALDA",
    "state": "WEST BENGAL"
  },
  "733006": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "733101": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733102": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733103": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733121": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733123": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733124": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733125": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733126": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733127": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733128": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733129": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733130": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733131": {
    "city": "GANGARAMPUR",
    "state": "WEST BENGAL"
  },
  "733132": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733133": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733134": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733140": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733141": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733142": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733143": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733144": {
    "city": "RAIGANJ",
    "state": "WEST BENGAL"
  },
  "733145": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733146": {
    "city": "GANGARAMPUR",
    "state": "WEST BENGAL"
  },
  "733147": {
    "city": "GANGARAMPUR",
    "state": "WEST BENGAL"
  },
  "733148": {
    "city": "GANGARAMPUR",
    "state": "WEST BENGAL"
  },
  "733149": {
    "city": "GANGARAMPUR",
    "state": "WEST BENGAL"
  },
  "733150": {
    "city": "KUSHMANDI",
    "state": "WEST BENGAL"
  },
  "733151": {
    "city": "BALURGHAT",
    "state": "WEST BENGAL"
  },
  "733153": {
    "city": "BALURGHAT",
    "state": "WEST BENGAL"
  },
  "733154": {
    "city": "BALURGHAT",
    "state": "WEST BENGAL"
  },
  "733155": {
    "city": "BALURGHAT",
    "state": "WEST BENGAL"
  },
  "733156": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733157": {
    "city": "RAIGANJ",
    "state": "WEST BENGAL"
  },
  "733158": {
    "city": "South Dinajpur",
    "state": "West Bengal"
  },
  "733201": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733202": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733207": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733208": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733209": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733210": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733211": {
    "city": "DALKOLA",
    "state": "WEST BENGAL"
  },
  "733212": {
    "city": "DALKOLA",
    "state": "WEST BENGAL"
  },
  "733213": {
    "city": "ISLAMPUR",
    "state": "WEST BENGAL"
  },
  "733214": {
    "city": "ISLAMPUR",
    "state": "WEST BENGAL"
  },
  "733215": {
    "city": "North Dinajpur",
    "state": "West Bengal"
  },
  "733216": {
    "city": "ISLAMPUR",
    "state": "WEST BENGAL"
  },
  "733246": {
    "city": "HARIRAMPUR",
    "state": "WEST BENGAL"
  },
  "733252": {
    "city": "KUSHMANDI",
    "state": "WEST BENGAL"
  },
  "733302": {
    "city": "DURGAPUR",
    "state": "WEST BENGAL"
  },
  "734000": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734001": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734002": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734003": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734004": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734005": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734006": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "734007": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "734008": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734009": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734010": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734011": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734012": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734013": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734014": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734015": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "734016": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734018": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734025": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734100": {
    "city": "DARJEELING",
    "state": "WEST BENGAL"
  },
  "734101": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734102": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734103": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734104": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734105": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734121": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734122": {
    "city": "DARJEELING",
    "state": "WEST BENGAL"
  },
  "734123": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734124": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734201": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734203": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734204": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734209": {
    "city": "KURSEONG",
    "state": "WEST BENGAL"
  },
  "734210": {
    "city": "TAKDAH",
    "state": "WEST BENGAL"
  },
  "734211": {
    "city": "TAKDAH",
    "state": "WEST BENGAL"
  },
  "734212": {
    "city": "TAKDAH",
    "state": "WEST BENGAL"
  },
  "734213": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734214": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734215": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734216": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734217": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734218": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734219": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734220": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734221": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734222": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734223": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734224": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734225": {
    "city": "KURSEONG",
    "state": "WEST BENGAL"
  },
  "734226": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734227": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734301": {
    "city": "Kalimpong",
    "state": "West Bengal"
  },
  "734311": {
    "city": "Kalimpong",
    "state": "West Bengal"
  },
  "734312": {
    "city": "Kalimpong",
    "state": "West Bengal"
  },
  "734313": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734314": {
    "city": "Kalimpong",
    "state": "West Bengal"
  },
  "734315": {
    "city": "Kalimpong",
    "state": "West Bengal"
  },
  "734316": {
    "city": "Kalimpong",
    "state": "West Bengal"
  },
  "734317": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734318": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734319": {
    "city": "TAKDAH",
    "state": "WEST BENGAL"
  },
  "734320": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734321": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734325": {
    "city": "TAKDAH",
    "state": "WEST BENGAL"
  },
  "734333": {
    "city": "SIBMANDIR",
    "state": "WEST BENGAL"
  },
  "734401": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734402": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734403": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734404": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734405": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734406": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734407": {
    "city": "RAJGANJ",
    "state": "WEST BENGAL"
  },
  "734418": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734421": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734422": {
    "city": "SIBMANDIR",
    "state": "WEST BENGAL"
  },
  "734423": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734424": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734425": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734426": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734427": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734428": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734429": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734430": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734431": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734432": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734433": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734434": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734435": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "734436": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "734501": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "734502": {
    "city": "DARJEELING",
    "state": "WEST BENGAL"
  },
  "734503": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "735101": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735102": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735121": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735122": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "735132": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735133": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735134": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735135": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735136": {
    "city": "JALPAIGURI",
    "state": "WEST BENGAL"
  },
  "735137": {
    "city": "JALPAIGURI",
    "state": "WEST BENGAL"
  },
  "735138": {
    "city": "RAJGANJ",
    "state": "WEST BENGAL"
  },
  "735139": {
    "city": "JALPAIGURI",
    "state": "WEST BENGAL"
  },
  "735140": {
    "city": "JALPAIGURI",
    "state": "WEST BENGAL"
  },
  "735152": {
    "city": "BALURGHAT",
    "state": "WEST BENGAL"
  },
  "735201": {
    "city": "BIRPARA",
    "state": "WEST BENGAL"
  },
  "735202": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735203": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735204": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "735205": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735206": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735207": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735208": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "735209": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735210": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735211": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "735212": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735213": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "735214": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "735215": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "735216": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "735217": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "735218": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735219": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735220": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "735221": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735222": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735223": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735224": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735225": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735226": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "735227": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "735228": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "735229": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735230": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735231": {
    "city": "Darjiling",
    "state": "West Bengal"
  },
  "735232": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735233": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735234": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735235": {
    "city": "MALBAZAR",
    "state": "WEST BENGAL"
  },
  "735236": {
    "city": "MALBAZAR",
    "state": "WEST BENGAL"
  },
  "735237": {
    "city": "MALBAZAR",
    "state": "WEST BENGAL"
  },
  "735238": {
    "city": "MALBAZAR",
    "state": "WEST BENGAL"
  },
  "735251": {
    "city": "MALBAZAR",
    "state": "WEST BENGAL"
  },
  "735301": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "735302": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735303": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735304": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "735305": {
    "city": "Jalpaiguri",
    "state": "West Bengal"
  },
  "735306": {
    "city": "MEKLIGANJ",
    "state": "WEST BENGAL"
  },
  "735307": {
    "city": "MEKLIGANJ",
    "state": "WEST BENGAL"
  },
  "735308": {
    "city": "MEKLIGANJ",
    "state": "WEST BENGAL"
  },
  "735309": {
    "city": "MEKLIGANJ",
    "state": "WEST BENGAL"
  },
  "735310": {
    "city": "MEKLIGANJ",
    "state": "WEST BENGAL"
  },
  "735350": {
    "city": "BIRPARA",
    "state": "WEST BENGAL"
  },
  "735503": {
    "city": "BANKURA",
    "state": "WEST BENGAL"
  },
  "735505": {
    "city": "BANKURA",
    "state": "WEST BENGAL"
  },
  "736101": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736102": {
    "city": "COOCH BEHAR",
    "state": "WEST BENGAL"
  },
  "736118": {
    "city": "COOCH BEHAR",
    "state": "WEST BENGAL"
  },
  "736121": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "736122": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "736123": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "736130": {
    "city": "ALIPURDUAR",
    "state": "WEST BENGAL"
  },
  "736131": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736132": {
    "city": "TUFANGANJ",
    "state": "WEST BENGAL"
  },
  "736133": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736134": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736135": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736136": {
    "city": "COOCH BEHAR",
    "state": "WEST BENGAL"
  },
  "736145": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736146": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736150": {
    "city": "DINHATA",
    "state": "WEST BENGAL"
  },
  "736156": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736157": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736158": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736159": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736160": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736162": {
    "city": "ALIPURDUAR",
    "state": "WEST BENGAL"
  },
  "736165": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736166": {
    "city": "DINHATA",
    "state": "WEST BENGAL"
  },
  "736167": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736168": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736169": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736170": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736171": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736172": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736173": {
    "city": "DINHATA",
    "state": "WEST BENGAL"
  },
  "736174": {
    "city": "DINHATA",
    "state": "WEST BENGAL"
  },
  "736175": {
    "city": "DINHATA",
    "state": "WEST BENGAL"
  },
  "736176": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736177": {
    "city": "TUFANGANJ",
    "state": "WEST BENGAL"
  },
  "736179": {
    "city": "Cooch Behar",
    "state": "West Bengal"
  },
  "736180": {
    "city": "COOCH BEHAR",
    "state": "WEST BENGAL"
  },
  "736181": {
    "city": "COOCH BEHAR",
    "state": "WEST BENGAL"
  },
  "736182": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "736201": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "736202": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "736203": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "736204": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "736205": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "736206": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "736207": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "736208": {
    "city": "Alipurduar",
    "state": "West Bengal"
  },
  "736257": {
    "city": "COOCH BEHAR",
    "state": "WEST BENGAL"
  },
  "737101": {
    "city": "SIKKIM",
    "state": "SIKKIM"
  },
  "737102": {
    "city": "GANGTOK",
    "state": "SIKKIM"
  },
  "737103": {
    "city": "GANGTOK",
    "state": "SIKKIM"
  },
  "737105": {
    "city": "RANIPOOL",
    "state": "SIKKIM"
  },
  "737121": {
    "city": "JORETHANG",
    "state": "SIKKIM"
  },
  "737126": {
    "city": "NAMCHI",
    "state": "SIKKIM"
  },
  "737131": {
    "city": "RANGPO",
    "state": "SIKKIM"
  },
  "737132": {
    "city": "SIKKIM",
    "state": "SIKKIM"
  },
  "737133": {
    "city": "SIKKIM",
    "state": "SIKKIM"
  },
  "737134": {
    "city": "RANGPO",
    "state": "SIKKIM"
  },
  "737135": {
    "city": "RANIPOOL",
    "state": "SIKKIM"
  },
  "737136": {
    "city": "GANGTOK",
    "state": "SIKKIM"
  },
  "737137": {
    "city": "GANGTOK",
    "state": "SIKKIM"
  },
  "741001": {
    "city": "ISLAMPUR",
    "state": "WEST BENGAL"
  },
  "741101": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741102": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741103": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741104": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741111": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741117": {
    "city": "KRISHNAGAR",
    "state": "WEST BENGAL"
  },
  "741121": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741122": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741123": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741124": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741125": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741126": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741127": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741137": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741138": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741139": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741140": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741150": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741151": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741152": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741153": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741154": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741155": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741156": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741157": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741158": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741159": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741160": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741161": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741162": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741163": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741164": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741165": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741166": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741167": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741168": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741169": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741170": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741171": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741172": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741173": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741174": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741175": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741176": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741177": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741178": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741179": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741180": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741181": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741182": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741183": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741184": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741185": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741186": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741187": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741188": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741189": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741190": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741191": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741192": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741193": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741194": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741195": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741196": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741197": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741198": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741199": {
    "city": "TEHATTA",
    "state": "WEST BENGAL"
  },
  "741201": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741202": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741203": {
    "city": "HARINGHATA",
    "state": "WEST BENGAL"
  },
  "741221": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741222": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741223": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741224": {
    "city": "HARINGHATA",
    "state": "WEST BENGAL"
  },
  "741225": {
    "city": "HARINGHATA",
    "state": "WEST BENGAL"
  },
  "741232": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741233": {
    "city": "RANAGHAT",
    "state": "WEST BENGAL"
  },
  "741234": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741235": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741236": {
    "city": "KALYANI",
    "state": "WEST BENGAL"
  },
  "741238": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741243": {
    "city": "KALYANI",
    "state": "WEST BENGAL"
  },
  "741245": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741246": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741247": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741248": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741249": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741250": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741251": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741252": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741253": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741254": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741255": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741256": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741257": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741258": {
    "city": "RANAGHAT",
    "state": "WEST BENGAL"
  },
  "741301": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741302": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741312": {
    "city": "PURBASTHALI",
    "state": "WEST BENGAL"
  },
  "741313": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741314": {
    "city": "KRISHNAGAR",
    "state": "WEST BENGAL"
  },
  "741315": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741316": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741317": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741318": {
    "city": "KRISHNAGAR",
    "state": "WEST BENGAL"
  },
  "741319": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741401": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741402": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741403": {
    "city": "RANAGHAT",
    "state": "WEST BENGAL"
  },
  "741404": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741405": {
    "city": "SANTIPUR",
    "state": "WEST BENGAL"
  },
  "741501": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741502": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741503": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741504": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741505": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741506": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741507": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741508": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741509": {
    "city": "Nadia",
    "state": "West Bengal"
  },
  "741510": {
    "city": "BAGULA",
    "state": "WEST BENGAL"
  },
  "741511": {
    "city": "BAGULA",
    "state": "WEST BENGAL"
  },
  "741512": {
    "city": "BAGULA",
    "state": "WEST BENGAL"
  },
  "741513": {
    "city": "BAGULA",
    "state": "WEST BENGAL"
  },
  "741514": {
    "city": "BAGULA",
    "state": "WEST BENGAL"
  },
  "741515": {
    "city": "BAGULA",
    "state": "WEST BENGAL"
  },
  "741516": {
    "city": "BAGULA",
    "state": "WEST BENGAL"
  },
  "742000": {
    "city": "BURDWAN",
    "state": "WEST BENGAL"
  },
  "742101": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742102": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742103": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742104": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742109": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742113": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742121": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742122": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742123": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742124": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742131": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742132": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742133": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742134": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742135": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742136": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742137": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742138": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742139": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742140": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742147": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742148": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742149": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742150": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742151": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742152": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742156": {
    "city": "KANDI",
    "state": "WEST BENGAL"
  },
  "742157": {
    "city": "KANDI",
    "state": "WEST BENGAL"
  },
  "742159": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742160": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742161": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742162": {
    "city": "KARIMPUR",
    "state": "WEST BENGAL"
  },
  "742163": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742164": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742165": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742166": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742167": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742168": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742169": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742170": {
    "city": "KANDI",
    "state": "WEST BENGAL"
  },
  "742171": {
    "city": "KANDI",
    "state": "WEST BENGAL"
  },
  "742172": {
    "city": "KANDI",
    "state": "WEST BENGAL"
  },
  "742173": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742174": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742175": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742176": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742177": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742178": {
    "city": "LALGOLA",
    "state": "WEST BENGAL"
  },
  "742179": {
    "city": "LALGOLA",
    "state": "WEST BENGAL"
  },
  "742180": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742181": {
    "city": "SAGARDIGHI",
    "state": "WEST BENGAL"
  },
  "742182": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742183": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742184": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742185": {
    "city": "LALGOLA",
    "state": "WEST BENGAL"
  },
  "742186": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742187": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742188": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742189": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742190": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742191": {
    "city": "BERHAMPORE",
    "state": "WEST BENGAL"
  },
  "742201": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742202": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742212": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742213": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742220": {
    "city": "SUTI",
    "state": "WEST BENGAL"
  },
  "742223": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742224": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742225": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742226": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742227": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742228": {
    "city": "SUTI",
    "state": "WEST BENGAL"
  },
  "742229": {
    "city": "RAGHUNATHGANJ",
    "state": "WEST BENGAL"
  },
  "742230": {
    "city": "SUTI",
    "state": "WEST BENGAL"
  },
  "742231": {
    "city": "SUTI",
    "state": "WEST BENGAL"
  },
  "742232": {
    "city": "SUTI",
    "state": "WEST BENGAL"
  },
  "742233": {
    "city": "SUTI",
    "state": "WEST BENGAL"
  },
  "742234": {
    "city": "SUTI",
    "state": "WEST BENGAL"
  },
  "742235": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742236": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742237": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742238": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742262": {
    "city": "SUTI",
    "state": "WEST BENGAL"
  },
  "742286": {
    "city": "SUTI",
    "state": "WEST BENGAL"
  },
  "742301": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742302": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742303": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742304": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742305": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742306": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742307": {
    "city": "RANINAGAR",
    "state": "WEST BENGAL"
  },
  "742308": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742401": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742402": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742403": {
    "city": "KANDI",
    "state": "WEST BENGAL"
  },
  "742404": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742405": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742406": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742407": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742408": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "742409": {
    "city": "Murshidabad",
    "state": "West Bengal"
  },
  "743001": {
    "city": "SILIGURI",
    "state": "WEST BENGAL"
  },
  "743004": {
    "city": "RAMPURHAT",
    "state": "WEST BENGAL"
  },
  "743101": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743102": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743120": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743121": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743122": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743123": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743124": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743125": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743126": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743127": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743128": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743129": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743130": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743133": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743134": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743135": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743136": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743143": {
    "city": "BHATAR",
    "state": "WEST BENGAL"
  },
  "743144": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743145": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743146": {
    "city": "KALYANI",
    "state": "WEST BENGAL"
  },
  "743155": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743164": {
    "city": "KALYANI",
    "state": "WEST BENGAL"
  },
  "743165": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743166": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743170": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743175": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743176": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743177": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743178": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743179": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743180": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743186": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743187": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743188": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743193": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743194": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743195": {
    "city": "SHRIRAMPUR",
    "state": "WEST BENGAL"
  },
  "743200": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743201": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743202": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743203": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743204": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743211": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743212": {
    "city": "BARRACKPORE",
    "state": "WEST BENGAL"
  },
  "743221": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743222": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743223": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743232": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743233": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743234": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743235": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743236": {
    "city": "BONGAON",
    "state": "WEST BENGAL"
  },
  "743244": {
    "city": "BONGAON",
    "state": "WEST BENGAL"
  },
  "743245": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743246": {
    "city": "BONGAON",
    "state": "WEST BENGAL"
  },
  "743247": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743248": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743249": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743250": {
    "city": "BARASAT",
    "state": "WEST BENGAL"
  },
  "743251": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743252": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743262": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743263": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743266": {
    "city": "HABRA",
    "state": "WEST BENGAL"
  },
  "743268": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743269": {
    "city": "HABRA",
    "state": "WEST BENGAL"
  },
  "743270": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743271": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743272": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743273": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743274": {
    "city": "HABRA",
    "state": "WEST BENGAL"
  },
  "743275": {
    "city": "SWARUPNAGAR",
    "state": "WEST BENGAL"
  },
  "743276": {
    "city": "SWARUPNAGAR",
    "state": "WEST BENGAL"
  },
  "743286": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743287": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743288": {
    "city": "BONGAON",
    "state": "WEST BENGAL"
  },
  "743289": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743290": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743291": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743292": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743293": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743294": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743295": {
    "city": "BARASAT",
    "state": "WEST BENGAL"
  },
  "743296": {
    "city": "BARASAT",
    "state": "WEST BENGAL"
  },
  "743297": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743298": {
    "city": "BAGDA",
    "state": "WEST BENGAL"
  },
  "743299": {
    "city": "SWARUPNAGAR",
    "state": "WEST BENGAL"
  },
  "743301": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743302": {
    "city": "BARUIPUR",
    "state": "WEST BENGAL"
  },
  "743304": {
    "city": "FALTA",
    "state": "WEST BENGAL"
  },
  "743312": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743313": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743316": {
    "city": "DIAMOND HARBOUR",
    "state": "WEST BENGAL"
  },
  "743318": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743319": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743322": {
    "city": "DIAMOND HARBOUR",
    "state": "WEST BENGAL"
  },
  "743329": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743330": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743331": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743332": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743336": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743337": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743338": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743339": {
    "city": "KAKDWIP",
    "state": "WEST BENGAL"
  },
  "743343": {
    "city": "JOYNAGAR",
    "state": "WEST BENGAL"
  },
  "743345": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743347": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743348": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743349": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743351": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743352": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743353": {
    "city": "BARUIPUR",
    "state": "WEST BENGAL"
  },
  "743354": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743355": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743356": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743357": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743358": {
    "city": "BARUIPUR",
    "state": "WEST BENGAL"
  },
  "743360": {
    "city": "DIAMOND HARBOUR",
    "state": "WEST BENGAL"
  },
  "743363": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743368": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743369": {
    "city": "DIAMOND HARBOUR",
    "state": "WEST BENGAL"
  },
  "743370": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743371": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743372": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743373": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743374": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743375": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743376": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743377": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743378": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743379": {
    "city": "BARUIPUR",
    "state": "WEST BENGAL"
  },
  "743380": {
    "city": "DIAMOND HARBOUR",
    "state": "WEST BENGAL"
  },
  "743381": {
    "city": "DIAMOND HARBOUR",
    "state": "WEST BENGAL"
  },
  "743382": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743383": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743384": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743385": {
    "city": "SURJAPUR",
    "state": "WEST BENGAL"
  },
  "743387": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743388": {
    "city": "DIAMOND HARBOUR",
    "state": "WEST BENGAL"
  },
  "743389": {
    "city": "DIAMOND HARBOUR",
    "state": "WEST BENGAL"
  },
  "743390": {
    "city": "GANGASAGAR",
    "state": "WEST BENGAL"
  },
  "743391": {
    "city": "SURJAPUR",
    "state": "WEST BENGAL"
  },
  "743392": {
    "city": "GANGASAGAR",
    "state": "WEST BENGAL"
  },
  "743393": {
    "city": "KAKDWIP",
    "state": "WEST BENGAL"
  },
  "743394": {
    "city": "DIAMOND HARBOUR",
    "state": "WEST BENGAL"
  },
  "743395": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743396": {
    "city": "SURJAPUR",
    "state": "WEST BENGAL"
  },
  "743397": {
    "city": "DIAMOND HARBOUR",
    "state": "WEST BENGAL"
  },
  "743398": {
    "city": "FALTA",
    "state": "WEST BENGAL"
  },
  "743399": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743401": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743402": {
    "city": "HAROA",
    "state": "WEST BENGAL"
  },
  "743405": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743411": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743412": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743413": {
    "city": "HASNABAD",
    "state": "WEST BENGAL"
  },
  "743414": {
    "city": "HASNABAD",
    "state": "WEST BENGAL"
  },
  "743422": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743423": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743424": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743425": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743426": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743427": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743428": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743429": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743434": {
    "city": "HASNABAD",
    "state": "WEST BENGAL"
  },
  "743435": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743436": {
    "city": "HASNABAD",
    "state": "WEST BENGAL"
  },
  "743437": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743438": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743439": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743440": {
    "city": "HABRA",
    "state": "WEST BENGAL"
  },
  "743441": {
    "city": "MALANCHA",
    "state": "WEST BENGAL"
  },
  "743442": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743443": {
    "city": "HAROA",
    "state": "WEST BENGAL"
  },
  "743445": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743446": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743456": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743486": {
    "city": "MALANCHA",
    "state": "WEST BENGAL"
  },
  "743502": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743503": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743504": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743505": {
    "city": "BARUIPUR",
    "state": "WEST BENGAL"
  },
  "743506": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743507": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743508": {
    "city": "BARUIPUR",
    "state": "WEST BENGAL"
  },
  "743510": {
    "city": "FALTA",
    "state": "WEST BENGAL"
  },
  "743511": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743512": {
    "city": "BALLY",
    "state": "WEST BENGAL"
  },
  "743513": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743514": {
    "city": "FALTA",
    "state": "WEST BENGAL"
  },
  "743515": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743516": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743517": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743518": {
    "city": "MALANCHA",
    "state": "WEST BENGAL"
  },
  "743601": {
    "city": "SURJAPUR",
    "state": "WEST BENGAL"
  },
  "743602": {
    "city": "BARUIPUR",
    "state": "WEST BENGAL"
  },
  "743603": {
    "city": "BARUIPUR",
    "state": "WEST BENGAL"
  },
  "743604": {
    "city": "BARUIPUR",
    "state": "WEST BENGAL"
  },
  "743605": {
    "city": "BARUIPUR",
    "state": "WEST BENGAL"
  },
  "743606": {
    "city": "GANGASAGAR",
    "state": "WEST BENGAL"
  },
  "743607": {
    "city": "BARUIPUR",
    "state": "WEST BENGAL"
  },
  "743608": {
    "city": "BARUIPUR",
    "state": "WEST BENGAL"
  },
  "743609": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743610": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743611": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743612": {
    "city": "KOLKATA",
    "state": "WEST BENGAL"
  },
  "743613": {
    "city": "South 24 Parganas",
    "state": "West Bengal"
  },
  "743700": {
    "city": "BARASAT",
    "state": "WEST BENGAL"
  },
  "743701": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743702": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743703": {
    "city": "SWARUPNAGAR",
    "state": "WEST BENGAL"
  },
  "743704": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743705": {
    "city": "BONGAON",
    "state": "WEST BENGAL"
  },
  "743706": {
    "city": "BARASAT",
    "state": "WEST BENGAL"
  },
  "743707": {
    "city": "BARASAT",
    "state": "WEST BENGAL"
  },
  "743708": {
    "city": "BARASAT",
    "state": "WEST BENGAL"
  },
  "743710": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743711": {
    "city": "North 24 Parganas",
    "state": "West Bengal"
  },
  "743744": {
    "city": "HASNABAD",
    "state": "WEST BENGAL"
  },
  "744101": {
    "city": "ANDAMAN",
    "state": "ANDAMAN & NICOBAR ISLANDS"
  },
  "744102": {
    "city": "ANDAMAN",
    "state": "ANDAMAN & NICOBAR ISLANDS"
  },
  "744103": {
    "city": "ANDAMAN",
    "state": "ANDAMAN & NICOBAR ISLANDS"
  },
  "744104": {
    "city": "ANDAMAN",
    "state": "ANDAMAN & NICOBAR ISLANDS"
  },
  "744105": {
    "city": "PORT BLAIR",
    "state": "ANDAMAN AND NICOBAR ISLANDS"
  },
  "744106": {
    "city": "PORT BLAIR",
    "state": "ANDAMAN AND NICOBAR ISLANDS"
  },
  "744107": {
    "city": "PORT BLAIR",
    "state": "ANDAMAN AND NICOBAR ISLANDS"
  },
  "744112": {
    "city": "PORT BLAIR",
    "state": "ANDAMAN AND NICOBAR ISLANDS"
  },
  "747273": {
    "city": "SWARUPNAGAR",
    "state": "WEST BENGAL"
  },
  "748706": {
    "city": "RAMPURHAT",
    "state": "WEST BENGAL"
  },
  "751001": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751002": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751003": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751004": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751005": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751006": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751007": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751008": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751009": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751010": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751011": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751012": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751013": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751014": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751015": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751016": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751017": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751018": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751019": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751020": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751021": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751022": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751023": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751024": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751025": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751026": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751027": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751028": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751029": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751030": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751031": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "751054": {
    "city": "BHUBANESWAR",
    "state": "ODISHA"
  },
  "751062": {
    "city": "CHANDRASHEKHARPUR",
    "state": "ORISSA"
  },
  "752000": {
    "city": "Bhubaneswar",
    "state": "ODISHA"
  },
  "752001": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752002": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752003": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752006": {
    "city": "PURI",
    "state": "ODISHA"
  },
  "752010": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752011": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752012": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752013": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752014": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752015": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752016": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752017": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752018": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752019": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752020": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752021": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752022": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752023": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752024": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752025": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752026": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752027": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752028": {
    "city": "BALUGAON",
    "state": "ODISHA"
  },
  "752029": {
    "city": "PURI",
    "state": "ODISHA"
  },
  "752030": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752031": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752032": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752033": {
    "city": "PURI",
    "state": "ODISHA"
  },
  "752034": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752035": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752036": {
    "city": "KHORDHA",
    "state": "ODISHA"
  },
  "752037": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752038": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752041": {
    "city": "KHORDHA",
    "state": "ODISHA"
  },
  "752042": {
    "city": "KHORDHA",
    "state": "ODISHA"
  },
  "752043": {
    "city": "PURI",
    "state": "ODISHA"
  },
  "752044": {
    "city": "PURI",
    "state": "ODISHA"
  },
  "752045": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752046": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752050": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752054": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752055": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752056": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752057": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752058": {
    "city": "KHORDHA",
    "state": "ODISHA"
  },
  "752059": {
    "city": "KHORDHA",
    "state": "ODISHA"
  },
  "752060": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752061": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752062": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752063": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752064": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752065": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752066": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752067": {
    "city": "PURI",
    "state": "ODISHA"
  },
  "752068": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752069": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752070": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752077": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752078": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752079": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752080": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752081": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752082": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752083": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752084": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752085": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752086": {
    "city": "BHAPUR",
    "state": "ODISHA"
  },
  "752087": {
    "city": "NAYAGARH",
    "state": "ODISHA"
  },
  "752088": {
    "city": "BHAPUR",
    "state": "ODISHA"
  },
  "752089": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752090": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752091": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752092": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752093": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752094": {
    "city": "Nayagarh",
    "state": "Odisha"
  },
  "752095": {
    "city": "NAYAGARH",
    "state": "ODISHA"
  },
  "752096": {
    "city": "CHHATRAPUR",
    "state": "ODISHA"
  },
  "752100": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752101": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752102": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752103": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752104": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752105": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752106": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752107": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752108": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752109": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752110": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752111": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752112": {
    "city": "NIMAPARA",
    "state": "ODISHA"
  },
  "752113": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752114": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752115": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "752116": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752117": {
    "city": "NIMAPARA",
    "state": "ODISHA"
  },
  "752118": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752119": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752120": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "752121": {
    "city": "Puri",
    "state": "Odisha"
  },
  "752201": {
    "city": "BHUBANESWAR",
    "state": "ODISHA"
  },
  "752932": {
    "city": "KESHPUR",
    "state": "ODISHA"
  },
  "753000": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "753001": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753002": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753003": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753004": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753005": {
    "city": "CUTTACK",
    "state": "ORISSA"
  },
  "753006": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753007": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753008": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753009": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753010": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753011": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753012": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753013": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753014": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753015": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "753021": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "753025": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "753027": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "753051": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "753052": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "753071": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "753141": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "754001": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "754002": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754003": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754004": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "754005": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754006": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754007": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754008": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754009": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754010": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754011": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754012": {
    "city": "Khorda",
    "state": "Odisha"
  },
  "754013": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754014": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "754015": {
    "city": "BHUBANESWAR",
    "state": "ODISHA"
  },
  "754016": {
    "city": "NIMAPARA",
    "state": "ODISHA"
  },
  "754017": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "754018": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754020": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "754021": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754022": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754023": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "754024": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "754025": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754026": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754027": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754028": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754029": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754030": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754031": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754032": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754033": {
    "city": "DHENKANALA",
    "state": "ODISHA"
  },
  "754034": {
    "city": "BADAMBA",
    "state": "ODISHA"
  },
  "754035": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754036": {
    "city": "BANKI",
    "state": "ODISHA"
  },
  "754037": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754070": {
    "city": "TALCHER",
    "state": "ODISHA"
  },
  "754071": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754080": {
    "city": "SALEPUR",
    "state": "ODISHA"
  },
  "754081": {
    "city": "CHANDIKHOL",
    "state": "ODISHA"
  },
  "754082": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "754100": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754101": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "754102": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754103": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754104": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754105": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754106": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754107": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754108": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754109": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754110": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754111": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754112": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754113": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754114": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754115": {
    "city": "JAGATSINGHPUR",
    "state": "ODISHA"
  },
  "754116": {
    "city": "JAGATSINGHPUR",
    "state": "ODISHA"
  },
  "754117": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "754118": {
    "city": "BALIKUDA",
    "state": "ODISHA"
  },
  "754119": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754120": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754130": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754131": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754132": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754133": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754134": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754135": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754136": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754137": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754138": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754139": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754140": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754141": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754142": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754143": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754144": {
    "city": "PARADIP",
    "state": "ODISHA"
  },
  "754145": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754153": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754154": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754155": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754156": {
    "city": "SALEPUR",
    "state": "ODISHA"
  },
  "754157": {
    "city": "SALEPUR",
    "state": "ODISHA"
  },
  "754158": {
    "city": "SALEPUR",
    "state": "ODISHA"
  },
  "754159": {
    "city": "SALEPUR",
    "state": "ODISHA"
  },
  "754160": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754161": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754162": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754163": {
    "city": "PARADIP",
    "state": "ODISHA"
  },
  "754200": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754201": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754202": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754203": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754204": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754205": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "754206": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754207": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754208": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754209": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754210": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754211": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754212": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754213": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754214": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754215": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754216": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754217": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754218": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754219": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754220": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754221": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754222": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754223": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754224": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754225": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754226": {
    "city": "AUL",
    "state": "ODISHA"
  },
  "754227": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754228": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754229": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754230": {
    "city": "AUL",
    "state": "ODISHA"
  },
  "754231": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754232": {
    "city": "AUL",
    "state": "ODISHA"
  },
  "754233": {
    "city": "AUL",
    "state": "ODISHA"
  },
  "754234": {
    "city": "AUL",
    "state": "ODISHA"
  },
  "754235": {
    "city": "AUL",
    "state": "ODISHA"
  },
  "754236": {
    "city": "AUL",
    "state": "ODISHA"
  },
  "754237": {
    "city": "AUL",
    "state": "ODISHA"
  },
  "754238": {
    "city": "AUL",
    "state": "ODISHA"
  },
  "754239": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754240": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754241": {
    "city": "RAJ NAGAR",
    "state": "ODISHA"
  },
  "754242": {
    "city": "RAJ NAGAR",
    "state": "ODISHA"
  },
  "754243": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754244": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754245": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754246": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754247": {
    "city": "CHANDBALI",
    "state": "ODISHA"
  },
  "754248": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754249": {
    "city": "RAJ NAGAR",
    "state": "ODISHA"
  },
  "754250": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754251": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754252": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754253": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754260": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754261": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754280": {
    "city": "SALEPUR",
    "state": "ODISHA"
  },
  "754281": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754282": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "754283": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754284": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754285": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754286": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754287": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754288": {
    "city": "KENDRAPARA",
    "state": "ODISHA"
  },
  "754289": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "754290": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754291": {
    "city": "CUTTACK",
    "state": "ODISHA"
  },
  "754292": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "754293": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754294": {
    "city": "Jagatsinghapur",
    "state": "Odisha"
  },
  "754295": {
    "city": "Cuttack",
    "state": "Odisha"
  },
  "754296": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "754982": {
    "city": "JAJPUR TOWN",
    "state": "ODISHA"
  },
  "755001": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755003": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755004": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755005": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755006": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755007": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755008": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755009": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755010": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755011": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755012": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755013": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755014": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755015": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755016": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755017": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755018": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755019": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755020": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755021": {
    "city": "JAJPUR",
    "state": "ODISHA"
  },
  "755022": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755023": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755024": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755025": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755026": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755027": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755028": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755029": {
    "city": "BHUBAN",
    "state": "ODISHA"
  },
  "755030": {
    "city": "BINJHARPUR",
    "state": "ODISHA"
  },
  "755031": {
    "city": "BINJHARPUR",
    "state": "ODISHA"
  },
  "755032": {
    "city": "CHANDIKHOL",
    "state": "ODISHA"
  },
  "755033": {
    "city": "BINJHARPUR",
    "state": "ODISHA"
  },
  "755034": {
    "city": "BINJHARPUR",
    "state": "ODISHA"
  },
  "755035": {
    "city": "BINJHARPUR",
    "state": "ODISHA"
  },
  "755036": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755037": {
    "city": "BINJHARPUR",
    "state": "ODISHA"
  },
  "755038": {
    "city": "BINJHARPUR",
    "state": "ODISHA"
  },
  "755039": {
    "city": "BINJHARPUR",
    "state": "ODISHA"
  },
  "755040": {
    "city": "JAJPUR ROAD",
    "state": "ORISSA"
  },
  "755041": {
    "city": "CHANDIKHOL",
    "state": "ODISHA"
  },
  "755042": {
    "city": "JAJPUR",
    "state": "ODISHA"
  },
  "755043": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755044": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755045": {
    "city": "CHANDIKHOL",
    "state": "ODISHA"
  },
  "755046": {
    "city": "CHANDIKHOL",
    "state": "ODISHA"
  },
  "755047": {
    "city": "BHUBAN",
    "state": "ODISHA"
  },
  "755048": {
    "city": "JAJPUR",
    "state": "ODISHA"
  },
  "755049": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755050": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755051": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755061": {
    "city": "Kendrapara",
    "state": "Odisha"
  },
  "755062": {
    "city": "Jajapur",
    "state": "Odisha"
  },
  "755081": {
    "city": "BINJHARPUR",
    "state": "ODISHA"
  },
  "756001": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756002": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756003": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756009": {
    "city": "BALASORE",
    "state": "ODISHA"
  },
  "756017": {
    "city": "BALASORE",
    "state": "ODISHA"
  },
  "756018": {
    "city": "BALASORE",
    "state": "ODISHA"
  },
  "756019": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756020": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756021": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756022": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756023": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756024": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756025": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756026": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756027": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756028": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756029": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756030": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756032": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756033": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756034": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756035": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756036": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756037": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756038": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756039": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756040": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756041": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756042": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756043": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756044": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756045": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756046": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756047": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756048": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756049": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756050": {
    "city": "SORO",
    "state": "ODISHA"
  },
  "756051": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756052": {
    "city": "SORO",
    "state": "ODISHA"
  },
  "756053": {
    "city": "BALASORE",
    "state": "ODISHA"
  },
  "756054": {
    "city": "SORO",
    "state": "ODISHA"
  },
  "756055": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756056": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756057": {
    "city": "BALASORE",
    "state": "ODISHA"
  },
  "756058": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756059": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756060": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756071": {
    "city": "BALASORE",
    "state": "ODISHA"
  },
  "756072": {
    "city": "BALASORE",
    "state": "ODISHA"
  },
  "756073": {
    "city": "BALASORE",
    "state": "ODISHA"
  },
  "756074": {
    "city": "BALASORE",
    "state": "ODISHA"
  },
  "756075": {
    "city": "BALASORE",
    "state": "ODISHA"
  },
  "756076": {
    "city": "BALASORE",
    "state": "ODISHA"
  },
  "756077": {
    "city": "BALASORE",
    "state": "ODISHA"
  },
  "756078": {
    "city": "BALIAPAL",
    "state": "ODISHA"
  },
  "756079": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756080": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756081": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756082": {
    "city": "BALIAPAL",
    "state": "ODISHA"
  },
  "756083": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756084": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756085": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756086": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756087": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756100": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756101": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756110": {
    "city": "BHADRAK",
    "state": "ODISHA"
  },
  "756111": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756112": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756113": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756114": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756115": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756116": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756117": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756118": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756119": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756120": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756121": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756122": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756123": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756124": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756125": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756126": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756127": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756128": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756129": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756130": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756131": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756132": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756133": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756134": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756135": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756136": {
    "city": "BHADRAK",
    "state": "ODISHA"
  },
  "756137": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756138": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756139": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756140": {
    "city": "CHANDBALI",
    "state": "ODISHA"
  },
  "756141": {
    "city": "CHANDBALI",
    "state": "ODISHA"
  },
  "756142": {
    "city": "CHANDBALI",
    "state": "ODISHA"
  },
  "756143": {
    "city": "HATADIHI",
    "state": "ODISHA"
  },
  "756144": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756161": {
    "city": "BASUDEBPUR",
    "state": "ODISHA"
  },
  "756162": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756163": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756164": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756165": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756166": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "756167": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756168": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756169": {
    "city": "BASUDEBPUR",
    "state": "ODISHA"
  },
  "756171": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756181": {
    "city": "Bhadrak",
    "state": "Odisha"
  },
  "756182": {
    "city": "Baleswar",
    "state": "Odisha"
  },
  "757001": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757002": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757003": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757012": {
    "city": "BARIPADA",
    "state": "ODISHA"
  },
  "757014": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757015": {
    "city": "BARIPADA",
    "state": "ODISHA"
  },
  "757016": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757017": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757018": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757019": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757020": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757021": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757022": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757023": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757024": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757025": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757026": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757027": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757028": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757029": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757030": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757031": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757032": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757033": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757034": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757035": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757036": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757037": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757038": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757039": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757040": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757041": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757042": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757043": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757045": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757046": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757047": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757048": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757049": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757050": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757051": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757052": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757053": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757054": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757055": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757056": {
    "city": "JALESHWAR",
    "state": "ODISHA"
  },
  "757070": {
    "city": "JALESHWAR",
    "state": "ODISHA"
  },
  "757071": {
    "city": "JALESHWAR",
    "state": "ODISHA"
  },
  "757072": {
    "city": "MORADA",
    "state": "ODISHA"
  },
  "757073": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757074": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757075": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757076": {
    "city": "SORO",
    "state": "ODISHA"
  },
  "757077": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757078": {
    "city": "HATADIHI",
    "state": "ODISHA"
  },
  "757079": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757080": {
    "city": "JHARPOKHARIA",
    "state": "ODISHA"
  },
  "757081": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757082": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757083": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757084": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757085": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757086": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757087": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757091": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757092": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757093": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757100": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757101": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757102": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757103": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757104": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757105": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757106": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "757107": {
    "city": "Mayurbhanj",
    "state": "Odisha"
  },
  "758001": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758002": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758013": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758014": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758015": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758016": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758017": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758018": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758019": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758020": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758021": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758022": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758023": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758025": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758026": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758027": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758028": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758029": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758030": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758031": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758032": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758033": {
    "city": "BARBIL",
    "state": "ODISHA"
  },
  "758034": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758035": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758036": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758037": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758038": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758040": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758041": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758042": {
    "city": "BARBIL",
    "state": "ODISHA"
  },
  "758043": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758044": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758045": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758046": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758047": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758048": {
    "city": "CHAMPUA",
    "state": "ODISHA"
  },
  "758049": {
    "city": "CHAMPUA",
    "state": "ODISHA"
  },
  "758051": {
    "city": "CHAMPUA",
    "state": "ODISHA"
  },
  "758052": {
    "city": "BARBIL",
    "state": "ODISHA"
  },
  "758053": {
    "city": "CHAMPUA",
    "state": "ODISHA"
  },
  "758054": {
    "city": "CHAMPUA",
    "state": "ODISHA"
  },
  "758061": {
    "city": "CHAMPUA",
    "state": "ODISHA"
  },
  "758062": {
    "city": "CHAMPUA",
    "state": "ODISHA"
  },
  "758063": {
    "city": "CHAMPUA",
    "state": "ODISHA"
  },
  "758064": {
    "city": "CHAMPUA",
    "state": "ODISHA"
  },
  "758071": {
    "city": "CHAMPUA",
    "state": "ODISHA"
  },
  "758072": {
    "city": "CHAMPUA",
    "state": "ODISHA"
  },
  "758073": {
    "city": "CHAMPUA",
    "state": "ODISHA"
  },
  "758074": {
    "city": "KENDUJHARGARH",
    "state": "ODISHA"
  },
  "758075": {
    "city": "TELKOI",
    "state": "ODISHA"
  },
  "758076": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758077": {
    "city": "HATADIHI",
    "state": "ODISHA"
  },
  "758078": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758079": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758080": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758081": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758082": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758083": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758084": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758085": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758086": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "758087": {
    "city": "Kendujhar",
    "state": "Odisha"
  },
  "759001": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759013": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759014": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759015": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759016": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759017": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759018": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759019": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759020": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759021": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759022": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759023": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759024": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759025": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759026": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759027": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759028": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759029": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759030": {
    "city": "KAMAKHYANAGAR",
    "state": "ODISHA"
  },
  "759031": {
    "city": "KAMAKHYANAGAR",
    "state": "ODISHA"
  },
  "759032": {
    "city": "KAMAKHYANAGAR",
    "state": "ODISHA"
  },
  "759033": {
    "city": "KAMAKHYANAGAR",
    "state": "ODISHA"
  },
  "759034": {
    "city": "KAMAKHYANAGAR",
    "state": "ODISHA"
  },
  "759035": {
    "city": "KAMAKHYANAGAR",
    "state": "ODISHA"
  },
  "759036": {
    "city": "KANIHA",
    "state": "ODISHA"
  },
  "759037": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759039": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759040": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759100": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759101": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759102": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759103": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759104": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759105": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759106": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759107": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759111": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759114": {
    "city": "ANGUL",
    "state": "ODISHA"
  },
  "759116": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759117": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759118": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759119": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759120": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759121": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759122": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759123": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759124": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759125": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759126": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759127": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759128": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759129": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759130": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759131": {
    "city": "ANGUL",
    "state": "ODISHA"
  },
  "759132": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759133": {
    "city": "ANGUL",
    "state": "ODISHA"
  },
  "759134": {
    "city": "ANGUL",
    "state": "ODISHA"
  },
  "759135": {
    "city": "ANGUL",
    "state": "ODISHA"
  },
  "759136": {
    "city": "ANGUL",
    "state": "ODISHA"
  },
  "759137": {
    "city": "ANGUL",
    "state": "ODISHA"
  },
  "759138": {
    "city": "ANGUL",
    "state": "ODISHA"
  },
  "759139": {
    "city": "ANGUL",
    "state": "ODISHA"
  },
  "759140": {
    "city": "CHENDIPADA",
    "state": "ODISHA"
  },
  "759141": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759142": {
    "city": "ANGUL",
    "state": "ODISHA"
  },
  "759143": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759144": {
    "city": "ANGUL",
    "state": "ODISHA"
  },
  "759145": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759146": {
    "city": "Dhenkanal",
    "state": "Odisha"
  },
  "759147": {
    "city": "Angul",
    "state": "Odisha"
  },
  "759148": {
    "city": "Angul",
    "state": "Odisha"
  },
  "760001": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "760002": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "760003": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "760004": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "760005": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "760006": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "760007": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "760008": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "760009": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "760010": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "760011": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "760020": {
    "city": "BOUDH",
    "state": "ODISHA"
  },
  "760031": {
    "city": "BERHAMPUR",
    "state": "ODISHA"
  },
  "760032": {
    "city": "CHHATRAPUR",
    "state": "ODISHA"
  },
  "760033": {
    "city": "BERHAMPUR",
    "state": "ODISHA"
  },
  "760034": {
    "city": "CHHATRAPUR",
    "state": "ODISHA"
  },
  "760100": {
    "city": "DIGAPAHANDI",
    "state": "ODISHA"
  },
  "761001": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761002": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761003": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761004": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761005": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761006": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761007": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761008": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761009": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761010": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761011": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761012": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761013": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761014": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761015": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761016": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761017": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761018": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761019": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761020": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761021": {
    "city": "CHHATRAPUR",
    "state": "ODISHA"
  },
  "761022": {
    "city": "CHHATRAPUR",
    "state": "ODISHA"
  },
  "761025": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761026": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761027": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761028": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761029": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761030": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761031": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761032": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761033": {
    "city": "PURUSOTTAMPUR",
    "state": "ODISHA"
  },
  "761034": {
    "city": "PURUSOTTAMPUR",
    "state": "ODISHA"
  },
  "761035": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761036": {
    "city": "DIGAPAHANDI",
    "state": "ODISHA"
  },
  "761037": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761038": {
    "city": "DIGAPAHANDI",
    "state": "ODISHA"
  },
  "761039": {
    "city": "DIGAPAHANDI",
    "state": "ODISHA"
  },
  "761040": {
    "city": "PURUSOTTAMPUR",
    "state": "ODISHA"
  },
  "761041": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761042": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761043": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761044": {
    "city": "CHHATRAPUR",
    "state": "ODISHA"
  },
  "761045": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761046": {
    "city": "CHHATRAPUR",
    "state": "ODISHA"
  },
  "761051": {
    "city": "CHHATRAPUR",
    "state": "ODISHA"
  },
  "761052": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761053": {
    "city": "CHHATRAPUR",
    "state": "ODISHA"
  },
  "761054": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761055": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761056": {
    "city": "DIGAPAHANDI",
    "state": "ODISHA"
  },
  "761100": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761101": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761102": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761103": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761104": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761105": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761106": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761107": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761108": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761109": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761110": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761111": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761112": {
    "city": "BUGUDA",
    "state": "ODISHA"
  },
  "761113": {
    "city": "ASKA",
    "state": "ODISHA"
  },
  "761114": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761115": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761116": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761117": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761118": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761119": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761120": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761121": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761122": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761123": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761124": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761125": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761126": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761127": {
    "city": "BHANJANAGAR",
    "state": "ODISHA"
  },
  "761128": {
    "city": "BHANJANAGAR",
    "state": "ODISHA"
  },
  "761131": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761132": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761133": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761134": {
    "city": "BHANJANAGAR",
    "state": "ODISHA"
  },
  "761135": {
    "city": "BHANJANAGAR",
    "state": "ODISHA"
  },
  "761136": {
    "city": "BHANJANAGAR",
    "state": "ODISHA"
  },
  "761137": {
    "city": "BHANJANAGAR",
    "state": "ODISHA"
  },
  "761138": {
    "city": "BHANJANAGAR",
    "state": "ODISHA"
  },
  "761139": {
    "city": "BHANJANAGAR",
    "state": "ODISHA"
  },
  "761140": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761141": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761142": {
    "city": "BUGUDA",
    "state": "ODISHA"
  },
  "761143": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761144": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761145": {
    "city": "ASKA",
    "state": "ODISHA"
  },
  "761146": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761151": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761200": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761201": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761206": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761207": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761208": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761209": {
    "city": "Ganjam",
    "state": "Odisha"
  },
  "761210": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761211": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761212": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761213": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761214": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761215": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "761216": {
    "city": "MOHANA",
    "state": "ODISHA"
  },
  "761217": {
    "city": "Gajapati",
    "state": "Odisha"
  },
  "762001": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762002": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762010": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762011": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762012": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762013": {
    "city": "Boudh",
    "state": "Odisha"
  },
  "762014": {
    "city": "Boudh",
    "state": "Odisha"
  },
  "762015": {
    "city": "Boudh",
    "state": "Odisha"
  },
  "762016": {
    "city": "Boudh",
    "state": "Odisha"
  },
  "762017": {
    "city": "Boudh",
    "state": "Odisha"
  },
  "762018": {
    "city": "Boudh",
    "state": "Odisha"
  },
  "762019": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762020": {
    "city": "Boudh",
    "state": "Odisha"
  },
  "762021": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762022": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762023": {
    "city": "Boudh",
    "state": "Odisha"
  },
  "762024": {
    "city": "Boudh",
    "state": "Odisha"
  },
  "762025": {
    "city": "BOUDH",
    "state": "ODISHA"
  },
  "762026": {
    "city": "Boudh",
    "state": "Odisha"
  },
  "762027": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762028": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762029": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762030": {
    "city": "Boudh",
    "state": "Odisha"
  },
  "762100": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762101": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762102": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762103": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762104": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762105": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762106": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762107": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762108": {
    "city": "BALLIGUDA",
    "state": "ODISHA"
  },
  "762109": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762110": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "762111": {
    "city": "G. UDAYAGIRI",
    "state": "ODISHA"
  },
  "762112": {
    "city": "Kandhamal",
    "state": "Odisha"
  },
  "763001": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "763002": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "763003": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "763004": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "763008": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "763036": {
    "city": "KORAPUT",
    "state": "ODISHA"
  },
  "764001": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764002": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764003": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764004": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764005": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764006": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764008": {
    "city": "JAYPORE",
    "state": "ODISHA"
  },
  "764011": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764012": {
    "city": "JAYPORE",
    "state": "ODISHA"
  },
  "764014": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764020": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764021": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764022": {
    "city": "KORAPUT",
    "state": "ODISHA"
  },
  "764027": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764028": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764036": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764037": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764038": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764039": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764040": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764041": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764042": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764043": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764044": {
    "city": "Malkangiri",
    "state": "Odisha"
  },
  "764045": {
    "city": "Malkangiri",
    "state": "Odisha"
  },
  "764046": {
    "city": "Malkangiri",
    "state": "Odisha"
  },
  "764047": {
    "city": "Malkangiri",
    "state": "Odisha"
  },
  "764048": {
    "city": "Malkangiri",
    "state": "Odisha"
  },
  "764049": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764051": {
    "city": "Malkangiri",
    "state": "Odisha"
  },
  "764052": {
    "city": "Malkangiri",
    "state": "Odisha"
  },
  "764053": {
    "city": "BALIMELA",
    "state": "ODISHA"
  },
  "764054": {
    "city": "JAYPORE",
    "state": "ODISHA"
  },
  "764055": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764056": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764057": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764058": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764059": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764060": {
    "city": "KOTAPAD",
    "state": "ODISHA"
  },
  "764061": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764062": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "764063": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764069": {
    "city": "NABARANGAPUR",
    "state": "ODISHA"
  },
  "764070": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764071": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764072": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764073": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764074": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764075": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764076": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764077": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764078": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764079": {
    "city": "NABARANGAPUR",
    "state": "ODISHA"
  },
  "764081": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "764082": {
    "city": "JAYPORE",
    "state": "ODISHA"
  },
  "764083": {
    "city": "JAYPORE",
    "state": "ODISHA"
  },
  "764084": {
    "city": "JAYAPATNA",
    "state": "ODISHA"
  },
  "764085": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "764086": {
    "city": "Malkangiri",
    "state": "Odisha"
  },
  "764087": {
    "city": "Malkangiri",
    "state": "Odisha"
  },
  "764088": {
    "city": "Nabarangapur",
    "state": "Odisha"
  },
  "765001": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765002": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765012": {
    "city": "TIKIRI",
    "state": "ODISHA"
  },
  "765013": {
    "city": "Koraput",
    "state": "Odisha"
  },
  "765014": {
    "city": "TIKIRI",
    "state": "ODISHA"
  },
  "765015": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765016": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765017": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765018": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765019": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765020": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765021": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765022": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765023": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765024": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765025": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765026": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765027": {
    "city": "BISSAMCUTTACK",
    "state": "ODISHA"
  },
  "765028": {
    "city": "RAYAGADA",
    "state": "ODISHA"
  },
  "765029": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765030": {
    "city": "RAYAGADA",
    "state": "ODISHA"
  },
  "765031": {
    "city": "RAYAGADA",
    "state": "ODISHA"
  },
  "765032": {
    "city": "GUNUPUR",
    "state": "ODISHA"
  },
  "765033": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765034": {
    "city": "Rayagada",
    "state": "Odisha"
  },
  "765062": {
    "city": "GUNUPUR",
    "state": "ODISHA"
  },
  "766001": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766002": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766011": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766012": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766013": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766014": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766015": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766016": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766017": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766018": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766019": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766020": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766021": {
    "city": "BHAWANIPATNA",
    "state": "ODISHA"
  },
  "766022": {
    "city": "JUNAGADA",
    "state": "ODISHA"
  },
  "766023": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766024": {
    "city": "JUNAGADA",
    "state": "ODISHA"
  },
  "766025": {
    "city": "JAYAPATNA",
    "state": "ODISHA"
  },
  "766026": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766027": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766028": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766029": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766031": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766032": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766036": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766037": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766100": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766101": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766102": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766103": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766104": {
    "city": "Nuapada",
    "state": "Odisha"
  },
  "766105": {
    "city": "Nuapada",
    "state": "Odisha"
  },
  "766106": {
    "city": "Nuapada",
    "state": "Odisha"
  },
  "766107": {
    "city": "Nuapada",
    "state": "Odisha"
  },
  "766108": {
    "city": "Nuapada",
    "state": "Odisha"
  },
  "766109": {
    "city": "BHAWANIPATNA",
    "state": "ODISHA"
  },
  "766110": {
    "city": "Kalahandi",
    "state": "Odisha"
  },
  "766111": {
    "city": "Nuapada",
    "state": "Odisha"
  },
  "766112": {
    "city": "NUAPARHA",
    "state": "ODISHA"
  },
  "766113": {
    "city": "NUAPARHA",
    "state": "ODISHA"
  },
  "766114": {
    "city": "NUAPARHA",
    "state": "ODISHA"
  },
  "766115": {
    "city": "NUAPARHA",
    "state": "ODISHA"
  },
  "766116": {
    "city": "NUAPARHA",
    "state": "ODISHA"
  },
  "766117": {
    "city": "KHARIAR",
    "state": "ODISHA"
  },
  "766118": {
    "city": "Nuapada",
    "state": "Odisha"
  },
  "766692": {
    "city": "Duliajan",
    "state": "ASSAM"
  },
  "767001": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767002": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767003": {
    "city": "BALANGIR",
    "state": "ODISHA"
  },
  "767004": {
    "city": "BALANGIR",
    "state": "ODISHA"
  },
  "767005": {
    "city": "BALANGIR",
    "state": "ODISHA"
  },
  "767006": {
    "city": "BALANGIR",
    "state": "ODISHA"
  },
  "767016": {
    "city": "Sonapur",
    "state": "Odisha"
  },
  "767017": {
    "city": "Sonapur",
    "state": "Odisha"
  },
  "767018": {
    "city": "Sonapur",
    "state": "Odisha"
  },
  "767019": {
    "city": "Sonapur",
    "state": "Odisha"
  },
  "767020": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767021": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767022": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767023": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767024": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767025": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767026": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767027": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767028": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767029": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767030": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767031": {
    "city": "SAINTALA",
    "state": "ODISHA"
  },
  "767032": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767033": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767034": {
    "city": "TITLAGARH",
    "state": "ODISHA"
  },
  "767035": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767036": {
    "city": "TITLAGARH",
    "state": "ODISHA"
  },
  "767037": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767038": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767039": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767040": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767041": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767042": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767043": {
    "city": "TITLAGARH",
    "state": "ODISHA"
  },
  "767044": {
    "city": "BINIKA",
    "state": "ODISHA"
  },
  "767045": {
    "city": "Sonapur",
    "state": "Odisha"
  },
  "767046": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767047": {
    "city": "PATNAGARH",
    "state": "ODISHA"
  },
  "767048": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767049": {
    "city": "PATNAGARH",
    "state": "ODISHA"
  },
  "767050": {
    "city": "PATNAGARH",
    "state": "ODISHA"
  },
  "767060": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767061": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767062": {
    "city": "Sonapur",
    "state": "Odisha"
  },
  "767063": {
    "city": "BINIKA",
    "state": "ODISHA"
  },
  "767064": {
    "city": "BALANGIR",
    "state": "ODISHA"
  },
  "767065": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767066": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767067": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767068": {
    "city": "Sonapur",
    "state": "Odisha"
  },
  "767070": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767071": {
    "city": "Balangir",
    "state": "Odisha"
  },
  "767091": {
    "city": "TALCHER",
    "state": "ODISHA"
  },
  "767184": {
    "city": "TALCHER",
    "state": "ODISHA"
  },
  "768001": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768002": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768003": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768004": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768005": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768006": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768011": {
    "city": "SAMBALPUR",
    "state": "ODISHA"
  },
  "768016": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768017": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768018": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768019": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768020": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768025": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768026": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768027": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768028": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768029": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768030": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768031": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768032": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768033": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768034": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768035": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768036": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768037": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768038": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768039": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768040": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768041": {
    "city": "PADMAPUR",
    "state": "ODISHA"
  },
  "768042": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768043": {
    "city": "PADMAPUR",
    "state": "ODISHA"
  },
  "768044": {
    "city": "BHATLI",
    "state": "ODISHA"
  },
  "768045": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768046": {
    "city": "BHATLI",
    "state": "ODISHA"
  },
  "768047": {
    "city": "SOHELA",
    "state": "ODISHA"
  },
  "768048": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768049": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768050": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768051": {
    "city": "BHATLI",
    "state": "ODISHA"
  },
  "768052": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768053": {
    "city": "BHATLI",
    "state": "ODISHA"
  },
  "768054": {
    "city": "BHATLI",
    "state": "ODISHA"
  },
  "768100": {
    "city": "BHATLI",
    "state": "ODISHA"
  },
  "768101": {
    "city": "ATTABIRA",
    "state": "ODISHA"
  },
  "768102": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768103": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768104": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768105": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768106": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768107": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768108": {
    "city": "Debagarh",
    "state": "Odisha"
  },
  "768109": {
    "city": "Debagarh",
    "state": "Odisha"
  },
  "768110": {
    "city": "Debagarh",
    "state": "Odisha"
  },
  "768111": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768112": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768113": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768114": {
    "city": "BINIKA",
    "state": "ODISHA"
  },
  "768115": {
    "city": "Bargarh",
    "state": "Odisha"
  },
  "768116": {
    "city": "BINIKA",
    "state": "ODISHA"
  },
  "768117": {
    "city": "REDHAKHOL",
    "state": "ODISHA"
  },
  "768118": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768119": {
    "city": "Debagarh",
    "state": "Odisha"
  },
  "768120": {
    "city": "DEOGARH",
    "state": "ODISHA"
  },
  "768121": {
    "city": "Debagarh",
    "state": "Odisha"
  },
  "768130": {
    "city": "DEOGARH",
    "state": "ODISHA"
  },
  "768142": {
    "city": "DEOGARH",
    "state": "ODISHA"
  },
  "768150": {
    "city": "SAMBALPUR",
    "state": "ODISHA"
  },
  "768151": {
    "city": "DEOGARH",
    "state": "ODISHA"
  },
  "768200": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768201": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768202": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768203": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768204": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768205": {
    "city": "JHARSUGUDA",
    "state": "ODISHA"
  },
  "768210": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768211": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768212": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768213": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768214": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768215": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768216": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768217": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768218": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768219": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768220": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768221": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768222": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768223": {
    "city": "RAJGANGPUR",
    "state": "ODISHA"
  },
  "768224": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768225": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768226": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768227": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768228": {
    "city": "Sambalpur",
    "state": "Odisha"
  },
  "768229": {
    "city": "KUCHINDA",
    "state": "ODISHA"
  },
  "768230": {
    "city": "KUCHINDA",
    "state": "ODISHA"
  },
  "768231": {
    "city": "KUCHINDA",
    "state": "ODISHA"
  },
  "768232": {
    "city": "RENGALI",
    "state": "ODISHA"
  },
  "768233": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "768234": {
    "city": "Jharsuguda",
    "state": "Odisha"
  },
  "769001": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769002": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769003": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769004": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769005": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769006": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769007": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769008": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769009": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769010": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769011": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769012": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769013": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769014": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769015": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769016": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769017": {
    "city": "ROURKELA",
    "state": "ODISHA"
  },
  "769018": {
    "city": "ROURKELA",
    "state": "ODISHA"
  },
  "769019": {
    "city": "ROURKELA",
    "state": "ODISHA"
  },
  "769032": {
    "city": "ROURKELA",
    "state": "ODISHA"
  },
  "769041": {
    "city": "ROURKELA",
    "state": "ODISHA"
  },
  "769042": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "769043": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770001": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770002": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770011": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770012": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770013": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770014": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770015": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770016": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770017": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770018": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770019": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770020": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770021": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770022": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770023": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770024": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770025": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770026": {
    "city": "SUNDERGARH",
    "state": "ODISHA"
  },
  "770027": {
    "city": "SUNDERGARH",
    "state": "ODISHA"
  },
  "770029": {
    "city": "ROURKELA",
    "state": "ODISHA"
  },
  "770031": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770032": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770033": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770034": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770035": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770036": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770037": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770038": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770039": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770040": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770041": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770042": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770043": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770044": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770045": {
    "city": "BIRMITRAPUR",
    "state": "ODISHA"
  },
  "770046": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770047": {
    "city": "BARBIL",
    "state": "ODISHA"
  },
  "770048": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770049": {
    "city": "BARBIL",
    "state": "ODISHA"
  },
  "770050": {
    "city": "BANEI",
    "state": "ODISHA"
  },
  "770051": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770052": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770070": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770071": {
    "city": "SUNDERGARH",
    "state": "ODISHA"
  },
  "770072": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770073": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770074": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770075": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770076": {
    "city": "Sundergarh",
    "state": "Odisha"
  },
  "770077": {
    "city": "SUNDERGARH",
    "state": "ODISHA"
  },
  "781000": {
    "city": "GUWAHATI",
    "state": "ASSAM"
  },
  "781001": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781002": {
    "city": "GUWAHATI",
    "state": "ASSAM"
  },
  "781003": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781004": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781005": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781006": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781007": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781008": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781009": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781010": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781011": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781012": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781013": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781014": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781015": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781016": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781017": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781018": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781019": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781020": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781021": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781022": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781023": {
    "city": "SONAPUR",
    "state": "ASSAM"
  },
  "781024": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781025": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781026": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781027": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781028": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781029": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781030": {
    "city": "BAIHATA",
    "state": "ASSAM"
  },
  "781031": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781032": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781033": {
    "city": "GUWAHATI",
    "state": "ASSAM"
  },
  "781034": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781035": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781036": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781037": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781038": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781039": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781040": {
    "city": "GUWAHATI",
    "state": "ASSAM"
  },
  "781068": {
    "city": "GUWAHATI",
    "state": "ASSAM"
  },
  "781071": {
    "city": "GUWAHATI",
    "state": "ASSAM"
  },
  "781101": {
    "city": "BAIHATA",
    "state": "ASSAM"
  },
  "781102": {
    "city": "HAJO",
    "state": "ASSAM"
  },
  "781103": {
    "city": "HAJO",
    "state": "ASSAM"
  },
  "781104": {
    "city": "HAJO",
    "state": "ASSAM"
  },
  "781111": {
    "city": "MIRZA",
    "state": "ASSAM"
  },
  "781112": {
    "city": "MIRZA",
    "state": "ASSAM"
  },
  "781120": {
    "city": "MIRZA",
    "state": "ASSAM"
  },
  "781121": {
    "city": "BAIHATA",
    "state": "ASSAM"
  },
  "781122": {
    "city": "MIRZA",
    "state": "ASSAM"
  },
  "781123": {
    "city": "DHUPDHARA",
    "state": "ASSAM"
  },
  "781124": {
    "city": "CHHAYAGAON",
    "state": "ASSAM"
  },
  "781125": {
    "city": "GUWAHATI",
    "state": "ASSAM"
  },
  "781126": {
    "city": "HAJO",
    "state": "ASSAM"
  },
  "781127": {
    "city": "DHUPDHARA",
    "state": "ASSAM"
  },
  "781128": {
    "city": "MIRZA",
    "state": "ASSAM"
  },
  "781129": {
    "city": "DHUPDHARA",
    "state": "ASSAM"
  },
  "781130": {
    "city": "MIRZA",
    "state": "ASSAM"
  },
  "781131": {
    "city": "MIRZA",
    "state": "ASSAM"
  },
  "781132": {
    "city": "CHHAYAGAON",
    "state": "ASSAM"
  },
  "781133": {
    "city": "BAIHATA",
    "state": "ASSAM"
  },
  "781134": {
    "city": "CHHAYAGAON",
    "state": "ASSAM"
  },
  "781135": {
    "city": "DHUPDHARA",
    "state": "ASSAM"
  },
  "781136": {
    "city": "DHUPDHARA",
    "state": "ASSAM"
  },
  "781137": {
    "city": "CHHAYAGAON",
    "state": "ASSAM"
  },
  "781138": {
    "city": "KARAKUCHI",
    "state": "ASSAM"
  },
  "781141": {
    "city": "CHHAYAGAON",
    "state": "ASSAM"
  },
  "781150": {
    "city": "SONAPUR",
    "state": "ASSAM"
  },
  "781171": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781301": {
    "city": "BARPETA",
    "state": "ASSAM"
  },
  "781302": {
    "city": "BARPETA",
    "state": "ASSAM"
  },
  "781303": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781304": {
    "city": "KARAKUCHI",
    "state": "ASSAM"
  },
  "781305": {
    "city": "KARAKUCHI",
    "state": "ASSAM"
  },
  "781306": {
    "city": "KARAKUCHI",
    "state": "ASSAM"
  },
  "781307": {
    "city": "KARAKUCHI",
    "state": "ASSAM"
  },
  "781308": {
    "city": "BARPETA",
    "state": "ASSAM"
  },
  "781309": {
    "city": "BARPETA",
    "state": "ASSAM"
  },
  "781310": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781311": {
    "city": "KARAKUCHI",
    "state": "ASSAM"
  },
  "781312": {
    "city": "KARAKUCHI",
    "state": "ASSAM"
  },
  "781313": {
    "city": "BARPETA",
    "state": "ASSAM"
  },
  "781314": {
    "city": "BARPETA",
    "state": "ASSAM"
  },
  "781315": {
    "city": "BARPETA",
    "state": "ASSAM"
  },
  "781316": {
    "city": "BARPETA",
    "state": "ASSAM"
  },
  "781317": {
    "city": "BARPETA",
    "state": "ASSAM"
  },
  "781318": {
    "city": "JALAHGAON",
    "state": "ASSAM"
  },
  "781319": {
    "city": "BARPETA",
    "state": "ASSAM"
  },
  "781320": {
    "city": "GOALPARA",
    "state": "ASSAM"
  },
  "781321": {
    "city": "BARPETA",
    "state": "ASSAM"
  },
  "781325": {
    "city": "JALAHGAON",
    "state": "ASSAM"
  },
  "781326": {
    "city": "KARAKUCHI",
    "state": "ASSAM"
  },
  "781327": {
    "city": "JALAHGAON",
    "state": "ASSAM"
  },
  "781328": {
    "city": "JALAHGAON",
    "state": "ASSAM"
  },
  "781329": {
    "city": "JALAHGAON",
    "state": "ASSAM"
  },
  "781330": {
    "city": "JALAHGAON",
    "state": "ASSAM"
  },
  "781333": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781334": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781335": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781336": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781337": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781338": {
    "city": "KARAKUCHI",
    "state": "ASSAM"
  },
  "781339": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781340": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781341": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781343": {
    "city": "JALAHGAON",
    "state": "ASSAM"
  },
  "781344": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781345": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781346": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781347": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781348": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781349": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781350": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781351": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781352": {
    "city": "BARPETA",
    "state": "ASSAM"
  },
  "781353": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781354": {
    "city": "KAMRUP",
    "state": "ASSAM"
  },
  "781355": {
    "city": "JALAHGAON",
    "state": "ASSAM"
  },
  "781360": {
    "city": "TAMULPUR",
    "state": "ASSAM"
  },
  "781364": {
    "city": "GORESWAR",
    "state": "ASSAM"
  },
  "781365": {
    "city": "RANGIA",
    "state": "ASSAM"
  },
  "781366": {
    "city": "GORESWAR",
    "state": "ASSAM"
  },
  "781367": {
    "city": "TAMULPUR",
    "state": "ASSAM"
  },
  "781368": {
    "city": "TAMULPUR",
    "state": "ASSAM"
  },
  "781369": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781370": {
    "city": "NALBARI",
    "state": "ASSAM"
  },
  "781371": {
    "city": "KARAKUCHI",
    "state": "ASSAM"
  },
  "781372": {
    "city": "JALAHGAON",
    "state": "ASSAM"
  },
  "781373": {
    "city": "JALAHGAON",
    "state": "ASSAM"
  },
  "781374": {
    "city": "KARAKUCHI",
    "state": "ASSAM"
  },
  "781375": {
    "city": "KARAKUCHI",
    "state": "ASSAM"
  },
  "781376": {
    "city": "TAMULPUR",
    "state": "ASSAM"
  },
  "781377": {
    "city": "JALAHGAON",
    "state": "ASSAM"
  },
  "781378": {
    "city": "KARAKUCHI",
    "state": "ASSAM"
  },
  "781380": {
    "city": "RANGIA",
    "state": "ASSAM"
  },
  "781381": {
    "city": "RANGIA",
    "state": "ASSAM"
  },
  "781382": {
    "city": "BAIHATA",
    "state": "ASSAM"
  },
  "781385": {
    "city": "BAIHATA",
    "state": "ASSAM"
  },
  "781402": {
    "city": "SONAPUR",
    "state": "ASSAM"
  },
  "782001": {
    "city": "NAGAON",
    "state": "ASSAM"
  },
  "782002": {
    "city": "NAGAON",
    "state": "ASSAM"
  },
  "782003": {
    "city": "NAGAON",
    "state": "ASSAM"
  },
  "782010": {
    "city": "NAGAON",
    "state": "ASSAM"
  },
  "782101": {
    "city": "NAGAON",
    "state": "ASSAM"
  },
  "782102": {
    "city": "NAGAON",
    "state": "ASSAM"
  },
  "782103": {
    "city": "RAHA",
    "state": "ASSAM"
  },
  "782104": {
    "city": "MORIGAON",
    "state": "ASSAM"
  },
  "782105": {
    "city": "MORIGAON",
    "state": "ASSAM"
  },
  "782106": {
    "city": "MORIGAON",
    "state": "ASSAM"
  },
  "782107": {
    "city": "MORIGAON",
    "state": "ASSAM"
  },
  "782108": {
    "city": "MORIGAON",
    "state": "ASSAM"
  },
  "782120": {
    "city": "KALIABOR",
    "state": "ASSAM"
  },
  "782121": {
    "city": "LAHARIGHAT",
    "state": "ASSAM"
  },
  "782122": {
    "city": "DHING",
    "state": "ASSAM"
  },
  "782123": {
    "city": "DHING",
    "state": "ASSAM"
  },
  "782124": {
    "city": "NAGAON",
    "state": "ASSAM"
  },
  "782125": {
    "city": "NAGAON",
    "state": "ASSAM"
  },
  "782126": {
    "city": "DHING",
    "state": "ASSAM"
  },
  "782127": {
    "city": "LAHARIGHAT",
    "state": "ASSAM"
  },
  "782128": {
    "city": "LAHARIGHAT",
    "state": "ASSAM"
  },
  "782130": {
    "city": "LAHARIGHAT",
    "state": "ASSAM"
  },
  "782135": {
    "city": "NAGAON",
    "state": "ASSAM"
  },
  "782136": {
    "city": "KALIABOR",
    "state": "ASSAM"
  },
  "782137": {
    "city": "KALIABOR",
    "state": "ASSAM"
  },
  "782138": {
    "city": "KALIABOR",
    "state": "ASSAM"
  },
  "782139": {
    "city": "KALIABOR",
    "state": "ASSAM"
  },
  "782140": {
    "city": "NAGAON",
    "state": "ASSAM"
  },
  "782141": {
    "city": "NAGAON",
    "state": "ASSAM"
  },
  "782142": {
    "city": "NAGAON",
    "state": "ASSAM"
  },
  "782143": {
    "city": "KALIABOR",
    "state": "ASSAM"
  },
  "782144": {
    "city": "KATHIATOLI",
    "state": "ASSAM"
  },
  "782168": {
    "city": "KATHIATOLI",
    "state": "ASSAM"
  },
  "782401": {
    "city": "SONAPUR",
    "state": "ASSAM"
  },
  "782402": {
    "city": "REHABARI OFFICE",
    "state": "ASSAM"
  },
  "782403": {
    "city": "JAGIROAD",
    "state": "ASSAM"
  },
  "782410": {
    "city": "JAGIROAD",
    "state": "ASSAM"
  },
  "782411": {
    "city": "JAGIROAD",
    "state": "ASSAM"
  },
  "782412": {
    "city": "MORIGAON",
    "state": "ASSAM"
  },
  "782413": {
    "city": "JAGIROAD",
    "state": "ASSAM"
  },
  "782425": {
    "city": "RAHA",
    "state": "ASSAM"
  },
  "782426": {
    "city": "KATHIATOLI",
    "state": "ASSAM"
  },
  "782427": {
    "city": "KATHIATOLI",
    "state": "ASSAM"
  },
  "782428": {
    "city": "KATHIATOLI",
    "state": "ASSAM"
  },
  "782429": {
    "city": "HOJAI",
    "state": "ASSAM"
  },
  "782435": {
    "city": "NAGAON",
    "state": "ASSAM"
  },
  "782439": {
    "city": "HOWRAGHAT",
    "state": "ASSAM"
  },
  "782440": {
    "city": "KATHIATOLI",
    "state": "ASSAM"
  },
  "782441": {
    "city": "DOKMOKA",
    "state": "ASSAM"
  },
  "782442": {
    "city": "LANKA",
    "state": "ASSAM"
  },
  "782445": {
    "city": "HOJAI",
    "state": "ASSAM"
  },
  "782446": {
    "city": "LANKA",
    "state": "ASSAM"
  },
  "782447": {
    "city": "LUMDING",
    "state": "ASSAM"
  },
  "782448": {
    "city": "LANKA",
    "state": "ASSAM"
  },
  "782450": {
    "city": "HOJAI",
    "state": "ASSAM"
  },
  "782460": {
    "city": "DIPHU",
    "state": "ASSAM"
  },
  "782461": {
    "city": "DIPHU",
    "state": "ASSAM"
  },
  "782462": {
    "city": "DIPHU",
    "state": "ASSAM"
  },
  "782470": {
    "city": "BOKAJAN",
    "state": "ASSAM"
  },
  "782475": {
    "city": "BOKAJAN",
    "state": "ASSAM"
  },
  "782480": {
    "city": "BOKAJAN",
    "state": "ASSAM"
  },
  "782481": {
    "city": "HOWRAGHAT",
    "state": "ASSAM"
  },
  "782482": {
    "city": "HOWRAGHAT",
    "state": "ASSAM"
  },
  "782485": {
    "city": "HOJAI",
    "state": "ASSAM"
  },
  "782486": {
    "city": "HOJAI",
    "state": "ASSAM"
  },
  "782490": {
    "city": "BOKAJAN",
    "state": "ASSAM"
  },
  "783101": {
    "city": "GOALPARA",
    "state": "ASSAM"
  },
  "783120": {
    "city": "GOALPARA",
    "state": "ASSAM"
  },
  "783121": {
    "city": "GOALPARA",
    "state": "ASSAM"
  },
  "783122": {
    "city": "DUDHNOI",
    "state": "ASSAM"
  },
  "783123": {
    "city": "DHUPDHARA",
    "state": "ASSAM"
  },
  "783124": {
    "city": "DUDHNOI",
    "state": "ASSAM"
  },
  "783125": {
    "city": "DUDHNOI",
    "state": "ASSAM"
  },
  "783126": {
    "city": "DUDHNOI",
    "state": "ASSAM"
  },
  "783127": {
    "city": "MANKACHER",
    "state": "ASSAM"
  },
  "783128": {
    "city": "MANKACHER",
    "state": "ASSAM"
  },
  "783129": {
    "city": "GOALPARA",
    "state": "ASSAM"
  },
  "783130": {
    "city": "GOALPARA",
    "state": "ASSAM"
  },
  "783131": {
    "city": "MANKACHER",
    "state": "ASSAM"
  },
  "783132": {
    "city": "LAKHIPUR-GOALPARA",
    "state": "ASSAM"
  },
  "783133": {
    "city": "GOALPARA",
    "state": "ASSAM"
  },
  "783134": {
    "city": "DUDHNOI",
    "state": "ASSAM"
  },
  "783135": {
    "city": "MANKACHER",
    "state": "ASSAM"
  },
  "783301": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783302": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783303": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783304": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783305": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783306": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783307": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783308": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783309": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783310": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783311": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783312": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783313": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783314": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783315": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783316": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783317": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783318": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783319": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783320": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783321": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783322": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783323": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783324": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783325": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783330": {
    "city": "LAKHIPUR-GOALPARA",
    "state": "ASSAM"
  },
  "783331": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783332": {
    "city": "AGOMANI",
    "state": "ASSAM"
  },
  "783333": {
    "city": "GOSSAIGAON",
    "state": "ASSAM"
  },
  "783334": {
    "city": "AGOMANI",
    "state": "ASSAM"
  },
  "783335": {
    "city": "AGOMANI",
    "state": "ASSAM"
  },
  "783336": {
    "city": "GOSSAIGAON",
    "state": "ASSAM"
  },
  "783337": {
    "city": "GOSSAIGAON",
    "state": "ASSAM"
  },
  "783338": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783339": {
    "city": "DHUBRI",
    "state": "ASSAM"
  },
  "783344": {
    "city": "BILASIPARA",
    "state": "ASSAM"
  },
  "783345": {
    "city": "BILASIPARA",
    "state": "ASSAM"
  },
  "783346": {
    "city": "GOSSAIGAON",
    "state": "ASSAM"
  },
  "783347": {
    "city": "KOKRAJHAR",
    "state": "ASSAM"
  },
  "783348": {
    "city": "BILASIPARA",
    "state": "ASSAM"
  },
  "783349": {
    "city": "BILASIPARA",
    "state": "ASSAM"
  },
  "783350": {
    "city": "GOSSAIGAON",
    "state": "ASSAM"
  },
  "783351": {
    "city": "BILASIPARA",
    "state": "ASSAM"
  },
  "783354": {
    "city": "KOKRAJHAR",
    "state": "ASSAM"
  },
  "783360": {
    "city": "GOSSAIGAON",
    "state": "ASSAM"
  },
  "783361": {
    "city": "GOSSAIGAON",
    "state": "ASSAM"
  },
  "783362": {
    "city": "GOSSAIGAON",
    "state": "ASSAM"
  },
  "783369": {
    "city": "KOKRAJHAR",
    "state": "ASSAM"
  },
  "783370": {
    "city": "KOKRAJHAR",
    "state": "ASSAM"
  },
  "783371": {
    "city": "BILASIPARA",
    "state": "ASSAM"
  },
  "783372": {
    "city": "KOKRAJHAR",
    "state": "ASSAM"
  },
  "783373": {
    "city": "BONGAIGAON",
    "state": "ASSAM"
  },
  "783374": {
    "city": "KOKRAJHAR",
    "state": "ASSAM"
  },
  "783375": {
    "city": "BONGAIGAON",
    "state": "ASSAM"
  },
  "783376": {
    "city": "KOKRAJHAR",
    "state": "ASSAM"
  },
  "783380": {
    "city": "BONGAIGAON",
    "state": "ASSAM"
  },
  "783381": {
    "city": "BONGAIGAON",
    "state": "ASSAM"
  },
  "783382": {
    "city": "ABHAYAPURI",
    "state": "ASSAM"
  },
  "783383": {
    "city": "ABHAYAPURI",
    "state": "ASSAM"
  },
  "783384": {
    "city": "ABHAYAPURI",
    "state": "ASSAM"
  },
  "783385": {
    "city": "BONGAIGAON",
    "state": "ASSAM"
  },
  "783386": {
    "city": "ABHAYAPURI",
    "state": "ASSAM"
  },
  "783387": {
    "city": "KOKRAJHAR",
    "state": "ASSAM"
  },
  "783388": {
    "city": "ABHAYAPURI",
    "state": "ASSAM"
  },
  "783389": {
    "city": "ABHAYAPURI",
    "state": "ASSAM"
  },
  "783390": {
    "city": "BIJNI",
    "state": "ASSAM"
  },
  "783391": {
    "city": "BIJNI",
    "state": "ASSAM"
  },
  "783392": {
    "city": "BIJNI",
    "state": "ASSAM"
  },
  "783393": {
    "city": "BIJNI",
    "state": "ASSAM"
  },
  "783394": {
    "city": "BONGAIGAON",
    "state": "ASSAM"
  },
  "784001": {
    "city": "SONITPUR",
    "state": "ASSAM"
  },
  "784002": {
    "city": "TEZPUR",
    "state": "ASSAM"
  },
  "784003": {
    "city": "TEZPUR",
    "state": "ASSAM"
  },
  "784004": {
    "city": "TEZPUR",
    "state": "ASSAM"
  },
  "784010": {
    "city": "SONITPUR",
    "state": "ASSAM"
  },
  "784025": {
    "city": "TEZPUR",
    "state": "ASSAM"
  },
  "784026": {
    "city": "TEZPUR",
    "state": "ASSAM"
  },
  "784027": {
    "city": "TEZPUR",
    "state": "ASSAM"
  },
  "784028": {
    "city": "TEZPUR",
    "state": "ASSAM"
  },
  "784101": {
    "city": "BALIPARA",
    "state": "ASSAM"
  },
  "784102": {
    "city": "BALIPARA",
    "state": "ASSAM"
  },
  "784103": {
    "city": "BALIPARA",
    "state": "ASSAM"
  },
  "784104": {
    "city": "SONITPUR",
    "state": "ASSAM"
  },
  "784105": {
    "city": "BALIPARA",
    "state": "ASSAM"
  },
  "784110": {
    "city": "SONITPUR",
    "state": "ASSAM"
  },
  "784111": {
    "city": "MAZBAT",
    "state": "ASSAM"
  },
  "784112": {
    "city": "MAZBAT",
    "state": "ASSAM"
  },
  "784113": {
    "city": "KHARUPETIA",
    "state": "ASSAM"
  },
  "784114": {
    "city": "MAZBAT",
    "state": "ASSAM"
  },
  "784115": {
    "city": "MANGALDOI",
    "state": "ASSAM"
  },
  "784116": {
    "city": "KHARUPETIA",
    "state": "ASSAM"
  },
  "784117": {
    "city": "DHEKIAJULI",
    "state": "ASSAM"
  },
  "784118": {
    "city": "DHEKIAJULI",
    "state": "ASSAM"
  },
  "784119": {
    "city": "DHEKIAJULI",
    "state": "ASSAM"
  },
  "784120": {
    "city": "DHEKIAJULI",
    "state": "ASSAM"
  },
  "784125": {
    "city": "DARRANG",
    "state": "ASSAM"
  },
  "784144": {
    "city": "MANGOLDOI",
    "state": "ASSAM"
  },
  "784145": {
    "city": "MANGOLDOI",
    "state": "ASSAM"
  },
  "784146": {
    "city": "MANGOLDOI",
    "state": "ASSAM"
  },
  "784147": {
    "city": "MANGOLDOI",
    "state": "ASSAM"
  },
  "784148": {
    "city": "GORESWAR",
    "state": "ASSAM"
  },
  "784149": {
    "city": "DHEKIAJULI",
    "state": "ASSAM"
  },
  "784150": {
    "city": "TEZPUR",
    "state": "ASSAM"
  },
  "784151": {
    "city": "TEZPUR",
    "state": "ASSAM"
  },
  "784152": {
    "city": "DHEKIAJULI",
    "state": "ASSAM"
  },
  "784153": {
    "city": "DHEKIAJULI",
    "state": "ASSAM"
  },
  "784154": {
    "city": "SONITPUR",
    "state": "ASSAM"
  },
  "784160": {
    "city": "LAKHIMPUR",
    "state": "ASSAM"
  },
  "784161": {
    "city": "LAKHIMPUR",
    "state": "ASSAM"
  },
  "784162": {
    "city": "BIHPURIA",
    "state": "ASSAM"
  },
  "784163": {
    "city": "BIHPURIA",
    "state": "ASSAM"
  },
  "784164": {
    "city": "LAKHIMPUR",
    "state": "ASSAM"
  },
  "784165": {
    "city": "LAKHIMPUR",
    "state": "ASSAM"
  },
  "784166": {
    "city": "BEHALI",
    "state": "ASSAM"
  },
  "784167": {
    "city": "BEHALI",
    "state": "ASSAM"
  },
  "784168": {
    "city": "GOHPUR",
    "state": "ASSAM"
  },
  "784169": {
    "city": "GOHPUR",
    "state": "ASSAM"
  },
  "784170": {
    "city": "BEHALI",
    "state": "ASSAM"
  },
  "784171": {
    "city": "BEHALI",
    "state": "ASSAM"
  },
  "784172": {
    "city": "GOHPUR",
    "state": "ASSAM"
  },
  "784173": {
    "city": "BISWANATH CHARIALI",
    "state": "ASSAM"
  },
  "784174": {
    "city": "BISWANATH CHARIALI",
    "state": "ASSAM"
  },
  "784175": {
    "city": "BISWANATH CHARIALI",
    "state": "ASSAM"
  },
  "784176": {
    "city": "BISWANATH CHARIALI",
    "state": "ASSAM"
  },
  "784177": {
    "city": "BISWANATH CHARIALI",
    "state": "ASSAM"
  },
  "784178": {
    "city": "GOHPUR",
    "state": "ASSAM"
  },
  "784179": {
    "city": "BEHALI",
    "state": "ASSAM"
  },
  "784180": {
    "city": "JAMUGURIHAT",
    "state": "ASSAM"
  },
  "784181": {
    "city": "JAMUGURIHAT",
    "state": "ASSAM"
  },
  "784182": {
    "city": "JAMUGURIHAT",
    "state": "ASSAM"
  },
  "784183": {
    "city": "JAMUGURIHAT",
    "state": "ASSAM"
  },
  "784184": {
    "city": "BEHALI",
    "state": "ASSAM"
  },
  "784185": {
    "city": "JAMUGURIHAT",
    "state": "ASSAM"
  },
  "784189": {
    "city": "JAMUGURIHAT",
    "state": "ASSAM"
  },
  "784190": {
    "city": "KHARUPETIA",
    "state": "ASSAM"
  },
  "784501": {
    "city": "SONITPUR",
    "state": "ASSAM"
  },
  "784502": {
    "city": "TEZPUR",
    "state": "ASSAM"
  },
  "784503": {
    "city": "BALIPARA",
    "state": "ASSAM"
  },
  "784504": {
    "city": "BALIPARA",
    "state": "ASSAM"
  },
  "784505": {
    "city": "BALIPARA",
    "state": "ASSAM"
  },
  "784506": {
    "city": "BALIPARA",
    "state": "ASSAM"
  },
  "784507": {
    "city": "MAZBAT",
    "state": "ASSAM"
  },
  "784508": {
    "city": "UDALGURI",
    "state": "ASSAM"
  },
  "784509": {
    "city": "UDALGURI",
    "state": "ASSAM"
  },
  "784510": {
    "city": "UDALGURI",
    "state": "ASSAM"
  },
  "784513": {
    "city": "UDALGURI",
    "state": "ASSAM"
  },
  "784514": {
    "city": "KHARUPETIA",
    "state": "ASSAM"
  },
  "784521": {
    "city": "MANGALDOI",
    "state": "ASSAM"
  },
  "784522": {
    "city": "GORESWAR",
    "state": "ASSAM"
  },
  "784523": {
    "city": "UDALGURI",
    "state": "ASSAM"
  },
  "784524": {
    "city": "UDALGURI",
    "state": "ASSAM"
  },
  "784525": {
    "city": "TANGLA",
    "state": "ASSAM"
  },
  "784526": {
    "city": "GORESWAR",
    "state": "ASSAM"
  },
  "784527": {
    "city": "UDALGURI",
    "state": "ASSAM"
  },
  "784528": {
    "city": "TANGLA",
    "state": "ASSAM"
  },
  "784529": {
    "city": "MANGOLDOI",
    "state": "ASSAM"
  },
  "784544": {
    "city": "GORESWAR",
    "state": "ASSAM"
  },
  "784614": {
    "city": "NORTH LAKHIMPUR",
    "state": "ASSAM"
  },
  "785001": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785002": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785003": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785004": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785005": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785006": {
    "city": "SIBSAGAR",
    "state": "ASSAM"
  },
  "785007": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785008": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785009": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785010": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785011": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785012": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785013": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785014": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785015": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785016": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785018": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785020": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785057": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785101": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785102": {
    "city": "MAJULI",
    "state": "ASSAM"
  },
  "785103": {
    "city": "MAJULI",
    "state": "ASSAM"
  },
  "785104": {
    "city": "MAJULI",
    "state": "ASSAM"
  },
  "785105": {
    "city": "MAJULI",
    "state": "ASSAM"
  },
  "785106": {
    "city": "MAJULI",
    "state": "ASSAM"
  },
  "785107": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785108": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785109": {
    "city": "BOKAGHAT",
    "state": "ASSAM"
  },
  "785110": {
    "city": "MAJULI",
    "state": "ASSAM"
  },
  "785111": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785112": {
    "city": "NAKACHARI",
    "state": "ASSAM"
  },
  "785113": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785601": {
    "city": "SARUPATHAR",
    "state": "ASSAM"
  },
  "785602": {
    "city": "SARUPATHAR",
    "state": "ASSAM"
  },
  "785603": {
    "city": "MERAPANI",
    "state": "ASSAM"
  },
  "785604": {
    "city": "SARUPATHAR",
    "state": "ASSAM"
  },
  "785609": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785610": {
    "city": "MERAPANI",
    "state": "ASSAM"
  },
  "785611": {
    "city": "NUMALIGARH",
    "state": "ASSAM"
  },
  "785612": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785613": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785614": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785615": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785616": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785617": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785618": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785619": {
    "city": "NUMALIGARH",
    "state": "ASSAM"
  },
  "785620": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785621": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785622": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785623": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785624": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785625": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785626": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785627": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785628": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785629": {
    "city": "TITABOR",
    "state": "ASSAM"
  },
  "785630": {
    "city": "TITABOR",
    "state": "ASSAM"
  },
  "785631": {
    "city": "MERAPANI",
    "state": "ASSAM"
  },
  "785632": {
    "city": "TITABOR",
    "state": "ASSAM"
  },
  "785633": {
    "city": "TITABOR",
    "state": "ASSAM"
  },
  "785634": {
    "city": "NAKACHARI",
    "state": "ASSAM"
  },
  "785635": {
    "city": "NAKACHARI",
    "state": "ASSAM"
  },
  "785636": {
    "city": "AMGURI",
    "state": "ASSAM"
  },
  "785637": {
    "city": "AMGURI",
    "state": "ASSAM"
  },
  "785638": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785639": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785640": {
    "city": "SIBSAGAR",
    "state": "ASSAM"
  },
  "785641": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785642": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785643": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785644": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785645": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785646": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785647": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785648": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785649": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785650": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785651": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785652": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785653": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785654": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785655": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785656": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785657": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785658": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785659": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785660": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785661": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785662": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785663": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785664": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785665": {
    "city": "SIBSAGAR",
    "state": "ASSAM"
  },
  "785666": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785667": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785668": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785669": {
    "city": "SIBSAGAR",
    "state": "ASSAM"
  },
  "785670": {
    "city": "SIBSAGAR",
    "state": "ASSAM"
  },
  "785671": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785672": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785673": {
    "city": "MORANHAT",
    "state": "ASSAM"
  },
  "785674": {
    "city": "NAZIRA",
    "state": "ASSAM"
  },
  "785675": {
    "city": "MORANHAT",
    "state": "ASSAM"
  },
  "785676": {
    "city": "MORANHAT",
    "state": "ASSAM"
  },
  "785677": {
    "city": "MORANHAT",
    "state": "ASSAM"
  },
  "785678": {
    "city": "MORANHAT",
    "state": "ASSAM"
  },
  "785679": {
    "city": "AMGURI",
    "state": "ASSAM"
  },
  "785680": {
    "city": "AMGURI",
    "state": "ASSAM"
  },
  "785681": {
    "city": "AMGURI",
    "state": "ASSAM"
  },
  "785682": {
    "city": "NAKACHARI",
    "state": "ASSAM"
  },
  "785683": {
    "city": "AMGURI",
    "state": "ASSAM"
  },
  "785684": {
    "city": "AMGURI",
    "state": "ASSAM"
  },
  "785685": {
    "city": "SIBSAGAR",
    "state": "ASSAM"
  },
  "785686": {
    "city": "SIBSAGAR",
    "state": "ASSAM"
  },
  "785687": {
    "city": "NAZIRA",
    "state": "ASSAM"
  },
  "785688": {
    "city": "NAZIRA",
    "state": "ASSAM"
  },
  "785689": {
    "city": "SONARI",
    "state": "ASSAM"
  },
  "785690": {
    "city": "SIBSAGAR",
    "state": "ASSAM"
  },
  "785691": {
    "city": "SONARI",
    "state": "ASSAM"
  },
  "785692": {
    "city": "SONARI",
    "state": "ASSAM"
  },
  "785693": {
    "city": "NAMRUP",
    "state": "ASSAM"
  },
  "785694": {
    "city": "SONARI",
    "state": "ASSAM"
  },
  "785695": {
    "city": "AMGURI",
    "state": "ASSAM"
  },
  "785696": {
    "city": "NAZIRA",
    "state": "ASSAM"
  },
  "785697": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785698": {
    "city": "NAZIRA",
    "state": "ASSAM"
  },
  "785699": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785700": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785701": {
    "city": "SIVASAGAR",
    "state": "ASSAM"
  },
  "785702": {
    "city": "GOLAGHAT",
    "state": "ASSAM"
  },
  "785703": {
    "city": "JORHAT",
    "state": "ASSAM"
  },
  "785704": {
    "city": "TITABOR",
    "state": "ASSAM"
  },
  "785705": {
    "city": "MERAPANI",
    "state": "ASSAM"
  },
  "786001": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786002": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786003": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786004": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786005": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786006": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786007": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786008": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786009": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786010": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786012": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786052": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786053": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786054": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786101": {
    "city": "CHABUA",
    "state": "ASSAM"
  },
  "786102": {
    "city": "CHABUA",
    "state": "ASSAM"
  },
  "786103": {
    "city": "CHABUA",
    "state": "ASSAM"
  },
  "786110": {
    "city": "SILAPATHAR",
    "state": "ASSAM"
  },
  "786121": {
    "city": "CHABUA",
    "state": "ASSAM"
  },
  "786124": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786125": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786126": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786145": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786146": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786147": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786148": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786150": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786151": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786152": {
    "city": "DOOM DOOMA",
    "state": "ASSAM"
  },
  "786153": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786154": {
    "city": "DOOM DOOMA",
    "state": "ASSAM"
  },
  "786155": {
    "city": "SADIYA",
    "state": "ASSAM"
  },
  "786156": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786157": {
    "city": "SADIYA",
    "state": "ASSAM"
  },
  "786158": {
    "city": "SADIYA",
    "state": "ASSAM"
  },
  "786159": {
    "city": "DOOM DOOMA",
    "state": "ASSAM"
  },
  "786160": {
    "city": "DOOM DOOMA",
    "state": "ASSAM"
  },
  "786170": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786171": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786172": {
    "city": "DIGBOI",
    "state": "ASSAM"
  },
  "786173": {
    "city": "DIGBOI",
    "state": "ASSAM"
  },
  "786174": {
    "city": "DIGBOI",
    "state": "ASSAM"
  },
  "786179": {
    "city": "LEDO",
    "state": "ASSAM"
  },
  "786180": {
    "city": "LEDO",
    "state": "ASSAM"
  },
  "786181": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786182": {
    "city": "LEDO",
    "state": "ASSAM"
  },
  "786183": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786184": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786185": {
    "city": "CHABUA",
    "state": "ASSAM"
  },
  "786186": {
    "city": "DIGBOI",
    "state": "ASSAM"
  },
  "786187": {
    "city": "DIGBOI",
    "state": "ASSAM"
  },
  "786188": {
    "city": "LEDO",
    "state": "ASSAM"
  },
  "786189": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786190": {
    "city": "DOOM DOOMA",
    "state": "ASSAM"
  },
  "786191": {
    "city": "DULIAJAN",
    "state": "ASSAM"
  },
  "786192": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786601": {
    "city": "TINSUKIA",
    "state": "ASSAM"
  },
  "786602": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786610": {
    "city": "TINGKHONG",
    "state": "ASSAM"
  },
  "786611": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786612": {
    "city": "TINGKHONG",
    "state": "ASSAM"
  },
  "786613": {
    "city": "MORANHAT",
    "state": "ASSAM"
  },
  "786614": {
    "city": "NAMRUP",
    "state": "ASSAM"
  },
  "786615": {
    "city": "TINGKHONG",
    "state": "ASSAM"
  },
  "786616": {
    "city": "NAMRUP",
    "state": "ASSAM"
  },
  "786621": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786622": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786623": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "786624": {
    "city": "TINGKHONG",
    "state": "ASSAM"
  },
  "786629": {
    "city": "NAMRUP",
    "state": "ASSAM"
  },
  "786630": {
    "city": "NAMRUP",
    "state": "ASSAM"
  },
  "786631": {
    "city": "NAMRUP",
    "state": "ASSAM"
  },
  "786678": {
    "city": "NAMRUP",
    "state": "ASSAM"
  },
  "786684": {
    "city": "NAMRUP",
    "state": "ASSAM"
  },
  "786692": {
    "city": "DIBRUGARH",
    "state": "ASSAM"
  },
  "787001": {
    "city": "LAKHIMPUR",
    "state": "ASSAM"
  },
  "787023": {
    "city": "LAKHIMPUR",
    "state": "ASSAM"
  },
  "787026": {
    "city": "DHEMAJI",
    "state": "ASSAM"
  },
  "787027": {
    "city": "GOGAMUKH",
    "state": "ASSAM"
  },
  "787028": {
    "city": "GOGAMUKH",
    "state": "ASSAM"
  },
  "787029": {
    "city": "GOGAMUKH",
    "state": "ASSAM"
  },
  "787030": {
    "city": "NORTH LAKHIMPUR",
    "state": "ASSAM"
  },
  "787031": {
    "city": "LAKHIMPUR",
    "state": "ASSAM"
  },
  "787032": {
    "city": "NORTH LAKHIMPUR",
    "state": "ASSAM"
  },
  "787033": {
    "city": "BIHPURIA",
    "state": "ASSAM"
  },
  "787034": {
    "city": "LAKHIMPUR",
    "state": "ASSAM"
  },
  "787035": {
    "city": "GOGAMUKH",
    "state": "ASSAM"
  },
  "787051": {
    "city": "LAKHIMPUR",
    "state": "ASSAM"
  },
  "787052": {
    "city": "NORTH LAKHIMPUR",
    "state": "ASSAM"
  },
  "787053": {
    "city": "DHAKUAKHANA",
    "state": "ASSAM"
  },
  "787054": {
    "city": "BIHPURIA",
    "state": "ASSAM"
  },
  "787055": {
    "city": "LAKHIMPUR",
    "state": "ASSAM"
  },
  "787056": {
    "city": "GOGAMUKH",
    "state": "ASSAM"
  },
  "787057": {
    "city": "DHEMAJI",
    "state": "ASSAM"
  },
  "787058": {
    "city": "DHEMAJI",
    "state": "ASSAM"
  },
  "787059": {
    "city": "SILAPATHAR",
    "state": "ASSAM"
  },
  "787060": {
    "city": "MURKONGSELEK",
    "state": "ASSAM"
  },
  "787061": {
    "city": "SILAPATHAR",
    "state": "ASSAM"
  },
  "787110": {
    "city": "SILAPATHAR",
    "state": "ASSAM"
  },
  "787112": {
    "city": "SILAPATHAR",
    "state": "ASSAM"
  },
  "787116": {
    "city": "DIMAPUR",
    "state": "NAGALAND"
  },
  "787117": {
    "city": "DIMAPUR",
    "state": "NAGALAND"
  },
  "787160": {
    "city": "NORTH LAKHIMPUR",
    "state": "ASSAM"
  },
  "788001": {
    "city": "CACHAR",
    "state": "ASSAM"
  },
  "788002": {
    "city": "CACHAR",
    "state": "ASSAM"
  },
  "788003": {
    "city": "CACHAR",
    "state": "ASSAM"
  },
  "788004": {
    "city": "CACHAR",
    "state": "ASSAM"
  },
  "788005": {
    "city": "CACHAR",
    "state": "ASSAM"
  },
  "788006": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788007": {
    "city": "CACHAR",
    "state": "ASSAM"
  },
  "788008": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788009": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788010": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788011": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788012": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788013": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788014": {
    "city": "CACHAR",
    "state": "ASSAM"
  },
  "788015": {
    "city": "CACHAR",
    "state": "ASSAM"
  },
  "788019": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788025": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788026": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788030": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788031": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788098": {
    "city": "LAKHIPUR-CACHAR",
    "state": "ASSAM"
  },
  "788099": {
    "city": "DHOLAI BAZAR",
    "state": "ASSAM"
  },
  "788101": {
    "city": "LAKHIPUR-CACHAR",
    "state": "ASSAM"
  },
  "788102": {
    "city": "LAKHIPUR-CACHAR",
    "state": "ASSAM"
  },
  "788103": {
    "city": "LAKHIPUR-CACHAR",
    "state": "ASSAM"
  },
  "788104": {
    "city": "LAKHIPUR-CACHAR",
    "state": "ASSAM"
  },
  "788106": {
    "city": "LAKHIPUR-CACHAR",
    "state": "ASSAM"
  },
  "788107": {
    "city": "LAKHIPUR-CACHAR",
    "state": "ASSAM"
  },
  "788108": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788109": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788110": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788111": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788112": {
    "city": "DHOLAI BAZAR",
    "state": "ASSAM"
  },
  "788113": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788114": {
    "city": "DHOLAI BAZAR",
    "state": "ASSAM"
  },
  "788115": {
    "city": "DHOLAI BAZAR",
    "state": "ASSAM"
  },
  "788116": {
    "city": "DHOLAI BAZAR",
    "state": "ASSAM"
  },
  "788117": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788118": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788119": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788120": {
    "city": "DHOLAI BAZAR",
    "state": "ASSAM"
  },
  "788121": {
    "city": "DHOLAI BAZAR",
    "state": "ASSAM"
  },
  "788122": {
    "city": "DHOLAI BAZAR",
    "state": "ASSAM"
  },
  "788123": {
    "city": "DHOLAI BAZAR",
    "state": "ASSAM"
  },
  "788124": {
    "city": "DHOLAI BAZAR",
    "state": "ASSAM"
  },
  "788125": {
    "city": "LAKHIPUR-CACHAR",
    "state": "ASSAM"
  },
  "788126": {
    "city": "LAKHIPUR-CACHAR",
    "state": "ASSAM"
  },
  "788127": {
    "city": "SILCHAR",
    "state": "ASSAM"
  },
  "788130": {
    "city": "LAKHIPUR-CACHAR",
    "state": "ASSAM"
  },
  "788145": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788150": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788151": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788152": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788155": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788156": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788160": {
    "city": "KATLICHERRA",
    "state": "ASSAM"
  },
  "788161": {
    "city": "KATLICHERRA",
    "state": "ASSAM"
  },
  "788162": {
    "city": "KATLICHERRA",
    "state": "ASSAM"
  },
  "788163": {
    "city": "KATLICHERRA",
    "state": "ASSAM"
  },
  "788164": {
    "city": "KATLICHERRA",
    "state": "ASSAM"
  },
  "788165": {
    "city": "KATLICHERRA",
    "state": "ASSAM"
  },
  "788166": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788167": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788168": {
    "city": "KATLICHERRA",
    "state": "ASSAM"
  },
  "788169": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788701": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788702": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788705": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788706": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788708": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788709": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788710": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788711": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788712": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788713": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788716": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788719": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788720": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788721": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788722": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788723": {
    "city": "PATHARKANDI",
    "state": "ASSAM"
  },
  "788724": {
    "city": "PATHARKANDI",
    "state": "ASSAM"
  },
  "788725": {
    "city": "PATHARKANDI",
    "state": "ASSAM"
  },
  "788726": {
    "city": "PATHARKANDI",
    "state": "ASSAM"
  },
  "788727": {
    "city": "PATHARKANDI",
    "state": "ASSAM"
  },
  "788728": {
    "city": "PATHARKANDI",
    "state": "ASSAM"
  },
  "788729": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788731": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788733": {
    "city": "PATHARKANDI",
    "state": "ASSAM"
  },
  "788734": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788735": {
    "city": "PATHARKANDI",
    "state": "ASSAM"
  },
  "788736": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788737": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788740": {
    "city": "KATLICHERRA",
    "state": "ASSAM"
  },
  "788781": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788790": {
    "city": "KARIMGANJ",
    "state": "ASSAM"
  },
  "788801": {
    "city": "HAILAKANDI",
    "state": "ASSAM"
  },
  "788802": {
    "city": "KALAIN",
    "state": "ASSAM"
  },
  "788803": {
    "city": "KALAIN",
    "state": "ASSAM"
  },
  "788804": {
    "city": "KALAIN",
    "state": "ASSAM"
  },
  "788805": {
    "city": "KALAIN",
    "state": "ASSAM"
  },
  "788806": {
    "city": "KALAIN",
    "state": "ASSAM"
  },
  "788808": {
    "city": "KALAIN",
    "state": "ASSAM"
  },
  "788812": {
    "city": "KALAIN",
    "state": "ASSAM"
  },
  "788814": {
    "city": "KALAIN",
    "state": "ASSAM"
  },
  "788815": {
    "city": "KALAIN",
    "state": "ASSAM"
  },
  "788816": {
    "city": "KALAIN",
    "state": "ASSAM"
  },
  "788817": {
    "city": "KALAIN",
    "state": "ASSAM"
  },
  "788818": {
    "city": "HAFLONG",
    "state": "ASSAM"
  },
  "788819": {
    "city": "HAFLONG",
    "state": "ASSAM"
  },
  "788820": {
    "city": "HAFLONG",
    "state": "ASSAM"
  },
  "788830": {
    "city": "HAFLONG",
    "state": "ASSAM"
  },
  "788831": {
    "city": "HAFLONG",
    "state": "ASSAM"
  },
  "788832": {
    "city": "HAFLONG",
    "state": "ASSAM"
  },
  "788834": {
    "city": "HAFLONG",
    "state": "ASSAM"
  },
  "788931": {
    "city": "UMRANGSO",
    "state": "ASSAM"
  },
  "790001": {
    "city": "BOMDILA",
    "state": "ARUNACHAL PRADESH"
  },
  "790003": {
    "city": "BOMDILA",
    "state": "ARUNACHAL PRADESH"
  },
  "790115": {
    "city": "BOMDILA",
    "state": "ARUNACHAL PRADESH"
  },
  "791102": {
    "city": "PASHIGHAT",
    "state": "ASSAM"
  },
  "791103": {
    "city": "PASHIGHAT",
    "state": "ASSAM"
  },
  "791109": {
    "city": "PAPUM PARE",
    "state": "ARUNACHAL PRADESH"
  },
  "791110": {
    "city": "PAPUM PARE",
    "state": "ARUNACHAL PRADESH"
  },
  "791111": {
    "city": "PAPUM PARE",
    "state": "ARUNACHAL PRADESH"
  },
  "791112": {
    "city": "ITANAGAR",
    "state": "ARUNACHAL PRADESH"
  },
  "791113": {
    "city": "PAPUM PARE",
    "state": "ARUNACHAL PRADESH"
  },
  "791123": {
    "city": "PAPUM PARE",
    "state": "ARUNACHAL PRADESH"
  },
  "791125": {
    "city": "LIKABALI",
    "state": "ARUNACHAL PRADESH"
  },
  "793001": {
    "city": "KHASI HILLS",
    "state": "MEGHALAYA"
  },
  "793002": {
    "city": "KHASI HILLS",
    "state": "MEGHALAYA"
  },
  "793003": {
    "city": "KHASI HILLS",
    "state": "MEGHALAYA"
  },
  "793004": {
    "city": "SHILLONG",
    "state": "MEGHALAYA"
  },
  "793005": {
    "city": "SHILLONG",
    "state": "MEGHALAYA"
  },
  "793006": {
    "city": "KHASI HILLS",
    "state": "MEGHALAYA"
  },
  "793007": {
    "city": "KHASI HILLS",
    "state": "MEGHALAYA"
  },
  "793008": {
    "city": "Shillong",
    "state": "MEGHALAYA"
  },
  "793009": {
    "city": "Shillong",
    "state": "MEGHALAYA"
  },
  "793010": {
    "city": "Shillong",
    "state": "MEGHALAYA"
  },
  "793011": {
    "city": "Shillong",
    "state": "MEGHALAYA"
  },
  "793012": {
    "city": "SHILLONG",
    "state": "MEGHALAYA"
  },
  "793013": {
    "city": "SHILLONG",
    "state": "MEGHALAYA"
  },
  "793014": {
    "city": "SHILLONG",
    "state": "MEGHALAYA"
  },
  "793015": {
    "city": "SHILLONG",
    "state": "MEGHALAYA"
  },
  "793016": {
    "city": "SHILLONG",
    "state": "MEGHALAYA"
  },
  "793017": {
    "city": "KHASI HILLS",
    "state": "MEGHALAYA"
  },
  "793018": {
    "city": "Shillong",
    "state": "MEGHALAYA"
  },
  "793019": {
    "city": "Shillong",
    "state": "MEGHALAYA"
  },
  "793021": {
    "city": "Shillong",
    "state": "MEGHALAYA"
  },
  "793022": {
    "city": "Shillong",
    "state": "MEGHALAYA"
  },
  "793102": {
    "city": "GUWAHATI",
    "state": "ASSAM"
  },
  "793120": {
    "city": "MAIRANGBAH",
    "state": "MEGHALAYA"
  },
  "793150": {
    "city": "Jowai",
    "state": "MEGHALAYA"
  },
  "793160": {
    "city": "KHLIEHRIAT",
    "state": "MEGHALAYA"
  },
  "793200": {
    "city": "KHLIEHRIAT",
    "state": "MEGHALAYA"
  },
  "794002": {
    "city": "DEKACHANG",
    "state": "MEGHALAYA"
  },
  "794104": {
    "city": "HATSINGIMARI",
    "state": "ASSAM"
  },
  "794108": {
    "city": "DEKACHANG",
    "state": "MEGHALAYA"
  },
  "794110": {
    "city": "DUDHNOI",
    "state": "ASSAM"
  },
  "794111": {
    "city": "WILLIAM NAGAR",
    "state": "MEGHALAYA"
  },
  "794112": {
    "city": "DUDHNOI",
    "state": "ASSAM"
  },
  "795001": {
    "city": "IMPHAL",
    "state": "MANIPUR"
  },
  "795002": {
    "city": "Imphal",
    "state": "MANIPUR"
  },
  "795003": {
    "city": "Imphal",
    "state": "MANIPUR"
  },
  "795004": {
    "city": "IMPHAL",
    "state": "MANIPUR"
  },
  "795005": {
    "city": "Imphal",
    "state": "MANIPUR"
  },
  "795006": {
    "city": "IMPHAL",
    "state": "MANIPUR"
  },
  "795008": {
    "city": "IMPHAL",
    "state": "MANIPUR"
  },
  "795009": {
    "city": "WANGOI",
    "state": "MANIPUR"
  },
  "795010": {
    "city": "NAMBOL",
    "state": "MANIPUR"
  },
  "795011": {
    "city": "NINGTHOUKHONG",
    "state": "MANIPUR"
  },
  "795103": {
    "city": "KAKCHING",
    "state": "MANIPUR"
  },
  "795106": {
    "city": "SENAPATI",
    "state": "MANIPUR"
  },
  "795114": {
    "city": "NAMBOL",
    "state": "MANIPUR"
  },
  "795116": {
    "city": "JIRIBAM",
    "state": "MANIPUR"
  },
  "795126": {
    "city": "MOIRANG",
    "state": "MANIPUR"
  },
  "795128": {
    "city": "IMPHAL",
    "state": "MANIPUR"
  },
  "795129": {
    "city": "KANGPOPKI",
    "state": "MANIPUR"
  },
  "795130": {
    "city": "THOUBAL",
    "state": "MANIPUR"
  },
  "795132": {
    "city": "MAYANGIMPHAL",
    "state": "MANIPUR"
  },
  "795133": {
    "city": "MOIRANG",
    "state": "MANIPUR"
  },
  "795134": {
    "city": "NAMBOL",
    "state": "MANIPUR"
  },
  "795136": {
    "city": "NAMBOL",
    "state": "MANIPUR"
  },
  "795138": {
    "city": "THOUBAL",
    "state": "MANIPUR"
  },
  "795140": {
    "city": "Imphal",
    "state": "MANIPUR"
  },
  "795142": {
    "city": "UKHRUL",
    "state": "MANIPUR"
  },
  "795148": {
    "city": "THOUBAL",
    "state": "MANIPUR"
  },
  "795149": {
    "city": "THOUBAL",
    "state": "MANIPUR"
  },
  "795150": {
    "city": "SENAPATI",
    "state": "MANIPUR"
  },
  "795158": {
    "city": "IMPHAL",
    "state": "MANIPUR"
  },
  "796001": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796002": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796003": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796004": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796005": {
    "city": "HLIMEN",
    "state": "MIZORAM"
  },
  "796006": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796007": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796008": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796009": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796012": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796014": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796015": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796016": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796017": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796025": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796036": {
    "city": "AIZAWL",
    "state": "MIZORAM"
  },
  "796081": {
    "city": "KOLASIB",
    "state": "MIZORAM"
  },
  "796082": {
    "city": "KOLASIB",
    "state": "MIZORAM"
  },
  "796321": {
    "city": "AIZWAL",
    "state": "MIZORAM"
  },
  "796701": {
    "city": "LUNGLEI",
    "state": "MIZORAM"
  },
  "797001": {
    "city": "KOHIMA",
    "state": "NAGALAND"
  },
  "797003": {
    "city": "KOHIMA",
    "state": "NAGALAND"
  },
  "797004": {
    "city": "KOHIMA",
    "state": "NAGALAND"
  },
  "797103": {
    "city": "DIMAPUR",
    "state": "NAGALAND"
  },
  "797106": {
    "city": "CHUMUKIDIMA",
    "state": "NAGALAND"
  },
  "797111": {
    "city": "WOKHA",
    "state": "NAGALAND"
  },
  "797112": {
    "city": "DIMAPUR",
    "state": "NAGALAND"
  },
  "797113": {
    "city": "DIMAPUR",
    "state": "NAGALAND"
  },
  "797115": {
    "city": "DIMAPUR",
    "state": "NAGALAND"
  },
  "797116": {
    "city": "DIMAPUR",
    "state": "NAGALAND"
  },
  "797117": {
    "city": "DIMAPUR",
    "state": "NAGALAND"
  },
  "797118": {
    "city": "DIMAPUR",
    "state": "NAGALAND"
  },
  "797120": {
    "city": "DIMAPUR",
    "state": "NAGALAND"
  },
  "798601": {
    "city": "MOKOKCHUNG",
    "state": "NAGALAND"
  },
  "798612": {
    "city": "TUENSANG",
    "state": "NAGALAND"
  },
  "798618": {
    "city": "TULI",
    "state": "NAGALAND"
  },
  "798620": {
    "city": "ZUNHEBOTO",
    "state": "NAGALAND"
  },
  "798623": {
    "city": "TULI",
    "state": "NAGALAND"
  },
  "798627": {
    "city": "MOKOKCHUNG",
    "state": "NAGALAND"
  },
  "799001": {
    "city": "TRIPURA",
    "state": "TRIPURA"
  },
  "799002": {
    "city": "TRIPURA",
    "state": "TRIPURA"
  },
  "799003": {
    "city": "TRIPURA",
    "state": "TRIPURA"
  },
  "799004": {
    "city": "TRIPURA",
    "state": "TRIPURA"
  },
  "799005": {
    "city": "TRIPURA",
    "state": "TRIPURA"
  },
  "799006": {
    "city": "TRIPURA",
    "state": "TRIPURA"
  },
  "799007": {
    "city": "TRIPURA",
    "state": "TRIPURA"
  },
  "799008": {
    "city": "TRIPURA",
    "state": "TRIPURA"
  },
  "799009": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799010": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799011": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799012": {
    "city": "TRIPURA",
    "state": "TRIPURA"
  },
  "799013": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799014": {
    "city": "TRIPURA",
    "state": "TRIPURA"
  },
  "799015": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799022": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799035": {
    "city": "JIRANIA",
    "state": "TRIPURA"
  },
  "799045": {
    "city": "JIRANIA",
    "state": "TRIPURA"
  },
  "799046": {
    "city": "JIRANIA",
    "state": "TRIPURA"
  },
  "799101": {
    "city": "AMARPUR",
    "state": "TRIPURA"
  },
  "799102": {
    "city": "BISHALGARH",
    "state": "TRIPURA"
  },
  "799103": {
    "city": "RSCUDAIPUR",
    "state": "TRIPURA"
  },
  "799104": {
    "city": "AMARPUR",
    "state": "TRIPURA"
  },
  "799105": {
    "city": "RSCUDAIPUR",
    "state": "TRIPURA"
  },
  "799114": {
    "city": "RSCUDAIPUR",
    "state": "TRIPURA"
  },
  "799115": {
    "city": "RSCUDAIPUR",
    "state": "TRIPURA"
  },
  "799120": {
    "city": "RSCUDAIPUR",
    "state": "TRIPURA"
  },
  "799125": {
    "city": "RSCUDAIPUR",
    "state": "TRIPURA"
  },
  "799130": {
    "city": "BISHALGARH",
    "state": "TRIPURA"
  },
  "799131": {
    "city": "SONAMURA",
    "state": "TRIPURA"
  },
  "799132": {
    "city": "SONAMURA",
    "state": "TRIPURA"
  },
  "799141": {
    "city": "SABROOM",
    "state": "TRIPURA"
  },
  "799142": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799143": {
    "city": "SABROOM",
    "state": "TRIPURA"
  },
  "799144": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799145": {
    "city": "SABROOM",
    "state": "TRIPURA"
  },
  "799150": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799155": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799156": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799159": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799201": {
    "city": "KHOWAI",
    "state": "TRIPURA"
  },
  "799202": {
    "city": "KHOWAI",
    "state": "TRIPURA"
  },
  "799203": {
    "city": "KHOWAI",
    "state": "TRIPURA"
  },
  "799204": {
    "city": "Aambasa",
    "state": "TRIPURA"
  },
  "799205": {
    "city": "TELIAMURA",
    "state": "TRIPURA"
  },
  "799206": {
    "city": "TELIAMURA",
    "state": "TRIPURA"
  },
  "799207": {
    "city": "KHOWAI",
    "state": "TRIPURA"
  },
  "799210": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799211": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799212": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799250": {
    "city": "DHARMANAGAR",
    "state": "TRIPURA"
  },
  "799251": {
    "city": "DHARMANAGAR",
    "state": "TRIPURA"
  },
  "799253": {
    "city": "DHARMANAGAR",
    "state": "TRIPURA"
  },
  "799254": {
    "city": "DHARMANAGAR",
    "state": "TRIPURA"
  },
  "799256": {
    "city": "KANCHANPUR",
    "state": "TRIPURA"
  },
  "799260": {
    "city": "DHARMANAGAR",
    "state": "TRIPURA"
  },
  "799261": {
    "city": "DHARMANAGAR",
    "state": "TRIPURA"
  },
  "799262": {
    "city": "DHARMANAGAR",
    "state": "TRIPURA"
  },
  "799263": {
    "city": "Kumarghat",
    "state": "TRIPURA"
  },
  "799264": {
    "city": "Kumarghat",
    "state": "TRIPURA"
  },
  "799266": {
    "city": "Kumarghat",
    "state": "TRIPURA"
  },
  "799269": {
    "city": "KANCHANPUR",
    "state": "TRIPURA"
  },
  "799270": {
    "city": "KANCHANPUR",
    "state": "TRIPURA"
  },
  "799271": {
    "city": "KANCHANPUR",
    "state": "TRIPURA"
  },
  "799273": {
    "city": "MANOGHAT",
    "state": "TRIPURA"
  },
  "799275": {
    "city": "MANOGHAT",
    "state": "TRIPURA"
  },
  "799277": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799278": {
    "city": "Aambasa",
    "state": "TRIPURA"
  },
  "799279": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799280": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799281": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799282": {
    "city": "AGARTALA",
    "state": "TRIPURA"
  },
  "799285": {
    "city": "HALAHALI",
    "state": "TRIPURA"
  },
  "799286": {
    "city": "HALAHALI",
    "state": "TRIPURA"
  },
  "799287": {
    "city": "HALAHALI",
    "state": "TRIPURA"
  },
  "799288": {
    "city": "KUMARGHAT",
    "state": "TRIPURA"
  },
  "799289": {
    "city": "Aambasa",
    "state": "TRIPURA"
  },
  "799290": {
    "city": "KUMARGHAT",
    "state": "TRIPURA"
  },
  "800001": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800002": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800003": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800004": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800005": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800006": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800007": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800008": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800009": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800010": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800011": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800012": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800013": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800014": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800015": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800016": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800017": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800018": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800019": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800020": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800021": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800022": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800023": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800024": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800025": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800026": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800027": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800028": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800029": {
    "city": "PATNA",
    "state": "BIHAR"
  },
  "800030": {
    "city": "Patna",
    "state": "Bihar"
  },
  "800108": {
    "city": "PATNA",
    "state": "BIHAR"
  },
  "800111": {
    "city": "BIHTA",
    "state": "BIHAR"
  },
  "801101": {
    "city": "PALIGANJ",
    "state": "BIHAR"
  },
  "801102": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801103": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801104": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801105": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801106": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801108": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801109": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801110": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801111": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801112": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801113": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801114": {
    "city": "NEORA",
    "state": "BIHAR"
  },
  "801115": {
    "city": "NEORA",
    "state": "BIHAR"
  },
  "801116": {
    "city": "NEORA",
    "state": "BIHAR"
  },
  "801117": {
    "city": "NEORA",
    "state": "BIHAR"
  },
  "801118": {
    "city": "BIHTA",
    "state": "BIHAR"
  },
  "801119": {
    "city": "BIHTA",
    "state": "BIHAR"
  },
  "801301": {
    "city": "HILSA",
    "state": "BIHAR"
  },
  "801302": {
    "city": "HILSA",
    "state": "BIHAR"
  },
  "801303": {
    "city": "HULASGANJ",
    "state": "BIHAR"
  },
  "801304": {
    "city": "HILSA",
    "state": "BIHAR"
  },
  "801305": {
    "city": "CHANDI",
    "state": "BIHAR"
  },
  "801306": {
    "city": "HILSA",
    "state": "BIHAR"
  },
  "801307": {
    "city": "CHANDI",
    "state": "BIHAR"
  },
  "801308": {
    "city": "HILSA",
    "state": "BIHAR"
  },
  "801309": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "801310": {
    "city": "CHANDI",
    "state": "BIHAR"
  },
  "801311": {
    "city": "CHANDI",
    "state": "BIHAR"
  },
  "801501": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801502": {
    "city": "PATNA",
    "state": "BIHAR"
  },
  "801503": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801505": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801506": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801507": {
    "city": "Patna",
    "state": "Bihar"
  },
  "801508": {
    "city": "NEORA",
    "state": "BIHAR"
  },
  "801509": {
    "city": "NEORA",
    "state": "BIHAR"
  },
  "802101": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802102": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802103": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802111": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802112": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802113": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802114": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802115": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802116": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802117": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802118": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802119": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802120": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802122": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802123": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802125": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802126": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802127": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802128": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802129": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802130": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802131": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802132": {
    "city": "Kaimur (Bhabua)",
    "state": "Bihar"
  },
  "802133": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802134": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802135": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802136": {
    "city": "Buxar",
    "state": "Bihar"
  },
  "802151": {
    "city": "BIHIA",
    "state": "BIHAR"
  },
  "802152": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802154": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802155": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802156": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802157": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802158": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802159": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802160": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802161": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802162": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802163": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802164": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802165": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802166": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802169": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "802171": {
    "city": "BIHIA",
    "state": "BIHAR"
  },
  "802172": {
    "city": "BIHIA",
    "state": "BIHAR"
  },
  "802173": {
    "city": "BIHIA",
    "state": "BIHAR"
  },
  "802174": {
    "city": "ARRAH",
    "state": "BIHAR"
  },
  "802178": {
    "city": "BIHIA",
    "state": "BIHAR"
  },
  "802180": {
    "city": "BIHIA",
    "state": "BIHAR"
  },
  "802182": {
    "city": "BIHIA",
    "state": "BIHAR"
  },
  "802183": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802201": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802202": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802203": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802204": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802205": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802206": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802207": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802208": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802209": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802210": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802211": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "802212": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "802213": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "802214": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "802215": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "802216": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "802217": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "802218": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "802219": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "802220": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "802221": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "802222": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802223": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802225": {
    "city": "MAJHAUL",
    "state": "BIHAR"
  },
  "802226": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "802230": {
    "city": "ARRAH",
    "state": "BIHAR"
  },
  "802231": {
    "city": "ARRAH",
    "state": "BIHAR"
  },
  "802237": {
    "city": "BIKRAMGANJ",
    "state": "BIHAR"
  },
  "802301": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802302": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802304": {
    "city": "ARRAH",
    "state": "BIHAR"
  },
  "802311": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802312": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802313": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802314": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802315": {
    "city": "ARRAH",
    "state": "BIHAR"
  },
  "802316": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802317": {
    "city": "ARRAH",
    "state": "BIHAR"
  },
  "802318": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "802351": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802352": {
    "city": "Bhojpur",
    "state": "Bihar"
  },
  "802366": {
    "city": "ARRAH",
    "state": "BIHAR"
  },
  "803101": {
    "city": "NALANDA",
    "state": "BIHAR"
  },
  "803102": {
    "city": "HILSA",
    "state": "BIHAR"
  },
  "803107": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "803108": {
    "city": "CHANDI",
    "state": "BIHAR"
  },
  "803109": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "803110": {
    "city": "CHANDI",
    "state": "BIHAR"
  },
  "803111": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "803112": {
    "city": "CHANDI",
    "state": "BIHAR"
  },
  "803113": {
    "city": "CHANDI",
    "state": "BIHAR"
  },
  "803114": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "803115": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "803116": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "803117": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "803118": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "803119": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "803120": {
    "city": "CHANDI",
    "state": "BIHAR"
  },
  "803121": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "803122": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "803123": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "803124": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "803129": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "803130": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "803131": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "803201": {
    "city": "Patna",
    "state": "Bihar"
  },
  "803202": {
    "city": "Patna",
    "state": "Bihar"
  },
  "803203": {
    "city": "Patna",
    "state": "Bihar"
  },
  "803204": {
    "city": "CHANDI",
    "state": "BIHAR"
  },
  "803205": {
    "city": "BARH",
    "state": "BIHAR"
  },
  "803206": {
    "city": "PATNA",
    "state": "BIHAR"
  },
  "803211": {
    "city": "BARH",
    "state": "BIHAR"
  },
  "803212": {
    "city": "BARH",
    "state": "BIHAR"
  },
  "803213": {
    "city": "PATNA",
    "state": "BIHAR"
  },
  "803214": {
    "city": "BARH",
    "state": "BIHAR"
  },
  "803215": {
    "city": "BARH",
    "state": "BIHAR"
  },
  "803216": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "803218": {
    "city": "PATNA",
    "state": "BIHAR"
  },
  "803221": {
    "city": "BARH",
    "state": "BIHAR"
  },
  "803232": {
    "city": "BARH",
    "state": "BIHAR"
  },
  "803301": {
    "city": "MOKAMA",
    "state": "BIHAR"
  },
  "803302": {
    "city": "MOKAMA",
    "state": "BIHAR"
  },
  "803303": {
    "city": "MOKAMA",
    "state": "BIHAR"
  },
  "803305": {
    "city": "MOKAMA",
    "state": "BIHAR"
  },
  "803306": {
    "city": "MOKAMA",
    "state": "BIHAR"
  },
  "803307": {
    "city": "BARH",
    "state": "BIHAR"
  },
  "804401": {
    "city": "Arwal",
    "state": "Bihar"
  },
  "804402": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "804403": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "804404": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "804405": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804406": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804407": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804408": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804417": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804418": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804419": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "804420": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804421": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "804422": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804423": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "804424": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804425": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804426": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804427": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804428": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "804429": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804430": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "804431": {
    "city": "DAUDNAGAR",
    "state": "BIHAR"
  },
  "804432": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804433": {
    "city": "JEHANABAD",
    "state": "BIHAR"
  },
  "804434": {
    "city": "Jehanabad",
    "state": "Bihar"
  },
  "804435": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "804448": {
    "city": "JEHANABAD",
    "state": "BIHAR"
  },
  "804451": {
    "city": "Patna",
    "state": "Bihar"
  },
  "804452": {
    "city": "Patna",
    "state": "Bihar"
  },
  "804453": {
    "city": "Patna",
    "state": "Bihar"
  },
  "804454": {
    "city": "Patna",
    "state": "Bihar"
  },
  "804457": {
    "city": "MASHAURHI",
    "state": "BIHAR"
  },
  "805101": {
    "city": "SIKANDRA",
    "state": "BIHAR"
  },
  "805102": {
    "city": "RAJAULI",
    "state": "BIHAR"
  },
  "805103": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805104": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805105": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "805106": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805107": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805108": {
    "city": "SHEIKHPURA",
    "state": "BIHAR"
  },
  "805109": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "805110": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805111": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805112": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805113": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805121": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805122": {
    "city": "RAJAULI",
    "state": "BIHAR"
  },
  "805123": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805124": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805125": {
    "city": "RAJAULI",
    "state": "BIHAR"
  },
  "805126": {
    "city": "RAJAULI",
    "state": "BIHAR"
  },
  "805127": {
    "city": "RAJAULI",
    "state": "BIHAR"
  },
  "805128": {
    "city": "WAZIRGANJ",
    "state": "BIHAR"
  },
  "805129": {
    "city": "WAZIRGANJ",
    "state": "BIHAR"
  },
  "805130": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805131": {
    "city": "WAZIRGANJ",
    "state": "BIHAR"
  },
  "805132": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805133": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "805134": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "805135": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "805136": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "805137": {
    "city": "LAKHISARAI",
    "state": "BIHAR"
  },
  "805138": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "805139": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "805140": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "805141": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805143": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805144": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "805145": {
    "city": "NAWADA",
    "state": "BIHAR"
  },
  "805236": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "811101": {
    "city": "SHEIKHPURA",
    "state": "BIHAR"
  },
  "811102": {
    "city": "SHEIKHPURA",
    "state": "BIHAR"
  },
  "811103": {
    "city": "SHEIKHPURA",
    "state": "BIHAR"
  },
  "811104": {
    "city": "MOKAMA",
    "state": "BIHAR"
  },
  "811105": {
    "city": "SHEIKHPURA",
    "state": "BIHAR"
  },
  "811106": {
    "city": "LAKHISARAI",
    "state": "BIHAR"
  },
  "811107": {
    "city": "SHEIKHPURA",
    "state": "BIHAR"
  },
  "811108": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "811109": {
    "city": "SHEIKHPURA",
    "state": "BIHAR"
  },
  "811110": {
    "city": "SHEIKHPURA",
    "state": "BIHAR"
  },
  "811111": {
    "city": "MOKAMA",
    "state": "BIHAR"
  },
  "811112": {
    "city": "MUNGER",
    "state": "BIHAR"
  },
  "811201": {
    "city": "MUNGER",
    "state": "BIHAR"
  },
  "811202": {
    "city": "MUNGER",
    "state": "BIHAR"
  },
  "811203": {
    "city": "KHARAGPUR - BH",
    "state": "BIHAR"
  },
  "811204": {
    "city": "KHARAGPUR - BH",
    "state": "BIHAR"
  },
  "811205": {
    "city": "KHARAGPUR - BH",
    "state": "BIHAR"
  },
  "811206": {
    "city": "KHARAGPUR - BH",
    "state": "BIHAR"
  },
  "811207": {
    "city": "KHARAGPUR - BH",
    "state": "BIHAR"
  },
  "811208": {
    "city": "KHARAGPUR - BH",
    "state": "BIHAR"
  },
  "811209": {
    "city": "KHARAGPUR - BH",
    "state": "BIHAR"
  },
  "811210": {
    "city": "KHARAGPUR - BH",
    "state": "BIHAR"
  },
  "811211": {
    "city": "MUNGER",
    "state": "BIHAR"
  },
  "811212": {
    "city": "MUNGER",
    "state": "BIHAR"
  },
  "811213": {
    "city": "KHARAGPUR - BH",
    "state": "BIHAR"
  },
  "811214": {
    "city": "MUNGER",
    "state": "BIHAR"
  },
  "811241": {
    "city": "MUNGER",
    "state": "BIHAR"
  },
  "811269": {
    "city": "MUNGER",
    "state": "BIHAR"
  },
  "811301": {
    "city": "SIKANDRA",
    "state": "BIHAR"
  },
  "811302": {
    "city": "LAKHISARAI",
    "state": "BIHAR"
  },
  "811303": {
    "city": "CHAKAI",
    "state": "BIHAR"
  },
  "811304": {
    "city": "SHEIKHPURA",
    "state": "BIHAR"
  },
  "811305": {
    "city": "JHAJHA",
    "state": "BIHAR"
  },
  "811307": {
    "city": "JAMUI",
    "state": "BIHAR"
  },
  "811308": {
    "city": "JHAJHA",
    "state": "BIHAR"
  },
  "811309": {
    "city": "LAKHISARAI",
    "state": "BIHAR"
  },
  "811310": {
    "city": "LAKHISARAI",
    "state": "BIHAR"
  },
  "811311": {
    "city": "LAKHISARAI",
    "state": "BIHAR"
  },
  "811312": {
    "city": "JAMUI",
    "state": "BIHAR"
  },
  "811313": {
    "city": "JAMUI",
    "state": "BIHAR"
  },
  "811314": {
    "city": "JHAJHA",
    "state": "BIHAR"
  },
  "811315": {
    "city": "SIKANDRA",
    "state": "BIHAR"
  },
  "811316": {
    "city": "CHAKAI",
    "state": "BIHAR"
  },
  "811317": {
    "city": "JAMUI",
    "state": "BIHAR"
  },
  "811802": {
    "city": "SIKANDRA",
    "state": "BIHAR"
  },
  "812001": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "812002": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "812003": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "812004": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "812005": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "812006": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "812007": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "812008": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "812009": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "812010": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "813101": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813102": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813103": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813104": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813105": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "813106": {
    "city": "KATORIA",
    "state": "BIHAR"
  },
  "813107": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813108": {
    "city": "SULTANGANJ",
    "state": "BIHAR"
  },
  "813109": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813110": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813111": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "813112": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "813113": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "813114": {
    "city": "SULTANGANJ",
    "state": "BIHAR"
  },
  "813115": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813116": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813117": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813118": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813119": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813120": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813121": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813122": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813123": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813124": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813125": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813126": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813127": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813128": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813129": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813201": {
    "city": "KHARAGPUR - BH",
    "state": "BIHAR"
  },
  "813202": {
    "city": "BELHAR",
    "state": "BIHAR"
  },
  "813203": {
    "city": "KAHALGAON",
    "state": "BIHAR"
  },
  "813204": {
    "city": "KAHALGAON",
    "state": "BIHAR"
  },
  "813205": {
    "city": "KAHALGAON",
    "state": "BIHAR"
  },
  "813206": {
    "city": "KAHALGAON",
    "state": "BIHAR"
  },
  "813207": {
    "city": "BELHAR",
    "state": "BIHAR"
  },
  "813208": {
    "city": "MERHMA",
    "state": "JHARKHAND"
  },
  "813209": {
    "city": "KAHALGAON",
    "state": "BIHAR"
  },
  "813210": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "813211": {
    "city": "SULTANGANJ",
    "state": "BIHAR"
  },
  "813212": {
    "city": "BELHAR",
    "state": "BIHAR"
  },
  "813213": {
    "city": "SULTANGANJ",
    "state": "BIHAR"
  },
  "813214": {
    "city": "KAHALGAON",
    "state": "BIHAR"
  },
  "813221": {
    "city": "KHARAGPUR - BH",
    "state": "BIHAR"
  },
  "813222": {
    "city": "KAHALGAON",
    "state": "BIHAR"
  },
  "813223": {
    "city": "SULTANGANJ",
    "state": "BIHAR"
  },
  "813224": {
    "city": "BANKA",
    "state": "BIHAR"
  },
  "813225": {
    "city": "KAHALGAON",
    "state": "BIHAR"
  },
  "813226": {
    "city": "KAHALGAON",
    "state": "BIHAR"
  },
  "813227": {
    "city": "SULTANGANJ",
    "state": "BIHAR"
  },
  "813228": {
    "city": "SULTANGANJ",
    "state": "BIHAR"
  },
  "813229": {
    "city": "KAHALGAON",
    "state": "BIHAR"
  },
  "813231": {
    "city": "KAHALGAON",
    "state": "BIHAR"
  },
  "813233": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "813321": {
    "city": "KHARAGPUR - BH",
    "state": "BIHAR"
  },
  "814101": {
    "city": "DUMKA",
    "state": "JHARKHAND"
  },
  "814102": {
    "city": "HANSDIHA",
    "state": "JHARKHAND"
  },
  "814103": {
    "city": "DUMKA",
    "state": "JHARKHAND"
  },
  "814110": {
    "city": "DUMKA",
    "state": "JHARKHAND"
  },
  "814111": {
    "city": "MAHESPUR",
    "state": "JHARKHAND"
  },
  "814112": {
    "city": "DEOGHAR",
    "state": "JHARKHAND"
  },
  "814113": {
    "city": "DEOGHAR",
    "state": "JHARKHAND"
  },
  "814114": {
    "city": "DEOGHAR",
    "state": "JHARKHAND"
  },
  "814115": {
    "city": "DEOGHAR",
    "state": "JHARKHAND"
  },
  "814116": {
    "city": "DEOGHAR",
    "state": "JHARKHAND"
  },
  "814117": {
    "city": "HANSDIHA",
    "state": "JHARKHAND"
  },
  "814118": {
    "city": "JHARMUNDI",
    "state": "JHARKHAND"
  },
  "814119": {
    "city": "DUMKA",
    "state": "JHARKHAND"
  },
  "814120": {
    "city": "JHARMUNDI",
    "state": "JHARKHAND"
  },
  "814122": {
    "city": "DEOGHAR",
    "state": "JHARKHAND"
  },
  "814124": {
    "city": "DEOGHAR",
    "state": "JHARKHAND"
  },
  "814131": {
    "city": "KATORIA",
    "state": "BIHAR"
  },
  "814132": {
    "city": "GODDA",
    "state": "JHARKHAND"
  },
  "814133": {
    "city": "GODDA",
    "state": "JHARKHAND"
  },
  "814140": {
    "city": "HANSDIHA",
    "state": "JHARKHAND"
  },
  "814141": {
    "city": "JHARMUNDI",
    "state": "JHARKHAND"
  },
  "814142": {
    "city": "DEOGHAR",
    "state": "JHARKHAND"
  },
  "814143": {
    "city": "DEOGHAR",
    "state": "JHARKHAND"
  },
  "814144": {
    "city": "KUNDAHIT",
    "state": "JHARKHAND"
  },
  "814145": {
    "city": "HANSDIHA",
    "state": "JHARKHAND"
  },
  "814146": {
    "city": "JHARMUNDI",
    "state": "JHARKHAND"
  },
  "814147": {
    "city": "MAHAGAMA",
    "state": "JHARKHAND"
  },
  "814148": {
    "city": "KUNDAHIT",
    "state": "JHARKHAND"
  },
  "814149": {
    "city": "MADHUPUR",
    "state": "JHARKHAND"
  },
  "814150": {
    "city": "MADHUPUR",
    "state": "JHARKHAND"
  },
  "814151": {
    "city": "HANSDIHA",
    "state": "JHARKHAND"
  },
  "814152": {
    "city": "DEOGHAR",
    "state": "JHARKHAND"
  },
  "814153": {
    "city": "HANSDIHA",
    "state": "JHARKHAND"
  },
  "814154": {
    "city": "MAHAGAMA",
    "state": "JHARKHAND"
  },
  "814155": {
    "city": "MAHAGAMA",
    "state": "JHARKHAND"
  },
  "814156": {
    "city": "GODDA",
    "state": "JHARKHAND"
  },
  "814157": {
    "city": "DEOGHAR",
    "state": "JHARKHAND"
  },
  "814158": {
    "city": "DUMKA",
    "state": "JHARKHAND"
  },
  "814160": {
    "city": "MERHMA",
    "state": "JHARKHAND"
  },
  "814162": {
    "city": "MERHMA",
    "state": "JHARKHAND"
  },
  "814165": {
    "city": "MAHAGAMA",
    "state": "JHARKHAND"
  },
  "814166": {
    "city": "KUNDAHIT",
    "state": "JHARKHAND"
  },
  "814167": {
    "city": "KUNDAHIT",
    "state": "JHARKHAND"
  },
  "815201": {
    "city": "GIRIDIH",
    "state": "JHARKHAND"
  },
  "815301": {
    "city": "GIRIDH",
    "state": "JHARKHAND"
  },
  "815302": {
    "city": "GIRIDIH",
    "state": "JHARKHAND"
  },
  "815303": {
    "city": "GIRIDIH",
    "state": "JHARKHAND"
  },
  "815304": {
    "city": "GIRIDIH",
    "state": "JHARKHAND"
  },
  "815305": {
    "city": "GIRIDIH",
    "state": "JHARKHAND"
  },
  "815311": {
    "city": "GIRIDIH",
    "state": "JHARKHAND"
  },
  "815312": {
    "city": "GIRIDIH",
    "state": "JHARKHAND"
  },
  "815313": {
    "city": "SATGAWAN",
    "state": "JHARKHAND"
  },
  "815314": {
    "city": "JAMUA",
    "state": "JHARKHAND"
  },
  "815315": {
    "city": "JAMUA",
    "state": "JHARKHAND"
  },
  "815316": {
    "city": "GIRIDIH",
    "state": "JHARKHAND"
  },
  "815317": {
    "city": "SATGAWAN",
    "state": "JHARKHAND"
  },
  "815318": {
    "city": "JAMUA",
    "state": "JHARKHAND"
  },
  "815351": {
    "city": "JAMTARA",
    "state": "JHARKHAND"
  },
  "815352": {
    "city": "JAMTARA",
    "state": "JHARKHAND"
  },
  "815353": {
    "city": "MADHUPUR",
    "state": "JHARKHAND"
  },
  "815354": {
    "city": "JAMTARA",
    "state": "JHARKHAND"
  },
  "815355": {
    "city": "KUNDAHIT",
    "state": "JHARKHAND"
  },
  "815356": {
    "city": "JAMTARA",
    "state": "JHARKHAND"
  },
  "815357": {
    "city": "MADHUPUR",
    "state": "JHARKHAND"
  },
  "815359": {
    "city": "KUNDAHIT",
    "state": "JHARKHAND"
  },
  "815401": {
    "city": "KUNDAHIT",
    "state": "JHARKHAND"
  },
  "816101": {
    "city": "BARARWA",
    "state": "JHARKHAND"
  },
  "816102": {
    "city": "BARARWA",
    "state": "JHARKHAND"
  },
  "816103": {
    "city": "DUMKA",
    "state": "JHARKHAND"
  },
  "816104": {
    "city": "BARARWA",
    "state": "JHARKHAND"
  },
  "816105": {
    "city": "BARARWA",
    "state": "JHARKHAND"
  },
  "816106": {
    "city": "MAHESPUR",
    "state": "JHARKHAND"
  },
  "816107": {
    "city": "PAKUR",
    "state": "JHARKHAND"
  },
  "816108": {
    "city": "RAJMAHAL",
    "state": "JHARKHAND"
  },
  "816109": {
    "city": "SAHEBGANJ",
    "state": "JHARKHAND"
  },
  "816110": {
    "city": "BARARWA",
    "state": "JHARKHAND"
  },
  "816115": {
    "city": "SAHEBGANJ",
    "state": "JHARKHAND"
  },
  "816116": {
    "city": "RAJMAHAL",
    "state": "JHARKHAND"
  },
  "816117": {
    "city": "MAHESPUR",
    "state": "JHARKHAND"
  },
  "816118": {
    "city": "DUMKA",
    "state": "JHARKHAND"
  },
  "816119": {
    "city": "BARARWA",
    "state": "JHARKHAND"
  },
  "816120": {
    "city": "SAHEBGANJ",
    "state": "JHARKHAND"
  },
  "816121": {
    "city": "BARARWA",
    "state": "JHARKHAND"
  },
  "816122": {
    "city": "PAKUR",
    "state": "JHARKHAND"
  },
  "816123": {
    "city": "DUMKA",
    "state": "JHARKHAND"
  },
  "816124": {
    "city": "DUMKA",
    "state": "JHARKHAND"
  },
  "816125": {
    "city": "BARARWA",
    "state": "JHARKHAND"
  },
  "816129": {
    "city": "RAJMAHAL",
    "state": "JHARKHAND"
  },
  "816145": {
    "city": "SAHEBGANJ - BH",
    "state": "BIHAR"
  },
  "821001": {
    "city": "SASARAM",
    "state": "BIHAR"
  },
  "821002": {
    "city": "SASARAM",
    "state": "BIHAR"
  },
  "821003": {
    "city": "SASARAM",
    "state": "BIHAR"
  },
  "821004": {
    "city": "SASARAM",
    "state": "BIHAR"
  },
  "821005": {
    "city": "SASARAM",
    "state": "BIHAR"
  },
  "821006": {
    "city": "SASARAM",
    "state": "BIHAR"
  },
  "821101": {
    "city": "Kaimur (Bhabua)",
    "state": "Bihar"
  },
  "821102": {
    "city": "Kaimur (Bhabua)",
    "state": "Bihar"
  },
  "821103": {
    "city": "Kaimur (Bhabua)",
    "state": "Bihar"
  },
  "821104": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821105": {
    "city": "Kaimur (Bhabua)",
    "state": "Bihar"
  },
  "821106": {
    "city": "Kaimur (Bhabua)",
    "state": "Bihar"
  },
  "821107": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821108": {
    "city": "Kaimur (Bhabua)",
    "state": "Bihar"
  },
  "821109": {
    "city": "Kaimur (Bhabua)",
    "state": "Bihar"
  },
  "821110": {
    "city": "Kaimur (Bhabua)",
    "state": "Bihar"
  },
  "821111": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821112": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821113": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821114": {
    "city": "SASARAM",
    "state": "BIHAR"
  },
  "821115": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821116": {
    "city": "SASARAM",
    "state": "BIHAR"
  },
  "821117": {
    "city": "KISHANGANJ",
    "state": "BIHAR"
  },
  "821118": {
    "city": "KISHANGANJ",
    "state": "BIHAR"
  },
  "821119": {
    "city": "KISHANGANJ",
    "state": "BIHAR"
  },
  "821120": {
    "city": "KISHANGANJ",
    "state": "BIHAR"
  },
  "821121": {
    "city": "KISHANGANJ",
    "state": "BIHAR"
  },
  "821122": {
    "city": "KISHANGANJ",
    "state": "BIHAR"
  },
  "821123": {
    "city": "MALAHIPUR",
    "state": "BIHAR"
  },
  "821124": {
    "city": "SASARAM",
    "state": "BIHAR"
  },
  "821125": {
    "city": "NABINAGAR",
    "state": "BIHAR"
  },
  "821132": {
    "city": "NAUGACHIA",
    "state": "BIHAR"
  },
  "821301": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821302": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821303": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821304": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821305": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821306": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821307": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821308": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821309": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821310": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821311": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821312": {
    "city": "Rohtas",
    "state": "Bihar"
  },
  "821313": {
    "city": "BIKRAMGANJ",
    "state": "BIHAR"
  },
  "821314": {
    "city": "DEHRI-ON-SONE",
    "state": "BIHAR"
  },
  "821315": {
    "city": "SASARAM",
    "state": "BIHAR"
  },
  "821316": {
    "city": "SASARAM",
    "state": "BIHAR"
  },
  "821317": {
    "city": "NABINAGAR",
    "state": "BIHAR"
  },
  "822101": {
    "city": "MEDININAGAR",
    "state": "JHARKHAND"
  },
  "822102": {
    "city": "MEDININAGAR",
    "state": "JHARKHAND"
  },
  "822110": {
    "city": "MEDININAGAR",
    "state": "JHARKHAND"
  },
  "822111": {
    "city": "MEDININAGAR",
    "state": "JHARKHAND"
  },
  "822112": {
    "city": "NAGAR UNTARI",
    "state": "JHARKHAND"
  },
  "822113": {
    "city": "TARHASI",
    "state": "JHARKHAND"
  },
  "822114": {
    "city": "GARHWA",
    "state": "JHARKHAND"
  },
  "822115": {
    "city": "HAIDER NAGAR",
    "state": "JHARKHAND"
  },
  "822116": {
    "city": "HAIDER NAGAR",
    "state": "JHARKHAND"
  },
  "822117": {
    "city": "HAIDER NAGAR",
    "state": "JHARKHAND"
  },
  "822118": {
    "city": "MEDININAGAR",
    "state": "JHARKHAND"
  },
  "822119": {
    "city": "CHAINPUR",
    "state": "JHARKHAND"
  },
  "822120": {
    "city": "HAIDER NAGAR",
    "state": "JHARKHAND"
  },
  "822121": {
    "city": "NAGAR UNTARI",
    "state": "JHARKHAND"
  },
  "822122": {
    "city": "PANKI",
    "state": "JHARKHAND"
  },
  "822123": {
    "city": "MEDININAGAR",
    "state": "JHARKHAND"
  },
  "822124": {
    "city": "GARHWA",
    "state": "JHARKHAND"
  },
  "822125": {
    "city": "GARHWA",
    "state": "JHARKHAND"
  },
  "822126": {
    "city": "LATEHAR",
    "state": "JHARKHAND"
  },
  "822127": {
    "city": "NAGAR UNTARI",
    "state": "JHARKHAND"
  },
  "822128": {
    "city": "NAGAR UNTARI",
    "state": "JHARKHAND"
  },
  "822129": {
    "city": "NAGAR UNTARI",
    "state": "JHARKHAND"
  },
  "822131": {
    "city": "TARHASI",
    "state": "JHARKHAND"
  },
  "822132": {
    "city": "GARHWA",
    "state": "JHARKHAND"
  },
  "822133": {
    "city": "GARHWA",
    "state": "JHARKHAND"
  },
  "822134": {
    "city": "GARHWA",
    "state": "JHARKHAND"
  },
  "822199": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "822212": {
    "city": "SASARAM",
    "state": "BIHAR"
  },
  "823000": {
    "city": "GAYA",
    "state": "BIHAR"
  },
  "823001": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "823002": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "823003": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "823004": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "823005": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "823109": {
    "city": "JAMSHEDPUR",
    "state": "JHARKHAND"
  },
  "823201": {
    "city": "BHAGALPUR",
    "state": "BIHAR"
  },
  "823311": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824000": {
    "city": "AURANGABAD - BH",
    "state": "BIHAR"
  },
  "824101": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824102": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824103": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824111": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824112": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824113": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824114": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824115": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824116": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824118": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824119": {
    "city": "DAUDNAGAR",
    "state": "BIHAR"
  },
  "824120": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824121": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824122": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824123": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824124": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824125": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824126": {
    "city": "RAFIGANJ",
    "state": "BIHAR"
  },
  "824127": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824128": {
    "city": "RAFIGANJ",
    "state": "BIHAR"
  },
  "824129": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824130": {
    "city": "DAUDNAGAR",
    "state": "BIHAR"
  },
  "824143": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824201": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824202": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824203": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824205": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824206": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824207": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824208": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824209": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824210": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824211": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824212": {
    "city": "AURANGABAD - BH",
    "state": "BIHAR"
  },
  "824213": {
    "city": "BARACHHATI",
    "state": "BIHAR"
  },
  "824214": {
    "city": "BARACHHATI",
    "state": "BIHAR"
  },
  "824215": {
    "city": "BARACHHATI",
    "state": "BIHAR"
  },
  "824216": {
    "city": "AURANGABAD - BH",
    "state": "BIHAR"
  },
  "824217": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824218": {
    "city": "AURANGABAD - BH",
    "state": "BIHAR"
  },
  "824219": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824220": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824221": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824230": {
    "city": "GAYA",
    "state": "BIHAR"
  },
  "824231": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824232": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824233": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824234": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824235": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824236": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824237": {
    "city": "Gaya",
    "state": "Bihar"
  },
  "824238": {
    "city": "RAJAULI",
    "state": "BIHAR"
  },
  "824239": {
    "city": "BARACHHATI",
    "state": "BIHAR"
  },
  "824301": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824302": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824303": {
    "city": "Aurangabad(Bh)",
    "state": "Bihar"
  },
  "824320": {
    "city": "NABINAGAR",
    "state": "BIHAR"
  },
  "825101": {
    "city": "RAMGARH",
    "state": "JHARKHAND"
  },
  "825102": {
    "city": "GUMIA",
    "state": "JHARKHAND"
  },
  "825103": {
    "city": "CHATRA",
    "state": "JHARKHAND"
  },
  "825106": {
    "city": "ISHRI",
    "state": "JHARKHAND"
  },
  "825107": {
    "city": "ISHRI",
    "state": "JHARKHAND"
  },
  "825108": {
    "city": "GIRIDIH",
    "state": "JHARKHAND"
  },
  "825109": {
    "city": "MARKACHO",
    "state": "JHARKHAND"
  },
  "825132": {
    "city": "SATGAWAN",
    "state": "JHARKHAND"
  },
  "825167": {
    "city": "ISHRI",
    "state": "JHARKHAND"
  },
  "825223": {
    "city": "BARKATHA",
    "state": "JHARKHAND"
  },
  "825301": {
    "city": "HAZARIBAG",
    "state": "JHARKHAND"
  },
  "825302": {
    "city": "HAZARIBAGH",
    "state": "JHARKHAND"
  },
  "825303": {
    "city": "HAZARIBAGH",
    "state": "JHARKHAND"
  },
  "825304": {
    "city": "HAZARIBAGH",
    "state": "JHARKHAND"
  },
  "825308": {
    "city": "BARKAGAON",
    "state": "JHARKHAND"
  },
  "825311": {
    "city": "BARKAGAON",
    "state": "JHARKHAND"
  },
  "825312": {
    "city": "BAGODAR",
    "state": "JHARKHAND"
  },
  "825313": {
    "city": "HAZARIBAGH",
    "state": "JHARKHAND"
  },
  "825314": {
    "city": "GHATO",
    "state": "JHARKHAND"
  },
  "825315": {
    "city": "GUMIA",
    "state": "JHARKHAND"
  },
  "825316": {
    "city": "MANDU",
    "state": "JHARKHAND"
  },
  "825317": {
    "city": "HAZARIBAGH",
    "state": "JHARKHAND"
  },
  "825318": {
    "city": "MARKACHO",
    "state": "JHARKHAND"
  },
  "825319": {
    "city": "HAZARIBAGH",
    "state": "JHARKHAND"
  },
  "825320": {
    "city": "BAGODAR",
    "state": "JHARKHAND"
  },
  "825321": {
    "city": "BARKAGAON",
    "state": "JHARKHAND"
  },
  "825322": {
    "city": "BAGODAR",
    "state": "JHARKHAND"
  },
  "825323": {
    "city": "BARKATHA",
    "state": "JHARKHAND"
  },
  "825324": {
    "city": "JAMUA",
    "state": "JHARKHAND"
  },
  "825325": {
    "city": "GHATO",
    "state": "JHARKHAND"
  },
  "825326": {
    "city": "MANDU",
    "state": "JHARKHAND"
  },
  "825327": {
    "city": "HAZARIBAGH",
    "state": "JHARKHAND"
  },
  "825329": {
    "city": "GIRIDIH",
    "state": "JHARKHAND"
  },
  "825330": {
    "city": "MANDU",
    "state": "JHARKHAND"
  },
  "825332": {
    "city": "MANDU",
    "state": "JHARKHAND"
  },
  "825335": {
    "city": "HAZARIBAGH",
    "state": "JHARKHAND"
  },
  "825336": {
    "city": "MANDU",
    "state": "JHARKHAND"
  },
  "825401": {
    "city": "CHATRA",
    "state": "JHARKHAND"
  },
  "825402": {
    "city": "HAZARIBAGH",
    "state": "JHARKHAND"
  },
  "825403": {
    "city": "CHATRA",
    "state": "JHARKHAND"
  },
  "825404": {
    "city": "CHATRA",
    "state": "JHARKHAND"
  },
  "825405": {
    "city": "PADMA",
    "state": "JHARKHAND"
  },
  "825406": {
    "city": "CHOUPARAN",
    "state": "JHARKHAND"
  },
  "825407": {
    "city": "MARKACHO",
    "state": "JHARKHAND"
  },
  "825408": {
    "city": "CHOUPARAN",
    "state": "JHARKHAND"
  },
  "825409": {
    "city": "KODERMA",
    "state": "JHARKHAND"
  },
  "825410": {
    "city": "JHUMRI TELAIYA",
    "state": "JHARKHAND"
  },
  "825411": {
    "city": "PADMA",
    "state": "JHARKHAND"
  },
  "825412": {
    "city": "JAMUA",
    "state": "JHARKHAND"
  },
  "825413": {
    "city": "JHUMRI TELAIYA",
    "state": "JHARKHAND"
  },
  "825414": {
    "city": "HAZARIBAGH",
    "state": "JHARKHAND"
  },
  "825418": {
    "city": "MARKACHO",
    "state": "JHARKHAND"
  },
  "825420": {
    "city": "CHATRA",
    "state": "JHARKHAND"
  },
  "825421": {
    "city": "JHUMRI TELAIYA",
    "state": "JHARKHAND"
  },
  "826001": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "826002": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "826003": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "826004": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "826005": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "826006": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "826007": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "826009": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "826012": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "826013": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "826014": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "826015": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "826016": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "826017": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "826106": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "826109": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "826116": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "826124": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "827001": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827002": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827003": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827004": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827005": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827006": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827007": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827008": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827009": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827010": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827011": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827012": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827013": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827014": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827015": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "827302": {
    "city": "PETERWAR",
    "state": "JHARKHAND"
  },
  "827611": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "828101": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828102": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828103": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828104": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828105": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828106": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828107": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828108": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828109": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828110": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828111": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828112": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828113": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828114": {
    "city": "GOMOH",
    "state": "JHARKHAND"
  },
  "828115": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828116": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828117": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828119": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828120": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828121": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828122": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828123": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828124": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828125": {
    "city": "GOMOH",
    "state": "JHARKHAND"
  },
  "828126": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828127": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828128": {
    "city": "GOMOH",
    "state": "JHARKHAND"
  },
  "828129": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828130": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828131": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828132": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828133": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828134": {
    "city": "CHANDANKAYARI",
    "state": "JHARKHAND"
  },
  "828135": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828142": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828144": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828147": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828201": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828202": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828203": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828204": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828205": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828206": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828207": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828209": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828301": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828302": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828303": {
    "city": "CHANDANKAYARI",
    "state": "JHARKHAND"
  },
  "828304": {
    "city": "GOMOH",
    "state": "JHARKHAND"
  },
  "828305": {
    "city": "GOMOH",
    "state": "JHARKHAND"
  },
  "828306": {
    "city": "GOMOH",
    "state": "JHARKHAND"
  },
  "828307": {
    "city": "GOMOH",
    "state": "JHARKHAND"
  },
  "828308": {
    "city": "GOMOH",
    "state": "JHARKHAND"
  },
  "828309": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828311": {
    "city": "DHANBAD",
    "state": "JHARKHAND"
  },
  "828401": {
    "city": "GOMOH",
    "state": "JHARKHAND"
  },
  "828402": {
    "city": "GOMOH",
    "state": "JHARKHAND"
  },
  "828403": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "828404": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "829000": {
    "city": "PETARBAR",
    "state": "JHARKHAND"
  },
  "829101": {
    "city": "RAMGARH",
    "state": "JHARKHAND"
  },
  "829102": {
    "city": "RAMGARH",
    "state": "JHARKHAND"
  },
  "829103": {
    "city": "RAMGARH",
    "state": "JHARKHAND"
  },
  "829104": {
    "city": "GUMIA",
    "state": "JHARKHAND"
  },
  "829105": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829106": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829107": {
    "city": "GUMIA",
    "state": "JHARKHAND"
  },
  "829108": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829109": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829110": {
    "city": "PETERWAR",
    "state": "JHARKHAND"
  },
  "829111": {
    "city": "GUMIA",
    "state": "JHARKHAND"
  },
  "829112": {
    "city": "GUMIA",
    "state": "JHARKHAND"
  },
  "829113": {
    "city": "GUMIA",
    "state": "JHARKHAND"
  },
  "829114": {
    "city": "GUMIA",
    "state": "JHARKHAND"
  },
  "829115": {
    "city": "PETERWAR",
    "state": "JHARKHAND"
  },
  "829116": {
    "city": "GUMIA",
    "state": "JHARKHAND"
  },
  "829117": {
    "city": "RAMGARH",
    "state": "JHARKHAND"
  },
  "829118": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829119": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829120": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829121": {
    "city": "PETERWAR",
    "state": "JHARKHAND"
  },
  "829122": {
    "city": "RAMGARH",
    "state": "JHARKHAND"
  },
  "829123": {
    "city": "PETERWAR",
    "state": "JHARKHAND"
  },
  "829124": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829125": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829126": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829127": {
    "city": "GUMIA",
    "state": "JHARKHAND"
  },
  "829128": {
    "city": "GUMIA",
    "state": "JHARKHAND"
  },
  "829129": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829130": {
    "city": "RAMGARH",
    "state": "JHARKHAND"
  },
  "829131": {
    "city": "RAMGARH",
    "state": "JHARKHAND"
  },
  "829132": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "829133": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829134": {
    "city": "GHATO",
    "state": "JHARKHAND"
  },
  "829135": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829137": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829138": {
    "city": "BOKARO",
    "state": "JHARKHAND"
  },
  "829141": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829143": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "829144": {
    "city": "GUMIA",
    "state": "JHARKHAND"
  },
  "829145": {
    "city": "RAMGARH",
    "state": "JHARKHAND"
  },
  "829146": {
    "city": "RAMGARH",
    "state": "JHARKHAND"
  },
  "829149": {
    "city": "GUMIA",
    "state": "JHARKHAND"
  },
  "829150": {
    "city": "RAMGARH",
    "state": "JHARKHAND"
  },
  "829167": {
    "city": "BAGODAR",
    "state": "JHARKHAND"
  },
  "829201": {
    "city": "TANDWA",
    "state": "JHARKHAND"
  },
  "829202": {
    "city": "CHANDWA",
    "state": "JHARKHAND"
  },
  "829203": {
    "city": "CHANDWA",
    "state": "JHARKHAND"
  },
  "829204": {
    "city": "LATEHAR",
    "state": "JHARKHAND"
  },
  "829205": {
    "city": "TANDWA",
    "state": "JHARKHAND"
  },
  "829206": {
    "city": "LATEHAR",
    "state": "JHARKHAND"
  },
  "829207": {
    "city": "LATEHAR",
    "state": "JHARKHAND"
  },
  "829208": {
    "city": "TANDWA",
    "state": "JHARKHAND"
  },
  "829209": {
    "city": "TANDWA",
    "state": "JHARKHAND"
  },
  "829210": {
    "city": "KHALARI",
    "state": "JHARKHAND"
  },
  "829211": {
    "city": "CHANDWA",
    "state": "JHARKHAND"
  },
  "829301": {
    "city": "PETERWAR",
    "state": "JHARKHAND"
  },
  "829302": {
    "city": "PETARBAR",
    "state": "JHARKHAND"
  },
  "829317": {
    "city": "PETERWAR",
    "state": "JHARKHAND"
  },
  "829412": {
    "city": "PETERWAR",
    "state": "JHARKHAND"
  },
  "831000": {
    "city": "JAMSHEDPUR",
    "state": "JHARKHAND"
  },
  "831001": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831002": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831003": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831004": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831005": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831006": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831007": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831008": {
    "city": "JAMSHEDPUR",
    "state": "JHARKHAND"
  },
  "831009": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831010": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831011": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831012": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831013": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831014": {
    "city": "SERAIKELA-KHARSAWAN",
    "state": "JHARKHAND"
  },
  "831015": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831016": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831017": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831018": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831019": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "831020": {
    "city": "JAMSHEDPUR",
    "state": "JHARKHAND"
  },
  "831021": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "831035": {
    "city": "JAMSHEDPUR",
    "state": "JHARKHAND"
  },
  "831109": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "831110": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "832012": {
    "city": "JAMSHEDPUR",
    "state": "JHARKHAND"
  },
  "832013": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "832101": {
    "city": "BAHARAGORA",
    "state": "JHARKHAND"
  },
  "832102": {
    "city": "GHATSILA",
    "state": "JHARKHAND"
  },
  "832103": {
    "city": "GHATSILA",
    "state": "JHARKHAND"
  },
  "832104": {
    "city": "GHATSILA",
    "state": "JHARKHAND"
  },
  "832105": {
    "city": "JAMSHEDPUR",
    "state": "JHARKHAND"
  },
  "832106": {
    "city": "GHATSILA",
    "state": "JHARKHAND"
  },
  "832107": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "832108": {
    "city": "SERAIKELA-KHARSAWAN",
    "state": "JHARKHAND"
  },
  "832109": {
    "city": "SERAIKELA-KHARSAWAN",
    "state": "JHARKHAND"
  },
  "832110": {
    "city": "SINGHBHUM",
    "state": "JHARKHAND"
  },
  "832111": {
    "city": "JUGSALAI",
    "state": "JHARKHAND"
  },
  "832112": {
    "city": "JAMSHEDPUR",
    "state": "JHARKHAND"
  },
  "832113": {
    "city": "JAMSHEDPUR",
    "state": "JHARKHAND"
  },
  "832301": {
    "city": "BAHARAGORA",
    "state": "JHARKHAND"
  },
  "832302": {
    "city": "BAHARAGORA",
    "state": "JHARKHAND"
  },
  "832303": {
    "city": "GHATSILA",
    "state": "JHARKHAND"
  },
  "832304": {
    "city": "GHATSILA",
    "state": "JHARKHAND"
  },
  "832401": {
    "city": "CHANDIL",
    "state": "JHARKHAND"
  },
  "832402": {
    "city": "CHOWKA",
    "state": "JHARKHAND"
  },
  "832403": {
    "city": "CHOWKA",
    "state": "JHARKHAND"
  },
  "832404": {
    "city": "CHOWKA",
    "state": "JHARKHAND"
  },
  "833101": {
    "city": "KHARSAWAN",
    "state": "JHARKHAND"
  },
  "833102": {
    "city": "CHAKRADHARPUR",
    "state": "JHARKHAND"
  },
  "833103": {
    "city": "SONUA",
    "state": "JHARKHAND"
  },
  "833104": {
    "city": "BANO",
    "state": "JHARKHAND"
  },
  "833105": {
    "city": "SONUA",
    "state": "JHARKHAND"
  },
  "833106": {
    "city": "SONUA",
    "state": "JHARKHAND"
  },
  "833108": {
    "city": "KHARSAWAN",
    "state": "JHARKHAND"
  },
  "833201": {
    "city": "CHAIBASA",
    "state": "JHARKHAND"
  },
  "833202": {
    "city": "CHAIBASA",
    "state": "JHARKHAND"
  },
  "833203": {
    "city": "JAGANNATHPUR",
    "state": "JHARKHAND"
  },
  "833204": {
    "city": "CHAIBASA",
    "state": "JHARKHAND"
  },
  "833212": {
    "city": "JAGANNATHPUR",
    "state": "JHARKHAND"
  },
  "833213": {
    "city": "NAOMUNDI",
    "state": "JHARKHAND"
  },
  "833214": {
    "city": "JAGANNATHPUR",
    "state": "JHARKHAND"
  },
  "833215": {
    "city": "CHAIBASA",
    "state": "JHARKHAND"
  },
  "833216": {
    "city": "KHARSAWAN",
    "state": "JHARKHAND"
  },
  "833217": {
    "city": "NAOMUNDI",
    "state": "JHARKHAND"
  },
  "833218": {
    "city": "NAOMUNDI",
    "state": "JHARKHAND"
  },
  "833219": {
    "city": "KHARSAWAN",
    "state": "JHARKHAND"
  },
  "833220": {
    "city": "KHARSAWAN",
    "state": "JHARKHAND"
  },
  "833221": {
    "city": "NAOMUNDI",
    "state": "JHARKHAND"
  },
  "833222": {
    "city": "NAOMUNDI",
    "state": "JHARKHAND"
  },
  "833223": {
    "city": "NAOMUNDI",
    "state": "JHARKHAND"
  },
  "834001": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "834002": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "834003": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "834004": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "834005": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "834006": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "834007": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "834008": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "834009": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "834010": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "834011": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "834012": {
    "city": "RANCHI",
    "state": "JHARKHAND"
  },
  "834013": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "834016": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "834025": {
    "city": "PATRATU",
    "state": "JHARKHAND"
  },
  "835022": {
    "city": "SILLI",
    "state": "JHARKHAND"
  },
  "835101": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835102": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835103": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835104": {
    "city": "RANCHI",
    "state": "JHARKHAND"
  },
  "835125": {
    "city": "RANCHI",
    "state": "JHARKHAND"
  },
  "835201": {
    "city": "Simdega",
    "state": "Jharkhand"
  },
  "835202": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835203": {
    "city": "Gumla",
    "state": "Jharkhand"
  },
  "835204": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835205": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835206": {
    "city": "Gumla",
    "state": "Jharkhand"
  },
  "835207": {
    "city": "Gumla",
    "state": "Jharkhand"
  },
  "835208": {
    "city": "Gumla",
    "state": "Jharkhand"
  },
  "835209": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835210": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835211": {
    "city": "Simdega",
    "state": "Jharkhand"
  },
  "835212": {
    "city": "Simdega",
    "state": "Jharkhand"
  },
  "835213": {
    "city": "Lohardaga",
    "state": "Jharkhand"
  },
  "835214": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835215": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835216": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835217": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835218": {
    "city": "Lohardaga",
    "state": "Jharkhand"
  },
  "835219": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835220": {
    "city": "Gumla",
    "state": "Jharkhand"
  },
  "835221": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835222": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835223": {
    "city": "Simdega",
    "state": "Jharkhand"
  },
  "835224": {
    "city": "Gumla",
    "state": "Jharkhand"
  },
  "835225": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835226": {
    "city": "Simdega",
    "state": "Jharkhand"
  },
  "835227": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835228": {
    "city": "Simdega",
    "state": "Jharkhand"
  },
  "835229": {
    "city": "Gumla",
    "state": "Jharkhand"
  },
  "835230": {
    "city": "Gumla",
    "state": "Jharkhand"
  },
  "835231": {
    "city": "Gumla",
    "state": "Jharkhand"
  },
  "835232": {
    "city": "Gumla",
    "state": "Jharkhand"
  },
  "835233": {
    "city": "Gumla",
    "state": "Jharkhand"
  },
  "835234": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835235": {
    "city": "Simdega",
    "state": "Jharkhand"
  },
  "835236": {
    "city": "SIMDEGA",
    "state": "JHARKHAND"
  },
  "835238": {
    "city": "RANCHI",
    "state": "JHARKHAND"
  },
  "835239": {
    "city": "SIMDEGA",
    "state": "JHARKHAND"
  },
  "835240": {
    "city": "RANCHI",
    "state": "JHARKHAND"
  },
  "835242": {
    "city": "SIMDEGA",
    "state": "JHARKHAND"
  },
  "835244": {
    "city": "SIMDEGA",
    "state": "JHARKHAND"
  },
  "835301": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835302": {
    "city": "Lohardaga",
    "state": "Jharkhand"
  },
  "835303": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "835304": {
    "city": "SEMBO",
    "state": "JHARKHAND"
  },
  "835305": {
    "city": "SEMBO",
    "state": "JHARKHAND"
  },
  "835306": {
    "city": "LOHARDAGA",
    "state": "JHARKHAND"
  },
  "835324": {
    "city": "GUMLA",
    "state": "JHARKHAND"
  },
  "835325": {
    "city": "Ranchi",
    "state": "Jharkhand"
  },
  "838303": {
    "city": "LOHARDAGA",
    "state": "JHARKHAND"
  },
  "838325": {
    "city": "LOHARDAGA",
    "state": "JHARKHAND"
  },
  "840001": {
    "city": "GUMLA",
    "state": "JHARKHAND"
  },
  "841101": {
    "city": "SARAN",
    "state": "BIHAR"
  },
  "841105": {
    "city": "HAJIPUR",
    "state": "BIHAR"
  },
  "841201": {
    "city": "EKMA",
    "state": "BIHAR"
  },
  "841202": {
    "city": "DIGHWARA",
    "state": "BIHAR"
  },
  "841203": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "841204": {
    "city": "EKMA",
    "state": "BIHAR"
  },
  "841205": {
    "city": "EKMA",
    "state": "BIHAR"
  },
  "841206": {
    "city": "EKMA",
    "state": "BIHAR"
  },
  "841207": {
    "city": "DIGHWARA",
    "state": "BIHAR"
  },
  "841208": {
    "city": "EKMA",
    "state": "BIHAR"
  },
  "841209": {
    "city": "EKMA",
    "state": "BIHAR"
  },
  "841210": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "841211": {
    "city": "SARAN",
    "state": "BIHAR"
  },
  "841212": {
    "city": "EKMA",
    "state": "BIHAR"
  },
  "841213": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841214": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841215": {
    "city": "PARSA",
    "state": "BIHAR"
  },
  "841216": {
    "city": "DIGHWARA",
    "state": "BIHAR"
  },
  "841217": {
    "city": "DIGHWARA",
    "state": "BIHAR"
  },
  "841218": {
    "city": "PARSA",
    "state": "BIHAR"
  },
  "841219": {
    "city": "PARSA",
    "state": "BIHAR"
  },
  "841220": {
    "city": "EKMA",
    "state": "BIHAR"
  },
  "841221": {
    "city": "DIGHWARA",
    "state": "BIHAR"
  },
  "841222": {
    "city": "PARSA",
    "state": "BIHAR"
  },
  "841223": {
    "city": "EKMA",
    "state": "BIHAR"
  },
  "841224": {
    "city": "MAHRAJGANJ",
    "state": "BIHAR"
  },
  "841225": {
    "city": "DIGHWARA",
    "state": "BIHAR"
  },
  "841226": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841227": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841231": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "841232": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841233": {
    "city": "MAHRAJGANJ",
    "state": "BIHAR"
  },
  "841234": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "841235": {
    "city": "MAIRWA",
    "state": "BIHAR"
  },
  "841236": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841237": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841238": {
    "city": "MAHRAJGANJ",
    "state": "BIHAR"
  },
  "841239": {
    "city": "MAIRWA",
    "state": "BIHAR"
  },
  "841240": {
    "city": "MAHRAJGANJ",
    "state": "BIHAR"
  },
  "841241": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841242": {
    "city": "MAHRAJGANJ",
    "state": "BIHAR"
  },
  "841243": {
    "city": "MAIRWA",
    "state": "BIHAR"
  },
  "841244": {
    "city": "MAHRAJGANJ",
    "state": "BIHAR"
  },
  "841245": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841246": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841247": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841248": {
    "city": "DIGHWARA",
    "state": "BIHAR"
  },
  "841249": {
    "city": "DIGHWARA",
    "state": "BIHAR"
  },
  "841250": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841251": {
    "city": "DIGHWARA",
    "state": "BIHAR"
  },
  "841252": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841253": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841254": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841255": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841256": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841286": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841287": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "841301": {
    "city": "SARAN",
    "state": "BIHAR"
  },
  "841302": {
    "city": "SARAN",
    "state": "BIHAR"
  },
  "841305": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841311": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841312": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841313": {
    "city": "EKMA",
    "state": "BIHAR"
  },
  "841314": {
    "city": "EKMA",
    "state": "BIHAR"
  },
  "841315": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841316": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841317": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841318": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841339": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841401": {
    "city": "PARSA",
    "state": "BIHAR"
  },
  "841402": {
    "city": "PARSA",
    "state": "BIHAR"
  },
  "841403": {
    "city": "EKMA",
    "state": "BIHAR"
  },
  "841404": {
    "city": "MAHRAJGANJ",
    "state": "BIHAR"
  },
  "841405": {
    "city": "GOPALGANJ",
    "state": "BIHAR"
  },
  "841406": {
    "city": "BASANTPUR",
    "state": "BIHAR"
  },
  "841407": {
    "city": "BASANTPUR",
    "state": "BIHAR"
  },
  "841408": {
    "city": "BASANTPUR",
    "state": "BIHAR"
  },
  "841409": {
    "city": "BASANTPUR",
    "state": "BIHAR"
  },
  "841410": {
    "city": "MASRAKH",
    "state": "BIHAR"
  },
  "841411": {
    "city": "MASRAKH",
    "state": "BIHAR"
  },
  "841412": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841413": {
    "city": "BASANTPUR",
    "state": "BIHAR"
  },
  "841414": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841415": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841416": {
    "city": "BASANTPUR",
    "state": "BIHAR"
  },
  "841417": {
    "city": "MASRAKH",
    "state": "BIHAR"
  },
  "841418": {
    "city": "PARSA",
    "state": "BIHAR"
  },
  "841419": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841420": {
    "city": "MASRAKH",
    "state": "BIHAR"
  },
  "841421": {
    "city": "MASRAKH",
    "state": "BIHAR"
  },
  "841422": {
    "city": "MASRAKH",
    "state": "BIHAR"
  },
  "841423": {
    "city": "BASANTPUR",
    "state": "BIHAR"
  },
  "841424": {
    "city": "MASRAKH",
    "state": "BIHAR"
  },
  "841425": {
    "city": "KUCHAIKOTE",
    "state": "BIHAR"
  },
  "841426": {
    "city": "BHORE",
    "state": "BIHAR"
  },
  "841427": {
    "city": "GOPALGANJ",
    "state": "BIHAR"
  },
  "841428": {
    "city": "GOPALGANJ",
    "state": "BIHAR"
  },
  "841429": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841430": {
    "city": "GOPALGANJ",
    "state": "BIHAR"
  },
  "841431": {
    "city": "GOPALGANJ",
    "state": "BIHAR"
  },
  "841432": {
    "city": "GOPALGANJ",
    "state": "BIHAR"
  },
  "841433": {
    "city": "MASRAKH",
    "state": "BIHAR"
  },
  "841434": {
    "city": "BASANTPUR",
    "state": "BIHAR"
  },
  "841435": {
    "city": "MAIRWA",
    "state": "BIHAR"
  },
  "841436": {
    "city": "MIRGANJ",
    "state": "BIHAR"
  },
  "841437": {
    "city": "BHORE",
    "state": "BIHAR"
  },
  "841438": {
    "city": "MIRGANJ",
    "state": "BIHAR"
  },
  "841439": {
    "city": "MAHRAJGANJ",
    "state": "BIHAR"
  },
  "841440": {
    "city": "MIRGANJ",
    "state": "BIHAR"
  },
  "841441": {
    "city": "BHORE",
    "state": "BIHAR"
  },
  "841442": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "841443": {
    "city": "MASRAKH",
    "state": "BIHAR"
  },
  "841446": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "841460": {
    "city": "PARSA",
    "state": "BIHAR"
  },
  "841501": {
    "city": "KUCHAIKOTE",
    "state": "BIHAR"
  },
  "841502": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "841503": {
    "city": "KUCHAIKOTE",
    "state": "BIHAR"
  },
  "841504": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "841505": {
    "city": "GOPALGANJ",
    "state": "BIHAR"
  },
  "841506": {
    "city": "MAHRAJGANJ",
    "state": "BIHAR"
  },
  "841507": {
    "city": "BASANTPUR",
    "state": "BIHAR"
  },
  "841508": {
    "city": "BHORE",
    "state": "BIHAR"
  },
  "841509": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "841512": {
    "city": "SIWAN",
    "state": "BIHAR"
  },
  "842001": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "842002": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "842003": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "842004": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "842005": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "842006": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "842007": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "842008": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "842009": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "842010": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843001": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843014": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843031": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843100": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "843101": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "843102": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "843103": {
    "city": "KATRA - BH",
    "state": "BIHAR"
  },
  "843104": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "843105": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "843106": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "843107": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "843108": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843109": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843110": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "843111": {
    "city": "MOTIPUR",
    "state": "BIHAR"
  },
  "843112": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "843113": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843114": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "843115": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "843116": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843117": {
    "city": "RUNNI",
    "state": "BIHAR"
  },
  "843118": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "843119": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "843120": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "843121": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "843122": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "843123": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "843124": {
    "city": "MOTIPUR",
    "state": "BIHAR"
  },
  "843125": {
    "city": "SAHEBGANJ - BH",
    "state": "BIHAR"
  },
  "843126": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "843127": {
    "city": "MOTIPUR",
    "state": "BIHAR"
  },
  "843128": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843129": {
    "city": "KATRA - BH",
    "state": "BIHAR"
  },
  "843130": {
    "city": "MOTIPUR",
    "state": "BIHAR"
  },
  "843131": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843132": {
    "city": "MOTIPUR",
    "state": "BIHAR"
  },
  "843133": {
    "city": "MOTIPUR",
    "state": "BIHAR"
  },
  "843134": {
    "city": "MOTIPUR",
    "state": "BIHAR"
  },
  "843135": {
    "city": "BHAGWANPUR",
    "state": "BIHAR"
  },
  "843136": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "843137": {
    "city": "MOTIPUR",
    "state": "BIHAR"
  },
  "843138": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843139": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "843140": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843141": {
    "city": "MOTIPUR",
    "state": "BIHAR"
  },
  "843142": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843143": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "843144": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "843145": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "843146": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843147": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "843148": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843149": {
    "city": "MIRGANJ",
    "state": "BIHAR"
  },
  "843150": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843151": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843152": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843153": {
    "city": "MOTIPUR",
    "state": "BIHAR"
  },
  "843154": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843155": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843156": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843157": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "843158": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843159": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843160": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843161": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843162": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843163": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843164": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843165": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843301": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843302": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843311": {
    "city": "RUNNI",
    "state": "BIHAR"
  },
  "843312": {
    "city": "RUNNI",
    "state": "BIHAR"
  },
  "843313": {
    "city": "DHAKA",
    "state": "BIHAR"
  },
  "843314": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843315": {
    "city": "BHUTAHI",
    "state": "BIHAR"
  },
  "843316": {
    "city": "RUNNI",
    "state": "BIHAR"
  },
  "843317": {
    "city": "BHUTAHI",
    "state": "BIHAR"
  },
  "843318": {
    "city": "PUPRI",
    "state": "BIHAR"
  },
  "843319": {
    "city": "PUPRI",
    "state": "BIHAR"
  },
  "843320": {
    "city": "PUPRI",
    "state": "BIHAR"
  },
  "843321": {
    "city": "KATRA - BH",
    "state": "BIHAR"
  },
  "843322": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843323": {
    "city": "RUNNI",
    "state": "BIHAR"
  },
  "843324": {
    "city": "BHUTAHI",
    "state": "BIHAR"
  },
  "843325": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843326": {
    "city": "RUNNI",
    "state": "BIHAR"
  },
  "843327": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843328": {
    "city": "RUNNI",
    "state": "BIHAR"
  },
  "843329": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843330": {
    "city": "BHUTAHI",
    "state": "BIHAR"
  },
  "843331": {
    "city": "PUPRI",
    "state": "BIHAR"
  },
  "843332": {
    "city": "BHUTAHI",
    "state": "BIHAR"
  },
  "843333": {
    "city": "PUPRI",
    "state": "BIHAR"
  },
  "843334": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843335": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843336": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843337": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843338": {
    "city": "DHAKA",
    "state": "BIHAR"
  },
  "843339": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "843340": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843341": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843342": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843343": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843344": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843346": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843347": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843348": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843349": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843350": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843351": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843352": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843353": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843354": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843355": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843356": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843357": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843358": {
    "city": "LAKHMINIA",
    "state": "BIHAR"
  },
  "843359": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843360": {
    "city": "KATRA - BH",
    "state": "BIHAR"
  },
  "843361": {
    "city": "BHUTAHI",
    "state": "BIHAR"
  },
  "843362": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843363": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843364": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843365": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "843366": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "843367": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843368": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843611": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "843801": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "844101": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844102": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844103": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844111": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844112": {
    "city": "MAHUA",
    "state": "BIHAR"
  },
  "844113": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844114": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844115": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844116": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844117": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844118": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844119": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844120": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "844121": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844122": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844123": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844124": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844125": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844126": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844127": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "844128": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844129": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844130": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844131": {
    "city": "BHAGWANPUR",
    "state": "BIHAR"
  },
  "844132": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844133": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844134": {
    "city": "BHAGWANPUR",
    "state": "BIHAR"
  },
  "844135": {
    "city": "BHAGWANPUR",
    "state": "BIHAR"
  },
  "844136": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844137": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844138": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844139": {
    "city": "MAHUA",
    "state": "BIHAR"
  },
  "844140": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844141": {
    "city": "MAHUA",
    "state": "BIHAR"
  },
  "844501": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844502": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844503": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844504": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844505": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844506": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844507": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844508": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844509": {
    "city": "Vaishali",
    "state": "Bihar"
  },
  "844510": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844511": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844512": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844513": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844514": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844515": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844516": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844517": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844518": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844519": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844520": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844521": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844522": {
    "city": "SARAIYA",
    "state": "BIHAR"
  },
  "844532": {
    "city": "BIHTA",
    "state": "BIHAR"
  },
  "845101": {
    "city": "BAGAHA",
    "state": "BIHAR"
  },
  "845102": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845103": {
    "city": "LAURIYA",
    "state": "BIHAR"
  },
  "845104": {
    "city": "BAGAHA",
    "state": "BIHAR"
  },
  "845105": {
    "city": "BAGAHA",
    "state": "BIHAR"
  },
  "845106": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845107": {
    "city": "BAGAHA",
    "state": "BIHAR"
  },
  "845108": {
    "city": "BAGAHA",
    "state": "BIHAR"
  },
  "845109": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845110": {
    "city": "BAGAHA",
    "state": "BIHAR"
  },
  "845112": {
    "city": "BAGAHA",
    "state": "BIHAR"
  },
  "845113": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "845114": {
    "city": "DHAKA",
    "state": "BIHAR"
  },
  "845115": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "845116": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "845117": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "845118": {
    "city": "BAGAHA",
    "state": "BIHAR"
  },
  "845119": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "845120": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "845145": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "845301": {
    "city": "RAXAUL",
    "state": "BIHAR"
  },
  "845302": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845303": {
    "city": "DHAKA",
    "state": "BIHAR"
  },
  "845304": {
    "city": "DHAKA",
    "state": "BIHAR"
  },
  "845305": {
    "city": "RAXAUL",
    "state": "BIHAR"
  },
  "845306": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845307": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845308": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845309": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "845310": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845311": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845312": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845313": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845314": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845315": {
    "city": "DHAKA",
    "state": "BIHAR"
  },
  "845318": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "845335": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "845363": {
    "city": "BANMANKHI",
    "state": "BIHAR"
  },
  "845401": {
    "city": "CHAMPARAN",
    "state": "BIHAR"
  },
  "845402": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845404": {
    "city": "BAGAHA",
    "state": "BIHAR"
  },
  "845406": {
    "city": "MOTIPUR",
    "state": "BIHAR"
  },
  "845408": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845411": {
    "city": "ARERAJ",
    "state": "BIHAR"
  },
  "845412": {
    "city": "CHAMPARAN",
    "state": "BIHAR"
  },
  "845413": {
    "city": "CHAKIA",
    "state": "BIHAR"
  },
  "845414": {
    "city": "CHAKIA",
    "state": "BIHAR"
  },
  "845415": {
    "city": "DHAKA",
    "state": "BIHAR"
  },
  "845416": {
    "city": "CHAKIA",
    "state": "BIHAR"
  },
  "845417": {
    "city": "ARERAJ",
    "state": "BIHAR"
  },
  "845418": {
    "city": "DHAKA",
    "state": "BIHAR"
  },
  "845419": {
    "city": "ARERAJ",
    "state": "BIHAR"
  },
  "845420": {
    "city": "CHAKIA",
    "state": "BIHAR"
  },
  "845421": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845422": {
    "city": "ARERAJ",
    "state": "BIHAR"
  },
  "845423": {
    "city": "SAHEBGANJ - BH",
    "state": "BIHAR"
  },
  "845424": {
    "city": "SAHEBGANJ - BH",
    "state": "BIHAR"
  },
  "845425": {
    "city": "ARERAJ",
    "state": "BIHAR"
  },
  "845426": {
    "city": "CHAKIA",
    "state": "BIHAR"
  },
  "845427": {
    "city": "DHAKA",
    "state": "BIHAR"
  },
  "845428": {
    "city": "DHAKA",
    "state": "BIHAR"
  },
  "845429": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845430": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "845431": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845432": {
    "city": "SAHEBGANJ - BH",
    "state": "BIHAR"
  },
  "845433": {
    "city": "RAXAUL",
    "state": "BIHAR"
  },
  "845434": {
    "city": "ARERAJ",
    "state": "BIHAR"
  },
  "845435": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845436": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "845437": {
    "city": "ARERAJ",
    "state": "BIHAR"
  },
  "845438": {
    "city": "CHAMPARAN",
    "state": "BIHAR"
  },
  "845440": {
    "city": "RAXAUL",
    "state": "BIHAR"
  },
  "845449": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845450": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845451": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845452": {
    "city": "LAURIYA",
    "state": "BIHAR"
  },
  "845453": {
    "city": "LAURIYA",
    "state": "BIHAR"
  },
  "845454": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845455": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845456": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845457": {
    "city": "DHAKA",
    "state": "BIHAR"
  },
  "845458": {
    "city": "ARERAJ",
    "state": "BIHAR"
  },
  "845459": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845460": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845461": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845462": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845463": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845464": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845465": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "845466": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845467": {
    "city": "MAHRAJGANJ",
    "state": "BIHAR"
  },
  "845468": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845469": {
    "city": "BARAUNI",
    "state": "BIHAR"
  },
  "845470": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "845471": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845472": {
    "city": "AURANGABAD - BH",
    "state": "BIHAR"
  },
  "845473": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845474": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845475": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845476": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845477": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845478": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845479": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845480": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845481": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845483": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845484": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845485": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845486": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845487": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845488": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845489": {
    "city": "BHAGWANPUR",
    "state": "BIHAR"
  },
  "845490": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845491": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845492": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845494": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845495": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "845496": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845497": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845498": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845499": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845500": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845501": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845502": {
    "city": "CHAKIA",
    "state": "BIHAR"
  },
  "845503": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845504": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845505": {
    "city": "DHAKA",
    "state": "BIHAR"
  },
  "845506": {
    "city": "KUCHAIKOTE",
    "state": "BIHAR"
  },
  "845507": {
    "city": "MAHUA",
    "state": "BIHAR"
  },
  "845508": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845509": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845511": {
    "city": "RAXAUL",
    "state": "BIHAR"
  },
  "845513": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "845514": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845515": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845516": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845517": {
    "city": "MAHUA",
    "state": "BIHAR"
  },
  "845518": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "845519": {
    "city": "NARKAIAGANJ",
    "state": "BIHAR"
  },
  "845520": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "845521": {
    "city": "ARERAJ",
    "state": "BIHAR"
  },
  "845522": {
    "city": "DHAKA",
    "state": "BIHAR"
  },
  "845523": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "845524": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "845525": {
    "city": "CHAKIA",
    "state": "BIHAR"
  },
  "846001": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "846002": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "846003": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "846004": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "846005": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "846006": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "846007": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "846008": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "846009": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847101": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847102": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "847103": {
    "city": "BENIPUR",
    "state": "BIHAR"
  },
  "847104": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847105": {
    "city": "SINGHIA",
    "state": "BIHAR"
  },
  "847106": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847107": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "847108": {
    "city": "KHUTONA",
    "state": "BIHAR"
  },
  "847109": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847110": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847111": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847112": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847113": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847114": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847115": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847116": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847117": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847118": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847119": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847120": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847121": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847122": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847123": {
    "city": "KATRA - BH",
    "state": "BIHAR"
  },
  "847124": {
    "city": "KATRA - BH",
    "state": "BIHAR"
  },
  "847125": {
    "city": "KATRA - BH",
    "state": "BIHAR"
  },
  "847126": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "847201": {
    "city": "BENIPUR",
    "state": "BIHAR"
  },
  "847203": {
    "city": "SINGHIA",
    "state": "BIHAR"
  },
  "847204": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847205": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847211": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847212": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847213": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847214": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847215": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847222": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "847223": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "847224": {
    "city": "KHUTONA",
    "state": "BIHAR"
  },
  "847225": {
    "city": "JAYNAGAR",
    "state": "BIHAR"
  },
  "847226": {
    "city": "JAYNAGAR",
    "state": "BIHAR"
  },
  "847227": {
    "city": "KHUTONA",
    "state": "BIHAR"
  },
  "847228": {
    "city": "JAYNAGAR",
    "state": "BIHAR"
  },
  "847229": {
    "city": "JAYNAGAR",
    "state": "BIHAR"
  },
  "847230": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "847231": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847232": {
    "city": "JAYNAGAR",
    "state": "BIHAR"
  },
  "847233": {
    "city": "BENIPUR",
    "state": "BIHAR"
  },
  "847234": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847235": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847236": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847237": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847238": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847239": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847240": {
    "city": "JAYNAGAR",
    "state": "BIHAR"
  },
  "847241": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "847242": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "847243": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "847244": {
    "city": "JAYNAGAR",
    "state": "BIHAR"
  },
  "847245": {
    "city": "JAYNAGAR",
    "state": "BIHAR"
  },
  "847246": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847247": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847248": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847249": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "847250": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847251": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847252": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847253": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847254": {
    "city": "SULTANGANJ",
    "state": "BIHAR"
  },
  "847255": {
    "city": "JAYNAGAR",
    "state": "BIHAR"
  },
  "847256": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847257": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847301": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847302": {
    "city": "PUPRI",
    "state": "BIHAR"
  },
  "847303": {
    "city": "PUPRI",
    "state": "BIHAR"
  },
  "847304": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "847305": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "847306": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847307": {
    "city": "KATRA - BH",
    "state": "BIHAR"
  },
  "847308": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "847309": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "847310": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "847311": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "847312": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "847313": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "847337": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "847401": {
    "city": "KHUTONA",
    "state": "BIHAR"
  },
  "847402": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847403": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847404": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847405": {
    "city": "BENIPUR",
    "state": "BIHAR"
  },
  "847406": {
    "city": "JAYNAGAR",
    "state": "BIHAR"
  },
  "847407": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847408": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847409": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847410": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847411": {
    "city": "KHUTONA",
    "state": "BIHAR"
  },
  "847412": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847413": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847414": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847415": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847416": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847417": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847418": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847419": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847420": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847421": {
    "city": "KHUTONA",
    "state": "BIHAR"
  },
  "847422": {
    "city": "BENIPUR",
    "state": "BIHAR"
  },
  "847423": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847424": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847425": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847426": {
    "city": "JHANJHARPUR",
    "state": "BIHAR"
  },
  "847427": {
    "city": "BENIPUR",
    "state": "BIHAR"
  },
  "847428": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847429": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "847451": {
    "city": "KHUTONA",
    "state": "BIHAR"
  },
  "847452": {
    "city": "SIMRAHI BAZAR",
    "state": "BIHAR"
  },
  "848101": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848102": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848103": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848109": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848110": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848111": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848112": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848113": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848114": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848115": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "848116": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "848117": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848118": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848119": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848120": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848121": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848122": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848123": {
    "city": "BACHHAWARA",
    "state": "BIHAR"
  },
  "848124": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848125": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "848126": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848127": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848128": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848129": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848130": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848131": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848132": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848133": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848134": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848135": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848136": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848137": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848138": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848139": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848140": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848142": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848144": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848145": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848146": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848147": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848148": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848149": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848150": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "848151": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "848152": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "848153": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "848154": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "848155": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848156": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "848157": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "848158": {
    "city": "BARH",
    "state": "BIHAR"
  },
  "848159": {
    "city": "BIHAR SHARIF",
    "state": "BIHAR"
  },
  "848160": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848161": {
    "city": "RAJGIR",
    "state": "BIHAR"
  },
  "848162": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848163": {
    "city": "DHOLI",
    "state": "BIHAR"
  },
  "848177": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848183": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848201": {
    "city": "MAJHAUL",
    "state": "BIHAR"
  },
  "848202": {
    "city": "MAJHAUL",
    "state": "BIHAR"
  },
  "848203": {
    "city": "KHAGARIA",
    "state": "BIHAR"
  },
  "848204": {
    "city": "MAJHAUL",
    "state": "BIHAR"
  },
  "848205": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848206": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848207": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848208": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848209": {
    "city": "SINGHIA",
    "state": "BIHAR"
  },
  "848210": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848211": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848213": {
    "city": "SINGHIA",
    "state": "BIHAR"
  },
  "848214": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848216": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848217": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848218": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848219": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848220": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848221": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848222": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848223": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848224": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848225": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848226": {
    "city": "BUXAR",
    "state": "BIHAR"
  },
  "848227": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848228": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848229": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848230": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848231": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848233": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848234": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848235": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848236": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848237": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848238": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848239": {
    "city": "RUSERA",
    "state": "BIHAR"
  },
  "848301": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848302": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848303": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848501": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848502": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848503": {
    "city": "BACHHAWARA",
    "state": "BIHAR"
  },
  "848504": {
    "city": "MAHUA",
    "state": "BIHAR"
  },
  "848505": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848506": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848507": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848508": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848509": {
    "city": "PATNA",
    "state": "BIHAR"
  },
  "848510": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848511": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848512": {
    "city": "SAMASTIPUR",
    "state": "BIHAR"
  },
  "848513": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848514": {
    "city": "BACHHAWARA",
    "state": "BIHAR"
  },
  "848515": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848516": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848517": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848518": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848519": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "848572": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "849212": {
    "city": "DALSINGH SARAI",
    "state": "BIHAR"
  },
  "851026": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851101": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851102": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851103": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851107": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851110": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851111": {
    "city": "BACHHAWARA",
    "state": "BIHAR"
  },
  "851112": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851113": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851114": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851115": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851116": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851117": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851118": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851119": {
    "city": "BARAUNI",
    "state": "BIHAR"
  },
  "851120": {
    "city": "BARAUNI",
    "state": "BIHAR"
  },
  "851121": {
    "city": "BARAUNI",
    "state": "BIHAR"
  },
  "851122": {
    "city": "BARAUNI",
    "state": "BIHAR"
  },
  "851126": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851127": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851128": {
    "city": "BACHHAWARA",
    "state": "BIHAR"
  },
  "851129": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851130": {
    "city": "MAJHAUL",
    "state": "BIHAR"
  },
  "851131": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851132": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851133": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851134": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851135": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851136": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851137": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851138": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851139": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851201": {
    "city": "GOGRI",
    "state": "BIHAR"
  },
  "851202": {
    "city": "GOGRI",
    "state": "BIHAR"
  },
  "851203": {
    "city": "GOGRI",
    "state": "BIHAR"
  },
  "851204": {
    "city": "KHAGARIA",
    "state": "BIHAR"
  },
  "851205": {
    "city": "KHAGARIA",
    "state": "BIHAR"
  },
  "851206": {
    "city": "KHAGARIA",
    "state": "BIHAR"
  },
  "851209": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851210": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851211": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851212": {
    "city": "GOGRI",
    "state": "BIHAR"
  },
  "851213": {
    "city": "GOGRI",
    "state": "BIHAR"
  },
  "851214": {
    "city": "KHAGARIA",
    "state": "BIHAR"
  },
  "851215": {
    "city": "PARBATTA",
    "state": "BIHAR"
  },
  "851216": {
    "city": "PARBATTA",
    "state": "BIHAR"
  },
  "851217": {
    "city": "LAKHMINIA",
    "state": "BIHAR"
  },
  "851218": {
    "city": "LAKHMINIA",
    "state": "BIHAR"
  },
  "851219": {
    "city": "LAKHMINIA",
    "state": "BIHAR"
  },
  "851220": {
    "city": "KHAGARIA",
    "state": "BIHAR"
  },
  "851221": {
    "city": "LAKHMINIA",
    "state": "BIHAR"
  },
  "851222": {
    "city": "LAKHMINIA",
    "state": "BIHAR"
  },
  "851223": {
    "city": "BIHTA",
    "state": "BIHAR"
  },
  "851224": {
    "city": "KHAGARIA",
    "state": "BIHAR"
  },
  "851225": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "851226": {
    "city": "PARSA",
    "state": "BIHAR"
  },
  "851227": {
    "city": "NAUGACHIA",
    "state": "BIHAR"
  },
  "851228": {
    "city": "BEGUSARAI",
    "state": "BIHAR"
  },
  "852101": {
    "city": "UDAKISHANGANJ",
    "state": "BIHAR"
  },
  "852105": {
    "city": "SIMRAHI BAZAR",
    "state": "BIHAR"
  },
  "852106": {
    "city": "SAHASRA",
    "state": "BIHAR"
  },
  "852107": {
    "city": "MADHEPURA",
    "state": "BIHAR"
  },
  "852108": {
    "city": "SUPAUL",
    "state": "BIHAR"
  },
  "852109": {
    "city": "SIMRAHI BAZAR",
    "state": "BIHAR"
  },
  "852110": {
    "city": "SAHASRA",
    "state": "BIHAR"
  },
  "852111": {
    "city": "SIMRAHI BAZAR",
    "state": "BIHAR"
  },
  "852112": {
    "city": "TRIVENIGANJ",
    "state": "BIHAR"
  },
  "852113": {
    "city": "MADHEPURA",
    "state": "BIHAR"
  },
  "852114": {
    "city": "MADHEPURA",
    "state": "BIHAR"
  },
  "852115": {
    "city": "UDAKISHANGANJ",
    "state": "BIHAR"
  },
  "852116": {
    "city": "UDAKISHANGANJ",
    "state": "BIHAR"
  },
  "852121": {
    "city": "SAHASRA",
    "state": "BIHAR"
  },
  "852122": {
    "city": "MADHEPURA",
    "state": "BIHAR"
  },
  "852123": {
    "city": "SAHASRA",
    "state": "BIHAR"
  },
  "852124": {
    "city": "SAHASRA",
    "state": "BIHAR"
  },
  "852125": {
    "city": "SIMRAHI BAZAR",
    "state": "BIHAR"
  },
  "852126": {
    "city": "SIMRI BAKHTIYARPUR",
    "state": "BIHAR"
  },
  "852127": {
    "city": "SIMRI BAKHTIYARPUR",
    "state": "BIHAR"
  },
  "852128": {
    "city": "MADHEPURA",
    "state": "BIHAR"
  },
  "852129": {
    "city": "SIMRI BAKHTIYARPUR",
    "state": "BIHAR"
  },
  "852130": {
    "city": "SUPAUL",
    "state": "BIHAR"
  },
  "852131": {
    "city": "SUPAUL",
    "state": "BIHAR"
  },
  "852132": {
    "city": "MADHEPURA",
    "state": "BIHAR"
  },
  "852133": {
    "city": "MADHEPURA",
    "state": "BIHAR"
  },
  "852136": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "852137": {
    "city": "TRIVENIGANJ",
    "state": "BIHAR"
  },
  "852138": {
    "city": "SUPAUL",
    "state": "BIHAR"
  },
  "852139": {
    "city": "TRIVENIGANJ",
    "state": "BIHAR"
  },
  "852140": {
    "city": "TRIVENIGANJ",
    "state": "BIHAR"
  },
  "852141": {
    "city": "MADHEPURA",
    "state": "BIHAR"
  },
  "852142": {
    "city": "TRIVENIGANJ",
    "state": "BIHAR"
  },
  "852143": {
    "city": "SAHASRA",
    "state": "BIHAR"
  },
  "852144": {
    "city": "UDAKISHANGANJ",
    "state": "BIHAR"
  },
  "852145": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "852146": {
    "city": "SAHASRA",
    "state": "BIHAR"
  },
  "852147": {
    "city": "UDAKISHANGANJ",
    "state": "BIHAR"
  },
  "852148": {
    "city": "SUPAUL",
    "state": "BIHAR"
  },
  "852149": {
    "city": "SAHASRA",
    "state": "BIHAR"
  },
  "852150": {
    "city": "SHEOHAR",
    "state": "BIHAR"
  },
  "852151": {
    "city": "MUNGER",
    "state": "BIHAR"
  },
  "852152": {
    "city": "SAHASRA",
    "state": "BIHAR"
  },
  "852153": {
    "city": "MADHEPURA",
    "state": "BIHAR"
  },
  "852154": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "852155": {
    "city": "JAMUI",
    "state": "BIHAR"
  },
  "852156": {
    "city": "SUPAUL",
    "state": "BIHAR"
  },
  "852157": {
    "city": "SUPAUL",
    "state": "BIHAR"
  },
  "852158": {
    "city": "SUPAUL",
    "state": "BIHAR"
  },
  "852159": {
    "city": "SUPAUL",
    "state": "BIHAR"
  },
  "852160": {
    "city": "SUPAUL",
    "state": "BIHAR"
  },
  "852161": {
    "city": "SIMRI BAKHTIYARPUR",
    "state": "BIHAR"
  },
  "852201": {
    "city": "SAHARSA",
    "state": "BIHAR"
  },
  "852202": {
    "city": "SAHASRA",
    "state": "BIHAR"
  },
  "852210": {
    "city": "UDAKISHANGANJ",
    "state": "BIHAR"
  },
  "852212": {
    "city": "SAHASRA",
    "state": "BIHAR"
  },
  "852213": {
    "city": "NAUGACHIA",
    "state": "BIHAR"
  },
  "852214": {
    "city": "TRIVENIGANJ",
    "state": "BIHAR"
  },
  "852215": {
    "city": "SIMRAHI BAZAR",
    "state": "BIHAR"
  },
  "852216": {
    "city": "SAHASRA",
    "state": "BIHAR"
  },
  "852217": {
    "city": "UDAKISHANGANJ",
    "state": "BIHAR"
  },
  "852218": {
    "city": "TRIVENIGANJ",
    "state": "BIHAR"
  },
  "852219": {
    "city": "UDAKISHANGANJ",
    "state": "BIHAR"
  },
  "852220": {
    "city": "UDAKISHANGANJ",
    "state": "BIHAR"
  },
  "852221": {
    "city": "SIMRI BAKHTIYARPUR",
    "state": "BIHAR"
  },
  "852233": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "852235": {
    "city": "MUZAFFARPUR",
    "state": "BIHAR"
  },
  "853201": {
    "city": "NAUGACHIA",
    "state": "BIHAR"
  },
  "853202": {
    "city": "NAUGACHIA",
    "state": "BIHAR"
  },
  "853203": {
    "city": "PARBATTA",
    "state": "BIHAR"
  },
  "853204": {
    "city": "NAUGACHIA",
    "state": "BIHAR"
  },
  "853205": {
    "city": "NAUGACHIA",
    "state": "BIHAR"
  },
  "853206": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "853207": {
    "city": "NAUGACHIA",
    "state": "BIHAR"
  },
  "853208": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854001": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854101": {
    "city": "FALKA",
    "state": "BIHAR"
  },
  "854102": {
    "city": "BANMANKHI",
    "state": "BIHAR"
  },
  "854103": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "854104": {
    "city": "FALKA",
    "state": "BIHAR"
  },
  "854105": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "854106": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "854107": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "854108": {
    "city": "FALKA",
    "state": "BIHAR"
  },
  "854109": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "854111": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "854112": {
    "city": "MANIHARI",
    "state": "BIHAR"
  },
  "854113": {
    "city": "MANIHARI",
    "state": "BIHAR"
  },
  "854114": {
    "city": "FALKA",
    "state": "BIHAR"
  },
  "854115": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "854116": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "854117": {
    "city": "MANIHARI",
    "state": "BIHAR"
  },
  "854118": {
    "city": "FALKA",
    "state": "BIHAR"
  },
  "854119": {
    "city": "MAHUA",
    "state": "BIHAR"
  },
  "854120": {
    "city": "NAUGACHIA",
    "state": "BIHAR"
  },
  "854121": {
    "city": "BARACHHATI",
    "state": "BIHAR"
  },
  "854122": {
    "city": "MANIHARI",
    "state": "BIHAR"
  },
  "854123": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "854124": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "854125": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "854126": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "854127": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "854201": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854202": {
    "city": "BANMANKHI",
    "state": "BIHAR"
  },
  "854203": {
    "city": "UDAKISHANGANJ",
    "state": "BIHAR"
  },
  "854204": {
    "city": "Bhawanipur",
    "state": "BIHAR"
  },
  "854205": {
    "city": "BANMANKHI",
    "state": "BIHAR"
  },
  "854206": {
    "city": "BANMANKHI",
    "state": "BIHAR"
  },
  "854207": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854208": {
    "city": "LAKHMINIA",
    "state": "BIHAR"
  },
  "854209": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854301": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854302": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854303": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854304": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854305": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854306": {
    "city": "BANMANKHI",
    "state": "BIHAR"
  },
  "854311": {
    "city": "ARARIA",
    "state": "BIHAR"
  },
  "854312": {
    "city": "ARARIA",
    "state": "BIHAR"
  },
  "854315": {
    "city": "BAISI",
    "state": "BIHAR"
  },
  "854316": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "854317": {
    "city": "BARSOI",
    "state": "BIHAR"
  },
  "854318": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "854319": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854321": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854325": {
    "city": "ARARIA",
    "state": "BIHAR"
  },
  "854326": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854327": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854328": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "854329": {
    "city": "ARARIA",
    "state": "BIHAR"
  },
  "854330": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854331": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "854332": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "854333": {
    "city": "ARARIA",
    "state": "BIHAR"
  },
  "854334": {
    "city": "ARARIA",
    "state": "BIHAR"
  },
  "854335": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "854336": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "854337": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854338": {
    "city": "SIMRAHI BAZAR",
    "state": "BIHAR"
  },
  "854339": {
    "city": "SIMRAHI BAZAR",
    "state": "BIHAR"
  },
  "854340": {
    "city": "SIMRAHI BAZAR",
    "state": "BIHAR"
  },
  "854341": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "854342": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "854343": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "854344": {
    "city": "ARARIA",
    "state": "BIHAR"
  },
  "854345": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "854346": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "854347": {
    "city": "RAGHUNATHPUR - BH",
    "state": "BIHAR"
  },
  "854349": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854350": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854351": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "854352": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854353": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854354": {
    "city": "BETTIAH",
    "state": "BIHAR"
  },
  "854355": {
    "city": "ARARIA",
    "state": "BIHAR"
  },
  "854356": {
    "city": "ARARIA",
    "state": "BIHAR"
  },
  "854357": {
    "city": "FORBESGANJ",
    "state": "BIHAR"
  },
  "854358": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854360": {
    "city": "CHHAPRA",
    "state": "BIHAR"
  },
  "854362": {
    "city": "ARARIA",
    "state": "BIHAR"
  },
  "854364": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854365": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "854366": {
    "city": "ARARIA",
    "state": "BIHAR"
  },
  "854367": {
    "city": "DARBHANGA",
    "state": "BIHAR"
  },
  "854368": {
    "city": "SITAMARHI",
    "state": "BIHAR"
  },
  "854369": {
    "city": "BASANTPUR",
    "state": "BIHAR"
  },
  "855101": {
    "city": "DAHIBHAT",
    "state": "BIHAR"
  },
  "855102": {
    "city": "BARSOI",
    "state": "BIHAR"
  },
  "855105": {
    "city": "BAISI",
    "state": "BIHAR"
  },
  "855106": {
    "city": "THAKURGANJ",
    "state": "BIHAR"
  },
  "855107": {
    "city": "KISHANGANJ",
    "state": "BIHAR"
  },
  "855108": {
    "city": "KISHANGANJ",
    "state": "BIHAR"
  },
  "855113": {
    "city": "BARSOI",
    "state": "BIHAR"
  },
  "855114": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "855115": {
    "city": "DAHIBHAT",
    "state": "BIHAR"
  },
  "855116": {
    "city": "THAKURGANJ",
    "state": "BIHAR"
  },
  "855117": {
    "city": "THAKURGANJ",
    "state": "BIHAR"
  },
  "855119": {
    "city": "THAKURGANJ",
    "state": "BIHAR"
  },
  "855120": {
    "city": "KISHANGANJ",
    "state": "BIHAR"
  },
  "855121": {
    "city": "KISHANGANJ",
    "state": "BIHAR"
  },
  "855122": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "855124": {
    "city": "KATIHAR",
    "state": "BIHAR"
  },
  "855126": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "855128": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "855276": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "855315": {
    "city": "PURNEA",
    "state": "BIHAR"
  },
  "855456": {
    "city": "MOTIHARI",
    "state": "BIHAR"
  },
  "857225": {
    "city": "BENIPATTI",
    "state": "BIHAR"
  },
  "858434": {
    "city": "MADHUBANI",
    "state": "BIHAR"
  },
  "896109": {
    "city": "SAHIBGANJ",
    "state": "JHARKHAND"
  },
  "990401": {
    "city": "Hyderabad",
    "state": "TELANGANA"
  },
  "992026": {
    "city": "DELHI NCR",
    "state": "DELHI"
  },
  "999000": {
    "city": "LATUR",
    "state": "MAHARASHTRA"
  },
  "999001": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "999002": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "999003": {
    "city": "PUNE",
    "state": "MAHARASHTRA"
  },
  "999004": {
    "city": "BANGALORE",
    "state": "KARNATAKA"
  },
  "999025": {
    "city": "DELHI NCR",
    "state": "DELHI"
  }
};